webpackJsonp([8],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _app = __webpack_require__(129);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _app3 = __webpack_require__(132);
	
	var _app4 = _interopRequireDefault(_app3);
	
	var _app5 = __webpack_require__(130);
	
	var _app6 = _interopRequireDefault(_app5);
	
	var _app7 = __webpack_require__(131);
	
	var _app8 = _interopRequireDefault(_app7);
	
	var _shared = __webpack_require__(418);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _cart = __webpack_require__(136);
	
	var _cart2 = _interopRequireDefault(_cart);
	
	var _catalog = __webpack_require__(143);
	
	var _catalog2 = _interopRequireDefault(_catalog);
	
	var _login = __webpack_require__(272);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _home = __webpack_require__(259);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _payZone = __webpack_require__(314);
	
	var _payZone2 = _interopRequireDefault(_payZone);
	
	var _tunnel = __webpack_require__(433);
	
	var _tunnel2 = _interopRequireDefault(_tunnel);
	
	var _orders = __webpack_require__(284);
	
	var _orders2 = _interopRequireDefault(_orders);
	
	var _pqrs = __webpack_require__(360);
	
	var _pqrs2 = _interopRequireDefault(_pqrs);
	
	var _reports = __webpack_require__(375);
	
	var _reports2 = _interopRequireDefault(_reports);
	
	var _templates = __webpack_require__(428);
	
	var _templates2 = _interopRequireDefault(_templates);
	
	var _paymentsAdvances = __webpack_require__(335);
	
	var _paymentsAdvances2 = _interopRequireDefault(_paymentsAdvances);
	
	var _consultCrm = __webpack_require__(210);
	
	var _consultCrm2 = _interopRequireDefault(_consultCrm);
	
	var _dashboard = __webpack_require__(67);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import contactModule from './contact/contact';
	// import confirmationOrderModule from './confirmation-order/confirmation-order';
	// import accountModule from './account/account';
	
	
	var casaBlancaModule = _angular2.default.module('hoyos', [
	// knowUsModule.name,
	// accountModule.name,
	// confirmationOrderModule.name,
	_dashboard2.default.name,
	// contactModule.name,
	// registerModule.name,
	// salesHome.name,
	// usersModule.name,
	_app8.default.name, _login2.default.name, _payZone2.default.name, _shared2.default.name, _tunnel2.default.name, _reports2.default.name, _catalog2.default.name, _home2.default.name, _orders2.default.name, _pqrs2.default.name, _templates2.default.name, _cart2.default.name, _paymentsAdvances2.default.name, _consultCrm2.default.name]).constant('ngAuthSettings', _app6.default).config(_app2.default).run(_app4.default);
	// import usersModule from './users/users';
	// import salesHome from './sales-home/sales-home';
	// import registerModule from './register/register';
	// import knowUsModule from './know-us/know-us';
	exports.default = casaBlancaModule;

/***/ },
/* 1 */,
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4b3afb84b2b71ef56df09997a350bd04.gif";

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = "<div class=\"modal-content salir-aplication\"><div class=modal-header ng-if=mdCtrl.modalOptions.title><h5 class=modal-title ng-if=!mdCtrl.modalOptions.titleIsHtml><span>{{mdCtrl.modalOptions.title}}</span></h5><h5 class=modal-title ng-if=mdCtrl.modalOptions.titleIsHtml ng-bind-html=\"mdCtrl.modalOptions.title | toTrusted\"></h5></div><div class=modal-body><div class=\"product-add clearfix\"><div class=row><div class=col-xs-12 ng-if=mdCtrl.modalOptions.isHtml><p ng-bind-html=\"mdCtrl.modalOptions.content | toTrusted\"></div><div class=col-xs-12 ng-if=!mdCtrl.modalOptions.isHtml><p>{{mdCtrl.modalOptions.content}}</div></div><div class=row><div class=col-xs-12><div class=btn-actions style=\"text-align: right\"><button class=\"btn btn-danger squeare-button\" type=button ng-if=mdCtrl.modalOptions.showBottonCancel ng-click=mdCtrl.cancel() style=\"margin-right: 5px\"><strong>{{mdCtrl.modalOptions.textActionCancel}}</strong></button> <button type=button ng-click=mdCtrl.ok() class=\"btn btn-warning squeare-button\"><strong>{{mdCtrl.modalOptions.textAction}}</strong></button></div></div></div></div></div></div>";

/***/ },
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ function(module, exports) {

	module.exports = "<div class=modal-content style=\"height: 345px\"><div><div class=modal-header><h5 class=modal-title>Un producto ha sido cargado al carrito</h5></div><div class=modal-body><div id=resumen-pedido class=row><div class=col-lg-12><div class=row><div class=\"col-md-7 col-sm-12 col-xs-12 resumen-producto\"><div class=cuerpo><div class=row><div class=\"col-md-5 col-sm-6 col-xs-12\"><figure><img ng-src={{mdCtrl.product.image}}></figure></div><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=info><h3 class=item-name>{{mdCtrl.product.name}}</h3><ul class=list-group><li class=list-group-item>Referencia: <span>{{mdCtrl.product.reference}}</span><li class=list-group-item>Precio: <span ng-show=!mdCtrl.productAdded.quote>$ {{mdCtrl.product.price + mdCtrl.product.ivaValue | currency:'':0}} </span><span ng-show=mdCtrl.productAdded.quote>-</span><li class=list-group-item ng-if=mdCtrl.product.discount>Desc. total: <span ng-show=!mdCtrl.productAdded.quote>$ {{mdCtrl.product.discount | currency:'':0}} </span><span ng-show=mdCtrl.productAdded.quote>-</span><li class=list-group-item>Cantidad: <span>{{mdCtrl.product.quantity| currency:'':0}}</span><li class=list-group-item>Total a pagar: <span ng-show=!mdCtrl.productAdded.quote>$ {{mdCtrl.product.total | currency:'':0}}</span> <span ng-show=mdCtrl.productAdded.quote>(Cotizar)</span></ul></div></div></div></div></div><div class=\"col-md-5 col-sm-12 col-xs-12 resumen-canasta\"><div class=cuerpo><h6><i class=\"fa fa-shopping-cart\"></i> Resumen del carrito.</h6><hr><ul ng-show=\"mdCtrl.cart.order.totalItemsToQuote !== mdCtrl.cart.items.length\"><li>Subtotal: <span>$ {{mdCtrl.cart.cartSubtotal | currency:'':0}} <small>COP</small></span><li ng-show=mdCtrl.cart.cartDiscounts>Descuentos: <span>$ {{mdCtrl.cart.cartDiscounts | currency:'':0}} <small>COP</small></span><li>Impuestos: <span>$ {{mdCtrl.cart.cartTaxes | currency:'':0}} <small>COP</small></span><li>Preliquidación: <span>$ {{mdCtrl.cart.cartTotal | currency:'':0}} <small>COP</small></span><li ng-show=mdCtrl.cart.cartTransports>Gestión y Transporte: <span>$ {{mdCtrl.cart.cartTransports | currency:'':0}} <small>COP</small></span><li>Total: <span>$ {{mdCtrl.cart.cartTotal | currency:'':0}} <small>COP</small></span></ul><ul ng-show=\"mdCtrl.cart.order.totalItemsToQuote === mdCtrl.cart.items.length\"><li>Subtotal: <span>-</span><li>Descuentos: <span>-</span><li>Impuestos: <span>-</span><li>Preliquidación: <span>-</span><li>Gestión y Transporte: <span>-</span><li>Total: <span>(Cotizar)</span></ul></div><div class=md-margin></div></div><div class=botones-acciones><div class=\"col-md-12 col-sm-12 col-xs-12 text-right\"><button ng-click=mdCtrl.cancel() type=button class=\"btn btn-custom-2\"><i class=\"fa fa-arrow-circle-left\"></i> {{mdCtrl.productAdded.textLabelContinue}}</button> <a id=btn-canasta ng-click=mdCtrl.goToCart() title=\"Ir al carrito\"><button class=\"btn btn-custom-4\"><i class=\"fa fa-shopping-cart\"></i> Ir al carrito</button></a></div></div></div></div></div></div></div></div><style>#content img {\r\n    max-width: 100%;\r\n    display: block;\r\n    height: auto;\r\n  }</style>";

/***/ },
/* 12 */
/***/ function(module, exports) {

	module.exports = "<div class=\"modal-content precanasta-cantidad\"><div class=modal-header><h5 class=modal-title><span>Agregar al carrito</span> <span style=font-weight:bold>{{mdCtrl.product.name}}</span></h5></div><div class=modal-body><div class=\"product-add clearfix\"><div class=row><div class=col-xs-12><p class=text-justify><span class=\"glyphicon glyphicon-shopping-cart\"></span> Ingrese la cantidad de este producto que desea agregar al carrito de compras</div><div class=\"col-xs-offset-1 col-md-3 col-sm-3 col-xs-3\"><label for=cantidad>Cantidad</label></div><div class=\"col-md-8 col-sm-8 col-xs-8\"><div class=custom-quantity-input><input id=cantidad restrict-type=num maxlength=4 ng-model=mdCtrl.itemQuantityToAdd name=cantidad> <a class=\"quantity-btn quantity-input-up\" ng-click=mdCtrl.increaseItemQuantityToAdd()><i class=\"fa fa-angle-up\"></i> </a><a class=\"quantity-btn quantity-input-down\" ng-click=mdCtrl.decreaseItemQuantityToAdd()><i class=\"fa fa-angle-down\"></i></a></div><label class=measure-unit>{{mdCtrl.product.measureUnit}}</label></div><div class=col-xs-12 ng-if=\"mdCtrl.product.discountsRange && mdCtrl.product.discountsRange.length\"><div class=sm-margin></div><ul class=list-style><li ng-repeat=\"discount in mdCtrl.product.discountsRange\"><div ng-if=discount.cantidad_maxima>Si compras una cantidad igual o superior a {{discount.cantidad_minima}} Und. de este producto obten un <span ng-if=\"discount.tipo_valor==2\">$</span> {{discount.valor|currency:'':0}} <span ng-if=\"discount.tipo_valor=1\">%</span> de descuento total.</div><div ng-if=discount.valor_minimo>Comprando entre {{discount.valor_minimo|currency:'$ ':0}} y {{discount.valor_maximo|currency:'$ ':0}} obten un descuento del <span ng-if=\"discount.tipo_valor==2\">$</span> {{discount.valor|currency:'':0}} <span ng-if=\"discount.tipo_valor=1\">%</span></div></ul></div><div class=\"col-md-12 col-sm-12 col-xs-12 text-right\" ng-show=!mdCtrl.addingItemtoCart><div class=sm-margin></div><button class=\"btn btn-sm btn-custom-4\" ng-disabled=!mdCtrl.itemQuantityToAdd ng-click=\"mdCtrl.addItemToCart(mdCtrl.product, mdCtrl.itemQuantityToAdd)\">{{mdCtrl.product.textAction}}</button> &nbsp; <button ng-click=mdCtrl.cancel() class=\"btn btn-default btn-sm\">Cancelar</button></div></div></div></div></div>";

/***/ },
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "013bcdd5e5a4eb68a022c4114ddf2010.jpg";

/***/ },
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ function(module, exports) {

	module.exports = "<div class=modal-header><h5 class=modal-title><span>Seleccione la sucursal con la cual desea trabajar</span> <i class=\"fa fa-times pull-right\" data-dismiss=modal ng-if=mdCtrl.modalOptions.currentBranch.name></i></h5></div><div class=modal-body><div ng-if=mdCtrl.modalOptions.currentBranch.id><p>Se ha seleccionado previamente la sucursal <b>{{ mdCtrl.modalOptions.currentBranch.name }}</b>, con ubicación en <b>{{ mdCtrl.modalOptions.currentBranch.location.fullname }}</b></div><form id=register-form name=mdCtrl.branchUserB2BForm ng-submit=\"\" novalidate><div class=row><div class=col-md-12><div class=form-group><label>Sucursal*</label><select title=\"Por favor seleccione la sucursal\" class=form-control name=branchUserB2B id=branchUserB2B ng-model=mdCtrl.branchUserB2B ng-options=\"x.id as x.name for x in mdCtrl.modalOptions.branches\" required><option value=\"\">Seleccione la sucursal</select><span class=input-help><span ng-show=\"mdCtrl.branchUserB2BForm.branchUserB2B.$invalid && !mdCtrl.branchUserB2BForm.branchUserB2B.$pristine\" class=help-block style=\"top:0px; font-size:12px\">Seleccione la sucursal.</span></span></div></div></div><div class=row ng-hide=state.saving><div class=\"col-md-12 text-right\"><button class=\"btn btn-md btn-custom-4\" ng-disabled=state.saving ng-click=mdCtrl.cancel() ng-show=mdCtrl.modalOptions.currentBranch.name>Cerrar</button> <button class=\"btn btn-md btn-custom-4\" ng-disabled=!mdCtrl.branchUserB2B ng-click=mdCtrl.setOperatingCenter(mdCtrl.branchUserB2B)>Seleccionar</button></div></div><div class=row ng-show=mdCtrl.state.saving><div class=\"col-md-12 text-right\" style=color:#ccc><span>Actualizando la sucursal del cliente...</span> <i class=\"fa fa-history load-animation\"></i></div></div><div class=row ng-show=\"mdCtrl.state.saved && mdCtrl.state.error\"><div class=col-md-12><div class=\"alert alert-danger\">Ha ocurrido un error al actualizar la información de la sucursal del cliente. Por favor inténtelo de nuevo.</div></div></div></form></div>";

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"modal-content salir-aplication\" id=modalFormPQRS><div class=modal-header><button type=button class=close ng-click=mdCtrl.cancel()>&times;</button><h5 class=modal-title><span>Registrar Incidencia</span></h5></div><div class=modal-body><div class=row><div class=col-md-12><div><div class=row><div class=col-md-12 ng-show=mdCtrl.pqrsFormData.state.savedPqrs><div class=row><div class=col-md-12><div class=\"alert alert-success\"><h3>Incidencia Registrada!</h3><p>Su incidencia ha sido registrada exitosamente con el No. <strong>{{mdCtrl.pqrsId}}</strong>. Para ver el listado de casos registrados haga click <a id=enlace-ver-listado-pqrs ng-click=mdCtrl.goToPQRSList()>aqu&iacute; </a>.</div></div></div></div><div class=col-md-12><div class=row><div class=col-md-12><h4>Para nosotros tu opinión es muy importante</h4><hr><p>Por favor diligencia el siguiente formulario para reportarnos una petición, queja, reclamo y sugerencia. Uno de nuestros ejecutivos de servicio al cliente atendrá tu caso en el menor tiempo posible.<div class=\"alert alert-danger\" ng-if=\"globals.currentUser.isOwner && !mdCtrl.clientSelected\">Debes seleccionar un cliente para registrar una incidencia</div><p><span class=\"col-md-9 col-md-offset-3\">Los campos marcados con * son obligatorios.</span></div></div><div class=sm-margin></div><div class=row><div class=col-md-12><form id=pqrs-form class=\"form pqrs\" name=pqrsForm ng-submit=mdCtrl.savePQRS(pqrsForm) novalidate><div class=\"row contenido-registro\"><div class=\"col-md-3 hidden-sm hidden-xs\"><img src=" + __webpack_require__(23) + " alt=PQRS style=\"padding: 0 25px; width: 100%\"></div><div class=col-md-9><div class=\"col-md-4 col-sm-4 col-xs-12\"><div class=form-group><label>Asunto *</label><select title=\"Por favor seleccione el asunto\" class=form-control name=subject ng-model=mdCtrl.pqrsFormData.subject ng-disabled=mdCtrl.pqrsFormData.state.savingPqrs ng-options=\"subject.id as subject.name for subject\r\n                                                    in mdCtrl.pqrsParams.subjects track by subject.id\" required><option value=\"\" selected>Seleccione el asunto</select><span class=input-help><span ng-show=\"pqrsForm.subject.$invalid && !pqrsForm.subject.$pristine\" class=help-block>Seleccione el asunto.</span></span></div></div><div class=\"col-md-4 col-sm-4 col-xs-12\"><div class=form-group><label>Relacionado con *</label><select title=\"Por favor seleccione la relación\" class=form-control name=relatedWith ng-model=mdCtrl.pqrsFormData.relatedWith ng-disabled=mdCtrl.pqrsFormData.state.savingPqrs ng-options=\"rel.id as rel.name for rel in mdCtrl.pqrsParams.relatedWith track by rel.id\" required><option value=\"\" selected>Seleccione la relación</select><span class=input-help><span ng-show=\"pqrsForm.relatedWith.$invalid && !pqrsForm.relatedWith.$pristine\" class=help-block>Seleccione la relación.</span></span></div></div><div class=\"col-md-4 col-sm-4 col-xs-12\"><div class=form-group><label>Fecha de Incidencia *</label><div class=input-group style=\"width:100%;margin-bottom: 0px;padding:0px\"><input id=incidenceDate name=incidenceDate uib-datepicker-popup={{$ctrl.shCtrl.formatDate}} is-open=$ctrl.popup1 close-text=Cerrar datepicker-options=$ctrl.shCtrl.dateOptions on-open-focus=true show-button-bar=false alt-input-formats=$ctrl.shCtrl.altInputFormats class=\"form-control datepicker\" placeholder=\"ej. 2016-07-13\" ng-model=mdCtrl.pqrsFormData.incidenceDate ng-disabled=mdCtrl.pqrsFormData.state.savingPqrs autocomplete=off required readonly><label ng-click=\"$ctrl.popup1 = !$ctrl.popup1\" class=\"input-group-addon btn\" for=incidenceDate style=min-width:auto><span class=\"fa fa-calendar\"></span></label></div><span class=input-help><span ng-show=\"pqrsForm.incidenceDate.$error.required &&\r\n                                             !pqrsForm.incidenceDate.$pristine\" class=help-block>Seleccione la fecha de la incidencia. </span><span ng-show=\"pqrsForm.incidenceDate.$error.date &&\r\n                                             !pqrsForm.incidenceDate.$pristine\" class=help-block>La fecha de la incidencia no es valida.</span></span></div></div><div class=\"col-md-4 col-sm-4 col-xs-12\"><div class=form-group><label>Lugar de la incidencia</label><input title=\"Por favor ingrese la ubicación de la incidencia\" placeholder=\"ej. Carrera 52 No. 34 - 62\" class=\"form-control input-sm\" maxlength=30 name=incidenceLocation ng-model=mdCtrl.pqrsFormData.incidenceLocation ng-disabled=mdCtrl.pqrsFormData.state.savingPqrs autocomplete=off> <span class=input-help><span ng-show=\"pqrsForm.incidenceLocation.$invalid && !pqrsForm.incidenceLocation.$pristine\" class=help-block>Ingrese el lugar de la incidencia.</span></span></div></div><div class=\"col-md-4 col-sm-4 col-xs-12\"><div class=form-group><label>Email de Respuesta</label><input title=\"Por favor ingrese Email de respuesta\" placeholder=ejemplo@ejemplo.com class=\"form-control input-sm\" name=incidenceResponseMail ng-model=mdCtrl.pqrsFormData.incidenceResponseMail ng-disabled=mdCtrl.pqrsFormData.state.savingPqrs autocomplete=off> <span class=input-help><span ng-show=\"pqrsForm.incidenceResponseMail.$invalid && !pqrsForm.incidenceResponseMail.$pristine\" class=help-block>Ingrese email de respuesta.</span></span></div></div><div class=\"col-md-4 col-sm-4 col-xs-12\"><div class=form-group><label>Teléfono de Respuesta</label><input title=\"Por favor ingrese teléfono de respuesta\" placeholder=\"+57 555 55 55\" class=\"form-control input-sm\" name=incidenceResponsePhone ng-model=mdCtrl.pqrsFormData.incidenceResponsePhone ng-disabled=mdCtrl.pqrsFormData.state.savingPqrs autocomplete=off> <span class=input-help><span ng-show=\"pqrsForm.incidenceResponsePhone.$invalid && !pqrsForm.incidenceResponsePhone.$pristine\" class=help-block>Ingrese teléfono de respuesta.</span></span></div></div><div class=col-xs-12><div class=form-group><label>Por favor comentenos su caso *</label><textarea rows=5 placeholder=\"\" class=\"form-control input-sm\" name=comments title=\"Por favor comentenos su caso\" autocomplete=off ng-model=mdCtrl.pqrsFormData.comments ng-disabled=mdCtrl.pqrsFormData.state.savingPqrs required></textarea><span class=input-help><span ng-show=\"pqrsForm.comments.$invalid && !pqrsForm.comments.$pristine\" class=help-block>Ingrese los comentarios.</span></span></div></div><div class=\"col-md-4 col-sm-4 col-xs-12\"><div class=form-group><label>Documento Relacionado</label><select title=\"Por favor seleccione el documento relacionado\" class=form-control name=documentRelated ng-model=mdCtrl.pqrsFormData.documentRelated ng-disabled=mdCtrl.pqrsFormData.state.savingPqrs ng-options=\"document.id as document.name for document\r\n                                                    in mdCtrl.pqrsParams.documentTypes track by document.id\"><option value=\"\" selected>Seleccione el documento relacionado</select><span class=input-help><span ng-show=\"pqrsForm.documentRelated.$invalid && !pqrsForm.documentRelated.$pristine\" class=help-block>Seleccione el documento relacionado.</span></span></div></div><div class=\"col-md-4 col-sm-4 col-xs-12\"><div class=form-group><label class=container_tooltip>Nro. Documento <i class=\"fa fa-question-circle\" tooltip-placement=top uib-tooltip=\"Digite el número de la factura o remisión que está relacionada con su caso. S\r\n                                i no cuenta con ella puede dejar este campo sin diligenciar.\"></i></label><input name=documentNumber placeholder=\"ej. 54A1243J1\" title=\"Por favor ingrese el número de la incidencia\" class=\"form-control input-sm\" ng-model=mdCtrl.pqrsFormData.documentNumber ng-disabled=mdCtrl.pqrsFormData.state.savingPqrs autocomplete=off> <span class=input-help><span ng-show=\"pqrsForm.documentNumber.$invalid && !pqrsForm.documentNumber.$pristine\" class=help-block>Ingrese el número del documento.</span></span></div></div><div class=\"col-md-4 col-xs-12\"><div class=form-group><label class=container_tooltip>Adjuntar documentos <i class=\"fa fa-question-circle\" uib-tooltip-html=messageRestriction tooltip-placement=top></i></label><input type=file ng-model=mdCtrl.pqrsFormData.attachFiles name=files style=display:none id=pqrsFile multiple accept=\"image/*, .pdf\" base-sixty-four-input ng-change=mdCtrl.copyFiles();> <span class=\"btn btn-info\" onclick=\"document.getElementById('pqrsFile').click()\">Elegir Archivos</span><p class=\"text-warning bg-warning\" style=\"padding: 15px\" ng-show=mdCtrl.maxSizeError>Los archivos no deben exceder 3 MB.<p class=\"text-warning bg-warning\" style=\"padding: 15px\" ng-show=mdCtrl.invalidExt>Archivo con formato invalido.<br>Formato permitido: (.jpg, .pdf)</div></div><div class=col-md-12><div class=table-responsive><table class=table ng-show=\"mdCtrl.pqrsFormData.files.length > 0\"><thead><tr><th width=50%>Nombre del archivo<th>Tamaño<th>Remover<tbody><tr ng-repeat=\"file in mdCtrl.pqrsFormData.files\"><td>{{file.filename}}<td>{{file.filesize | fileSize:2}}<td><button type=button class=\"btn btn-danger btn-s\" ng-click=mdCtrl.removeFile(file); style=\"padding: 2px 5px\" ng-disabled=mdCtrl.pqrsFormData.state.savingPqrs><span class=\"glyphicon glyphicon-trash\"></span></button><tr><td><b>Peso Total</b><td><b>{{mdCtrl.totalSize | fileSize:2}}</b><td></table></div></div><div class=col-xs-12><div class=sm-margin></div><div class=\"loader-general pull-right\" ng-show=mdCtrl.pqrsFormData.state.savingPqrs style=\"margin-top:10px; margin-bottom: 10px;text-align:left;font-size:11px;\r\n                                      margin-left:7px; displaY:inline-block\"><img src=" + __webpack_require__(2) + " style=width:18px></div><button type=submit ng-disabled=\"mdCtrl.pqrsFormData.state.savingPqrs || (globals.currentUser.isOwner && !mdCtrl.clientSelected)\" class=\"btn btn btn-success md-margin pull-right\"><span ng-show=!mdCtrl.pqrsFormData.state.savingPqrs>Registrar Incidencia</span> <span ng-show=mdCtrl.pqrsFormData.state.savingPqrs>Registrando la Incidencia...</span></button> <a href=# id=btn-ver-listados-casos ng-disabled=mdCtrl.pqrsFormData.state.savingPqrs class=\"btn btn btn-custom-4 md-margin pull-right\" ng-click=mdCtrl.goToPQRSList() style=\"margin-right: 10px\">Listar Casos</a></div></div></div></form></div></div></div></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" id=btn-cerrar-formulario-pqrs ng-click=mdCtrl.cancel()>Cerrar</button></div></div>";

/***/ },
/* 38 */
/***/ function(module, exports) {

	module.exports = "<div class=\"modal-content salir-aplication\"><div class=modal-header><h5 class=\"modal-title font-weight-700\"><span>Sede Cali - Calle 4B No. 38-17</span></h5></div><div class=modal-body><div class=\"product-add clearfix\"><div class=\"row content-modal-body\"><ui-gmap-google-map center=mdCtrl.map.center pan=mdCtrl.map.pan refresh=\"mdCtrl.activateMap === true\" zoom=mdCtrl.map.zoom><ui-gmap-marker coords=mdCtrl.map.marker idkey=452><ui-gmap-window isiconvisibleonclick=true><p ng-cloak></p></ui-gmap-window></ui-gmap-marker></ui-gmap-google-map></div><div class=\"row btn-actions\"><div class=\"col-xs-12 text-right\"><button class=\"btn btn-custom-5 glyphicon glyphicon-refresh\" ng-click=mdCtrl.refresh()></button> <button type=button ng-click=mdCtrl.ok() class=\"btn btn-info btn-custom-4\"><strong>Salir</strong></button></div></div></div></div></div><style>.angular-google-map-container { height: 400px; }\r\n  .text-right {\r\n    text-align: right;\r\n  }</style>";

/***/ },
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _dashboard = __webpack_require__(250);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _dashboard3 = __webpack_require__(252);
	
	var _dashboard4 = _interopRequireDefault(_dashboard3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import dashboardConfig from './dashboard.config';
	
	var dashboardModule = _angular2.default.module('app.dashboard', []).component('dashboard', _dashboard2.default).service('DashboardService', _dashboard4.default);
	// .config(dashboardConfig);
	exports.default = dashboardModule;

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b9134cc94709f09b998452f2f88a4905.jpg";

/***/ },
/* 69 */
/***/ function(module, exports) {

	module.exports = "<div class=\"modal-content salir-aplication\"><div class=modal-header><h5 class=modal-title><span>Sincronización de Pedidos</span></h5></div><div class=modal-body><div class=\"product-add clearfix\"><div class=\"row content-modal-body\">{{$ctrl.mensajeNotificacion}}</div><div class=\"row btn-actions\"><div class=col-xs-12><button type=button ng-click=mdCtrl.ok() class=\"btn btn-info\"><strong>Aceptar</strong></button></div></div></div></div></div>";

/***/ },
/* 70 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 71 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA2YAAACCCAIAAACiikygAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAJbSURBVHja7NbZCYAwEEBBV+y/w6QWK4jkWBVl5teYgMfyopSyAQBA29G6EBHru09vMnfj6F3964d27lyce3rioZ9b87+Dnn+hb3239/1fK8NkZfqtT86U2QuQq9a6ewoAAFyTjAAASEYAACQjAACSEQAAyQgAgGQEAEAyAgAgGQEAkIwAACAZAQCQjAAASEYAACQjAACSEQAAyQgAgGQEAEAyAgCAZAQAQDICACAZAQCQjAAASEYAACQjAACSEQAAyQgAAJIRAADJCACAZAQAQDICACAZAQCQjAAASEYAACQjAACSEQAAJCMAAJIRAADJCACAZAQAQDICACAZAQCQjAAASEYAAJCMAABIRgAAJCMAAJIRAADJCACAZAQAQDICACAZAQBAMgIAIBkBAJCMAABIRgAAJCMAAJIRAADJCACAZAQAQDICAIBkBABAMgIAIBkBAJCMAABIRgAAJCMAAJIRAADJCAAAkhEAAMkIAIBkBABAMgIAIBkBAJCMAABIRgAAJCMAAEhGAAAkIwAAkhEAAMkIAIBkBABAMgIAIBkBAJCMAABIRgAAkIwAAEhGAAAkIwAAkhEAAMkIAIBkBABAMgIAIBkBAEAyAgAgGQEAkIwAAEhGAAAkIwAAkhEAAMkIAIBkBAAAyQgAgGQEAEAyAgAgGQEAkIwAAEhGAAAkIwAAkhEAAMkIAACSEQAAyQgAgGQEAEAyAgAgGQEAkIwAAEhGAAAkIwAASEYAACQjAACSEQAAyQgAgGQEAEAyAgAgGQEAkIwAACAZAQCQjAAAJDgBAAD//wMA6BAGnU8wMNgAAAAASUVORK5CYII="

/***/ },
/* 72 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _core = __webpack_require__(476);
	
	var _core2 = _interopRequireDefault(_core);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	appConfig.$inject = ['$stateProvider', '$urlRouterProvider', '$httpProvider', 'ngAuthSettings', '$ocLazyLoadProvider'];
	
	function appConfig($stateProvider, $urlRouterProvider, $httpProvider, ngAuthSettings, $ocLazyLoadProvider) {
	  $httpProvider.interceptors.push('AuthInterceptor');
	
	  $ocLazyLoadProvider.config({ debug: true });
	  // $urlRouterProvider.otherwise('/app/login');
	  $urlRouterProvider.otherwise(function ($injector, $location) {
	    if ($location.path()) return '/app/404';else return ngAuthSettings.config.home_url;
	  });
	
	  $stateProvider.state('home', {
	    url: "/app",
	    // abstract: true,
	    template: _core2.default,
	    controller: 'SharedController',
	    controllerAs: 'shCtrl',
	    resolve: {
	      userData: userData
	    }
	  }).state('home.account', {
	    url: "/mi-cuenta",
	    template: '<account sh-ctrl="shCtrl"></account>',
	    resolve: {
	      loadController: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	        return $q(function (resolve) {
	          __webpack_require__.e/* nsure */(7, function () {
	            var ctrl = __webpack_require__(127);
	            $ocLazyLoad.load({ name: 'app.account' });
	            resolve(ctrl);
	          });
	        });
	      }]
	    }
	  }).state('home.confirmationOrder', {
	    url: "/confirmationOrder/{orderId}/{resolve}",
	    template: '<confirmation-order sh-ctrl="shCtrl"></confirmation-order>',
	    resolve: {
	      loadController: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	        return $q(function (resolve) {
	          __webpack_require__.e/* nsure */(6, function () {
	            var ctrl = __webpack_require__(205);
	            $ocLazyLoad.load({ name: 'app.confirmationOrder' });
	            resolve(ctrl);
	          });
	        });
	      }]
	    }
	  }).state('home.contact', {
	    url: "/contact",
	    template: '<contact sh-ctrl="shCtrl"></contact>',
	    resolve: {
	      loadController: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	        return $q(function (resolve) {
	          __webpack_require__.e/* nsure */(5, function () {
	            var ctrl = __webpack_require__(248);
	            $ocLazyLoad.load({ name: 'app.contact' });
	            resolve(ctrl);
	          });
	        });
	      }]
	    }
	  }).state('home.dashboard', {
	    url: "/panel-de-control",
	    template: '<dashboard sh-ctrl="shCtrl"></dashboard>',
	    resolve: {
	      loadController: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	        return $q(function (resolve) {
	          !/* require.ensure */(function () {
	            var ctrl = __webpack_require__(67);
	            $ocLazyLoad.load({ name: 'app.dashboard' });
	            resolve(ctrl);
	          }(__webpack_require__));
	        });
	      }]
	    }
	  }).state('home.knowUs', {
	    url: "/conocenos",
	    template: '<know-us sh-ctrl="shCtrl"></know-us>',
	    resolve: {
	      loadController: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	        return $q(function (resolve) {
	          __webpack_require__.e/* nsure */(4, function () {
	            var ctrl = __webpack_require__(267);
	            $ocLazyLoad.load({ name: 'app.knowUs' });
	            resolve(ctrl);
	          });
	        });
	      }]
	    }
	  }).state('home.register', {
	    url: "/register",
	    template: '<register sh-ctrl="shCtrl"></register>',
	    resolve: {
	      loadController: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	        return $q(function (resolve) {
	          __webpack_require__.e/* nsure */(3, function () {
	            var ctrl = __webpack_require__(363);
	            $ocLazyLoad.load({ name: 'app.register' });
	            resolve(ctrl);
	          });
	        });
	      }]
	    }
	  }).state('home.users', {
	    url: "/users",
	    template: '<users sh-ctrl="shCtrl"></users>',
	    resolve: {
	      loadController: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	        return $q(function (resolve) {
	          __webpack_require__.e/* nsure */(1, function () {
	            var ctrl = __webpack_require__(438);
	            $ocLazyLoad.load({ name: 'app.users' });
	            resolve(ctrl);
	          });
	        });
	      }]
	    }
	  }).state('home.salesHome', {
	    url: "/sales-home",
	    template: '<sales-home sh-ctrl="shCtrl"></sales-home>',
	    resolve: {
	      loadController: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	        return $q(function (resolve) {
	          __webpack_require__.e/* nsure */(2, function () {
	            var ctrl = __webpack_require__(378);
	            $ocLazyLoad.load({ name: 'app.salesHome' });
	            resolve(ctrl);
	          });
	        });
	      }]
	    }
	  });
	
	  userData.$inject = ['SessionService', '$state', 'CartService', 'SharedService'];
	  function userData(SessionService, $state, CartService, SharedService) {
	    var userData = {};
	    var cartId = SessionService.get('cartId') || '';
	    var userId = '';
	    var clientPriceListName = '';
	    try {
	      clientPriceListName = SessionService.get('quoteCartSeller').clientPriceList;
	    } catch (e) {}
	    return SessionService.getGlobals().then(function (globals) {
	      userData.globals = globals;
	      try {
	        userId = userData.globals.currentUser.userId;
	      } catch (e) {}
	      return CartService.getCart(cartId, userId, clientPriceListName).then(function (cartInfo) {
	        userData.cartInfo = cartInfo;
	        return SharedService.getInitialParams(userId).then(function (data) {
	          userData.globalCategories = data[0].data;
	          userData.categoriesMenu = data[1].data;
	          userData.banners = data[2].data;
	          userData.params = data[3].data;
	          if (userData.params.showChat) {
	            // Esta funcion se encuentra en el archivo assets/lib/chat.js
	            cargarChat();
	          }
	          return userData;
	        }).catch(function (error) {
	          console.log(error);
	          return {};
	        });
	      });
	    }).catch(function (reason) {
	      $state.go('login');
	    });
	  }
	}
	
	exports.default = appConfig;

/***/ },
/* 130 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var constants = {
	  apiServiceBaseUri: 'https://b2b.diamante.com.co/admin/frontend/web/index.php',
	  apiServiceBaseUri2: 'https://b2b.diamante.com.co/admin/backend/web/index.php',
	  config: {
	    appName: 'DIAMANTE S.A.',
	    appVersion: 1.0,
	    home_url: '/app/home',
	    env: {
	      basePath: 'https://b2b.diamante.com.co/',
	      apiEndPoint: 'https://b2b.diamante.com.co/admin/frontend/web/index.php'
	    },
	    captchaKey: '6LcjNHQUAAAAAPVDqOJeDyL2NUTJRutxtdkI5BsH',
	    paths: {
	      categoriesMenu: '/param/get-category-menu',
	      categories: '/categoria-info/ver-categorias',
	      category: '/categoria-info/ver-categoria?id=',
	      categoryArbol: '/categoria-info/arbol-categoria?id=',
	      categoryProducts: '/categoria-info/ver-productos-categoria?id=',
	      categoryAttributes: '/categoria-info/ver-atributos-categoria-dos?id=',
	      advancedAttributes: '/item-info/get-advanced-attributes',
	      compoundAttributes: '/item-info/get-compounds-attributes?id=',
	      productsByAdvancedSearch: '/item-info/products-by-advanced-search',
	      featuredProducts: '/item-info/ver-productos-destacados',
	      product: '/item-info/ver-producto?id=',
	      compareProducts: '/item-info/comparar-productos?ids=',
	      relatedProducts: '/item-info/ver-productos-relacionados?id=',
	      searchProduct: '/item-info/buscar-producto?cadena=',
	      searchProductAutocomplete: '/item-info/autocompletado-producto?cadena=',
	      searchProductLength: '/item-info/buscar-producto-cantidad?cadena=',
	      adavancedSearchProduct: '/item-info/busqieda-avanzada-producto',
	      clonedProductPrice: '/item-info/obtener-precio-item-clonado',
	      setFavoriteProduct: '/item-info/set-favorite-product',
	
	      // Fast Search
	      fastSearchFavoriteItems: '/item-info/get-favorite-items',
	      fastSearchLastItemsBought: '/item-info/get-last-items-bought',
	
	      newItems: '/item-info/get-new-items',
	      bestSellerItems: '/item-info/ver-productos-mas-vendidos',
	      salesItems: '/item-info/lista-items-en-oferta',
	      salesItemsLength: '/item-info/total-items-en-oferta',
	
	      // Location Paths
	      countries: '/location/get-countries',
	      states: '/location/get-states?countryId=',
	      cities: '/location/get-cities?stateId=',
	      location: '/location/get-location?ids=',
	      locationBySearchText: '/location/get-location-by-search-text',
	
	      // Mails
	      mailContact: '/item-info/enviar-correo-contactenos',
	      mailProductNotFound: '/item-info/enviar-correo-producto-no-encontrado',
	      mailProductRecommended: '/item-info/enviar-correo-producto-recomendado',
	
	      mailNewsletter: '/item-info/send-newsletter-register',
	
	      // User
	      recoverPassword: '/login/recover-password',
	      userLogin: '/login/user-login',
	      userLogout: '/login/user-logout',
	      userRegister: '/login/user-register',
	      validateEmail: '/login/validate-email',
	      validateNumberId: '/login/validate-number-id-zona-de-pago',
	      userUpdate: '/user/update-user',
	      passwordUpdate: '/user/update-password',
	      getUserInfo: '/user/user-info',
	      thirdBySearchText: '/user/get-third-by-search-text',
	      userRegisterPayZone: '/login/user-register-pay-zone',
	
	      // Contact
	      getContactByIdentificationNumber: '/user/get-contact-by-identification-number',
	
	      // Carrito
	      addItemToCart: '/cart/agregar-item-canasta',
	      getCart: '/cart/obtener-canasta?cartId=',
	      deleteCart: '/cart/delete-cart',
	      deleteItemFromCart: '/cart/eliminar-item-canasta',
	      updateCommentCart: '/cart/update-comment-cart',
	      updateCommentItemCart: '/cart/update-comment-item-cart',
	      updateQuantityItemCart: '/cart/update-quantity-item-cart',
	      saveCartOrderData: '/cart/save-cart-order-data',
	      saveCartTunnelData: '/cart/save-cart-tunnel-data',
	      getPointsOfSale: '/cart/points-of-sale',
	      updateCityLocation: '/cart/update-city-location',
	      updatePayMethod: '/cart/update-pay-method',
	      updateDespachoPedido: '/cart/update-despacho-pedido',
	
	      // Order
	      payMethods: '/order/pay-methods',
	      payMethod: '/order/pay-method?payMethodId=',
	      saveOrder: '/order/save-order',
	      getOrder: '/order/order',
	      duplicateOrder: '/cart/duplicate-order',
	      getPay: '/order/get-pay-info?idPedido=',
	      getUserOrders: '/order/user-orders',
	      getDashboardInfo: '/dashboard/dashboard-info',
	      createCartTemplate: '/cart/create-cart-template',
	      getUserCartTemplates: '/cart/get-cart-templates',
	      getUserCartTemplate: '/cart/get-cart-template',
	      duplicateCartTemplate: '/cart/duplicate-cart-template',
	      deleteCartTemplate: '/cart/delete-cart-template',
	      changeStatus: '/order/change-status',
	      sincronizarPedido: '/order/sincronizar-erp',
	
	      // Quotes
	      updateOrder: '/order/update-order',
	      replyQuotes: '/quotes/reply-order',
	      sendCopyEmailOrder: '/order/send-copy-order',
	      convertOrder: '/quotes/convert-order',
	      getSummaryQuotes: '/quotes/summary-quotes',
	      loadPricesForPriceList: '/quotes/load-prices-for-price-list',
	      setLostQuote: '/quotes/set-lost-quote',
	
	      // Enlistment
	      createEnlistment: '/enlistment/create-enlistment',
	
	      // Warranty
	      searchWarranty: '/warranty/search-warranty',
	      saveWarranty: '/warranty/save-warranty',
	
	      // Banners
	      getBanners: '/template/get-ads-info',
	
	      // App params
	      getParams: '/param/get-app-params',
	
	      // Contact Locations
	      getContactLocations: '/location/get-contact-locations',
	
	      // Seller Client
	      getSellerClients: '/login/get-seller-clients',
	      getSellerClientThirds: '/login/get-client-thirds',
	      getSellerClientOperatingCenters: '/login/get-client-operating-centers',
	      setClientOperatingCenter: '/login/set-client-operating-center',
	      getOperatingCentersByUser: '/login/get-operating-centes-by-user',
	
	      // Edarvico: Busqueda de motobombas
	      getUmCaudalPresion: '/item-curva/get-unidades-medida',
	      getMotobombas: '/item-curva/buscar-items',
	      getCategoriasBombas: '/item-curva/get-categorias-bombas',
	
	      // Ocasional Client
	      getOcasionalInformation: '/user/get-ocasional-information',
	      updateInfoClientSelected: '/user/update-info-client-selected',
	      createUserByAdmin: '/user-admin/create-update-user-by-admin',
	      usersRelatedToAdmin: '/user-admin/users-related-to-admin',
	      sendInvitationToRealtedAdmin: '/user-admin/send-invitation',
	      enableUserAdmin: '/user-admin/enable-user-admin',
	      permissionsFront: '/user-admin/get-permissions-front',
	      preloadUserCreatedByAdmin: '/user-admin/preload-user-created-by-admin',
	
	      // Consult
	      getConsult: '/consult/get-consult',
	      orderStatusReport: '/sincronizaciones/reportes-b-2-b/pedido-importado',
	      referralsOrdersReport: '/sincronizaciones/reportes-b-2-b/remision-importada',
	
	      // Consult
	      getSucursales: '/login/get-sucursales-id-usuario',
	      PROVIDER: {
	        SCHEDULED_PAYMENTS: 'proveedores/pagos-programados/listar',
	        FINISHED_PAYMENTS: 'proveedores/pagos-realizados/listar',
	        CREDIT_NOTES: 'proveedores/notas-credito/listar'
	      },
	      PAYMENT_ADVANCED: {
	        QUOTATIONS_HEAD: 'recaudos/crm/cabeceracot',
	        QUOTATIONS_DETAIL: 'recaudos/crm/detallecot',
	        ORDERS_SERVICE_HEAD: 'recaudos/crm/cabeceraordenes',
	        ORDERS_SERVICE_DETAIL: 'recaudos/crm/detalleordenes'
	      },
	      PQRS: {
	        PARAMS: 'pqrs/get-params',
	        SAVE: 'pqrs/save-pqrs',
	        LIST: 'pqrs/get-pqrs-list',
	        DETAIL: 'pqrs/get-pqrs-detail',
	        SAVE_RESPONSE: 'pqrs/save-pqrs-response',
	        RESOLVED: 'pqrs/resolve-pqrs',
	        CHANGE_STATUS: 'pqrs/change-status',
	        RESPONSABLES_LIST: 'pqrs/get-responsable-pqrs-list?search=',
	        CHANGE_PQRS_RESPONSABLE: 'pqrs/change-responsable-pqrs',
	        EXPORT_CSV: 'pqrs/exportar-incidencias-listado-csv',
	        EXPORT_CSV_DETAIL: 'pqrs/exportar-incidencia-csv'
	      },
	      REPORTS: {
	        // SYNC: {
	        //   ORDER: {
	        //     STATES: '/sincronizaciones/reportes-b-2-b/pedido-importado'
	        //   },
	        //   REMISSION: {
	        //     LIST: '/sincronizaciones/reportes-b-2-b/remision-importada'
	        //   }
	        // },
	        SYNC: {
	          ORDER: {
	            STATES: '/sincronizaciones/reportes-b-2-b/pedido-importado'
	          },
	          REMISSION: {
	            LIST: '/sincronizaciones/reportes-b-2-b/remision-importada'
	          },
	          BILLFOLD: {
	            LIST: "/sincronizaciones/reportes-b-2-b/cartera-importada"
	          }
	        },
	        B2B: {
	          CLIENT: "/sincronizaciones/reportes-b-2-b/cliente",
	          ORDERS: "/sincronizaciones/reportes-b-2-b/pedidos-cliente",
	          CONSOLIDATED: "/sincronizaciones/reportes-b-2-b/consolidados-cliente", // TODO: DELETE
	          //BILLFOLD_RESUME: "/sincronizaciones/reportes-b-2-b/cartera-cliente", // TODO: DELETE
	          CONSOLIDATED_SMARTB: "/sincronizaciones/reportes-b-2-b/consolidados-cliente-smart-b",
	          // BILLFOLD_RESUME: "/sincronizaciones/reportes-b-2-b/cartera-cliente",
	          BILLFOLD_RESUME: "/sincronizaciones/reportes-b-2-b/reporte-cartera-cliente"
	        }
	      },
	      PRODUCTS: {
	        LAST_ITEMS_BOUGHT: '/item-info/get-last-items-bought'
	      }
	    }
	  },
	  site: {
	    config: {
	      // Bandera para depuración del sitio. Muestra cierta información como
	      // liquidación de transporte, etc.
	      debug: false,
	      showLegalAdvice: false,
	      redirectToB2bPage: true,
	      quantity_validate: false,
	      data: {
	        item: {
	          // Muestra los comentarios en la canasta
	          showComments: false,
	          // Habilitación del filtro de precios en el listado de productos de unsa categoría
	          showItemsPriceFilter: true,
	          // Texto utilizado para el 'Precio en Internet'
	          internetPriceString: 'Precio',
	          annexedDocumentString: 'Ficha Técnica',
	          getMoreSelledProducts: false,
	          getNewProducts: false,
	          getJoyasDeLaCasaProducts: false,
	          placeholderSearchProduct: ''
	        },
	        shipping: {
	          // Habilita la búsqueda rápida. No utilizar.
	          fastSearch: true,
	          // Muestra el punto de venta en la canasta.
	          showPointsOfSale: false,
	          // Muestra la forma de entrega en la canasta
	          showShippingMethod: false,
	          // Muestra el banner de entrega en la canasta. Este se debe utilizar cuando
	          // se ocultan los dos parámetros: showPointsOfSale, showShippingMethod
	          showBannerShippingMethod: true
	        },
	        cart: {
	          cartBuyText: 'Confirmar pedido',
	          // Mostrar comentario de la orden
	          showOrderComment: true,
	          maxlengthOrderComment: 60,
	          // Mostrar simulación de cupon
	          showDiscountCoupon: false,
	          // Mostrar precio de transporte
	          showTransportPrice: true,
	          // mostrar boton de pdf
	          showPdfButton: false,
	          // mostrar mensaje 'TENER PRESENTE'
	          showPremessageOrder: false,
	          showSelectPriceList: false,
	          showFooterCartBanner: false,
	          showCartetera: false
	        },
	        tunnel: {
	          // Mostrar fecha programada de entrega
	          showContactProgrammedDelivery: true,
	          // Utilizar pasarela
	          hasGangway: true,
	          // Permite realizar cotizaciones sin estar logueado
	          allowQuotesNoLogin: true
	        },
	        banners: {
	          // Mostrar banners de noticias. Essto fue una prueba.
	          showNews: false
	        },
	        categories: {
	          // Tipos de Menu:
	          // 1. Con campo de filtro
	          // 2. Slider a 2 niveles
	          // 3. Slider multinivel
	          menuType: 2,
	          textOurProducts: ""
	        },
	        register: {
	          // Login automático o no
	          automaticLogin: true,
	          allowRegister: false
	        }
	      },
	      header: {
	        showIcons: false,
	        show_account_in_header: true,
	        selectBranch: false,
	        show_cart_in_header: false,
	        showCategories: false,
	        showKnowUs: false,
	        showOfferts: false,
	        showContact: true,
	        show_tab_right: false,
	        show_pay_zone: true,
	        pay_zone: {
	          pay_zone_and_advances: true,
	          only_pay_zone: false,
	          only_advances: false,
	          only_payments: false
	        },
	        logout: {
	          state_lost_session: 'home.login'
	        },
	        fastLoad: {
	          showFastLoad: false
	        }
	      },
	      footer: {
	        is_template: false,
	        template: '',
	        options_list: [{}],
	        products: {
	          show: true,
	          text_describe: 'Productos',
	          is_state: false,
	          url_state: ''
	        }
	      },
	      pay_zone: {
	        home_url: 'home.detailZone',
	        payments_url: 'home.myPaymentsList'
	      },
	      login: {
	        // text_welcome_withow_branch: 'Las credenciales de acceso son validas. En un momento la página se recargara y tendra acceso a su cuenta.',
	        text_welcome_withow_branch: 'Los datos de acceso son correctos, bienvenido a nuestra tienda virtual.',
	        text_welcome_with_branch: 'Las credenciales de acceso son validas. Seleccione la sucursal con la que desea realizar las compras.'
	      },
	      // Panel de control del usuario
	      dashboard: {
	        // Mostrar las ordenes
	        showMyOrders: true,
	        // Mostrar las cotizaciones
	        showMyQuotes: true,
	        // Mostrar ver mi cuenta. Aquí se realiza la actualización de los datos.
	        showMyAccount: true,
	        // Mostrar cliente seleccionado. Dejar en 'false'.
	        showSelectClient: true
	      },
	      menu: {
	        // Mostrar menu de Incidencias
	        showPqrs: false,
	        // Mostrar menu de consultas B2B
	        showConsults: false,
	        // Mostrar menu corporativo
	        showCoorporateDemoMenu: false,
	        // mostrar enlace de búsqueda de trabajo
	        showSearchJob: false,
	        // Mostrar búsqueda dentro del menu
	        showSearchInsideMenu: false,
	        // Mostrar enlace de búsqueda rápida en el menu del footer. Si
	        // se deja en 'true' el enalce se muestra en el menu del header.
	        showFastLoadInHeader: false,
	        showFastLoadInFooter: false,
	        showFastLoadAlways: false,
	        fastLoadText: 'Carga rápida'
	      }
	    },
	    app: {
	      url: 'https://www.pallomaro.com/tienda/',
	      title: 'Diamante',
	      description: 'Descripción el diamante',
	      header: {
	        showContactInfo: true,
	        placeholder: 'Buscar',
	        logo: {
	          src: './assets/img/proyect-selected/logo-header.png',
	          url: 'home.home',
	          url_url: '/app/home',
	          // url: 'https://www.pallomaro.com/tienda/#/',
	          title: 'Diamante',
	          alt: 'Diamante',
	          width: '150px',
	          height: 'auto'
	        }
	      },
	      pages: {
	        corporate: {
	          link: {
	            url: 'home.knowUs',
	            title: 'Diamante'
	          }
	        }
	      },
	      footer: {
	        menu: {
	          contactUrl: 'home.contact'
	        },
	        info: {
	          title: '',
	          description: 'Trabajamos con excelencia y motivación para que cada día podamos garantizar el bienestar que trae ambientes sanos y limpios; entregar los mejores procesos y productos; brindar una atención cálida y eficaz, y asegurando el cuidado del medio ambiente.',
	          date: new Date()
	        },
	        logo: {
	          src: './assets/img/proyect-selected/logo-footer.png',
	          title: 'Diamante',
	          alt: 'Diamante',
	          width: '190px',
	          height: 'auto'
	        },
	        showNewsletterForm: false
	      }
	    },
	    info: {
	      company: {
	        name: 'DIAMANTE',
	        nit: '', // TODO
	        webpage: '', // TODO
	        address: 'Calle 4B No. 38-17',
	        pbx: '(2) 514 7777',
	        phone: '',
	        cell: '',
	        email: 'asistenteoperativo3@diamante.com.co',
	        location: 'CALI'
	      },
	      social: {
	        facebook: {
	          title: 'Síguenos en facebook',
	          link: 'https://www.facebook.com/brilladoraeldiamante/',
	          alt: 'Facebook',
	          show: true
	        },
	        youtube: {
	          title: 'Véanos en youtube',
	          link: 'https://www.youtube.com/user/6136465?sub_confirmation=1',
	          alt: 'Youtube',
	          show: false
	        },
	        twitter: {
	          title: 'Twitter Diamante',
	          link: 'https://twitter.com/Diamante1955',
	          alt: 'Twitter',
	          show: true
	        },
	        pinterest: {
	          title: 'Pinterest Diamante',
	          link: 'https://www.pinterest.com/davidsoul69/Diamante-valoramos-la-alimentaci%C3%B3n/',
	          alt: 'Pinterest',
	          show: false
	        },
	        linkedin: {
	          title: 'Linkedin Diamante',
	          link: 'https://www.linkedin.com/company-beta/10323386',
	          alt: 'Twitter',
	          show: true
	        },
	        instagram: {
	          title: 'Instagram Diamante',
	          link: 'https://www.instagram.com/Diamante/',
	          alt: 'Instagram',
	          show: false
	        }
	      },
	      /*
	      video: {
	        link: 'https://www.youtube.com/embed/hq7ZrUQN1ZY'
	      },
	      imagenvideo: {
	        idvideo: 'http://img.youtube.com/vi/hq7ZrUQN1ZY/0.jpg'
	      },
	      */
	      recaptcha: {
	        id: '6LfbIwsTAAAAAKhEWIKXphwD_Qa26r0_xl5E0Yon'
	      }
	    }
	  }
	};
	
	exports.default = constants;

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dependenciesModule = _angular2.default.module('app.dependencies', ['angular-jwt', 'ui.router', 'ui.bootstrap', 'ngAria', 'ngMessages', 'ngCookies', 'ngAnimate', 'ngMaterial', 'rzModule', 'vcRecaptcha', 'uiGmapgoogle-maps', 'simplePagination', 'ngTable', 'naif.base64', 'MassAutoComplete', 'angularUtils.directives.dirPagination', 'ui.grid', 'ui.grid.selection', 'ui.grid.resizeColumns', 'ui.grid.edit', 'ui.grid.rowEdit', 'ui.grid.cellNav', 'ui.grid.pinning', 'ui.grid.pagination', 'ui.grid.grouping', 'ui.grid.autoResize', 'ui.grid.exporter', 'oc.lazyLoad']);
	
	exports.default = dependenciesModule;

/***/ },
/* 132 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	appRun.$inject = ['$rootScope', '$window', '$state', '$transitions'];
	
	function appRun($rootScope, $window, $state, $transitions, $timeout) {
	  $rootScope.reloadProyect = false;
	  $rootScope.reloadProyectState = '';
	  $transitions.onSuccess({ to: 'home.**' }, function (trans1, trans) {
	
	    document.body.scrollTop = document.documentElement.scrollTop = 0;
	    // if (!auth.isAuthenticated()) {
	    //   // User isn't authenticated. Redirect to a new Target State
	    //   return trans.router.stateService.target('login');
	    // }
	    if ($rootScope.reloadProyect) {
	      $rootScope.reloadProyect = false;
	      $state.go($rootScope.reloadProyectState);
	      // $timeout(() => {
	      //   $state.reload();
	      // }, 1000);
	    }
	  });
	}
	
	exports.default = appRun;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cart = __webpack_require__(135);
	
	var _cart2 = _interopRequireDefault(_cart);
	
	var _cartView = __webpack_require__(445);
	
	var _cartView2 = _interopRequireDefault(_cartView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CartComponent = {
	  template: _cartView2.default,
	  controller: _cart2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = CartComponent;

/***/ },
/* 134 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.cart', {
	    url: "/canasta",
	    template: '<cart sh-ctrl="shCtrl"></cart>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modalResponseView = __webpack_require__(3);
	
	var _modalResponseView2 = _interopRequireDefault(_modalResponseView);
	
	var _modalMapView = __webpack_require__(38);
	
	var _modalMapView2 = _interopRequireDefault(_modalMapView);
	
	var _productCommentModalView = __webpack_require__(449);
	
	var _productCommentModalView2 = _interopRequireDefault(_productCommentModalView);
	
	var _createTemplateModalView = __webpack_require__(446);
	
	var _createTemplateModalView2 = _interopRequireDefault(_createTemplateModalView);
	
	var _modalLogisticView = __webpack_require__(448);
	
	var _modalLogisticView2 = _interopRequireDefault(_modalLogisticView);
	
	var _modalCommentCartView = __webpack_require__(447);
	
	var _modalCommentCartView2 = _interopRequireDefault(_modalCommentCartView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'CartService', '$state', '$rootScope', 'SharedService', '$uibModal', 'ngAuthSettings', 'SessionService', '$timeout', '$filter'];
	
	var CartController = function () {
	  function CartController($scope, CartService, $state, $rootScope, SharedService, $uibModal, ngAuthSettings, SessionService, $timeout, $filter) {
	    var _this = this;
	
	    _classCallCheck(this, CartController);
	
	    this.$state = $state;
	    this.ngAuthSettings = ngAuthSettings;
	    this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.$filter = $filter;
	    this.$rootScope = $rootScope;
	    this.$uibModal = $uibModal;
	    this.SessionService = SessionService;
	    this.CartService = CartService;
	    this.SharedService = SharedService;
	    this.loanding = false;
	    this.orderDataForm = {
	      country: '',
	      state: '',
	      city: '',
	      shipping: 0,
	      payment: '',
	      comment: '',
	      clientPriceList: ''
	    };
	    this.quoteCartSeller = {
	      realOrderInfo: {},
	      realQuoteInfo: {}
	    };
	    this.orderDataForm.locationsByFastSearch = [];
	    this.orderDataForm.locationSelected = false;
	    this.orderDataForm.searchLocationtext = '';
	    this.orderDataForm.loadingLocationsByFastSearh = false;
	    this.orderDataForm.loadedLocationsByFastSearch = false;
	    this.orderDataForm.errorLoadingLocationsByFastSearch = false;
	    this.quoteCartSeller.subtotalItemsQuoteValueSeller = 0;
	    this.quoteCartSeller.discountsItemsQuoteValueSeller = 0;
	    this.quoteCartSeller.ivaItemsQuoteValueSeller = 0;
	    this.quoteCartSeller.transportItemsQuoteValueSeller = 0;
	    this.quoteCartSeller.totalItemsQuoteValueSeller = 0;
	    this.pesoTotalCanasta = 0;
	    this.cantidadTotalCanasta = 0;
	    this.updatingCityLocation = false;
	    this.updatedCityLocation = false;
	    this.errorUpdatingCityLocation = false;
	    this.pointsOfSaleData = [];
	    this.pointOfSaleId = '';
	    this.currentPointOfSale = '';
	    this.loadingPointsOfSale = false;
	    this.loadedPointsOfSale = false;
	    this.savingPayMethodCart = false;
	    this.errorUpdatingPayMethod = false;
	    this.addingQuantityItemCart = false;
	    this.addedQuantityItemCart = false;
	    this.errorAddingQuantityItemtoCart = false;
	    this.errorMessageAddingQuantityItemtoCart = '';
	    this.errorMessagesAddingQuantityItemtoCart = '';
	    this.coupon = {};
	    this.coupon.savingCoupon = false;
	    this.coupon.savedCoupon = false;
	    this.coupon.validCoupon = false;
	    this.orderDataForm.loadingCartInfo = false;
	    this.orderDataForm.loadedCartInfo = false;
	    this.loadedPayMethods = false;
	
	    this.cart = {};
	
	    this.$rootScope.$on('onUpdateCart', function (event, arg) {
	      _this.updateCart();
	    });
	  }
	
	  _createClass(CartController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      var cartId = this.SessionService.get('cartId') || '';
	      var userId = '';
	      try {
	        userId = this.shCtrl.globals.currentUser.userId;
	      } catch (e) {}
	      var clientPriceListName = '';
	      try {
	        clientPriceListName = this.SessionService.get('quoteCartSeller').clientPriceList;
	      } catch (e) {}
	      this.CartService.getCart(cartId, userId, clientPriceListName, true).then(function (response) {
	        _this2.cart = response;
	        _this2.getAllCartOrderInfo();
	        // Get the bill resume
	        try {
	          if (_this2.shCtrl.globals.currentClient.third) {
	            _this2.getInfoBillfoldState();
	          }
	        } catch (e) {}
	      }).catch(function () {
	        _this2.$state.go(_this2.ngAuthSettings.site.app.header.logo.url);
	      });
	    }
	  }, {
	    key: 'getAllCartOrderInfo',
	    value: function getAllCartOrderInfo() {
	      var _this3 = this;
	
	      this.orderDataForm.loadingCartInfo = true;
	      this.orderDataForm.loadedCartIfno = false;
	      var cart = angular.copy(this.shCtrl.cart);
	      if (cart) {
	        var sellerId = '';
	        try {
	          sellerId = this.shCtrl.globals.currentUser.sellerId;
	        } catch (e) {}
	
	        var userId = '';
	        try {
	          userId = this.shCtrl.globals.currentUser.userId;
	        } catch (e) {}
	
	        this.CartService.getPayMethods(sellerId, userId).then(function (response) {
	          if (!_this3.orderDataForm.pointOfSaleId) {
	            _this3.loadedPayMethods = true;
	            _this3.payMethods = response;
	            if (response.length === 1) {
	              _this3.orderDataForm.payment = response[0].id;
	            }
	          }
	          _this3.CartService.getPointsOfSale().then(function (response2) {
	            if (!_this3.orderDataForm.pointOfSaleId) {
	              _this3.loadedPointsOfSale = true;
	              _this3.pointsOfSaleData = response2.operatingCenters;
	            }
	            _this3.$timeout(function () {
	              // Set the default Point of Sale
	              var pointOfSaleId = _this3.shCtrl.cart.order.pointOfSale.id;
	              if (pointOfSaleId) {
	                _this3.orderDataForm.pointOfSaleId = pointOfSaleId.toString();
	                _this3.setCurrentPointOfSale(_this3.orderDataForm.pointOfSaleId);
	              } else if (_this3.pointsOfSaleData.length === 1) {
	                _this3.orderDataForm.pointOfSaleId = _this3.pointsOfSaleData[0].id.toString();
	                _this3.setCurrentPointOfSale(_this3.orderDataForm.pointOfSaleId);
	              }
	
	              if (!_this3.orderDataForm.shipping && _this3.shCtrl.cart.order.shippingId) {
	                _this3.orderDataForm.shipping = _this3.shCtrl.cart.order.shippingId.toString();
	              }
	              if (!_this3.orderComment && _this3.shCtrl.cart.order.comment) {
	                _this3.orderComment = _this3.shCtrl.cart.order.comment.toString();
	              }
	              if (!_this3.orderDataForm.comment && _this3.shCtrl.cart.order.comment) {
	                _this3.orderDataForm.comment = _this3.shCtrl.cart.order.comment.toString();
	              }
	
	              if (!_this3.orderDataForm.payment && _this3.shCtrl.cart.order.payment.id) {
	                _this3.orderDataForm.payment = _this3.shCtrl.cart.order.payment.id.toString();
	              } else if (_this3.payMethods.length === 1) {
	                _this3.orderDataForm.payment = _this3.payMethods[0].id.toString();
	              }
	
	              // Set the city
	              try {
	                if (_this3.shCtrl.cart.order.location.city.id) {
	                  _this3.orderDataForm.city = _this3.shCtrl.cart.order.location.city.id;
	                  _this3.orderDataForm.state = _this3.shCtrl.cart.order.location.state.id;
	                  _this3.orderDataForm.country = _this3.shCtrl.cart.order.location.country.id;
	
	                  _this3.orderDataForm.searchLocationtext = _this3.shCtrl.cart.order.location.city.name + ', ';
	                  _this3.orderDataForm.searchLocationtext += _this3.shCtrl.cart.order.location.state.name + ', ';
	                  _this3.orderDataForm.searchLocationtext += _this3.shCtrl.cart.order.location.country.name;
	                }
	              } catch (e) {}
	            }, 1000);
	          }).catch(function (reason) {});
	        }).catch(function (reason) {});
	      }
	      this.orderDataForm.loadingCartInfo = false;
	      this.orderDataForm.loadedCartInfo = true;
	    }
	  }, {
	    key: 'getInfoBillfoldState',
	    value: function getInfoBillfoldState() {
	      var _this4 = this;
	
	      try {
	        this.loadingBillResume = true;
	        var thirdDocumentNumber = this.shCtrl.globals.currentClient.third.documentNumber;
	        var branchCode = this.shCtrl.globals.currentClient.operatingCenter.code;
	        this.CartService.getInfoBillfoldState(thirdDocumentNumber, branchCode).then(function (billfoldResume) {
	          _this4.billfoldResume = billfoldResume;
	          _this4.loadingBillResume = false;
	          _this4.loadedBillResume = true;
	          _this4.lastUpdatedBillResume = _this4.$filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
	        }).catch(function (error) {
	          _this4.loadingBillResume = false;
	        });
	      } catch (e) {
	        // ...
	      }
	    }
	  }, {
	    key: 'buyNow',
	    value: function buyNow(form, allowGuestInTunnel) {
	      var _this5 = this;
	
	      if (allowGuestInTunnel === 'register') {
	        this.$state.go('home.login');
	        return;
	      }
	      this.$rootScope.allowGuestInTunnel = allowGuestInTunnel || 0;
	      this.showAllCartErrors = false;
	      if (form.$valid) {
	        if (this.cart) {
	          var itemWithOutStock = this.cart.items.filter(function (value) {
	            if (value.quantity > value.cantidad) {
	              return value;
	            }
	          });
	          if (itemWithOutStock.length) {
	            var cartItemHtml = '';
	            itemWithOutStock.forEach(function (val) {
	              cartItemHtml += '\n              <li>\n                <strong>- Producto: </strong> ' + val.name + ' -\n                <strong>Cantidad: </strong>' + val.cantidad + ' Unidades\n              </li>';
	            });
	            var mensaje = '\n            <span>Lo Sentimos, Algunos productos exceden la cantidad dispobible<strong>\n            <ul>\n              ' + cartItemHtml + '\n            </ul>\n            Por favor elimine el excedente.</span>';
	            var _options = {
	              title: 'Cantidad no disponible',
	              isHtml: true,
	              content: mensaje,
	              size: '',
	              showBottonCancel: false,
	              textActionCancel: '',
	              textAction: 'Aceptar'
	            };
	            return this.messageResponse(_options);
	          }
	        }
	        if (this.cart.cartId) {
	          this.savingOrderCart = true;
	          this.savedOrderCart = false;
	          this.errorSavingOrderCart = false;
	          this.orderDataForm.cartId = this.cart.cartId;
	          this.orderDataForm.userId = '';
	          this.orderDataForm.sellerId = '';
	          try {
	            this.orderDataForm.userId = this.shCtrl.globals.currentUser.userId;
	          } catch (e) {}
	          try {
	            this.orderDataForm.sellerId = this.shCtrl.globals.currentUser.sellerId;
	          } catch (e) {}
	          this.CartService.saveCartOrderData(this.orderDataForm).then(function (response) {
	            _this5.savingOrderCart = false;
	            if (!response.error) {
	              _this5.savedOrderCart = true;
	              _this5.$state.go('home.tunnel');
	            } else {
	              var errorMessageSavingOrderCart = response.message;
	              _this5.errorSavingOrderCart = true;
	              var messageTitle = response.errorCode === 'EVMP' ? 'El pedido no puede ser procesado' : 'Debes diligenciar algunos datos aún...';
	              var _options2 = {
	                title: messageTitle,
	                isHtml: true,
	                content: errorMessageSavingOrderCart,
	                size: '',
	                showBottonCancel: false,
	                textActionCancel: '',
	                textAction: 'Aceptar'
	              };
	              _this5.messageResponse(_options2);
	            }
	          }).catch(function (reason) {
	            _this5.savingOrderCart = false;
	            _this5.savedOrderCart = false;
	            _this5.errorSavingOrderCart = true;
	            var options = {
	              title: '',
	              isHtml: false,
	              content: 'Ha ocurrido un error al actualizar la informacion del carrito',
	              size: '',
	              showBottonCancel: false,
	              textActionCancel: '',
	              textAction: 'Aceptar'
	            };
	            _this5.messageResponse(options);
	          });
	        }
	      } else {
	        this.showAllCartErrors = true;
	        angular.forEach(form.$error.required, function (field) {
	          field.$setDirty();
	        });
	        if (!this.orderForm.searchLocationtext) this.orderForm.searchLocationtext = {};
	        if (!this.orderForm.payment) this.orderForm.payment = {};
	        if (!this.orderForm.clientPriceList) this.orderForm.clientPriceList = {};
	        var contentDynamic = '';
	        if (this.orderForm.searchLocationtext.$invalid && !this.orderForm.searchLocationtext.$pristine) {
	          contentDynamic = '\n          <li>\n            Seleccione la Ciudad.\n          </li>';
	        }
	        if (this.orderForm.payment.$invalid && !this.orderForm.payment.$pristine) {
	          contentDynamic += '\n          <li>\n            Seleccione el medio de pago.\n          </li>';
	        }
	        if (this.orderForm.clientPriceList.$invalid && !this.orderForm.clientPriceList.$pristine) {
	          contentDynamic += '\n          <li>\n            Seleccione la lista de precios a aplicar al cliente.\n          </li>';
	        }
	        var _options3 = {
	          title: 'Faltan algunos datos por diligenciar...',
	          isHtml: true,
	          content: '\n          <div>\n            <p>\n              Para continuar con este proceso debes diligenciar los siguientes datos:\n            </p>\n            <ul style="margin-top: 10px;list-style: inherit;margin-left: 30px;">\n              ' + contentDynamic + '\n            </ul>\n          </div>\n        ',
	          size: '',
	          showBottonCancel: false,
	          textActionCancel: '',
	          textAction: 'Aceptar'
	        };
	        this.messageResponse(_options3);
	      }
	    }
	  }, {
	    key: 'showProductComment',
	    value: function showProductComment(item) {
	      var modal_options = this.$uibModal.open({
	        animation: true,
	        template: _productCommentModalView2.default,
	        controller: 'ProductCommentModalController',
	        controllerAs: 'mdCtrl',
	        size: '',
	        resolve: {
	          modalOptions: function modalOptions() {
	            return item;
	          }
	        }
	      });
	      modal_options.result.then(function () {}).catch(function (reason) {});
	    }
	  }, {
	    key: 'getLocationsByFastSearch',
	    value: function getLocationsByFastSearch(searchLocationText) {
	      var _this6 = this;
	
	      this.orderDataForm.locationSelected = false;
	      this.orderDataForm.locationsByFastSearch = [];
	      this.orderDataForm.locationSelected = false;
	      this.orderDataForm.country = '';
	      this.orderDataForm.state = '';
	      this.orderDataForm.city = '';
	      this.orderDataForm.loadingLocationsByFastSearh = false;
	      this.orderDataForm.loadedLocationsByFastSearch = false;
	      this.orderDataForm.errorLoadingLocationsByFastSearch = false;
	      if (searchLocationText.length > 3) {
	        this.orderDataForm.loadingLocationsByFastSearh = true;
	        this.CartService.locationBySearchText({
	          'searchText': searchLocationText,
	          'showOnlyValidCountries': 1,
	          'showOnlyCitiesInTransportRule': 1
	        }).then(function (response) {
	          _this6.orderDataForm.loadingLocationsByFastSearh = false;
	          _this6.orderDataForm.loadedLocationsByFastSearch = true;
	          _this6.orderDataForm.locationsByFastSearch = response;
	        }).catch(function (reason) {
	          _this6.orderDataForm.loadingLocationsByFastSearh = false;
	          _this6.orderDataForm.loadedLocationsByFastSearch = true;
	          _this6.orderDataForm.errorLoadingLocationsByFastSearch = true;
	        });
	      }
	    }
	  }, {
	    key: 'setLocationCity',
	    value: function setLocationCity(location) {
	      this.orderDataForm.country = location.countryId;
	      this.orderDataForm.state = location.stateId;
	      this.orderDataForm.city = location.cityId;
	
	      this.orderDataForm.locationSelected = true;
	      this.orderDataForm.searchLocationtext = location.cityName + ', ' + location.stateName + ' - ' + location.countryName;
	      this.updateCityLocation();
	    }
	  }, {
	    key: 'updateValuesQuoteSeller',
	    value: function updateValuesQuoteSeller() {
	      var _this7 = this;
	
	      if (!this.orderDataForm.clientPriceList) {
	        try {
	          this.orderDataForm.clientPriceList = this.SessionService.get('quoteCartSeller').clientPriceList;
	        } catch (e) {}
	
	        if (!this.orderDataForm.clientPriceList) {
	          this.orderDataForm.clientPriceList = 'client';
	        }
	      }
	      this.quoteCartSeller.subtotalItemsQuoteValueSeller = 0;
	      this.quoteCartSeller.ivaItemsQuoteValueSeller = 0;
	      this.quoteCartSeller.discountsItemsQuoteValueSeller = 0;
	      this.quoteCartSeller.transportItemsQuoteValueSeller = 0;
	      this.quoteCartSeller.totalItemsQuoteValueSeller = 0;
	
	      var realOrderInfo = {
	        subtotal: 0,
	        iva: 0,
	        discount: 0,
	        transport: 0,
	        total: 0
	      };
	
	      var realQuoteInfo = {
	        subtotal: 0,
	        iva: 0,
	        discount: 0,
	        transport: 0,
	        total: 0
	      };
	      if (this.shCtrl.globals.currentUser.isSeller) {
	        // Se actualiza la informacion de los precios
	        var itemsQuoteCartSeller = [];
	        var priceListName = this.orderDataForm.clientPriceList;
	
	        var subtotal = 0;
	        var taxes = 0;
	        var discounts = 0;
	        var total = 0;
	        this.cart.items.forEach(function (item, key) {
	          try {
	            // Item data
	            var itemId = item.id;
	            var itemQuantity = item.quantity;
	            var itemUnitValue = item.priceItemQuoteSeller;
	            var itemQuantityValue = item.quantity * item.priceItemQuoteSeller;
	            var itemTaxPercent = item.ivaPercentageQuoteSeller;
	            var itemDiscountPercent = item.discountPercentageItemQuoteSeller;
	            // Some verifications
	            if (isNaN(itemDiscountPercent) || itemDiscountPercent < 0 || itemDiscountPercent > 100) {
	              item.discountPercentageItemQuoteSeller = 0;
	              itemDiscountPercent = 0;
	            } else if (priceListName === 'client' && itemDiscountPercent > item.maxDiscount) {
	              item.discountPercentageItemQuoteSeller = item.maxDiscount;
	              itemDiscountPercent = item.maxDiscount;
	            } else if (priceListName === 'cost' && itemDiscountPercent > 100) {
	              item.discountPercentageItemQuoteSeller = 100;
	              itemDiscountPercent = 100;
	            }
	
	            // Item values
	            var itemSubtotal = itemQuantityValue;
	            var itemDiscount = 0;
	
	            if (priceListName === 'client') {
	              itemDiscount = itemQuantityValue * itemDiscountPercent / 100;
	            }
	            if (priceListName === 'cost') {
	              itemDiscount = itemQuantityValue / ((100 - itemDiscountPercent) / 100);
	              itemDiscount = itemDiscount - itemQuantityValue;
	            }
	            // Discount or Profit?
	            var itemQuantityValueWithDiscount = 0;
	            if (priceListName === 'client') {
	              itemQuantityValueWithDiscount = itemQuantityValue - itemDiscount;
	            }
	            if (priceListName === 'cost') {
	              itemQuantityValueWithDiscount = itemQuantityValue + itemDiscount;
	            }
	            var itemTax = itemQuantityValueWithDiscount * itemTaxPercent / 100;
	            var itemTotal = itemQuantityValueWithDiscount + itemTax;
	
	            // Totals
	            subtotal += itemQuantityValue;
	            discounts += itemDiscount;
	            taxes += itemTax;
	            total += itemTotal;
	
	            // Update the item total model
	            _this7.cart.items[key].totalItemCartSeller = itemTotal;
	
	            // ========================================================================================================================
	            // Real quote values
	            // ========================================================================================================================
	            if (item.quote) {
	              realQuoteInfo.subtotal += itemQuantityValue;
	              realQuoteInfo.iva += itemTax;
	              realQuoteInfo.discount += itemDiscount;
	              if (priceListName === 'client') {
	                realQuoteInfo.total = realQuoteInfo.subtotal - realQuoteInfo.discount + realQuoteInfo.iva;
	              } else if (priceListName === 'cost') {
	                realQuoteInfo.total = realQuoteInfo.subtotal + realQuoteInfo.discount + realQuoteInfo.iva;
	              }
	            }
	            // ========================================================================================================================
	            // Real order values
	            // ========================================================================================================================
	            else {
	                realOrderInfo.subtotal += itemQuantityValue;
	                realOrderInfo.iva += itemTax;
	                realOrderInfo.discount += itemDiscount;
	
	                if (priceListName === 'client') {
	                  realOrderInfo.total = realOrderInfo.subtotal + realOrderInfo.iva - realOrderInfo.discount;
	                } else if (priceListName === 'cost') {
	                  realOrderInfo.total = realOrderInfo.subtotal + realOrderInfo.iva + realOrderInfo.discount;
	                }
	              }
	
	            // ========================================================================================================================
	            // Push data to the cart seller object
	            // ========================================================================================================================
	            itemsQuoteCartSeller.push({
	              id: item.id,
	              priceItemQuoteSeller: itemUnitValue,
	              ivaPercentageQuoteSeller: itemTaxPercent,
	              discountPercentageItemQuoteSeller: itemDiscountPercent,
	              discountValueItemQuoteSeller: itemDiscount
	            });
	          } catch (e) {
	            var options2 = {
	              title: '',
	              isHtml: false,
	              content: e,
	              size: '',
	              showBottonCancel: false,
	              textActionCancel: '',
	              textAction: 'Aceptar'
	            };
	            _this7.messageResponse(options);
	          }
	
	          try {
	            // Update the model
	            _this7.quoteCartSeller.subtotalItemsQuoteValueSeller = subtotal;
	            _this7.quoteCartSeller.ivaItemsQuoteValueSeller = taxes;
	            _this7.quoteCartSeller.discountsItemsQuoteValueSeller = discounts;
	            _this7.quoteCartSeller.transportItemsQuoteValueSeller = $rootScope.cartTransports;
	            _this7.quoteCartSeller.totalItemsQuoteValueSeller = total + $rootScope.cartTransports;
	
	            _this7.quoteCartSeller.realOrderInfo.transport = $rootScope.cartTransports;
	            _this7.quoteCartSeller.realOrderInfo.total += +$rootScope.cartTransports;
	            _this7.quoteCartSeller.realOrderInfo = realOrderInfo;
	
	            _this7.quoteCartSeller.realQuoteInfo.transport = $rootScope.cartTransports;
	            _this7.quoteCartSeller.realQuoteInfo.total += +$rootScope.cartTransports;
	            _this7.quoteCartSeller.realQuoteInfo = realQuoteInfo;
	            // save data state to cookie
	            _this7.SessionService.put('quoteCartSeller', {
	              clientPriceList: priceListName,
	              itemsQuoteCartSeller: itemsQuoteCartSeller,
	              subtotalItemsQuoteValueSeller: subtotal,
	              ivaItemsQuoteValueSeller: taxes,
	              discountsItemsQuoteValueSeller: discounts,
	              totalItemsQuoteValueSeller: _this7.quoteCartSeller.totalItemsQuoteValueSeller,
	              realOrderInfo: realOrderInfo,
	              realQuoteInfo: realQuoteInfo
	            });
	          } catch (e) {
	            var _options4 = {
	              title: '',
	              isHtml: false,
	              content: e,
	              size: '',
	              showBottonCancel: false,
	              textActionCancel: '',
	              textAction: 'Aceptar'
	            };
	            _this7.messageResponse(_options4);
	          }
	        });
	      }
	      this.updateCart();
	    }
	  }, {
	    key: 'setCurrentPointOfSale',
	    value: function setCurrentPointOfSale(pointOfSaleId) {
	      var _this8 = this;
	
	      this.pointsOfSaleData.forEach(function (pointOfSale) {
	        if (pointOfSale.id === pointOfSaleId) {
	          _this8.currentPointOfSale = pointOfSale;
	        }
	      });
	    }
	  }, {
	    key: 'savePayMethodCart',
	    value: function savePayMethodCart(payMethodId) {
	      var _this9 = this;
	
	      if (payMethodId) {
	        this.savingPayMethodCart = true;
	        this.errorUpdatingPayMethod = false;
	        var data = {
	          'cartId': this.cart.cartId,
	          'payMethodId': payMethodId
	        };
	        this.CartService.updatePayMethod(data).then(function (response) {
	          if (!response.error) {
	            _this9.savingPayMethodCart = false;
	            _this9.updateCart();
	          } else {
	            _this9.savingPayMethodCart = false;
	            _this9.errorUpdatingPayMethod = true;
	            _this9.orderDataForm.payment = '';
	          }
	        }).catch(function (reason) {
	          _this9.savingPayMethodCart = false;
	          _this9.errorUpdatingPayMethod = true;
	        });
	      }
	    }
	  }, {
	    key: 'changeLogisticService',
	    value: function changeLogisticService(value) {
	      if (!value) {
	        this.selectGuestUser();
	      } else {
	        this.guestUser = {};
	      }
	    }
	  }, {
	    key: 'selectGuestUser',
	    value: function selectGuestUser() {
	      var _this10 = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        backdrop: 'static',
	        template: _modalLogisticView2.default,
	        controller: 'GuestUserController',
	        controllerAs: 'mdCtrl',
	        resolve: {
	          optionsModal: function optionsModal() {
	            return _this10.guestUser;
	          }
	        }
	      });
	      modalInstance.result.then(function (resultUser) {
	        _this10.guestUser = resultUser;
	      }).catch(function (errModal) {
	        _this10.isLogisticService = true;
	      });
	    }
	  }, {
	    key: 'saveDiscountCoupon',
	    value: function saveDiscountCoupon(code) {
	      var _this11 = this;
	
	      this.coupon.savingCoupon = true;
	      this.coupon.savedCoupon = false;
	      if (code === 'DESC14') {
	        this.$timeout(function () {
	          _this11.coupon.savingCoupon = false;
	          _this11.coupon.couponSaved = true;
	
	          _this11.coupon.validCoupon = true;
	          _this11.coupon.couponValue = 10000;
	        }, 3000);
	      } else {
	        this.$timeout(function () {
	          _this11.coupon.discountCoupon = '';
	
	          _this11.coupon.savingCoupon = false;
	          _this11.coupon.couponSaved = true;
	
	          _this11.coupon.validCoupon = false;
	          _this11.coupon.couponValue = 0;
	        }, 3000);
	      }
	    }
	  }, {
	    key: 'updateCityLocation',
	    value: function updateCityLocation() {
	      var _this12 = this;
	
	      var cityLocationId = this.orderDataForm.city;
	      this.updatingCityLocation = true;
	      this.updatedCityLocation = false;
	      this.errorUpdatingCityLocation = false;
	      if (this.cart.cartId && cityLocationId) {
	        this.CartService.updateCityLocation({
	          'cartId': this.cart.cartId,
	          'cityLocationId': cityLocationId
	        }).then(function (response) {
	          _this12.updatingCityLocation = false;
	          _this12.updatedCityLocation = false;
	          if (response.error) {
	            _this12.errorUpdatingCityLocation = true;
	          }
	        }).catch(function (reason) {
	          _this12.updatingCityLocation = false;
	          _this12.updatedCityLocation = true;
	          _this12.errorUpdatingCityLocation = true;
	        });
	      }
	    }
	  }, {
	    key: 'saveItemQuantity',
	    value: function saveItemQuantity(product) {
	      var _this13 = this;
	
	      this.addingQuantityItemCart = true;
	      this.addedQuantityItemCart = false;
	      this.errorAddingQuantityItemtoCart = false;
	      this.errorMessageAddingQuantityItemtoCart = '';
	      this.errorMessagesAddingQuantityItemtoCart = '';
	
	      if (isNaN(product.quantityToAddFromCart) || product.quantityToAddFromCart < 1) {
	        product.quantityToAddFromCart = product.quantity;
	        return false;
	      }
	
	      if (product.quantity !== product.quantityToAddFromCart) {
	        /* Si la cantidad a agregar del producto es mayor a la cantidad disponible del mismo le indica al
	         * usuario que hacer al respecto */
	        // if (quantity > product.cantidad){
	        if (product.quantityToAddFromCart > product.cantidad) {
	          var mensaje = '\n          <span>Lo Sentimos, El producto <strong> ' + product.name + ' </strong>\n          no est\xE1 disponible en la cantidad solicitada. La existencia actual de este producto es\n          <strong>' + product.cantidad + '</strong> Unidades</span>';
	          product.quantityToAddFromCart = product.quantity;
	          var _options5 = {
	            title: 'Cantidad no disponible',
	            isHtml: true,
	            content: mensaje,
	            size: '',
	            showBottonCancel: false,
	            textActionCancel: '',
	            textAction: 'Aceptar'
	          };
	          return this.messageResponse(_options5);
	        }
	
	        var data = {
	          'cartId': this.cart.cartId,
	          'productId': product.id,
	          'productQuantity': product.quantityToAddFromCart
	        };
	
	        if (this.cart.cartId) {
	          this.CartService.updateQuantityItemCart(data).then(function (response) {
	            _this13.addingQuantityItemCart = false;
	            if (!response.error) {
	              _this13.updateCart();
	            } else {
	              product.quantityToAddFromCart = product.quantity;
	              _this13.errorAddingQuantityItemtoCart = true;
	              _this13.errorMessageAddingQuantityItemtoCart = response.message;
	            }
	          }).catch(function (reason) {
	            _this13.addingQuantityItemCart = false;
	            product.quantityToAddFromCart = product.quantity;
	            var options = {
	              title: '',
	              isHtml: false,
	              content: 'Ha ocurrido un error al actualizar el carrito',
	              size: '',
	              showBottonCancel: false,
	              textActionCancel: '',
	              textAction: 'Aceptar'
	            };
	            _this13.messageResponse(options);
	          });
	        }
	      } else {
	        this.addingQuantityItemCart = false;
	        product.quantityToAddFromCart = product.quantity;
	      }
	    }
	  }, {
	    key: 'createTemplate',
	    value: function createTemplate() {
	      var options = {
	        globals: this.shCtrl.globals
	      };
	      var modal_options = this.$uibModal.open({
	        animation: true,
	        template: _createTemplateModalView2.default,
	        controller: 'CreateTemplateModalController',
	        controllerAs: 'mdCtrl',
	        size: '',
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modal_options.result.then(function () {}).catch(function (reason) {});
	    }
	  }, {
	    key: 'calcularTotales',
	    value: function calcularTotales() {
	      var _this14 = this;
	
	      this.pesoTotalCanasta = 0;
	      this.cantidadTotalCanasta = 0;
	      this.cart.order.totalPesoItems = 0;
	      this.cart.order.cantidadTotalCanasta = 0;
	      this.cart.items.forEach(function (item) {
	        _this14.pesoTotalCanasta += item.quantityToAddFromCart * item.peso.embalaje;
	        _this14.cantidadTotalCanasta += item.quantityToAddFromCart;
	        _this14.cart.order.totalPesoItems += item.quantityToAddFromCart * item.peso.embalaje;
	        _this14.cart.order.cantidadTotalCanasta += item.quantityToAddFromCart;
	      });
	    }
	  }, {
	    key: 'setCartSellerAction',
	    value: function setCartSellerAction(form) {
	      if (form.$valid) {
	        var userIsLogged = false;
	        try {
	          userIsLogged = this.shCtrl.globals.currentUser.isLogged;
	        } catch (e) {}
	        // ===========================================================================================================
	        // Logged client
	        // ===========================================================================================================
	        if (userIsLogged) {
	          if (this.orderDataForm.quoteCartSellerAction === 'quote') {
	            this.showModalCartSeller();
	          } else if (this.orderDataForm.quoteCartSellerAction === 'order') {
	
	            // If there is no client selected
	            if (this.shCtrl.globals.currentUser.userId === this.shCtrl.globals.currentUser.sellerId) {
	              this.showModalCartSeller();
	            } else {
	              this.buyNow(form);
	            }
	          }
	        } else {
	          this.showModalCartSeller();
	        }
	      } else {
	        this.showAllCartErrors = true;
	
	        angular.forEach(form.$error.required, function (field) {
	          field.$setDirty();
	        });
	      }
	    }
	  }, {
	    key: 'showModalCartSeller',
	    value: function showModalCartSeller() {
	      // Always open the step 1
	
	      // Validate the third number to restart all the info
	      // let thirdNumberIb = $('#modalQuoteSeller #sellerQuoteAttendantDocumentNumber').val();
	      // if (thirdNumberIb) {
	      //   this.validateNumberIdUnused(thirdNumberIb);
	      // }
	    }
	  }, {
	    key: 'openCartComment',
	    value: function openCartComment() {
	      var _this15 = this;
	
	      var options = {
	        comment: this.orderComment
	      };
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalCommentCartView2.default,
	        controller: 'CommentCartModalController',
	        controllerAs: 'mdCtrl',
	        size: '',
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function (comment) {
	        _this15.orderDataForm.comment = comment;
	        _this15.orderComment = comment;
	      }).catch(function (reason) {});
	    }
	  }, {
	    key: 'removeItemFromCart',
	    value: function removeItemFromCart(product) {
	      var _this16 = this;
	
	      var options = {
	        title: 'ELIMINAR PRODUCTO <b>' + product.name + '</b>',
	        isHtml: true,
	        titleIsHtml: true,
	        content: '\xBFEn realidad desea eliminar del carrito el producto <b>' + product.name + '</b>?',
	        showBottonCancel: true,
	        textActionCancel: 'Cancelar',
	        textAction: 'Aceptar'
	      };
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalResponseView2.default,
	        controller: 'ModalResponseController',
	        controllerAs: 'mdCtrl',
	        size: '',
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        _this16.confirmRemoveItem(product.id, product);
	      }).catch(function () {});
	    }
	  }, {
	    key: 'confirmRemoveItem',
	    value: function confirmRemoveItem(productId, product) {
	      var _this17 = this;
	
	      if (this.cart.cartId) {
	        this.deletingItemCart = true;
	        this.deletedItemCart = false;
	        this.errorDeletedItemCart = false;
	        this.CartService.deleteItemFromCart(productId, this.cart.cartId).then(function (response) {
	          _this17.deletingItemCart = false;
	          if (!response.error) {
	            _this17.deletedItemCart = true;
	            _this17.updateCart();
	            var _options6 = {
	              title: 'Notificación',
	              isHtml: true,
	              content: '<div class="alert alert-success" style="margin-bottom: 10px;">\n              El producto <b>' + (product ? product.name : '') + '</b> ha sido eliminado del carrito.\n            </div>',
	              size: 'sm',
	              showBottonCancel: false,
	              textActionCancel: '',
	              textAction: 'Aceptar'
	            };
	            _this17.messageResponse(_options6);
	          } else {
	            _this17.errorDeletedItemCart = true;
	          }
	        }).catch(function (error) {
	          _this17.deletingItemCart = false;
	          _this17.deletedItemCart = false;
	          _this17.errorDeletedItemCart = true;
	        });
	      }
	    }
	  }, {
	    key: 'openMap',
	    value: function openMap(branch) {
	      var options = {
	        center: {
	          latitude: branch.latitude,
	          longitude: branch.longitude
	        },
	        zoom: 15,
	        pan: true
	      };
	      var modal_options = this.$uibModal.open({
	        animation: true,
	        template: _modalMapView2.default,
	        controller: 'ModalMapController',
	        controllerAs: 'mdCtrl',
	        size: '',
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modal_options.result.then(function () {}).catch(function (reason) {});
	    }
	  }, {
	    key: 'updateCart',
	    value: function updateCart() {
	      var _this18 = this;
	
	      var cartId = this.SessionService.get('cartId') || '';
	      var userId = '';
	      try {
	        userId = this.shCtrl.globals.currentUser.userId;
	      } catch (e) {}
	      var clientPriceListName = '';
	      try {
	        clientPriceListName = this.SessionService.get('quoteCartSeller').clientPriceList;
	      } catch (e) {}
	      this.CartService.getCart(cartId, userId, clientPriceListName, true).then(function (response) {
	        _this18.cart = response;
	        _this18.$scope.$emit('onUpdateCart');
	      }).catch(function () {
	        _this18.$state.go(_this18.ngAuthSettings.site.app.header.logo.url);
	      });
	    }
	  }, {
	    key: 'clearCart',
	    value: function clearCart() {
	      var _this19 = this;
	
	      // Delete cart
	      var data = {
	        'cartId': this.cart.cartId
	      };
	      this.CartService.clearCart(data).then(function (response) {
	        if (!response.error) {
	          _this19.cart = {};
	          _this19.SessionService.put('cartId', '');
	          _this19.SessionService.remove('quoteCartSeller');
	          _this19.$scope.$emit('onUpdateCart');
	          _this19.updateCart();
	        } else {
	          var _options7 = {
	            title: '',
	            isHtml: false,
	            content: response.message,
	            size: '',
	            showBottonCancel: false,
	            textActionCancel: '',
	            textAction: 'Aceptar'
	          };
	          _this19.messageResponse(_options7);
	        }
	      }).catch(function (reason) {
	        var options = {
	          title: '',
	          isHtml: false,
	          content: reason,
	          size: '',
	          showBottonCancel: false,
	          textActionCancel: '',
	          textAction: 'Aceptar'
	        };
	        _this19.messageResponse(options);
	      });
	    }
	  }, {
	    key: 'messageResponse',
	    value: function messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalResponseView2.default,
	        controller: 'ModalResponseController',
	        controllerAs: 'mdCtrl',
	        size: options.size,
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        if (callAcept) {
	          callback();
	        }
	      }).catch(function (reason) {
	        if (callCancel) {
	          callbackCancel();
	        }
	      });
	    }
	  }]);
	
	  return CartController;
	}();
	
	CartController.$inject = inject;
	
	exports.default = CartController;

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _cart = __webpack_require__(133);
	
	var _cart2 = _interopRequireDefault(_cart);
	
	var _cart3 = __webpack_require__(137);
	
	var _cart4 = _interopRequireDefault(_cart3);
	
	var _cart5 = __webpack_require__(134);
	
	var _cart6 = _interopRequireDefault(_cart5);
	
	var _productCommentModal = __webpack_require__(142);
	
	var _productCommentModal2 = _interopRequireDefault(_productCommentModal);
	
	var _createTemplateModal = __webpack_require__(138);
	
	var _createTemplateModal2 = _interopRequireDefault(_createTemplateModal);
	
	var _modalLogistic = __webpack_require__(141);
	
	var _modalLogistic2 = _interopRequireDefault(_modalLogistic);
	
	var _modalCartSeller = __webpack_require__(139);
	
	var _modalCartSeller2 = _interopRequireDefault(_modalCartSeller);
	
	var _modalCommentCart = __webpack_require__(140);
	
	var _modalCommentCart2 = _interopRequireDefault(_modalCommentCart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cartModule = _angular2.default.module('app.cart', []).component('cart', _cart2.default).controller('ProductCommentModalController', _productCommentModal2.default).controller('CommentCartModalController', _modalCommentCart2.default).controller('CreateTemplateModalController', _createTemplateModal2.default).controller('CartSellerModalController', _modalCartSeller2.default).controller('GuestUserController', _modalLogistic2.default).service('CartService', _cart4.default).config(_cart6.default);
	
	exports.default = cartModule;

/***/ },
/* 137 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService', '$httpParamSerializerJQLike'];
	
	var CartService = function () {
	  function CartService($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService, $httpParamSerializerJQLike) {
	    _classCallCheck(this, CartService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	    this.AuthTokenFactory = AuthTokenFactory;
	    this.SharedService = SharedService;
	    this.SessionService = SessionService;
	    this.cart = {};
	  }
	
	  _createClass(CartService, [{
	    key: 'addItemToCart',
	    value: function addItemToCart(product, quantity, addItemAlreadyInCart1, isModalFastLoad, userId, cart) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        var addItemAlreadyInCart = addItemAlreadyInCart1 || 0;
	        // Se valida la cantidad en local
	        if (isNaN(quantity) || quantity < 1) {
	          return resolve({
	            error: true,
	            message: 'Para adicionar este producto al carrito de compras debe ingresar una cantidad valida.',
	            isHtml: false
	          });
	        }
	        /* Declara la letiable itemCart */
	        var itemCart = undefined;
	        /* Si es definida la letiable global cart, recorre el arreglo de items adentro de la misma
	        * y devuelve el objeto con la misma referencía en el carrito y el que se este agregando */
	        if (cart) {
	          itemCart = cart.items.filter(function (val) {
	            return val.reference === product.reference;
	          })[0];
	        }
	        /* define la letiable itemCartQuantity => si itemCart esta definido, agrega la cantidad de ese item
	        * en el carrito, Sino lo define en 0 */
	        var itemCartQuantity = itemCart ? itemCart.quantity : 0;
	        /* Define la letiable availableQuantity restando la cantidad del producto a comprar y la cantiadad del mismo
	        * item en el carrito */
	        var availableQuantity = parseInt(product.cantidad) - parseInt(itemCartQuantity);
	        /* Si la cantidad disponible es negativa le indica a el usuario que hacer al respecto*/
	        if (availableQuantity < 0) {
	          var mensaje = "<span>El producto <strong>" + product.name + "</strong>  tiene un excedente de <strong>" + availableQuantity * -1 + "</strong> unidades en el carrito. Por favor elimine el excedente.</span>";
	          return resolve({
	            error: true,
	            message: mensaje,
	            isHtml: true
	          });
	        }
	        /* Si la cantidad a agregar del producto es mayor a la cantidad disponible del mismo le indica al usuario que hacer al respecto */
	        // if (quantity > product.cantidad){
	        if (quantity > availableQuantity) {
	          var _mensaje = "<span>Lo Sentimos, El producto <strong>" + product.name + "</strong>  no está disponible en la cantidad solicitada. La existencia actual de este producto es <strong>" + product.cantidad + "</strong> Unidades</span>";
	          return resolve({
	            error: true,
	            message: _mensaje,
	            isHtml: true
	          });
	        }
	        var currentItemId = product.id;
	        var cartId = _this.SessionService.get('cartId') || '';
	        var productId = product.id;
	        if (product.clonedId) {
	          currentItemId = product.clonedId;
	          productId = product.clonedId;
	        }
	        var data = {
	          'id_canasta': cartId,
	          'userId': userId,
	          'id_producto': productId,
	          'cantidad_producto': quantity,
	          'comentario_producto': '',
	          'addItemAlreadyInCart': addItemAlreadyInCart
	        };
	        _this.$http({
	          method: 'POST',
	          url: _this.ngAuthSettings.apiServiceBaseUri + _this.ngAuthSettings.config.paths.addItemToCart,
	          cache: true,
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          data: _this.$httpParamSerializerJQLike(data)
	        }).then(function (response) {
	          _this.SessionService.put('cartId', response.data.cartId);
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'addProductToCartNew',
	    value: function addProductToCartNew(data) {
	      var _this2 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this2.$http({
	          method: 'POST',
	          url: _this2.ngAuthSettings.apiServiceBaseUri + '/cart/agregar-item-canasta',
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false,
	          data: _this2.$httpParamSerializerJQLike(data)
	        }).then(function (response) {
	          if (!response.data.error) {
	            if (!data.id_canasta) {
	              _this2.saveCart(response.data.cartId);
	            }
	            resolve(response.data);
	          } else {
	            reject(response.data.message);
	          }
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'saveCartOrderData',
	    value: function saveCartOrderData(data) {
	      var _this3 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this3.$http({
	          method: 'POST',
	          url: _this3.ngAuthSettings.apiServiceBaseUri + _this3.ngAuthSettings.config.paths.saveCartOrderData,
	          cache: false,
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          data: _this3.$httpParamSerializerJQLike(data)
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'locationBySearchText',
	    value: function locationBySearchText(data) {
	      var _this4 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this4.$http({
	          method: 'POST',
	          url: _this4.ngAuthSettings.apiServiceBaseUri + _this4.ngAuthSettings.config.paths.locationBySearchText,
	          cache: false,
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          data: _this4.$httpParamSerializerJQLike(data)
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'updateCommentCart',
	    value: function updateCommentCart(data) {
	      var _this5 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this5.$http({
	          method: 'POST',
	          url: _this5.ngAuthSettings.apiServiceBaseUri + _this5.ngAuthSettings.config.paths.updateCommentCart,
	          cache: false,
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          data: _this5.$httpParamSerializerJQLike(data)
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'updatePayMethod',
	    value: function updatePayMethod(data) {
	      var _this6 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this6.$http({
	          method: 'POST',
	          url: _this6.ngAuthSettings.apiServiceBaseUri + _this6.ngAuthSettings.config.paths.updatePayMethod,
	          cache: false,
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          data: _this6.$httpParamSerializerJQLike(data)
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'updateQuantityItemCart',
	    value: function updateQuantityItemCart(data) {
	      var _this7 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this7.$http({
	          method: 'POST',
	          url: _this7.ngAuthSettings.apiServiceBaseUri + _this7.ngAuthSettings.config.paths.updateQuantityItemCart,
	          cache: false,
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          data: _this7.$httpParamSerializerJQLike(data)
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getPayMethods',
	    value: function getPayMethods(sellerId, userId) {
	      var _this8 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this8.$http({
	          method: 'GET',
	          url: _this8.ngAuthSettings.apiServiceBaseUri + _this8.ngAuthSettings.config.paths.payMethods + '?sellerId=' + sellerId + '&userId=' + userId,
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getPointsOfSale',
	    value: function getPointsOfSale() {
	      var _this9 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this9.$http({
	          method: 'GET',
	          url: _this9.ngAuthSettings.apiServiceBaseUri + _this9.ngAuthSettings.config.paths.getPointsOfSale,
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getInfoBillfoldState',
	    value: function getInfoBillfoldState(thirdDocumentNumber, branchCode) {
	      var _this10 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this10.$http({
	          method: 'GET',
	          url: _this10.ngAuthSettings.apiServiceBaseUri2 + _this10.ngAuthSettings.config.paths.REPORTS.B2B.BILLFOLD_RESUME + '?terceroDocumentoNumero=' + thirdDocumentNumber + '&sucursalCodigo=' + branchCode,
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'saveCart',
	    value: function saveCart(cart) {
	      var token = btoa(cart + ':' + new Date());
	      this.AuthTokenFactory.setToken('auth-cart', token);
	      this.cart = cart;
	    }
	  }, {
	    key: 'clearCart',
	    value: function clearCart(data) {
	      var _this11 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this11.$http({
	          method: 'POST',
	          url: _this11.ngAuthSettings.apiServiceBaseUri + _this11.ngAuthSettings.config.paths.deleteCart,
	          cache: false,
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          data: _this11.$httpParamSerializerJQLike(data)
	        }).then(function (response) {
	          _this11.cart = {};
	          _this11.cart.cartQuantity = 0;
	          _this11.cart.cartTaxes = 0;
	          _this11.cart.cartSubtotal = 0;
	          _this11.cart.cartTotal = 0;
	          _this11.cart.cartDiscounts = 0;
	          _this11.cart.cartTransports = 0;
	          _this11.cart.items = [];
	          _this11.cart.order = {};
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getCart',
	    value: function getCart(cartId, userId, clientPriceListName, clear, url) {
	      var _this12 = this;
	
	      return this.$q(function (resolve, reject) {
	        if (_this12.cart.cartId && !clear && cartId === _this12.cart.cartId) {
	          resolve(_this12.cart);
	        } else {
	          _this12.$http({
	            method: 'GET',
	            url: url ? url : _this12.ngAuthSettings.apiServiceBaseUri + '/cart/obtener-canasta?cartId=' + cartId + '&userId=' + userId + '&quotePriceListName=' + clientPriceListName,
	            cache: false
	          }).then(function (response) {
	            if (!response.data.error) {
	              _this12.SessionService.put('cartId', response.data.cartId);
	              response.data.items = [];
	              response.data.order = {};
	              // Se actualiza la información del item almacenado
	              if (!response.data.itemsCanastaUsuario) response.data.itemsCanastaUsuario = [];
	              response.data.itemsCanastaUsuario.forEach(function (dato) {
	                response.data.items.push(dato);
	              });
	              response.data.cartQuantity = response.data.cartQuantity || 0;
	              response.data.cartTaxes = response.data.cartTaxes || 0;
	              response.data.cartSubtotal = response.data.cartSubtotal || 0;
	              response.data.cartTotal = response.data.cartTotal || 0;
	              response.data.cartDiscounts = response.data.cartDiscounts || 0;
	              response.data.cartTransports = response.data.cartTransports || 0;
	
	              response.data.order = response.data.cartOrderData || {};
	              response.data.order.cantidadTotalCanasta = 0;
	              response.data.order.vehiculo_transporte = {};
	              response.data.items.forEach(function (item) {
	                response.data.order.cantidadTotalCanasta += item.quantity;
	              });
	              response.data.tunnel = response.data.cartTunnelData || {};
	              // ===================================================================================================
	              // Load the values for the seller quoting
	              // ===================================================================================================
	              var quoteCartSeller = _this12.SessionService.get('quoteCartSeller') || null;
	
	              if (quoteCartSeller) {
	                var itemsQuoteCartSeller = quoteCartSeller.itemsQuoteCartSeller;
	                itemsQuoteCartSeller.forEach(function (itemSeller) {
	                  response.data.items.forEach(function (item, key) {
	                    if (item.id === itemSeller.id) {
	                      response.data.items[key].priceItemQuoteSeller = response.data.items[key].priceItemQuoteSeller || 0;
	                      response.data.items[key].ivaPercentageQuoteSeller = item.ivaPercentageQuoteSeller || 0;
	                      response.data.items[key].discountPercentageItemQuoteSeller = itemSeller.discountPercentageItemQuoteSeller || 0;
	                    }
	                  });
	                });
	              }
	              _this12.cart = response.data;
	              resolve(response.data);
	            } else {
	              response.data.items = [];
	              response.data.order = {};
	              response.data.cartQuantity = response.data.cartQuantity || 0;
	              response.data.cartTaxes = response.data.cartTaxes || 0;
	              response.data.cartSubtotal = response.data.cartSubtotal || 0;
	              response.data.cartTotal = response.data.cartTotal || 0;
	              response.data.cartDiscounts = response.data.cartDiscounts || 0;
	              response.data.cartTransports = response.data.cartTransports || 0;
	              _this12.cart = response.data;
	              resolve(response.data);
	            }
	          }).catch(function (reason) {
	            reject(reason);
	          });
	        }
	      });
	    }
	  }, {
	    key: 'getCartNew',
	    value: function getCartNew(clear) {
	      var _this13 = this;
	
	      return this.$q(function (resolve, reject) {
	        var thirdId = _this13.SharedService.partialConsultThird();
	        var userId = _this13.SharedService.partialConsultUser();
	        if (_this13.cart.cartId && !clear) {
	          resolve(_this13.cart);
	        } else {
	          var cartSaved = _this13.AuthTokenFactory.getToken('auth-cart');
	          if (!cartSaved) return reject();
	          var cart = atob(cartSaved);
	          cart = cart.split(':')[0];
	          _this13.$http({
	            method: 'GET',
	            url: _this13.ngAuthSettings.apiServiceBaseUri + '/cart/obtener-canasta?cartId=' + cart + '&userId=' + (thirdId ? thirdId : userId),
	            cache: false
	          }).then(function (response) {
	            response.data.id = cart;
	            _this13.cart = response.data;
	            resolve(response.data);
	          }).catch(function (reason) {
	            reject(reason);
	          });
	        }
	      });
	    }
	  }, {
	    key: 'saveOrder',
	    value: function saveOrder(cartId, branchId, userId, contact, sellerOfCounter) {
	      var _this14 = this;
	
	      var data = {
	        canastaId: cartId,
	        sucursalId: branchId,
	        usuarioVendedorId: userId,
	        esVentaMostrador: sellerOfCounter
	      };
	      if (contact) {
	        data.contactoNombre = contact.contactoNombre;
	        data.contactoEmail = contact.contactoEmail;
	        data.contactoTelefono = contact.contactoTelefono;
	        data.contactoDireccion = contact.contactoDireccion;
	        data.contactoNombreCiudad = contact.contactoNombreCiudad;
	      }
	      return this.$q(function (resolve, reject) {
	        _this14.$http({
	          method: 'POST',
	          url: _this14.ngAuthSettings.apiServiceBaseUri + '/pedidos/pedidos/crear-pedido',
	          // url: this.ngAuthSettings.apiServiceBaseUri + '/pedidos/pedidos/crear-pedido?canastaId=' + cartId + '&sucursalId=' + branchId + '&usuarioVendedorId=' + userId,
	          cache: false,
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          data: _this14.$httpParamSerializerJQLike(data)
	        }).then(function (response) {
	          if (!response.data.error) {
	            resolve(response.data);
	          } else {
	            reject(response.data.message);
	          }
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'createCartTemplate',
	    value: function createCartTemplate(data) {
	      var _this15 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this15.$http({
	          method: 'POST',
	          url: _this15.ngAuthSettings.apiServiceBaseUri + _this15.ngAuthSettings.config.paths.createCartTemplate,
	          cache: false,
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          data: _this15.$httpParamSerializerJQLike(data)
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'updateCityLocation',
	    value: function updateCityLocation(data) {
	      var _this16 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this16.$http({
	          method: 'POST',
	          url: _this16.ngAuthSettings.apiServiceBaseUri + _this16.ngAuthSettings.config.paths.updateCityLocation,
	          cache: false,
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          data: _this16.$httpParamSerializerJQLike(data)
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'deleteItemFromCart',
	    value: function deleteItemFromCart(itemId, cartId) {
	      var _this17 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this17.$http({
	          method: 'POST',
	          url: _this17.ngAuthSettings.apiServiceBaseUri + '/cart/eliminar-item-canasta',
	          cache: false,
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          data: $.param({
	            'id_canasta': cartId,
	            'id_producto': itemId
	          })
	        }).then(function (response) {
	          if (!response.data.error) {
	            resolve(response.data);
	          } else {
	            reject(response.data.message);
	          }
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return CartService;
	}();
	
	CartService.$inject = inject;
	
	exports.default = CartService;

/***/ },
/* 138 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$uibModalInstance', '$timeout', 'SessionService', 'modalOptions', 'CartService'];
	
	var CreateTemplateModalController = function () {
	  function CreateTemplateModalController($scope, $uibModalInstance, $timeout, SessionService, modalOptions, CartService) {
	    _classCallCheck(this, CreateTemplateModalController);
	
	    this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.CartService = CartService;
	    this.SessionService = SessionService;
	    this.$uibModalInstance = $uibModalInstance;
	    this.modalOptions = modalOptions;
	    this.globals = modalOptions.globals;
	    this.cartTemplate = {};
	  }
	
	  _createClass(CreateTemplateModalController, [{
	    key: 'createCartTemplate',
	    value: function createCartTemplate() {
	      var _this = this;
	
	      this.cartTemplate.loading = true;
	      var cartId = this.SessionService.get('cartId') || '';
	      var userId = '';
	      try {
	        userId = this.globals.currentUser.userId;
	      } catch (e) {}
	      var sellerId = '';
	      try {
	        sellerId = this.globals.currentUser.sellerId;
	      } catch (e) {}
	      this.CartService.createCartTemplate({ 'cartId': cartId, 'userId': userId, 'sellerId': sellerId, 'cartTemplateName': this.cartTemplate.name }).then(function (response) {
	        _this.cartTemplate.loading = false;
	        _this.cartTemplate.response = response;
	      }).catch(function (reason) {
	        _this.cartTemplate.loading = false;
	        _this.cartTemplate.response = reason;
	      });
	    }
	  }, {
	    key: 'clearCreateTemplateForm',
	    value: function clearCreateTemplateForm() {
	      this.cartTemplate = {};
	      this.ok();
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.$uibModalInstance.close();
	    }
	  }]);
	
	  return CreateTemplateModalController;
	}();
	
	CreateTemplateModalController.$inject = inject;
	
	exports.default = CreateTemplateModalController;

/***/ },
/* 139 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$uibModalInstance', '$timeout', 'SessionService', 'modalOptions'];
	
	var CreateTemplateModalController = function () {
	  function CreateTemplateModalController($scope, $uibModalInstance, $timeout, SessionService, modalOptions) {
	    _classCallCheck(this, CreateTemplateModalController);
	
	    this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.SessionService = SessionService;
	    this.$uibModalInstance = $uibModalInstance;
	    this.modalOptions = modalOptions;
	  }
	
	  _createClass(CreateTemplateModalController, [{
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.$uibModalInstance.close();
	    }
	  }]);
	
	  return CreateTemplateModalController;
	}();
	
	CreateTemplateModalController.$inject = inject;
	
	exports.default = CreateTemplateModalController;

/***/ },
/* 140 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$uibModalInstance', 'modalOptions', '$timeout', 'CartService', 'SessionService'];
	
	var CommentCartModalController = function () {
	  function CommentCartModalController($scope, $uibModalInstance, modalOptions, $timeout, CartService, SessionService) {
	    _classCallCheck(this, CommentCartModalController);
	
	    this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.SessionService = SessionService;
	    this.CartService = CartService;
	    this.$uibModalInstance = $uibModalInstance;
	    this.modalOptions = Object.assign({}, modalOptions);
	    this.comment = this.modalOptions.comment;
	    this.maxlengthComment = 150;
	  }
	
	  _createClass(CommentCartModalController, [{
	    key: 'saveOrderComment',
	    value: function saveOrderComment() {
	      var _this = this;
	
	      this.addingCommentCart = true;
	      this.addedCommentCart = false;
	      this.errorAddedCommentCart = false;
	      var cartId = this.SessionService.get('cartId') || '';
	      var data = {
	        'cartId': cartId,
	        'comment': this.comment
	      };
	      if (cartId) {
	        this.CartService.updateCommentCart(data).then(function (response) {
	          _this.addingCommentCart = false;
	          if (!response.error) {
	            _this.addedCommentCart = true;
	            _this.messageAddedCommentCart = response.message;
	            _this.$timeout(function () {
	              _this.ok();
	            }, 3000);
	          } else {
	            _this.errorAddedCommentCart = true;
	          }
	        }).catch(function (reason) {
	          _this.addingCommentCart = false;
	          _this.addedCommentCart = false;
	          _this.errorAddedCommentCart = true;
	        });
	      }
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.$uibModalInstance.close(this.comment);
	    }
	  }]);
	
	  return CommentCartModalController;
	}();
	
	CommentCartModalController.$inject = inject;
	
	exports.default = CommentCartModalController;

/***/ },
/* 141 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GuestUserController = function () {
	  function GuestUserController($scope, $uibModalInstance, optionsModal) {
	    _classCallCheck(this, GuestUserController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.$scope = $scope;
	    this.optionsModal = optionsModal;
	  }
	
	  _createClass(GuestUserController, [{
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'selectThird',
	    value: function selectThird() {
	      if (this.guestUserForm.$valid) {
	        this.$uibModalInstance.close(this.user);
	      } else {
	        this.guestUserForm.contactoNombre.$setDirty();
	        this.guestUserForm.contactoEmail.$setDirty();
	        this.guestUserForm.contactoTelefono.$setDirty();
	        this.guestUserForm.contactoDireccion.$setDirty();
	        this.guestUserForm.contactoNombreCiudad.$setDirty();
	      }
	    }
	  }]);
	
	  return GuestUserController;
	}();
	
	GuestUserController.$inject = ['$scope', '$uibModalInstance', 'optionsModal'];
	
	exports.default = GuestUserController;

/***/ },
/* 142 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$uibModalInstance', 'modalOptions', '$timeout'];
	
	var ProductCommentModalController = function () {
	  function ProductCommentModalController($scope, $uibModalInstance, modalOptions, $timeout) {
	    _classCallCheck(this, ProductCommentModalController);
	
	    this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.$uibModalInstance = $uibModalInstance;
	    this.item = Object.assign({}, modalOptions);
	    this.comment = this.item.comment;
	  }
	
	  _createClass(ProductCommentModalController, [{
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.$uibModalInstance.close(this.comment);
	    }
	  }]);
	
	  return ProductCommentModalController;
	}();
	
	ProductCommentModalController.$inject = inject;
	
	exports.default = ProductCommentModalController;

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _categoriesFilter = __webpack_require__(147);
	
	var _categoriesFilter2 = _interopRequireDefault(_categoriesFilter);
	
	var _featuredProducts = __webpack_require__(174);
	
	var _featuredProducts2 = _interopRequireDefault(_featuredProducts);
	
	var _newProducts = __webpack_require__(182);
	
	var _newProducts2 = _interopRequireDefault(_newProducts);
	
	var _mostSelledProducts = __webpack_require__(179);
	
	var _mostSelledProducts2 = _interopRequireDefault(_mostSelledProducts);
	
	var _relatedProducts = __webpack_require__(202);
	
	var _relatedProducts2 = _interopRequireDefault(_relatedProducts);
	
	var _catalog = __webpack_require__(144);
	
	var _catalog2 = _interopRequireDefault(_catalog);
	
	var _modalQuantityCart = __webpack_require__(176);
	
	var _modalQuantityCart2 = _interopRequireDefault(_modalQuantityCart);
	
	var _modalConfirmation = __webpack_require__(175);
	
	var _modalConfirmation2 = _interopRequireDefault(_modalConfirmation);
	
	var _category = __webpack_require__(164);
	
	var _category2 = _interopRequireDefault(_category);
	
	var _productsList = __webpack_require__(199);
	
	var _productsList2 = _interopRequireDefault(_productsList);
	
	var _productDetail = __webpack_require__(186);
	
	var _productDetail2 = _interopRequireDefault(_productDetail);
	
	var _compareProducts = __webpack_require__(169);
	
	var _compareProducts2 = _interopRequireDefault(_compareProducts);
	
	var _productNotFound = __webpack_require__(191);
	
	var _productNotFound2 = _interopRequireDefault(_productNotFound);
	
	var _fastSearch = __webpack_require__(171);
	
	var _fastSearch2 = _interopRequireDefault(_fastSearch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogModule = _angular2.default.module('catalog', [_categoriesFilter2.default.name, _fastSearch2.default.name, _productDetail2.default.name, _productNotFound2.default.name, _compareProducts2.default.name, _newProducts2.default.name, _productsList2.default.name, _relatedProducts2.default.name, _category2.default.name, _mostSelledProducts2.default.name, _featuredProducts2.default.name]).controller('ModalQuantityCartController', _modalQuantityCart2.default).controller('ModalConfirmationController', _modalConfirmation2.default).service('CatalogService', _catalog2.default);
	
	exports.default = CatalogModule;

/***/ },
/* 144 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$q', '$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];
	
	var CatalogService = function () {
	  function CatalogService($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
	    _classCallCheck(this, CatalogService);
	
	    this.ngAuthSettings = ngAuthSettings;
	    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	    this.$q = $q;
	    this.$http = $http;
	  }
	
	  _createClass(CatalogService, [{
	    key: 'getFeaturedProducts',
	    value: function getFeaturedProducts(userId, limit) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'GET',
	          url: _this.ngAuthSettings.apiServiceBaseUri + _this.ngAuthSettings.config.paths.featuredProducts + '?userId=' + userId + '&limit=' + limit,
	          cache: true
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getRelatedProducts',
	    value: function getRelatedProducts(productId, userId, limit) {
	      var _this2 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this2.$http({
	          method: 'GET',
	          url: _this2.ngAuthSettings.apiServiceBaseUri + _this2.ngAuthSettings.config.paths.relatedProducts + productId + '?userId=' + userId + '&limit=' + limit,
	          cache: true
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getNewProducts',
	    value: function getNewProducts(userId, limit) {
	      var _this3 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this3.$http({
	          method: 'GET',
	          url: _this3.ngAuthSettings.apiServiceBaseUri + _this3.ngAuthSettings.config.paths.newItems + '?userId=' + userId + '&limit=' + limit,
	          cache: true
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getMostSelledProducts',
	    value: function getMostSelledProducts(userId, limit) {
	      var _this4 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this4.$http({
	          method: 'GET',
	          url: _this4.ngAuthSettings.apiServiceBaseUri + _this4.ngAuthSettings.config.paths.bestSellerItems + '?userId=' + userId + '&limit=' + limit,
	          cache: true
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'updateFavoriteProducts',
	    value: function updateFavoriteProducts(data) {
	      var _this5 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this5.$http({
	          method: 'POST',
	          url: _this5.ngAuthSettings.apiServiceBaseUri + _this5.ngAuthSettings.config.paths.setFavoriteProduct,
	          cache: true,
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          data: _this5.$httpParamSerializerJQLike(data)
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return CatalogService;
	}();
	
	CatalogService.$inject = inject;
	
	exports.default = CatalogService;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _categoriesFilter = __webpack_require__(146);
	
	var _categoriesFilter2 = _interopRequireDefault(_categoriesFilter);
	
	var _categoriesFilterView = __webpack_require__(450);
	
	var _categoriesFilterView2 = _interopRequireDefault(_categoriesFilterView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CategoriesFilterComponent = {
	  template: _categoriesFilterView2.default,
	  controller: _categoriesFilter2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = CategoriesFilterComponent;

/***/ },
/* 146 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$state', '$rootScope', 'SharedService', 'ngAuthSettings'];
	
	var CategoriesFilterController = function CategoriesFilterController($scope, $state, $rootScope, SharedService, ngAuthSettings) {
	  _classCallCheck(this, CategoriesFilterController);
	
	  this.$state = $state;
	  this.$scope = $scope;
	  this.ngAuthSettings = ngAuthSettings;
	  this.$rootScope = $rootScope;
	  this.SharedService = SharedService;
	};
	
	CategoriesFilterController.$inject = inject;
	
	exports.default = CategoriesFilterController;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _categoriesFilter = __webpack_require__(145);
	
	var _categoriesFilter2 = _interopRequireDefault(_categoriesFilter);
	
	var _categoriesInputFilter = __webpack_require__(150);
	
	var _categoriesInputFilter2 = _interopRequireDefault(_categoriesInputFilter);
	
	var _categoriesSliderFilter = __webpack_require__(153);
	
	var _categoriesSliderFilter2 = _interopRequireDefault(_categoriesSliderFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CategoriesFilterModule = _angular2.default.module('catalog.categoriesFilter', [_categoriesInputFilter2.default.name, _categoriesSliderFilter2.default.name]).component('categoriesFilter', _categoriesFilter2.default);
	
	exports.default = CategoriesFilterModule;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _categoriesInputFilter = __webpack_require__(149);
	
	var _categoriesInputFilter2 = _interopRequireDefault(_categoriesInputFilter);
	
	var _categoriesInputFilterView = __webpack_require__(451);
	
	var _categoriesInputFilterView2 = _interopRequireDefault(_categoriesInputFilterView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CategoriesInputFilterComponent = {
	  template: _categoriesInputFilterView2.default,
	  controller: _categoriesInputFilter2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = CategoriesInputFilterComponent;

/***/ },
/* 149 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$state', '$rootScope', 'SharedService', 'ngAuthSettings'];
	
	var CategoriesInputFilterController = function CategoriesInputFilterController($scope, $state, $rootScope, SharedService, ngAuthSettings) {
	  _classCallCheck(this, CategoriesInputFilterController);
	
	  this.$state = $state;
	  this.$scope = $scope;
	  this.ngAuthSettings = ngAuthSettings;
	  this.$rootScope = $rootScope;
	  this.SharedService = SharedService;
	};
	
	CategoriesInputFilterController.$inject = inject;
	
	exports.default = CategoriesInputFilterController;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _categoriesInputFilter = __webpack_require__(148);
	
	var _categoriesInputFilter2 = _interopRequireDefault(_categoriesInputFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CategoriesFilterModule = _angular2.default.module('catalog.categoriesFilter.categoriesInputFilter', []).component('categoriesInputFilter', _categoriesInputFilter2.default);
	
	exports.default = CategoriesFilterModule;

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _categoriesSliderFilter = __webpack_require__(152);
	
	var _categoriesSliderFilter2 = _interopRequireDefault(_categoriesSliderFilter);
	
	var _categoriesSliderFilterView = __webpack_require__(452);
	
	var _categoriesSliderFilterView2 = _interopRequireDefault(_categoriesSliderFilterView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CategoriesSliderFilterComponent = {
	  template: _categoriesSliderFilterView2.default,
	  controller: _categoriesSliderFilter2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = CategoriesSliderFilterComponent;

/***/ },
/* 152 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$state', '$rootScope', 'SharedService', 'ngAuthSettings'];
	
	var CategoriessliderFilterController = function CategoriessliderFilterController($scope, $state, $rootScope, SharedService, ngAuthSettings) {
	  _classCallCheck(this, CategoriessliderFilterController);
	
	  this.$state = $state;
	  this.$scope = $scope;
	  this.ngAuthSettings = ngAuthSettings;
	  this.$rootScope = $rootScope;
	  this.SharedService = SharedService;
	};
	
	CategoriessliderFilterController.$inject = inject;
	
	exports.default = CategoriessliderFilterController;

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _categoriesSliderFilter = __webpack_require__(151);
	
	var _categoriesSliderFilter2 = _interopRequireDefault(_categoriesSliderFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CategoriesSliderFilterModule = _angular2.default.module('catalog.categoriesSliderFilter', []).component('categoriesSliderFilter', _categoriesSliderFilter2.default);
	
	exports.default = CategoriesSliderFilterModule;

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _categoryPagerToolboxView = __webpack_require__(453);
	
	var _categoryPagerToolboxView2 = _interopRequireDefault(_categoryPagerToolboxView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MenuDirective() {
	  return {
	    restrict: 'E',
	    template: _categoryPagerToolboxView2.default
	  };
	}
	
	MenuDirective.$inject = [];
	
	exports.default = MenuDirective;

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _categoryPagerToolbox = __webpack_require__(154);
	
	var _categoryPagerToolbox2 = _interopRequireDefault(_categoryPagerToolbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CategoryPagerToolboxModule = _angular2.default.module('catalog.category.categoryPagerToolbox', []).directive('categoryPagerToolbox', _categoryPagerToolbox2.default);
	
	exports.default = CategoryPagerToolboxModule;

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _categoryProducts = __webpack_require__(158);
	
	var _categoryProducts2 = _interopRequireDefault(_categoryProducts);
	
	var _categoryProductsView = __webpack_require__(454);
	
	var _categoryProductsView2 = _interopRequireDefault(_categoryProductsView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CategoryComponent = {
	  template: _categoryProductsView2.default,
	  controller: _categoryProducts2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = CategoryComponent;

/***/ },
/* 157 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.categorySales', {
	    url: "/categories/sales/{productSale}",
	    template: '<category-products sh-ctrl="shCtrl"></category-products>'
	  }).state('home.categorySlugProducts', {
	    url: "/categories-slug/{categorySlug}/products",
	    template: '<category-products sh-ctrl="shCtrl"></category-products>'
	  }).state('home.productSearch', {
	    url: "/categories-search/{searchText}/products",
	    template: '<category-products sh-ctrl="shCtrl"></category-products>'
	  }).state('home.categoryIdProducts', {
	    url: "/categories-id/{idCategory}/products",
	    template: '<category-products sh-ctrl="shCtrl"></category-products>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _modalResponseView = __webpack_require__(3);
	
	var _modalResponseView2 = _interopRequireDefault(_modalResponseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'CategoryService', '$state', '$rootScope', 'SharedService', '$stateParams', '$uibModal', '$timeout', 'Pagination', 'SessionService', 'CategoryProductsService', '$filter', 'ngAuthSettings'];
	
	var CategoryController = function () {
	  function CategoryController($scope, CategoryService, $state, $rootScope, SharedService, $stateParams, $uibModal, $timeout, Pagination, SessionService, CategoryProductsService, $filter, ngAuthSettings) {
	    _classCallCheck(this, CategoryController);
	
	    this.$state = $state;
	    this.$scope = $scope;
	    this.ngAuthSettings = ngAuthSettings;
	    this.Pagination = Pagination;
	    this.SessionService = SessionService;
	    this.$stateParams = $stateParams;
	    this.$rootScope = $rootScope;
	    this.$uibModal = $uibModal;
	    this.CategoryService = CategoryService;
	    this.$timeout = $timeout;
	    this.SharedService = SharedService;
	    this.CategoryProductsService = CategoryProductsService;
	    this.$filter = $filter;
	    this.loanding = false;
	    this.pagerCategories = [];
	    this.itemsPerPage = 12;
	    this.loadingCategories = true;
	    this.categoryId = this.$stateParams.idCategory || '';
	    this.categorySlug = this.$stateParams.categorySlug || '';
	    this.productSale = this.$stateParams.productSale || '';
	    this.productsList = [];
	    this.productHighPriceTest = 0;
	    this.productLowPriceTest = 0;
	    this.categoryAttributes = [];
	    this.categoryProductAttributes = [];
	    this.categoryAttributesGroups = [];
	    this.filterAttributesProducts = {};
	    this.loadingProducts = false;
	    this.pageSize = 24;
	    this.currentPage = 1;
	    this.totalItems = 1;
	    this.controlPrice = 0;
	    this.sortType = 1;
	    this.searchText = '';
	    this.typeview = 1;
	    this.dataFilter = {};
	    this.localFilters = null;
	
	    this.ctrlTest = 3;
	    this.initializeTest = false;
	
	    this.customFilters = {
	      productHighPrice: null,
	      productLowPrice: null,
	      productHighPriceTest: null,
	      productLowPriceTest: null
	    };
	  }
	
	  _createClass(CategoryController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.dataFilter = this.CategoryProductsService.getFiltersData();
	      if (this.$stateParams.idCategory || this.$stateParams.categorySlug) {
	        if (this.dataFilter) {
	          if (this.$stateParams.categorySlug === this.dataFilter.slug || this.$stateParams.idCategory === this.dataFilter.id) {
	            this.pageSize = this.dataFilter.pageSize;
	            this.currentPage = this.dataFilter.pageNumber;
	            this.searchText = this.dataFilter.internSearchText;
	            this.customFilters.attributes = this.dataFilter.filters.attributes;
	            this.customFilters.productHighPriceTest = this.dataFilter.filters.productHighPrice;
	            this.customFilters.productLowPriceTest = this.dataFilter.filters.productLowPrice;
	            this.sortType = this.dataFilter.filters.sort;
	            this.getCurrentCategory();
	          } else {
	            this.CategoryProductsService.setFiltersData(null);
	            this.getCurrentCategory();
	          }
	        } else {
	          this.getCurrentCategory();
	        }
	      } else if (this.$stateParams.searchText) {
	        if (this.dataFilter) {
	          if (this.$stateParams.searchText === this.dataFilter.searchText) {
	            this.pageSize = this.dataFilter.pageSize;
	            this.currentPage = this.dataFilter.pageNumber;
	            this.searchText = this.dataFilter.internSearchText;
	            this.customFilters.attributes = this.dataFilter.filters.attributes;
	            this.customFilters.productHighPriceTest = this.dataFilter.filters.productHighPrice;
	            this.customFilters.productLowPriceTest = this.dataFilter.filters.productLowPrice;
	            this.sortType = this.dataFilter.filters.sort;
	            this.getProducts();
	          } else {
	            this.CategoryProductsService.setFiltersData(null);
	            this.getProducts();
	          }
	        } else {
	          this.getProducts();
	        }
	      }
	    }
	  }, {
	    key: 'confirmTimerTest',
	    value: function confirmTimerTest() {
	      var _this = this;
	
	      this.$timeout(function () {
	        _this.timerTest();
	      }, 1000);
	    }
	  }, {
	    key: 'timerTest',
	    value: function timerTest() {
	      if (this.ctrlTest > 0) {
	        this.ctrlTest--;
	        this.confirmTimerTest();
	      } else {
	        this.getProducts();
	        this.initializeTest = false;
	      }
	    }
	  }, {
	    key: 'onChangePriceFilter',
	    value: function onChangePriceFilter() {
	      if (this.initializeTest) this.ctrlTest = 3;else {
	        this.initializeTest = true;
	        this.timerTest();
	      }
	    }
	  }, {
	    key: 'getCurrentCategory',
	
	
	    /**
	     Get current category
	     @method getCurrentCategory
	     */
	    value: function getCurrentCategory() {
	      var _this2 = this;
	
	      this.CategoryService.getCurrentCategory(this.$stateParams.idCategory, this.$stateParams.categorySlug).then(function (response) {
	        _this2.currentCategory = response;
	        if (!_this2.categoryId) {
	          _this2.categoryId = response.id;
	        }
	        _this2.getAttributesCategory(_this2.$stateParams.idCategory, _this2.$stateParams.categorySlug);
	      }).catch(function (reason) {
	        console.log(reason);
	        _this2.$state.go('404');
	      });
	    }
	  }, {
	    key: 'getAttributesCategory',
	    value: function getAttributesCategory(idCategory, categorySlug) {
	      var _this3 = this;
	
	      this.CategoryService.getAttributesCategory(idCategory, categorySlug).then(function (response) {
	        _this3.categoryAttributes = response;
	        _this3.getProducts();
	      }).catch(function (reason) {
	        console.log(reason);
	        _this3.$state.go('404');
	      });
	    }
	  }, {
	    key: 'getProducts',
	    value: function getProducts(footer, cleanFilter, footerPlace) {
	      var _this4 = this;
	
	      if (this.loadingProducts) return;
	      this.loadingProducts = true;
	      var searchText = this.$stateParams.searchText;
	      //this.controlPrice = this.searchText ? 0 : this.controlPrice;
	      this.searchText = cleanFilter ? '' : this.searchText;
	      if (!searchText) searchText = '';
	      var userId = '';
	      try {
	        userId = this.shCtrl.globals.currentUser.userId;
	      } catch (e) {}
	      if (footer) {
	        this.scrollProductListToTop();
	      }
	      var data = {
	        id: this.categoryId,
	        slug: this.categorySlug,
	        pageSize: this.pageSize,
	        pageNumber: this.currentPage,
	        searchText: decodeURIComponent(searchText),
	        internSearchText: this.searchText,
	        userId: userId,
	        filters: {
	          attributes: cleanFilter ? null : this.customFilters.attributes,
	          productHighPrice: cleanFilter ? 0 : this.customFilters.productHighPriceTest,
	          productLowPrice: cleanFilter ? 0 : this.customFilters.productLowPriceTest,
	          sort: this.sortType
	        }
	      };
	      this.CategoryProductsService.getProducts(data, this.$stateParams.productSale).then(function (response) {
	        _this4.pageSize = _this4.pageSize > response.cantidadTotal ? 24 : _this4.pageSize;
	        _this4.totalItems = _angular2.default.copy(response.cantidadTotal);
	        _this4.totalPages = _angular2.default.copy(response.totalPage);
	
	        if (response.items.length) {
	          //there is data on the back page?
	          if (_this4.dataFilter && (_this4.categorySlug && _this4.categorySlug === _this4.dataFilter.slug || searchText && decodeURIComponent(searchText) === _this4.dataFilter.searchText)) {
	            _this4.currentPage = _this4.dataFilter.pageNumber;
	            if (!_this4.controlPrice) {
	              _this4.customFilters.productHighPriceTest = _this4.dataFilter.filters.productHighPrice;
	              _this4.customFilters.productLowPriceTest = _this4.dataFilter.filters.productLowPrice;
	              _this4.controlPrice++;
	            }
	          } else {
	            if (!_this4.controlPrice) {
	              _this4.customFilters.productHighPriceTest = response.highestPrice;
	              _this4.customFilters.productLowPriceTest = 0;
	              _this4.controlPrice++;
	            }
	          }
	
	          _this4.customFilters.productHighPrice = response.highestPrice;
	          _this4.customFilters.productLowPrice = response.lowestPrice;
	          _this4.dataFilter = {};
	          _this4.productsList = _angular2.default.copy(response.items);
	          _this4.loadingProducts = false;
	          _this4.localFilters = _angular2.default.copy(_this4.customFilters.attributes);
	          _this4.activateProducts(_this4.customFilters);
	          var resultView = _this4.SessionService.get('itemsView');
	          if (!resultView) {
	            if ($(window).width() >= 1200) {
	              _this4.setCookieItemsView(_this4.shCtrl.globalParams.itemsView.pc);
	            } else if ($(window).width() < 1200) {
	              _this4.setCookieItemsView(_this4.shCtrl.globalParams.itemsView.tablet);
	            }
	          } else {
	            _this4.setCookieItemsView(resultView);
	          }
	        } else {
	          if (searchText && !_this4.searchText) {
	            _this4.$state.go('home.productNotFount', { productSearchText: searchText });
	          } else {
	            _this4.productsList = [];
	            _this4.loadingProducts = false;
	            _this4.controlPrice = 1;
	          }
	        }
	      }).catch(function (reason) {
	        _this4.loadingProducts = false;
	        _this4.localFilters = _angular2.default.copy(_this4.customFilters.attributes);
	      });
	    }
	  }, {
	    key: 'activateProducts',
	    value: function activateProducts(item) {
	      var _this5 = this;
	
	      this.sliderOptions = {
	        options: {
	          showSelectionBar: true,
	          selectionBarGradient: {
	            from: this.ngAuthSettings.site.info.style.secondColor,
	            to: this.ngAuthSettings.site.info.style.secondColor
	          },
	          getPointerColor: function getPointerColor(value) {
	            return _this5.ngAuthSettings.site.info.style.mainColor;
	          },
	          floor: 0,
	          step: 1,
	          minRange: 10,
	          ceil: item.productHighPrice,
	          noSwitching: true,
	          onEnd: function onEnd(sliderId, modelValue, highValue) {
	            _this5.getProducts();
	          },
	          translate: function translate(value) {
	            return _this5.$filter('currency')(value, '$', 0);
	          }
	        }
	      };
	      this.$timeout(function () {
	        _this5.$scope.$broadcast('rzSliderForceRender');
	      }, 1000);
	    }
	  }, {
	    key: 'scrollProductListToTop',
	    value: function scrollProductListToTop() {
	      $('html, body').animate({
	        'scrollTop': $('#breadcrumb-container').offset().top
	      }, 1200);
	    }
	  }, {
	    key: 'updateProductAttribute',
	    value: function updateProductAttribute(group, value, addRemove, att, val) {
	      if (!this.categoryProductAttributes[group]) {
	        this.categoryAttributesGroups.push(group);
	        this.categoryProductAttributes[group] = [];
	      }
	      if (!this.filterAttributesProducts.hasOwnProperty(att)) {
	        this.filterAttributesProducts[att] = [];
	      }
	      if (addRemove) {
	        this.categoryProductAttributes[group].push(value);
	        this.filterAttributesProducts[att].push(val);
	      } else {
	        var indexOf = this.categoryProductAttributes[group].indexOf(value);
	        this.categoryProductAttributes[group].splice(indexOf, 1);
	        var indexOfFilter = this.filterAttributesProducts[att].indexOf(val);
	        this.filterAttributesProducts[att].splice(indexOfFilter, 1);
	      }
	      // this result = Object.keys(this.filterAttributesProducts);
	      // this resultToCopy = {};
	      // result.forEach(function(val){
	      //     resultToCopy[val] = this.categoryProductAttributes[val];
	      // });
	
	      this.customFilters.attributes = _angular2.default.copy(this.filterAttributesProducts);
	      this.getProducts();
	    }
	  }, {
	    key: 'changeInternalWordSearch',
	    value: function changeInternalWordSearch() {
	      this.controlPrice = 0;
	    }
	  }, {
	    key: 'compareProductsSelected',
	    value: function compareProductsSelected() {
	      var keys = Object.keys(this.productsToCompare.items);
	      this.$state.go('/products/compare/' + this.categoryId + '/' + keys.join('-'));
	    }
	  }, {
	    key: 'cleanFilters',
	    value: function cleanFilters() {
	      if (this.customFilters.attributes) {
	        var keyAttributes = Object.values(this.customFilters.attributes);
	        if (keyAttributes.length) {
	          this.customFilters.attributes = {};
	          this.loadInitialAttributesFitler();
	        } else {
	          this.customFilters.attributes = {};
	        }
	      } else {
	        this.customFilters.attributes = {};
	      }
	      this.controlPrice = 0;
	      this.getProducts(false, true);
	    }
	  }, {
	    key: 'loadInitialAttributesFitler',
	    value: function loadInitialAttributesFitler() {
	      var _this6 = this;
	
	      var keyArray = Object.keys(this.customFilters.attributes);
	      this.filterAttributesProducts = _angular2.default.copy(this.customFilters.attributes);
	      if (this.categoryAttributes) {
	        this.categoryAttributes.forEach(function (attr) {
	          if (keyArray.length) {
	            keyArray.forEach(function (attrId) {
	              if (attr.id === parseInt(attrId)) {
	                attr.data.forEach(function (opcion) {
	                  _this6.customFilters.attributes[attrId].forEach(function (elId) {
	                    if (opcion.id === elId) {
	                      opcion.name = true;
	                    }
	                  });
	                });
	              }
	            });
	          } else {
	            attr.data.forEach(function (opcion) {
	              opcion.name = false;
	            });
	          }
	        });
	      }
	    }
	  }, {
	    key: 'setPagination',
	    value: function setPagination(type, footer) {
	      this.pageSize = type;
	      this.getProducts(footer);
	    }
	  }, {
	    key: 'setSort',
	    value: function setSort(type, footer) {
	      this.sortType = type;
	      this.getProducts(footer);
	    }
	  }, {
	    key: 'setCookieItemsView',
	    value: function setCookieItemsView(itemView) {
	      itemView = parseInt(itemView);
	      this.typeview = itemView;
	      this.SessionService.put('itemsView', itemView);
	    }
	  }, {
	    key: 'messageResponse',
	    value: function messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalResponseView2.default,
	        controller: 'ModalResponseController',
	        controllerAs: 'mdCtrl',
	        size: options.size,
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        if (callAcept) {
	          callback();
	        }
	      }).catch(function (reason) {
	        if (callCancel) {
	          callbackCancel();
	        }
	      });
	    }
	  }]);
	
	  return CategoryController;
	}();
	
	CategoryController.$inject = inject;
	
	exports.default = CategoryController;

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _categoryProducts = __webpack_require__(156);
	
	var _categoryProducts2 = _interopRequireDefault(_categoryProducts);
	
	var _categoryProducts3 = __webpack_require__(160);
	
	var _categoryProducts4 = _interopRequireDefault(_categoryProducts3);
	
	var _categoryProducts5 = __webpack_require__(157);
	
	var _categoryProducts6 = _interopRequireDefault(_categoryProducts5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var categoryProductsModule = _angular2.default.module('categoryProducts', []).component('categoryProducts', _categoryProducts2.default).service('CategoryProductsService', _categoryProducts4.default).config(_categoryProducts6.default);
	
	exports.default = categoryProductsModule;

/***/ },
/* 160 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService'];
	
	var CategoryProductsService = function () {
	  function CategoryProductsService($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService) {
	    _classCallCheck(this, CategoryProductsService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	    this.AuthTokenFactory = AuthTokenFactory;
	    this.SharedService = SharedService;
	    this.SessionService = SessionService;
	    this.dataFilters = null;
	  }
	
	  _createClass(CategoryProductsService, [{
	    key: 'getProducts',
	    value: function getProducts(data, sales) {
	      var _this = this;
	
	      this.dataFilters = data;
	      if (sales) {
	        return this.$q(function (resolve, reject) {
	          _this.$http({
	            method: 'POST',
	            url: _this.ngAuthSettings.apiServiceBaseUri + _this.ngAuthSettings.config.paths.salesItems,
	            cache: false,
	            data: data,
	            headers: { 'Content-Type': 'application/json' }
	          }).then(function (response) {
	            resolve(response.data);
	          }, function (reason) {
	            console.log('reason');
	            console.log(reason);
	            console.log('reason');
	            reject(reason);
	          });
	        });
	      } else {
	        return this.$q(function (resolve, reject) {
	          _this.$http({
	            method: 'POST',
	            url: _this.ngAuthSettings.apiServiceBaseUri + '/categoria-info/show-items-by-cattegory',
	            cache: false,
	            data: data,
	            headers: { 'Content-Type': 'application/json' }
	          }).then(function (response) {
	            resolve(response.data);
	          }, function (reason) {
	            console.log('reason');
	            console.log(reason);
	            console.log('reason');
	            reject(reason);
	          });
	        });
	      }
	    }
	  }, {
	    key: 'getFiltersData',
	    value: function getFiltersData() {
	      return this.dataFilters;
	    }
	  }, {
	    key: 'setFiltersData',
	    value: function setFiltersData(dataFilters) {
	      this.dataFilters = dataFilters;
	    }
	  }]);
	
	  return CategoryProductsService;
	}();
	
	CategoryProductsService.$inject = inject;
	
	exports.default = CategoryProductsService;

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _category = __webpack_require__(163);
	
	var _category2 = _interopRequireDefault(_category);
	
	var _categoryView = __webpack_require__(455);
	
	var _categoryView2 = _interopRequireDefault(_categoryView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CategoryComponent = {
	  template: _categoryView2.default,
	  controller: _category2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = CategoryComponent;

/***/ },
/* 162 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.category', {
	    url: "/categories",
	    template: '<category sh-ctrl="shCtrl"></category>'
	  }).state('home.categorySlug', {
	    url: "/categories/{categorySlug}",
	    template: '<category sh-ctrl="shCtrl"></category>'
	  }).state('home.categoryId', {
	    url: "/categories/{idCategory}",
	    template: '<category sh-ctrl="shCtrl"></category>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modalResponseView = __webpack_require__(3);
	
	var _modalResponseView2 = _interopRequireDefault(_modalResponseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'CategoryService', '$state', '$rootScope', 'SharedService', '$stateParams', '$uibModal', 'Pagination'];
	
	var CategoryController = function () {
	  function CategoryController($scope, CategoryService, $state, $rootScope, SharedService, $stateParams, $uibModal, Pagination) {
	    _classCallCheck(this, CategoryController);
	
	    this.$state = $state;
	    this.$scope = $scope;
	    this.Pagination = Pagination;
	    this.$stateParams = $stateParams;
	    this.$rootScope = $rootScope;
	    this.$uibModal = $uibModal;
	    this.CategoryService = CategoryService;
	    this.SharedService = SharedService;
	    this.loanding = false;
	    this.pagerCategories = [];
	    this.itemsPerPage = 12;
	    this.loadingCategories = true;
	  }
	
	  _createClass(CategoryController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.$stateParams.idCategory || this.$stateParams.categorySlug) {
	        this.getSubcategories(this.$stateParams.idCategory, this.$stateParams.categorySlug);
	      } else {
	        try {
	          this.pagerCategories = this.shCtrl.globalCategoriesMenu;
	          this.pagination = this.Pagination.getNew(this.itemsPerPage);
	          this.pagination.numPages = Math.ceil(this.pagerCategories.length / this.pagination.perPage);
	
	          this.loadingCategories = false;
	        } catch (e) {}
	      }
	      this.getCurrentCategory();
	    }
	
	    // /**
	    //  Get categories
	    //  @method getCategories
	    //  @param url {String} URL to fetch the categories
	    //  */
	    // getCategories(url) {
	    //   this.loadingCategories = true;
	    //
	    //   $http.get(url,
	    //     {
	    //       headers: { 'Cache-Control' : 'no-cache' }
	    //     }
	    //   )
	    //     .success(function(data){
	    //       this.loadingCategories = false;
	    //
	    //       this.pagerCategories = data;
	    //
	    //       this.pagination = Pagination.getNew(this.itemsPerPage);
	    //       this.pagination.numPages = Math.ceil(this.pagerCategories.length/this.pagination.perPage);
	    //     }).error(function(data){});
	    // };
	
	    /**
	     Get subcategories
	     @method getSubcategories
	     @param categoryId {String} URL to fetch the subcategories of a category
	     @param categorySlug {String} URL to fetch the subcategories of a category
	     */
	
	  }, {
	    key: 'getSubcategories',
	    value: function getSubcategories(categoryId, categorySlug) {
	      var _this = this;
	
	      var categoryIdSlug = categoryId || categorySlug;
	
	      var userId = '';
	      try {
	        userId = this.shCtrl.globals.currentUser.userId;
	      } catch (e) {}
	      this.loadingCategories = true;
	      this.CategoryService.getSubcategories(categoryIdSlug, userId).then(function (response) {
	        _this.loadingCategories = false;
	        if (!response) {
	          _this.pagerCategories = response;
	          _this.pagination = Pagination.getNew(_this.itemsPerPage);
	          _this.pagination.numPages = Math.ceil(_this.pagerCategories.length / _this.pagination.perPage);
	        } else {
	          _this.$state.go('404');
	        }
	      }).catch(function (reason) {
	        _this.$state.go('404');
	      });
	    }
	
	    /**
	     Get current category
	     @method getCurrentCategory
	     */
	
	  }, {
	    key: 'getCurrentCategory',
	    value: function getCurrentCategory() {
	      var _this2 = this;
	
	      // currentCategory = response;
	      this.CategoryService.getCurrentCategory(this.$stateParams.idCategory, this.$stateParams.categorySlug).then(function (response) {
	        _this2.currentCategory = data;
	      }).catch(function (reason) {});
	    }
	
	    /**
	     Set item per page on the pagination
	     @method setPagination
	     @param itemsPerPage {Integer} Items per page on the pager
	     @example
	     setpagination(8)
	     */
	
	  }, {
	    key: 'setPagination',
	    value: function setPagination(itemsPerPage) {
	      this.itemsPerPage = itemsPerPage;
	      this.pagination = this.Pagination.getNew(this.itemsPerPage);
	      this.pagination.numPages = Math.ceil(this.pagerCategories.length / this.pagination.perPage);
	    }
	  }, {
	    key: 'messageResponse',
	    value: function messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalResponseView2.default,
	        controller: 'ModalResponseController',
	        controllerAs: 'mdCtrl',
	        size: options.size,
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        if (callAcept) {
	          callback();
	        }
	      }).catch(function (reason) {
	        if (callCancel) {
	          callbackCancel();
	        }
	      });
	    }
	  }]);
	
	  return CategoryController;
	}();
	
	CategoryController.$inject = inject;
	
	exports.default = CategoryController;

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _category = __webpack_require__(161);
	
	var _category2 = _interopRequireDefault(_category);
	
	var _category3 = __webpack_require__(165);
	
	var _category4 = _interopRequireDefault(_category3);
	
	var _category5 = __webpack_require__(162);
	
	var _category6 = _interopRequireDefault(_category5);
	
	var _categoryPagerToolbox = __webpack_require__(155);
	
	var _categoryPagerToolbox2 = _interopRequireDefault(_categoryPagerToolbox);
	
	var _categoryProducts = __webpack_require__(159);
	
	var _categoryProducts2 = _interopRequireDefault(_categoryProducts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var categoryModule = _angular2.default.module('category', [_categoryPagerToolbox2.default.name, _categoryProducts2.default.name]).component('category', _category2.default).service('CategoryService', _category4.default).config(_category6.default);
	
	exports.default = categoryModule;

/***/ },
/* 165 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService'];
	
	var CategoryService = function () {
	  function CategoryService($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService) {
	    _classCallCheck(this, CategoryService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	    this.AuthTokenFactory = AuthTokenFactory;
	    this.SharedService = SharedService;
	    this.SessionService = SessionService;
	  }
	
	  _createClass(CategoryService, [{
	    key: 'getCategories',
	    value: function getCategories() {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'GET',
	          url: _this.ngAuthSettings.apiServiceBaseUri + _this.ngAuthSettings.config.paths.category + (categoryId ? categoryId : '') + '&slug=' + (categorySlug ? categorySlug : ''),
	          cache: true
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getAttributesCategory',
	    value: function getAttributesCategory(categoryId, categorySlug) {
	      var _this2 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this2.$http({
	          method: 'GET',
	          url: _this2.ngAuthSettings.apiServiceBaseUri + _this2.ngAuthSettings.config.paths.categoryAttributes + (categoryId ? categoryId : '') + '&slug=' + (categorySlug ? categorySlug : ''),
	          cache: true
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getCurrentCategory',
	    value: function getCurrentCategory(categoryId, categorySlug) {
	      var _this3 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this3.$http({
	          method: 'GET',
	          url: _this3.ngAuthSettings.apiServiceBaseUri + _this3.ngAuthSettings.config.paths.category + (categoryId ? categoryId : '') + '&slug=' + (categorySlug ? categorySlug : ''),
	          cache: true
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getSubcategories',
	    value: function getSubcategories(categoryIdSlug, userId) {
	      var _this4 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this4.$http({
	          method: 'GET',
	          url: _this4.ngAuthSettings.apiServiceBaseUri + _this4.ngAuthSettings.config.paths.categoryArbol + (categoryIdSlug ? categoryIdSlug : '') + '&userId=' + userId,
	          cache: true
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return CategoryService;
	}();
	
	CategoryService.$inject = inject;
	
	exports.default = CategoryService;

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compareProducts = __webpack_require__(168);
	
	var _compareProducts2 = _interopRequireDefault(_compareProducts);
	
	var _compareProductsView = __webpack_require__(456);
	
	var _compareProductsView2 = _interopRequireDefault(_compareProductsView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CompareProductsComponent = {
	  template: _compareProductsView2.default,
	  controller: _compareProducts2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = CompareProductsComponent;

/***/ },
/* 167 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.compare', {
	    url: "/comparar-productos/{categoryId}/{products:string}",
	    params: {
	      products: {
	        array: true
	      }
	    },
	    template: '<compare-products sh-ctrl="shCtrl"></compare-products>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modalResponseView = __webpack_require__(3);
	
	var _modalResponseView2 = _interopRequireDefault(_modalResponseView);
	
	var _modalQuantityCartView = __webpack_require__(12);
	
	var _modalQuantityCartView2 = _interopRequireDefault(_modalQuantityCartView);
	
	var _modalConfirmationView = __webpack_require__(11);
	
	var _modalConfirmationView2 = _interopRequireDefault(_modalConfirmationView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'CompareProductsService', '$state', '$rootScope', 'SharedService', '$timeout', 'ngAuthSettings', 'CartService', 'SessionService', 'NgTableParams', '$uibModal', 'CategoryService', '$stateParams'];
	
	var CompareProductsController = function () {
	  function CompareProductsController($scope, CompareProductsService, $state, $rootScope, SharedService, $timeout, ngAuthSettings, CartService, SessionService, NgTableParams, $uibModal, CategoryService, $stateParams) {
	    _classCallCheck(this, CompareProductsController);
	
	    this.$state = $state;
	    this.SessionService = SessionService;
	    this.ngAuthSettings = ngAuthSettings;
	    this.CartService = CartService;
	    this.NgTableParams = NgTableParams;
	    this.CategoryService = CategoryService;
	    this.$stateParams = $stateParams;
	    this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.$rootScope = $rootScope;
	    this.CompareProductsService = CompareProductsService;
	    this.$uibModal = $uibModal;
	    this.SharedService = SharedService;
	    this.idCategory = this.$stateParams.categoryId;
	    this.idsProductsToCompare = this.$stateParams.products;
	  }
	
	  _createClass(CompareProductsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getAttributesCategoryToCompare();
	    }
	  }, {
	    key: 'getAttributesCategoryToCompare',
	    value: function getAttributesCategoryToCompare() {
	      var _this = this;
	
	      this.CategoryService.getAttributesCategory(this.idCategory).then(function (response) {
	        _this.categoryAttributesToCompare = response;
	        _this.getProductToCompare();
	      }).catch(function (reason) {
	        console.log(reason);
	        // this.$state.go('404');
	      });
	    }
	  }, {
	    key: 'getProductToCompare',
	    value: function getProductToCompare() {
	      var _this2 = this;
	
	      var userId = '';
	      try {
	        userId = this.shCtrl.globals.currentUser.userId;
	      } catch (e) {}
	      this.CompareProductsService.getProductToCompare(this.idsProductsToCompare, userId).then(function (response) {
	        _this2.productsToCompare = response;
	        // Validate attributes count in products
	        var productsToCompareQuantity = response.length;
	        var productsToCompareDummy = [];
	        _this2.categoryAttributesToCompare.forEach(function (attribute) {
	          var group = attribute.group;
	          var countAttribute = 0;
	          _this2.productsToCompare.forEach(function (product) {
	            angular.forEach(product.attributesDetail, function (attributeProduct) {
	              if (attributeProduct.name === group) {
	                countAttribute++;
	              }
	            });
	          });
	          if (countAttribute) {
	            productsToCompareDummy.push(attribute);
	          }
	        });
	
	        _this2.categoryAttributesToCompare = productsToCompareDummy;
	      }).catch(function (reason) {});
	    }
	  }, {
	    key: 'setItemToAddToCart',
	    value: function setItemToAddToCart(_product) {
	      var _this3 = this;
	
	      _product.id = parseInt(_product.id);
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalQuantityCartView2.default,
	        controller: 'ModalQuantityCartController',
	        controllerAs: 'mdCtrl',
	        size: 'sm',
	        resolve: {
	          product: function product() {
	            return _product;
	          }
	        }
	      });
	      modalInstance.result.then(function (result) {
	        if (result.product.id && result.quantity) {
	          var userId = '',
	              cart = null;
	          try {
	            userId = _this3.shCtrl.globals.currentUser.userId;
	          } catch (e) {}
	          try {
	            cart = _this3.shCtrl.cart;
	          } catch (e) {}
	          _this3.CartService.addItemToCart(result.product, result.quantity, null, null, userId, cart).then(function (response) {
	            if (!response.error) {
	              _this3.$scope.$emit('onUpdateCart');
	              var modalInstance2 = _this3.$uibModal.open({
	                animation: true,
	                template: _modalConfirmationView2.default,
	                controller: 'ModalConfirmationController',
	                controllerAs: 'mdCtrl',
	                size: 'lg',
	                resolve: {
	                  product: function product() {
	                    return _product;
	                  }
	                }
	              });
	            } else {
	              var options = {
	                title: '',
	                isHtml: false,
	                content: response.message,
	                size: '',
	                showBottonCancel: false,
	                textActionCancel: '',
	                textAction: 'Aceptar'
	              };
	              _this3.messageResponse(options);
	            }
	          }).catch(function (reason) {
	            var options = {
	              title: '',
	              isHtml: false,
	              content: reason,
	              size: '',
	              showBottonCancel: false,
	              textActionCancel: '',
	              textAction: 'Aceptar'
	            };
	            _this3.messageResponse(options);
	          });
	        }
	      }).catch(function (error) {});
	    }
	  }, {
	    key: 'delProductToArray',
	    value: function delProductToArray(productId) {
	      if (productId) {
	        this.productsToCompare = this.productsToCompare.filter(function (val) {
	          return val.id !== productId;
	        });
	        if (!this.productsToCompare.length) {
	          this.$state.go('home.categoryIdProducts', { idCategory: this.idCategory });
	        }
	      }
	    }
	  }, {
	    key: 'messageResponse',
	    value: function messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalResponseView2.default,
	        controller: 'ModalResponseController',
	        controllerAs: 'mdCtrl',
	        size: options.size,
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        if (callAcept) {
	          callback();
	        }
	      }).catch(function (reason) {
	        if (callCancel) {
	          callbackCancel();
	        }
	      });
	    }
	  }]);
	
	  return CompareProductsController;
	}();
	
	CompareProductsController.$inject = inject;
	
	exports.default = CompareProductsController;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _compareProducts = __webpack_require__(166);
	
	var _compareProducts2 = _interopRequireDefault(_compareProducts);
	
	var _compareProducts3 = __webpack_require__(170);
	
	var _compareProducts4 = _interopRequireDefault(_compareProducts3);
	
	var _compareProducts5 = __webpack_require__(167);
	
	var _compareProducts6 = _interopRequireDefault(_compareProducts5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var compareProductsModule = _angular2.default.module('app.compareProducts', []).component('compareProducts', _compareProducts2.default).service('CompareProductsService', _compareProducts4.default).config(_compareProducts6.default);
	exports.default = compareProductsModule;

/***/ },
/* 170 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CompareProductsService = function () {
	  function CompareProductsService($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
	    _classCallCheck(this, CompareProductsService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	  }
	
	  _createClass(CompareProductsService, [{
	    key: 'getProductToCompare',
	    value: function getProductToCompare(idsProductsToCompare, userId) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'GET',
	          url: _this.ngAuthSettings.apiServiceBaseUri + _this.ngAuthSettings.config.paths.compareProducts + idsProductsToCompare + '&userId=' + userId,
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return CompareProductsService;
	}();
	
	CompareProductsService.$inject = ['$q', '$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];
	
	exports.default = CompareProductsService;

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fastSearchModule = _angular2.default.module('app.catalog.fastSearch', []);
	
	exports.default = fastSearchModule;

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _featuredProducts = __webpack_require__(173);
	
	var _featuredProducts2 = _interopRequireDefault(_featuredProducts);
	
	var _featuredProductsView = __webpack_require__(457);
	
	var _featuredProductsView2 = _interopRequireDefault(_featuredProductsView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FeaturedProductsComponent = {
	  template: _featuredProductsView2.default,
	  controller: _featuredProducts2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = FeaturedProductsComponent;

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modalResponseView = __webpack_require__(3);
	
	var _modalResponseView2 = _interopRequireDefault(_modalResponseView);
	
	var _modalQuantityCartView = __webpack_require__(12);
	
	var _modalQuantityCartView2 = _interopRequireDefault(_modalQuantityCartView);
	
	var _modalConfirmationView = __webpack_require__(11);
	
	var _modalConfirmationView2 = _interopRequireDefault(_modalConfirmationView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$state', '$rootScope', 'SharedService', 'ngAuthSettings', 'CatalogService', '$uibModal', '$timeout', 'CartService'];
	
	var FeaturedProductsController = function () {
	  function FeaturedProductsController($scope, $state, $rootScope, SharedService, ngAuthSettings, CatalogService, $uibModal, $timeout, CartService) {
	    _classCallCheck(this, FeaturedProductsController);
	
	    this.$state = $state;
	    this.$uibModal = $uibModal;
	    this.$scope = $scope;
	    this.CatalogService = CatalogService;
	    this.CartService = CartService;
	    this.$timeout = $timeout;
	    this.ngAuthSettings = ngAuthSettings;
	    this.$rootScope = $rootScope;
	    this.SharedService = SharedService;
	  }
	
	  _createClass(FeaturedProductsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getFeaturedProducts();
	    }
	  }, {
	    key: 'getFeaturedProducts',
	    value: function getFeaturedProducts() {
	      var _this = this;
	
	      var userId = '';
	      try {
	        userId = this.shCtrl.currentUser.userId;
	      } catch (e) {}
	      this.CatalogService.getFeaturedProducts(userId, 10).then(function (response) {
	        _this.featuredProducts = response;
	        _this.featuredProducts1 = [];
	        _this.featuredProducts2 = [];
	        if (response.length) {
	          response.forEach(function (valFor, indexFor) {
	            if (indexFor <= (response.length - 1) / 2 || response.length < 8) {
	              _this.featuredProducts1.push(valFor);
	            } else {
	              _this.featuredProducts2.push(valFor);
	            }
	          });
	        }
	        _this.initRelatedProductsCarousel();
	        // initBrandsCarousel();
	
	        _this.loadingRelatedProducts = false;
	      }).catch(function (error) {});
	    }
	  }, {
	    key: 'initRelatedProductsCarousel',
	    value: function initRelatedProductsCarousel() {
	      this.$timeout(function () {
	        var purchasedItems = $('.purchased-items-slider.owl-carousel');
	        purchasedItems.owlCarousel({
	          items: 4,
	          itemsDesktop: [1199, 3],
	          itemsDesktopSmall: [979, 2],
	          itemsTablet: [768, 2],
	          itemsMobile: [479, 1],
	          slideSpeed: 400,
	          autoPlay: 8000,
	          stopOnHover: true,
	          navigation: false,
	          pagination: false,
	          responsive: true,
	          mouseDrag: false,
	          autoHeight: true
	        }).data('navigationBtns', ['#purchased-items-slider-prev', '#purchased-items-slider-next']);
	        purchasedItems.each(function () {
	          var $this = $(this),
	              owlCarousel = $this.data('owlCarousel'),
	              owlBtns = $this.data('navigationBtns'),
	              prevBtn = void 0,
	              nextBtn = void 0;
	
	          if (typeof owlCarousel === 'undefined' || typeof owlBtns === 'undefined') {
	            return;
	          }
	
	          for (var key in owlBtns) {
	            if (owlBtns[key].indexOf('next') === -1) {
	              prevBtn = $(owlBtns[key]);
	            } else {
	              nextBtn = $(owlBtns[key]);
	            }
	          }
	
	          prevBtn.on('click touchstart', function (e) {
	            owlCarousel.prev();
	            e.preventDefault();
	          });
	
	          nextBtn.on('click touchstart', function (e) {
	            owlCarousel.next();
	            e.preventDefault();
	          });
	        });
	
	        $('.add-tooltip').tooltip();
	      }, 1000);
	    }
	  }, {
	    key: 'setItemToAddToCart',
	    value: function setItemToAddToCart(_product) {
	      var _this2 = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalQuantityCartView2.default,
	        controller: 'ModalQuantityCartController',
	        controllerAs: 'mdCtrl',
	        size: 'sm',
	        resolve: {
	          product: function product() {
	            return _product;
	          }
	        }
	      });
	      modalInstance.result.then(function (result) {
	        if (result.product.id && result.quantity) {
	          var userId = '',
	              cart = null;
	          try {
	            userId = _this2.shCtrl.globals.currentUser.userId;
	          } catch (e) {}
	          try {
	            cart = _this2.shCtrl.cart;
	          } catch (e) {}
	          _this2.CartService.addItemToCart(result.product, result.quantity, null, null, userId, cart).then(function (response) {
	            if (!response.error) {
	              _this2.$scope.$emit('onUpdateCart');
	              var modalInstance2 = _this2.$uibModal.open({
	                animation: true,
	                template: _modalConfirmationView2.default,
	                controller: 'ModalConfirmationController',
	                controllerAs: 'mdCtrl',
	                size: 'lg',
	                resolve: {
	                  product: function product() {
	                    return _product;
	                  }
	                }
	              });
	            } else {
	              var options = {
	                title: '',
	                isHtml: true,
	                content: response.message,
	                size: '',
	                showBottonCancel: false,
	                textActionCancel: '',
	                textAction: 'Aceptar'
	              };
	              _this2.messageResponse(options);
	            }
	          }).catch(function (reason) {
	            var options = {
	              title: '',
	              isHtml: false,
	              content: reason,
	              size: '',
	              showBottonCancel: false,
	              textActionCancel: '',
	              textAction: 'Aceptar'
	            };
	            _this2.messageResponse(options);
	          });
	        }
	      }).catch(function (error) {});
	    }
	  }, {
	    key: 'updateFavoriteProducts',
	    value: function updateFavoriteProducts(product) {
	      var _this3 = this;
	
	      product.isSettingAsFavorite = true;
	      var userId = '';
	      try {
	        userId = this.shCtrl.globals.currentUser.userId;
	      } catch (e) {}
	      if (userId) {
	        var data = {
	          'productId': product.id,
	          'userId': userId,
	          'setFavorite': !product.isFavorite
	        };
	        this.CatalogService.updateFavoriteProducts(data).then(function (response) {
	          product.isFavorite = !product.isFavorite;
	          product.isSettingAsFavorite = false;
	        }).catch(function (error) {
	          product.isSettingAsFavorite = false;
	          var options = {
	            title: '',
	            isHtml: false,
	            content: 'Ha ocurrido un error al actualizar el producto',
	            size: '',
	            showBottonCancel: false,
	            textActionCancel: '',
	            textAction: 'Aceptar'
	          };
	          _this3.messageResponse(options);
	        });
	      }
	    }
	  }, {
	    key: 'messageResponse',
	    value: function messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalResponseView2.default,
	        controller: 'ModalResponseController',
	        controllerAs: 'mdCtrl',
	        size: options.size,
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        if (callAcept) {
	          callback();
	        }
	      }).catch(function (reason) {
	        if (callCancel) {
	          callbackCancel();
	        }
	      });
	    }
	  }]);
	
	  return FeaturedProductsController;
	}();
	
	FeaturedProductsController.$inject = inject;
	
	exports.default = FeaturedProductsController;

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _featuredProducts = __webpack_require__(172);
	
	var _featuredProducts2 = _interopRequireDefault(_featuredProducts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FeaturedProductsModule = _angular2.default.module('catalog.featuredProducts', []).component('featuredProducts', _featuredProducts2.default);
	
	exports.default = FeaturedProductsModule;

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$uibModalInstance', 'product', 'CartService', 'SessionService', '$state'];
	
	var ModalConfirmationController = function () {
	  function ModalConfirmationController($scope, $uibModalInstance, product, CartService, SessionService, $state) {
	    _classCallCheck(this, ModalConfirmationController);
	
	    this.$scope = $scope;
	    this.productAdded = _angular2.default.copy(product);
	    this.$uibModalInstance = $uibModalInstance;
	    this.$state = $state;
	    this.SessionService = SessionService;
	    this.CartService = CartService;
	    this.itemQuantityToAdd = 1;
	    this.user = {};
	  }
	
	  _createClass(ModalConfirmationController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.SessionService.getGlobals().then(function (response) {
	        var cartId = _this.SessionService.get('cartId') || '';
	        var userId = '';
	        try {
	          userId = response.currentUser.userId;
	        } catch (e) {}
	        var clientPriceListName = '';
	        try {
	          clientPriceListName = _this.SessionService.get('quoteCartSeller').clientPriceList;
	        } catch (e) {}
	        _this.CartService.getCart(cartId, userId, clientPriceListName).then(function (response) {
	          _this.cart = response;
	          _this.product = _this.cart.items.filter(function (val) {
	            return val.id === _this.productAdded.id;
	          })[0];
	        });
	      }).catch(function (reason) {
	        return null;
	      });
	    }
	  }, {
	    key: 'goToCart',
	    value: function goToCart() {
	      this.$state.go('home.cart');
	      this.cancel();
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return ModalConfirmationController;
	}();
	
	ModalConfirmationController.$inject = inject;
	
	exports.default = ModalConfirmationController;

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$uibModalInstance', 'product'];
	
	var ModalQuantityCartController = function () {
	  function ModalQuantityCartController($scope, $uibModalInstance, product) {
	    _classCallCheck(this, ModalQuantityCartController);
	
	    this.$scope = $scope;
	    this.product = _angular2.default.copy(product);
	    this.$uibModalInstance = $uibModalInstance;
	    this.itemQuantityToAdd = 1;
	    this.user = {};
	  }
	
	  _createClass(ModalQuantityCartController, [{
	    key: 'increaseItemQuantityToAdd',
	    value: function increaseItemQuantityToAdd() {
	      if (!this.itemQuantityToAdd) this.itemQuantityToAdd = 1;else this.itemQuantityToAdd++;
	    }
	  }, {
	    key: 'decreaseItemQuantityToAdd',
	    value: function decreaseItemQuantityToAdd() {
	      if (!this.itemQuantityToAdd) this.itemQuantityToAdd = 1;else if (this.itemQuantityToAdd > 1) {
	        this.itemQuantityToAdd--;
	      }
	    }
	  }, {
	    key: 'addItemToCart',
	    value: function addItemToCart(product, quantity) {
	      this.$uibModalInstance.close({ product: product, quantity: quantity });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return ModalQuantityCartController;
	}();
	
	ModalQuantityCartController.$inject = inject;
	
	exports.default = ModalQuantityCartController;

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mostSelledProducts = __webpack_require__(178);
	
	var _mostSelledProducts2 = _interopRequireDefault(_mostSelledProducts);
	
	var _mostSelledProductsView = __webpack_require__(458);
	
	var _mostSelledProductsView2 = _interopRequireDefault(_mostSelledProductsView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MostSelledProductsComponent = {
	  template: _mostSelledProductsView2.default,
	  controller: _mostSelledProducts2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = MostSelledProductsComponent;

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modalResponseView = __webpack_require__(3);
	
	var _modalResponseView2 = _interopRequireDefault(_modalResponseView);
	
	var _modalQuantityCartView = __webpack_require__(12);
	
	var _modalQuantityCartView2 = _interopRequireDefault(_modalQuantityCartView);
	
	var _modalConfirmationView = __webpack_require__(11);
	
	var _modalConfirmationView2 = _interopRequireDefault(_modalConfirmationView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$state', '$rootScope', 'SharedService', 'ngAuthSettings', 'CatalogService', '$uibModal', '$timeout', 'CartService'];
	
	var MostSelledProductsController = function () {
	  function MostSelledProductsController($scope, $state, $rootScope, SharedService, ngAuthSettings, CatalogService, $uibModal, $timeout, CartService) {
	    _classCallCheck(this, MostSelledProductsController);
	
	    this.$state = $state;
	    this.$uibModal = $uibModal;
	    this.$scope = $scope;
	    this.CatalogService = CatalogService;
	    this.CartService = CartService;
	    this.$timeout = $timeout;
	    this.ngAuthSettings = ngAuthSettings;
	    this.$rootScope = $rootScope;
	    this.SharedService = SharedService;
	  }
	
	  _createClass(MostSelledProductsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getMostSelledProducts();
	    }
	  }, {
	    key: 'getMostSelledProducts',
	    value: function getMostSelledProducts() {
	      var _this = this;
	
	      var userId = '';
	      try {
	        userId = this.shCtrl.currentUser.userId;
	      } catch (e) {}
	      this.CatalogService.getMostSelledProducts(userId, 10).then(function (response) {
	        _this.mostSelledProducts = response;
	        _this.mostSelledProducts1 = [];
	        _this.mostSelledProducts2 = [];
	        if (response.length) {
	          response.forEach(function (valFor, indexFor) {
	            if (indexFor <= (response.length - 1) / 2 || response.length < 8) {
	              _this.mostSelledProducts1.push(valFor);
	            } else {
	              _this.mostSelledProducts2.push(valFor);
	            }
	          });
	        }
	        _this.initRelatedProductsCarousel();
	        // initBrandsCarousel();
	
	        _this.loadingRelatedProducts = false;
	      }).catch(function (error) {});
	    }
	  }, {
	    key: 'initRelatedProductsCarousel',
	    value: function initRelatedProductsCarousel() {
	      var _this2 = this;
	
	      this.$timeout(function () {
	        var purchasedItems = $('.most-selled-items-slider.owl-carousel');
	        purchasedItems.owlCarousel({
	          items: 4,
	          itemsDesktop: [1199, 3],
	          itemsDesktopSmall: [979, 2],
	          itemsTablet: [768, 2],
	          itemsMobile: [479, 1],
	          slideSpeed: 400,
	          autoPlay: 8000,
	          stopOnHover: true,
	          navigation: false,
	          pagination: false,
	          responsive: true,
	          mouseDrag: false,
	          autoHeight: true
	        }).data('navigationBtns', ['#purchased-items-slider-prev', '#purchased-items-slider-next']);
	        purchasedItems.each(function () {
	          var $this = $(_this2),
	              owlCarousel = $this.data('owlCarousel'),
	              owlBtns = $this.data('navigationBtns'),
	              prevBtn = void 0,
	              nextBtn = void 0;
	
	          if (typeof owlCarousel === 'undefined' || typeof owlBtns === 'undefined') {
	            return;
	          }
	
	          for (var key in owlBtns) {
	            if (owlBtns[key].indexOf('next') === -1) {
	              prevBtn = $(owlBtns[key]);
	            } else {
	              nextBtn = $(owlBtns[key]);
	            }
	          }
	
	          prevBtn.on('click touchstart', function (e) {
	            owlCarousel.prev();
	            e.preventDefault();
	          });
	
	          nextBtn.on('click touchstart', function (e) {
	            owlCarousel.next();
	            e.preventDefault();
	          });
	        });
	
	        $('.add-tooltip').tooltip();
	      }, 1000);
	    }
	  }, {
	    key: 'setItemToAddToCart',
	    value: function setItemToAddToCart(_product) {
	      var _this3 = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalQuantityCartView2.default,
	        controller: 'ModalQuantityCartController',
	        controllerAs: 'mdCtrl',
	        size: 'sm',
	        resolve: {
	          product: function product() {
	            return _product;
	          }
	        }
	      });
	      modalInstance.result.then(function (result) {
	        if (result.product.id && result.quantity) {
	          var userId = '',
	              cart = null;
	          try {
	            userId = _this3.shCtrl.globals.currentUser.userId;
	          } catch (e) {}
	          try {
	            cart = _this3.shCtrl.cart;
	          } catch (e) {}
	          _this3.CartService.addItemToCart(result.product, result.quantity, null, null, userId, cart).then(function (response) {
	            if (!response.error) {
	              _this3.$scope.$emit('onUpdateCart');
	              var modalInstance2 = _this3.$uibModal.open({
	                animation: true,
	                template: _modalConfirmationView2.default,
	                controller: 'ModalConfirmationController',
	                controllerAs: 'mdCtrl',
	                size: 'lg',
	                resolve: {
	                  product: function product() {
	                    return _product;
	                  }
	                }
	              });
	            } else {
	              var options = {
	                title: '',
	                isHtml: true,
	                content: response.message,
	                size: '',
	                showBottonCancel: false,
	                textActionCancel: '',
	                textAction: 'Aceptar'
	              };
	              _this3.messageResponse(options);
	            }
	          }).catch(function (reason) {
	            var options = {
	              title: '',
	              isHtml: false,
	              content: reason,
	              size: '',
	              showBottonCancel: false,
	              textActionCancel: '',
	              textAction: 'Aceptar'
	            };
	            _this3.messageResponse(options);
	          });
	        }
	      }).catch(function (error) {});
	    }
	  }, {
	    key: 'updateFavoriteProducts',
	    value: function updateFavoriteProducts(product) {
	      var _this4 = this;
	
	      product.isSettingAsFavorite = true;
	      var userId = '';
	      try {
	        userId = this.shCtrl.globals.currentUser.userId;
	      } catch (e) {}
	      if (userId) {
	        var data = {
	          'productId': product.id,
	          'userId': userId,
	          'setFavorite': !product.isFavorite
	        };
	        this.CatalogService.updateFavoriteProducts(data).then(function (response) {
	          product.isFavorite = !product.isFavorite;
	          product.isSettingAsFavorite = false;
	        }).catch(function (error) {
	          product.isSettingAsFavorite = false;
	          var options = {
	            title: '',
	            isHtml: false,
	            content: 'Ha ocurrido un error al actualizar el producto',
	            size: '',
	            showBottonCancel: false,
	            textActionCancel: '',
	            textAction: 'Aceptar'
	          };
	          _this4.messageResponse(options);
	        });
	      }
	    }
	  }, {
	    key: 'messageResponse',
	    value: function messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalResponseView2.default,
	        controller: 'ModalResponseController',
	        controllerAs: 'mdCtrl',
	        size: options.size,
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        if (callAcept) {
	          callback();
	        }
	      }).catch(function (reason) {
	        if (callCancel) {
	          callbackCancel();
	        }
	      });
	    }
	  }]);
	
	  return MostSelledProductsController;
	}();
	
	MostSelledProductsController.$inject = inject;
	
	exports.default = MostSelledProductsController;

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _mostSelledProducts = __webpack_require__(177);
	
	var _mostSelledProducts2 = _interopRequireDefault(_mostSelledProducts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MostSelledProductsModule = _angular2.default.module('catalog.mostSelledProducts', []).component('mostSelledProducts', _mostSelledProducts2.default);
	
	exports.default = MostSelledProductsModule;

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _newProducts = __webpack_require__(181);
	
	var _newProducts2 = _interopRequireDefault(_newProducts);
	
	var _newProductsView = __webpack_require__(459);
	
	var _newProductsView2 = _interopRequireDefault(_newProductsView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NewProductsComponent = {
	  template: _newProductsView2.default,
	  controller: _newProducts2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = NewProductsComponent;

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modalResponseView = __webpack_require__(3);
	
	var _modalResponseView2 = _interopRequireDefault(_modalResponseView);
	
	var _modalQuantityCartView = __webpack_require__(12);
	
	var _modalQuantityCartView2 = _interopRequireDefault(_modalQuantityCartView);
	
	var _modalConfirmationView = __webpack_require__(11);
	
	var _modalConfirmationView2 = _interopRequireDefault(_modalConfirmationView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$state', '$rootScope', 'SharedService', 'ngAuthSettings', 'CatalogService', '$uibModal', '$timeout', 'CartService'];
	
	var NewProductsController = function () {
	  function NewProductsController($scope, $state, $rootScope, SharedService, ngAuthSettings, CatalogService, $uibModal, $timeout, CartService) {
	    _classCallCheck(this, NewProductsController);
	
	    this.$state = $state;
	    this.$uibModal = $uibModal;
	    this.$scope = $scope;
	    this.CatalogService = CatalogService;
	    this.CartService = CartService;
	    this.$timeout = $timeout;
	    this.ngAuthSettings = ngAuthSettings;
	    this.$rootScope = $rootScope;
	    this.SharedService = SharedService;
	  }
	
	  _createClass(NewProductsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getNewProducts();
	    }
	  }, {
	    key: 'getNewProducts',
	    value: function getNewProducts() {
	      var _this = this;
	
	      var userId = '';
	      try {
	        userId = this.shCtrl.currentUser.userId;
	      } catch (e) {}
	      this.CatalogService.getNewProducts(userId, 10).then(function (response) {
	        _this.newProducts = response;
	        _this.newProducts1 = [];
	        _this.newProducts2 = [];
	        if (response.length) {
	          response.forEach(function (valFor, indexFor) {
	            if (indexFor <= (response.length - 1) / 2 || response.length < 8) {
	              _this.newProducts1.push(valFor);
	            } else {
	              _this.newProducts2.push(valFor);
	            }
	          });
	        }
	        _this.initNewProductsCarousel();
	        // initBrandsCarousel();
	
	        _this.loadingRelatedProducts = false;
	      }).catch(function (error) {});
	    }
	  }, {
	    key: 'initNewProductsCarousel',
	    value: function initNewProductsCarousel() {
	      this.$timeout(function () {
	        var newItems = $('.new-items-slider.owl-carousel');
	        newItems.owlCarousel({
	          items: 4,
	          itemsDesktop: [1199, 3],
	          itemsDesktopSmall: [979, 2],
	          itemsTablet: [768, 2],
	          itemsMobile: [479, 1],
	          slideSpeed: 400,
	          autoPlay: 8000,
	          stopOnHover: true,
	          navigation: false,
	          pagination: false,
	          responsive: true,
	          mouseDrag: false,
	          autoHeight: true
	        }).data('navigationBtns', ['#new-items-slider-prev', '#new-items-slider-next']);
	        newItems.each(function () {
	          var $this = $(this),
	              owlCarousel = $this.data('owlCarousel'),
	              owlBtns = $this.data('navigationBtns'),
	              prevBtn = void 0,
	              nextBtn = void 0;
	
	          if (typeof owlCarousel === 'undefined' || typeof owlBtns === 'undefined') {
	            return;
	          }
	
	          for (var key in owlBtns) {
	            if (owlBtns[key].indexOf('next') === -1) {
	              prevBtn = $(owlBtns[key]);
	            } else {
	              nextBtn = $(owlBtns[key]);
	            }
	          }
	
	          prevBtn.on('click touchstart', function (e) {
	            owlCarousel.prev();
	            e.preventDefault();
	          });
	
	          nextBtn.on('click touchstart', function (e) {
	            owlCarousel.next();
	            e.preventDefault();
	          });
	        });
	
	        $('.add-tooltip').tooltip();
	      }, 1000);
	    }
	  }, {
	    key: 'setItemToAddToCart',
	    value: function setItemToAddToCart(_product) {
	      var _this2 = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalQuantityCartView2.default,
	        controller: 'ModalQuantityCartController',
	        controllerAs: 'mdCtrl',
	        size: 'sm',
	        resolve: {
	          product: function product() {
	            return _product;
	          }
	        }
	      });
	      modalInstance.result.then(function (result) {
	        if (result.product.id && result.quantity) {
	          var userId = '',
	              cart = null;
	          try {
	            userId = _this2.shCtrl.globals.currentUser.userId;
	          } catch (e) {}
	          try {
	            cart = _this2.shCtrl.cart;
	          } catch (e) {}
	          _this2.CartService.addItemToCart(result.product, result.quantity, null, null, userId, cart).then(function (response) {
	            if (!response.error) {
	              _this2.$scope.$emit('onUpdateCart');
	              var modalInstance2 = _this2.$uibModal.open({
	                animation: true,
	                template: _modalConfirmationView2.default,
	                controller: 'ModalConfirmationController',
	                controllerAs: 'mdCtrl',
	                size: 'lg',
	                resolve: {
	                  product: function product() {
	                    return _product;
	                  }
	                }
	              });
	            } else {
	              var options = {
	                title: '',
	                isHtml: true,
	                content: response.message,
	                size: '',
	                showBottonCancel: false,
	                textActionCancel: '',
	                textAction: 'Aceptar'
	              };
	              _this2.messageResponse(options);
	            }
	          }).catch(function (reason) {
	            var options = {
	              title: '',
	              isHtml: false,
	              content: reason,
	              size: '',
	              showBottonCancel: false,
	              textActionCancel: '',
	              textAction: 'Aceptar'
	            };
	            _this2.messageResponse(options);
	          });
	        }
	      }).catch(function (error) {});
	    }
	  }, {
	    key: 'updateFavoriteProducts',
	    value: function updateFavoriteProducts(product) {
	      var _this3 = this;
	
	      product.isSettingAsFavorite = true;
	      var userId = '';
	      try {
	        userId = this.shCtrl.globals.currentUser.userId;
	      } catch (e) {}
	      if (userId) {
	        var data = {
	          'productId': product.id,
	          'userId': userId,
	          'setFavorite': !product.isFavorite
	        };
	        this.CatalogService.updateFavoriteProducts(data).then(function (response) {
	          product.isFavorite = !product.isFavorite;
	          product.isSettingAsFavorite = false;
	        }).catch(function (error) {
	          product.isSettingAsFavorite = false;
	          var options = {
	            title: '',
	            isHtml: false,
	            content: 'Ha ocurrido un error al actualizar el producto',
	            size: '',
	            showBottonCancel: false,
	            textActionCancel: '',
	            textAction: 'Aceptar'
	          };
	          _this3.messageResponse(options);
	        });
	      }
	    }
	  }, {
	    key: 'messageResponse',
	    value: function messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalResponseView2.default,
	        controller: 'ModalResponseController',
	        controllerAs: 'mdCtrl',
	        size: options.size,
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        if (callAcept) {
	          callback();
	        }
	      }).catch(function (reason) {
	        if (callCancel) {
	          callbackCancel();
	        }
	      });
	    }
	  }]);
	
	  return NewProductsController;
	}();
	
	NewProductsController.$inject = inject;
	
	exports.default = NewProductsController;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _newProducts = __webpack_require__(180);
	
	var _newProducts2 = _interopRequireDefault(_newProducts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NewProductsModule = _angular2.default.module('catalog.newProducts', []).component('newProducts', _newProducts2.default);
	
	exports.default = NewProductsModule;

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _productDetail = __webpack_require__(185);
	
	var _productDetail2 = _interopRequireDefault(_productDetail);
	
	var _productDetailView = __webpack_require__(460);
	
	var _productDetailView2 = _interopRequireDefault(_productDetailView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductDetailComponent = {
	  template: _productDetailView2.default,
	  controller: _productDetail2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = ProductDetailComponent;

/***/ },
/* 184 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider
	  // .state('home.productDetail', {
	  //   url: "/categories",
	  //   template: `<product-detail sh-ctrl="shCtrl"></product-detail>`
	  // })
	  .state('home.productDetailSlug', {
	    url: "/product-detail-slug/{productSlug}",
	    template: '<product-detail sh-ctrl="shCtrl"></product-detail>'
	  }).state('home.productDetailId', {
	    url: "/product-detail-id/{productId}",
	    template: '<product-detail sh-ctrl="shCtrl"></product-detail>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable angular/ng_angularelement */
	
	
	var _modalQuantityCartView = __webpack_require__(12);
	
	var _modalQuantityCartView2 = _interopRequireDefault(_modalQuantityCartView);
	
	var _modalResponseView = __webpack_require__(3);
	
	var _modalResponseView2 = _interopRequireDefault(_modalResponseView);
	
	var _modalVideoView = __webpack_require__(513);
	
	var _modalVideoView2 = _interopRequireDefault(_modalVideoView);
	
	var _modalConfirmationView = __webpack_require__(11);
	
	var _modalConfirmationView2 = _interopRequireDefault(_modalConfirmationView);
	
	var _modalRecommendProductView = __webpack_require__(511);
	
	var _modalRecommendProductView2 = _interopRequireDefault(_modalRecommendProductView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'CategoryService', '$state', '$rootScope', 'SharedService', '$stateParams', '$uibModal', 'ProductDetailService', '$timeout', 'CatalogService', 'CartService'];
	
	var ProductDetailController = function () {
	  function ProductDetailController($scope, CategoryService, $state, $rootScope, SharedService, $stateParams, $uibModal, ProductDetailService, $timeout, CatalogService, CartService) {
	    _classCallCheck(this, ProductDetailController);
	
	    this.$state = $state;
	    this.$scope = $scope;
	    this.CatalogService = CatalogService;
	    this.ProductDetailService = ProductDetailService;
	    this.$stateParams = $stateParams;
	    this.$rootScope = $rootScope;
	    this.$uibModal = $uibModal;
	    this.CartService = CartService;
	    this.CategoryService = CategoryService;
	    this.SharedService = SharedService;
	    this.$timeout = $timeout;
	    this.loanding = false;
	    this.showProductPrice = true;
	    this.partSuppliesProduct = [];
	    this.featuredProducts = [];
	    this.active = 0;
	    this.partSustitutesProduct = [];
	    this.showBottomAddCart = true;
	    this.productQuantity = 1;
	    this.productId = this.$stateParams.productId || '';
	    this.productSlug = this.$stateParams.productSlug || '';
	  }
	
	  _createClass(ProductDetailController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getProductDetail();
	      this.getFeaturedProducts();
	      this.getRelatedProducts();
	    }
	  }, {
	    key: 'updateFavoriteProducts',
	    value: function updateFavoriteProducts(product) {
	      var _this = this;
	
	      product.isSettingAsFavorite = true;
	      var userId = '';
	      try {
	        userId = this.shCtrl.globals.currentUser.userId;
	      } catch (e) {}
	      if (userId) {
	        var data = {
	          'productId': product.id,
	          'userId': userId,
	          'setFavorite': !product.isFavorite
	        };
	        this.CatalogService.updateFavoriteProducts(data).then(function (response) {
	          product.isFavorite = !product.isFavorite;
	          product.isSettingAsFavorite = false;
	        }).catch(function (error) {
	          product.isSettingAsFavorite = false;
	          var options = {
	            title: '',
	            isHtml: false,
	            content: 'Ha ocurrido un error al actualizar el producto',
	            size: '',
	            showBottonCancel: false,
	            textActionCancel: '',
	            textAction: 'Aceptar'
	          };
	          _this.messageResponse(options);
	        });
	      }
	    }
	  }, {
	    key: 'getProductDetail',
	    value: function getProductDetail() {
	      var _this2 = this;
	
	      this.loadingProductDetail = true;
	      var userId = '';
	      try {
	        userId = this.shCtrl.globals.currentUser.userId;
	      } catch (e) {}
	      this.ProductDetailService.getProductDetail(this.productId, this.productSlug, userId).then(function (response) {
	        _this2.loadingProductDetail = false;
	        try {
	          _this2.productDetail = response;
	          _this2.productoPlantilla = response;
	          _this2.initPluginsProductDetails();
	
	          if (_this2.productDetail.clonedAttributesDetail.length > 0) {
	            _this2.showProductPrice = false;
	          }
	
	          if (_this2.productDetail.isTemplate) {
	            _this2.productTemplateCopy = angular.copy(_this2.productDetail);
	          }
	        } catch (e) {
	          _this2.$state.go('/404');
	        }
	      }).catch(function (reason) {
	        _this2.$state.go('/404');
	      });
	    }
	  }, {
	    key: 'setItemToAddToCart',
	    value: function setItemToAddToCart(_product) {
	      var _this3 = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalQuantityCartView2.default,
	        controller: 'ModalQuantityCartController',
	        controllerAs: 'mdCtrl',
	        size: 'sm',
	        resolve: {
	          product: function product() {
	            return _product;
	          }
	        }
	      });
	      modalInstance.result.then(function (result) {
	        if (result.product.id && result.quantity) {
	          var userId = '',
	              cart = null;
	          try {
	            userId = _this3.shCtrl.globals.currentUser.userId;
	          } catch (e) {}
	          try {
	            cart = _this3.shCtrl.cart;
	          } catch (e) {}
	          _this3.CartService.addItemToCart(result.product, result.quantity, null, null, userId, cart).then(function (response) {
	            if (!response.error) {
	              _this3.$scope.$emit('onUpdateCart');
	              var modalInstance2 = _this3.$uibModal.open({
	                animation: true,
	                template: _modalConfirmationView2.default,
	                controller: 'ModalConfirmationController',
	                controllerAs: 'mdCtrl',
	                size: 'lg',
	                resolve: {
	                  product: function product() {
	                    return _product;
	                  }
	                }
	              });
	            } else {
	              var options = {
	                title: '',
	                isHtml: true,
	                content: response.message,
	                size: '',
	                showBottonCancel: false,
	                textActionCancel: '',
	                textAction: 'Aceptar'
	              };
	              _this3.messageResponse(options);
	            }
	          }).catch(function (reason) {
	            var options = {
	              title: '',
	              isHtml: false,
	              content: reason,
	              size: '',
	              showBottonCancel: false,
	              textActionCancel: '',
	              textAction: 'Aceptar'
	            };
	            _this3.messageResponse(options);
	          });
	        }
	      }).catch(function (error) {});
	    }
	  }, {
	    key: 'getRelatedProducts',
	    value: function getRelatedProducts() {
	      var _this4 = this;
	
	      this.loadingRelatedProducts = true;
	      var userId = '';
	      try {
	        userId = this.shCtrl.globals.currentUser.userId;
	      } catch (e) {}
	      this.ProductDetailService.getRelatedProducts(this.productId, userId, this.productSlug).then(function (response) {
	        _this4.relatedProducts = response;
	        response.forEach(function (item) {
	          if (item.id_tipo_relacion == '1' || item.id_tipo_relacion == '3') {
	            _this4.partSuppliesProduct.push(item);
	          }
	
	          if (item.id_tipo_relacion == '2') {
	            _this4.partSustitutesProduct.push(item);
	          }
	        });
	        _this4.loadingRelatedProducts = false;
	      }).catch(function (reason) {});
	    }
	  }, {
	    key: 'addItemToCart',
	    value: function addItemToCart(_product2, quantity) {
	      var _this5 = this;
	
	      if (_product2.id && quantity) {
	        var userId = '',
	            cart = null;
	        try {
	          userId = this.shCtrl.globals.currentUser.userId;
	        } catch (e) {}
	        try {
	          cart = this.shCtrl.cart;
	        } catch (e) {}
	        this.CartService.addItemToCart(_product2, quantity, null, null, userId, cart).then(function (response) {
	          if (!response.error) {
	            _this5.$scope.$emit('onUpdateCart');
	            var modalInstance2 = _this5.$uibModal.open({
	              animation: true,
	              template: _modalConfirmationView2.default,
	              controller: 'ModalConfirmationController',
	              controllerAs: 'mdCtrl',
	              size: 'lg',
	              resolve: {
	                product: function product() {
	                  return _product2;
	                }
	              }
	            });
	          } else {
	            var options = {
	              title: '',
	              isHtml: true,
	              content: response.message,
	              size: '',
	              showBottonCancel: false,
	              textActionCancel: '',
	              textAction: 'Aceptar'
	            };
	            _this5.messageResponse(options);
	          }
	        }).catch(function (reason) {
	          var options = {
	            title: '',
	            isHtml: false,
	            content: reason,
	            size: '',
	            showBottonCancel: false,
	            textActionCancel: '',
	            textAction: 'Aceptar'
	          };
	          _this5.messageResponse(options);
	        });
	      }
	    }
	  }, {
	    key: 'recommendProduct',
	    value: function recommendProduct() {
	      var _this6 = this;
	
	      this.$uibModal.open({
	        animation: true,
	        template: _modalRecommendProductView2.default,
	        controller: 'ModalRecommendProductController',
	        controllerAs: 'mdCtrl',
	        size: '',
	        resolve: {
	          product: function product() {
	            return _this6.productDetail;
	          }
	        }
	      });
	    }
	  }, {
	    key: 'clonedAttributesSelected',
	    value: function clonedAttributesSelected() {
	      var _this7 = this;
	
	      this.clonedAttributesSelectedLength = 0;
	
	      console.log('clone attribute selected');
	
	      this.clonedProductPrice = '';
	      this.showProductPrice = false;
	      this.showBottomAddCart = true;
	      this.messageClonedProductPrice = '';
	
	      this.clonedFormData.forEach(function (value, key) {
	        value = value || '';
	        if (value) {
	          _this7.clonedAttributesSelectedLength++;
	        }
	      });
	
	      if (this.productDetail.clonedAttributesDetail.length === this.clonedAttributesSelectedLength) {
	        var userId = '';
	        try {
	          userId = this.shCtrl.globals.currentUser.userId;
	        } catch (e) {}
	        this.loadingClonedProductPrice = true;
	        var data = {
	          'productTemplateId': this.productTemplateCopy.id,
	          'attributes': this.clonedFormData,
	          'userId': userId
	        };
	        this.loadingClonedProductPrice = true;
	        this.showBottomAddCart = false;
	
	        this.ProductDetailService.clonedProductPrice(data).then(function (response) {
	          _this7.loadingClonedProductPrice = false;
	          _this7.showBottomAddCart = true;
	
	          if (!response.error) {
	            _this7.showProductPrice = true;
	            _this7.productDetail.currentPrice = response.data.currentPrice;
	            _this7.productDetail.discountValue = response.data.discountValue;
	            _this7.productDetail.discountPercentage = response.data.discountPercentage;
	
	            _this7.productDetail.clonedId = response.data.clonedId;
	
	            _this7.productDetail.quote = response.data.quote;
	            _this7.productDetail.textLabel = response.data.textLabel;
	            _this7.productDetail.textLabelContinue = response.data.textLabelContinue;
	            _this7.productDetail.textAction = response.data.textAction;
	
	            // Replace the template item for the real item
	            _this7.productDetail = response.data.dataItem;
	            _this7.productDetail.clonedAttributesDetail = _this7.productTemplateCopy.clonedAttributesDetail;
	            _this7.loadedItemFromTemplate = true;
	            // Restart pretty photo
	            _this7.initProductImagesViewer();
	          } else {
	            _this7.messageClonedProductPrice = 'Producto no disponible';
	            _this7.productDetail = angular.copy(_this7.productTemplateCopy);
	            _this7.loadedItemFromTemplate = false;
	
	            // Restart pretty photo
	            _this7.initProductImagesViewer();
	          }
	        }).catch(function (reason) {
	          console.log('response - error');
	          console.log(reason);
	          _this7.loadingClonedProductPrice = false;
	          alert('Error al obtener el precio del producto');
	        });
	      } else {
	        // Recover the template
	        this.productDetail = angular.copy(this.productTemplateCopy);
	        this.loadedItemFromTemplate = false;
	
	        this.productDetail.discountValue = 0;
	        this.productDetail.discountPercentage = 0;
	
	        // Restart pretty photo
	        this.initProductImagesViewer();
	      }
	      return false;
	    }
	  }, {
	    key: 'increaseProductQuantity',
	    value: function increaseProductQuantity() {
	      this.productQuantity++;
	    }
	  }, {
	    key: 'getFeaturedProducts',
	    value: function getFeaturedProducts() {
	      var _this8 = this;
	
	      var userId = '';
	      try {
	        userId = this.shCtrl.currentUser.userId;
	      } catch (e) {}
	      this.CatalogService.getFeaturedProducts(userId, 6).then(function (response) {
	        var rellenarList = [];
	        response.forEach(function (item) {
	          if (rellenarList.length === 1) {
	            rellenarList.push(item);
	            _this8.featuredProducts.push(rellenarList);
	          } else {
	            rellenarList = [];
	            rellenarList.push(item);
	          }
	        });
	        // this.featuredProducts = response;
	        _this8.initRelatedProductsCarousel();
	      }).catch(function (reason) {});
	    }
	  }, {
	    key: 'initRelatedProductsCarousel',
	    value: function initRelatedProductsCarousel() {
	      this.$timeout(function () {
	        var owlfeatured = $("#featured-items-slider");
	        owlfeatured.owlCarousel({
	          items: 1,
	          itemsDesktop: [1199, 1],
	          itemsDesktopSmall: [979, 1],
	          itemsTablet: [768, 1],
	          itemsMobile: [479, 1],
	          slideSpeed: 400,
	          autoPlay: 5000,
	          stopOnHover: true,
	          navigation: false,
	          pagination: false,
	          responsive: true,
	          mouseDrag: false,
	          autoHeight: true
	        });
	
	        // Custom Navigation Events Featured
	        $("#featured-items-slider-next").click(function () {
	          owlfeatured.trigger('owl.next');
	        });
	        $("#featured-items-slider-prev").click(function () {
	          owlfeatured.trigger('owl.prev');
	        });
	      }, 100);
	    }
	  }, {
	    key: 'decreaseProductQuantity',
	    value: function decreaseProductQuantity() {
	      if (this.productQuantity > 1) this.productQuantity--;
	    }
	  }, {
	    key: 'initProductImagesViewer',
	    value: function initProductImagesViewer() {
	      this.initPluginsProductDetails();
	      this.$timeout(function () {
	        $('#product-image-carousel-container').find('li:first-child a').mouseover();
	      }, 1000);
	    }
	  }, {
	    key: 'openVideo',
	    value: function openVideo(video) {
	      var options = {
	        video: video,
	        propertySrc: 'url'
	      };
	      this.$uibModal.open({
	        animation: true,
	        template: _modalVideoView2.default,
	        controller: 'ModalVideoController',
	        controllerAs: 'mdCtrl',
	        size: '',
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	    }
	  }, {
	    key: 'initPluginsProductDetails',
	    value: function initPluginsProductDetails() {
	      var _this9 = this;
	
	      this.$timeout(function () {
	        $('.related-slider.flexslider').flexslider({
	          animation: "slide",
	          selector: ".related-list > li",
	          controlNav: false, // false
	          prevText: '',
	          nextText: '',
	          smoothHeight: true,
	          slideshowSpeed: 7000
	        });
	        // Pretty Photo
	        $("a[data-rel^='prettyPhoto']").prettyPhoto({
	          hook: 'data-rel',
	          animation_speed: 'fast',
	          slideshow: 6000,
	          autoplay_slideshow: false,
	          show_title: false,
	          deeplinking: false,
	          social_tools: '',
	          overlay_gallery: true,
	          theme: 'light_square'
	        });
	        // Carousel
	        var carouselContainer = $('#product-carousel'),
	            productImg = $('#product-image');
	        if ($.fn.elastislide) {
	          carouselContainer.elastislide({
	            orientation: 'vertical',
	            minItems: 1
	          });
	        }
	        // Product page zoom plugin settings
	        if ($.fn.elevateZoom) {
	          productImg.elevateZoom({
	            responsive: true, // simple solution for zoom plugin down here // it can cause bugs at resize
	            zoomType: self.mobile || $(window).width() < 768 ? 'inner' : 'lens', // you can use 'inner' or 'window' // change inner and go to product.html page and see zoom plugin differances
	            borderColour: '#d0d0d0',
	            cursor: "crosshair",
	            borderSize: 2,
	            lensSize: 140,
	            lensOpacity: 1,
	            lensColour: 'rgba(255, 255, 255, 0.25)'
	          });
	          carouselContainer.find('a').on('mouseover', function (e) {
	            var ez = $('#product-image').data('elevateZoom'),
	                smallImg = $(_this9).data('image'),
	                bigImg = $(_this9).data('zoom-image');
	            ez.swaptheimage(smallImg, bigImg);
	            e.preventDefault();
	          });
	        }
	      }, 100);
	    }
	  }, {
	    key: 'messageResponse',
	    value: function messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalResponseView2.default,
	        controller: 'ModalResponseController',
	        controllerAs: 'mdCtrl',
	        size: options.size,
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        if (callAcept) {
	          callback();
	        }
	      }).catch(function (reason) {
	        if (callCancel) {
	          callbackCancel();
	        }
	      });
	    }
	  }], [{
	    key: 'clickgaleria',
	    value: function clickgaleria() {
	      //click en la imagen con lupa grande para que popup se despliegue.
	      $("#product-image-carousel-container ul li a").eq(0).trigger('click');
	    }
	  }]);
	
	  return ProductDetailController;
	}();
	
	ProductDetailController.$inject = inject;
	
	exports.default = ProductDetailController;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _productDetail = __webpack_require__(183);
	
	var _productDetail2 = _interopRequireDefault(_productDetail);
	
	var _productDetail3 = __webpack_require__(187);
	
	var _productDetail4 = _interopRequireDefault(_productDetail3);
	
	var _productDetail5 = __webpack_require__(184);
	
	var _productDetail6 = _interopRequireDefault(_productDetail5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var productDetailModule = _angular2.default.module('productDetail', []).component('productDetail', _productDetail2.default).service('ProductDetailService', _productDetail4.default).config(_productDetail6.default);
	
	exports.default = productDetailModule;

/***/ },
/* 187 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService', '$httpParamSerializerJQLike'];
	
	var ProductDetailService = function () {
	  function ProductDetailService($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService, $httpParamSerializerJQLike) {
	    _classCallCheck(this, ProductDetailService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	    this.AuthTokenFactory = AuthTokenFactory;
	    this.SharedService = SharedService;
	    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	    this.SessionService = SessionService;
	  }
	
	  _createClass(ProductDetailService, [{
	    key: 'getProductDetail',
	    value: function getProductDetail(productId, categorySlug, userId) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'GET',
	          url: _this.ngAuthSettings.apiServiceBaseUri + _this.ngAuthSettings.config.paths.product + productId + '&userId=' + userId + '&slug=' + categorySlug,
	          cache: true
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'clonedProductPrice',
	    value: function clonedProductPrice(data) {
	      var _this2 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this2.$http({
	          method: 'POST',
	          url: _this2.ngAuthSettings.apiServiceBaseUri + _this2.ngAuthSettings.config.paths.clonedProductPrice,
	          data: _this2.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getRelatedProducts',
	    value: function getRelatedProducts(productId, userId, categorySlug) {
	      var _this3 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this3.$http({
	          method: 'GET',
	          url: _this3.ngAuthSettings.apiServiceBaseUri + _this3.ngAuthSettings.config.paths.relatedProducts + productId + '&userId=' + userId + '&slug=' + categorySlug,
	          cache: true
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return ProductDetailService;
	}();
	
	ProductDetailService.$inject = inject;
	
	exports.default = ProductDetailService;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _productNotFound = __webpack_require__(190);
	
	var _productNotFound2 = _interopRequireDefault(_productNotFound);
	
	var _productNotFoundView = __webpack_require__(461);
	
	var _productNotFoundView2 = _interopRequireDefault(_productNotFoundView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductNotFoundComponent = {
	  template: _productNotFoundView2.default,
	  controller: _productNotFound2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = ProductNotFoundComponent;

/***/ },
/* 189 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.productNotFound', {
	    url: "/product-not-found/{productSearchText}",
	    template: '<product-not-found sh-ctrl="shCtrl"></product-not-found>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable angular/ng_angularelement */
	
	
	var _modalResponseView = __webpack_require__(3);
	
	var _modalResponseView2 = _interopRequireDefault(_modalResponseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'CategoryService', '$state', '$rootScope', 'SharedService', '$stateParams', '$uibModal', 'ProductNotFoundService', '$timeout', 'CatalogService', 'CartService'];
	
	var ProductNotFoundController = function () {
	  function ProductNotFoundController($scope, CategoryService, $state, $rootScope, SharedService, $stateParams, $uibModal, ProductNotFoundService, $timeout, CatalogService, CartService) {
	    _classCallCheck(this, ProductNotFoundController);
	
	    this.$state = $state;
	    this.$scope = $scope;
	    this.CatalogService = CatalogService;
	    this.ProductNotFoundService = ProductNotFoundService;
	    this.$stateParams = $stateParams;
	    this.$rootScope = $rootScope;
	    this.$uibModal = $uibModal;
	    this.CartService = CartService;
	    this.CategoryService = CategoryService;
	    this.SharedService = SharedService;
	    this.$timeout = $timeout;
	    this.productSearchText = this.$stateParams.productSearchText;
	    this.productNotFoundDataForm = {};
	    this.mailSent = false;
	  }
	
	  _createClass(ProductNotFoundController, [{
	    key: 'sendMailProductNotFound',
	    value: function sendMailProductNotFound() {
	      var _this = this;
	
	      this.productNotFoundDataForm.productSearchText = this.productSearchText;
	      this.ProductNotFoundService.mailProductNotFound(this.productNotFoundDataForm).then(function (response) {
	        if (!response.error) {
	          _this.mailSent = true;
	        } else {
	          alert(response.message);
	        }
	      }).catch(function (reason) {
	        alert('Ha ocurrido un error al enviar el mensaje');
	      });
	    }
	  }, {
	    key: 'messageResponse',
	    value: function messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalResponseView2.default,
	        controller: 'ModalResponseController',
	        controllerAs: 'mdCtrl',
	        size: options.size,
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        if (callAcept) {
	          callback();
	        }
	      }).catch(function (reason) {
	        if (callCancel) {
	          callbackCancel();
	        }
	      });
	    }
	  }]);
	
	  return ProductNotFoundController;
	}();
	
	ProductNotFoundController.$inject = inject;
	
	exports.default = ProductNotFoundController;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _productNotFound = __webpack_require__(188);
	
	var _productNotFound2 = _interopRequireDefault(_productNotFound);
	
	var _productNotFound3 = __webpack_require__(192);
	
	var _productNotFound4 = _interopRequireDefault(_productNotFound3);
	
	var _productNotFound5 = __webpack_require__(189);
	
	var _productNotFound6 = _interopRequireDefault(_productNotFound5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var productNotFoundModule = _angular2.default.module('productNotFound', []).component('productNotFound', _productNotFound2.default).service('ProductNotFoundService', _productNotFound4.default).config(_productNotFound6.default);
	
	exports.default = productNotFoundModule;

/***/ },
/* 192 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService', '$httpParamSerializerJQLike'];
	
	var ProductNotFoundService = function () {
	  function ProductNotFoundService($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService, $httpParamSerializerJQLike) {
	    _classCallCheck(this, ProductNotFoundService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	    this.AuthTokenFactory = AuthTokenFactory;
	    this.SharedService = SharedService;
	    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	    this.SessionService = SessionService;
	  }
	
	  _createClass(ProductNotFoundService, [{
	    key: 'mailProductNotFound',
	    value: function mailProductNotFound(data) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'POST',
	          url: _this.ngAuthSettings.apiServiceBaseUri + _this.ngAuthSettings.config.paths.mailProductNotFound,
	          cache: true,
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          data: _this.$httpParamSerializerJQLike(data)
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return ProductNotFoundService;
	}();
	
	ProductNotFoundService.$inject = inject;
	
	exports.default = ProductNotFoundService;

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dynamicFiltersView = __webpack_require__(462);
	
	var _dynamicFiltersView2 = _interopRequireDefault(_dynamicFiltersView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DynamicFiltersDirective() {
	  return {
	    restrict: 'E',
	    template: _dynamicFiltersView2.default
	  };
	}
	
	DynamicFiltersDirective.$inject = [];
	
	exports.default = DynamicFiltersDirective;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _dynamicFilters = __webpack_require__(193);
	
	var _dynamicFilters2 = _interopRequireDefault(_dynamicFilters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DynamicFiltersModule = _angular2.default.module('catalog.productsList.dynamicFilter', []).directive('dynamicFilters', _dynamicFilters2.default);
	
	exports.default = DynamicFiltersModule;

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _priceFilterView = __webpack_require__(463);
	
	var _priceFilterView2 = _interopRequireDefault(_priceFilterView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PriceFilterDirective() {
	  return {
	    restrict: 'E',
	    template: _priceFilterView2.default
	  };
	}
	
	PriceFilterDirective.$inject = [];
	
	exports.default = PriceFilterDirective;

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _priceFilter = __webpack_require__(195);
	
	var _priceFilter2 = _interopRequireDefault(_priceFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PriceFilterModule = _angular2.default.module('catalog.productsList.priceFilter', []).directive('priceFilter', _priceFilter2.default);
	
	exports.default = PriceFilterModule;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _productsList = __webpack_require__(198);
	
	var _productsList2 = _interopRequireDefault(_productsList);
	
	var _productsListView = __webpack_require__(464);
	
	var _productsListView2 = _interopRequireDefault(_productsListView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductsListComponent = {
	  template: _productsListView2.default,
	  controller: _productsList2.default,
	  bindings: {
	    shCtrl: '<',
	    categorySlug: "<",
	    categoryId: '<',
	    productsList: '<',
	    typeview: '<'
	  }
	};
	
	exports.default = ProductsListComponent;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modalResponseView = __webpack_require__(3);
	
	var _modalResponseView2 = _interopRequireDefault(_modalResponseView);
	
	var _modalQuantityCartView = __webpack_require__(12);
	
	var _modalQuantityCartView2 = _interopRequireDefault(_modalQuantityCartView);
	
	var _modalConfirmationView = __webpack_require__(11);
	
	var _modalConfirmationView2 = _interopRequireDefault(_modalConfirmationView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'CatalogService', 'CategoryService', '$state', '$rootScope', 'SharedService', '$stateParams', '$uibModal', 'Pagination', 'ngAuthSettings', '$timeout', 'CartService'];
	
	var ProductsListController = function () {
	  function ProductsListController($scope, CatalogService, CategoryService, $state, $rootScope, SharedService, $stateParams, $uibModal, Pagination, ngAuthSettings, $timeout, CartService) {
	    _classCallCheck(this, ProductsListController);
	
	    this.$state = $state;
	    this.$scope = $scope;
	    this.ngAuthSettings = ngAuthSettings;
	    this.Pagination = Pagination;
	    this.CatalogService = CatalogService;
	    this.$stateParams = $stateParams;
	    this.CartService = CartService;
	    this.$rootScope = $rootScope;
	    this.$uibModal = $uibModal;
	    this.CategoryService = CategoryService;
	    this.SharedService = SharedService;
	    this.$timeout = $timeout;
	    this.loanding = false;
	    this.pagerCategories = [];
	    this.itemsPerPage = 12;
	    this.loadingCategories = true;
	    this.productsToCompare = {
	      customLength: 0,
	      items: {}
	    };
	  }
	
	  _createClass(ProductsListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.$timeout(function () {
	        var maxHeight = 0;
	        var itemProduct = $(".item-product");
	        itemProduct.each(function () {
	          if ($(this).height() > maxHeight) {
	            maxHeight = $(this).height();
	          }
	        });
	        itemProduct.height(maxHeight);
	        $('.add-tooltip').tooltip();
	        $('a[data-toggle="tooltip"]').tooltip();
	      }, 1000);
	    }
	  }, {
	    key: 'setItemToAddToCart',
	    value: function setItemToAddToCart(_product) {
	      var _this = this;
	
	      _product.id = parseInt(_product.id);
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalQuantityCartView2.default,
	        controller: 'ModalQuantityCartController',
	        controllerAs: 'mdCtrl',
	        size: 'sm',
	        resolve: {
	          product: function product() {
	            return _product;
	          }
	        }
	      });
	      modalInstance.result.then(function (result) {
	        if (result.product.id && result.quantity) {
	          var userId = '',
	              cart = null;
	          try {
	            userId = _this.shCtrl.globals.currentUser.userId;
	          } catch (e) {}
	          try {
	            cart = _this.shCtrl.cart;
	          } catch (e) {}
	          _this.CartService.addItemToCart(result.product, result.quantity, null, null, userId, cart).then(function (response) {
	            if (!response.error) {
	              _this.$scope.$emit('onUpdateCart');
	              var modalInstance2 = _this.$uibModal.open({
	                animation: true,
	                template: _modalConfirmationView2.default,
	                controller: 'ModalConfirmationController',
	                controllerAs: 'mdCtrl',
	                size: 'lg',
	                resolve: {
	                  product: function product() {
	                    return _product;
	                  }
	                }
	              });
	            } else {
	              var options = {
	                title: '',
	                isHtml: false,
	                content: response.message,
	                size: '',
	                showBottonCancel: false,
	                textActionCancel: '',
	                textAction: 'Aceptar'
	              };
	              _this.messageResponse(options);
	            }
	          }).catch(function (reason) {
	            var options = {
	              title: '',
	              isHtml: false,
	              content: reason,
	              size: '',
	              showBottonCancel: false,
	              textActionCancel: '',
	              textAction: 'Aceptar'
	            };
	            _this.messageResponse(options);
	          });
	        }
	      }).catch(function (error) {});
	    }
	  }, {
	    key: 'compareProductsSelected',
	    value: function compareProductsSelected() {
	      var keys = Object.keys(this.productsToCompare.items);
	      this.$state.go('home.compare', { categoryId: this.categoryId, products: keys });
	    }
	  }, {
	    key: 'updateProductToCompare',
	    value: function updateProductToCompare(value) {
	      var keys = Object.keys(this.productsToCompare.items);
	      var indexOf = keys.indexOf(value);
	      if (indexOf !== -1) {
	
	        keys.splice(indexOf, 1);
	        var newObjectToCompare = {};
	        keys.forEach(function (val) {
	          newObjectToCompare[val] = true;
	        });
	        this.productsToCompare.items = angular.copy(newObjectToCompare);
	        this.productsToCompare.customLength = keys.length;
	      } else {
	        this.productsToCompare.items[value] = true;
	        this.productsToCompare.customLength++;
	      }
	    }
	  }, {
	    key: 'updateFavoriteProducts',
	    value: function updateFavoriteProducts(product) {
	      var _this2 = this;
	
	      product.isSettingAsFavorite = true;
	      var userId = '';
	      try {
	        userId = this.shCtrl.globals.currentUser.userId;
	      } catch (e) {}
	      if (userId) {
	        var data = {
	          'productId': product.id,
	          'userId': userId,
	          'setFavorite': !product.isFavorite
	        };
	        this.CatalogService.updateFavoriteProducts(data).then(function (response) {
	          product.isFavorite = !product.isFavorite;
	          product.isSettingAsFavorite = false;
	        }).catch(function (error) {
	          product.isSettingAsFavorite = false;
	          var options = {
	            title: '',
	            isHtml: false,
	            content: 'Ha ocurrido un error al actualizar el producto',
	            size: '',
	            showBottonCancel: false,
	            textActionCancel: '',
	            textAction: 'Aceptar'
	          };
	          _this2.messageResponse(options);
	        });
	      }
	    }
	  }, {
	    key: 'messageResponse',
	    value: function messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalResponseView2.default,
	        controller: 'ModalResponseController',
	        controllerAs: 'mdCtrl',
	        size: options.size,
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        if (callAcept) {
	          callback();
	        }
	      }).catch(function (reason) {
	        if (callCancel) {
	          callbackCancel();
	        }
	      });
	    }
	  }]);
	
	  return ProductsListController;
	}();
	
	ProductsListController.$inject = inject;
	
	exports.default = ProductsListController;

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _productsList = __webpack_require__(197);
	
	var _productsList2 = _interopRequireDefault(_productsList);
	
	var _priceFilter = __webpack_require__(196);
	
	var _priceFilter2 = _interopRequireDefault(_priceFilter);
	
	var _dynamicFilters = __webpack_require__(194);
	
	var _dynamicFilters2 = _interopRequireDefault(_dynamicFilters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var productsListModule = _angular2.default.module('productsList', [_priceFilter2.default.name, _dynamicFilters2.default.name]).component('productsList', _productsList2.default);
	
	exports.default = productsListModule;

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _relatedProducts = __webpack_require__(201);
	
	var _relatedProducts2 = _interopRequireDefault(_relatedProducts);
	
	var _relatedProductsView = __webpack_require__(465);
	
	var _relatedProductsView2 = _interopRequireDefault(_relatedProductsView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RelatedProductsComponent = {
	  template: _relatedProductsView2.default,
	  controller: _relatedProducts2.default,
	  bindings: {
	    shCtrl: '<',
	    productRelatedId: '<'
	  }
	};
	
	exports.default = RelatedProductsComponent;

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modalResponseView = __webpack_require__(3);
	
	var _modalResponseView2 = _interopRequireDefault(_modalResponseView);
	
	var _modalQuantityCartView = __webpack_require__(12);
	
	var _modalQuantityCartView2 = _interopRequireDefault(_modalQuantityCartView);
	
	var _modalConfirmationView = __webpack_require__(11);
	
	var _modalConfirmationView2 = _interopRequireDefault(_modalConfirmationView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$state', '$rootScope', 'SharedService', 'ngAuthSettings', 'CatalogService', '$uibModal', '$timeout', 'CartService'];
	
	var RelatedProductsController = function () {
	  function RelatedProductsController($scope, $state, $rootScope, SharedService, ngAuthSettings, CatalogService, $uibModal, $timeout, CartService) {
	    _classCallCheck(this, RelatedProductsController);
	
	    this.$state = $state;
	    this.$uibModal = $uibModal;
	    this.$scope = $scope;
	    this.CatalogService = CatalogService;
	    this.CartService = CartService;
	    this.$timeout = $timeout;
	    this.ngAuthSettings = ngAuthSettings;
	    this.$rootScope = $rootScope;
	    this.SharedService = SharedService;
	  }
	
	  _createClass(RelatedProductsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getRelatedProducts();
	    }
	  }, {
	    key: 'getRelatedProducts',
	    value: function getRelatedProducts() {
	      var _this = this;
	
	      var userId = '';
	      try {
	        userId = this.shCtrl.currentUser.userId;
	      } catch (e) {}
	      this.CatalogService.getRelatedProducts(this.productRelatedId, userId, 10).then(function (response) {
	        _this.relatedProducts = response;
	        _this.initRelatedProductsCarousel();
	        _this.loadingRelatedProducts = false;
	      }).catch(function (error) {});
	    }
	  }, {
	    key: 'initRelatedProductsCarousel',
	    value: function initRelatedProductsCarousel() {
	      this.$timeout(function () {
	        var purchasedItems = $('.related-items-slider.owl-carousel');
	        purchasedItems.owlCarousel({
	          items: 4,
	          itemsDesktop: [1199, 3],
	          itemsDesktopSmall: [979, 2],
	          itemsTablet: [768, 2],
	          itemsMobile: [479, 1],
	          slideSpeed: 400,
	          autoPlay: 8000,
	          stopOnHover: true,
	          navigation: false,
	          pagination: false,
	          responsive: true,
	          mouseDrag: false,
	          autoHeight: true
	        }).data('navigationBtns', ['#related-items-slider-prev', '#related-items-slider-next']);
	        purchasedItems.each(function () {
	          var $this = $(this),
	              owlCarousel = $this.data('owlCarousel'),
	              owlBtns = $this.data('navigationBtns'),
	              prevBtn = void 0,
	              nextBtn = void 0;
	
	          if (typeof owlCarousel === 'undefined' || typeof owlBtns === 'undefined') {
	            return;
	          }
	
	          for (var key in owlBtns) {
	            if (owlBtns[key].indexOf('next') === -1) {
	              prevBtn = $(owlBtns[key]);
	            } else {
	              nextBtn = $(owlBtns[key]);
	            }
	          }
	
	          prevBtn.on('click touchstart', function (e) {
	            owlCarousel.prev();
	            e.preventDefault();
	          });
	
	          nextBtn.on('click touchstart', function (e) {
	            owlCarousel.next();
	            e.preventDefault();
	          });
	        });
	
	        $('.add-tooltip').tooltip();
	      }, 1000);
	    }
	  }, {
	    key: 'setItemToAddToCart',
	    value: function setItemToAddToCart(_product) {
	      var _this2 = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalQuantityCartView2.default,
	        controller: 'ModalQuantityCartController',
	        controllerAs: 'mdCtrl',
	        size: 'sm',
	        resolve: {
	          product: function product() {
	            return _product;
	          }
	        }
	      });
	      modalInstance.result.then(function (result) {
	        if (result.product.id && result.quantity) {
	          var userId = '',
	              cart = null;
	          try {
	            userId = _this2.shCtrl.globals.currentUser.userId;
	          } catch (e) {}
	          try {
	            cart = _this2.shCtrl.cart;
	          } catch (e) {}
	          _this2.CartService.addItemToCart(result.product, result.quantity, null, null, userId, cart).then(function (response) {
	            if (!response.error) {
	              _this2.$scope.$emit('onUpdateCart');
	              var modalInstance2 = _this2.$uibModal.open({
	                animation: true,
	                template: _modalConfirmationView2.default,
	                controller: 'ModalConfirmationController',
	                controllerAs: 'mdCtrl',
	                size: 'lg',
	                resolve: {
	                  product: function product() {
	                    return _product;
	                  }
	                }
	              });
	            } else {
	              var options = {
	                title: '',
	                isHtml: true,
	                content: response.message,
	                size: '',
	                showBottonCancel: false,
	                textActionCancel: '',
	                textAction: 'Aceptar'
	              };
	              _this2.messageResponse(options);
	            }
	          }).catch(function (reason) {
	            var options = {
	              title: '',
	              isHtml: true,
	              content: reason,
	              size: '',
	              showBottonCancel: false,
	              textActionCancel: '',
	              textAction: 'Aceptar'
	            };
	            _this2.messageResponse(options);
	          });
	        }
	      }).catch(function (error) {});
	    }
	  }, {
	    key: 'updateFavoriteProducts',
	    value: function updateFavoriteProducts(product) {
	      var _this3 = this;
	
	      product.isSettingAsFavorite = true;
	      var userId = '';
	      try {
	        userId = this.shCtrl.globals.currentUser.userId;
	      } catch (e) {}
	      if (userId) {
	        var data = {
	          'productId': product.id,
	          'userId': userId,
	          'setFavorite': !product.isFavorite
	        };
	        this.CatalogService.updateFavoriteProducts(data).then(function (response) {
	          product.isFavorite = !product.isFavorite;
	          product.isSettingAsFavorite = false;
	        }).catch(function (error) {
	          product.isSettingAsFavorite = false;
	          var options = {
	            title: '',
	            isHtml: false,
	            content: 'Ha ocurrido un error al actualizar el producto',
	            size: '',
	            showBottonCancel: false,
	            textActionCancel: '',
	            textAction: 'Aceptar'
	          };
	          _this3.messageResponse(options);
	        });
	      }
	    }
	  }, {
	    key: 'messageResponse',
	    value: function messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalResponseView2.default,
	        controller: 'ModalResponseController',
	        controllerAs: 'mdCtrl',
	        size: options.size,
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        if (callAcept) {
	          callback();
	        }
	      }).catch(function (reason) {
	        if (callCancel) {
	          callbackCancel();
	        }
	      });
	    }
	  }]);
	
	  return RelatedProductsController;
	}();
	
	RelatedProductsController.$inject = inject;
	
	exports.default = RelatedProductsController;

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _relatedProducts = __webpack_require__(200);
	
	var _relatedProducts2 = _interopRequireDefault(_relatedProducts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RelatedProductsModule = _angular2.default.module('catalog.relatedProducts', []).component('relatedProducts', _relatedProducts2.default);
	
	exports.default = RelatedProductsModule;

/***/ },
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _consultCrm = __webpack_require__(209);
	
	var _consultCrm2 = _interopRequireDefault(_consultCrm);
	
	var _consultCrmView = __webpack_require__(467);
	
	var _consultCrmView2 = _interopRequireDefault(_consultCrmView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConsultCrmComponent = {
	  template: _consultCrmView2.default,
	  controller: _consultCrm2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = ConsultCrmComponent;

/***/ },
/* 208 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.consultCrm', {
	    url: "/consultas",
	    template: '<consult-crm sh-ctrl="shCtrl"></consult-crm>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modalResponseView = __webpack_require__(3);
	
	var _modalResponseView2 = _interopRequireDefault(_modalResponseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'DetailZoneService', '$state', '$rootScope', 'SharedService', '$uibModal', 'DetailedPaymentService', 'SessionService'];
	
	var ConsultCrmController = function () {
	  // constructor ($scope, DetailZoneService, $state, $rootScope, SharedService, $uibModal, DetailedPaymentService, AdvanceService) {
	  function ConsultCrmController($scope, DetailZoneService, $state, $rootScope, SharedService, $uibModal, DetailedPaymentService, SessionService) {
	    _classCallCheck(this, ConsultCrmController);
	
	    this.$state = $state;
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	    this.DetailedPaymentService = DetailedPaymentService;
	    this.SessionService = SessionService;
	    // this.AdvanceService = AdvanceService;
	    this.$uibModal = $uibModal;
	    this.DetailZoneService = DetailZoneService;
	    this.SharedService = SharedService;
	    this.loanding = false;
	    this.plant = [];
	    this.concepts = [];
	    this.advance = {};
	    this.conceptSelected = null;
	    this.openModal = false;
	    this.conceptSelected = 2;
	    this.payment = {};
	  }
	
	  _createClass(ConsultCrmController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.shCtrl.activate();
	      this.tab = 1;
	
	      this.shCtrl.globals.currentUser.activeTap = 0;
	      this.getDatas();
	      this.copy();
	
	      //this.getBillfold();
	    }
	  }, {
	    key: 'getDatas',
	    value: function getDatas() {
	      if (angular.isUndefined(this.shCtrl.globals.currentUser.payCart)) {
	        this.dataGlobals = this.shCtrl.globals;
	        this.dataGlobals.currentUser.payCart = [];
	        this.dataGlobals.currentUser.totalCartPay = null;
	        this.SessionService.put('globals', this.dataGlobals);
	      }
	    }
	  }, {
	    key: 'messageResponse',
	    value: function messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalResponseView2.default,
	        controller: 'ModalResponseController',
	        controllerAs: 'mdCtrl',
	        size: options.size,
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        if (callAcept) {
	          callback();
	        }
	      }).catch(function (reason) {
	        if (callCancel) {
	          callbackCancel();
	        }
	      });
	    }
	  }, {
	    key: 'copy',
	    value: function copy() {
	      angular.copy(this.shCtrl.globals.currentUser, this.shCtrl.globals.currentClient);
	    }
	  }]);
	
	  return ConsultCrmController;
	}();
	
	ConsultCrmController.$inject = inject;
	
	exports.default = ConsultCrmController;

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _specificActList = __webpack_require__(239);
	
	var _specificActList2 = _interopRequireDefault(_specificActList);
	
	var _routinesList = __webpack_require__(234);
	
	var _routinesList2 = _interopRequireDefault(_routinesList);
	
	var _routinesDetail = __webpack_require__(229);
	
	var _routinesDetail2 = _interopRequireDefault(_routinesDetail);
	
	var _proceedingsList = __webpack_require__(224);
	
	var _proceedingsList2 = _interopRequireDefault(_proceedingsList);
	
	var _documentsList = __webpack_require__(214);
	
	var _documentsList2 = _interopRequireDefault(_documentsList);
	
	var _pqrsList = __webpack_require__(219);
	
	var _pqrsList2 = _interopRequireDefault(_pqrsList);
	
	var _taskList = __webpack_require__(244);
	
	var _taskList2 = _interopRequireDefault(_taskList);
	
	var _consultCrmComponent = __webpack_require__(207);
	
	var _consultCrmComponent2 = _interopRequireDefault(_consultCrmComponent);
	
	var _consultCrmConfig = __webpack_require__(208);
	
	var _consultCrmConfig2 = _interopRequireDefault(_consultCrmConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consultCrmModule = _angular2.default.module('app.consultCrm', [_specificActList2.default.name, _routinesList2.default.name, _routinesDetail2.default.name, _proceedingsList2.default.name, _documentsList2.default.name, _pqrsList2.default.name, _taskList2.default.name]).component("consultCrm", _consultCrmComponent2.default).config(_consultCrmConfig2.default);
	
	exports.default = consultCrmModule;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _documentsList = __webpack_require__(213);
	
	var _documentsList2 = _interopRequireDefault(_documentsList);
	
	var _documentsListView = __webpack_require__(468);
	
	var _documentsListView2 = _interopRequireDefault(_documentsListView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DocumentsListComponent = {
	  template: _documentsListView2.default,
	  controller: _documentsList2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = DocumentsListComponent;

/***/ },
/* 212 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.documentsList', {
	    url: "/consultas/documentos",
	    template: '<documents-list sh-ctrl="shCtrl"></documents-list>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 213 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'documentsListService', '$state', '$rootScope', '$timeout', 'SessionService'];
	
	var DocumentsListController = function () {
		function DocumentsListController($scope, documentsListService, $state, $rootScope, $timeout, SessionService) {
			_classCallCheck(this, DocumentsListController);
	
			this.$state = $state;
			this.$scope = $scope;
			this.$timeout = $timeout;
			this.$rootScope = $rootScope;
			this.documentsListService = documentsListService;
			this.activities = [];
			this.SessionService = SessionService;
		}
	
		_createClass(DocumentsListController, [{
			key: '$onInit',
			value: function $onInit() {
				this.shCtrl.activate();
				this.order = 'date_entered';
				this.desc = true;
				this.sucursales = this.shCtrl.globals.currentUser.sucursales;
				this.userId = this.shCtrl.globals.currentUser.userId;
				this.sessionId = this.shCtrl.globals.currentUser.sessionCrm;
				this.filter = {};
				this.cacheFilter = {
					firtsConsulta: true
				};
	
				this.currentPage = 1;
				this.currentPageCache = 0;
				this.getActivities();
	
				this.totalItems = 0;
				this.totalPages = 1;
	
				this.detalle = {};
	
				this.ultimaActualizacion = '';
			}
		}, {
			key: 'orderBy',
			value: function orderBy(name) {
				if (this.order == name) {
					this.desc = !this.desc;
				} else {
					this.order = name;
					this.desc = true;
				}
	
				this.getActivities(true);
			}
		}, {
			key: 'getActivities',
			value: function getActivities() {
				var _this = this;
	
				var ordenar = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
				if (!angular.equals(this.filter, this.cacheFilter) || this.currentPage != this.currentPageCache || ordenar) {
					this.currentPageCache = angular.copy(this.currentPage);
					this.cacheFilter = angular.copy(this.filter);
					this.loading = true;
					this.error = false;
					this.errorMsg = '';
	
					this.data = {
						'userId': this.userId,
						'pageNumber': this.currentPage ? this.currentPage : 1,
						'pageSize': 20,
						'filter': this.filter,
						'consulta': 'documentos',
						'sessionId': this.sessionId,
						'sucursales': this.sucursales,
						'order': this.order,
						'desc': this.desc
					};
	
					this.documentsListService.getActivitiesData(this.data).then(function (response) {
						_this.loading = false;
	
						if (response.error) {
							_this.error = true;
							_this.errorMsg = response.mensaje;
						} else {
							// Renombra la session crm en caso de que el servidor se la cambie
							if (response.sessionCrm) {
								var currentUser = _this.SessionService.get('currentUser');
								currentUser.sessionCrm = response.sessionCrm;
								_this.sessionId = response.sessionCrm;
								_this.SessionService.put('currentUser', currentUser);
								_this.shCtrl.globals.currentUser.sessionCrm = response.sessionCrm;
							}
							_this.activities = response.actividades;
							_this.totalItems = response.totalItems;
							_this.totalPages = response.totalPage;
							_this.ultimaActualizacion = response.ultimaActualizacion;
	
							/*this.activities.forEach((value,key)=>{
	      	value.description = this.decodeEntities(value.description);
	      });*/
						}
						if ((_this.error || !_this.activities.length) && _this.errorMsg == '') {
							_this.errorMsg = 'No se han encontrado registros que coincidan con los filtros seleccionados';
						}
					}).catch(function (reason) {
						_this.loading = false;
						_this.error = true;
						if (_this.error && _this.errorMsg == '') {
							_this.errorMsg = 'No se han encontrado registros que coincidan con los filtros seleccionados';
						}
					});
				}
			}
		}, {
			key: 'exportarXls',
			value: function exportarXls() {
				var _this2 = this;
	
				this.exportLoading = true;
	
				var data = {
					'pageNumber': 1,
					'pageSize': this.totalItems,
					'userId': this.userId,
					'filter': this.filter,
					'consulta': 'documentos',
					'sessionId': this.sessionId,
					'sucursales': this.sucursales,
					'order': this.order,
					'desc': this.desc
				};
				this.documentsListService.exportarXls(data).then(function (response) {
					// Renombra la session crm en caso de que el servidor se la cambie
					if (response.sessionCrm) {
						var currentUser = _this2.SessionService.get('currentUser');
						currentUser.sessionCrm = response.sessionCrm;
						_this2.sessionId = data.sessionCrm;
						_this2.SessionService.put('currentUser', currentUser);
						_this2.shCtrl.globals.currentUser.sessionCrm = response.sessionCrm;
					}
	
					_this2.exportLoading = false;
					var ruta = response.split('/');
	
					var link = document.getElementById("labelprueba");
					link.setAttribute("href", response);
					link.setAttribute("download", ruta[ruta.length - 1]);
					link.click();
				}).catch(function (reason) {
					$this.exportLoading = false;
				});
			}
		}, {
			key: 'descargarDocumento',
			value: function descargarDocumento(id, nombre) {
				var _this3 = this;
	
				this.exportLoading = true;
	
				var data = {
					'userId': this.userId,
					'tipoDoc': 'documento',
					'id': id,
					'nombreDocumento': nombre
				};
				this.documentsListService.descargarDocumento(data).then(function (response) {
	
					_this3.exportLoading = false;
					var ruta = response.split('/');
	
					var link = document.getElementById("labelprueba");
					link.setAttribute("href", response);
					link.setAttribute("download", ruta[ruta.length - 1]);
					link.click();
				}).catch(function (reason) {
					$this.exportLoading = false;
				});
			}
		}]);
	
		return DocumentsListController;
	}();
	
	DocumentsListController.$inject = inject;
	
	exports.default = DocumentsListController;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _documentsList = __webpack_require__(211);
	
	var _documentsList2 = _interopRequireDefault(_documentsList);
	
	var _documentsList3 = __webpack_require__(215);
	
	var _documentsList4 = _interopRequireDefault(_documentsList3);
	
	var _documentsList5 = __webpack_require__(212);
	
	var _documentsList6 = _interopRequireDefault(_documentsList5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var documentsListModule = _angular2.default.module('app.documentsList', []).component('documentsList', _documentsList2.default).service('documentsListService', _documentsList4.default).config(_documentsList6.default);
	
	exports.default = documentsListModule;

/***/ },
/* 215 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var documentsListService = function () {
	  function documentsListService($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
	    _classCallCheck(this, documentsListService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	  }
	
	  _createClass(documentsListService, [{
	    key: 'getActivitiesData',
	    value: function getActivitiesData(data) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'POST',
	          url: _this.ngAuthSettings.apiServiceBaseUri + '/opalo/opalo/consulta',
	          data: _this.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'exportarXls',
	    value: function exportarXls(data) {
	      var _this2 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this2.$http({
	          method: 'POST',
	          url: _this2.ngAuthSettings.apiServiceBaseUri + '/opalo/opalo/exportar-datos-csv',
	          data: _this2.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'descargarDocumento',
	    value: function descargarDocumento(data) {
	      var _this3 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this3.$http({
	          method: 'POST',
	          url: _this3.ngAuthSettings.apiServiceBaseUri + '/opalo/opalo/descarga-documento',
	          data: _this3.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return documentsListService;
	}();
	
	documentsListService.$inject = ['$q', '$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];
	
	exports.default = documentsListService;

/***/ },
/* 216 */
[547, 218, 469],
/* 217 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.pqrsList', {
	    url: "/consultas/pqrs",
	    template: '<pqrs-list sh-ctrl="shCtrl"></pqrs-list>',
	    params: {
	      id: null
	    }
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 218 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'pqrsListService', '$state', '$rootScope', '$timeout', 'SessionService', '$stateParams'];
	
	var PqrsListController = function () {
		function PqrsListController($scope, pqrsListService, $state, $rootScope, $timeout, SessionService, $stateParams) {
			_classCallCheck(this, PqrsListController);
	
			this.$state = $state;
			this.$scope = $scope;
			this.$timeout = $timeout;
			this.$rootScope = $rootScope;
			this.pqrsListService = pqrsListService;
			this.activities = [];
			this.SessionService = SessionService;
			this.$stateParams = $stateParams;
		}
	
		_createClass(PqrsListController, [{
			key: '$onInit',
			value: function $onInit() {
				this.shCtrl.activate();
				this.order = 'date_entered';
				this.desc = true;
				this.sucursales = this.shCtrl.globals.currentUser.sucursales;
				this.userId = this.shCtrl.globals.currentUser.userId;
				this.sessionId = this.shCtrl.globals.currentUser.sessionCrm;
				this.filter = {};
				this.cacheFilter = {
					firtsConsulta: true
				};
	
				this.currentPage = 1;
				this.currentPageCache = 0;
				this.getActivities();
	
				this.totalItems = 0;
				this.totalPages = 1;
	
				if (this.$stateParams.id) {
					this.detalle = { id: this.$stateParams.id };
				} else {
					this.detalle = {};
				}
	
				this.ultimaActualizacion = '';
			}
		}, {
			key: 'orderBy',
			value: function orderBy(name) {
				if (this.order == name) {
					this.desc = !this.desc;
				} else {
					this.order = name;
					this.desc = true;
				}
	
				this.getActivities(true);
			}
		}, {
			key: 'getActivities',
			value: function getActivities() {
				var _this = this;
	
				var ordenar = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
				if (!angular.equals(this.filter, this.cacheFilter) || this.currentPage != this.currentPageCache || ordenar) {
					this.currentPageCache = angular.copy(this.currentPage);
					this.cacheFilter = angular.copy(this.filter);
					this.loading = true;
					this.error = false;
					this.errorMsg = '';
	
					this.data = {
						'userId': this.userId,
						'pageNumber': this.currentPage ? this.currentPage : 1,
						'pageSize': 20,
						'filter': this.filter,
						'consulta': 'pqrs',
						'order': this.order,
						'desc': this.desc
					};
	
					this.pqrsListService.getActivitiesData(this.data).then(function (response) {
						_this.loading = false;
	
						if (response.error) {
							_this.error = true;
							_this.errorMsg = response.mensaje;
						} else {
							_this.activities = response.actividades;
							_this.totalItems = response.totalItems;
							_this.totalPages = response.totalPage;
							_this.ultimaActualizacion = response.ultimaActualizacion;
	
							/*this.activities.forEach((value,key)=>{
	      	value.description = this.decodeEntities(value.description);
	      });*/
						}
						if ((_this.error || !_this.activities.length) && _this.errorMsg == '') {
							_this.errorMsg = 'No se han encontrado registros que coincidan con los filtros seleccionados';
						}
					}).catch(function (reason) {
						_this.loading = false;
						_this.error = true;
						if (_this.error && _this.errorMsg == '') {
							_this.errorMsg = 'No se han encontrado registros que coincidan con los filtros seleccionados';
						}
					});
				}
			}
		}, {
			key: 'exportarXls',
			value: function exportarXls() {
				var _this2 = this;
	
				this.exportLoading = true;
	
				var data = {
					'pageNumber': 1,
					'pageSize': this.totalItems,
					'userId': this.userId,
					'filter': this.filter,
					'consulta': 'pqrs',
					'order': this.order,
					'desc': this.desc
				};
				this.pqrsListService.exportarXls(data).then(function (response) {
	
					_this2.exportLoading = false;
					var ruta = response.split('/');
	
					var link = document.getElementById("labelprueba");
					link.setAttribute("href", response);
					link.setAttribute("download", ruta[ruta.length - 1]);
					link.click();
				}).catch(function (reason) {
					$this.exportLoading = false;
				});
			}
		}, {
			key: 'exportarPdf',
			value: function exportarPdf() {
				var _this3 = this;
	
				this.exportLoading = true;
	
				var data = {
					'pageNumber': 1,
					'pageSize': this.totalItems,
					'userId': this.userId,
					'filter': this.filter,
					'consulta': 'pqrs',
					'id': this.detalle.id,
					'order': this.order,
					'desc': this.desc
				};
				this.pqrsListService.exportarPdf(data).then(function (response) {
	
					_this3.exportLoading = false;
					var ruta = response.split('/');
	
					var link = document.getElementById("labelprueba");
					link.setAttribute("href", response);
					link.setAttribute("download", ruta[ruta.length - 1]);
					link.click();
				}).catch(function (reason) {
					$this.exportLoading = false;
				});
			}
		}]);
	
		return PqrsListController;
	}();
	
	PqrsListController.$inject = inject;
	
	exports.default = PqrsListController;

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _pqrsList = __webpack_require__(216);
	
	var _pqrsList2 = _interopRequireDefault(_pqrsList);
	
	var _pqrsList3 = __webpack_require__(220);
	
	var _pqrsList4 = _interopRequireDefault(_pqrsList3);
	
	var _pqrsList5 = __webpack_require__(217);
	
	var _pqrsList6 = _interopRequireDefault(_pqrsList5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pqrsListModule = _angular2.default.module('app.pqrsList', []).component('pqrsList', _pqrsList2.default).service('pqrsListService', _pqrsList4.default).config(_pqrsList6.default);
	
	exports.default = pqrsListModule;

/***/ },
/* 220 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var pqrsListService = function () {
	  function pqrsListService($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
	    _classCallCheck(this, pqrsListService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	  }
	
	  _createClass(pqrsListService, [{
	    key: 'getActivitiesData',
	    value: function getActivitiesData(data) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'POST',
	          url: _this.ngAuthSettings.apiServiceBaseUri + '/opalo/opalo/consulta',
	          data: _this.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'exportarXls',
	    value: function exportarXls(data) {
	      var _this2 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this2.$http({
	          method: 'POST',
	          url: _this2.ngAuthSettings.apiServiceBaseUri + '/opalo/opalo/exportar-datos-csv',
	          data: _this2.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'exportarPdf',
	    value: function exportarPdf(data) {
	      var _this3 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this3.$http({
	          method: 'POST',
	          url: _this3.ngAuthSettings.apiServiceBaseUri + '/opalo/opalo/exportar-datos-pdf',
	          data: _this3.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return pqrsListService;
	}();
	
	pqrsListService.$inject = ['$q', '$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];
	
	exports.default = pqrsListService;

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _proceedingsList = __webpack_require__(223);
	
	var _proceedingsList2 = _interopRequireDefault(_proceedingsList);
	
	var _proceedingsListView = __webpack_require__(470);
	
	var _proceedingsListView2 = _interopRequireDefault(_proceedingsListView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProceedingsListComponent = {
	  template: _proceedingsListView2.default,
	  controller: _proceedingsList2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = ProceedingsListComponent;

/***/ },
/* 222 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.proceedingsList', {
	    url: "/consultas/actas",
	    template: '<proceedings-list sh-ctrl="shCtrl"></proceedings-list>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 223 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'proceedingsListService', '$state', '$rootScope', '$timeout', 'SessionService'];
	
	var ProceedingsListController = function () {
		function ProceedingsListController($scope, proceedingsListService, $state, $rootScope, $timeout, SessionService) {
			_classCallCheck(this, ProceedingsListController);
	
			this.$state = $state;
			this.$scope = $scope;
			this.$timeout = $timeout;
			this.$rootScope = $rootScope;
			this.proceedingsListService = proceedingsListService;
			this.activities = [];
			this.SessionService = SessionService;
		}
	
		_createClass(ProceedingsListController, [{
			key: '$onInit',
			value: function $onInit() {
				this.shCtrl.activate();
				this.order = 'date_entered';
				this.desc = true;
				this.sucursales = this.shCtrl.globals.currentUser.sucursales;
				this.userId = this.shCtrl.globals.currentUser.userId;
				this.sessionId = this.shCtrl.globals.currentUser.sessionCrm;
				this.filter = {};
				this.cacheFilter = {
					firtsConsulta: true
				};
	
				this.currentPage = 1;
				this.currentPageCache = 0;
				this.getActivities();
	
				this.totalItems = 0;
				this.totalPages = 1;
	
				this.detalle = {};
	
				this.sucursales = {};
	
				this.ultimaActualizacion = '';
			}
		}, {
			key: 'orderBy',
			value: function orderBy(name) {
				if (this.order == name) {
					this.desc = !this.desc;
				} else {
					this.order = name;
					this.desc = true;
				}
	
				this.getActivities(true);
			}
		}, {
			key: 'getActivities',
			value: function getActivities() {
				var _this = this;
	
				var ordenar = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
				if (!angular.equals(this.filter, this.cacheFilter) || this.currentPage != this.currentPageCache || ordenar) {
					this.currentPageCache = angular.copy(this.currentPage);
					this.cacheFilter = angular.copy(this.filter);
					this.loading = true;
					this.error = false;
					this.errorMsg = '';
	
					this.data = {
						'userId': this.userId,
						'pageNumber': this.currentPage ? this.currentPage : 1,
						'pageSize': 20,
						'filter': this.filter,
						'consulta': 'actas',
						'order': this.order,
						'desc': this.desc
					};
	
					this.proceedingsListService.getActivitiesData(this.data).then(function (response) {
						_this.loading = false;
	
						if (response.error) {
							_this.error = true;
							_this.errorMsg = response.mensaje;
						} else {
							_this.activities = response.actividades;
							_this.totalItems = response.totalItems;
							_this.totalPages = response.totalPage;
							_this.sucursales = response.sucursales;
	
							_this.ultimaActualizacion = response.ultimaActualizacion;
	
							/*this.activities.forEach((value,key)=>{
	      	value.description = this.decodeEntities(value.description);
	      });*/
						}
						if ((_this.error || !_this.activities.length) && _this.errorMsg == '') {
							_this.errorMsg = 'No se han encontrado registros que coincidan con los filtros seleccionados';
						}
					}).catch(function (reason) {
						_this.loading = false;
						_this.error = true;
						if (_this.error && _this.errorMsg == '') {
							_this.errorMsg = 'No se han encontrado registros que coincidan con los filtros seleccionados';
						}
					});
				}
			}
		}, {
			key: 'exportarXls',
			value: function exportarXls() {
				var _this2 = this;
	
				this.exportLoading = true;
	
				var data = {
					'pageNumber': 1,
					'pageSize': this.totalItems,
					'userId': this.userId,
					'filter': this.filter,
					'consulta': 'actas',
					'order': this.order,
					'desc': this.desc
				};
				this.proceedingsListService.exportarXls(data).then(function (response) {
	
					_this2.exportLoading = false;
					var ruta = response.split('/');
	
					var link = document.getElementById("labelprueba");
					link.setAttribute("href", response);
					link.setAttribute("download", ruta[ruta.length - 1]);
					link.click();
				}).catch(function (reason) {
					$this.exportLoading = false;
				});
			}
		}, {
			key: 'exportarPdf',
			value: function exportarPdf() {
				var _this3 = this;
	
				this.exportLoading = true;
	
				var data = {
					'userId': this.userId,
					'tipoDoc': 'actas',
					'id': this.detalle.referencia,
					'nombreDocumento': this.detalle.rut
				};
				this.proceedingsListService.exportarPdf(data).then(function (response) {
	
					_this3.exportLoading = false;
					var ruta = response.split('/');
	
					var link = document.getElementById("labelprueba");
					link.setAttribute("href", response);
					link.setAttribute("download", ruta[ruta.length - 1]);
					link.click();
				}).catch(function (reason) {
					$this.exportLoading = false;
				});
			}
		}]);
	
		return ProceedingsListController;
	}();
	
	ProceedingsListController.$inject = inject;
	
	exports.default = ProceedingsListController;

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _proceedingsList = __webpack_require__(221);
	
	var _proceedingsList2 = _interopRequireDefault(_proceedingsList);
	
	var _proceedingsList3 = __webpack_require__(225);
	
	var _proceedingsList4 = _interopRequireDefault(_proceedingsList3);
	
	var _proceedingsList5 = __webpack_require__(222);
	
	var _proceedingsList6 = _interopRequireDefault(_proceedingsList5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var proceedingsListModule = _angular2.default.module('app.proceedingsList', []).component('proceedingsList', _proceedingsList2.default).service('proceedingsListService', _proceedingsList4.default).config(_proceedingsList6.default);
	
	exports.default = proceedingsListModule;

/***/ },
/* 225 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var proceedingsListService = function () {
	  function proceedingsListService($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
	    _classCallCheck(this, proceedingsListService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	  }
	
	  _createClass(proceedingsListService, [{
	    key: 'getActivitiesData',
	    value: function getActivitiesData(data) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'POST',
	          url: _this.ngAuthSettings.apiServiceBaseUri + '/opalo/opalo/consulta',
	          data: _this.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'exportarXls',
	    value: function exportarXls(data) {
	      var _this2 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this2.$http({
	          method: 'POST',
	          url: _this2.ngAuthSettings.apiServiceBaseUri + '/opalo/opalo/exportar-datos-csv',
	          data: _this2.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'exportarPdf',
	    value: function exportarPdf(data) {
	      var _this3 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this3.$http({
	          method: 'POST',
	          url: _this3.ngAuthSettings.apiServiceBaseUri + '/opalo/opalo/descarga-documento',
	          data: _this3.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return proceedingsListService;
	}();
	
	proceedingsListService.$inject = ['$q', '$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];
	
	exports.default = proceedingsListService;

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routinesDetail = __webpack_require__(228);
	
	var _routinesDetail2 = _interopRequireDefault(_routinesDetail);
	
	var _routinesDetailView = __webpack_require__(471);
	
	var _routinesDetailView2 = _interopRequireDefault(_routinesDetailView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RoutinesDetailComponent = {
	  template: _routinesDetailView2.default,
	  controller: _routinesDetail2.default,
	  bindings: {
	    shCtrl: '<',
	    id: '=',
	    rut: '<'
	  }
	};
	
	exports.default = RoutinesDetailComponent;

/***/ },
/* 227 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.routinesDetail', {
	    url: "/consultas/detalle-rutinas/{id}",
	    template: '<routines-detail sh-ctrl="shCtrl" id="id"></routines-detail>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 228 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'routinesDetailService', '$state', '$rootScope', '$timeout', 'SessionService'];
	
	var RoutinesDetailController = function () {
		function RoutinesDetailController($scope, routinesDetailService, $state, $rootScope, $timeout, SessionService) {
			_classCallCheck(this, RoutinesDetailController);
	
			this.$state = $state;
			this.$scope = $scope;
			this.$timeout = $timeout;
			this.$rootScope = $rootScope;
			this.routinesDetailService = routinesDetailService;
			this.activities = [];
			this.SessionService = SessionService;
		}
	
		_createClass(RoutinesDetailController, [{
			key: '$onInit',
			value: function $onInit() {
				this.shCtrl.activate();
				this.userId = this.shCtrl.globals.currentUser.userId;
				this.filter = {};
				this.cacheFilter = {
					firtsConsulta: true
				};
	
				this.currentPage = 1;
				this.currentPageCache = 0;
				this.getActivities();
	
				this.totalItems = 0;
				this.totalPages = 1;
	
				this.ultimaActualizacion = '';
			}
		}, {
			key: 'getActivities',
			value: function getActivities() {
				var _this = this;
	
				if (!angular.equals(this.filter, this.cacheFilter) || this.currentPage != this.currentPageCache) {
					this.currentPageCache = angular.copy(this.currentPage);
					this.cacheFilter = angular.copy(this.filter);
					this.loading = true;
					this.error = false;
					this.errorMsg = '';
	
					this.data = {
						'userId': this.userId,
						'pageNumber': this.currentPage ? this.currentPage : 1,
						'pageSize': 20,
						'filter': this.filter,
						'consulta': 'detalleRutina',
						'id': this.id
					};
	
					this.routinesDetailService.getActivitiesData(this.data).then(function (response) {
						_this.loading = false;
	
						if (response.error) {
							_this.error = true;
							_this.errorMsg = response.mensaje;
						} else {
							_this.activities = response.actividades;
							_this.totalItems = response.totalItems;
							_this.totalPages = response.totalPage;
							_this.ultimaActualizacion = response.ultimaActualizacion;
						}
						if ((_this.error || !_this.activities.length) && _this.errorMsg == '') {
							_this.errorMsg = 'No se han encontrado registros que coincidan con los filtros seleccionados';
						}
					}).catch(function (reason) {
						_this.loading = false;
						_this.error = true;
	
						if (_this.error && _this.errorMsg == '') {
							_this.errorMsg = 'No se han encontrado registros que coincidan con los filtros seleccionados';
						}
					});
				}
			}
		}, {
			key: 'exportarXls',
			value: function exportarXls(id) {
				var _this2 = this;
	
				this.exportLoading2 = true;
	
				var data = {
					'pageNumber': 1,
					'pageSize': this.totalItems,
					'userId': this.userId,
					'consulta': 'detalleRutina',
					'filter': this.filter,
					'id': this.id,
					'rut': this.rut
				};
				this.routinesDetailService.exportarXls(data).then(function (response) {
	
					_this2.exportLoading2 = false;
					var ruta = response.split('/');
	
					var link = document.getElementById("labelprueba");
					link.setAttribute("href", response);
					link.setAttribute("download", ruta[ruta.length - 1]);
					link.click();
				}).catch(function (reason) {
					$this.exportLoading2 = false;
				});
			}
		}, {
			key: 'exportarPdf',
			value: function exportarPdf() {
				var _this3 = this;
	
				this.exportLoading = true;
	
				var data = {
					'userId': this.userId,
					'tipoDoc': 'detalleRutina',
					'id': this.id,
					'nombreDocumento': this.rut
				};
				this.routinesDetailService.exportarPdf(data).then(function (response) {
	
					_this3.exportLoading = false;
					var ruta = response.split('/');
	
					var link = document.getElementById("labelprueba");
					link.setAttribute("href", response);
					link.setAttribute("download", ruta[ruta.length - 1]);
					link.click();
				}).catch(function (reason) {
					$this.exportLoading = false;
				});
			}
		}]);
	
		return RoutinesDetailController;
	}();
	
	RoutinesDetailController.$inject = inject;
	
	exports.default = RoutinesDetailController;

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _routinesDetail = __webpack_require__(226);
	
	var _routinesDetail2 = _interopRequireDefault(_routinesDetail);
	
	var _routinesDetail3 = __webpack_require__(230);
	
	var _routinesDetail4 = _interopRequireDefault(_routinesDetail3);
	
	var _routinesDetail5 = __webpack_require__(227);
	
	var _routinesDetail6 = _interopRequireDefault(_routinesDetail5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var routinesDetailModule = _angular2.default.module('app.routinesDetail', []).component('routinesDetail', _routinesDetail2.default).service('routinesDetailService', _routinesDetail4.default).config(_routinesDetail6.default);
	
	exports.default = routinesDetailModule;

/***/ },
/* 230 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var routinesDetailService = function () {
	  function routinesDetailService($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
	    _classCallCheck(this, routinesDetailService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	  }
	
	  _createClass(routinesDetailService, [{
	    key: 'getActivitiesData',
	    value: function getActivitiesData(data) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'POST',
	          url: _this.ngAuthSettings.apiServiceBaseUri + '/opalo/opalo/consulta',
	          data: _this.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'exportarXls',
	    value: function exportarXls(data) {
	      var _this2 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this2.$http({
	          method: 'POST',
	          url: _this2.ngAuthSettings.apiServiceBaseUri + '/opalo/opalo/exportar-datos-csv',
	          data: _this2.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'exportarPdf',
	    value: function exportarPdf(data) {
	      var _this3 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this3.$http({
	          method: 'POST',
	          url: _this3.ngAuthSettings.apiServiceBaseUri + '/opalo/opalo/descarga-documento',
	          data: _this3.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return routinesDetailService;
	}();
	
	routinesDetailService.$inject = ['$q', '$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];
	
	exports.default = routinesDetailService;

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routinesList = __webpack_require__(233);
	
	var _routinesList2 = _interopRequireDefault(_routinesList);
	
	var _routinesListView = __webpack_require__(472);
	
	var _routinesListView2 = _interopRequireDefault(_routinesListView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RoutinesListComponent = {
	  template: _routinesListView2.default,
	  controller: _routinesList2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = RoutinesListComponent;

/***/ },
/* 232 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.routinesList', {
	    url: "/consultas/rutinas",
	    template: '<routines-list  sh-ctrl="shCtrl"></routines-list>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 233 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'routinesListService', '$state', '$rootScope', '$timeout', 'SessionService'];
	
	var RoutinesListController = function () {
		function RoutinesListController($scope, routinesListService, $state, $rootScope, $timeout, SessionService) {
			_classCallCheck(this, RoutinesListController);
	
			this.$state = $state;
			this.$scope = $scope;
			this.$timeout = $timeout;
			this.$rootScope = $rootScope;
			this.routinesListService = routinesListService;
			this.activities = [];
			this.SessionService = SessionService;
		}
	
		_createClass(RoutinesListController, [{
			key: '$onInit',
			value: function $onInit() {
				this.shCtrl.activate();
				this.order = 'name';
				this.desc = true;
				this.userId = this.shCtrl.globals.currentUser.userId;
				this.filter = {};
				this.cacheFilter = {
					firtsConsulta: true
				};
	
				this.currentPage = 1;
				this.currentPageCache = 0;
				this.getActivities();
	
				this.totalItems = 0;
				this.totalPages = 1;
	
				this.detalle = {};
	
				this.ultimaActualizacion = '';
			}
		}, {
			key: 'orderBy',
			value: function orderBy(name) {
				if (this.order == name) {
					this.desc = !this.desc;
				} else {
					this.order = name;
					this.desc = true;
				}
	
				this.getActivities(true);
			}
		}, {
			key: 'getActivities',
			value: function getActivities(ordenar) {
				var _this = this;
	
				if (!angular.equals(this.filter, this.cacheFilter) || this.currentPage != this.currentPageCache || ordenar) {
					this.currentPageCache = angular.copy(this.currentPage);
					this.cacheFilter = angular.copy(this.filter);
					this.loading = true;
					this.error = false;
					this.errorMsg = '';
	
					this.data = {
						'userId': this.userId,
						'pageNumber': this.currentPage ? this.currentPage : 1,
						'pageSize': 20,
						'filter': this.filter,
						'consulta': 'rutinas',
						'order': this.order,
						'desc': this.desc
					};
	
					this.routinesListService.getActivitiesData(this.data).then(function (response) {
						_this.loading = false;
	
						if (response.error) {
							_this.error = true;
							_this.errorMsg = response.mensaje;
						} else {
							_this.activities = response.actividades;
							_this.totalItems = response.totalItems;
							_this.totalPages = response.totalPage;
							_this.ultimaActualizacion = response.ultimaActualizacion;
						}
						if ((_this.error || !_this.activities.length) && _this.errorMsg == '') {
							_this.errorMsg = 'No se han encontrado registros que coincidan con los filtros seleccionados';
						}
					}).catch(function (reason) {
						_this.loading = false;
						_this.error = true;
						if (_this.error && _this.errorMsg == '') {
							_this.errorMsg = 'No se han encontrado registros que coincidan con los filtros seleccionados';
						}
					});
				}
			}
		}, {
			key: 'exportarXls',
			value: function exportarXls() {
				var _this2 = this;
	
				this.exportLoading = true;
	
				var data = {
					'pageNumber': 1,
					'pageSize': this.totalItems,
					'userId': this.userId,
					'filter': this.filter,
					'consulta': 'rutinas',
					'order': this.order,
					'desc': this.desc
				};
				this.routinesListService.exportarXls(data).then(function (response) {
					_this2.exportLoading = false;
					var ruta = response.split('/');
	
					var link = document.getElementById("labelprueba");
					link.setAttribute("href", response);
					link.setAttribute("download", ruta[ruta.length - 1]);
					link.click();
				}).catch(function (reason) {
					$this.exportLoading = false;
				});
			}
		}]);
	
		return RoutinesListController;
	}();
	
	RoutinesListController.$inject = inject;
	
	exports.default = RoutinesListController;

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _routinesList = __webpack_require__(231);
	
	var _routinesList2 = _interopRequireDefault(_routinesList);
	
	var _routinesList3 = __webpack_require__(235);
	
	var _routinesList4 = _interopRequireDefault(_routinesList3);
	
	var _routinesList5 = __webpack_require__(232);
	
	var _routinesList6 = _interopRequireDefault(_routinesList5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var routinesListModule = _angular2.default.module('app.routinesList', []).component('routinesList', _routinesList2.default).service('routinesListService', _routinesList4.default).config(_routinesList6.default);
	
	exports.default = routinesListModule;

/***/ },
/* 235 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var routinesListService = function () {
	  function routinesListService($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
	    _classCallCheck(this, routinesListService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	  }
	
	  _createClass(routinesListService, [{
	    key: 'getActivitiesData',
	    value: function getActivitiesData(data) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'POST',
	          url: _this.ngAuthSettings.apiServiceBaseUri + '/opalo/opalo/consulta',
	          data: _this.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'exportarXls',
	    value: function exportarXls(data) {
	      var _this2 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this2.$http({
	          method: 'POST',
	          url: _this2.ngAuthSettings.apiServiceBaseUri + '/opalo/opalo/exportar-datos-csv',
	          data: _this2.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return routinesListService;
	}();
	
	routinesListService.$inject = ['$q', '$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];
	
	exports.default = routinesListService;

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _specificActList = __webpack_require__(238);
	
	var _specificActList2 = _interopRequireDefault(_specificActList);
	
	var _specificActListView = __webpack_require__(473);
	
	var _specificActListView2 = _interopRequireDefault(_specificActListView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SpecificActListComponent = {
	  template: _specificActListView2.default,
	  controller: _specificActList2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = SpecificActListComponent;

/***/ },
/* 237 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.specificActList', {
	    url: "/consultas/actividades-especificas",
	    template: '<specific-act-list  sh-ctrl="shCtrl"></specific-act-list>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 238 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'specificActListService', '$state', '$rootScope', '$timeout', 'SessionService'];
	
	var SpecificActListController = function () {
		function SpecificActListController($scope, specificActListService, $state, $rootScope, $timeout, SessionService) {
			_classCallCheck(this, SpecificActListController);
	
			this.$state = $state;
			this.$scope = $scope;
			this.$timeout = $timeout;
			this.$rootScope = $rootScope;
			this.SessionService = SessionService;
			this.specificActListService = specificActListService;
			this.activities = [];
	
			this.search = {};
		}
	
		_createClass(SpecificActListController, [{
			key: '$onInit',
			value: function $onInit() {
				this.shCtrl.activate();
				this.order = 'date_entered';
				this.desc = true;
				this.userId = this.shCtrl.globals.currentUser.userId;
				this.filter = {};
				this.cacheFilter = {
					firtsConsulta: true
				};
	
				this.currentPageCache = 0;
	
				this.currentPage = 1;
				this.getActivities();
	
				this.totalItems = 0;
				this.totalPages = 1;
	
				this.exportLoading = false;
	
				this.ultimaActualizacion = '';
			}
		}, {
			key: 'orderBy',
			value: function orderBy(name) {
				if (this.order == name) {
					this.desc = !this.desc;
				} else {
					this.order = name;
					this.desc = true;
				}
	
				this.getActivities(true);
			}
		}, {
			key: 'getActivities',
			value: function getActivities() {
				var _this = this;
	
				var ordenar = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
				if (!angular.equals(this.filter, this.cacheFilter) || this.currentPage != this.currentPageCache || ordenar) {
					this.currentPageCache = angular.copy(this.currentPage);
					this.cacheFilter = angular.copy(this.filter);
	
					this.loading = true;
					this.error = false;
					this.errorMsg = '';
	
					this.data = {
						'userId': this.userId,
						'pageNumber': this.currentPage ? this.currentPage : 1,
						'pageSize': 20,
						'filter': this.filter,
						'consulta': 'actividades',
						'order': this.order,
						'desc': this.desc
					};
	
					this.specificActListService.getActivitiesData(this.data).then(function (response) {
						_this.loading = false;
	
						if (response.error) {
							_this.error = true;
							_this.errorMsg = response.mensaje;
						} else {
	
							_this.activities = response.actividades;
							_this.totalItems = response.totalItems;
							_this.totalPages = response.totalPage;
							_this.ultimaActualizacion = response.ultimaActualizacion;
						}
						if ((_this.error || !_this.activities.length) && _this.errorMsg == '') {
							_this.errorMsg = 'No se han encontrado registros que coincidan con los filtros seleccionados';
						}
					}).catch(function (reason) {
	
						console.log(reason);
						_this.loading = false;
						_this.error = true;
						if (_this.error && _this.errorMsg == '') {
							_this.errorMsg = 'No se han encontrado registros que coincidan con los filtros seleccionados';
						}
					});
				}
			}
		}, {
			key: 'exportarXls',
			value: function exportarXls() {
				var _this2 = this;
	
				this.exportLoading = true;
	
				var action = 'listado';
				if (this.search.id) {
					action = 'detalle';
				}
				var data = {
					'pageNumber': 1,
					'pageSize': this.totalItems,
					'userId': this.userId,
					'consulta': 'actividades',
					'filter': this.filter,
					'accion': action,
					'order': this.order,
					'desc': this.desc
				};
				if (this.search.id) {
					data['id'] = this.search.id;
				}
				this.specificActListService.exportarXls(data).then(function (response) {
	
					_this2.exportLoading = false;
					var ruta = response.split('/');
	
					var link = document.getElementById("labelprueba");
					link.setAttribute("href", response);
					link.setAttribute("download", ruta[ruta.length - 1]);
					link.click();
				}).catch(function (reason) {
					$this.exportLoading = false;
				});
			}
		}, {
			key: 'salirDetalle',
			value: function salirDetalle() {
				this.search = {};
			}
		}]);
	
		return SpecificActListController;
	}();
	
	SpecificActListController.$inject = inject;
	
	exports.default = SpecificActListController;

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _specificActList = __webpack_require__(236);
	
	var _specificActList2 = _interopRequireDefault(_specificActList);
	
	var _specificActList3 = __webpack_require__(240);
	
	var _specificActList4 = _interopRequireDefault(_specificActList3);
	
	var _specificActList5 = __webpack_require__(237);
	
	var _specificActList6 = _interopRequireDefault(_specificActList5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var specificActListModule = _angular2.default.module('app.specificActList', []).component('specificActList', _specificActList2.default).service('specificActListService', _specificActList4.default).config(_specificActList6.default);
	
	exports.default = specificActListModule;

/***/ },
/* 240 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var specificActListService = function () {
	  function specificActListService($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
	    _classCallCheck(this, specificActListService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	  }
	
	  _createClass(specificActListService, [{
	    key: 'getActivitiesData',
	    value: function getActivitiesData(data) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'POST',
	          url: _this.ngAuthSettings.apiServiceBaseUri + '/opalo/opalo/consulta',
	          data: _this.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'exportarXls',
	    value: function exportarXls(data) {
	      var _this2 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this2.$http({
	          method: 'POST',
	          url: _this2.ngAuthSettings.apiServiceBaseUri + '/opalo/opalo/exportar-datos-csv',
	          data: _this2.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return specificActListService;
	}();
	
	specificActListService.$inject = ['$q', '$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];
	
	exports.default = specificActListService;

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _taskList = __webpack_require__(243);
	
	var _taskList2 = _interopRequireDefault(_taskList);
	
	var _taskListView = __webpack_require__(474);
	
	var _taskListView2 = _interopRequireDefault(_taskListView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TaskListComponent = {
	  template: _taskListView2.default,
	  controller: _taskList2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = TaskListComponent;

/***/ },
/* 242 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.taskList', {
	    url: "/consultas/tareas/:id",
	    template: '<task-list sh-ctrl="shCtrl"></task-list>'
	  }).state('home.taskList2', {
	    url: "/consultas/tareas",
	    template: '<task-list sh-ctrl="shCtrl"></task-list>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 243 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'taskListService', '$state', '$rootScope', '$timeout', 'SessionService', '$stateParams'];
	
	var TaskListController = function () {
		function TaskListController($scope, taskListService, $state, $rootScope, $timeout, SessionService, $stateParams) {
			_classCallCheck(this, TaskListController);
	
			this.$state = $state;
			this.$scope = $scope;
			this.$timeout = $timeout;
			this.$rootScope = $rootScope;
			this.taskListService = taskListService;
			this.activities = [];
			this.SessionService = SessionService;
			this.$stateParams = $stateParams;
		}
	
		_createClass(TaskListController, [{
			key: '$onInit',
			value: function $onInit() {
				this.shCtrl.activate();
				this.order = 'date_entered';
				this.desc = true;
				this.sucursales = this.shCtrl.globals.currentUser.sucursales;
				this.userId = this.shCtrl.globals.currentUser.userId;
				this.sessionId = this.shCtrl.globals.currentUser.sessionCrm;
				if (this.$stateParams.id) {
					this.filter = { 'id': this.$stateParams.id };
					this.detalle = { 'id': this.$stateParams.id };
				} else {
					this.filter = {};
					this.detalle = {};
				}
				this.cacheFilter = {
					firtsConsulta: true
				};
	
				this.currentPage = 1;
				this.currentPageCache = 0;
				this.getActivities();
	
				this.totalItems = 0;
				this.totalPages = 1;
	
				this.ultimaActualizacion = '';
			}
		}, {
			key: 'orderBy',
			value: function orderBy(name) {
				if (this.order == name) {
					this.desc = !this.desc;
				} else {
					this.order = name;
					this.desc = true;
				}
	
				this.getActivities(true);
			}
		}, {
			key: 'volverAlListado',
			value: function volverAlListado() {
				console.log('test');
				this.detalle = {};
				if (this.$stateParams.id) {
					this.filter = {};
					this.getActivities();
				}
			}
		}, {
			key: 'getActivities',
			value: function getActivities() {
				var _this = this;
	
				var ordenar = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
				if (!angular.equals(this.filter, this.cacheFilter) || this.currentPage != this.currentPageCache || ordenar) {
					this.currentPageCache = angular.copy(this.currentPage);
					this.cacheFilter = angular.copy(this.filter);
					this.loading = true;
					this.error = false;
					this.errorMsg = '';
	
					this.data = {
						'userId': this.userId,
						'pageNumber': this.currentPage ? this.currentPage : 1,
						'pageSize': 20,
						'filter': this.filter,
						'consulta': 'tareas',
						'order': this.order,
						'desc': this.desc
					};
	
					this.taskListService.getActivitiesData(this.data).then(function (response) {
						_this.loading = false;
	
						if (response.error) {
							_this.error = true;
							_this.errorMsg = response.mensaje;
						} else {
							_this.activities = response.actividades;
							_this.totalItems = response.totalItems;
							_this.totalPages = response.totalPage;
	
							_this.ultimaActualizacion = response.ultimaActualizacion;
	
							/*this.activities.forEach((value,key)=>{
	      	value.description = this.decodeEntities(value.description);
	      });*/
						}
						if ((_this.error || !_this.activities.length) && _this.errorMsg == '') {
							_this.errorMsg = 'No se han encontrado registros que coincidan con los filtros seleccionados';
						}
					}).catch(function (reason) {
						_this.loading = false;
						_this.error = true;
						if (_this.error && _this.errorMsg == '') {
							_this.errorMsg = 'No se han encontrado registros que coincidan con los filtros seleccionados';
						}
					});
				}
			}
		}, {
			key: 'exportarXls',
			value: function exportarXls() {
				var _this2 = this;
	
				this.exportLoading = true;
	
				var data = {
					'pageNumber': 1,
					'pageSize': this.totalItems,
					'userId': this.userId,
					'filter': this.filter,
					'consulta': 'tareas',
					'order': this.order,
					'desc': this.desc
				};
				this.taskListService.exportarXls(data).then(function (response) {
					// Renombra la session crm en caso de que el servidor se la cambie		
					_this2.exportLoading = false;
					var ruta = response.split('/');
	
					var link = document.getElementById("labelprueba");
					link.setAttribute("href", response);
					link.setAttribute("download", ruta[ruta.length - 1]);
					link.click();
				}).catch(function (reason) {
					$this.exportLoading = false;
				});
			}
		}, {
			key: 'exportarPdf',
			value: function exportarPdf() {
				var _this3 = this;
	
				this.exportLoading = true;
	
				var data = {
					'pageNumber': 1,
					'pageSize': this.totalItems,
					'userId': this.userId,
					'filter': this.filter,
					'consulta': 'tareas',
					'id': this.detalle.id,
					'order': this.order,
					'desc': this.desc
				};
				this.taskListService.exportarPdf(data).then(function (response) {
					// Renombra la session crm en caso de que el servidor se la cambie
					if (response.sessionCrm) {
						var currentUser = _this3.SessionService.get('currentUser');
						currentUser.sessionCrm = response.sessionCrm;
						_this3.sessionId = data.sessionCrm;
						_this3.SessionService.put('currentUser', currentUser);
						_this3.shCtrl.globals.currentUser.sessionCrm = response.sessionCrm;
					}
	
					_this3.exportLoading = false;
					var ruta = response.split('/');
	
					var link = document.getElementById("labelprueba");
					link.setAttribute("href", response);
					link.setAttribute("download", ruta[ruta.length - 1]);
					link.click();
				}).catch(function (reason) {
					$this.exportLoading = false;
				});
			}
		}]);
	
		return TaskListController;
	}();
	
	TaskListController.$inject = inject;
	
	exports.default = TaskListController;

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _taskList = __webpack_require__(241);
	
	var _taskList2 = _interopRequireDefault(_taskList);
	
	var _taskList3 = __webpack_require__(245);
	
	var _taskList4 = _interopRequireDefault(_taskList3);
	
	var _taskList5 = __webpack_require__(242);
	
	var _taskList6 = _interopRequireDefault(_taskList5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var taskListModule = _angular2.default.module('app.taskList', []).component('taskList', _taskList2.default).service('taskListService', _taskList4.default).config(_taskList6.default);
	
	exports.default = taskListModule;

/***/ },
/* 245 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var taskListService = function () {
	  function taskListService($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
	    _classCallCheck(this, taskListService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	  }
	
	  _createClass(taskListService, [{
	    key: 'getActivitiesData',
	    value: function getActivitiesData(data) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'POST',
	          url: _this.ngAuthSettings.apiServiceBaseUri + '/opalo/opalo/consulta',
	          data: _this.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'exportarXls',
	    value: function exportarXls(data) {
	      var _this2 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this2.$http({
	          method: 'POST',
	          url: _this2.ngAuthSettings.apiServiceBaseUri + '/opalo/opalo/exportar-datos-csv',
	          data: _this2.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'exportarPdf',
	    value: function exportarPdf(data) {
	      var _this3 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this3.$http({
	          method: 'POST',
	          url: _this3.ngAuthSettings.apiServiceBaseUri + '/opalo/opalo/exportar-datos-pdf',
	          data: _this3.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return taskListService;
	}();
	
	taskListService.$inject = ['$q', '$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];
	
	exports.default = taskListService;

/***/ },
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */
[548, 251, 477],
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modalResponseView = __webpack_require__(3);
	
	var _modalResponseView2 = _interopRequireDefault(_modalResponseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'DashboardService', '$state', '$rootScope', 'SharedService', '$timeout', 'ngAuthSettings', 'CartService', 'SessionService', 'NgTableParams', '$uibModal'];
	
	var DashboardController = function () {
	  function DashboardController($scope, DashboardService, $state, $rootScope, SharedService, $timeout, ngAuthSettings, CartService, SessionService, NgTableParams, $uibModal) {
	    _classCallCheck(this, DashboardController);
	
	    this.$state = $state;
	    this.SessionService = SessionService;
	    this.ngAuthSettings = ngAuthSettings;
	    this.CartService = CartService;
	    this.NgTableParams = NgTableParams;
	    // this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.$rootScope = $rootScope;
	    this.DashboardService = DashboardService;
	    this.$uibModal = $uibModal;
	    this.SharedService = SharedService;
	    this.dashboardInfo = [];
	
	    this.loadingDashboardInfo = false;
	    this.loadedDashboardInfo = false;
	    this.errorloadingDashboardInfo = false;
	  }
	
	  _createClass(DashboardController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	    //this.getDashboardInfo();
	
	
	    // getDashboardInfo () {
	    //   let globals = this.shCtrl.globals;
	    //   let userId = '';
	    //   try {userId = globals.currentUser.userId; }catch(e){}
	    //   this.loadingDashboardInfo = true;
	    //   this.loadedDashboardInfo = false;
	    //   this.errorloadingDashboardInfo = false;
	    //   this.DashboardService.getDashboardInfo({'userId': userId}).then(response => {
	    //     this.loadingDashboardInfo = false;
	    //     this.loadedDashboardInfo = true;
	    //     this.errorloadingDashboardInfo = false;
	
	    //     this.dashboardInfo = response.dashboardInfo;
	    //   }).catch(reason => {
	    //     this.loadingDashboardInfo = false;
	    //     this.loadedDashboardInfo = true;
	    //     this.errorloadingDashboardInfo = true;
	    //   });
	    // }
	
	    // messageResponse (options, callAcept, callback, callCancel, callbackCancel) {
	    //   let modalInstance = this.$uibModal.open({
	    //     animation: true,
	    //     template: modalConfirmation,
	    //     controller : 'ModalResponseController',
	    //     controllerAs : 'mdCtrl',
	    //     size: options.size,
	    //     resolve : {
	    //       modalOptions : () => options
	    //     }
	    //   });
	    //   modalInstance.result.then(() => {
	    //     if(callAcept) {
	    //       callback();
	    //     }
	    //   }).catch(reason => {
	    //     if(callCancel) {
	    //       callbackCancel();
	    //     }
	    //   });
	    // }
	
	  }]);
	
	  return DashboardController;
	}();
	
	DashboardController.$inject = inject;
	
	exports.default = DashboardController;

/***/ },
/* 252 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DashboardService = function () {
	  function DashboardService($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
	    _classCallCheck(this, DashboardService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	  }
	
	  _createClass(DashboardService, [{
	    key: 'getDashboardInfo',
	    value: function getDashboardInfo(data) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'POST',
	          url: _this.ngAuthSettings.apiServiceBaseUri + '/' + _this.ngAuthSettings.config.paths.getDashboardInfo,
	          data: _this.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return DashboardService;
	}();
	
	DashboardService.$inject = ['$q', '$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];
	
	exports.default = DashboardService;

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _brands = __webpack_require__(254);
	
	var _brands2 = _interopRequireDefault(_brands);
	
	var _brandsView = __webpack_require__(478);
	
	var _brandsView2 = _interopRequireDefault(_brandsView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BrandsComponent = {
	  template: _brandsView2.default,
	  controller: _brands2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = BrandsComponent;

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modalResponseView = __webpack_require__(3);
	
	var _modalResponseView2 = _interopRequireDefault(_modalResponseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$state', '$rootScope', 'SharedService', 'ngAuthSettings', 'HomeService', '$uibModal', '$timeout', 'CartService'];
	
	var BrandsController = function () {
	  function BrandsController($scope, $state, $rootScope, SharedService, ngAuthSettings, HomeService, $uibModal, $timeout, CartService) {
	    _classCallCheck(this, BrandsController);
	
	    this.$state = $state;
	    this.$uibModal = $uibModal;
	    this.$scope = $scope;
	    this.HomeService = HomeService;
	    this.CartService = CartService;
	    this.$timeout = $timeout;
	    this.ngAuthSettings = ngAuthSettings;
	    this.$rootScope = $rootScope;
	    this.SharedService = SharedService;
	  }
	
	  _createClass(BrandsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getBrands();
	    }
	  }, {
	    key: 'getBrands',
	    value: function getBrands() {
	      // let userId = '';
	      // try{ userId = this.shCtrl.currentUser.userId; }
	      // catch(e){}
	      // this.HomeService.getBrands(userId, 10).then(response => {
	      //   this.featuredProducts = response;
	      //   this.featuredProducts1 = [];
	      //   this.featuredProducts2 = [];
	      //   if(response.length){
	      //     response.forEach((valFor, indexFor) => {
	      //       if(indexFor <= ((response.length - 1) / 2) || response.length < 8) {
	      //         this.featuredProducts1.push(valFor);
	      //       } else {
	      //         this.featuredProducts2.push(valFor);
	      //       }
	      //     });
	      //   }
	      //   this.initRelatedProductsCarousel();
	      //   // initBrandsCarousel();
	      //
	      //   this.loadingRelatedProducts = false;
	      // }).catch(error => {
	      //
	      // });
	      this.initBrandsCarousel();
	    }
	  }, {
	    key: 'initBrandsCarousel',
	    value: function initBrandsCarousel() {
	      this.$timeout(function () {
	
	        var brandsItemsSlider = $('.brands-slider.owl-carousel');
	        brandsItemsSlider.owlCarousel({
	          items: 5,
	          itemsDesktop: [1199, 3],
	          itemsDesktopSmall: [979, 2],
	          itemsTablet: [768, 2],
	          itemsMobile: [479, 1],
	          slideSpeed: 400,
	          autoPlay: 8000,
	          stopOnHover: true,
	          navigation: false,
	          pagination: false,
	          responsive: true,
	          mouseDrag: false,
	          autoHeight: false
	        }).data('navigationBtns', ['#brands-slider-prev', '#brands-slider-next']);
	        brandsItemsSlider.each(function () {
	          var $this = $(this),
	              owlCarousel = $this.data('owlCarousel'),
	              owlBtns = $this.data('navigationBtns'),
	              prevBtn = void 0,
	              nextBtn = void 0;
	
	          if (typeof owlCarousel === 'undefined' || typeof owlBtns === 'undefined') {
	            return;
	          }
	
	          for (var key in owlBtns) {
	            if (owlBtns[key].indexOf('next') === -1) {
	              prevBtn = $(owlBtns[key]);
	            } else {
	              nextBtn = $(owlBtns[key]);
	            }
	          }
	
	          prevBtn.on('click touchstart', function (e) {
	            owlCarousel.prev();
	            e.preventDefault();
	          });
	
	          nextBtn.on('click touchstart', function (e) {
	            owlCarousel.next();
	            e.preventDefault();
	          });
	        });
	
	        $('.add-tooltip').tooltip();
	      }, 1000);
	    }
	  }, {
	    key: 'messageResponse',
	    value: function messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalResponseView2.default,
	        controller: 'ModalResponseController',
	        controllerAs: 'mdCtrl',
	        size: options.size,
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        if (callAcept) {
	          callback();
	        }
	      }).catch(function (reason) {
	        if (callCancel) {
	          callbackCancel();
	        }
	      });
	    }
	  }]);
	
	  return BrandsController;
	}();
	
	BrandsController.$inject = inject;
	
	exports.default = BrandsController;

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _brands = __webpack_require__(253);
	
	var _brands2 = _interopRequireDefault(_brands);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BrandsModule = _angular2.default.module('home.brands', []).component('brands', _brands2.default);
	
	exports.default = BrandsModule;

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _home = __webpack_require__(258);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _homeView = __webpack_require__(479);
	
	var _homeView2 = _interopRequireDefault(_homeView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeComponent = {
	  template: _homeView2.default,
	  controller: _home2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = HomeComponent;

/***/ },
/* 257 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.home', {
	    url: "/home",
	    template: '<home sh-ctrl="shCtrl"></home>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 258 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'SharedService', '$state', '$rootScope', '$timeout'];
	
	var HomeController = function () {
	  function HomeController($scope, SharedService, $state, $rootScope, $timeout) {
	    _classCallCheck(this, HomeController);
	
	    this.$state = $state;
	    this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.$rootScope = $rootScope;
	    this.SharedService = SharedService;
	  }
	
	  _createClass(HomeController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.shCtrl.activate();
	    }
	  }]);
	
	  return HomeController;
	}();
	
	HomeController.$inject = inject;
	
	exports.default = HomeController;

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _home = __webpack_require__(256);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _home3 = __webpack_require__(260);
	
	var _home4 = _interopRequireDefault(_home3);
	
	var _home5 = __webpack_require__(257);
	
	var _home6 = _interopRequireDefault(_home5);
	
	var _brands = __webpack_require__(255);
	
	var _brands2 = _interopRequireDefault(_brands);
	
	var _menu = __webpack_require__(264);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var homeModule = _angular2.default.module('home', [_brands2.default.name, _menu2.default.name]).component('home', _home2.default).service('HomeService', _home4.default).config(_home6.default);
	
	exports.default = homeModule;

/***/ },
/* 260 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HomeService = function () {
	  function HomeService($q, $http, ngAuthSettings) {
	    _classCallCheck(this, HomeService);
	
	    this.ngAuthSettings = ngAuthSettings;
	    this.$q = $q;
	    this.$http = $http;
	  }
	
	  _createClass(HomeService, [{
	    key: 'getProductsBySearchText',
	    value: function getProductsBySearchText(pageNumber, searchText, third) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'GET',
	          url: _this.ngAuthSettings.apiServiceBaseUri + '/items/items/search-items?pageSize=' + 5 + '&pageNumber=' + pageNumber + '&searchText=' + searchText + '&terceroId=' + third,
	          cache: true
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return HomeService;
	}();
	
	HomeService.$inject = ['$q', '$http', 'ngAuthSettings'];
	
	exports.default = HomeService;

/***/ },
/* 261 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function MenuItemDirective($compile) {
	  return {
	    template: '\n      <li>\n        <a>\n          <span class="subitem-menu">\n            <img ng-src="{{ctrl.ngAuthSettings.config.env.basePath + item.icon}}" alt="">\n            <p>{{item.nombre}}</p>\n          </span>\n        </a>\n      </li>',
	    restrict: 'A',
	    replace: true,
	    controller: controller,
	    controllerAs: 'ctrl',
	    scope: {
	      item: '=menuItem'
	    },
	    link: function link(scope, element, attrs) {
	      if (!scope.item.icono_solo) {
	        if (scope.item.header) {
	          element.addClass('nav-header');
	          element.text(scope.item.header);
	        }
	        if (scope.item.divider) {
	          element.addClass('divider');
	          element.empty();
	        }
	        if (scope.item.hijas) {
	          var text = element.children('a').text();
	          var href = '';
	          if (scope.item.url_destino) {
	            href = 'href="' + scope.item.url_destino + '" target="_blank"';
	          } else {
	            href = 'href="./#/' + scope.item.slug + '" target=""';
	          }
	          element.empty();
	          var $a = $('<a ' + href + '>' + text + '</a> <i class="fa fa-chevron-right pull-right"></i>');
	          element.append($a);
	
	          var $submenu = $('<div menu="item.hijas"></div>');
	          element.append($submenu);
	        } else {
	          element.children('a').attr('ui-sref', 'home.categorySlugProducts({categorySlug : \'' + scope.item.slug + '\'})');
	        }
	
	        $compile(element.contents())(scope);
	      } else {
	        if (scope.item.hijas) {
	          var _text = element.children('a').text();
	          var _href = 'href="' + scope.item.url_destino + '"';
	
	          element.empty();
	          var _$a = $('<a ' + _href + '>' + _text + '</a> <i class="fa fa-chevron-right pull-right"></i>');
	          element.append(_$a);
	
	          var _$submenu = $('<div menu="item.hijas"></div>');
	          element.append(_$submenu);
	        } else {
	          element.children('a').attr('href', scope.item.url_destino);
	        }
	
	        $compile(element.contents())(scope);
	      }
	    }
	  };
	}
	
	function controller(ngAuthSettings) {
	  var vm = this;
	  this.ngAuthSettings = ngAuthSettings;
	}
	
	controller.$inject = ['ngAuthSettings'];
	MenuItemDirective.$inject = ['$compile'];
	
	exports.default = MenuItemDirective;

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _menuItem = __webpack_require__(261);
	
	var _menuItem2 = _interopRequireDefault(_menuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MenuItemModule = _angular2.default.module('home.menuItem', []).directive('menuItem', _menuItem2.default);
	
	exports.default = MenuItemModule;

/***/ },
/* 263 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function MenuDirective() {
	  return {
	    restrict: 'A',
	    template: '\n      <ul class="multilevel-menu estee">\n        <li ng-repeat="item in menu" menu-item="item"></li>\n      </ul>\n    ',
	    scope: {
	      menu: '=menu',
	      cls: '=ngClass'
	    },
	    replace: true,
	    link: function link(scope, element, attrs) {
	      element.addClass(attrs.class);
	      element.addClass(scope.cls);
	    }
	  };
	}
	
	MenuDirective.$inject = [];
	
	exports.default = MenuDirective;

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _menu = __webpack_require__(263);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _menuItem = __webpack_require__(262);
	
	var _menuItem2 = _interopRequireDefault(_menuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MenuModule = _angular2.default.module('home.menu', [_menuItem2.default.name]).directive('menu', _menu2.default);
	
	exports.default = MenuModule;

/***/ },
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _login = __webpack_require__(271);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _loginView = __webpack_require__(481);
	
	var _loginView2 = _interopRequireDefault(_loginView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoginComponent = {
	  template: _loginView2.default,
	  controller: _login2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = LoginComponent;

/***/ },
/* 270 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.login', {
	    url: "/login",
	    template: '<login sh-ctrl="shCtrl"></login>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modalSelectBranchB2bUserView = __webpack_require__(36);
	
	var _modalSelectBranchB2bUserView2 = _interopRequireDefault(_modalSelectBranchB2bUserView);
	
	var _modalResponseView = __webpack_require__(3);
	
	var _modalResponseView2 = _interopRequireDefault(_modalResponseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'LoginService', '$state', '$rootScope', 'SharedService', '$timeout', 'ngAuthSettings', 'CartService', 'SessionService', '$uibModal'];
	
	var LoginController = function () {
	  function LoginController($scope, LoginService, $state, $rootScope, SharedService, $timeout, ngAuthSettings, CartService, SessionService, $uibModal) {
	    _classCallCheck(this, LoginController);
	
	    this.$state = $state;
	    this.SessionService = SessionService;
	    this.activateTab = 0;
	    this.ngAuthSettings = ngAuthSettings;
	    this.CartService = CartService;
	    // this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.$rootScope = $rootScope;
	    this.errorLogin = '';
	    this.LoginService = LoginService;
	    this.$uibModal = $uibModal;
	    this.SharedService = SharedService;
	    this.user = {};
	    this.newUser = {
	      branchCity: ''
	    };
	    this.documentTypes = [];
	    this.restoreAccount = '';
	    this.invalidUserOrPass = false;
	    this.validateRestore = false;
	    this.passwordInvalid = false;
	    this.thirdDocumentInvalid = false;
	    this.userEmailInvalid = false;
	    this.validatingDocument = false;
	    this.validatingEmail = false;
	    this.validatingLogin = false;
	    this.showSelectModal = false;
	    this.successMessage = false;
	    this.errorMessageRegister = false;
	    this.validatingCreateUser = false;
	    this.errorRestoringAccount = false;
	    this.successRestoringAccount = false;
	    this.recoveryPasswordDataLoading = false;
	    this.recoveryPasswordDataReceived = false;
	    this.recoveryPasswordIsAValidUser = false;
	    this.errorRecoveryPassword = '';
	    this.active = 0;
	  }
	
	  _createClass(LoginController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      try {
	        var userId = this.shCtrl.globals.currentUser.userId;
	        this.$state.go(this.ngAuthSettings.site.app.header.logo.url);
	      } catch (e) {}
	    }
	  }, {
	    key: 'loginUser',
	    value: function loginUser() {
	      var _this = this;
	
	      if (this.loginForm.$valid) {
	        this.errorLogin = '';
	        this.dataLoading = true;
	        this.validatingLogin = true;
	        this.LoginService.login(this.loginDataForm.email, this.loginDataForm.password).then(function (response) {
	          _this.validatingLogin = false;
	          _this.dataLoading = false;
	          _this.dataReceived = true;
	          if (!response.error) {
	            _this.isAValidUser = true;
	            var cartId = _this.SessionService.get('cartId') || '';
	            var clientPriceListName = '';
	            try {
	              clientPriceListName = _this.SessionService.get('quoteCartSeller').clientPriceList;
	            } catch (e) {}
	            _this.CartService.getCart(cartId, response.data.userId, clientPriceListName).then(function (cartResponse) {
	              // this.cart = response;
	              _this.SharedService.saveUserLogued(response.data);
	              try {
	                if (response.data.isB2B && response.data.operatingCenters) {
	                  if (response.data.isB2B && response.data.operatingCenters.length > 1) {
	                    _this.showSelectModal = true;
	                    _this.showModalSelectBranchUserB2B(response.data);
	                    return;
	                  } else if (response.data.operatingCenters.length === 1) {
	                    _this.LoginService.setOperatingCenter(response.data.operatingCenters[0].id).then(function (response) {
	                      response.data.operatingCenter = response.branch;
	                      _this.SharedService.saveUserLogued(response.data);
	                    }).catch(function (reason) {});
	                  }
	                }
	                // if (response.data.isB2B) this.$state.go('home.salesHome');
	                if (response.data.isB2B) {
	                  _this.$rootScope.reloadProyect = true;
	                  _this.$rootScope.reloadProyectState = _this.ngAuthSettings.site.app.header.logo.url;
	                  _this.$state.reload();
	                } else {
	                  if (_this.ngAuthSettings.site.config.redirectToB2bPage && (response.data.isSeller || response.data.isContactCenter)) {
	                    _this.$rootScope.reloadProyect = true;
	                    _this.$rootScope.reloadProyectState = 'home.contactCenterHome';
	                    // this.$state.go('home.contactCenterHome');
	                    _this.$state.reload();
	                    return;
	                  }
	                  if (cartResponse) {
	                    if (cartResponse.items.length > 0) {
	                      _this.$rootScope.reloadProyect = true;
	                      _this.$rootScope.reloadProyectState = 'home.cart';
	                      _this.$state.reload();
	                      // this.$state.go('home.cart');
	                    } else {
	                      // this.$state.go(this.ngAuthSettings.site.app.header.logo.url);
	                      // this.$timeout(() => {this.$state.reload();}, 1000);
	                      _this.$rootScope.reloadProyect = true;
	                      _this.$rootScope.reloadProyectState = _this.ngAuthSettings.site.app.header.logo.url;
	                      _this.$state.reload();
	                      // this.$timeout(() => {this.$state.go(this.ngAuthSettings.site.app.header.logo.url);}, 2000);
	                    }
	                  } else {
	                    // this.$state.go(this.ngAuthSettings.site.app.header.logo.url);
	                    // this.$timeout(() => {this.$state.reload();}, 1000);
	                    _this.$rootScope.reloadProyect = true;
	                    _this.$rootScope.reloadProyectState = _this.ngAuthSettings.site.app.header.logo.url;
	                    _this.$state.reload();
	                    // this.$timeout(() => {this.$state.go(this.ngAuthSettings.site.app.header.logo.url);}, 2000);
	                  }
	                }
	              } catch (e) {
	                alert(e.message);
	                _this.$rootScope.reloadProyect = true;
	                _this.$rootScope.reloadProyectState = _this.ngAuthSettings.site.app.header.logo.url;
	                _this.$state.reload();
	              }
	            });
	          } else {
	            console.log("login");
	            console.log(response);
	
	            if (response.errors.activo) {
	              _this.errorLogin = "Tu cuenta aún no ha sido activada por uno de nuestros ejecutivos. Para contactarte con nosotros has clic <a href='https://www.pallomaro.com/tienda/contact'>Aqui</a>";
	              _this.isAValidUser = false;
	            } else {
	              _this.errorLogin = response.message;
	              _this.isAValidUser = false;
	            }
	          }
	        }).catch(function () {
	          _this.validatingLogin = false;
	        });
	      }
	    }
	  }, {
	    key: 'showModalSelectBranchUserB2B',
	    value: function showModalSelectBranchUserB2B(userData) {
	      var _this2 = this;
	
	      var options = {
	        userData: userData,
	        branches: userData.operatingCenters,
	        currentBranch: null
	      };
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalSelectBranchB2bUserView2.default,
	        controller: 'ModalSelectBranchController',
	        controllerAs: 'mdCtrl',
	        size: '',
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function (result) {
	        _this2.showSelectModal = false;
	      }).catch(function (reason) {
	        _this2.showSelectModal = false;
	      });
	    }
	  }, {
	    key: 'registerUser',
	    value: function registerUser() {
	      var _this3 = this;
	
	      if (this.registerForm.$valid) {
	        this.validatingCreateUser = true;
	        if (this.newUser.branchCity) this.newUser.branchCityId = this.newUser.branchCity.id;
	        this.LoginService.registerUser(this.newUser).then(function (response) {
	          _this3.validatingCreateUser = false;
	          if (!response.error) {
	            _this3.successMessage = response.message;
	            _this3.user.email = angular.copy(_this3.newUser.email);
	            _this3.newUser = {};
	            _this3.registerForm.$setPristine();
	            _this3.$timeout(function () {
	              return _this3.activateTab = 0;
	            }, 7000);
	          } else {
	            _this3.errorMessageRegister = response.message;
	            _this3.$timeout(function () {
	              return _this3.errorMessageRegister = null;
	            }, 7000);
	          }
	        }).catch(function (error) {
	          _this3.validatingCreateUser = false;
	        });
	      }
	    }
	
	    // /**
	    //  Set captcha id on create captcha
	    //  @method widgetId
	    //  @param widgetId captcha widgetr id
	    //  */
	    // setWidgetId (widgetId)  {
	    //   this.captchaId = widgetId;
	    // };
	    //
	    // /**
	    //  Set captcha value on enter captcha
	    //  @method setResponse
	    //  @param response captcha value
	    //  */
	    // setResponse (response) {
	    //   this.enteredCaptcha = true;
	    //   this.expiredCaptcha = false;
	    //   this.captcha = response;
	    // };
	    //
	    // /**
	    //  Expiration captcha event
	    //  @method cbExpiration
	    //  */
	    // cbExpiration () {
	    //   this.expiredCaptcha = true;
	    //   this.enteredCaptcha = false;
	    //
	    //   this.captcha = '';
	    // };
	    //
	
	  }, {
	    key: 'validatePassword',
	    value: function validatePassword() {
	      if (this.newUser.password && this.newUser.passwordConfirm) {
	        if (!angular.equals(this.newUser.password, this.newUser.passwordConfirm)) {
	          this.passwordInvalid = true;
	        }
	      }
	    }
	  }, {
	    key: 'validateThirdDocument',
	    value: function validateThirdDocument() {
	      var _this4 = this;
	
	      if (this.newUser.thirdDocumentNumber) {
	        this.validatingDocument = true;
	        this.SharedService.validateThirdDocument(this.newUser.thirdDocumentNumber).then(function (response) {
	          _this4.validatingDocument = false;
	          _this4.thirdDocumentInvalid = response;
	        }).catch(function (error) {
	          _this4.validatingDocument = false;
	        });
	      }
	    }
	  }, {
	    key: 'validateEmail',
	    value: function validateEmail() {
	      var _this5 = this;
	
	      if (this.newUser.email) {
	        this.validatingEmail = true;
	        this.SharedService.validateEmail(this.newUser.email).then(function (response) {
	          _this5.validatingEmail = false;
	          _this5.userEmailInvalid = response.error;
	        }).catch(function (error) {
	          _this5.validatingEmail = false;
	        });
	      }
	    }
	  }, {
	    key: 'restoreAccountByEmail',
	    value: function restoreAccountByEmail() {
	      var _this6 = this;
	
	      this.validateRestore = true;
	      if (this.recoveryPasswordDataForm.email && this.captchaModel) {
	        this.LoginService.resetPassword(this.recoveryPasswordDataForm.email).then(function (response) {
	          _this6.validateRestore = false;
	          if (!response.error) {
	            _this6.active = 0;
	            _this6.recoveryPasswordDataForm.email = '';
	            _this6.captchaModel = null;
	          }
	          var options = {
	            title: 'Cambio de clave',
	            isHtml: true,
	            content: '<div class="alert alert-success">\n              Se ha enviado una nueva clave de acceso a su correo.\n          </div>',
	            size: '',
	            showBottonCancel: false,
	            textActionCancel: '',
	            textAction: 'Aceptar'
	          };
	          _this6.messageResponse(options);
	        }).catch(function (reason) {
	          var options = {
	            title: 'Cambio de clave',
	            isHtml: true,
	            content: '<div class="alert alert-danger">\n              ' + response.message + '\n          </div>',
	            size: '',
	            showBottonCancel: false,
	            textActionCancel: '',
	            textAction: 'Aceptar'
	          };
	          _this6.messageResponse(options);
	        });
	      }
	    }
	  }, {
	    key: 'messageResponse',
	    value: function messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalResponseView2.default,
	        controller: 'ModalResponseController',
	        controllerAs: 'mdCtrl',
	        size: options.size,
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        if (callAcept) {
	          callback();
	        }
	      }).catch(function (reason) {
	        if (callCancel) {
	          callbackCancel();
	        }
	      });
	    }
	  }]);
	
	  return LoginController;
	}();
	
	LoginController.$inject = inject;
	
	exports.default = LoginController;

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _login = __webpack_require__(269);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _login3 = __webpack_require__(273);
	
	var _login4 = _interopRequireDefault(_login3);
	
	var _modalLoginResponse = __webpack_require__(274);
	
	var _modalLoginResponse2 = _interopRequireDefault(_modalLoginResponse);
	
	var _modalSelectBranchB2bUser = __webpack_require__(275);
	
	var _modalSelectBranchB2bUser2 = _interopRequireDefault(_modalSelectBranchB2bUser);
	
	var _login5 = __webpack_require__(270);
	
	var _login6 = _interopRequireDefault(_login5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loginModule = _angular2.default.module('app.login', []).component('login', _login2.default).controller('ModalSelectBranchController', _modalSelectBranchB2bUser2.default).controller('ModalLoginResponseController', _modalLoginResponse2.default).service('LoginService', _login4.default).config(_login6.default);
	
	exports.default = loginModule;

/***/ },
/* 273 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LoginService = function () {
	  function LoginService($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
	    _classCallCheck(this, LoginService);
	
	    this.$q = $q;
	    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	  }
	
	  _createClass(LoginService, [{
	    key: 'login',
	    value: function login(user, pass) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'POST',
	          url: _this.ngAuthSettings.apiServiceBaseUri + '/login/user-login',
	          data: _this.$httpParamSerializerJQLike({ 'username': user, 'password': pass }),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      var _this2 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this2.$http({
	          method: 'POST',
	          url: _this2.ngAuthSettings.apiServiceBaseUri + _this2.ngAuthSettings.config.paths.userLogout,
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'setOperatingCenter',
	    value: function setOperatingCenter(branchId) {
	      var _this3 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this3.$http({
	          method: 'POST',
	          url: _this3.ngAuthSettings.apiServiceBaseUri + _this3.ngAuthSettings.config.paths.setClientOperatingCenter,
	          data: _this3.$httpParamSerializerJQLike({ 'operatingCenterId': branchId }),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'registerUser',
	    value: function registerUser(userData) {
	      var _this4 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this4.$http({
	          method: 'POST',
	          url: _this4.ngAuthSettings.apiServiceBaseUri + '/terceros/terceros/create',
	          data: userData,
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'resetPassword',
	    value: function resetPassword(user) {
	      var _this5 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this5.$http({
	          method: 'POST',
	          url: _this5.ngAuthSettings.apiServiceBaseUri + '/login/recover-password',
	          data: _this5.$httpParamSerializerJQLike({ 'email': user }),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return LoginService;
	}();
	
	LoginService.$inject = ['$q', '$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];
	
	exports.default = LoginService;

/***/ },
/* 274 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$uibModalInstance', 'modalOptions'];
	
	var ModalLoginResponseController = function () {
	  function ModalLoginResponseController($scope, $uibModalInstance, modalOptions) {
	    _classCallCheck(this, ModalLoginResponseController);
	
	    this.$scope = $scope;
	    this.$uibModalInstance = $uibModalInstance;
	    this.modalOptions = Object.assign({}, modalOptions);
	  }
	
	  _createClass(ModalLoginResponseController, [{
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.$uibModalInstance.close();
	    }
	  }]);
	
	  return ModalLoginResponseController;
	}();
	
	ModalLoginResponseController.$inject = inject;
	
	exports.default = ModalLoginResponseController;

/***/ },
/* 275 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$uibModalInstance', 'modalOptions', 'LoginService', 'SessionService', '$state'];
	
	var ModalSelectBranchController = function () {
	  function ModalSelectBranchController($scope, $uibModalInstance, modalOptions, LoginService, SessionService, $state) {
	    _classCallCheck(this, ModalSelectBranchController);
	
	    this.$scope = $scope;
	    this.LoginService = LoginService;
	    this.$state = $state;
	    this.SessionService = SessionService;
	    this.$uibModalInstance = $uibModalInstance;
	    this.modalOptions = Object.assign({}, modalOptions);
	    this.state = {};
	    this.activate();
	  }
	
	  _createClass(ModalSelectBranchController, [{
	    key: 'activate',
	    value: function activate() {
	      if (this.modalOptions.currentBranch) {
	        this.branchUserB2B = this.modalOptions.currentBranch.id;
	      }
	    }
	  }, {
	    key: 'setOperatingCenter',
	    value: function setOperatingCenter(branchId) {
	      var _this = this;
	
	      this.state.saving = true;
	      this.LoginService.setOperatingCenter(branchId).then(function (response) {
	        _this.state.saving = false;
	        _this.state.saved = true;
	        if (!response.error) {
	          // Set the current client
	          try {
	            _this.modalOptions.userData.currentClient.operatingCenter = response.branch;
	            _this.SessionService.put('globals', _this.modalOptions.userData);
	          } catch (e) {
	            _this.state.saving = false;
	            _this.state.error = true;
	          }
	          _this.$state.go('home.salesHome');
	        } else {
	          _this.state.error = true;
	        }
	      }).catch(function (reason) {
	        _this.state.saving = false;
	        _this.state.error = true;
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.$uibModalInstance.close(this.modalOptions.userData);
	    }
	  }]);
	
	  return ModalSelectBranchController;
	}();
	
	ModalSelectBranchController.$inject = inject;
	
	exports.default = ModalSelectBranchController;

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _orderDetail = __webpack_require__(278);
	
	var _orderDetail2 = _interopRequireDefault(_orderDetail);
	
	var _orderDetailView = __webpack_require__(482);
	
	var _orderDetailView2 = _interopRequireDefault(_orderDetailView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OrderDetailComponent = {
	  template: _orderDetailView2.default,
	  controller: _orderDetail2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = OrderDetailComponent;

/***/ },
/* 277 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.orderDetail', {
	    url: "/orderDetail/{orderId}",
	    template: '<order-detail sh-ctrl="shCtrl"></order-detail>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _syncOrderModalView = __webpack_require__(69);
	
	var _syncOrderModalView2 = _interopRequireDefault(_syncOrderModalView);
	
	var _modalResponseView = __webpack_require__(3);
	
	var _modalResponseView2 = _interopRequireDefault(_modalResponseView);
	
	var _modalDriverView = __webpack_require__(510);
	
	var _modalDriverView2 = _interopRequireDefault(_modalDriverView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'OrderDetailService', '$state', '$rootScope', 'SharedService', '$uibModal', '$timeout', 'Pagination', 'SessionService', '$window', 'ngAuthSettings', '$stateParams'];
	
	var OrderDetailController = function () {
	  function OrderDetailController($scope, OrderDetailService, $state, $rootScope, SharedService, $uibModal, $timeout, Pagination, SessionService, $window, ngAuthSettings, $stateParams) {
	    _classCallCheck(this, OrderDetailController);
	
	    this.$state = $state;
	    this.$scope = $scope;
	    this.$stateParams = $stateParams;
	    this.$timeout = $timeout;
	    this.$rootScope = $rootScope;
	    this.ngAuthSettings = ngAuthSettings;
	    this.$uibModal = $uibModal;
	    this.OrderDetailService = OrderDetailService;
	    this.Pagination = Pagination;
	    this.SharedService = SharedService;
	    this.SessionService = SessionService;
	    this.$window = $window;
	    this.messageNotification = '';
	    this.titleMessageNotification = '';
	    this.orderId = this.$stateParams.orderId;
	    this.orderData = {};
	  }
	
	  _createClass(OrderDetailController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getOrder(this.orderId);
	    }
	  }, {
	    key: 'changeStatus',
	    value: function changeStatus() {
	      var _this = this;
	
	      var globals = this.shCtrl.globals;
	      var sellerId = '';
	
	      try {
	        sellerId = globals.currentUser.sellerId;
	      } catch (e) {}
	      this.orderSaved = false;
	      this.OrderDetailService.changeStatus({ 'id': this.orderData.id, 'sellerId': sellerId, 'estado': this.orderData.estado_documento_id }).then(function (response) {
	        _this.orderSaved = true;
	      }).catch(function (reason) {
	        _this.orderSaved = true;
	      });
	    }
	  }, {
	    key: 'getOrder',
	    value: function getOrder(orderId) {
	      var _this2 = this;
	
	      this.loadingDataOrder = true;
	
	      var globals = this.shCtrl.globals;
	      var userId = '';
	      try {
	        userId = globals.currentUser.userId;
	      } catch (e) {}
	      var sellerId = '';
	      try {
	        sellerId = globals.currentUser.sellerId;
	      } catch (e) {}
	
	      // Send the request
	      this.OrderDetailService.getOrderById({ 'orderId': orderId, 'typeOrders': '', 'userId': userId, 'sellerId': sellerId }).then(function (response) {
	        _this2.loadingDataOrder = false;
	        if (!response.error) {
	          _this2.orderData = response.data.order;
	          _this2.orderData.totalPesoItems = 0;
	          _this2.orderData.cantidadTotalCanasta = 0;
	          response.data.order.items.forEach(function (val) {
	            _this2.orderData.totalPesoItems += val.cantidad * val.peso_embalaje;
	            _this2.orderData.cantidadTotalCanasta += val.cantidad;
	          });
	        }
	      }).catch(function (reason) {
	        _this2.loadingDataOrder = false;
	        alert('Ha ocurrido un error al obtener los datos');
	      });
	    }
	  }, {
	    key: 'showModalDriver',
	    value: function showModalDriver() {
	      var options = {
	        vehiculo_transporte: this.orderData.vehiculo_transporte
	      };
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalDriverView2.default,
	        controller: 'ModalDriverController',
	        controllerAs: 'mdCtrl',
	        size: '',
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function () {}).catch(function (reason) {});
	    }
	  }, {
	    key: 'syncOrder',
	    value: function syncOrder(orderId, orderData) {
	      var options = {
	        orderId: orderId
	      };
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _syncOrderModalView2.default,
	        controller: 'SyncOrderModalController',
	        controllerAs: 'mdCtrl',
	        size: '',
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function (result) {}).catch(function (reason) {});
	    }
	  }, {
	    key: 'payNow',
	    value: function payNow(orderId) {
	      this.$window.location = this.ngAuthSettings.config.env.apiEndPoint + '/order/pay-gate?id=' + orderId;
	    }
	  }, {
	    key: 'messageResponse',
	    value: function messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalResponseView2.default,
	        controller: 'ModalResponseController',
	        controllerAs: 'mdCtrl',
	        size: options.size,
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        if (callAcept) {
	          callback();
	        }
	      }).catch(function (reason) {
	        if (callCancel) {
	          callbackCancel();
	        }
	      });
	    }
	  }]);
	
	  return OrderDetailController;
	}();
	
	OrderDetailController.$inject = inject;
	
	exports.default = OrderDetailController;

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _orderDetail = __webpack_require__(276);
	
	var _orderDetail2 = _interopRequireDefault(_orderDetail);
	
	var _orderDetail3 = __webpack_require__(280);
	
	var _orderDetail4 = _interopRequireDefault(_orderDetail3);
	
	var _orderDetail5 = __webpack_require__(277);
	
	var _orderDetail6 = _interopRequireDefault(_orderDetail5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var orderDetailModule = _angular2.default.module('app.orderDetail', []).component('orderDetail', _orderDetail2.default).service('OrderDetailService', _orderDetail4.default).config(_orderDetail6.default);
	
	exports.default = orderDetailModule;

/***/ },
/* 280 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService', '$httpParamSerializerJQLike'];
	
	var OrderDetailService = function () {
	  function OrderDetailService($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService, $httpParamSerializerJQLike) {
	    _classCallCheck(this, OrderDetailService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	    this.AuthTokenFactory = AuthTokenFactory;
	    this.SharedService = SharedService;
	    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	    this.SessionService = SessionService;
	  }
	
	  _createClass(OrderDetailService, [{
	    key: 'changeStatus',
	    value: function changeStatus(data) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'POST',
	          url: _this.ngAuthSettings.apiServiceBaseUri + _this.ngAuthSettings.config.paths.changeStatus,
	          cache: false,
	          data: _this.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getOrderById',
	    value: function getOrderById(data) {
	      var _this2 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this2.$http({
	          method: 'POST',
	          url: _this2.ngAuthSettings.apiServiceBaseUri + _this2.ngAuthSettings.config.paths.getOrder,
	          cache: false,
	          data: _this2.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'duplicateOrderById',
	    value: function duplicateOrderById(userId, sellerId, orderId) {
	      var _this3 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this3.$http({
	          method: 'POST',
	          url: _this3.ngAuthSettings.apiServiceBaseUri + '/cart/duplicate-order',
	          cache: false,
	          data: { 'userId': userId, 'sellerId': sellerId, 'orderId': orderId }
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'syncOrder',
	    value: function syncOrder(data) {
	      var _this4 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this4.$http({
	          method: 'POST',
	          url: _this4.ngAuthSettings.apiServiceBaseUri + _this4.ngAuthSettings.config.paths.sincronizarPedido,
	          data: _this4.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return OrderDetailService;
	}();
	
	OrderDetailService.$inject = inject;
	
	exports.default = OrderDetailService;

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _orders = __webpack_require__(283);
	
	var _orders2 = _interopRequireDefault(_orders);
	
	var _ordersView = __webpack_require__(483);
	
	var _ordersView2 = _interopRequireDefault(_ordersView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OrdersComponent = {
	  template: _ordersView2.default,
	  controller: _orders2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = OrdersComponent;

/***/ },
/* 282 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.orders', {
	    url: "/orders",
	    template: '<orders sh-ctrl="shCtrl"></orders>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _syncOrderModalView = __webpack_require__(69);
	
	var _syncOrderModalView2 = _interopRequireDefault(_syncOrderModalView);
	
	var _modalResponseView = __webpack_require__(3);
	
	var _modalResponseView2 = _interopRequireDefault(_modalResponseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'OrdersService', '$state', '$rootScope', 'SharedService', '$uibModal', '$timeout', 'Pagination', 'SessionService', '$window'];
	
	var OrdersController = function () {
	  function OrdersController($scope, OrdersService, $state, $rootScope, SharedService, $uibModal, $timeout, Pagination, SessionService, $window) {
	    _classCallCheck(this, OrdersController);
	
	    this.$state = $state;
	    this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.$rootScope = $rootScope;
	    this.$uibModal = $uibModal;
	    this.OrdersService = OrdersService;
	    this.Pagination = Pagination;
	    this.SharedService = SharedService;
	    this.SessionService = SessionService;
	    this.$window = $window;
	    this.searchText = '';
	    this.sortType = 'orderId';
	    this.sortReverse = true;
	    this.userOrders = [];
	    this.summary = [];
	    this.itemsPerPage = 40;
	    this.loadingUserOrders = false;
	    this.loadedUserOrders = false;
	    this.errorloadingUserOrders = false;
	    this.currentPage = 1;
	    this.actualPage = 0;
	  }
	
	  _createClass(OrdersController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getUserOrders();
	      this.getSummaryQuotes();
	    }
	  }, {
	    key: 'duplicateOrder',
	    value: function duplicateOrder(order) {
	      var _this = this;
	
	      this.loadingDuplicateOrders = true;
	      var userId = '',
	          sellerId = '';
	      userId = this.shCtrl.globals.currentUser.userId;
	      try {
	        sellerId = this.shCtrl.globals.currentUser.sellerId;
	      } catch (e) {}
	      this.OrdersService.duplicateOrderById(userId, sellerId, order.orderId).then(function (response) {
	        _this.loadingDuplicateOrders = false;
	        if (!response.error) {
	          _this.SessionService.put('cartId', response.cartId);
	          _this.$state.go('home.cart');
	        } else {
	          alert('No se pudo completar la acción.');
	        }
	      });
	    }
	  }, {
	    key: 'getSummaryQuotes',
	    value: function getSummaryQuotes() {
	      var globals = this.shCtrl.globals;
	
	      var userId = '';
	      try {
	        userId = globals.currentUser.userId;
	      } catch (e) {}
	
	      var sellerId = '';
	      try {
	        sellerId = globals.currentUser.sellerId;
	      } catch (e) {}
	      this.loadingUserOrders = true;
	      this.loadedUserOrders = false;
	      this.errorloadingUserOrders = false;
	
	      if (userId) {
	        this.OrdersService.getSummaryQuotes({ 'userId': userId, 'sellerId': sellerId, 'typeOrders': '' }).then(function (response) {}).catch(function (reason) {});
	      }
	    }
	  }, {
	    key: 'getUserOrders',
	    value: function getUserOrders() {
	      var _this2 = this;
	
	      var globals = this.shCtrl.globals;
	      var userId = '';
	      try {
	        userId = globals.currentUser.userId;
	      } catch (e) {}
	
	      var sellerId = '';
	      try {
	        sellerId = globals.currentUser.sellerId;
	      } catch (e) {}
	
	      this.loadingUserOrders = true;
	      this.loadedUserOrders = false;
	      this.errorloadingUserOrders = false;
	      if (userId) {
	        this.OrdersService.getUserOrders({ 'userId': userId, 'sellerId': sellerId, 'typeOrders': '' }).then(function (response) {
	          _this2.loadingUserOrders = false;
	          _this2.loadedUserOrders = true;
	          _this2.errorloadingUserOrders = false;
	
	          _this2.pagination = _this2.Pagination.getNew(40);
	          _this2.userOrders = response.orders;
	
	          if (_this2.userOrders.ordersQuotes.length > 0) {
	            _this2.pagination.numPages = Math.ceil(_this2.userOrders.ordersQuotes.length / _this2.pagination.perPage);
	
	            // Get the clients
	            _this2.sellerClientsWithOrders = [];
	            _this2.userOrders.ordersQuotes.forEach(function (order) {
	              if (order.applicantName) {
	                if (_this2.sellerClientsWithOrders.indexOf(order.applicantName) === -1) {
	                  _this2.sellerClientsWithOrders.push(order.applicantName);
	                }
	              }
	            });
	          }
	        }).catch(function (reason) {
	          _this2.loadingUserOrders = false;
	          _this2.loadedUserOrders = true;
	          _this2.errorloadingUserOrders = true;
	        });
	      }
	    }
	  }, {
	    key: 'payNow',
	    value: function payNow(orderId) {
	      this.$window.location = this.shCtrl.ngAuthSettings.config.env.apiEndPoint + '/order/pay-gate?id=' + orderId;
	    }
	
	    /**
	     Set item per page on the pagination
	     @method setPagination
	     @param itemsPerPage {Integer} Items per page on the pager
	     @example
	     setpagination(8)
	     */
	
	  }, {
	    key: 'setPagination',
	    value: function setPagination(itemsPerPage) {
	      this.itemsPerPage = itemsPerPage;
	      this.pagination = this.Pagination.getNew(this.itemsPerPage);
	      this.pagination.numPages = Math.ceil(this.userOrders.ordersQuotes.length / this.pagination.perPage);
	    }
	  }, {
	    key: 'changePageOrdes',
	    value: function changePageOrdes(num) {
	      this.actualPage = num - 1;
	    }
	  }, {
	    key: 'syncOrder',
	    value: function syncOrder(orderId, orderData) {
	      var options = {
	        orderId: orderId
	      };
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _syncOrderModalView2.default,
	        controller: 'SyncOrderModalController',
	        controllerAs: 'mdCtrl',
	        size: '',
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function (result) {
	        orderData.sincronizado = result;
	      }).catch(function (reason) {});
	    }
	  }, {
	    key: 'updatePaginationPosition',
	    value: function updatePaginationPosition() {
	      if (this.pagination.page <= this.pagination.numPages - 3) {
	        $('.pagination-items ul').css('margin-left', this.pagination.page * -35 + 'px');
	      }
	    }
	  }, {
	    key: 'messageResponse',
	    value: function messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalResponseView2.default,
	        controller: 'ModalResponseController',
	        controllerAs: 'mdCtrl',
	        size: options.size,
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        if (callAcept) {
	          callback();
	        }
	      }).catch(function (reason) {
	        if (callCancel) {
	          callbackCancel();
	        }
	      });
	    }
	  }]);
	
	  return OrdersController;
	}();
	
	OrdersController.$inject = inject;
	
	exports.default = OrdersController;

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _orders = __webpack_require__(281);
	
	var _orders2 = _interopRequireDefault(_orders);
	
	var _orders3 = __webpack_require__(285);
	
	var _orders4 = _interopRequireDefault(_orders3);
	
	var _orders5 = __webpack_require__(282);
	
	var _orders6 = _interopRequireDefault(_orders5);
	
	var _syncOrderModal = __webpack_require__(286);
	
	var _syncOrderModal2 = _interopRequireDefault(_syncOrderModal);
	
	var _orderDetail = __webpack_require__(279);
	
	var _orderDetail2 = _interopRequireDefault(_orderDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ordersModule = _angular2.default.module('app.orders', [_orderDetail2.default.name]).component('orders', _orders2.default).controller('SyncOrderModalController', _syncOrderModal2.default).service('OrdersService', _orders4.default).config(_orders6.default);
	
	exports.default = ordersModule;

/***/ },
/* 285 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService', '$httpParamSerializerJQLike'];
	
	var OrdersService = function () {
	  function OrdersService($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService, $httpParamSerializerJQLike) {
	    _classCallCheck(this, OrdersService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	    this.AuthTokenFactory = AuthTokenFactory;
	    this.SharedService = SharedService;
	    this.SessionService = SessionService;
	    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	  }
	
	  _createClass(OrdersService, [{
	    key: 'getUserOrders',
	    value: function getUserOrders(data) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'POST',
	          url: _this.ngAuthSettings.apiServiceBaseUri + _this.ngAuthSettings.config.paths.getUserOrders,
	          cache: false,
	          data: _this.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getSummaryQuotes',
	    value: function getSummaryQuotes(data) {
	      var _this2 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this2.$http({
	          method: 'POST',
	          url: _this2.ngAuthSettings.apiServiceBaseUri + _this2.ngAuthSettings.config.paths.getSummaryQuotes,
	          cache: false,
	          data: _this2.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'duplicateOrderById',
	    value: function duplicateOrderById(userId, sellerId, orderId) {
	      var _this3 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this3.$http({
	          method: 'POST',
	          url: _this3.ngAuthSettings.apiServiceBaseUri + '/cart/duplicate-order',
	          cache: false,
	          data: { 'userId': userId, 'sellerId': sellerId, 'orderId': orderId }
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'syncOrder',
	    value: function syncOrder(data) {
	      var _this4 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this4.$http({
	          method: 'POST',
	          url: _this4.ngAuthSettings.apiServiceBaseUri + _this4.ngAuthSettings.config.paths.sincronizarPedido,
	          data: _this4.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return OrdersService;
	}();
	
	OrdersService.$inject = inject;
	
	exports.default = OrdersService;

/***/ },
/* 286 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$uibModalInstance', '$timeout', 'SessionService', 'modalOptions', 'OrdersService'];
	
	var SyncOrderModalController = function () {
	  function SyncOrderModalController($scope, $uibModalInstance, $timeout, SessionService, modalOptions, OrdersService) {
	    _classCallCheck(this, SyncOrderModalController);
	
	    this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.OrdersService = OrdersService;
	    this.SessionService = SessionService;
	    this.$uibModalInstance = $uibModalInstance;
	    this.modalOptions = modalOptions;
	    this.mensajeNotificacion = 'Espere un momento mientras se sincroniza el pedido No. ' + this.modalOptions.orderId;
	    this.activate();
	  }
	
	  _createClass(SyncOrderModalController, [{
	    key: 'activate',
	    value: function activate() {
	      this.syncOrder();
	    }
	  }, {
	    key: 'syncOrder',
	    value: function syncOrder() {
	      var _this = this;
	
	      var orderId = parseInt(this.modalOptions.orderId);
	      this.mensajeNotificacion = 'Espere un momento mientras se sincroniza el pedido No. ' + orderId;
	      this.tituloMensajeNotificacion = 'Sincronización de Pedidos';
	      this.OrdersService.syncOrder(orderId).then(function (response) {
	        _this.mensajeNotificacion = response.message;
	        if (!response.error) {
	          _this.$timeout(function () {
	            _this.ok(response.datos.sincronizado);
	          }, 3000);
	        } else {
	          _this.mensajeNotificacion = 'Lo sentimos el pedido no pudo ser sincronizado. Por favor intentelo nuevamente';
	        }
	      }).catch(function (reason) {
	        _this.mensajeNotificacion = 'Lo sentimos el pedido no pudo ser sincronizado. Por favor intentelo nuevamente';
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.$uibModalInstance.close();
	    }
	  }]);
	
	  return SyncOrderModalController;
	}();
	
	SyncOrderModalController.$inject = inject;
	
	exports.default = SyncOrderModalController;

/***/ },
/* 287 */
[548, 289, 484],
/* 288 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.payZoneDashboard', {
	    url: "/zona-de-pagos/dashboard",
	    template: '<pay-zone-dashboard sh-ctrl="shCtrl"></pay-zone-dashboard>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modalResponseView = __webpack_require__(3);
	
	var _modalResponseView2 = _interopRequireDefault(_modalResponseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'PayZoneDashboardService', '$state', '$rootScope', 'SharedService', '$uibModal'];
	
	var PayZoneDashboardController = function () {
	  function PayZoneDashboardController($scope, PayZoneDashboardService, $state, $rootScope, SharedService, $uibModal) {
	    _classCallCheck(this, PayZoneDashboardController);
	
	    this.$state = $state;
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	    this.$uibModal = $uibModal;
	    this.PayZoneDashboardService = PayZoneDashboardService;
	    this.SharedService = SharedService;
	    this.loanding = false;
	    this.plants = [];
	    this.billfoldResume = null;
	    this.billfoldResumeAll = null;
	    this.loadingBillResume = false;
	  }
	
	  _createClass(PayZoneDashboardController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getPlants();
	    }
	  }, {
	    key: 'getPlants',
	    value: function getPlants() {
	      var _this = this;
	
	      this.PayZoneDashboardService.getPlants(this.shCtrl.globals.currentUser.thirdDocumentNumber).then(function (response) {
	        _this.plants = response;
	        _this.billfoldResumeAll = 0;
	        response.forEach(function (val, index) {
	          if (angular.isString(val.cartera)) val.cartera = parseInt(val.cartera);
	          _this.billfoldResumeAll += val.cartera;
	        });
	        var thirdDocumentNumber = _this.shCtrl.globals.currentClient.third.documentNumber;
	        var branchCode = _this.shCtrl.globals.currentClient.operatingCenter.code;
	        _this.PayZoneDashboardService.getBillFold(thirdDocumentNumber, branchCode).then(function (billfoldResume) {
	          _this.loadingBillResume = false;
	          _this.billfoldResume = billfoldResume;
	        }).catch(function (error) {
	          _this.loadingBillResume = false;
	        });
	      }).catch(function (reason) {});
	    }
	  }, {
	    key: 'messageResponse',
	    value: function messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalResponseView2.default,
	        controller: 'ModalResponseController',
	        controllerAs: 'mdCtrl',
	        size: options.size,
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        if (callAcept) {
	          callback();
	        }
	      }).catch(function (reason) {
	        if (callCancel) {
	          callbackCancel();
	        }
	      });
	    }
	  }]);
	
	  return PayZoneDashboardController;
	}();
	
	PayZoneDashboardController.$inject = inject;
	
	exports.default = PayZoneDashboardController;

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _dashboard = __webpack_require__(287);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _dashboard3 = __webpack_require__(291);
	
	var _dashboard4 = _interopRequireDefault(_dashboard3);
	
	var _dashboard5 = __webpack_require__(288);
	
	var _dashboard6 = _interopRequireDefault(_dashboard5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dashboardModule = _angular2.default.module('app.payZone.dashboard', []).component('payZoneDashboard', _dashboard2.default).service('PayZoneDashboardService', _dashboard4.default).config(_dashboard6.default);
	
	exports.default = dashboardModule;

/***/ },
/* 291 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService'];
	
	var PayZoneDashboardService = function () {
	  function PayZoneDashboardService($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService) {
	    _classCallCheck(this, PayZoneDashboardService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	    this.AuthTokenFactory = AuthTokenFactory;
	    this.SharedService = SharedService;
	    this.SessionService = SessionService;
	  }
	
	  _createClass(PayZoneDashboardService, [{
	    key: 'getPlants',
	    value: function getPlants(documentNumber, reference) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'GET',
	          url: _this.ngAuthSettings.apiServiceBaseUri + '/recaudos/recaudos/cartera-centros-operaciones?terceroDocumento=' + documentNumber + (reference ? '&codigoCentroOperacion=' + reference : ''),
	          cache: true
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return PayZoneDashboardService;
	}();
	
	PayZoneDashboardService.$inject = inject;
	
	exports.default = PayZoneDashboardService;

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _detailZone = __webpack_require__(294);
	
	var _detailZone2 = _interopRequireDefault(_detailZone);
	
	var _detailZoneView = __webpack_require__(485);
	
	var _detailZoneView2 = _interopRequireDefault(_detailZoneView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DetailZoneComponent = {
	  template: _detailZoneView2.default,
	  controller: _detailZone2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = DetailZoneComponent;

/***/ },
/* 293 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.detailZone', {
	    url: "/zona-de-pagos/detalle",
	    template: '<detail-zone sh-ctrl="shCtrl"></detail-zone>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modalResponseView = __webpack_require__(3);
	
	var _modalResponseView2 = _interopRequireDefault(_modalResponseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// let inject = [
	//   '$scope',
	//   'DetailZoneService',
	//   '$state',
	//   '$rootScope',
	//   'SharedService',
	//   '$uibModal',
	//   'DetailedPaymentService',
	//   'AdvanceService'
	// ];
	var inject = ['$scope', 'DetailZoneService', '$state', '$rootScope', 'SharedService', '$uibModal', 'DetailedPaymentService', 'SessionService'];
	
	var DetailZoneController = function () {
	  // constructor ($scope, DetailZoneService, $state, $rootScope, SharedService, $uibModal, DetailedPaymentService, AdvanceService) {
	  function DetailZoneController($scope, DetailZoneService, $state, $rootScope, SharedService, $uibModal, DetailedPaymentService, SessionService) {
	    _classCallCheck(this, DetailZoneController);
	
	    this.$state = $state;
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	    this.DetailedPaymentService = DetailedPaymentService;
	    this.SessionService = SessionService;
	    // this.AdvanceService = AdvanceService;
	    this.$uibModal = $uibModal;
	    this.DetailZoneService = DetailZoneService;
	    this.SharedService = SharedService;
	    this.loanding = false;
	    this.plant = [];
	    this.concepts = [];
	    this.advance = {};
	    this.conceptSelected = null;
	    this.openModal = false;
	    this.conceptSelected = 2;
	    this.payment = {};
	  }
	
	  _createClass(DetailZoneController, [{
	    key: '$onInit',
	    value: function $onInit() {
	
	      this.shCtrl.globals.currentUser.activeTap = 0;
	      this.getDatas();
	      this.copy();
	
	      //this.getBillfold();
	    }
	  }, {
	    key: 'getDatas',
	    value: function getDatas() {
	      if (angular.isUndefined(this.shCtrl.globals.currentUser.payCart)) {
	        this.dataGlobals = this.shCtrl.globals;
	        this.dataGlobals.currentUser.payCart = [];
	        this.dataGlobals.currentUser.totalCartPay = null;
	        this.SessionService.put('globals', this.dataGlobals);
	      }
	    }
	  }, {
	    key: 'prueba',
	    value: function prueba() {
	      console.log("hola");
	    }
	  }, {
	    key: 'getBillfold',
	    value: function getBillfold() {
	
	      //this.payment = result;
	      this.payment.recaudo = 0;
	      this.payment.recaudo_total = 0;
	      // this.DetailedPaymentService.getBillfold('10018629').then(response => {
	      /*this.DetailedPaymentService.getBillfold(this.shCtrl.globals.currentUser.thirdDocumentNumber).then(response => {
	        if(!response) response = [];
	      
	        response.forEach(val => {
	          if(angular.isString(val.detalle_valor_documento)) val.detalle_valor_documento = parseInt(val.detalle_valor_documento);
	          if(angular.isString(val.detalle_saldo_documento)) val.detalle_saldo_documento = parseInt(val.detalle_saldo_documento);
	          this.payment.recaudo += val.detalle_saldo_documento;
	          val.valor_recaudo = val.detalle_saldo_documento;
	          val.numero_documento = val.detalle_numero_documento;
	          val.activate = false;
	          if(val.valor_recaudo < 0){
	            val.operation = 'Saldo a Favor';
	          } else {
	            val.operation = 'Pago completo';
	          }
	        });
	        console.log(this.payment.recaudo );
	        console.log(this.payment.recaudo_total );
	        return;
	          this.bills = response.filter(val =>  {return val.detalle_saldo_documento > 0});
	        this.getTableHeight = 'height: ' + (30 * this.bills.length) + 'px';
	        this.$scope.gridOptions.data = this.bills;
	      });*/
	    }
	  }, {
	    key: 'submitPayment',
	    value: function submitPayment() {
	      if (this.conceptForm.$valid) {
	        var today = new Date();
	        today = today.toISOString().substring(0, 10);
	        if (angular.isString(this.advance.valor)) {
	          this.advance.valor = this.advance.valor.replace(/[,]/g, '');
	          this.advance.valor = parseInt(this.advance.valor);
	        }
	        var result = {
	          advance: this.advance,
	          plant: this.plant,
	          concepto_id: this.conceptSelected,
	          centro_operacion_id: this.plant.id,
	          centro_operacion_code: this.reference,
	          recaudo_total: this.advance.valor,
	          observaciones: this.advance.reference,
	          usuario_creacion: this.shCtrl.globals.currentUser.userId,
	          fecha_creacion: today,
	          facturas: null
	        };
	
	        if (this.conceptSelected === 1) {
	          // this.AdvanceService.setPayment(result);
	          // $location.path('/zona-de-pagos/anticipo');
	        } else {
	          this.DetailedPaymentService.setPayment(result);
	          this.$state.go('home.detailedPayment');
	        }
	      }
	    }
	  }, {
	    key: 'messageResponse',
	    value: function messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalResponseView2.default,
	        controller: 'ModalResponseController',
	        controllerAs: 'mdCtrl',
	        size: options.size,
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        if (callAcept) {
	          callback();
	        }
	      }).catch(function (reason) {
	        if (callCancel) {
	          callbackCancel();
	        }
	      });
	    }
	  }, {
	    key: 'copy',
	    value: function copy() {
	      angular.copy(this.shCtrl.globals.currentUser, this.shCtrl.globals.currentClient);
	    }
	  }]);
	
	  return DetailZoneController;
	}();
	
	DetailZoneController.$inject = inject;
	
	exports.default = DetailZoneController;

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _detailZone = __webpack_require__(292);
	
	var _detailZone2 = _interopRequireDefault(_detailZone);
	
	var _detailZone3 = __webpack_require__(296);
	
	var _detailZone4 = _interopRequireDefault(_detailZone3);
	
	var _detailZone5 = __webpack_require__(293);
	
	var _detailZone6 = _interopRequireDefault(_detailZone5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var detailZoneModule = _angular2.default.module('app.payZone.detailZone', []).component('detailZone', _detailZone2.default).service('DetailZoneService', _detailZone4.default).config(_detailZone6.default);
	
	exports.default = detailZoneModule;

/***/ },
/* 296 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService'];
	
	var DetailZoneService = function () {
	  function DetailZoneService($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService) {
	    _classCallCheck(this, DetailZoneService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	    this.AuthTokenFactory = AuthTokenFactory;
	    this.SharedService = SharedService;
	    this.SessionService = SessionService;
	  }
	
	  _createClass(DetailZoneService, [{
	    key: 'getConcepts',
	    value: function getConcepts() {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'GET',
	          url: _this.ngAuthSettings.apiServiceBaseUri + '/recaudos/recaudos/conceptos-pago',
	          cache: true
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getBriefcase',
	    value: function getBriefcase(thirdDocumentNumber) {
	      var _this2 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this2.$http({
	          method: 'GET',
	          url: _this2.ngAuthSettings.apiServiceBaseUri + '/cartera/cartera/cartera-cliente-cabecera?terceroDocumento=' + thirdDocumentNumber,
	          cache: true
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getBillfold',
	    value: function getBillfold(documentNumber) {
	      var _this3 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this3.$http({
	          method: 'GET',
	          url: _this3.ngAuthSettings.apiServiceBaseUri + '/recaudos/recaudos/facturas-pendientes-co?terceroDocumento=' + documentNumber,
	          cache: true
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return DetailZoneService;
	}();
	
	DetailZoneService.$inject = inject;
	
	exports.default = DetailZoneService;

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _detailedPayment = __webpack_require__(299);
	
	var _detailedPayment2 = _interopRequireDefault(_detailedPayment);
	
	var _detailedPaymentView = __webpack_require__(486);
	
	var _detailedPaymentView2 = _interopRequireDefault(_detailedPaymentView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DetailedPaymentComponent = {
	  template: _detailedPaymentView2.default,
	  controller: _detailedPayment2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = DetailedPaymentComponent;

/***/ },
/* 298 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.detailedPayment', {
	    url: "/zona-de-pagos/pago-detallado",
	    template: '<detailed-payment sh-ctrl="shCtrl"></detailed-payment>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modalResponseView = __webpack_require__(3);
	
	var _modalResponseView2 = _interopRequireDefault(_modalResponseView);
	
	var _modalCommentPaymentView = __webpack_require__(487);
	
	var _modalCommentPaymentView2 = _interopRequireDefault(_modalCommentPaymentView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'DetailedPaymentService', '$state', '$rootScope', 'SharedService', '$uibModal', 'NgTableParams', 'ngAuthSettings'];
	
	var PayZoneDashboardController = function () {
	  function PayZoneDashboardController($scope, DetailedPaymentService, $state, $rootScope, SharedService, $uibModal, NgTableParams, ngAuthSettings) {
	    var _this = this;
	
	    _classCallCheck(this, PayZoneDashboardController);
	
	    this.$state = $state;
	    this.NgTableParams = NgTableParams;
	    this.$scope = $scope;
	    this.ngAuthSettings = ngAuthSettings;
	    this.$rootScope = $rootScope;
	    this.$uibModal = $uibModal;
	    this.DetailedPaymentService = DetailedPaymentService;
	    this.SharedService = SharedService;
	    this.loanding = false;
	    this.payment = {};
	    this.billfoldResume = null;
	    this.tab = 1;
	    this.getTableHeight = 'height: 30px';
	    this.bills = [];
	    this.urlPay = this.ngAuthSettings.config.env.apiEndPoint + '/recaudos/recaudos/pay-gate';
	    this.$scope.gridOptions = {
	      columnDefs: [{
	        field: 'detalle_numero_documento',
	        displayName: 'No. Doc.',
	        enableCellEdit: false,
	        headerCellClass: 'gridHeaderCustom',
	        cellClass: 'gridCellCustom'
	      }, {
	        field: "detalle_fecha_documento",
	        displayName: "Fecha Emisión",
	        enableCellEdit: false,
	        headerCellClass: 'gridHeaderCustom',
	        cellClass: 'gridCellCustom'
	      }, {
	        field: "detalle_fecha_vencimiento",
	        displayName: "Fecha Vencimiento",
	        enableCellEdit: false,
	        headerCellClass: 'gridHeaderCustom',
	        cellClass: 'gridCellCustom'
	      }, {
	        field: "detalle_saldo_documento",
	        displayName: "Vr. pte. de pago",
	        enableCellEdit: false,
	        cellFilter: 'currency',
	        headerCellClass: 'gridHeaderCustom',
	        cellClass: 'gridCellCustom'
	      }, {
	        field: "valor_recaudo",
	        displayName: "Vr. a pagar hoy",
	        cellFilter: 'currency',
	        cellEditableCondition: function cellEditableCondition(scope) {
	          return (scope.row.entity.operation === 'Pago completo' || scope.row.entity.operation === 'Abono') && scope.row.entity.activate;
	        },
	        editableCellTemplate: '<div >\n                                      <input\n                                          type="text"\n                                          class="input-editable"\n                                          restrict-type="numValues"\n                                          ng-class="\'colt\' + col.uid"\n                                          ui-grid-editor\n                                          maxlength="10"\n                                          ng-blur="grid.appScope.$ctrl.changeValor(row.entity)"\n                                          ng-model="MODEL_COL_FIELD"/>\n                                  </div>',
	        headerCellClass: 'gridHeaderCustom',
	        cellClass: 'gridCellCustom'
	      }, {
	        field: "selection",
	        displayName: "-",
	        enableCellEdit: false,
	        enableSorting: false,
	        enableFiltering: false,
	        headerCellClass: 'gridHeaderCustom',
	        cellTemplate: ' <div>\n                              <input\n                                type="checkbox"\n                                ng-model="row.entity.activate"\n                                ng-change="grid.appScope.$ctrl.activateBill(row.entity)"\n                                ng-disabled="row.entity.operation === \'Saldo a Favor\'"\n                                id="check-3">\n                          </div>',
	        cellClass: 'gridCellCustom'
	      }, {
	        field: "operation",
	        rowHeight: 5,
	        displayName: "Operación",
	        enableCellEdit: false,
	        headerCellClass: 'gridHeaderCustom',
	        cellClass: 'gridCellCustom'
	      }],
	      data: this.bills,
	      enableSorting: true,
	      enableFiltering: true,
	      virtualizationThreshold: 100,
	      enableColumnMenus: false,
	      paginationPageSizes: [25, 50, 75],
	      paginationPageSize: 50,
	      enableRowSelection: true,
	      enableGridMenu: false,
	      enableRowHeaderSelection: false,
	      lang: 'es',
	      enableColumnResize: true,
	      multiSelect: false,
	      cellTooltip: true,
	      enableCellEditOnFocus: true,
	      onRegisterApi: function onRegisterApi(gridApi) {
	        _this.$scope.gridApi = gridApi;
	      },
	      enableHorizontalScrollbar: 0
	    };
	  }
	
	  _createClass(PayZoneDashboardController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getDatas();
	    }
	  }, {
	    key: 'getDatas',
	    value: function getDatas() {
	      var _this2 = this;
	
	      var result = this.DetailedPaymentService.getPayment();
	      if (!result) this.$state.go('home.detailZone');else {
	        this.payment = result;
	
	        this.payment.recaudo = 0;
	        this.payment.recaudo_total = 0;
	        // this.DetailedPaymentService.getBillfold('10018629').then(response => {
	        this.DetailedPaymentService.getItemsToFact(this.payment.concepto_id, this.shCtrl.globals.currentUser.thirdDocumentNumber).then(function (response) {
	          if (!response) response = [];
	          response.forEach(function (val) {
	            if (angular.isString(val.detalle_valor_documento)) val.detalle_valor_documento = parseInt(val.detalle_valor_documento);
	            if (angular.isString(val.detalle_saldo_documento)) val.detalle_saldo_documento = parseInt(val.detalle_saldo_documento);
	            _this2.payment.recaudo += val.detalle_saldo_documento;
	            val.valor_recaudo = val.detalle_saldo_documento;
	            val.numero_documento = val.detalle_numero_documento;
	            val.activate = false;
	            if (val.valor_recaudo < 0) {
	              val.operation = 'Saldo a Favor';
	            } else {
	              val.operation = 'Pago completo';
	            }
	          });
	          _this2.bills = response.filter(function (val) {
	            return val.detalle_saldo_documento > 0;
	          });
	          _this2.getTableHeight = 'height: ' + 30 * _this2.bills.length + 'px';
	          _this2.$scope.gridOptions.data = _this2.bills;
	        });
	      }
	    }
	  }, {
	    key: 'getBill',
	    value: function getBill(detalle_numero_documento) {
	      var result = this.bills.filter(function (val) {
	        return val.detalle_numero_documento === detalle_numero_documento;
	      });
	      return result.length ? this.bills.indexOf(result[0]) : false;
	    }
	  }, {
	    key: 'activateBill',
	    value: function activateBill(bill) {
	      // let billIndex = getBill(bill.detalle_numero_documento);
	      if (!bill.activate) {
	        bill.valor_recaudo = bill.detalle_saldo_documento;
	      } else {
	        this.changeValor(bill);
	      }
	      this.changeTotals();
	    }
	  }, {
	    key: 'cancelTransaction',
	    value: function cancelTransaction() {
	      var _this3 = this;
	
	      var options = {
	        title: 'CANCELAR TRANSACCIÓN',
	        isHtml: false,
	        content: '¿Desea cancelar el pago?',
	        showBottonCancel: true,
	        size: 'sm',
	        textActionCancel: 'Cancelar',
	        textAction: 'Continuar Transacción'
	      };
	      this.messageResponse(options, false, null, true, function () {
	        _this3.$state.go('home.detailZone');
	      });
	    }
	  }, {
	    key: 'changeValor',
	    value: function changeValor(bill) {
	      if (angular.isString(bill.valor_recaudo)) {
	        bill.valor_recaudo = bill.valor_recaudo.replace(/[,]/g, '');
	        bill.valor_recaudo = parseInt(bill.valor_recaudo);
	      }
	      if (!bill.valor_recaudo || bill.valor_recaudo == 0) {
	        bill.valor_recaudo = bill.detalle_saldo_documento;
	        bill.operation = 'Pago completo';
	        alert('Valor a pagar es requerido.');
	      } else if (bill.valor_recaudo > bill.detalle_saldo_documento) {
	        bill.valor_recaudo = bill.detalle_saldo_documento;
	        bill.operation = 'Pago completo';
	        alert('Valor a pagar no puede ser mayor al valor del documento.');
	      } else if (bill.valor_recaudo == bill.detalle_saldo_documento) {
	        bill.operation = 'Pago completo';
	      } else if (bill.valor_recaudo < bill.detalle_saldo_documento) {
	        bill.operation = 'Abono';
	      }
	      this.changeTotals();
	    }
	  }, {
	    key: 'changeTotals',
	    value: function changeTotals() {
	      var _this4 = this;
	
	      this.payment.recaudo_total = 0;
	      this.$scope.gridOptions.data.forEach(function (val) {
	        if (val.activate) _this4.payment.recaudo_total += val.valor_recaudo;
	      });
	    }
	  }, {
	    key: 'submitDetail',
	    value: function submitDetail() {
	      this.changeTotals();
	      var result = this.$scope.gridOptions.data.filter(function (val) {
	        return val.activate;
	      });
	      if (result.length) {
	        this.payment.bills = result;
	        this.tab = 2;
	      } else {
	        alert('Debe seleccionar al menos una factura a pagar');
	      }
	    }
	  }, {
	    key: 'openPaymentComment',
	    value: function openPaymentComment() {
	      var _this5 = this;
	
	      var options = {
	        comment: this.payment.observaciones
	      };
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalCommentPaymentView2.default,
	        controller: 'CommentPaymentModalController',
	        controllerAs: 'mdCtrl',
	        size: '',
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	
	      modalInstance.result.then(function (comment) {
	        _this5.payment.observaciones = comment;
	      }).catch(function (reason) {});
	    }
	  }, {
	    key: 'messageResponse',
	    value: function messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalResponseView2.default,
	        controller: 'ModalResponseController',
	        controllerAs: 'mdCtrl',
	        size: options.size,
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        if (callAcept) {
	          callback();
	        }
	      }).catch(function (reason) {
	        if (callCancel) {
	          callbackCancel();
	        }
	      });
	    }
	  }]);
	
	  return PayZoneDashboardController;
	}();
	
	PayZoneDashboardController.$inject = inject;
	
	exports.default = PayZoneDashboardController;

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _detailedPayment = __webpack_require__(297);
	
	var _detailedPayment2 = _interopRequireDefault(_detailedPayment);
	
	var _detailedPayment3 = __webpack_require__(301);
	
	var _detailedPayment4 = _interopRequireDefault(_detailedPayment3);
	
	var _detailedPayment5 = __webpack_require__(298);
	
	var _detailedPayment6 = _interopRequireDefault(_detailedPayment5);
	
	var _modalCommentPayment = __webpack_require__(302);
	
	var _modalCommentPayment2 = _interopRequireDefault(_modalCommentPayment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DetailedPaymentModule = _angular2.default.module('app.payZone.detailedPayment', []).component('detailedPayment', _detailedPayment2.default).service('DetailedPaymentService', _detailedPayment4.default).config(_detailedPayment6.default).controller('CommentPaymentModalController', _modalCommentPayment2.default);
	
	exports.default = DetailedPaymentModule;

/***/ },
/* 301 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService'];
	
	var DetailedPaymentService = function () {
	  function DetailedPaymentService($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService) {
	    _classCallCheck(this, DetailedPaymentService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	    this.AuthTokenFactory = AuthTokenFactory;
	    this.SharedService = SharedService;
	    this.SessionService = SessionService;
	    this.payment = null;
	  }
	
	  _createClass(DetailedPaymentService, [{
	    key: 'getBillfold',
	    value: function getBillfold(documentNumber) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'GET',
	          url: _this.ngAuthSettings.apiServiceBaseUri + '/recaudos/recaudos/facturas-pendientes-co?terceroDocumento=' + documentNumber,
	          cache: true
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getItemsToFact',
	    value: function getItemsToFact(concept, documentNumber) {
	      var _this2 = this;
	
	      return this.$q(function (resolve, reject) {
	        if (concept === 3) {
	          _this2.$http({
	            method: 'GET',
	            url: _this2.ngAuthSettings.apiServiceBaseUri + '/recaudos/recaudos/pedidos-pendientes-co?terceroDocumento=' + documentNumber,
	            cache: true
	          }).then(function (response) {
	            resolve(response.data);
	          }, function (reason) {
	            reject(reason);
	          });
	        } else {
	          _this2.$http({
	            method: 'GET',
	            url: _this2.ngAuthSettings.apiServiceBaseUri + '/recaudos/recaudos/facturas-pendientes-co?terceroDocumento=' + documentNumber,
	            cache: true
	          }).then(function (response) {
	            resolve(response.data);
	          }, function (reason) {
	            reject(reason);
	          });
	        }
	      });
	    }
	  }, {
	    key: 'getPayment',
	    value: function getPayment() {
	      return this.payment;
	    }
	  }, {
	    key: 'setPayment',
	    value: function setPayment(data) {
	      this.payment = data;
	    }
	  }]);
	
	  return DetailedPaymentService;
	}();
	
	DetailedPaymentService.$inject = inject;
	
	exports.default = DetailedPaymentService;

/***/ },
/* 302 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$uibModalInstance', 'modalOptions', '$timeout', 'CartService', 'SessionService'];
	
	var CommentPaymentModalController = function () {
	  function CommentPaymentModalController($scope, $uibModalInstance, modalOptions, $timeout, CartService, SessionService) {
	    _classCallCheck(this, CommentPaymentModalController);
	
	    this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.SessionService = SessionService;
	    this.CartService = CartService;
	    this.$uibModalInstance = $uibModalInstance;
	    this.modalOptions = Object.assign({}, modalOptions);
	    this.comment = this.modalOptions.comment;
	    this.maxlengthComment = 150;
	  }
	
	  // saveOPaymentComment () {
	  //   this.addingCommentCart = true;
	  //   this.addedCommentCart = false;
	  //   this.errorAddedCommentCart = false;
	  //   let data = {
	  //     'cartId': 22,
	  //     'comment': this.comment
	  //   };
	  //
	  //   this.CartService.updateCommentCart(data).then(response => {
	  //     this.addingCommentCart = false;
	  //     if (!response.error) {
	  //       this.addedCommentCart = true;
	  //       this.messageAddedCommentCart = response.message;
	  //       this.$timeout(() => {
	  //         this.ok();
	  //       }, 3000);
	  //     }
	  //     else {
	  //       this.errorAddedCommentCart = true;
	  //     }
	  //   }).catch(reason => {
	  //     this.addingCommentCart = false;
	  //     this.addedCommentCart = false;
	  //     this.errorAddedCommentCart = true;
	  //   });
	  //
	  // }
	
	  _createClass(CommentPaymentModalController, [{
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.$uibModalInstance.close(this.comment);
	    }
	  }]);
	
	  return CommentPaymentModalController;
	}();
	
	CommentPaymentModalController.$inject = inject;
	
	exports.default = CommentPaymentModalController;

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _myPaymentsDetail = __webpack_require__(305);
	
	var _myPaymentsDetail2 = _interopRequireDefault(_myPaymentsDetail);
	
	var _myPaymentsDetailView = __webpack_require__(488);
	
	var _myPaymentsDetailView2 = _interopRequireDefault(_myPaymentsDetailView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MyPaymentsDetailComponent = {
	  template: _myPaymentsDetailView2.default,
	  controller: _myPaymentsDetail2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = MyPaymentsDetailComponent;

/***/ },
/* 304 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.myPaymentsDetail', {
	    url: "/mis-pagos/detalle/{paymentId}",
	    template: '<my-payments-detail sh-ctrl="shCtrl"></my-payments-detail>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modalResponseView = __webpack_require__(3);
	
	var _modalResponseView2 = _interopRequireDefault(_modalResponseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'MyPaymentsDetailService', '$state', '$rootScope', 'SharedService', '$uibModal', 'NgTableParams', '$stateParams'];
	
	var MyPaymentsDetailController = function () {
	  function MyPaymentsDetailController($scope, MyPaymentsDetailService, $state, $rootScope, SharedService, $uibModal, NgTableParams, $stateParams) {
	    _classCallCheck(this, MyPaymentsDetailController);
	
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$scope = $scope;
	    this.NgTableParams = NgTableParams;
	    this.$rootScope = $rootScope;
	    this.$uibModal = $uibModal;
	    this.MyPaymentsDetailService = MyPaymentsDetailService;
	    this.SharedService = SharedService;
	    this.payment = {};
	    this.loandingPayments = false;
	  }
	
	  _createClass(MyPaymentsDetailController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getDatas();
	    }
	  }, {
	    key: 'getDatas',
	    value: function getDatas() {
	      var _this = this;
	
	      var documentNumber = '';
	      try {
	        documentNumber = this.$stateParams.paymentId;
	      } catch (e) {}
	      this.loandingPayments = true;
	
	      this.MyPaymentsDetailService.getPaymentDetail(documentNumber).then(function (response) {
	        if (!response) return _this.$state.go('home.myPaymentsList');
	        _this.payment = response;
	        _this.loandingPayments = false;
	        _this.initTable();
	      }).catch(function (reason) {
	        _this.loandingPayments = false;
	      });
	    }
	  }, {
	    key: 'initTable',
	    value: function initTable() {
	      this.ngTableColsPayList = [{
	        field: "numero_documento",
	        title: "Número Dcto.",
	        sortable: "numero_documento",
	        filter: { "numero_documento": "text" },
	        show: true
	      }, {
	        field: "valor_recaudo",
	        title: "Valor Dcto.",
	        sortable: "valor_recaudo",
	        filter: { "valor_recaudo": "text" },
	        show: true
	      }, {
	        field: "valor_recaudo",
	        title: "Vr. pte. de pago",
	        sortable: "valor_recaudo",
	        filter: { "valor_recaudo": "text" },
	        show: true
	      }, {
	        field: "valor_recaudo",
	        title: "Vr. Pagado",
	        sortable: "valor_recaudo",
	        filter: { "valor_recaudo": "text" },
	        show: true
	      }];
	
	      var initialParams = {
	        count: 20,
	        sorting: { Fecha_Recaudo: "desc" }
	      };
	
	      var initialSettings = {
	        counts: [5, 10, 20],
	        paginationMaxBlocks: 8,
	        paginationMinBlocks: 2,
	        dataset: this.payment.facturas
	      };
	
	      this.ngTableConfigPayList = new this.NgTableParams(initialParams, initialSettings);
	    }
	  }, {
	    key: 'messageResponse',
	    value: function messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalResponseView2.default,
	        controller: 'ModalResponseController',
	        controllerAs: 'mdCtrl',
	        size: options.size,
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        if (callAcept) {
	          callback();
	        }
	      }).catch(function (reason) {
	        if (callCancel) {
	          callbackCancel();
	        }
	      });
	    }
	  }]);
	
	  return MyPaymentsDetailController;
	}();
	
	MyPaymentsDetailController.$inject = inject;
	
	exports.default = MyPaymentsDetailController;

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _myPaymentsDetail = __webpack_require__(303);
	
	var _myPaymentsDetail2 = _interopRequireDefault(_myPaymentsDetail);
	
	var _myPaymentsDetail3 = __webpack_require__(307);
	
	var _myPaymentsDetail4 = _interopRequireDefault(_myPaymentsDetail3);
	
	var _myPaymentsDetail5 = __webpack_require__(304);
	
	var _myPaymentsDetail6 = _interopRequireDefault(_myPaymentsDetail5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var myPaymentsDetailModule = _angular2.default.module('app.payZone.myPaymentsDetail', []).component('myPaymentsDetail', _myPaymentsDetail2.default).service('MyPaymentsDetailService', _myPaymentsDetail4.default).config(_myPaymentsDetail6.default);
	
	exports.default = myPaymentsDetailModule;

/***/ },
/* 307 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService'];
	
	var MyPaymentsDetailService = function () {
	  function MyPaymentsDetailService($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService) {
	    _classCallCheck(this, MyPaymentsDetailService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	    this.AuthTokenFactory = AuthTokenFactory;
	    this.SharedService = SharedService;
	    this.SessionService = SessionService;
	  }
	
	  _createClass(MyPaymentsDetailService, [{
	    key: 'getPaymentDetail',
	    value: function getPaymentDetail(documentNumber) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'GET',
	          url: _this.ngAuthSettings.apiServiceBaseUri + '/recaudos/recaudos/recibos-caja-detalle?documento_id=' + documentNumber,
	          cache: true
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return MyPaymentsDetailService;
	}();
	
	MyPaymentsDetailService.$inject = inject;
	
	exports.default = MyPaymentsDetailService;

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _myPaymentsList = __webpack_require__(310);
	
	var _myPaymentsList2 = _interopRequireDefault(_myPaymentsList);
	
	var _myPaymentsListView = __webpack_require__(489);
	
	var _myPaymentsListView2 = _interopRequireDefault(_myPaymentsListView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MyPaymentsListComponent = {
	  template: _myPaymentsListView2.default,
	  controller: _myPaymentsList2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = MyPaymentsListComponent;

/***/ },
/* 309 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.myPaymentsList', {
	    url: "/mis-pagos/listado",
	    template: '<my-payments-list sh-ctrl="shCtrl"></my-payments-list>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modalResponseView = __webpack_require__(3);
	
	var _modalResponseView2 = _interopRequireDefault(_modalResponseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'MyPaymentsListService', '$state', '$rootScope', 'SharedService', '$uibModal', 'NgTableParams'];
	
	var MyPaymentsListController = function () {
	  function MyPaymentsListController($scope, MyPaymentsListService, $state, $rootScope, SharedService, $uibModal, NgTableParams) {
	    _classCallCheck(this, MyPaymentsListController);
	
	    this.$state = $state;
	    this.$scope = $scope;
	    this.NgTableParams = NgTableParams;
	    this.$rootScope = $rootScope;
	    this.$uibModal = $uibModal;
	    this.MyPaymentsListService = MyPaymentsListService;
	    this.SharedService = SharedService;
	    this.myPayments = {};
	    this.totalPayed = 0;
	    this.loandingPayments = false;
	  }
	
	  _createClass(MyPaymentsListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getDatas();
	    }
	  }, {
	    key: 'getDatas',
	    value: function getDatas() {
	      var _this = this;
	
	      var documentNumber = '';
	      try {
	        documentNumber = this.shCtrl.globals.currentClient.third.id;
	      } catch (e) {
	        documentNumber = this.shCtrl.globals.currentUser.thirdDocumentNumber;
	      }
	      this.loandingPayments = true;
	      // this.MyPaymentsListService.getPeyments(documentNumber).then(response => {
	      this.MyPaymentsListService.getPeyments('890328444').then(function (response) {
	        _this.payments = response;
	        response.forEach(function (val) {
	          if (!val.recaudo_total) val.recaudo_total = 0;else if (angular.isString(val.recaudo_total)) parseInt(val.recaudo_total);
	          _this.totalPayed += val.recaudo_total;
	        });
	        _this.loandingPayments = false;
	        _this.initTable();
	      }).catch(function (reason) {
	        _this.loandingPayments = false;
	      });
	    }
	  }, {
	    key: 'initTable',
	    value: function initTable() {
	      this.ngTableColsPayList = [{
	        field: "fecha_creacion",
	        title: "Fecha",
	        sortable: "fecha_creacion",
	        filter: { "fecha_creacion": "text" },
	        show: true
	      }, {
	        field: "id",
	        title: "Pago",
	        sortable: "id",
	        filter: { "id": "text" },
	        show: true
	      }, {
	        field: "tercero_id",
	        title: "Tercero",
	        sortable: "tercero.nombre",
	        filter: { "tercero.nombre": "text" },
	        show: false
	      }, {
	        field: "estado_pago",
	        title: "Estado",
	        sortable: "estado_pago",
	        filter: { "estado_pago": "text" },
	        show: true
	      }, {
	        field: "recaudo_total",
	        title: "Recaudo",
	        sortable: "recaudo_total",
	        filter: { "recaudo_total": "text" },
	        show: true
	      }, {
	        field: "actions",
	        title: "Acciones",
	        show: true
	      }];
	
	      var initialParams = {
	        count: 20,
	        sorting: { fecha_creacion: "desc" }
	      };
	
	      var initialSettings = {
	        counts: [5, 10, 20],
	        paginationMaxBlocks: 8,
	        paginationMinBlocks: 2,
	        dataset: this.payments
	      };
	
	      this.ngTableConfigPayList = new this.NgTableParams(initialParams, initialSettings);
	    }
	  }, {
	    key: 'messageResponse',
	    value: function messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalResponseView2.default,
	        controller: 'ModalResponseController',
	        controllerAs: 'mdCtrl',
	        size: options.size,
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        if (callAcept) {
	          callback();
	        }
	      }).catch(function (reason) {
	        if (callCancel) {
	          callbackCancel();
	        }
	      });
	    }
	  }]);
	
	  return MyPaymentsListController;
	}();
	
	MyPaymentsListController.$inject = inject;
	
	exports.default = MyPaymentsListController;

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _myPaymentsList = __webpack_require__(308);
	
	var _myPaymentsList2 = _interopRequireDefault(_myPaymentsList);
	
	var _myPaymentsList3 = __webpack_require__(312);
	
	var _myPaymentsList4 = _interopRequireDefault(_myPaymentsList3);
	
	var _myPaymentsList5 = __webpack_require__(309);
	
	var _myPaymentsList6 = _interopRequireDefault(_myPaymentsList5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var myPaymentsListModule = _angular2.default.module('app.payZone.myPaymentsList', []).component('myPaymentsList', _myPaymentsList2.default).service('MyPaymentsListService', _myPaymentsList4.default).config(_myPaymentsList6.default);
	
	exports.default = myPaymentsListModule;

/***/ },
/* 312 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService'];
	
	var MyPaymentsListService = function () {
	  function MyPaymentsListService($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService) {
	    _classCallCheck(this, MyPaymentsListService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	    this.AuthTokenFactory = AuthTokenFactory;
	    this.SharedService = SharedService;
	    this.SessionService = SessionService;
	  }
	
	  _createClass(MyPaymentsListService, [{
	    key: 'getPeyments',
	    value: function getPeyments(documentNumber, branch) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'GET',
	          url: _this.ngAuthSettings.apiServiceBaseUri + '/recaudos/recaudos/recibos-caja-co?terceroDocumento=' + documentNumber,
	          cache: true
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return MyPaymentsListService;
	}();
	
	MyPaymentsListService.$inject = inject;
	
	exports.default = MyPaymentsListService;

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _myPaymentsList = __webpack_require__(311);
	
	var _myPaymentsList2 = _interopRequireDefault(_myPaymentsList);
	
	var _myPaymentsDetail = __webpack_require__(306);
	
	var _myPaymentsDetail2 = _interopRequireDefault(_myPaymentsDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var myPaymentsModule = _angular2.default.module('app.payZone.myPayments', [_myPaymentsList2.default.name, _myPaymentsDetail2.default.name]);
	
	exports.default = myPaymentsModule;

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _dashboard = __webpack_require__(290);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _detailZone = __webpack_require__(295);
	
	var _detailZone2 = _interopRequireDefault(_detailZone);
	
	var _detailedPayment = __webpack_require__(300);
	
	var _detailedPayment2 = _interopRequireDefault(_detailedPayment);
	
	var _response = __webpack_require__(318);
	
	var _response2 = _interopRequireDefault(_response);
	
	var _myPayments = __webpack_require__(313);
	
	var _myPayments2 = _interopRequireDefault(_myPayments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var payZoneModule = _angular2.default.module('app.payZone', [_response2.default.name, _myPayments2.default.name, _dashboard2.default.name, _detailedPayment2.default.name, _detailZone2.default.name]);
	
	exports.default = payZoneModule;

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _response = __webpack_require__(317);
	
	var _response2 = _interopRequireDefault(_response);
	
	var _responseView = __webpack_require__(490);
	
	var _responseView2 = _interopRequireDefault(_responseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResponseComponent = {
	  template: _responseView2.default,
	  controller: _response2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = ResponseComponent;

/***/ },
/* 316 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.payResponse', {
	    url: "/zona-de-pagos/response/{idPay}",
	    template: '<pay-response sh-ctrl="shCtrl"></pay-response>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modalResponseView = __webpack_require__(3);
	
	var _modalResponseView2 = _interopRequireDefault(_modalResponseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'PayResponseService', '$state', '$rootScope', 'SharedService', '$uibModal', '$stateParams'];
	
	var PayResponseController = function () {
	  function PayResponseController($scope, PayResponseService, $state, $rootScope, SharedService, $uibModal, $stateParams) {
	    _classCallCheck(this, PayResponseController);
	
	    this.$state = $state;
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	    this.$uibModal = $uibModal;
	    this.$stateParams = $stateParams;
	    this.PayResponseService = PayResponseService;
	    this.SharedService = SharedService;
	    this.loanding = false;
	    this.payInfo = {};
	  }
	
	  _createClass(PayResponseController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getResponse();
	    }
	  }, {
	    key: 'getResponse',
	    value: function getResponse() {
	      var _this = this;
	
	      this.PayResponseService.getResponse(this.$stateParams.idPay).then(function (_ref) {
	        var data = _ref.data;
	
	
	        _this.payInfo = data;
	        _this.payInfo.Info = _this.payInfo.estado_transaccion == 1 ? "Su Transacción se Realizó Exitosamente" : _this.payInfo.estado_transaccion == 0 ? "Su Transacción se Realizó Exitosamente" : "Su Transacción ha sido rechazada por la pasarela de pagos";
	        _this.payInfo.Summary = _this.payInfo.estado_transaccion == 1 ? "cuyo pago está siendo procesado, pronto le enviaremos un email de confirmación del pago." : _this.payInfo.estado_transaccion == 0 ? "cuyo pago está siendo procesado, pronto le enviaremos un email de confirmación del pago." : "";
	        _this.payInfo.fa = _this.payInfo.estado_transaccion == 1 ? "fa fa-check-square-o" : _this.payInfo.estado_transaccion == 0 ? "fa fa-check-square-o" : "fa fa-times-circle";
	
	        _this.getPaymentDetail();
	      }).catch(function (reason) {});
	    }
	  }, {
	    key: 'messageResponse',
	    value: function messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalResponseView2.default,
	        controller: 'ModalResponseController',
	        controllerAs: 'mdCtrl',
	        size: options.size,
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        if (callAcept) {
	          callback();
	        }
	      }).catch(function (reason) {
	        if (callCancel) {
	          callbackCancel();
	        }
	      });
	    }
	  }, {
	    key: 'getPaymentDetail',
	    value: function getPaymentDetail() {
	      var _this2 = this;
	
	      this.PayResponseService.getPaymentDetail(this.$stateParams.idPay).then(function (response) {
	        _this2.payInfo.facturas = response;
	        console.log(_this2.payInfo.facturas.facturas);
	      }).catch(function (reason) {});
	    }
	  }]);
	
	  return PayResponseController;
	}();
	
	PayResponseController.$inject = inject;
	
	exports.default = PayResponseController;

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _response = __webpack_require__(315);
	
	var _response2 = _interopRequireDefault(_response);
	
	var _response3 = __webpack_require__(319);
	
	var _response4 = _interopRequireDefault(_response3);
	
	var _response5 = __webpack_require__(316);
	
	var _response6 = _interopRequireDefault(_response5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var responseModule = _angular2.default.module('app.payZone.response', []).component('payResponse', _response2.default).service('PayResponseService', _response4.default).config(_response6.default);
	
	exports.default = responseModule;

/***/ },
/* 319 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService'];
	
	var PayResponseService = function () {
	  function PayResponseService($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService) {
	    _classCallCheck(this, PayResponseService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	    this.AuthTokenFactory = AuthTokenFactory;
	    this.SharedService = SharedService;
	    this.SessionService = SessionService;
	  }
	
	  _createClass(PayResponseService, [{
	    key: 'getResponse',
	    value: function getResponse(id) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'GET',
	          url: _this.ngAuthSettings.apiServiceBaseUri + '/recaudos/recaudos/get-pay-info?idRecaudo=' + id,
	          cache: true
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getPaymentDetail',
	    value: function getPaymentDetail(id) {
	      var _this2 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this2.$http({
	          method: 'GET',
	          url: _this2.ngAuthSettings.apiServiceBaseUri + '/recaudos/recaudos/recibos-caja-detalle-local?recaudoId=' + id,
	          cache: true
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return PayResponseService;
	}();
	
	PayResponseService.$inject = inject;
	
	exports.default = PayResponseService;

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _paymentBills = __webpack_require__(322);
	
	var _paymentBills2 = _interopRequireDefault(_paymentBills);
	
	var _paymentBillsView = __webpack_require__(491);
	
	var _paymentBillsView2 = _interopRequireDefault(_paymentBillsView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentBillsComponent = {
	  template: _paymentBillsView2.default,
	  controller: _paymentBills2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = PaymentBillsComponent;

/***/ },
/* 321 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.paymentBills', {
	    url: "/pagos-y-anticipos/facturas",
	    template: '<payment-bills sh-ctrl="shCtrl"></payment-bills>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 322 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'PaymentBillsService', '$state', '$rootScope', 'SharedService', '$timeout', 'ngAuthSettings', 'SessionService', 'NgTableParams', '$uibModal', 'ServiceOrdersService', '$window'];
	
	var PaymentBillsController = function () {
	  function PaymentBillsController($scope, PaymentBillsService, $state, $rootScope, SharedService, $timeout, ngAuthSettings, SessionService, NgTableParams, $uibModal, ServiceOrdersService, $window) {
	    _classCallCheck(this, PaymentBillsController);
	
	    this.$state = $state;
	    this.SessionService = SessionService;
	    this.ngAuthSettings = ngAuthSettings;
	    this.NgTableParams = NgTableParams;
	    this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.$rootScope = $rootScope;
	    this.PaymentBillsService = PaymentBillsService;
	    this.$uibModal = $uibModal;
	    this.SharedService = SharedService;
	    this.ServiceOrdersService = ServiceOrdersService;
	    this.store = $window.localStorage;
	
	    /*    this.loanding = false;
	        this.payment = {};
	        this.billfoldResume = null;
	        this.tab = 1;
	        this.getTableHeight = 'height: 30px';
	        this.bills = [];*/
	    this.urlPay = this.ngAuthSettings.config.env.apiEndPoint + '/recaudos/recaudos/pay-gate';
	    ////////////////////////////////////////////
	    this.serviceOrdersList = null;
	    this.stateServiceOrders = {};
	    this.ngTableConfigServiceOrders = null;
	    this.ngTableColsServiceOrders = null;
	
	    this.serviceOrderDetail = null;
	    this.stateServiceOrderDetail = {};
	    this.ngTableConfigServiceOrderDetail = null;
	    this.ngTableColsServiceOrderDetail = null;
	
	    this.wachingDetailServiceOrder = false;
	
	    this.payment = {};
	    this.payment.recaudo = 0;
	    this.payment.recaudo_total = 0;
	    this.payCart = [];
	    this.globals = null;
	    this.notification = false;
	  }
	
	  _createClass(PaymentBillsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.globals = this.shCtrl.globals;
	      this.getServiceOrdersHead();
	    }
	
	    //////////////////////////////////////////////////////////////////
	
	
	  }, {
	    key: 'getServiceOrdersHead',
	    value: function getServiceOrdersHead() {
	      var _this = this;
	
	      this.stateServiceOrders.loading = true;
	      this.wachingDetailServiceOrder = false;
	
	      this.$timeout(function () {
	        if (_this.serviceOrdersList && _this.serviceOrdersList.length > 0) {
	          _this.stateServiceOrders.loading = false;
	          _this.stateServiceOrders.loaded = true;
	        } else {
	
	          _this.shCtrl.globals.currentUser.thirdDocumentNumber;
	          _this.PaymentBillsService.getItemsToFact(_this.shCtrl.globals.currentUser.thirdDocumentNumber).then(function (response) {
	            _this.stateServiceOrders.loading = false;
	            _this.stateServiceOrders.loaded = true;
	            _this.serviceOrdersList = response;
	
	            _this.serviceOrdersList.forEach(function (value, index) {
	              value.saldo_documento = value.detalle_saldo_documento;
	              value.valor_doc = parseInt(value.detalle_valor_documento);
	              value.valor_pendiente = parseInt(value.detalle_valor_documento);
	              value.valor_pagar_hoy = 0;
	              value.valor_pagar_hoy_before = 0;
	              _this.payment.recaudo += value.valor_pendiente;
	              value.type = "Factura";
	
	              _this.shCtrl.globals.currentClient.payCart.forEach(function (val) {
	                if (value.type == "Factura") {
	                  if (value.detalle_numero_documento == val.detalle_numero_documento) {
	                    value.activate = true;
	                    value.valor_pagar_hoy = val.valor_pagar_hoy;
	                    value.valor_pagar_hoy_before = val.valor_pagar_hoy_before;
	                    value.valor_pendiente = val.valor_pendiente;
	                    value.detalle_saldo_documento = val.detalle_saldo_documento;
	                    _this.payment.recaudo_total += val.valor_pagar_hoy;
	                  }
	                }
	              });
	            });
	            //this.serviceOrdersList = cabeceraData;
	            _this.initNgTableServiceOrders();
	          }).catch(function (reason) {
	            _this.stateServiceOrders.loading = false;
	            _this.stateServiceOrders.loaded = true;
	            _this.stateServiceOrders.error = true;
	          });
	        }
	
	        console.log(_this.stateServiceOrders);
	        console.log(_this.wachingDetailServiceOrder);
	      }, 1000);
	    }
	  }, {
	    key: 'initNgTableServiceOrders',
	    value: function initNgTableServiceOrders() {
	      /**
	       * name:                           "NCN-000024"
	       * type:                             "Lorem Ipsum"
	       * fecha_cotizacion:                 "2016-09-14"
	       * validez_cotizacion:               "2016-09-14"
	       * assigned_user_name:               "Lorem Ipsum"
	       * valor_saldo:                      "0.0000"
	       * valor_pendiente:                  "0.0000"
	       * valor_pagar_hoy:                  "0.0000"
	       * total:                            "0.0000"
	       */
	      this.ngTableColsServiceOrders = [{
	        field: "detalle_numero_documento",
	        title: "No.",
	        // sortable: "detalle_numero_documento",
	        filter: { "detalle_numero_documento": "text" },
	        show: true
	      }, {
	        field: "detalle_fecha_documento",
	        title: "Fecha Emisión",
	        // sortable: "detalle_fecha_documento",
	        filter: { "detalle_fecha_documento": "text" },
	        show: true
	      }, {
	        field: "detalle_fecha_vencimiento",
	        title: "Fecha Vencimiento",
	        // sortable: "detalle_fecha_vencimiento",
	        filter: { "detalle_fecha_vencimiento": "text" },
	        show: true
	      }, {
	        field: "detalle_valor_documento",
	        title: "Vr. total doc.",
	        // sortable: "detalle_valor_documento",
	        filter: { "detalle_valor_documento": "text" },
	        show: true
	      }, {
	        field: "saldo_documento",
	        title: "Vr. Pte. por pagar",
	        // sortable: "saldo_documento",
	        filter: { "saldo_documento": "text" },
	        show: true
	      }, {
	        field: "valor_pagar_hoy",
	        title: "Vr. a pagar hoy",
	        filter: { "valor_pagar_hoy": "text" },
	        show: true
	      }, {
	        field: "selection",
	        title: "Seleccionar",
	        filter: { "selection": "text" },
	        show: true
	      }, {
	        field: "detalle_saldo_documento",
	        title: "Vr. pte. x pagar hoy",
	        filter: { "detalle_saldo_documento": "text" },
	        // // sortable: "detalle_saldo_documento",
	        // filter: { "detalle_saldo_documento": "text" },
	        show: true
	      }];
	
	      var initialParams = {
	        count: 20
	      };
	
	      var initialSettings = {
	        counts: [10, 20, 50],
	        paginationMaxBlocks: 8,
	        paginationMinBlocks: 2,
	        dataset: this.serviceOrdersList
	      };
	
	      this.ngTableConfigServiceOrders = new this.NgTableParams(initialParams, initialSettings);
	    }
	  }, {
	    key: 'activateServiceOrder',
	    value: function activateServiceOrder(row) {
	      if (row.activate) {
	        row.valor_pagar_hoy = row.valor_pendiente;
	        row.valor_pagar_hoy_before = row.valor_pendiente;
	        this.payment.recaudo_total += row.valor_pendiente;
	        row.detalle_saldo_documento = row.detalle_valor_documento - row.valor_pagar_hoy;
	      } else {
	        this.payment.recaudo_total -= row.valor_pagar_hoy_before;
	        row.valor_pagar_hoy = 0;
	        row.valor_pagar_hoy_before = 0;
	        row.detalle_saldo_documento = row.detalle_valor_documento;
	      }
	    }
	  }, {
	    key: 'changeValor',
	    value: function changeValor(row) {
	      var valorServiceOrder = parseInt(row.valor_pagar_hoy.replace(/,/g, ''));
	      if (valorServiceOrder > row.valor_pendiente) {
	        row.valor_pagar_hoy = row.valor_pendiente;
	        valorServiceOrder = row.valor_pendiente;
	      }
	      this.payment.recaudo_total -= row.valor_pagar_hoy_before;
	      this.payment.recaudo_total += valorServiceOrder;
	
	      row.detalle_saldo_documento = row.detalle_valor_documento - valorServiceOrder;
	      row.valor_pagar_hoy_before = valorServiceOrder;
	      row.valor_pagar_hoy = parseInt(row.valor_pagar_hoy.replace(/,/g, ''));
	    }
	  }, {
	    key: 'addPayment',
	    value: function addPayment() {
	      var _this2 = this;
	
	      var result = angular.copy(this.serviceOrdersList.filter(function (val) {
	        return val.activate;
	      }));
	      var globalsData = angular.copy(this.shCtrl.globals);
	      if (result.length) {
	        result.forEach(function (val) {
	          globalsData.currentUser.payCart.forEach(function (value, key) {
	            if (val.detalle_numero_documento == value.detalle_numero_documento) {
	              globalsData.currentUser.payCart.splice(key, 1);
	            }
	          });
	        });
	        globalsData.currentUser.totalCartPay = this.payment.recaudo_total;
	        globalsData.currentUser.payCart.forEach(function (val) {
	          result.push(val);
	          globalsData.currentUser.totalCartPay += val.valor_pagar_hoy;
	        });
	        // globalsData.currentUser.payCart = result;
	        this.shCtrl.globals.currentUser.payCart = result;
	        this.shCtrl.globals.currentUser.totalCartPay = globalsData.currentUser.totalCartPay;
	        this.SessionService.put('globals', this.shCtrl.globals);
	        // this.payment.recaudo_total = 0
	        angular.copy(this.shCtrl.globals.currentUser, this.shCtrl.globals.currentClient);
	        this.notification = true;
	        this.$timeout(function () {
	          // this.shCtrl.globals.currentUser.activeTap = 3;
	          _this2.notification = false;
	        }, 3000);
	      } else {
	        alert('Debe seleccionar al menos una factura a pagar');
	      }
	    }
	  }]);
	
	  return PaymentBillsController;
	}();
	
	PaymentBillsController.$inject = inject;
	
	exports.default = PaymentBillsController;

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _paymentBills = __webpack_require__(320);
	
	var _paymentBills2 = _interopRequireDefault(_paymentBills);
	
	var _paymentBills3 = __webpack_require__(324);
	
	var _paymentBills4 = _interopRequireDefault(_paymentBills3);
	
	var _paymentBills5 = __webpack_require__(321);
	
	var _paymentBills6 = _interopRequireDefault(_paymentBills5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paymentBillsModule = _angular2.default.module('app.paymentBills', []).component('paymentBills', _paymentBills2.default).service('PaymentBillsService', _paymentBills4.default).config(_paymentBills6.default);
	
	exports.default = paymentBillsModule;

/***/ },
/* 324 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PaymentBillsService = function () {
	  function PaymentBillsService($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
	    _classCallCheck(this, PaymentBillsService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	  }
	
	  _createClass(PaymentBillsService, [{
	    key: 'getItemsToFact',
	    value: function getItemsToFact(documentNumber) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'GET',
	          url: _this.ngAuthSettings.apiServiceBaseUri + '/recaudos/recaudos/facturas-pendientes-co?terceroDocumento=' + documentNumber,
	          cache: true
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return PaymentBillsService;
	}();
	
	PaymentBillsService.$inject = ['$q', '$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];
	
	exports.default = PaymentBillsService;

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _paymentCart = __webpack_require__(327);
	
	var _paymentCart2 = _interopRequireDefault(_paymentCart);
	
	var _paymentCartView = __webpack_require__(492);
	
	var _paymentCartView2 = _interopRequireDefault(_paymentCartView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentCartComponent = {
	  template: _paymentCartView2.default,
	  controller: _paymentCart2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = PaymentCartComponent;

/***/ },
/* 326 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.paymentCart', {
	    url: "/pagos-y-anticipos/carrito de pagos",
	    template: '<payment-cart sh-ctrl="shCtrl"></payment-cart>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 327 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'PaymentCartService', '$state', '$rootScope', 'SharedService', '$timeout', 'ngAuthSettings', 'SessionService', 'NgTableParams', '$uibModal', '$window'];
	
	var PaymentCartController = function () {
	  function PaymentCartController($scope, PaymentCartService, $state, $rootScope, SharedService, $timeout, ngAuthSettings, SessionService, NgTableParams, $uibModal, $window) {
	    _classCallCheck(this, PaymentCartController);
	
	    this.$state = $state;
	    this.SessionService = SessionService;
	    this.ngAuthSettings = ngAuthSettings;
	    this.NgTableParams = NgTableParams;
	    this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.$rootScope = $rootScope;
	    this.PaymentCartService = PaymentCartService;
	    this.$uibModal = $uibModal;
	    this.SharedService = SharedService;
	    this.total = null;
	    this.toDay = new Date();
	    this.fecha = null;
	    this.globals = null;
	    this.concepType = 2;
	    this.itemsCart = [];
	    this.totalCartPay = null;
	  }
	
	  _createClass(PaymentCartController, [{
	    key: '$onInit',
	    value: function $onInit() {
	
	      this.fecha = this.toDay.getFullYear() + "-" + (this.toDay.getMonth() + 1) + "-" + this.toDay.getDate();
	      this.globals = this.shCtrl.globals;
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this.globals.currentUser.payCart = [];
	      this.globals.currentUser.totalCartPay = null;
	      this.SessionService.put('globals', this.globals);
	    }
	  }, {
	    key: 'removeItems',
	    value: function removeItems(val) {
	      this.dataTemp = this.globals.currentUser.payCart[val.key].valor_pagar_hoy;
	      this.globals.currentUser.payCart.splice(val.key, 1);
	      this.globals.currentUser.totalCartPay = this.globals.currentUser.totalCartPay - this.dataTemp;
	      angular.copy(this.globals.currentUser, this.globals.currentClient);
	      this.SessionService.put('globals', this.globals);
	    }
	  }]);
	
	  return PaymentCartController;
	}();
	
	PaymentCartController.$inject = inject;
	
	exports.default = PaymentCartController;

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _paymentCart = __webpack_require__(325);
	
	var _paymentCart2 = _interopRequireDefault(_paymentCart);
	
	var _paymentCart3 = __webpack_require__(329);
	
	var _paymentCart4 = _interopRequireDefault(_paymentCart3);
	
	var _paymentCart5 = __webpack_require__(326);
	
	var _paymentCart6 = _interopRequireDefault(_paymentCart5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paymentCartModule = _angular2.default.module('app.paymentCart', []).component('paymentCart', _paymentCart2.default).service('PaymentCartService', _paymentCart4.default).config(_paymentCart6.default);
	exports.default = paymentCartModule;

/***/ },
/* 329 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PaymentCartService = function () {
	  function PaymentCartService($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
	    _classCallCheck(this, PaymentCartService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	  }
	
	  _createClass(PaymentCartService, [{
	    key: 'getItemsToFact',
	    value: function getItemsToFact(documentNumber) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'GET',
	          url: _this.ngAuthSettings.apiServiceBaseUri + '/recaudos/recaudos/facturas-pendientes-co?terceroDocumento=' + documentNumber,
	          cache: true
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return PaymentCartService;
	}();
	
	PaymentCartService.$inject = ['$q', '$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];
	
	exports.default = PaymentCartService;

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _paymentOrders = __webpack_require__(332);
	
	var _paymentOrders2 = _interopRequireDefault(_paymentOrders);
	
	var _paymentOrdersView = __webpack_require__(493);
	
	var _paymentOrdersView2 = _interopRequireDefault(_paymentOrdersView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentOrdersComponent = {
	  template: _paymentOrdersView2.default,
	  controller: _paymentOrders2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = PaymentOrdersComponent;

/***/ },
/* 331 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.paymentOrders', {
	    url: "/pagos-y-anticipos/pedidos",
	    template: '<payment-orders sh-ctrl="shCtrl"></payment-orders>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 332 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'ServiceOrdersService', '$state', '$rootScope', 'SharedService', '$timeout', 'ngAuthSettings', 'SessionService', 'NgTableParams', '$uibModal', 'PaymentOrdersService'];
	
	var PaymentOrdersController = function () {
	  function PaymentOrdersController($scope, ServiceOrdersService, $state, $rootScope, SharedService, $timeout, ngAuthSettings, SessionService, NgTableParams, $uibModal, PaymentOrdersService) {
	    _classCallCheck(this, PaymentOrdersController);
	
	    this.$state = $state;
	    this.SessionService = SessionService;
	    this.ngAuthSettings = ngAuthSettings;
	    this.NgTableParams = NgTableParams;
	    // this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.$rootScope = $rootScope;
	    this.ServiceOrdersService = ServiceOrdersService;
	    this.$uibModal = $uibModal;
	    this.SharedService = SharedService;
	    this.PaymentOrdersService = PaymentOrdersService;
	
	    this.serviceOrdersList = null;
	    this.stateServiceOrders = {};
	    this.ngTableConfigServiceOrders = null;
	    this.ngTableColsServiceOrders = null;
	
	    this.serviceOrderDetail = null;
	    this.stateServiceOrderDetail = {};
	    this.ngTableConfigServiceOrderDetail = null;
	    this.ngTableColsServiceOrderDetail = null;
	
	    this.wachingDetailServiceOrder = false;
	
	    this.payment = {};
	    this.payment.recaudo = 0;
	    this.payment.recaudo_total = 0;
	  }
	
	  _createClass(PaymentOrdersController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getServiceOrdersHead();
	    }
	
	    //////////////////////////////////////////////////////////////////
	
	
	  }, {
	    key: 'getServiceOrdersHead',
	    value: function getServiceOrdersHead() {
	      var _this = this;
	
	      var cabeceraData = [{
	        "number": "NCN-000024",
	        "type": "Lorem Ipsum",
	        "fecha_cotizacion": "2017-02-10",
	        "validez_cotizacion": "2017-02-10",
	        "assigned_user_name": "Lorem Ipsum",
	        "valor_doc": "55680.000000",
	        "valor_pendiente": "55680.000000",
	        "valor_pagar_hoy": "0",
	        "total": "55680.000000"
	      }];
	
	      this.stateServiceOrders.loading = true;
	      this.wachingDetailServiceOrder = false;
	      this.$timeout(function () {
	        if (_this.serviceOrdersList && _this.serviceOrdersList.length > 0) {
	
	          _this.stateServiceOrders.loading = false;
	          _this.stateServiceOrders.loaded = true;
	        } else {
	
	          //this.shCtrl.globals.currentUser.thirdDocumentNumber
	          _this.PaymentOrdersService.getItemsToFact(_this.shCtrl.globals.currentUser.thirdDocumentNumber).then(function (response) {
	
	            _this.stateServiceOrders.loading = false;
	            _this.stateServiceOrders.loaded = true;
	            _this.serviceOrdersList = response;
	            _this.serviceOrdersList.forEach(function (value, index) {
	              value.valor_doc = parseInt(value.detalle_valor_documento);
	              value.valor_pendiente = parseInt(value.detalle_valor_documento);
	              value.valor_pagar_hoy = value.detalle_saldo_documento * 30 / 100;
	              value.valor_pagar_hoy_before = value.detalle_saldo_documento * 30 / 100;
	              _this.payment.recaudo += value.valor_pendiente;
	              value.type = "Pedidos";
	
	              _this.shCtrl.globals.currentClient.payCart.forEach(function (val) {
	                if (value.type == "Pedidos") {
	                  if (value.detalle_numero_documento == val.detalle_numero_documento) {
	                    value.activate = true;
	                    value.valor_pagar_hoy = val.valor_pagar_hoy;
	                    value.valor_pagar_hoy_before = val.valor_pagar_hoy_before;
	                    value.valor_pendiente = val.valor_pendiente;
	                    value.detalle_saldo_documento = val.detalle_saldo_documento;
	                    _this.payment.recaudo_total += val.valor_pagar_hoy;
	                  }
	                }
	              });
	            });
	            console.log("Pedidos", _this.serviceOrdersList);
	            //this.serviceOrdersList = cabeceraData;
	
	            _this.initNgTableServiceOrders();
	          }).catch(function (reason) {
	            _this.stateServiceOrders.loading = false;
	            _this.stateServiceOrders.loaded = true;
	            _this.stateServiceOrders.error = true;
	          });
	        }
	      }, 1000);
	    }
	  }, {
	    key: 'initNgTableServiceOrders',
	    value: function initNgTableServiceOrders() {
	      /**
	       * name:                           "NCN-000024"
	       * type:                             "Lorem Ipsum"
	       * fecha_cotizacion:                 "2016-09-14"
	       * validez_cotizacion:               "2016-09-14"
	       * assigned_user_name:               "Lorem Ipsum"
	       * valor_saldo:                      "0.0000"
	       * valor_pendiente:                  "0.0000"
	       * valor_pagar_hoy:                  "0.0000"
	       * total:                            "0.0000"
	       */
	      this.ngTableColsServiceOrders = [{
	        field: "detalle_numero_documento",
	        title: "No.",
	        //sortable: "detalle_numero_documento",
	        filter: { "detalle_numero_documento": "text" },
	        show: true
	      }, {
	        field: "detalle_fecha_documento",
	        title: "Fecha Emisión",
	        //sortable: "detalle_fecha_documento",
	        filter: { "detalle_fecha_documento": "text" },
	        show: true
	      },
	      // {
	      //   field: "detalle_fecha_vencimiento",
	      //   title: "Fecha Vencimiento",
	      //   sortable: "detalle_fecha_vencimiento",
	      //   filter: { "detalle_fecha_vencimiento": "text" },
	      //   show: true
	      // },
	      {
	        field: "detalle_valor_documento",
	        title: "Vr. pte. de pago",
	        //sortable: "detalle_valor_documento",
	        filter: { "detalle_valor_documento": "text" },
	        show: true
	      }, {
	        field: "valor_pagar_hoy",
	        //sortable:"valor_pagar_hoy",
	        filter: { "valor_pagar_hoy": "text" },
	        title: "Vr. a pagar hoy",
	        show: true
	      }, {
	        field: "selection",
	        title: "Seleccionar",
	        filter: { "selection": "text" },
	        show: true
	      }, {
	        field: "detalle_saldo_documento",
	        title: "Vr. pte pagar hoy",
	        //sortable: "detalle_saldo_documento",
	        filter: { "detalle_saldo_documento": "text" },
	        show: true
	      }];
	
	      var initialParams = {
	        count: 20
	      };
	
	      var initialSettings = {
	        counts: [10, 20, 50],
	        paginationMaxBlocks: 8,
	        paginationMinBlocks: 2,
	        dataset: this.serviceOrdersList
	      };
	
	      this.ngTableConfigServiceOrders = new this.NgTableParams(initialParams, initialSettings);
	    }
	  }, {
	    key: 'activateServiceOrder',
	    value: function activateServiceOrder(row) {
	      if (row.activate) {
	        row.valor_pagar_hoy = row.valor_pendiente * 30 / 100;
	        row.valor_pagar_hoy_before = row.valor_pendiente * 30 / 100;
	        this.payment.recaudo_total += row.valor_pendiente * 30 / 100;
	        row.detalle_saldo_documento = row.detalle_valor_documento - row.valor_pagar_hoy;
	      } else {
	        this.payment.recaudo_total -= row.valor_pagar_hoy_before;
	        row.valor_pagar_hoy = row.valor_pendiente * 30 / 100;;
	        row.valor_pagar_hoy_before = row.valor_pendiente * 30 / 100;;
	        row.detalle_saldo_documento = row.detalle_valor_documento;
	      }
	    }
	  }, {
	    key: 'changeValor',
	    value: function changeValor(row) {
	      var valorServiceOrder = parseInt(row.valor_pagar_hoy.replace(/,/g, ''));
	      if (valorServiceOrder > row.valor_pendiente) {
	        row.valor_pagar_hoy = row.valor_pendiente * 30 / 100;
	        valorServiceOrder = row.valor_pendiente * 30 / 100;
	      } else if (valorServiceOrder < row.valor_pendiente * 30 / 100) {
	        row.valor_pagar_hoy = row.valor_pendiente * 30 / 100;
	        valorServiceOrder = row.valor_pendiente * 30 / 100;
	      }
	      this.payment.recaudo_total -= row.valor_pagar_hoy_before;
	      this.payment.recaudo_total += valorServiceOrder;
	
	      row.detalle_saldo_documento = row.detalle_valor_documento - valorServiceOrder;
	      row.valor_pagar_hoy_before = valorServiceOrder;
	      row.valor_pagar_hoy = parseInt(row.valor_pagar_hoy.replace(/,/g, ''));
	    }
	  }, {
	    key: 'addPayment',
	    value: function addPayment() {
	      var _this2 = this;
	
	      var result = angular.copy(this.serviceOrdersList.filter(function (val) {
	        return val.activate;
	      }));
	      var globalsData = angular.copy(this.shCtrl.globals);
	      if (result.length) {
	        result.forEach(function (val) {
	          globalsData.currentUser.payCart.forEach(function (value, key) {
	            if (val.detalle_numero_documento == value.detalle_numero_documento) {
	              globalsData.currentUser.payCart.splice(key, 1);
	            }
	          });
	        });
	
	        globalsData.currentUser.totalCartPay = this.payment.recaudo_total;
	        globalsData.currentUser.payCart.forEach(function (val) {
	          result.push(val);
	          globalsData.currentUser.totalCartPay += val.valor_pagar_hoy;
	        });
	        // globalsData.currentUser.payCart = result;
	        this.shCtrl.globals.currentUser.payCart = result;
	        this.shCtrl.globals.currentUser.totalCartPay = globalsData.currentUser.totalCartPay;
	        this.SessionService.put('globals', this.shCtrl.globals);
	        // this.payment.recaudo_total = 0;
	        angular.copy(this.shCtrl.globals.currentUser, this.shCtrl.globals.currentClient);
	        this.notification = true;
	        this.$timeout(function () {
	          // this.shCtrl.globals.currentUser.activeTap = 3;
	          _this2.notification = false;
	        }, 3000);
	      } else {
	        alert('Debe seleccionar al menos un pedido a pagar');
	      }
	    }
	  }]);
	
	  return PaymentOrdersController;
	}();
	
	PaymentOrdersController.$inject = inject;
	
	exports.default = PaymentOrdersController;

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _paymentOrders = __webpack_require__(330);
	
	var _paymentOrders2 = _interopRequireDefault(_paymentOrders);
	
	var _paymentOrders3 = __webpack_require__(334);
	
	var _paymentOrders4 = _interopRequireDefault(_paymentOrders3);
	
	var _paymentOrders5 = __webpack_require__(331);
	
	var _paymentOrders6 = _interopRequireDefault(_paymentOrders5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paymentOrdersModule = _angular2.default.module('app.paymentOrders', []).component('paymentOrders', _paymentOrders2.default).service('PaymentOrdersService', _paymentOrders4.default).config(_paymentOrders6.default);
	
	exports.default = paymentOrdersModule;

/***/ },
/* 334 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PaymentOrdersService = function () {
	  function PaymentOrdersService($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
	    _classCallCheck(this, PaymentOrdersService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	  }
	
	  _createClass(PaymentOrdersService, [{
	    key: 'getServiceOrdersHead',
	    value: function getServiceOrdersHead(userDocument) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'GET',
	          url: _this.ngAuthSettings.apiServiceBaseUri + '/' + _this.ngAuthSettings.config.paths.PAYMENT_ADVANCED.ORDERS_SERVICE_HEAD + (userDocument ? '?valor=' + userDocument : ''),
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getServiceOrdersDetail',
	    value: function getServiceOrdersDetail(documentNumber) {
	      var _this2 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this2.$http({
	          method: 'GET',
	          url: _this2.ngAuthSettings.apiServiceBaseUri + '/' + _this2.ngAuthSettings.config.paths.PAYMENT_ADVANCED.ORDERS_SERVICE_DETAIL + (documentNumber ? '?valor=' + documentNumber : ''),
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'userUpdate',
	    value: function userUpdate(data) {
	      var _this3 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this3.$http({
	          method: 'POST',
	          url: _this3.ngAuthSettings.apiServiceBaseUri + '/' + _this3.ngAuthSettings.config.paths.userUpdate,
	          data: _this3.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getItemsToFact',
	    value: function getItemsToFact(documentNumber) {
	      var _this4 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this4.$http({
	          method: 'GET',
	          url: _this4.ngAuthSettings.apiServiceBaseUri + '/recaudos/recaudos/pedidos-pendientes-co?terceroDocumento=' + documentNumber,
	          cache: true
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return PaymentOrdersService;
	}();
	
	PaymentOrdersService.$inject = ['$q', '$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];
	
	exports.default = PaymentOrdersService;

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _quotations = __webpack_require__(339);
	
	var _quotations2 = _interopRequireDefault(_quotations);
	
	var _serviceOrders = __webpack_require__(344);
	
	var _serviceOrders2 = _interopRequireDefault(_serviceOrders);
	
	var _paymentOrders = __webpack_require__(333);
	
	var _paymentOrders2 = _interopRequireDefault(_paymentOrders);
	
	var _paymentBills = __webpack_require__(323);
	
	var _paymentBills2 = _interopRequireDefault(_paymentBills);
	
	var _paymentCart = __webpack_require__(328);
	
	var _paymentCart2 = _interopRequireDefault(_paymentCart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paymentsAdvancesModule = _angular2.default.module('app.paymentsAdvances', [_quotations2.default.name, _serviceOrders2.default.name, _paymentOrders2.default.name, _paymentBills2.default.name, _paymentCart2.default.name]);
	
	exports.default = paymentsAdvancesModule;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _quotations = __webpack_require__(338);
	
	var _quotations2 = _interopRequireDefault(_quotations);
	
	var _quotationsView = __webpack_require__(494);
	
	var _quotationsView2 = _interopRequireDefault(_quotationsView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotationsComponent = {
	  template: _quotationsView2.default,
	  controller: _quotations2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = QuotationsComponent;

/***/ },
/* 337 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.quotations', {
	    url: "/pagos-y-anticipos/cotizaciones/{orderServiceId}",
	    template: '<quotations sh-ctrl="shCtrl"></quotations>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 338 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'QuotationsService', '$state', '$rootScope', 'SharedService', '$timeout', 'ngAuthSettings', 'SessionService', 'NgTableParams', '$uibModal', '$stateParams', 'ServiceOrdersService'];
	
	var QuotationsController = function () {
	  function QuotationsController($scope, QuotationsService, $state, $rootScope, SharedService, $timeout, ngAuthSettings, SessionService, NgTableParams, $uibModal, $stateParams, ServiceOrdersService) {
	    _classCallCheck(this, QuotationsController);
	
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.SessionService = SessionService;
	    this.ngAuthSettings = ngAuthSettings;
	    this.NgTableParams = NgTableParams;
	    // this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.$rootScope = $rootScope;
	    this.QuotationsService = QuotationsService;
	    this.ServiceOrdersService = ServiceOrdersService;
	    this.$uibModal = $uibModal;
	    this.SharedService = SharedService;
	
	    this.quotationsList = null;
	    this.stateQuotations = {};
	    this.ngTableConfigQuotations = null;
	    this.ngTableColsQuotations = null;
	
	    this.quotationDetail = null;
	    this.stateQuotationDetail = {};
	    this.ngTableConfigQuotationDetail = null;
	    this.ngTableColsQuotationDetail = null;
	    this.currentQuote = {};
	
	    this.wachingDetailQuotation = false;
	
	    this.payment = {};
	    this.payment.recaudo = 0;
	    this.payment.recaudo_total = 0;
	
	    this.orderServiceId = this.$stateParams.orderServiceId || null;
	  }
	
	  _createClass(QuotationsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getQuotationsHead();
	    }
	
	    //encabezado de la cotizacion
	
	  }, {
	    key: 'getQuotationsHead',
	    value: function getQuotationsHead() {
	      var _this = this;
	
	      this.stateQuotations.loading = true;
	      this.wachingDetailQuotation = false;
	      this.$timeout(function () {
	        if (_this.quotationsList && _this.quotationsList.length > 0) {
	          _this.stateQuotations.loading = false;
	          _this.stateQuotations.loaded = true;
	        } else {
	          //this.shCtrl.globals.currentUser.thirdDocumentNumber
	          var promiseQuotations = _this.orderServiceId ? _this.ServiceOrdersService.getServiceOrdersDetail(_this.orderServiceId) : _this.QuotationsService.getQuotationsHead(_this.shCtrl.globals.currentUser.thirdDocumentNumber);
	          promiseQuotations.then(function (response) {
	            _this.stateQuotations.loading = false;
	            _this.stateQuotations.loaded = true;
	            if (response.length) {
	              if (_this.orderServiceId) {
	                response.splice(response.length - 1, 1);
	              }
	
	              _this.quotationsList = response;
	              _this.quotationsList.forEach(function (value, index) {
	                value.valor_doc = parseInt(value.total);
	              });
	              //this.quotationsList = cabeceraData;
	              console.log(response);
	              _this.initNgTableQuotations();
	            }
	          }).catch(function (reason) {
	            _this.stateQuotations.loading = false;
	            _this.stateQuotations.loaded = true;
	            _this.stateQuotations.error = true;
	          });
	        }
	      }, 1000);
	    }
	  }, {
	    key: 'changeValor',
	    value: function changeValor(row) {
	      var valorServiceOrder = angular.copy(parseInt(row.valor_pagar_hoy.replace(/,/g, '')));
	
	      if (valorServiceOrder > row.valor_pendiente) {
	        row.valor_pagar_hoy = row.valor_pendiente * 30 / 100;
	        valorServiceOrder = row.valor_pendiente * 30 / 100;
	      } else if (valorServiceOrder < row.valor_pendiente * 30 / 100) {
	
	        row.valor_pagar_hoy = row.valor_pendiente * 30 / 100;
	        valorServiceOrder = row.valor_pendiente * 30 / 100;
	      }
	
	      this.payment.recaudo_total -= row.valor_pagar_hoy_before;
	      this.payment.recaudo_total += valorServiceOrder;
	
	      row.detalle_saldo_documento = row.detalle_valor_documento - valorServiceOrder;
	      row.valor_pagar_hoy_before = valorServiceOrder;
	      row.valor_pagar_hoy = parseInt(row.valor_pagar_hoy.replace(/,/g, ''));
	    }
	  }, {
	    key: 'activateQuotation',
	    value: function activateQuotation(row) {
	      console.log(row);
	      if (row.activate) {
	        row.valor_pagar_hoy = row.valor_pendiente * 30 / 100;
	        row.valor_pagar_hoy_before = row.valor_pendiente * 30 / 100;
	        this.payment.recaudo_total += row.valor_pendiente * 30 / 100;
	      } else {
	        this.payment.recaudo_total -= row.valor_pagar_hoy_before;
	        row.valor_pagar_hoy = row.valor_pendiente * 30 / 100;
	        row.valor_pagar_hoy_before = row.valor_pendiente * 30 / 100;
	      }
	    }
	  }, {
	    key: 'initNgTableQuotations',
	    value: function initNgTableQuotations() {
	      /**
	       * name:                           "NCN-000024"
	       * type:                             "Lorem Ipsum"
	       * fecha_cotizacion:                 "2016-09-14"
	       * validez_cotizacion:               "2016-09-14"
	       * assigned_user_name:               "Lorem Ipsum"
	       * valor_saldo:                      "0.0000"
	       * valor_pendiente:                  "0.0000"
	       * valor_pagar_hoy:                  "0.0000"
	       * total:                            "0.0000"
	       */
	      this.ngTableColsQuotations = [{
	        field: "name",
	        title: "No.",
	        // sortable: "name",
	        filter: { "name": "text" },
	        show: true
	      }, {
	        field: "fecha_cotizacion",
	        title: "F. Elaboración",
	        // sortable: "fecha_cotizacion",
	        filter: { "fecha_cotizacion": "text" },
	        show: true
	      }, {
	        field: "validez_cotizacion",
	        title: "F. Vencimiento",
	        // sortable: "validez_cotizacion",
	        filter: { "validez_cotizacion": "text" },
	        show: true
	      }, {
	        field: "assigned_user_name",
	        title: "Vendedor",
	        // sortable: "assigned_user_name",
	        filter: { "assigned_user_name": "text" },
	        show: true
	      }, {
	        field: "subtotal",
	        title: "Subtotal",
	        // sortable: "subtotal",
	        filter: { "subtotal": "text" },
	        show: true
	      }, {
	        field: "impuestos",
	        title: "Iva",
	        // sortable: "impuestos",
	        filter: { "impuestos": "text" },
	        show: true
	      }, {
	        field: "valor_doc",
	        title: "Vr. Doc.",
	        // sortable: "valor_doc",
	        filter: { "valor_doc": "text" },
	        show: true
	      },
	      /*{
	        field: "valor_pagar_hoy",
	        title: "Vr. a pagar hoy",
	        show: true
	      },*/
	      /*{
	        field: "selection",
	        title: "",
	        show: true
	      },*/
	      {
	        field: "actions",
	        title: "Acciones",
	        show: true
	      }];
	
	      var initialParams = {
	        count: 20,
	        sorting: { fecha_cotizacion: "desc" }
	      };
	
	      var initialSettings = {
	        counts: [5, 10, 20],
	        paginationMaxBlocks: 8,
	        paginationMinBlocks: 2,
	        dataset: this.quotationsList
	      };
	
	      this.ngTableConfigQuotations = new this.NgTableParams(initialParams, initialSettings);
	    }
	
	    //funcion del detalle de la cotizacion
	
	  }, {
	    key: 'getQuotationDetail',
	    value: function getQuotationDetail(document) {
	      var _this2 = this;
	
	      this.payment.recaudo = 0;
	      this.currentQuote.number = document.name;
	      this.currentQuote.value = document.valor_doc;
	      this.currentQuote.elaborationDate = document.fecha_cotizacion;
	      this.currentQuote.expirationDate = document.validez_cotizacion;
	      this.currentQuote.assigned_user_name = document.assigned_user_name;
	      this.wachingDetailQuotation = true;
	      this.stateQuotationDetail.loading = true;
	      //this.$timeout(()=>{
	      this.QuotationsService.getQuotationsDetail(document.name).then(function (response) {
	        _this2.stateQuotationDetail.loading = false;
	        _this2.stateQuotationDetail.loaded = true;
	        _this2.quotationDetail = response;
	        _this2.payment.recaudo_total = 0;
	        _this2.quotationDetail.forEach(function (value, index) {
	          value.detalle_numero_documento = document.name;
	          value.assigned_user_name = response.assigned_user_name;
	          if (value.descripcion_item.length > 30) {
	            value.descriptionShort = value.descripcion_item.slice(0, 30) + '...';
	            value.short = true;
	          } else {
	            value.descriptionShort = value.descripcion_item;
	            value.short = false;
	          }
	          value.vr_unit = parseInt(value.vr_unit);
	          value.cantidad = parseInt(value.cantidad);
	          value.vr_total = parseInt(value.vr_total);
	          value.porcentaje_descuento = parseInt(value.porcentaje_descuento);
	          value.descuento_moneda = parseInt(value.descuento_moneda) || value.vr_unit * (value.porcentaje_descuento / 100);
	          value.impuestos = parseInt(value.impuestos);
	          value.valor_pendiente = parseInt(value.vr_total);
	          value.valor_pagar_hoy = value.vr_total * 30 / 100;
	          value.valor_pagar_hoy_before = value.vr_total * 30 / 100;
	          _this2.payment.recaudo += value.valor_pendiente;
	          value.type = "Cotización";
	
	          _this2.shCtrl.globals.currentClient.payCart.forEach(function (val) {
	            if (value.type == "Cotización") {
	              if (value.detalle_numero_documento == val.detalle_numero_documento) {
	                if (value.referencia == val.referencia) {
	                  value.activate = true;
	                  value.valor_pagar_hoy = val.valor_pagar_hoy;
	                  value.valor_pagar_hoy_before = val.valor_pagar_hoy_before;
	                  value.valor_pendiente = val.valor_pendiente;
	                  _this2.payment.recaudo_total += val.valor_pagar_hoy;
	                }
	              }
	            }
	          });
	        });
	
	        _this2.initNgTableQuotationDetail();
	      }).catch(function (reason) {
	        _this2.stateQuotationDetail.loading = false;
	        _this2.stateQuotationDetail.loaded = true;
	        _this2.stateQuotationDetail.error = true;
	      });
	      //}, 1000);
	    }
	    //Tabla del detalle de cotizacion
	
	  }, {
	    key: 'initNgTableQuotationDetail',
	    value: function initNgTableQuotationDetail() {
	      /**
	       * nombre:                     "Estufa verde a gas"
	       * referencia:                 "981323"
	       * cantidad:                   "5"
	       * unidad_medida:              "BOLSA"
	       * vr_unit:                    "0.0000"
	       * descuento:                  "0.0000"
	       * porcentaje_descuento:       "5%"
	       * impuestos:                  "0.0000"
	       * vr_total:                   "0.0000"
	       */
	
	      this.ngTableColsQuotationDetail = [{
	        field: "descriptionShort",
	        title: "Nombre",
	        // sortable: "descriptionShort",
	        filter: { "descriptionShort": "text" },
	        show: true
	      }, {
	        field: "referencia",
	        title: "Ref.",
	        // sortable: "referencia",
	        filter: { "referencia": "text" },
	        show: true
	      }, {
	        field: "cantidad",
	        title: "Cant.",
	        filter: { "cantidad": "text" },
	        show: true
	      }, {
	        field: "unidad_medida",
	        title: "U.M.",
	        filter: { "unidad_medida": "text" },
	        show: true
	      }, {
	        field: "vr_unit",
	        title: "Vr. Unit.",
	        // sortable: "vr_unit",
	        filter: { "vr_unit": "text" },
	        show: true
	      }, {
	        field: "descuento_moneda",
	        title: "Vr. Desc",
	        // sortable: "descuento_moneda",
	        filter: { "descuento_moneda": "text" },
	        show: true
	      }, {
	        field: "porcentaje_descuento",
	        title: "% Desc",
	        // sortable: "porcentaje_descuento",
	        filter: { "porcentaje_descuento": "text" },
	        show: true
	      }, {
	        field: "impuestos",
	        title: "Iva",
	        filter: { "impuestos": "text" },
	        show: true
	      }, {
	        field: "vr_total",
	        title: "Total",
	        // sortable: "vr_total",
	        filter: { "vr_total": "text" },
	        show: true
	      }, {
	        field: "valor_pagar_hoy",
	        title: "Vr. a pagar hoy",
	        filter: { "valor_pagar_hoy": "text" },
	        show: true
	      }, {
	        field: "selection",
	        title: "Seleccionar",
	        filter: { "selection": "text" },
	        show: true
	      }];
	
	      var initialParams = {
	        count: 20
	      };
	
	      var initialSettings = {
	        counts: [5, 10, 20],
	        paginationMaxBlocks: 8,
	        paginationMinBlocks: 2,
	        dataset: this.quotationDetail
	      };
	
	      this.ngTableConfigQuotationDetail = new this.NgTableParams(initialParams, initialSettings);
	    }
	
	    //agregar al carrito
	
	  }, {
	    key: 'addPayment',
	    value: function addPayment() {
	      var _this3 = this;
	
	      var result = angular.copy(this.quotationDetail.filter(function (val) {
	        return val.activate;
	      }));
	
	      var globalsData = angular.copy(this.shCtrl.globals);
	      if (result.length) {
	        result.forEach(function (val) {
	          globalsData.currentUser.payCart.forEach(function (value, key) {
	            if (val.detalle_numero_documento == value.detalle_numero_documento) {
	              if (val.referencia == value.referencia) {
	                globalsData.currentUser.totalCartPay -= value.valor_pagar_hoy;
	                globalsData.currentUser.payCart.splice(key, 1);
	              }
	            }
	          });
	        });
	        result.forEach(function (value) {
	          value.detalle_valor_documento = value.vr_total;
	        });
	        globalsData.currentUser.totalCartPay = this.payment.recaudo_total;
	        globalsData.currentUser.payCart.forEach(function (val) {
	          result.push(val);
	          globalsData.currentUser.totalCartPay += val.valor_pagar_hoy;
	        });
	
	        // globalsData.currentUser.payCart = result;
	        this.shCtrl.globals.currentUser.payCart = result;
	        this.shCtrl.globals.currentUser.totalCartPay = globalsData.currentUser.totalCartPay;
	        this.SessionService.put('globals', this.shCtrl.globals);
	        //  this.payment.recaudo_total = 0;
	        angular.copy(this.shCtrl.globals.currentUser, this.shCtrl.globals.currentClient);
	        this.notification = true;
	        this.wachingDetailQuotation = false;
	
	        this.$timeout(function () {
	          // this.shCtrl.globals.currentUser.activeTap = 3;
	          _this3.notification = false;
	        }, 3000);
	      } else {
	        alert('Debe seleccionar al menos un items de la cotización a pagar');
	      }
	    }
	  }]);
	
	  return QuotationsController;
	}();
	
	QuotationsController.$inject = inject;
	
	exports.default = QuotationsController;

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _quotations = __webpack_require__(336);
	
	var _quotations2 = _interopRequireDefault(_quotations);
	
	var _quotations3 = __webpack_require__(340);
	
	var _quotations4 = _interopRequireDefault(_quotations3);
	
	var _quotations5 = __webpack_require__(337);
	
	var _quotations6 = _interopRequireDefault(_quotations5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var quotationsModule = _angular2.default.module('app.quotations', []).component('quotations', _quotations2.default).service('QuotationsService', _quotations4.default).config(_quotations6.default);
	exports.default = quotationsModule;

/***/ },
/* 340 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QuotationsService = function () {
	  function QuotationsService($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
	    _classCallCheck(this, QuotationsService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	  }
	
	  _createClass(QuotationsService, [{
	    key: 'getQuotationsHead',
	    value: function getQuotationsHead(userDocument) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'GET',
	          url: _this.ngAuthSettings.apiServiceBaseUri + '/' + _this.ngAuthSettings.config.paths.PAYMENT_ADVANCED.QUOTATIONS_HEAD + (userDocument ? '?valor=' + userDocument : ''),
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getQuotationsDetail',
	    value: function getQuotationsDetail(documentNumber) {
	      var _this2 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this2.$http({
	          method: 'GET',
	          url: _this2.ngAuthSettings.apiServiceBaseUri + '/' + _this2.ngAuthSettings.config.paths.PAYMENT_ADVANCED.QUOTATIONS_DETAIL + (documentNumber ? '?valor=' + documentNumber : ''),
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'userUpdate',
	    value: function userUpdate(data) {
	      var _this3 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this3.$http({
	          method: 'POST',
	          url: _this3.ngAuthSettings.apiServiceBaseUri + '/' + _this3.ngAuthSettings.config.paths.userUpdate,
	          data: _this3.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return QuotationsService;
	}();
	
	QuotationsService.$inject = ['$q', '$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];
	
	exports.default = QuotationsService;

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _serviceOrders = __webpack_require__(343);
	
	var _serviceOrders2 = _interopRequireDefault(_serviceOrders);
	
	var _serviceOrdersView = __webpack_require__(495);
	
	var _serviceOrdersView2 = _interopRequireDefault(_serviceOrdersView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServiceOrdersComponent = {
	  template: _serviceOrdersView2.default,
	  controller: _serviceOrders2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = ServiceOrdersComponent;

/***/ },
/* 342 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.serviceOrders', {
	    url: "/pagos-y-anticipos/ordenes-de-servicio",
	    template: '<service-orders sh-ctrl="shCtrl"></service-orders>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 343 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'ServiceOrdersService', '$state', '$rootScope', 'SharedService', '$timeout', 'ngAuthSettings', 'SessionService', 'NgTableParams', '$uibModal'];
	
	var ServiceOrdersController = function () {
	  function ServiceOrdersController($scope, ServiceOrdersService, $state, $rootScope, SharedService, $timeout, ngAuthSettings, SessionService, NgTableParams, $uibModal) {
	    _classCallCheck(this, ServiceOrdersController);
	
	    this.$state = $state;
	    this.SessionService = SessionService;
	    this.ngAuthSettings = ngAuthSettings;
	    this.NgTableParams = NgTableParams;
	    // this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.$rootScope = $rootScope;
	    this.ServiceOrdersService = ServiceOrdersService;
	    this.$uibModal = $uibModal;
	    this.SharedService = SharedService;
	
	    this.serviceOrdersList = null;
	    this.stateServiceOrders = {};
	    this.ngTableConfigServiceOrders = null;
	    this.ngTableColsServiceOrders = null;
	
	    this.serviceOrderDetail = null;
	    this.stateServiceOrderDetail = {};
	    this.ngTableConfigServiceOrderDetail = null;
	    this.ngTableColsServiceOrderDetail = null;
	
	    this.wachingDetailServiceOrder = false;
	
	    this.payment = {};
	    this.payment.recaudo = 0;
	    this.payment.recaudo_total = 0;
	  }
	
	  _createClass(ServiceOrdersController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      console.log("valor usuario " + JSON.stringify(this.shCtrl.globals.currentUser));
	
	      this.getServiceOrdersHead();
	    }
	  }, {
	    key: 'getServiceOrdersHead',
	    value: function getServiceOrdersHead() {
	      var _this = this;
	
	      this.stateServiceOrders.loading = true;
	      this.wachingDetailServiceOrder = false;
	      this.$timeout(function () {
	        if (_this.serviceOrdersList && _this.serviceOrdersList.length > 0) {
	          _this.stateServiceOrders.loading = false;
	          _this.stateServiceOrders.loaded = true;
	        } else {
	          _this.ServiceOrdersService.getServiceOrdersHead().then(function (response) {
	            _this.stateServiceOrders.loading = false;
	            _this.stateServiceOrders.loaded = true;
	            _this.serviceOrdersList = response;
	            _this.serviceOrdersList.forEach(function (value, index) {
	              value.valor_doc = parseInt(value.total);
	              value.valor_pendiente = parseInt(value.total);
	              value.valor_pagar_hoy = 0;
	              value.valor_pagar_hoy_before = 0;
	              _this.payment.recaudo += value.valor_pendiente;
	              value.type = "Cotización";
	            });
	            console.log("cotizaciones cabecera " + JSON.stringify(response));
	            _this.initNgTableServiceOrders();
	          }).catch(function (reason) {
	            _this.stateServiceOrders.loading = false;
	            _this.stateServiceOrders.loaded = true;
	            _this.stateServiceOrders.error = true;
	          });
	        }
	      }, 1000);
	    }
	  }, {
	    key: 'changeValor',
	    value: function changeValor(row) {
	      console.log("BLURRR");
	      var valorServiceOrder = parseInt(row.valor_pagar_hoy.replace(/,/g, ''));
	      if (valorServiceOrder > row.valor_pendiente) {
	        row.valor_pagar_hoy = row.valor_pendiente;
	        valorServiceOrder = row.valor_pendiente;
	      }
	      this.payment.recaudo_total -= row.valor_pagar_hoy_before;
	      this.payment.recaudo_total += valorServiceOrder;
	
	      row.valor_pagar_hoy_before = valorServiceOrder;
	    }
	  }, {
	    key: 'activateServiceOrder',
	    value: function activateServiceOrder(row) {
	      if (row.activate) {
	        row.valor_pagar_hoy = row.valor_pendiente;
	        row.valor_pagar_hoy_before = row.valor_pendiente;
	        this.payment.recaudo_total += row.valor_pendiente;
	      } else {
	        this.payment.recaudo_total -= row.valor_pagar_hoy_before;
	        row.valor_pagar_hoy = 0;
	        row.valor_pagar_hoy_before = 0;
	      }
	    }
	  }, {
	    key: 'initNgTableServiceOrders',
	    value: function initNgTableServiceOrders() {
	      /**
	       * name:                           "NCN-000024"
	       * type:                             "Lorem Ipsum"
	       * fecha_cotizacion:                 "2016-09-14"
	       * validez_cotizacion:               "2016-09-14"
	       * assigned_user_name:               "Lorem Ipsum"
	       * valor_saldo:                      "0.0000"
	       * valor_pendiente:                  "0.0000"
	       * valor_pagar_hoy:                  "0.0000"
	       * total:                            "0.0000"
	       */
	      this.ngTableColsServiceOrders = [{
	        field: "name",
	        title: "No.",
	        sortable: "name",
	        filter: { "name": "text" },
	        show: true
	      }, {
	        field: "tipo_orden",
	        title: "Tipo",
	        sortable: "tipo_orden",
	        filter: { "tipo_orden": "text" },
	        show: true
	      }, {
	        field: "date_entered",
	        title: "F. Creación",
	        sortable: "date_entered",
	        filter: { "date_entered": "date" },
	        show: true
	      }, {
	        field: "fecha_ejecucion",
	        title: "F. Ejecución",
	        sortable: "fecha_ejecucion",
	        filter: { "fecha_ejecucion": "date" },
	        show: true
	      }, {
	        field: "assigned_user_name",
	        title: "Vendedor",
	        sortable: "assigned_user_name",
	        filter: { "assigned_user_name": "text" },
	        show: true
	      }, {
	        field: "subtotal",
	        title: "Subtotal",
	        sortable: "subtotal",
	        filter: { "subtotal": "text" },
	        show: true
	      }, {
	        field: "impuestos",
	        title: "Impuestos",
	        sortable: "impuestos",
	        filter: { "impuestos": "text" },
	        show: true
	      }, {
	        field: "valor_doc",
	        title: "Vr. Doc.",
	        sortable: "valor_doc",
	        filter: { "valor_doc": "text" },
	        show: true
	      }, {
	        field: "valor_pagar_hoy",
	        title: "Vr. a pagar hoy",
	        show: true
	      }, {
	        field: "selection",
	        title: "",
	        show: true
	      }, {
	        field: "actions",
	        title: "",
	        show: true
	      }];
	
	      var initialParams = {
	        count: 20,
	        sorting: { date_entered: "desc" }
	      };
	
	      var initialSettings = {
	        counts: [5, 10, 20],
	        paginationMaxBlocks: 8,
	        paginationMinBlocks: 2,
	        dataset: this.serviceOrdersList
	      };
	
	      this.ngTableConfigServiceOrders = new this.NgTableParams(initialParams, initialSettings);
	    }
	  }, {
	    key: 'getServiceOrderDetail',
	    value: function getServiceOrderDetail(numberDocument) {}
	  }]);
	
	  return ServiceOrdersController;
	}();
	
	ServiceOrdersController.$inject = inject;
	
	exports.default = ServiceOrdersController;

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _serviceOrders = __webpack_require__(341);
	
	var _serviceOrders2 = _interopRequireDefault(_serviceOrders);
	
	var _serviceOrders3 = __webpack_require__(345);
	
	var _serviceOrders4 = _interopRequireDefault(_serviceOrders3);
	
	var _serviceOrders5 = __webpack_require__(342);
	
	var _serviceOrders6 = _interopRequireDefault(_serviceOrders5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var serviceOrdersModule = _angular2.default.module('app.serviceOrders', []).component('serviceOrders', _serviceOrders2.default).service('ServiceOrdersService', _serviceOrders4.default).config(_serviceOrders6.default);
	
	exports.default = serviceOrdersModule;

/***/ },
/* 345 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ServiceOrdersService = function () {
	  function ServiceOrdersService($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
	    _classCallCheck(this, ServiceOrdersService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	  }
	
	  _createClass(ServiceOrdersService, [{
	    key: 'getServiceOrdersHead',
	    value: function getServiceOrdersHead(userDocument) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'GET',
	          url: _this.ngAuthSettings.apiServiceBaseUri + '/' + _this.ngAuthSettings.config.paths.PAYMENT_ADVANCED.ORDERS_SERVICE_HEAD + (userDocument ? '?valor=' + userDocument : ''),
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getServiceOrdersDetail',
	    value: function getServiceOrdersDetail(documentNumber) {
	      var _this2 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this2.$http({
	          method: 'GET',
	          url: _this2.ngAuthSettings.apiServiceBaseUri + '/' + _this2.ngAuthSettings.config.paths.PAYMENT_ADVANCED.ORDERS_SERVICE_DETAIL + (documentNumber ? '?valor=' + documentNumber : ''),
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'userUpdate',
	    value: function userUpdate(data) {
	      var _this3 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this3.$http({
	          method: 'POST',
	          url: _this3.ngAuthSettings.apiServiceBaseUri + '/' + _this3.ngAuthSettings.config.paths.userUpdate,
	          data: _this3.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return ServiceOrdersService;
	}();
	
	ServiceOrdersService.$inject = ['$q', '$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];
	
	exports.default = ServiceOrdersService;

/***/ },
/* 346 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$uibModalInstance'];
	
	var PqrsDetailModalController = function () {
	  function PqrsDetailModalController($scope, $uibModalInstance) {
	    _classCallCheck(this, PqrsDetailModalController);
	
	    this.$scope = $scope;
	    this.$uibModalInstance = $uibModalInstance;
	    this.comment = '';
	  }
	
	  _createClass(PqrsDetailModalController, [{
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.$uibModalInstance.close(this.comment);
	    }
	  }]);
	
	  return PqrsDetailModalController;
	}();
	
	PqrsDetailModalController.$inject = inject;
	
	exports.default = PqrsDetailModalController;

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pqrsDetail = __webpack_require__(349);
	
	var _pqrsDetail2 = _interopRequireDefault(_pqrsDetail);
	
	var _pqrsDetailView = __webpack_require__(497);
	
	var _pqrsDetailView2 = _interopRequireDefault(_pqrsDetailView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PqrsDetailComponent = {
	  template: _pqrsDetailView2.default,
	  controller: _pqrsDetail2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = PqrsDetailComponent;

/***/ },
/* 348 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.pqrsDetail', {
	    url: "/pqrs/detalle/{id}",
	    template: '<pqrs-detail sh-ctrl="shCtrl"></pqrs-detail>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _pqrsResponsableModalView = __webpack_require__(499);
	
	var _pqrsResponsableModalView2 = _interopRequireDefault(_pqrsResponsableModalView);
	
	var _pqrsInnerModalView = __webpack_require__(498);
	
	var _pqrsInnerModalView2 = _interopRequireDefault(_pqrsInnerModalView);
	
	var _pqrsDetailModalView = __webpack_require__(496);
	
	var _pqrsDetailModalView2 = _interopRequireDefault(_pqrsDetailModalView);
	
	var _pqrsFormModalView = __webpack_require__(37);
	
	var _pqrsFormModalView2 = _interopRequireDefault(_pqrsFormModalView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'PqrsDetailService', '$state', '$rootScope', 'SharedService', '$uibModal', '$timeout', '$window', 'NgTableParams', '$stateParams'];
	
	var PqrsDetailController = function () {
	  function PqrsDetailController($scope, PqrsDetailService, $state, $rootScope, SharedService, $uibModal, $timeout, $window, NgTableParams, $stateParams) {
	    _classCallCheck(this, PqrsDetailController);
	
	    this.$state = $state;
	    this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.$stateParams = $stateParams;
	    this.NgTableParams = NgTableParams;
	    this.$rootScope = $rootScope;
	    this.$window = $window;
	    this.$uibModal = $uibModal;
	    this.PqrsDetailService = PqrsDetailService;
	    this.SharedService = SharedService;
	    this.state = {};
	    this.statuses = [];
	    this.pqrsResponsableList = [{
	      id: "158",
	      nombre: "Encargado PQRS 2"
	    }, {
	      id: "159",
	      nombre: "adrian serna"
	    }];
	    this.pqrs = null;
	    this.reasignacion = null;
	    this.changeStateSuccess = false;
	    this.changeResponsableSuccess = false;
	
	    this.pqrsResponseFormData = {};
	    this.pqrsResponseFormData.attachFiles = [];
	    this.pqrsResponseFormData.files = [];
	    this.ext = {
	      'image/jpg': 'jpg',
	      'image/jpeg': 'jpg',
	      // 'image/png': 'png',
	      'application/pdf': 'pdf'
	      // 'text/plain': 'txt',
	      // 'application/msword': 'doc',
	      // 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
	      // 'application/vnd.ms-excel': 'xls',
	      // 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
	      // 'application/vnd.ms-powerpoint': 'ppt',
	      // 'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx'
	    };
	    this.maxSize = 3145728;
	    this.maxSizeError = false;
	    this.totalSize = 0;
	
	    this.isOffAlert = false;
	  }
	
	  _createClass(PqrsDetailController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getPQRSDetail();
	    }
	  }, {
	    key: 'copyFiles',
	    value: function copyFiles() {
	      var _this = this;
	
	      this.invalidExt = false;
	      this.maxSizeError = false;
	      var files = _angular2.default.copy(this.pqrsResponseFormData.attachFiles);
	      var totalSize = 0;
	
	      _angular2.default.forEach(files, function (value, key) {
	        totalSize += parseInt(value.filesize);
	      });
	
	      if (this.totalSize + totalSize <= this.maxSize) {
	        this.totalSize += totalSize;
	        files.forEach(function (val) {
	          if (!_this.ext[val.filetype]) {
	            _this.invalidExt = true;
	          } else {
	            _this.pqrsResponseFormData.files.push(val);
	          }
	        });
	      } else {
	        console.log('Los archivos no deben exceder 3 MB');
	        this.maxSizeError = true;
	      }
	      this.pqrsResponseFormData.attachFiles = [];
	    }
	  }, {
	    key: 'showModalFormPQRS',
	    value: function showModalFormPQRS() {
	      var options = {
	        globals: this.shCtrl.globals
	      };
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        static: true,
	        template: _pqrsFormModalView2.default,
	        keyboard: false,
	        controller: 'PqrsFormModalController',
	        controllerAs: 'mdCtrl',
	        size: 'lg',
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	    }
	  }, {
	    key: 'getPQRSDetail',
	    value: function getPQRSDetail() {
	      var _this2 = this;
	
	      var userId = this.shCtrl.globals.currentUser.userId;
	      this.PqrsDetailService.getPQRSDetail(userId, this.$stateParams.id).then(function (_ref) {
	        var data = _ref.data;
	
	        _this2.state.loading = false;
	        _this2.state.loaded = true;
	        _this2.reasignacion = Number(data.reasignacion);
	        _this2.pqrs_due_date = data.pqrs_due_date;
	        _this2.pqrs_due_date.tipo_tiempo = _this2.pqrs_due_date.tipo_tiempo === 'Hours' ? 'Hora(s)' : _this2.pqrs_due_date.tipo_tiempo === 'Days' ? 'Día(s)' : _this2.pqrs_due_date.tipo_tiempo === 'Weeks' ? 'Semana(s)' : _this2.pqrs_due_date.tipo_tiempo === 'Months' ? 'Mes(es)' : 'Año(s)';
	        // this.isSupervisor = $rootScope.globals.currentUser.isSupervisor;
	        var responsesChat = [];
	        var responsesInner = [];
	        data.pqrs.responses.forEach(function (val) {
	          if (val.markedAsInner) {
	            responsesInner.push(val);
	          } else {
	            responsesChat.push(val);
	          }
	        });
	        _this2.pqrs = data.pqrs;
	        _this2.pqrs.responses = responsesChat;
	        _this2.pqrs.reponsesInner = responsesInner;
	        _this2.pqrs_responsable = data.pqrs_responsable;
	        _this2.pqrs_responsableCopy = _angular2.default.copy(data.pqrs_responsable);
	        //this.isSupervisor = this.pqrs.responsable;
	        _this2.pqrs.stateId = Number(_this2.pqrs.stateId);
	        _this2.pqrs.stateIdCopy = Number(_this2.pqrs.stateId);
	
	        if (_this2.pqrs.stateId === 56 || _this2.pqrs.stateId === 3) {
	          _this2.statuses = data.statuses.filter(function (val) {
	            return val.id === 3 || val.id === 56;
	          });
	        } else {
	          _this2.statuses = data.statuses.slice(0, -1);
	        }
	      }).catch(function (error) {
	        _this2.state.loading = false;
	        _this2.state.loaded = true;
	        _this2.state.error = true;
	      });
	    }
	  }, {
	    key: 'openModalInnerComments',
	    value: function openModalInnerComments() {
	      var _this3 = this;
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _pqrsInnerModalView2.default,
	        size: 'md',
	        controller: 'PqrsInnerModalController',
	        controllerAs: 'mdCtrl',
	        resolve: {
	          responses: function responses() {
	            return _this3.pqrs.reponsesInner;
	          }
	        }
	      });
	
	      modalInstance.result.then(function (comment) {
	        _this3.PqrsDetailService.changePQRSStatus(userId, _this3.pqrs.id, _this3.pqrs.stateId, comment).then(function (res) {
	          _this3.changeStateSuccess = true;
	          _this3.getPQRSDetail();
	          _this3.$timeout(function () {
	            _this3.changeStateSuccess = false;
	          }, 3000);
	        }).catch(function (err) {
	          console.log(err);
	        });
	      }, function () {
	        // $log.info('Modal dismissed at: ' + new Date());
	        _this3.pqrs.stateId = _this3.pqrs.stateIdCopy;
	      });
	    }
	  }, {
	    key: 'getPQRSResponsables',
	    value: function getPQRSResponsables(search) {
	      var _this4 = this;
	
	      return this.PqrsDetailService.getPQRSResponsables(search).then(function (_ref2) {
	        var data = _ref2.data;
	
	        _this4.state.loading = false;
	        _this4.state.loaded = true;
	        return data;
	      }).catch(function (error) {
	        _this4.state.loading = false;
	        _this4.state.loaded = true;
	        _this4.state.error = true;
	      });
	    }
	  }, {
	    key: 'savePQRSResponsable',
	    value: function savePQRSResponsable($item) {
	      var _this5 = this;
	
	      console.log($item);
	      var userId = this.shCtrl.globals.currentUser.userId;
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _pqrsResponsableModalView2.default,
	        size: '',
	        controller: 'PqrsResponsableModalController',
	        controllerAs: 'mdCtrl'
	      });
	
	      modalInstance.result.then(function (comment) {
	        _this5.PqrsDetailService.savePQRSResponsable(userId, _this5.$stateParams.id, $item.id, comment).then(function (response) {
	          _this5.changeResponsableSuccess = true;
	          _this5.state.loading = false;
	          _this5.state.loaded = true;
	          _this5.$timeout(function () {
	            _this5.$state.go('home.pqrsList');
	          }, 2000);
	        }).catch(function (error) {
	          _this5.changeResponsableSuccess = false;
	          _this5.state.loading = false;
	          _this5.state.loaded = true;
	          _this5.state.error = true;
	        });
	      }, function () {
	        // $log.info('Modal dismissed at: ' + new Date());
	        _this5.pqrs_responsable = _this5.pqrs_responsableCopy;
	      });
	    }
	  }, {
	    key: 'saveResponsePQRS',
	    value: function saveResponsePQRS(form) {
	      var _this6 = this;
	
	      if (!form.$valid) {
	        _angular2.default.forEach(form.$error.required, function (field) {
	          field.$setDirty();
	        });
	      } else {
	        this.pqrsResponseFormData.uploadFiles = _angular2.default.copy(this.pqrsResponseFormData.files);
	        _angular2.default.forEach(this.pqrsResponseFormData.uploadFiles, function (value, key) {
	          var fpath = value.filename.replace(/\\/g, '/');
	          var fname = fpath.substring(fpath.lastIndexOf('/') + 1, fpath.lastIndexOf('.'));
	          _this6.pqrsResponseFormData.uploadFiles[key] = {
	            base64: [value.filetype, fname, value.filesize, value.base64].join(";")
	          };
	        });
	
	        this.pqrsResponseFormData.state = {};
	        this.pqrsResponseFormData.state.savingPqrsResponse = true;
	        this.$timeout(function () {
	          var userId = _this6.shCtrl.globals.currentUser.userId;
	          var markedAsResolved = 0;
	          if (_this6.pqrsResponseFormData.markedAsResolved) {
	            markedAsResolved = 1;
	          }
	          var markedAsInner = 0;
	          if (_this6.pqrsResponseFormData.markedAsInner) {
	            markedAsInner = 1;
	          }
	          var data = {
	            responseText: _this6.pqrsResponseFormData.comments,
	            markedAsResolved: markedAsResolved,
	            markedAsInner: markedAsInner,
	            uploadFiles: _this6.pqrsResponseFormData.uploadFiles
	          };
	          _this6.PqrsDetailService.savePQRSResponse(userId, _this6.pqrs.id, data).then(function (pqrsResponse) {
	            _this6.pqrsResponseFormData.attachFiles = [];
	            _this6.pqrsResponseFormData.files = [];
	
	            // this.pqrs.responses.unshift(pqrsResponse);
	            // this.pqrs.isClosed = pqrsResponse.isClosed;
	            _this6.getPQRSDetail();
	            _this6.pqrsResponseFormData.comments = '';
	            _this6.pqrsResponseForm.comments.$setPristine();
	
	            _this6.pqrsResponseFormData.state.savingPqrsResponse = false;
	            _this6.pqrsResponseFormData.state.savedPqrsResponse = true;
	            _this6.$timeout(function () {
	              _this6.pqrsResponseFormData.state.savedPqrsResponse = false;
	            }, 2000);
	          }).catch(function (errors) {
	            console.log(JSON.stringify(errors));
	            _this6.pqrsResponseFormData.state.savingPqrsResponse = false;
	            _this6.pqrsResponseFormData.state.message = errors.message;
	            _this6.pqrsResponseFormData.state.errors = errors.errors;
	          });
	        }, 500);
	      }
	    }
	  }, {
	    key: 'changePQRSState',
	    value: function changePQRSState() {
	      var _this7 = this;
	
	      var userId = this.shCtrl.globals.currentUser.userId;
	      // Guardar info de cambio
	      if (this.pqrs.stateId === 3 || this.pqrs.stateId === '3') {
	        var modalInstance = this.$uibModal.open({
	          animation: true,
	          template: _pqrsDetailModalView2.default,
	          size: 'md',
	          controller: 'PqrsDetailModalController',
	          controllerAs: 'mdCtrl'
	        });
	        modalInstance.result.then(function (comment) {
	          console.log(comment);
	          _this7.PqrsDetailService.changePQRSStatus(userId, _this7.pqrs.id, _this7.pqrs.stateId, comment).then(function (res) {
	            console.log(res);
	            _this7.changeStateSuccess = true;
	            _this7.getPQRSDetail();
	            _this7.$timeout(function () {
	              _this7.changeStateSuccess = false;
	            }, 3000);
	          }).catch(function (err) {
	            console.log(err);
	          });
	        }, function () {
	          // $log.info('Modal dismissed at: ' + new Date());
	          _this7.pqrs.stateId = _this7.pqrs.stateIdCopy;
	        });
	      } else {
	        this.PqrsDetailService.changePQRSStatus(userId, this.pqrs.id, this.pqrs.stateId).then(function (res) {
	          console.log(res);
	          _this7.changeStateSuccess = true;
	          _this7.getPQRSDetail();
	          _this7.$timeout(function () {
	            _this7.changeStateSuccess = false;
	          }, 3000);
	        });
	      }
	      // pqrsService.changePQRSStatus(this.pqrs.id, this.pqrs.stateId).then(function (res) {
	      //   console.log(res);
	      //   this.changeStateSuccess = true;
	      //   getPQRSDetail();
	      //   $timeout(function () {
	      //     this.changeStateSuccess = false;
	      //   }, 3000)
	      // })
	      //   .catch(function (err) {
	      //     console.log(err);
	      //   })
	    }
	  }, {
	    key: 'offAlert',
	    value: function offAlert() {
	      console.log('sin alerta');
	      this.isOffAlert = true;
	    }
	  }, {
	    key: 'removeFile',
	    value: function removeFile(file) {
	      this.invalidExt = false;
	      this.maxSizeError = false;
	      var index = this.pqrsResponseFormData.files.indexOf(file);
	
	      if (index > -1) {
	        this.totalSize = this.totalSize - this.pqrsResponseFormData.files[index].filesize;
	        this.pqrsResponseFormData.files.splice(index, 1);
	      }
	    }
	  }, {
	    key: 'messageResponse',
	    value: function messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: modalConfirmation,
	        controller: 'ModalResponseController',
	        controllerAs: 'mdCtrl',
	        size: options.size,
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        if (callAcept) {
	          callback();
	        }
	      }).catch(function (reason) {
	        if (callCancel) {
	          callbackCancel();
	        }
	      });
	    }
	  }]);
	
	  return PqrsDetailController;
	}();
	
	PqrsDetailController.$inject = inject;
	
	exports.default = PqrsDetailController;

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _pqrsDetail = __webpack_require__(347);
	
	var _pqrsDetail2 = _interopRequireDefault(_pqrsDetail);
	
	var _pqrsDetail3 = __webpack_require__(351);
	
	var _pqrsDetail4 = _interopRequireDefault(_pqrsDetail3);
	
	var _pqrsDetail5 = __webpack_require__(348);
	
	var _pqrsDetail6 = _interopRequireDefault(_pqrsDetail5);
	
	var _pqrsResponsableModal = __webpack_require__(353);
	
	var _pqrsResponsableModal2 = _interopRequireDefault(_pqrsResponsableModal);
	
	var _pqrsInnerModal = __webpack_require__(352);
	
	var _pqrsInnerModal2 = _interopRequireDefault(_pqrsInnerModal);
	
	var _pqrsDetailModal = __webpack_require__(346);
	
	var _pqrsDetailModal2 = _interopRequireDefault(_pqrsDetailModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pqrsDetailModule = _angular2.default.module('app.pqrsDetail', []).component('pqrsDetail', _pqrsDetail2.default).service('PqrsDetailService', _pqrsDetail4.default).controller('PqrsResponsableModalController', _pqrsResponsableModal2.default).controller('PqrsDetailModalController', _pqrsDetailModal2.default).controller('PqrsInnerModalController', _pqrsInnerModal2.default).config(_pqrsDetail6.default);
	
	exports.default = pqrsDetailModule;

/***/ },
/* 351 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService', '$httpParamSerializerJQLike'];
	
	var PqrsListService = function () {
	  function PqrsListService($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService, $httpParamSerializerJQLike) {
	    _classCallCheck(this, PqrsListService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	    this.AuthTokenFactory = AuthTokenFactory;
	    this.SharedService = SharedService;
	    this.SessionService = SessionService;
	    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	  }
	
	  _createClass(PqrsListService, [{
	    key: 'getPQRSDetail',
	    value: function getPQRSDetail(userId, pqrsId) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'GET',
	          url: _this.ngAuthSettings.apiServiceBaseUri + _this.ngAuthSettings.config.paths.PQRS.DETAIL + '?userId=' + userId + '&pqrsId=' + pqrsId,
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getPQRSResponsables',
	    value: function getPQRSResponsables(search) {
	      var _this2 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this2.$http({
	          method: 'GET',
	          url: _this2.ngAuthSettings.apiServiceBaseUri + _this2.ngAuthSettings.config.paths.PQRS.RESPONSABLES_LIST + search,
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'changePQRSStatus',
	    value: function changePQRSStatus(userId, pqrsId, statusId, comment2) {
	      var _this3 = this;
	
	      var comment = comment2 || null;
	      var data = {
	        userId: userId,
	        statusId: statusId,
	        pqrsId: pqrsId,
	        comment: comment
	      };
	      return this.$q(function (resolve, reject) {
	        _this3.$http({
	          method: 'POST',
	          url: _this3.ngAuthSettings.apiServiceBaseUri + _this3.ngAuthSettings.config.paths.PQRS.CHANGE_STATUS,
	          data: _this3.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'savePQRSResponsable',
	    value: function savePQRSResponsable(userId, pqrsId, id_responsable, comment) {
	      var _this4 = this;
	
	      var data = {
	        userId: userId,
	        pqrsId: pqrsId,
	        id_responsable: id_responsable,
	        comment: comment
	      };
	      return this.$q(function (resolve, reject) {
	        _this4.$http({
	          method: 'POST',
	          url: _this4.ngAuthSettings.apiServiceBaseUri + _this4.ngAuthSettings.config.paths.PQRS.CHANGE_PQRS_RESPONSABLE,
	          data: _this4.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'savePQRSResponse',
	    value: function savePQRSResponse(userId, pqrsId, data) {
	      var _this5 = this;
	
	      data.userId = userId;
	      data.pqrsId = pqrsId;
	      return this.$q(function (resolve, reject) {
	        _this5.$http({
	          method: 'POST',
	          url: _this5.ngAuthSettings.apiServiceBaseUri + _this5.ngAuthSettings.config.paths.PQRS.SAVE_RESPONSE,
	          data: _this5.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return PqrsListService;
	}();
	
	PqrsListService.$inject = inject;
	
	exports.default = PqrsListService;

/***/ },
/* 352 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$uibModalInstance', 'responses'];
	
	var PqrsInnerModalController = function () {
	  function PqrsInnerModalController($scope, $uibModalInstance, responses) {
	    _classCallCheck(this, PqrsInnerModalController);
	
	    this.$scope = $scope;
	    this.$uibModalInstance = $uibModalInstance;
	    this.responses = responses;
	  }
	
	  _createClass(PqrsInnerModalController, [{
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.$uibModalInstance.close();
	    }
	  }]);
	
	  return PqrsInnerModalController;
	}();
	
	PqrsInnerModalController.$inject = inject;
	
	exports.default = PqrsInnerModalController;

/***/ },
/* 353 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$uibModalInstance'];
	
	var PqrsResponsableModalController = function () {
	  function PqrsResponsableModalController($scope, $uibModalInstance) {
	    _classCallCheck(this, PqrsResponsableModalController);
	
	    this.$scope = $scope;
	    this.$uibModalInstance = $uibModalInstance;
	    this.comment = '';
	  }
	
	  _createClass(PqrsResponsableModalController, [{
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.$uibModalInstance.close(this.comment);
	    }
	  }]);
	
	  return PqrsResponsableModalController;
	}();
	
	PqrsResponsableModalController.$inject = inject;
	
	exports.default = PqrsResponsableModalController;

/***/ },
/* 354 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$uibModalInstance', 'modalOptions', 'PqrsListService', '$state'];
	
	var PqrsFormModalController = function () {
	  function PqrsFormModalController($scope, $uibModalInstance, modalOptions, PqrsListService, $state) {
	    _classCallCheck(this, PqrsFormModalController);
	
	    this.$scope = $scope;
	    this.$uibModalInstance = $uibModalInstance;
	    this.PqrsListService = PqrsListService;
	    this.$state = $state;
	    this.modalOptions = Object.assign({}, modalOptions);
	    this.globals = modalOptions.globals;
	    this.clientSelected = false;
	
	    this.$scope.messageRestriction = '<span class="message_tool">Peso máximo por archivo <strong>3MB</strong> en formatos <strong>.jpg</strong> 0 <strong>.pdf</strong>.</span>';
	    this.ext = {
	      'image/jpg': 'jpg',
	      'image/jpeg': 'jpg',
	      // 'image/png': 'png',
	      'application/pdf': 'pdf'
	      // 'text/plain': 'txt',
	      // 'application/msword': 'doc',
	      // 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
	      // 'application/vnd.ms-excel': 'xls',
	      // 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
	      // 'application/vnd.ms-powerpoint': 'ppt',
	      // 'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx'
	    };
	    this.maxSize = 3145728;
	    this.maxSizeError = false;
	    this.pqrsFormData = {};
	    this.pqrsFormData.attachFiles = [];
	    this.pqrsFormData.files = [];
	    this.pqrsParams = {};
	    this.totalSize = 0;
	
	    this.activate();
	  }
	
	  _createClass(PqrsFormModalController, [{
	    key: 'activate',
	    value: function activate() {
	      if (this.globals.currentClient) {
	        this.clientSelected = Object.keys(this.globals.currentClient).length > 0;
	        if (this.globals.currentClient.id) {
	          this.pqrsFormData.incidenceResponseMail = this.globals.currentClient.email;
	          this.pqrsFormData.incidenceResponsePhone = this.globals.currentClient.phone;
	        } else {
	          this.pqrsFormData.incidenceResponseMail = this.globals.currentUser.contactEmail;
	          this.pqrsFormData.incidenceResponsePhone = this.globals.currentUser.contactPhone;
	        }
	      } else {
	        this.pqrsFormData.incidenceResponseMail = this.globals.currentUser.contactEmail;
	        this.pqrsFormData.incidenceResponsePhone = this.globals.currentUser.contactPhone;
	      }
	
	      this.getPQRSParams();
	    }
	  }, {
	    key: 'copyFiles',
	    value: function copyFiles() {
	      var _this = this;
	
	      this.invalidExt = false;
	      this.maxSizeError = false;
	      var files = angular.copy(this.pqrsFormData.attachFiles);
	      var totalSize = 0;
	
	      angular.forEach(files, function (value, key) {
	        totalSize += parseInt(value.filesize);
	      });
	
	      if (this.totalSize + totalSize <= this.maxSize) {
	        // this.totalSize += totalSize;
	        files.forEach(function (value) {
	          if (!_this.ext[value.filetype]) {
	            _this.invalidExt = true;
	          } else {
	            _this.totalSize += parseInt(value.filesize);
	            _this.pqrsFormData.files(value);
	          }
	        });
	      } else {
	        console.log('Los archivos no deben exceder 3 MB');
	        this.maxSizeError = true;
	      }
	      this.pqrsFormData.attachFiles = [];
	    }
	  }, {
	    key: 'getPQRSParams',
	    value: function getPQRSParams() {
	      var _this2 = this;
	
	      this.PqrsListService.getPQRSParams().then(function (params) {
	        _this2.pqrsParams = params;
	      }).catch(function (error) {
	        alert('Errror!');
	      });
	    }
	  }, {
	    key: 'savePQRS',
	    value: function savePQRS(form) {
	      var _this3 = this;
	
	      this.invalidExt = false;
	      this.maxSizeError = false;
	      // Validate the form and trigger the invalid fields
	      if (!form.$valid) {
	        angular.forEach(form.$error.required, function (field) {
	          field.$setDirty();
	        });
	        // showPqrsErrorModal();
	      }
	      // Save the pqrs
	      else {
	          this.pqrsFormData.uploadFiles = angular.copy(this.pqrsFormData.files);
	          angular.forEach(this.pqrsFormData.uploadFiles, function (value, key) {
	            var fpath = value.filename.replace(/\\/g, '/');
	            var fname = fpath.substring(fpath.lastIndexOf('/') + 1, fpath.lastIndexOf('.'));
	            _this3.pqrsFormData.uploadFiles[key] = {
	              base64: [value.filetype, fname, value.filesize, value.base64].join(";")
	            };
	          });
	          this.pqrsFormData.state = {};
	          this.pqrsFormData.state.savingPqrs = true;
	
	          var userId = this.globals.currentUser.userId;
	
	          this.PqrsListService.savePQRS(userId, this.pqrsFormData).then(function (pqrsId) {
	            _this3.pqrsFormData.state.savingPqrs = false;
	            _this3.pqrsFormData.state.savedPqrs = true;
	            _this3.pqrsId = pqrsId;
	            _this3.pqrsFormData.attachFiles = [];
	            _this3.pqrsFormData.files = [];
	            angular.element(document.querySelector("#pqrsFile")).val(null);
	            angular.forEach(form, function (field, key) {
	              if (!key.startsWith('$')) {
	                _this3.pqrsFormData[key] = '';
	                form[key].$setPristine();
	              }
	            });
	          }).catch(function (errors) {
	            console.log(errors);
	            _this3.pqrsFormData.state.savingPqrs = false;
	            _this3.pqrsFormData.state.message = errors.message;
	            _this3.pqrsFormData.state.errors = errors.errors;
	            alert(errors.message);
	          });
	        }
	    }
	  }, {
	    key: 'removeFile',
	    value: function removeFile(file) {
	      this.invalidExt = false;
	      this.maxSizeError = false;
	      var index = this.pqrsFormData.files.indexOf(file);
	      if (index > -1) {
	        this.totalSize = this.totalSize - this.pqrsFormData.files[index].filesize;
	        this.pqrsFormData.files.splice(index, 1);
	      }
	    }
	  }, {
	    key: 'goToPQRSList',
	    value: function goToPQRSList() {
	      this.cancel();
	      this.$state.go('home.pqrsList');
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.pqrsFormData.state.savedPqrs = false;
	      this.$uibModalInstance.close();
	    }
	  }]);
	
	  return PqrsFormModalController;
	}();
	
	PqrsFormModalController.$inject = inject;
	
	exports.default = PqrsFormModalController;

/***/ },
/* 355 */
[547, 357, 500],
/* 356 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.pqrsList', {
	    url: "/pqrs/listado",
	    template: '<pqrs-list sh-ctrl="shCtrl"></pqrs-list>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _pqrsFormModalView = __webpack_require__(37);
	
	var _pqrsFormModalView2 = _interopRequireDefault(_pqrsFormModalView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'PqrsListService', '$state', '$rootScope', 'SharedService', '$uibModal', '$timeout', '$window', 'NgTableParams', 'ngAuthSettings'];
	
	var PqrsListController = function () {
	  function PqrsListController($scope, PqrsListService, $state, $rootScope, SharedService, $uibModal, $timeout, $window, NgTableParams, ngAuthSettings) {
	    _classCallCheck(this, PqrsListController);
	
	    this.$state = $state;
	    this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.NgTableParams = NgTableParams;
	    this.$rootScope = $rootScope;
	    this.$window = $window;
	    this.$uibModal = $uibModal;
	    this.PqrsListService = PqrsListService;
	    this.ngAuthSettings = ngAuthSettings;
	    this.SharedService = SharedService;
	    this.pqrsList = null;
	    this.responsable = false;
	    this.state = {};
	    this.statistics = [{
	      'state': 'Casos Registrados',
	      'total': 0,
	      'bgcolor': 'bg-aqua'
	    }, {
	      'state': 'Casos Sin Revisar',
	      'total': 0,
	      'bgcolor': 'bg-yellow'
	    }, {
	      // 'state': 'Casos En Verificación',
	      'state': 'Casos En Proceso',
	      'total': 0,
	      'bgcolor': 'bg-red'
	    }, {
	      'state': 'Casos Cerrados',
	      'total': 0,
	      'bgcolor': 'bg-green'
	    }];
	    this.pqrsId = null;
	    this.ngTableConfig = null;
	    this.ngTableCols = null;
	  }
	
	  _createClass(PqrsListController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getPQRSList();
	    }
	  }, {
	    key: 'exportCSV',
	    value: function exportCSV(table) {
	      var userId = this.shCtrl.globals.currentUser.userId;
	      var a = '';
	
	      var tableConfig = this.ngTableConfig;
	      if (!tableConfig) return alert('Ocurrió un error al exportar XLS');
	      tableConfig.data.forEach(function (val, index) {
	        if (index > 0) {
	          a += "," + val.id;
	        } else {
	          a += val.id;
	        }
	      });
	
	      this.$window.location = this.shCtrl.ngAuthSettings.config.env.apiEndPoint + this.ngAuthSettings.config.paths.PQRS.EXPORT_CSV + '?incidencias=' + a + '&userId=' + userId;
	    }
	  }, {
	    key: 'showModalFormPQRS',
	    value: function showModalFormPQRS() {
	      var options = {
	        globals: this.shCtrl.globals
	      };
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        static: true,
	        template: _pqrsFormModalView2.default,
	        keyboard: false,
	        controller: 'PqrsFormModalController',
	        controllerAs: 'mdCtrl',
	        size: 'lg',
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	    }
	  }, {
	    key: 'initNgTable',
	    value: function initNgTable() {
	      this.ngTableCols = [{
	        field: "id",
	        title: "Caso",
	        sortable: "id",
	        filter: { "id": "text" },
	        show: true
	      }, {
	        field: "registeredDate",
	        title: "Registrado el",
	        filter: { "registeredDate": "text" },
	        sortable: "registeredDate",
	        show: true
	      }, {
	        field: "subject",
	        title: "Asunto",
	        sortable: "subject",
	        filter: { "subject": "text" },
	        show: true
	      }, {
	        field: "relatedWith",
	        title: "Relacionado",
	        filter: { "relatedWith": "text" },
	        sortable: "relatedWith",
	        show: true
	      }, {
	        field: "incidenceDate",
	        title: "Fecha Incidente",
	        filter: { "incidenceDate": "text" },
	        sortable: "incidenceDate",
	        show: true
	      }, {
	        field: "incidenceLocation",
	        title: "Lugar del Incidente",
	        filter: { "incidenceLocation": "text" },
	        sortable: "incidenceLocation",
	        show: true
	      },
	      // {
	      //   field: "thirdTypeName",
	      //   title: "Tipo Tercero",
	      //   filter: { "thirdTypeName": "text" },
	      //   sortable: "thirdTypeName",
	      //   show: this.responsable || this.pqrsMaster
	      // },
	      {
	        field: "branchCustomer",
	        // title: "Sucursal / Cliente",
	        title: "Tercero / Sucursal",
	        filter: { "thirdPartyName": "text" },
	        sortable: "thirdPartyName",
	        show: this.isSupervisor
	      }, {
	        field: "state",
	        title: "Estado",
	        filter: { "state": "text" },
	        sortable: "state",
	        show: true
	      }, {
	        field: "comments",
	        title: "Comentario",
	        filter: { "comments": "text" },
	        sortable: "comments",
	        show: false
	      }, {
	        field: "documentRelated",
	        title: "Documento Relacionado",
	        filter: { "documentRelated": "text" },
	        sortable: "documentRelated",
	        show: false
	      }, {
	        field: "documentNumber",
	        title: "Nro. Documento",
	        filter: { "documentNumber": "text" },
	        sortable: "documentNumber",
	        show: false
	      }, {
	        field: "actions",
	        show: true
	      }];
	
	      var initialParams = {
	        count: 8
	      };
	
	      var initialSettings = {
	        counts: [10, 20, 40, 100],
	        paginationMaxBlocks: 8,
	        paginationMinBlocks: 2,
	        dataset: this.pqrsList
	      };
	
	      this.ngTableConfig = new this.NgTableParams(initialParams, initialSettings);
	    }
	  }, {
	    key: 'getPQRSList',
	    value: function getPQRSList() {
	      var _this = this;
	
	      this.state = {};
	      this.state.loading = true;
	      var userId = this.shCtrl.globals.currentUser.userId;
	      this.PqrsListService.getPQRSList(userId).then(function (_ref) {
	        var data = _ref.data;
	
	        _this.pqrsList = data.pqrsList;
	        _this.responsable = data.responsable;
	        // this.isSupervisor = $rootScope.globals.currentUser.isSupervisor;
	        _this.isSupervisor = _this.responsable;
	        _this.pqrsList.forEach(function (val, inx) {
	          // TODO: Unificar el valor con los datos enviados desde el backend
	          val.branchCustomer = val.branchName + ' / ' + val.thirdPartyName;
	        });
	        _this.setStatistics(data.statistics);
	        _this.initNgTable();
	
	        _this.state.loading = false;
	        _this.state.loaded = true;
	      }).catch(function (error) {
	        _this.state.loading = false;
	        _this.state.loaded = true;
	        _this.state.error = true;
	      });
	    }
	  }, {
	    key: 'setStatistics',
	    value: function setStatistics(statistics) {
	      var _this2 = this;
	
	      var total = 0;
	
	      _angular2.default.forEach(statistics, function (value, key) {
	        var index = value.state - 1;
	
	        if (_this2.statistics[value.state]) {
	          _this2.statistics[value.state].total = value.total;
	        }
	        total += Number(value.total);
	      });
	      this.statistics[0].total = total;
	    }
	  }, {
	    key: 'setModalPqrsId',
	    value: function setModalPqrsId(pqrsId) {
	      this.modalPqrsId = pqrsId;
	    }
	  }, {
	    key: 'messageResponse',
	    value: function messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: modalConfirmation,
	        controller: 'ModalResponseController',
	        controllerAs: 'mdCtrl',
	        size: options.size,
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        if (callAcept) {
	          callback();
	        }
	      }).catch(function (reason) {
	        if (callCancel) {
	          callbackCancel();
	        }
	      });
	    }
	  }]);
	
	  return PqrsListController;
	}();
	
	PqrsListController.$inject = inject;
	
	exports.default = PqrsListController;

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _pqrsList = __webpack_require__(355);
	
	var _pqrsList2 = _interopRequireDefault(_pqrsList);
	
	var _pqrsList3 = __webpack_require__(359);
	
	var _pqrsList4 = _interopRequireDefault(_pqrsList3);
	
	var _pqrsList5 = __webpack_require__(356);
	
	var _pqrsList6 = _interopRequireDefault(_pqrsList5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pqrsListModule = _angular2.default.module('app.pqrsList', []).component('pqrsList', _pqrsList2.default).service('PqrsListService', _pqrsList4.default).config(_pqrsList6.default);
	
	exports.default = pqrsListModule;

/***/ },
/* 359 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService', '$httpParamSerializerJQLike'];
	
	var PqrsListService = function () {
	  function PqrsListService($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService, $httpParamSerializerJQLike) {
	    _classCallCheck(this, PqrsListService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	    this.ngAuthSettings = ngAuthSettings;
	    this.AuthTokenFactory = AuthTokenFactory;
	    this.SharedService = SharedService;
	    this.SessionService = SessionService;
	  }
	
	  _createClass(PqrsListService, [{
	    key: 'getPQRSList',
	    value: function getPQRSList(userId) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'GET',
	          url: _this.ngAuthSettings.apiServiceBaseUri + _this.ngAuthSettings.config.paths.PQRS.LIST + '?userId=' + userId,
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getPQRSParams',
	    value: function getPQRSParams() {
	      var _this2 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this2.$http({
	          method: 'GET',
	          url: _this2.ngAuthSettings.apiServiceBaseUri + _this2.ngAuthSettings.config.paths.PQRS.PARAMS,
	          cache: false
	        }).then(function (_ref) {
	          var data = _ref.data;
	
	          if (!data.error) {
	            resolve(data.data.pqrsParams);
	          } else {
	            reject(data.data);
	          }
	        }).catch(function (reason) {
	          reject(reason.data);
	        });
	      });
	    }
	  }, {
	    key: 'sendMailPqrsList',
	    value: function sendMailPqrsList(data) {
	      var _this3 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this3.$http({
	          method: 'POST',
	          url: _this3.ngAuthSettings.apiServiceBaseUri + _this3.ngAuthSettings.config.paths.mailPqrsList,
	          data: _this3.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'savePQRS',
	    value: function savePQRS(userId, data) {
	      var _this4 = this;
	
	      data.userId = userId;
	      return this.$q(function (resolve, reject) {
	        _this4.$http({
	          method: 'POST',
	          url: _this4.ngAuthSettings.apiServiceBaseUri + _this4.ngAuthSettings.config.paths.PQRS.SAVE,
	          data: _this4.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (_ref2) {
	          var data = _ref2.data;
	
	          if (!data.error) {
	            resolve(data.data.pqrsId);
	          } else {
	            reject(data.data);
	          }
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return PqrsListService;
	}();
	
	PqrsListService.$inject = inject;
	
	exports.default = PqrsListService;

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _pqrsList = __webpack_require__(358);
	
	var _pqrsList2 = _interopRequireDefault(_pqrsList);
	
	var _pqrsDetail = __webpack_require__(350);
	
	var _pqrsDetail2 = _interopRequireDefault(_pqrsDetail);
	
	var _pqrsFormModal = __webpack_require__(354);
	
	var _pqrsFormModal2 = _interopRequireDefault(_pqrsFormModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pqrsModule = _angular2.default.module('app.pqrs', [_pqrsList2.default.name, _pqrsDetail2.default.name]).controller('PqrsFormModalController', _pqrsFormModal2.default);
	// import pqrsComponent from './pqrs.component';
	// import ContactService from './pqrs.service';
	// import pqrsConfig from './pqrs.config';
	exports.default = pqrsModule;

/***/ },
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _billfold = __webpack_require__(367);
	
	var _billfold2 = _interopRequireDefault(_billfold);
	
	var _billfoldView = __webpack_require__(502);
	
	var _billfoldView2 = _interopRequireDefault(_billfoldView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BillfoldComponent = {
	  template: _billfoldView2.default,
	  controller: _billfold2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = BillfoldComponent;

/***/ },
/* 366 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.reportBillfold', {
	    url: "/reportes/cartera",
	    template: '<billfold sh-ctrl="shCtrl"></billfold>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 367 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'BillfoldService', '$state', '$rootScope', 'SharedService', '$timeout', 'ngAuthSettings', 'CartService', 'SessionService', 'NgTableParams', '$uibModal', '$filter'];
	
	var BillfoldController = function () {
	  function BillfoldController($scope, BillfoldService, $state, $rootScope, SharedService, $timeout, ngAuthSettings, CartService, SessionService, NgTableParams, $uibModal, $filter) {
	    _classCallCheck(this, BillfoldController);
	
	    this.$state = $state;
	    this.SessionService = SessionService;
	    this.ngAuthSettings = ngAuthSettings;
	    this.CartService = CartService;
	    this.$filter = $filter;
	    // this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.$rootScope = $rootScope;
	    this.NgTableParams = NgTableParams;
	    this.BillfoldService = BillfoldService;
	    this.$uibModal = $uibModal;
	    this.SharedService = SharedService;
	    this.billfolds = null;
	    this.watchingBillfold = false;
	    this.stateBillfold = {};
	    this.billfoldSelected = null;
	    // ngTable Params
	    this.ngTableConfigBillfold = null;
	    this.ngTableColsBillfold = null;
	    this.state = {};
	    this.updatedAt = '';
	    this.branches = [];
	    // ngTable Params
	    this.ngTableConfig = null;
	    this.ngTableCols = null;
	    this.thirdSelected = null;
	    this.branchesSelected = null;
	  }
	
	  _createClass(BillfoldController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (!this.shCtrl.globals.currentClient) this.shCtrl.globals.currentClient = {};
	      if (!this.shCtrl.globals.currentClient.third.documentNumber) return;
	      this.getBillFolds();
	    }
	  }, {
	    key: 'getBranches',
	    value: function getBranches(item) {
	      var _this = this;
	
	      this.thirdSelected = item;
	      this.BillfoldService.getBranchesByThirdId(item.id).then(function (response) {
	        _this.branches = response;
	      });
	    }
	  }, {
	    key: 'getBillFolds',
	    value: function getBillFolds(manual) {
	      var _this2 = this;
	
	      var documentNumber = '';
	      var branchCode = '';
	      try {
	        if (manual) {
	          this.billfolds = [];
	          documentNumber = this.thirdSelected.nit;
	          if (angular.isArray(this.branchesSelected)) {
	            branchCode = this.branchesSelected;
	          } else if (this.branchesSelected.id) {
	            branchCode = [this.branchesSelected.id];
	          } else {
	            branchCode = [];
	          }
	        } else {
	          documentNumber = this.shCtrl.globals.currentClient.third.documentNumber;
	          if (this.ngAuthSettings.site.config.data.cartera.carteraPorSucursal) {
	            branchCode = this.shCtrl.globals.currentClient.operatingCenter.code;
	          }
	        }
	      } catch (e) {
	        return;
	      }
	
	      this.state = {};
	      this.state.loading = true;
	      if (manual) {
	        this.BillfoldService.getBillFoldsBranches(documentNumber, branchCode, this.fecha_ini, this.fecha_fin).then(function (billfolds) {
	          if (billfolds === 'null') {
	            billfolds = [];
	          }
	          _this2.state.loading = false;
	          _this2.state.loaded = true;
	          _this2.billfolds = billfolds;
	          _this2.initNgTable();
	          _this2.updatedAt = _this2.$filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
	        }).catch(function (error) {
	          _this2.state.loading = false;
	          _this2.state.error = true;
	        });
	      } else {
	        this.BillfoldService.getBillFolds(documentNumber, branchCode).then(function (billfolds) {
	          _this2.state.loading = false;
	          _this2.state.loaded = true;
	
	          if (billfolds === 'null') {
	            _this2.billfolds = [];
	          } else {
	            _this2.billfolds = billfolds;
	            _this2.initNgTable();
	            _this2.updatedAt = _this2.$filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
	          }
	        }).catch(function (error) {
	          _this2.state.loading = false;
	          _this2.state.error = true;
	        });
	      }
	    }
	  }, {
	    key: 'selectBillfold',
	    value: function selectBillfold(billfold) {
	      var _this3 = this;
	
	      this.watchingBillfold = true;
	      var documentNumber = '';
	      var branchCode = '';
	      var nit = '';
	      try {
	        nit = this.thirdSelected.nit;
	      } catch (e) {}
	      if (nit) {
	        documentNumber = this.thirdSelected.nit;
	        if (angular.isArray(this.branchesSelected)) {
	          branchCode = this.branchesSelected;
	        } else if (this.branchesSelected.id) {
	          branchCode = [this.branchesSelected.id];
	        } else {
	          branchCode = [];
	        }
	      } else {
	        documentNumber = this.shCtrl.globals.currentClient.third.documentNumber;
	        if (this.ngAuthSettings.site.config.data.cartera.carteraPorSucursal) {
	          branchCode = this.shCtrl.globals.currentClient.operatingCenter.code;
	        }
	      }
	
	      if (!documentNumber || !billfold.sucursal) {
	        alert('Para realizar la consulta se necesita el numero de documento y el codigo de la sucursal.');
	      } else {
	        this.state.loading = true;
	        this.branchCode = billfold.sucursal;
	        this.BillfoldService.getBillFold(documentNumber, billfold.sucursal).then(function (billfold) {
	          _this3.stateBillfold.loading = false;
	          _this3.stateBillfold.loaded = true;
	          _this3.billfoldSelected = billfold;
	          _this3.initNgTableBillfold();
	          _this3.updatedAt = _this3.$filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
	        }).catch(function (error) {
	          _this3.stateBillfold.loading = false;
	          _this3.stateBillfold.loaded = true;
	          _this3.stateBillfold.error = true;
	        });
	      }
	    }
	  }, {
	    key: 'blurBillfold',
	    value: function blurBillfold() {
	      this.watchingBillfold = false;
	      this.billfoldSelected = null;
	      this.branchCode = null;
	    }
	  }, {
	    key: 'initNgTableBillfold',
	    value: function initNgTableBillfold() {
	      /**
	       * cupo_credito:                          "1.000000"
	       * detalle_fecha_documento:               "2016-06-17"
	       * detalle_fecha_vencimiento_documento:   "2016-09-14"
	       * detalle_numero_documento:              "FA-205068"
	       * detalle_valor_documento:               "50000.0000"
	       * empresa:                               "ALERE COLOMBIA S.A."
	       * sucursal:                              "01"
	       * tercero:                               "ANGEL DIAGNOSTICA S A"
	       * tercero_id:                            "805013591"
	       * total_cartera:                         "50000.0000"
	       * total_sin_vencer:                      "50000.0000"
	       * total_vencido:                         "0.0000"
	       * total_vencido_1_30:                    "0.0000"
	       * total_vencido_31_60:                   "0.0000"
	       * total_vencido_61_90:                   "0.0000"
	       * total_vencido_91_180:                  "0.0000"
	       * total_vencido_mayor_180:               "0.0000"
	       */
	
	      this.ngTableColsBillfold = [{
	        field: "cupo_credito",
	        title: "Cupo Crédito",
	        sortable: "cupo_credito",
	        filter: { "cupo_credito": "text" },
	        show: false
	      }, {
	        field: "detalle_fecha_documento",
	        title: "Fecha Documento",
	        sortable: "detalle_fecha_documento",
	        filter: { "detalle_fecha_documento": "date" },
	        show: true
	      }, {
	        field: "detalle_fecha_vencimiento_documento",
	        title: "Fecha Vto. Documento",
	        sortable: "detalle_fecha_vencimiento_documento",
	        filter: { "detalle_fecha_vencimiento_documento": "date" },
	        show: true
	      }, {
	        field: "detalle_numero_documento",
	        title: "Nro. Documento",
	        sortable: "detalle_numero_documento",
	        filter: { "detalle_numero_documento": "text" },
	        show: true
	      }, {
	        field: "detalle_valor_documento",
	        title: "Vlr. Documento",
	        sortable: "detalle_valor_documento",
	        filter: { "detalle_valor_documento": "text" },
	        show: true
	      }, {
	        field: "empresa",
	        title: "Empresa",
	        sortable: "empresa",
	        filter: { "empresa": "text" },
	        show: false
	      }, {
	        field: "sucursal",
	        title: "Sucursal",
	        sortable: "sucursal",
	        filter: { "sucursal": "text" },
	        show: false
	      }, {
	        field: "tercero",
	        title: "Tercero",
	        sortable: "tercero",
	        filter: { "tercero": "text" },
	        show: false
	      }, {
	        field: "tercero_id",
	        title: "Tercero Id",
	        sortable: "tercero_id",
	        filter: { "tercero_id": "text" },
	        show: false
	      }, {
	        field: "total_cartera",
	        title: "Total Cartera",
	        sortable: "total_cartera",
	        filter: { "total_cartera": "text" },
	        show: true
	      }, {
	        field: "total_sin_vencer",
	        title: "Total Sin Vencer",
	        sortable: "total_sin_vencer",
	        filter: { "total_sin_vencer": "text" },
	        show: true
	      }, {
	        field: "total_vencido",
	        title: "Total Vencido",
	        sortable: "total_vencido",
	        filter: { "total_vencido": "text" },
	        show: true
	      }, {
	        field: "total_vencido_1_30",
	        title: "De 1 a 30 días",
	        sortable: "total_vencido_1_30",
	        filter: { "total_vencido_1_30": "text" },
	        show: true
	      }, {
	        field: "total_vencido_31_60",
	        title: "De 31 a 60 días",
	        sortable: "total_vencido_31_60",
	        filter: { "total_vencido_31_60": "text" },
	        show: true
	      }, {
	        field: "total_vencido_61_90",
	        title: "De 61 a 90 días",
	        sortable: "total_vencido_61_90",
	        filter: { "total_vencido_61_90": "text" },
	        show: true
	      }, {
	        field: "total_vencido_91_180",
	        title: "De 91 a 180 días",
	        sortable: "total_vencido_91_180",
	        filter: { "total_vencido_91_180": "text" },
	        show: true
	      }, {
	        field: "total_vencido_mayor_180",
	        title: "> 180 días",
	        sortable: "total_vencido_mayor_180",
	        filter: { "total_vencido_mayor_180": "text" },
	        show: true
	      }];
	
	      var initialParams = {
	        count: 20
	      };
	
	      var initialSettings = {
	        counts: [5, 10, 20],
	        paginationMaxBlocks: 8,
	        paginationMinBlocks: 2,
	        dataset: this.billfoldSelected
	      };
	
	      this.ngTableConfigBillfold = new this.NgTableParams(initialParams, initialSettings);
	    }
	  }, {
	    key: 'initNgTable',
	    value: function initNgTable() {
	
	      /**
	       * cupo_credito
	       * empresa
	       * sucursal
	       * tercero
	       * tercero_id
	       * total_cartera
	       * total_sin_vencer
	       * total_vencido
	       * total_vencido_1_30
	       * total_vencido_31_60
	       * total_vencido_61_90
	       * total_vencido_91_180
	       * total_vencido_mayor_180
	       */
	
	      this.ngTableCols = [{
	        field: "cupo_credito",
	        title: "Cupo Crédito",
	        sortable: "cupo_credito",
	        filter: { "cupo_credito": "text" },
	        show: false
	      }, {
	        field: "empresa",
	        title: "Empresa",
	        sortable: "empresa",
	        filter: { "empresa": "text" },
	        show: false
	      }, {
	        field: "sucursal",
	        title: "Sucursal",
	        sortable: "sucursal",
	        filter: { "sucursal_nombre": "text" },
	        show: true
	      }, {
	        field: "tercero",
	        title: "Tercero",
	        sortable: "tercero",
	        filter: { "tercero": "text" },
	        show: false
	      }, {
	        field: "tercero_id",
	        title: "Tercero Id",
	        sortable: "tercero_id",
	        filter: { "tercero_id": "text" },
	        show: false
	      }, {
	        field: "total_cartera",
	        title: "Total Cartera",
	        sortable: "total_cartera",
	        filter: { "total_cartera": "text" },
	        show: true
	      }, {
	        field: "total_sin_vencer",
	        title: "Total Sin Vencer",
	        sortable: "total_sin_vencer",
	        filter: { "total_sin_vencer": "text" },
	        show: true
	      }, {
	        field: "total_vencido",
	        title: "Total Vencido",
	        sortable: "total_vencido",
	        filter: { "total_vencido": "text" },
	        show: true
	      }, {
	        field: "total_vencido_1_30",
	        title: "De 1 a 30 días",
	        sortable: "total_vencido_1_30",
	        filter: { "total_vencido_1_30": "text" },
	        show: true
	      }, {
	        field: "total_vencido_31_60",
	        title: "De 31 a 60 días",
	        sortable: "total_vencido_31_60",
	        filter: { "total_vencido_31_60": "text" },
	        show: true
	      }, {
	        field: "total_vencido_61_90",
	        title: "De 61 a 90 días",
	        sortable: "total_vencido_61_90",
	        filter: { "total_vencido_61_90": "text" },
	        show: true
	      }, {
	        field: "total_vencido_91_180",
	        title: "De 91 a 180 días",
	        sortable: "total_vencido_91_180",
	        filter: { "total_vencido_91_180": "text" },
	        show: true
	      }, {
	        field: "total_vencido_mayor_180",
	        title: "> 180 días",
	        sortable: "total_vencido_mayor_180",
	        filter: { "total_vencido_mayor_180": "text" },
	        show: true
	      }, {
	        field: "actions",
	        title: "Detalle",
	        show: true
	      }];
	
	      var initialParams = {
	        count: 20
	      };
	
	      var initialSettings = {
	        counts: [5, 10, 20],
	        paginationMaxBlocks: 8,
	        paginationMinBlocks: 2,
	        dataset: this.billfolds
	      };
	
	      this.ngTableConfig = new this.NgTableParams(initialParams, initialSettings);
	    }
	  }]);
	
	  return BillfoldController;
	}();
	
	BillfoldController.$inject = inject;
	
	exports.default = BillfoldController;

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _billfold = __webpack_require__(365);
	
	var _billfold2 = _interopRequireDefault(_billfold);
	
	var _billfold3 = __webpack_require__(369);
	
	var _billfold4 = _interopRequireDefault(_billfold3);
	
	var _billfold5 = __webpack_require__(366);
	
	var _billfold6 = _interopRequireDefault(_billfold5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var billfoldModule = _angular2.default.module('app.reports.billfold', []).component('billfold', _billfold2.default).service('BillfoldService', _billfold4.default).config(_billfold6.default);
	
	exports.default = billfoldModule;

/***/ },
/* 369 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BillfoldService = function () {
	  function BillfoldService($q, $http, ngAuthSettings) {
	    _classCallCheck(this, BillfoldService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	  }
	
	  _createClass(BillfoldService, [{
	    key: 'getBranchesByThirdId',
	    value: function getBranchesByThirdId(thirdId) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'GET',
	          url: _this.ngAuthSettings.apiServiceBaseUri + '/user/third-center-operating?thirdId=' + thirdId,
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getBillFold',
	    value: function getBillFold(documentNumber, branchCode) {
	      var _this2 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this2.$http({
	          method: 'GET',
	          url: _this2.ngAuthSettings.apiServiceBaseUri2 + _this2.ngAuthSettings.config.paths.REPORTS.SYNC.BILLFOLD.LIST + '?documentoTercero=' + documentNumber + '&codigoSucursal=' + branchCode + '&verDetalle=1',
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getBillFolds',
	    value: function getBillFolds(documentNumber, codigoSucursal) {
	      var _this3 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this3.$http({
	          method: 'GET',
	          url: _this3.ngAuthSettings.apiServiceBaseUri2 + _this3.ngAuthSettings.config.paths.REPORTS.SYNC.BILLFOLD.LIST + '?documentoTercero=' + documentNumber + '&codigoSucursal=' + codigoSucursal,
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getBillFoldsBranches',
	    value: function getBillFoldsBranches(documentNumber, branchCodes, fecha_ini, fecha_fin) {
	      var _this4 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this4.$http({
	          method: 'POST',
	          url: _this4.ngAuthSettings.apiServiceBaseUri2 + _this4.ngAuthSettings.config.paths.REPORTS.SYNC.BILLFOLD.LIST2,
	          data: {
	            'documentoTercero': documentNumber,
	            'branchCode': branchCodes,
	            'fecha_ini': fecha_ini,
	            'fecha_fin': fecha_fin
	          },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return BillfoldService;
	}();
	
	BillfoldService.$inject = ['$q', '$http', 'ngAuthSettings'];
	
	exports.default = BillfoldService;

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _orders = __webpack_require__(372);
	
	var _orders2 = _interopRequireDefault(_orders);
	
	var _ordersView = __webpack_require__(503);
	
	var _ordersView2 = _interopRequireDefault(_ordersView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReportOrdersComponent = {
	  template: _ordersView2.default,
	  controller: _orders2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = ReportOrdersComponent;

/***/ },
/* 371 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.reportOrders', {
	    url: "/reportes/pedidos",
	    template: '<report-orders sh-ctrl="shCtrl"></report-orders>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 372 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'ReportOrdersService', '$state', '$rootScope', 'SharedService', '$timeout', 'ngAuthSettings', 'CartService', 'SessionService', 'NgTableParams', '$uibModal', '$filter'];
	
	var ReportOrdersController = function () {
	  function ReportOrdersController($scope, ReportOrdersService, $state, $rootScope, SharedService, $timeout, ngAuthSettings, CartService, SessionService, NgTableParams, $uibModal, $filter) {
	    _classCallCheck(this, ReportOrdersController);
	
	    this.$state = $state;
	    this.SessionService = SessionService;
	    this.ngAuthSettings = ngAuthSettings;
	    this.CartService = CartService;
	    this.$filter = $filter;
	    // this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.$rootScope = $rootScope;
	    this.NgTableParams = NgTableParams;
	    this.ReportOrdersService = ReportOrdersService;
	    this.$uibModal = $uibModal;
	    this.SharedService = SharedService;
	
	    this.orders = null;
	    this.state = {};
	    this.branches = [];
	
	    this.stateOrder = {};
	    this.orderSelected = null;
	    this.watchingOrder = false;
	
	    // ngTable Params
	    this.ngTableConfigOrder = null;
	    this.ngTableColsOrder = null;
	
	    this.totalValueToPayOrders = 0;
	    this.totalValuePendingOrders = 0;
	    this.updatedAt = '';
	
	    // ngTable Params
	    this.ngTableConfig = null;
	    this.ngTableCols = null;
	    this.thirdSelected = null;
	    this.branchesSelected = null;
	  }
	
	  _createClass(ReportOrdersController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (!this.shCtrl.globals.currentClient) this.shCtrl.globals.currentClient = {};
	      if (!this.shCtrl.globals.currentClient.third.documentNumber) return;
	      this.getOrderStates();
	    }
	  }, {
	    key: 'getBranches',
	    value: function getBranches(item) {
	      var _this = this;
	
	      this.ReportOrdersService.getBranchesByThirdId(item.id).then(function (response) {
	        _this.branches = response;
	      });
	    }
	  }, {
	    key: 'getOrderStates',
	    value: function getOrderStates(manual) {
	      var _this2 = this;
	
	      var documentNumber = '';
	      var branchCode = '';
	      try {
	        if (manual) {
	          this.orders = [];
	          documentNumber = this.thirdSelected.nit;
	          if (angular.isArray(this.branchesSelected)) {
	            branchCode = this.branchesSelected;
	          } else if (this.branchesSelected) {
	            branchCode = [this.branchesSelected.id];
	          } else {
	            branchCode = [];
	          }
	        } else {
	          documentNumber = this.shCtrl.globals.currentClient.third.documentNumber;
	          branchCode = this.shCtrl.globals.currentClient.operatingCenter.code;
	        }
	      } catch (e) {
	        return;
	      }
	
	      if (!documentNumber || !branchCode) {
	        alert('Para realizar la consulta se necesita el numero de documento y el codigo de la sucursal.');
	      } else {
	        this.state = {};
	        this.state.loading = true;
	        if (manual) {
	          this.ReportOrdersService.getOrderStatesBranches(documentNumber, branchCode, this.fecha_ini, this.fecha_fin).then(function (orders) {
	            _this2.state.loading = false;
	            _this2.state.loaded = true;
	
	            _this2.totalValueToPayOrders = 0;
	            _this2.totalValuePendingOrders = 0;
	
	            angular.forEach(orders, function (order) {
	              var valor_pagar = +order.valor_pagar;
	              var valor_pendiente = +order.valor_pendiente;
	
	              _this2.totalValueToPayOrders = _this2.totalValueToPayOrders + valor_pagar;
	              _this2.totalValuePendingOrders = _this2.totalValuePendingOrders + valor_pendiente;
	            });
	
	            _this2.orders = orders;
	            _this2.initNgTable();
	
	            _this2.updatedAt = _this2.$filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
	          }).catch(function (error) {
	            _this2.state.loading = false;
	            _this2.state.error = true;
	          });
	        } else {
	          this.ReportOrdersService.getOrderStates(documentNumber, branchCode).then(function (orders) {
	            _this2.state.loading = false;
	            _this2.state.loaded = true;
	
	            _this2.totalValueToPayOrders = 0;
	            _this2.totalValuePendingOrders = 0;
	
	            angular.forEach(orders, function (order) {
	              var valor_pagar = +order.valor_pagar;
	              var valor_pendiente = +order.valor_pendiente;
	
	              _this2.totalValueToPayOrders = _this2.totalValueToPayOrders + valor_pagar;
	              _this2.totalValuePendingOrders = _this2.totalValuePendingOrders + valor_pendiente;
	            });
	
	            _this2.orders = orders;
	            _this2.initNgTable();
	
	            _this2.updatedAt = _this2.$filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
	          }).catch(function (error) {
	            _this2.state.loading = false;
	            _this2.state.error = true;
	          });
	        }
	      }
	    }
	  }, {
	    key: 'selectOrder',
	    value: function selectOrder(orderSelected) {
	      var _this3 = this;
	
	      this.watchingOrder = true;
	      this.stateOrder.loading = true;
	      var documentNumber = '';
	      var branchCode = '';
	      var nit = '';
	      try {
	        nit = this.thirdSelected.nit;
	      } catch (e) {}
	      if (nit) {
	        documentNumber = this.thirdSelected.nit;
	        if (angular.isArray(this.branchesSelected)) {
	          branchCode = this.branchesSelected;
	        } else if (this.branchesSelected) {
	          branchCode = [this.branchesSelected.id];
	        } else {
	          branchCode = [];
	        }
	      } else {
	        documentNumber = this.shCtrl.globals.currentClient.third.documentNumber;
	        branchCode = this.shCtrl.globals.currentClient.operatingCenter.code;
	      }
	      this.ReportOrdersService.getOrderState(documentNumber, orderSelected.pedido_id).then(function (order) {
	        _this3.stateOrder.loading = false;
	        _this3.stateOrder.loaded = true;
	        _this3.orderSelected = order;
	        _this3.initNgTableOrder();
	      }).catch(function (error) {
	        _this3.stateOrder.loading = false;
	        _this3.stateOrder.loaded = true;
	        _this3.stateOrder.error = true;
	      });
	    }
	  }, {
	    key: 'blurOrder',
	    value: function blurOrder() {
	      this.orderSelected = null;
	      this.watchingOrder = false;
	    }
	  }, {
	    key: 'initNgTableOrder',
	    value: function initNgTableOrder() {
	      /**
	       * destino:                             "ORDEN DE COMPRA 30455 **23183** LO RECOGEN"
	       * fecha_pedido:                  (OK)  "2016-07-18 00:00:00"
	       * id:                                  248
	       * item_cantidad_despachada:      (OK)  0
	       * item_cantidad_pedida:          (OK)  4
	       * item_centro_operacion_pedido:        1
	       * item_descripcion:              (OK)  "TRIAGE CARDIAC PANEL X 25 PBS"
	       * item_estado:                   (OK)  null
	       * item_fecha_entrega:            (OK)  "2016-07-18 00:00:00"(OK)
	       * item_referencia:               (OK)  "97000HSEU"
	       * item_unidad_medida:            (OK)  "UND"
	       * item_valor_descuento:          (OK)  0
	       * item_valor_total:              (OK)  1800000
	       * item_valor_unitario:           (OK)  450000
	       * pedido_estado:                       "1"
	       * pedido_id:                           "PV-150296"
	       * sucursal:                            "ANGEL DIAGNOSTICA S A/CAMBULOS"
	       * sucursal_id:                         "01"
	       * tercero:                             "ANGEL DIAGNOSTICA S A"
	       * tercero_id:                          "805013591"
	       * valor_pagar:                         null
	       * valor_pendiente:                     null
	       * vendedor:                            "ALVAREZ ACHURY CONSTANZA VIVIANA"
	       * vendedor_id:                         "0231"
	       */
	
	      this.ngTableColsOrder = [{
	        field: "fecha_pedido",
	        title: "Fecha Pedido",
	        sortable: "fecha_pedido",
	        filter: { "fecha_pedido": "date" },
	        show: true
	      }, {
	        field: "item_fecha_entrega",
	        title: "Fecha Entrega",
	        sortable: "item_fecha_entrega",
	        filter: { "item_fecha_entrega": "date" },
	        show: true
	      }, {
	        field: "item_referencia",
	        title: "Ref.",
	        sortable: "item_referencia",
	        filter: { "item_referencia": "text" },
	        show: true
	      }, {
	        field: "item_descripcion",
	        title: "Descripción",
	        sortable: "item_descripcion",
	        filter: { "item_descripcion": "text" },
	        show: true
	      }, {
	        field: "item_estado",
	        title: "Estado ítem",
	        sortable: "item_estado",
	        filter: { "item_estado": "text" },
	        show: true
	      }, {
	        field: "item_unidad_medida",
	        title: "Und. de Medida",
	        sortable: "item_unidad_medida",
	        filter: { "item_unidad_medida": "text" },
	        show: true
	      }, {
	        field: "item_cantidad_pedida",
	        title: "Cant. Pedida",
	        sortable: "item_cantidad_pedida",
	        filter: { "item_cantidad_pedida": "text" },
	        show: true
	      }, {
	        field: "item_cantidad_despachada",
	        title: "Cant. Despachada",
	        sortable: "item_cantidad_despachada",
	        filter: { "item_cantidad_despachada": "text" },
	        show: true
	      }, {
	        field: "item_cantidad_pendiente",
	        title: "Cant. Pendiente",
	        sortable: "item_cantidad_pendiente",
	        filter: { "item_cantidad_pendiente": "text" },
	        show: true
	      }, {
	        field: "item_valor_unitario",
	        title: "Vr. Unitario",
	        sortable: "item_valor_unitario",
	        filter: { "item_valor_unitario": "text" },
	        show: true
	      }, {
	        field: "item_valor_descuento",
	        title: "Vr. Descuento",
	        sortable: "item_valor_descuento",
	        filter: { "item_valor_descuento": "text" },
	        show: true
	      }, {
	        field: "item_valor_total",
	        title: "Vr. Neto Total",
	        sortable: "item_valor_total",
	        filter: { "item_valor_total": "text" },
	        show: true
	      }];
	
	      var initialParams = {
	        count: 20,
	        sorting: { item_fecha_entrega: "desc" }
	      };
	
	      var initialSettings = {
	        counts: [5, 10, 20],
	        paginationMaxBlocks: 8,
	        paginationMinBlocks: 2,
	        dataset: this.orderSelected
	      };
	
	      this.ngTableConfigOrder = new this.NgTableParams(initialParams, initialSettings);
	    }
	  }, {
	    key: 'initNgTable',
	    value: function initNgTable() {
	
	      this.ngTableCols = [{
	        field: "pedido_id",
	        title: "Pedido ERP",
	        sortable: "pedido_id",
	        filter: { "pedido_id": "text" },
	        show: true
	      }, {
	        field: "pedido_smartb",
	        title: "Pedido T. Virtual",
	        sortable: "pedido_smartb",
	        filter: { "pedido_smartb": "text" },
	        show: true
	      }, {
	        field: "pedido_estado",
	        title: "Estado",
	        sortable: "pedido_estado",
	        filter: { "pedido_estado": "text" },
	        show: true
	      }, {
	        field: "orden_compra",
	        title: "O.C. Cliente",
	        sortable: "orden_compra",
	        filter: { "orden_compra": "text" },
	        show: true
	      }, {
	        field: "sucursal",
	        title: "Sucursal",
	        sortable: "sucursal",
	        filter: { "sucursal": "text" },
	        show: true
	      }, {
	        field: "fecha_pedido",
	        title: "Fecha del Pedido",
	        sortable: "fecha_pedido",
	        filter: { "fecha_pedido": "date" },
	        show: true
	      }, {
	        field: "item_fecha_entrega",
	        title: "Fecha Entrega",
	        sortable: "item_fecha_entrega",
	        filter: { "item_fecha_entrega": "date" },
	        show: true
	      }, {
	        field: "destino",
	        title: "Comentario Pedido",
	        sortable: "destino",
	        filter: { "destino": "text" },
	        show: true
	      }, {
	        field: "vendedor",
	        title: "Vendedor",
	        sortable: "vendedor",
	        filter: { "vendedor": "text" },
	        show: true
	      }, {
	        field: "valor_pagar",
	        title: "Valor Neto Total",
	        sortable: "valor_pagar",
	        filter: { "valor_pagar": "text" },
	        show: true
	      }, {
	        field: "valor_pendiente",
	        title: "Valor Neto Pendiente",
	        sortable: "valor_pendiente",
	        filter: { "valor_pendiente": "text" },
	        show: true
	      }, {
	        field: "actions",
	        title: "Detalle",
	        show: true
	      }];
	
	      var initialParams = {
	        count: 20,
	        sorting: { item_fecha_entrega: "desc" }
	      };
	
	      var initialSettings = {
	        counts: [5, 10, 20],
	        paginationMaxBlocks: 8,
	        paginationMinBlocks: 2,
	        dataset: this.orders
	      };
	
	      this.ngTableConfig = new this.NgTableParams(initialParams, initialSettings);
	    }
	  }]);
	
	  return ReportOrdersController;
	}();
	
	ReportOrdersController.$inject = inject;
	
	exports.default = ReportOrdersController;

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _orders = __webpack_require__(370);
	
	var _orders2 = _interopRequireDefault(_orders);
	
	var _orders3 = __webpack_require__(374);
	
	var _orders4 = _interopRequireDefault(_orders3);
	
	var _orders5 = __webpack_require__(371);
	
	var _orders6 = _interopRequireDefault(_orders5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ordersModule = _angular2.default.module('app.reports.orders', []).component('reportOrders', _orders2.default).service('ReportOrdersService', _orders4.default).config(_orders6.default);
	
	exports.default = ordersModule;

/***/ },
/* 374 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BillfoldService = function () {
	  function BillfoldService($q, $http, ngAuthSettings) {
	    _classCallCheck(this, BillfoldService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	  }
	
	  _createClass(BillfoldService, [{
	    key: 'getBranchesByThirdId',
	    value: function getBranchesByThirdId(thirdId) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'GET',
	          url: _this.ngAuthSettings.apiServiceBaseUri + '/user/third-center-operating?thirdId=' + thirdId,
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getOrderState',
	    value: function getOrderState(documentNumber, orderNumber) {
	      var _this2 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this2.$http({
	          method: 'GET',
	          url: _this2.ngAuthSettings.apiServiceBaseUri2 + _this2.ngAuthSettings.config.paths.REPORTS.SYNC.ORDER.STATES + '?terceroId=' + documentNumber + '&pedidoId=' + orderNumber,
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getOrderStates',
	    value: function getOrderStates(documentNumber, branchCode) {
	      var _this3 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this3.$http({
	          method: 'GET',
	          url: _this3.ngAuthSettings.apiServiceBaseUri2 + _this3.ngAuthSettings.config.paths.REPORTS.SYNC.ORDER.STATES + '?terceroId=' + documentNumber + '&sucursalCodigo=' + branchCode,
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getOrderStatesBranches',
	    value: function getOrderStatesBranches(documentNumber, branchCodes, fecha_ini, fecha_fin) {
	      var _this4 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this4.$http({
	          method: 'POST',
	          url: _this4.ngAuthSettings.apiServiceBaseUri2 + _this4.ngAuthSettings.config.paths.REPORTS.SYNC.ORDER.STATES2,
	          data: {
	            'documentoTercero': documentNumber,
	            'branchCode': branchCodes,
	            'fecha_ini': fecha_ini,
	            'fecha_fin': fecha_fin
	          },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return BillfoldService;
	}();
	
	BillfoldService.$inject = ['$q', '$http', 'ngAuthSettings'];
	
	exports.default = BillfoldService;

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _billfold = __webpack_require__(368);
	
	var _billfold2 = _interopRequireDefault(_billfold);
	
	var _orders = __webpack_require__(373);
	
	var _orders2 = _interopRequireDefault(_orders);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reportsModule = _angular2.default.module('app.reports', [_billfold2.default.name, _orders2.default.name]);
	
	exports.default = reportsModule;

/***/ },
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['AutoCompleteService'];
	
	var AutoCompleteController = function () {
	  function AutoCompleteController(AutoCompleteService) {
	    _classCallCheck(this, AutoCompleteController);
	
	    this.AutoCompleteService = AutoCompleteService;
	    this.listCity = [];
	    this.contCity = 1;
	    this.maxPage = 2;
	    this.listCity2 = [];
	    this.editable = this.isEditable ? this.isEditable : false;
	    this.requirement = this.param;
	    this.intitializeSearch = false;
	  }
	
	  _createClass(AutoCompleteController, [{
	    key: 'getCityList',
	    value: function getCityList() {
	      var _this = this;
	
	      if (this.intitializeSearch) return;
	      this.intitializeSearch = true;
	      if (this.requirement !== this.param) {
	        this.contCity = 1;
	        this.listCity2 = [];
	        this.maxPage = 2;
	        this.requirement = this.param;
	      }
	      if (this.contCity <= this.maxPage) {
	        this.AutoCompleteService.getAllSimple(25, this.contCity, '', this.param).then(function (response) {
	          _this.maxPage = response.totalPage;
	          for (var x = 0; x < response.items.length; x++) {
	            _this.listCity2.push(response.items[x]);
	          }
	          _this.contCity++;
	          _this.intitializeSearch = false;
	        });
	      } else {
	        this.intitializeSearch = false;
	      }
	    }
	  }, {
	    key: 'getCitySearch',
	    value: function getCitySearch(val) {
	      var _this2 = this;
	
	      return this.AutoCompleteService.getAllSimple(25, 1, val, this.param).then(function (response) {
	        _this2.listCity = response.items;
	        return _this2.listCity;
	      });
	    }
	  }, {
	    key: 'onSelect',
	    value: function onSelect($item) {
	      this.myValue = $item;
	      this.typeaheadSelect({ item: $item });
	    }
	  }]);
	
	  return AutoCompleteController;
	}();
	
	AutoCompleteController.$inject = inject;
	
	exports.default = AutoCompleteController;

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _autocomplete = __webpack_require__(380);
	
	var _autocomplete2 = _interopRequireDefault(_autocomplete);
	
	var _autocompleteView = __webpack_require__(505);
	
	var _autocompleteView2 = _interopRequireDefault(_autocompleteView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AutocompleteDirective() {
	  return {
	    restrict: 'E',
	    template: _autocompleteView2.default,
	    replace: false,
	    bindToController: true,
	    scope: {
	      myValue: "=myAttribute",
	      isReq: "=",
	      isDis: "=",
	      tooltipP: "=",
	      typeaheadSelect: '&',
	      onBlurInput: '&',
	      idCity: "@",
	      isEditable: "=",
	      appendBody: "=",
	      placeholder: "@",
	      param: "@"
	    },
	    controller: _autocomplete2.default,
	    controllerAs: 'ctrl'
	  };
	}
	
	// let AutocompleteComponent = {
	//   template,
	//   controller,
	//   scopes : {
	//     myValue: "<",
	//     isReq: "<",
	//     isDis : "<",
	//     tooltipP :  "<",
	//     idCity : "<",
	//     isEditable: "<",
	//     placeholder : "<",
	//     param : "<"
	//   }
	// };
	
	// export default AutocompleteComponent;
	exports.default = AutocompleteDirective;

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _autocomplete = __webpack_require__(381);
	
	var _autocomplete2 = _interopRequireDefault(_autocomplete);
	
	var _autocomplete3 = __webpack_require__(383);
	
	var _autocomplete4 = _interopRequireDefault(_autocomplete3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var autoCompleteModule = _angular2.default.module('shared.components.autoComplete', []).service('AutoCompleteService', _autocomplete4.default).directive('autoComplete', _autocomplete2.default);
	exports.default = autoCompleteModule;

/***/ },
/* 383 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$q', '$http', 'ngAuthSettings', '$rootScope'];
	
	var AutoCompleteService = function () {
	  function AutoCompleteService($q, $http, ngAuthSettings, $rootScope) {
	    _classCallCheck(this, AutoCompleteService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	    this.$rootScope = $rootScope;
	    this.constants = {
	      cities: '/crm/proyectos/search-city',
	      projects: '/crm/oportunidades/search-proyecto',
	      accounts: '/terceros/terceros/search-terceros',
	      thirds: '/terceros/terceros/search-terceros',
	      contacts: '/crm/proyectos/search-responsable',
	      categories: '/categoria-info/search-categorias',
	      items: '/item-info/search-items',
	      sellers: '/crm/contactos/search-contactos?isSeller=true',
	      contactsWithowAccount: '/crm/contactos/search-contactos'
	    };
	  }
	
	  _createClass(AutoCompleteService, [{
	    key: 'getAllSimple',
	    value: function getAllSimple(pageSize, pageNumber, search, param) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'GET',
	          url: _this.ngAuthSettings.apiServiceBaseUri + _this.constants[param] + '?pageSize=' + pageSize + '&pageNumber=' + pageNumber + '&searchText=' + search,
	          cache: false
	          // data : {
	          //   'pageSize' : pageSize,
	          //   'pageNumber' : pageNumber,
	          //   'searchText' : search
	          // }
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return AutoCompleteService;
	}();
	
	AutoCompleteService.$inject = inject;
	
	exports.default = AutoCompleteService;

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _dynamicBanner = __webpack_require__(390);
	
	var _dynamicBanner2 = _interopRequireDefault(_dynamicBanner);
	
	var _carouselBanner = __webpack_require__(387);
	
	var _carouselBanner2 = _interopRequireDefault(_carouselBanner);
	
	var _sideBanners = __webpack_require__(393);
	
	var _sideBanners2 = _interopRequireDefault(_sideBanners);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BannersModule = _angular2.default.module('shared.components.banners', [_dynamicBanner2.default.name, _sideBanners2.default.name, _carouselBanner2.default.name]);
	
	exports.default = BannersModule;

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _carouselBanner = __webpack_require__(386);
	
	var _carouselBanner2 = _interopRequireDefault(_carouselBanner);
	
	var _carouselBannerView = __webpack_require__(506);
	
	var _carouselBannerView2 = _interopRequireDefault(_carouselBannerView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CarouselBannerComponent = {
	  template: _carouselBannerView2.default,
	  controller: _carouselBanner2.default,
	  bindings: {
	    cbItems: '<',
	    cbName: '<'
	  }
	};
	
	exports.default = CarouselBannerComponent;

/***/ },
/* 386 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$state', '$rootScope', 'SharedService', 'ngAuthSettings'];
	
	var CarouselBannerController = function CarouselBannerController($scope, $state, $rootScope, SharedService, ngAuthSettings) {
	  _classCallCheck(this, CarouselBannerController);
	
	  this.$state = $state;
	  this.$scope = $scope;
	  this.ngAuthSettings = ngAuthSettings;
	  this.$rootScope = $rootScope;
	  this.SharedService = SharedService;
	};
	
	CarouselBannerController.$inject = inject;
	
	exports.default = CarouselBannerController;

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _carouselBanner = __webpack_require__(385);
	
	var _carouselBanner2 = _interopRequireDefault(_carouselBanner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CarouselBannerModule = _angular2.default.module('shared.components.banners.carouselBanner', []).component('carouselBanner', _carouselBanner2.default);
	
	exports.default = CarouselBannerModule;

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dynamicBanner = __webpack_require__(389);
	
	var _dynamicBanner2 = _interopRequireDefault(_dynamicBanner);
	
	var _dynamicBannerView = __webpack_require__(507);
	
	var _dynamicBannerView2 = _interopRequireDefault(_dynamicBannerView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DynamicBannerComponent = {
	  template: _dynamicBannerView2.default,
	  controller: _dynamicBanner2.default,
	  bindings: {
	    dbData: '<',
	    dbName: '<'
	  }
	};
	
	exports.default = DynamicBannerComponent;

/***/ },
/* 389 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$state', '$rootScope', 'SharedService', 'ngAuthSettings'];
	
	var DynamicBannerController = function DynamicBannerController($scope, $state, $rootScope, SharedService, ngAuthSettings) {
	  _classCallCheck(this, DynamicBannerController);
	
	  this.$state = $state;
	  this.$scope = $scope;
	  this.ngAuthSettings = ngAuthSettings;
	  this.$rootScope = $rootScope;
	  this.SharedService = SharedService;
	};
	
	DynamicBannerController.$inject = inject;
	
	exports.default = DynamicBannerController;

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _dynamicBanner = __webpack_require__(388);
	
	var _dynamicBanner2 = _interopRequireDefault(_dynamicBanner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DynamicBannerModule = _angular2.default.module('shared.components.banners.dynamicBanner', []).component('dynamicBanner', _dynamicBanner2.default);
	
	exports.default = DynamicBannerModule;

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sideBanners = __webpack_require__(392);
	
	var _sideBanners2 = _interopRequireDefault(_sideBanners);
	
	var _sideBannersView = __webpack_require__(508);
	
	var _sideBannersView2 = _interopRequireDefault(_sideBannersView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SideBannersComponent = {
	  template: _sideBannersView2.default,
	  controller: _sideBanners2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = SideBannersComponent;

/***/ },
/* 392 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$state', '$rootScope', 'SharedService', 'ngAuthSettings'];
	
	var SideBannersController = function SideBannersController($scope, $state, $rootScope, SharedService, ngAuthSettings) {
	  _classCallCheck(this, SideBannersController);
	
	  this.$state = $state;
	  this.$scope = $scope;
	  this.ngAuthSettings = ngAuthSettings;
	  this.$rootScope = $rootScope;
	  this.SharedService = SharedService;
	};
	
	SideBannersController.$inject = inject;
	
	exports.default = SideBannersController;

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _sideBanners = __webpack_require__(391);
	
	var _sideBanners2 = _interopRequireDefault(_sideBanners);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SideBannersModule = _angular2.default.module('shared.components.banners.sideBanners', []).component('sideBanners', _sideBanners2.default);
	
	exports.default = SideBannersModule;

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _menuDropdown = __webpack_require__(395);
	
	var _menuDropdown2 = _interopRequireDefault(_menuDropdown);
	
	var _menuDropdownView = __webpack_require__(509);
	
	var _menuDropdownView2 = _interopRequireDefault(_menuDropdownView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MenuDropdownComponent = {
	  template: _menuDropdownView2.default,
	  controller: _menuDropdown2.default,
	  bindings: {
	    shCtrl: '<',
	    menu: '<'
	  }
	};
	
	exports.default = MenuDropdownComponent;

/***/ },
/* 395 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$state', '$rootScope', 'SharedService', 'ngAuthSettings'];
	
	var MenuDropdownController = function () {
	  function MenuDropdownController($scope, $state, $rootScope, SharedService, ngAuthSettings) {
	    _classCallCheck(this, MenuDropdownController);
	
	    this.$state = $state;
	    this.$scope = $scope;
	    this.ngAuthSettings = ngAuthSettings;
	    this.$rootScope = $rootScope;
	    this.SharedService = SharedService;
	    $(".ver-mas-cat").css("display", "none");
	  }
	
	  _createClass(MenuDropdownController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }]);
	
	  return MenuDropdownController;
	}();
	
	MenuDropdownController.$inject = inject;
	
	exports.default = MenuDropdownController;

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _menuDropdown = __webpack_require__(394);
	
	var _menuDropdown2 = _interopRequireDefault(_menuDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MenuDropdownModule = _angular2.default.module('shared.components.menuDropdown', []).component('menuDropdown', _menuDropdown2.default);
	
	exports.default = MenuDropdownModule;

/***/ },
/* 397 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$uibModalInstance', 'modalOptions', 'SharedService'];
	
	var ModalDriverController = function () {
	  function ModalDriverController($scope, $uibModalInstance, modalOptions, SharedService) {
	    _classCallCheck(this, ModalDriverController);
	
	    this.$scope = $scope;
	    this.SharedService = SharedService;
	    this.$uibModalInstance = $uibModalInstance;
	    this.modalOptions = Object.assign({}, modalOptions);
	    this.vehiculo_transporte = this.modalOptions.vehiculo_transporte;
	  }
	
	  _createClass(ModalDriverController, [{
	    key: 'updateInformation',
	    value: function updateInformation(despachoPedido) {
	      var _this = this;
	
	      this.SharedService.updateDespachoPedido(despachoPedido).then(function (response) {
	        _this.ok();
	      }).catch(function (reason) {
	        _this.cancel();
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.$uibModalInstance.close();
	    }
	  }]);
	
	  return ModalDriverController;
	}();
	
	ModalDriverController.$inject = inject;
	
	exports.default = ModalDriverController;

/***/ },
/* 398 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$uibModalInstance', 'modalOptions', '$timeout'];
	
	var ModalMapController = function () {
	  function ModalMapController($scope, $uibModalInstance, modalOptions, $timeout) {
	    var _this = this;
	
	    _classCallCheck(this, ModalMapController);
	
	    this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.activateMap = false;
	    this.$uibModalInstance = $uibModalInstance;
	    this.map = Object.assign({}, modalOptions);
	    this.$timeout(function () {
	      _this.activate();
	    }, 1000);
	  }
	
	  _createClass(ModalMapController, [{
	    key: 'activate',
	    value: function activate() {
	      var _this2 = this;
	
	      this.activateMap = true;
	      this.$timeout(function () {
	        _this2.activateMap = false;
	      }, 1000);
	    }
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      var _this3 = this;
	
	      this.activateMap = true;
	      this.$timeout(function () {
	        _this3.activateMap = false;
	      }, 1000);
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.$uibModalInstance.close();
	    }
	  }]);
	
	  return ModalMapController;
	}();
	
	ModalMapController.$inject = inject;
	
	exports.default = ModalMapController;

/***/ },
/* 399 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$uibModalInstance', 'product', 'ngAuthSettings', 'SharedService', '$timeout'];
	
	var ModalRecommendProductController = function () {
	  function ModalRecommendProductController($scope, $uibModalInstance, product, ngAuthSettings, SharedService, $timeout) {
	    _classCallCheck(this, ModalRecommendProductController);
	
	    this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.SharedService = SharedService;
	    this.$uibModalInstance = $uibModalInstance;
	    this.ngAuthSettings = ngAuthSettings;
	    this.product = Object.assign({}, product);
	    this.mailSent = false;
	    this.contactDataForm = {};
	  }
	
	  _createClass(ModalRecommendProductController, [{
	    key: 'sendMailContact',
	    value: function sendMailContact() {
	      var _this = this;
	
	      if (this.contactForm.$valid) {
	        this.contactDataForm.productName = this.product.name;
	        this.contactDataForm.productUrl = this.ngAuthSettings.config.env.basePath + '/#!/app/product-detail-id/' + this.product.id;
	        this.SharedService.sendMailContact(this.contactDataForm).then(function (response) {
	          if (!response.error) {
	            _this.mailSent = true;
	            _this.$timeout(function () {
	              _this.ok();
	            }, 3000);
	          }
	        }).catch(function (reason) {});
	      } else {
	        this.contactForm.$error.required.forEach(function (field) {
	          field.$setDirty();
	        });
	      }
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.$uibModalInstance.close();
	    }
	  }]);
	
	  return ModalRecommendProductController;
	}();
	
	ModalRecommendProductController.$inject = inject;
	
	exports.default = ModalRecommendProductController;

/***/ },
/* 400 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$uibModalInstance', 'modalOptions'];
	
	var ModalResponseController = function () {
	  function ModalResponseController($scope, $uibModalInstance, modalOptions) {
	    _classCallCheck(this, ModalResponseController);
	
	    this.$scope = $scope;
	    this.$uibModalInstance = $uibModalInstance;
	    this.modalOptions = Object.assign({}, modalOptions);
	  }
	
	  _createClass(ModalResponseController, [{
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.$uibModalInstance.close();
	    }
	  }]);
	
	  return ModalResponseController;
	}();
	
	ModalResponseController.$inject = inject;
	
	exports.default = ModalResponseController;

/***/ },
/* 401 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$uibModalInstance', 'modalOptions', 'SharedService', '$q', 'LoginService', '$filter'];
	
	var ModalSelectClientController = function () {
	  function ModalSelectClientController($scope, $uibModalInstance, modalOptions, SharedService, $q, LoginService, $filter) {
	    var _this = this;
	
	    _classCallCheck(this, ModalSelectClientController);
	
	    this.$scope = $scope;
	    this.$q = $q;
	    this.$filter = $filter;
	    this.LoginService = LoginService;
	    this.$uibModalInstance = $uibModalInstance;
	    this.SharedService = SharedService;
	    this.modalOptions = Object.assign({}, modalOptions);
	    this.globals = this.modalOptions.globals;
	    this.sellerQuoteFormDataHeader = {};
	    this.sellerQuoteFormDataHeader.attendant = {};
	    this.savingQuoteOrderCartSellerHeader = false;
	    this.errorSavingQuoteOrderCartSellerHeader = false;
	    this.errorMessageSavingQuoteOrderCartSellerHeader = '';
	    this.errorMessagesSavingQuoteOrderCartSellerHeader = '';
	    this.loadingOcasionalInformationHeader = false;
	    this.errorloadingOcasionalInformationHeader = false;
	    this.validatingNumberIdHeader = false;
	    this.validatedNumberIdHeader = false;
	    this.numberIdIsValidHeader = false;
	    this.ocasionalClientExistHeader = false;
	    this.terceroAsociadoOtroVendedor = false;
	    this.loadingCitiesHeader = false;
	    this.loadingContactByIdentificationNumberHeader = false;
	    this.globalCities = {};
	    this.globalCities.value = '';
	    this.autocomplete_options = {
	      suggest: function suggest(term) {
	        _this.sellerQuoteFormDataHeader.destination = {};
	        _this.sellerQuoteFormDataHeader.destination.location = {};
	        var q = term.toLowerCase().trim();
	        var results = [];
	        if (term.length > 3) {
	          return _this.$q(function (resolve, reject) {
	            _this.loadingCitiesHeader = true;
	            _this.SharedService.getLocationBySearchText({ 'searchText': q }).then(function (response) {
	              _this.loadingCitiesHeader = false;
	              if (!response.error) {
	                angular.forEach(response, function (item) {
	                  var locationName = item.cityName + ', ' + item.stateName + ', ' + item.countryName;
	                  var result = {
	                    label: _this.$filter('toTrusted')(locationName),
	                    value: _this.$filter('toTrusted')(locationName),
	                    item: item
	                  };
	                  results.push(result);
	                });
	              }
	              resolve(results);
	            }).catch(function (reason) {
	              _this.loadingCitiesHeader = false;
	              reject(reason);
	            });
	          });
	        }
	      },
	      on_error: console.log,
	      on_select: function on_select(data) {
	        var item = data.item;
	        var locationName = item.cityName + ', ' + item.stateName + ', ' + item.countryName;
	        _this.sellerQuoteFormDataHeader.destination.location = {
	          "city": {
	            "id": item.cityId,
	            "name": item.cityName,
	            "indicative": 2
	          },
	          "state": {
	            "id": item.stateId,
	            "name": item.stateName
	          },
	          "country": {
	            "id": item.countryId,
	            "name": item.countryName,
	            "indicative": 57
	          },
	          "fullname": item.cityName + ', ' + item.stateName + ', ' + item.countryName
	        };
	      }
	    };
	    //// End: Mass -autocomplete - cities
	
	    //// Begin: Mass - autocomplete - attendat names
	    this.attendant_name_options = {
	      suggest: function suggest(term) {
	        // this.sellerQuoteFormDataHeader.attendant = {};
	        var q = term.toLowerCase().trim();
	        var results = [];
	        if (term.length > 2) {
	          _this.loadingAttendatNamesHeader = true;
	          return _this.$q(function (resolve, reject) {
	            _this.loadingCitiesHeader = true;
	            _this.SharedService.getThirdBySearchText({ 'searchText': q }).then(function (response) {
	              _this.loadingAttendatNamesHeader = false;
	              if (!response.error) {
	                angular.forEach(response, function (item) {
	                  var result = {
	                    label: _this.$filter('toTrusted')(item.name),
	                    value: _this.$filter('toTrusted')(item.name),
	                    item: item
	                  };
	                  results.push(result);
	                });
	              }
	              resolve(results);
	            }).catch(function (reason) {
	              _this.loadingAttendatNamesHeader = false;
	              reject(reason);
	            });
	          });
	        }
	      },
	      on_error: console.log,
	      on_select: function on_select(data) {
	        var documentNumber = data.item.documentNumber;
	        _this.preloadOcasionalInformationHeader(documentNumber);
	      }
	    };
	    //// End: Mass -autocomplete
	    this.activate();
	  }
	
	  _createClass(ModalSelectClientController, [{
	    key: 'activate',
	    value: function activate() {}
	  }, {
	    key: 'autosetAttendantClientTypeHeader',
	    value: function autosetAttendantClientTypeHeader() {
	      this.sellerQuoteFormDataHeader.attendant.documentDV = '';
	
	      if (this.sellerQuoteFormDataHeader.attendant.documentType === '2' || this.sellerQuoteFormDataHeader.attendant.documentType === '3') {
	        this.sellerQuoteFormDataHeader.attendant.clientType = '2';
	
	        $('#modalQuoteSellerHeader').find('#sellerQuoteAttendantDocumentNumberHeader').select();
	      } else if (this.sellerQuoteFormDataHeader.attendant.documentType) {
	        this.sellerQuoteFormDataHeader.attendant.clientType = '1';
	
	        $('#modalQuoteSellerHeader').find('#sellerQuoteAttendantDocumentNumberHeader').select();
	      } else {
	        this.sellerQuoteFormDataHeader.attendant.clientType = '';
	      }
	    }
	  }, {
	    key: 'clearNameCityHeader',
	    value: function clearNameCityHeader() {
	      this.globalCities.value = '';
	      this.sellerQuoteFormDataHeader.contact = {};
	    }
	  }, {
	    key: 'loadContactByIdentificacionNumberHeader',
	    value: function loadContactByIdentificacionNumberHeader(contactIdentificationNumber) {
	      var _this2 = this;
	
	      this.loadingContactByIdentificationNumberHeader = true;
	      this.SharedService.getContactByIdentificationNumber({ 'numberId': contactIdentificationNumber }).then(function (response) {
	        _this2.loadingContactByIdentificationNumberHeader = false;
	        if (response.data) {
	          if (response.data.contact && angular.isObject(response.data.contact)) {
	            _this2.sellerQuoteFormDataHeader.contact = response.data.contact;
	          } else {
	            var documentType = _this2.sellerQuoteFormDataHeader.contact.documentType;
	            var documentNumber = _this2.sellerQuoteFormDataHeader.contact.documentNumber;
	            _this2.sellerQuoteFormDataHeader.contact = {};
	            // Restore the info
	            if (documentType) _this2.sellerQuoteFormDataHeader.contact.documentType = documentType;
	            if (documentNumber) _this2.sellerQuoteFormDataHeader.contact.documentNumber = documentNumber;
	          }
	        }
	      }).catch(function (reason) {});
	    }
	  }, {
	    key: 'setClientQuoteFormDataSeller',
	    value: function setClientQuoteFormDataSeller(form) {
	      var _this3 = this;
	
	      if (!form.$valid) {
	        angular.forEach(form.$error, function (errorType) {
	          angular.forEach(errorType, function (field) {
	            field.$setDirty();
	          });
	        });
	        return false;
	      }
	      this.savingQuoteOrderCartSellerHeader = true;
	      this.errorSavingQuoteOrderCartSellerHeader = false;
	      this.errorMessageSavingQuoteOrderCartSellerHeader = '';
	      this.errorMessagesSavingQuoteOrderCartSellerHeader = '';
	      var cityId = this.sellerQuoteFormDataHeader.destination.location.city.id;
	      this.SharedService.updateInfoClientSelected({ 'sellerQuoteFormData': this.sellerQuoteFormDataHeader, 'cityId': cityId }).then(function (response) {
	        _this3.savingQuoteOrderCartSellerHeader = false;
	        if (response.error) {
	          _this3.errorSavingQuoteOrderCartSellerHeader = true;
	          _this3.errorMessageSavingQuoteOrderCartSellerHeader = response.message;
	          _this3.errorMessagesSavingQuoteOrderCartSellerHeader = response.errors;
	        } else {
	          var data = response.data;
	
	          var firstname = data.contact.primerNombre;
	          if (data.contact.segundoNombre) {
	            firstname += ' ' + data.contact.segundoNombre;
	          }
	
	          var lastname = data.contact.primerApellido;
	          if (data.contact.segundoApellido) {
	            lastname += ' ' + data.contact.segundoApellido;
	          }
	          _this3.globals.currentClient = {
	            "id": data.contact.id,
	            "userId": data.user.id,
	            "name": firstname + ' ' + lastname,
	            "firstname": firstname,
	            "lastname": lastname,
	            "position": data.contact.cargo,
	            "email": data.contact.email,
	            "phone": data.contact.telefono,
	            "mobile": data.contact.movil,
	            "documentNumber": data.contact.documento_numero,
	            "documentTypeId": data.contact.documento_tipo_id,
	            "documentTypeName": data.contact.documento_tipo_nombre,
	            "third": {
	              "id": data.third.id,
	              "name": data.third.nombre,
	              "attendantTypeId": data.third.tipo_persona_id,
	              "attendantTypeName": data.third.tipo_persona_nombre,
	              "documentTypeId": data.third.documento_tipo_id,
	              "documentTypeName": data.third.documento_tipo_nombre,
	              "documentNumber": data.third.documento_numero,
	              "documentDV": data.third.documento_dv,
	              "website": data.third.web_site,
	              "isB2B": data.third.isB2B
	            },
	            "contact": {
	              "id": data.contact.id,
	              "name": firstname + ' ' + lastname,
	              "firstname": firstname,
	              "lastname": lastname,
	              "position": data.contact.cargo,
	              "email": data.contact.email,
	              "phone": data.contact.telefono,
	              "mobile": data.contact.movil,
	              "documentTypeId": data.contact.documento_tipo_id,
	              "documentTypeName": data.contact.documento_tipo_nombre,
	              "documentNumber": data.contact.documento_numero,
	              "whatsappNumber": "",
	              "secondaryEmail": "",
	              "seller": data.contact.seller
	            },
	            "operatingCenter": {
	              "id": data.operatingCenter.id,
	              "code": data.operatingCenter.referencia,
	              "name": data.operatingCenter.nombre,
	              "phone": data.operatingCenter.telefono_principal,
	              "address": data.operatingCenter.direccion_principal,
	              "location": data.operatingCenter.location
	            }
	          };
	          // Set the current client
	          _this3.globals.currentUser.userId = data.user.id;
	          _this3.ok();
	        }
	      }).catch(function (reason) {
	        _this3.errorSavingQuoteOrderCartSellerHeader = true;
	        _this3.savingQuoteOrderCartSellerHeader = false;
	        _this3.errorMessageSavingQuoteOrderCartSellerHeader = 'Ha ocurrido un error al cargar el cliente.';
	      });
	    }
	  }, {
	    key: 'validateNumberIdUnusedHeader',
	    value: function validateNumberIdUnusedHeader(numberId) {
	      var _this4 = this;
	
	      if (numberId) {
	        this.validatingNumberIdHeader = true;
	        this.validatedNumberIdHeader = false;
	        this.numberIdIsValidHeader = false;
	        this.ocasionalClientExistHeader = false;
	        this.terceroAsociadoOtroVendedor = false;
	        var userId = '';
	        try {
	          userId = this.globals.currentUser.sellerId;
	        } catch (e) {}
	        // Send the request
	        this.SharedService.validateNumberIdUnusedHeader({ 'numberId': numberId, 'validateIfIsOcasionalClient': 1, 'userId': userId }).then(function (response) {
	          _this4.validatingNumberIdHeader = false;
	          _this4.validatedNumberIdHeader = true;
	
	          if (!response.error) {
	            _this4.numberIdIsValidHeader = true;
	
	            var documentType = _this4.sellerQuoteFormDataHeader.attendant.documentType;
	            var clientType = _this4.sellerQuoteFormDataHeader.attendant.clientType;
	
	            // Clean the data
	            _this4.sellerQuoteFormDataHeader = {};
	            _this4.sellerQuoteFormDataHeader.attendant = {};
	
	            // Restore only the data needed
	            _this4.sellerQuoteFormDataHeader.attendant.documentType = documentType;
	            _this4.sellerQuoteFormDataHeader.attendant.clientType = clientType;
	            _this4.sellerQuoteFormDataHeader.attendant.documentNumber = numberId;
	          } else if (response.errorCode === 'ERROR-CLIENTE-OCASIONAL-EXISTE' || response.errorCode === 'ERROR-TERCERO-EXISTE') {
	            _this4.numberIdIsValidHeader = true;
	            _this4.ocasionalClientExistHeader = true;
	
	            _this4.preloadOcasionalInformationHeader(numberId);
	          } else {
	
	            if (response.errorCode === 'ERROR-TERCERO-ASIGNADO-OTRO-VENDEDOR') {
	              // Clean the data
	              _this4.sellerQuoteFormDataHeader = {};
	              _this4.sellerQuoteFormDataHeader.attendant = {};
	              _this4.sellerQuoteFormDataHeader.attendant.documentNumber = numberId;
	
	              _this4.terceroAsociadoOtroVendedor = true;
	              _this4.numberIdIsValidHeader = true;
	            } else if (response.errorCode === 'ERROR-TERCERO-NO-HABILITADO') {
	              // Clean the data
	              _this4.sellerQuoteFormDataHeader = {};
	              _this4.sellerQuoteFormDataHeader.attendant = {};
	              _this4.sellerQuoteFormDataHeader.attendant.documentNumber = numberId;
	
	              _this4.thirdIsInactive = true;
	              _this4.numberIdIsValidHeader = true;
	            } else {
	              _this4.numberIdIsValidHeader = false;
	            }
	          }
	        }).catch(function (reason) {
	          _this4.validatingNumberIdHeader = false;
	          _this4.validatedNumberIdHeader = true;
	          _this4.numberIdIsValidHeader = false;
	        });
	      }
	    }
	  }, {
	    key: 'validateEmailUnusedHeader',
	    value: function validateEmailUnusedHeader() {
	      var _this5 = this;
	
	      var contactId = this.sellerQuoteFormDataHeader.contact.id;
	      var contactEmail = this.sellerQuoteFormDataHeader.contact.principalEmail;
	      if (!contactId && contactEmail) {
	        this.sellerQuoteFormDataHeader.contact.validatingEmail = true;
	        this.sellerQuoteFormDataHeader.contact.validatedEmail = false;
	        this.sellerQuoteFormDataHeader.contact.emailIsValid = true;
	        // Send the request
	        this.SharedService.validateEmailUnusedHeader({ 'email': contactEmail }).then(function (response) {
	          _this5.sellerQuoteFormDataHeader.contact.validatingEmail = false;
	          _this5.sellerQuoteFormDataHeader.contact.validatedEmail = true;
	          _this5.sellerQuoteFormDataHeader.contact.emailIsValid = !response.error;
	        }).catch(function (reason) {
	          _this5.sellerQuoteFormDataHeader.contact.validatingEmail = false;
	          _this5.sellerQuoteFormDataHeader.contact.validatedEmail = true;
	          _this5.sellerQuoteFormDataHeader.contact.emailIsValid = false;
	        });
	      }
	    }
	  }, {
	    key: 'preloadOcasionalInformationHeader',
	    value: function preloadOcasionalInformationHeader(documentNumber) {
	      var _this6 = this;
	
	      this.loadingOcasionalInformationHeader = true;
	      this.errorloadingOcasionalInformationHeader = false;
	
	      var cityId = '';
	      // Send the request
	      this.SharedService.getOcasionalInformation({ 'documentNumber': documentNumber, 'cityId': cityId }).then(function (response) {
	        _this6.loadingOcasionalInformationHeader = false;
	        if (!response.error) {
	          if (response.data) {
	            // If a client is already selected
	            var thirdId = '';
	            try {
	              thirdId = _this6.globals.currentClient.third.id;
	            } catch (e) {}
	
	            if (thirdId) {
	              _this6.sellerQuoteFormDataHeader.destinations = response.data.destinations;
	              _this6.sellerQuoteFormDataHeader.contacts = response.data.contacts;
	
	              _this6.sellerQuoteFormDataHeader.attendant = {
	                id: response.data.attendant.id,
	                documentType: response.data.attendant.documentType,
	                documentTypeName: response.data.attendant.documentTypeName, // TODO
	                documentNumber: response.data.attendant.documentNumber,
	                documentDV: response.data.attendant.documentDV,
	                clientType: response.data.attendant.clientType,
	                clientTypeName: response.data.attendant.clientTypeName,
	                name: response.data.attendant.name
	              };
	            } else {
	              _this6.sellerQuoteFormDataHeader = response.data;
	              _this6.sellerQuoteFormDataHeader.destination = {};
	              _this6.sellerQuoteFormDataHeader.contact = {};
	            }
	          } else {
	            _this6.sellerQuoteFormDataHeader = {};
	          }
	        } else {
	          _this6.errorloadingOcasionalInformationHeader = true;
	        }
	      }).catch(function (reason) {
	        _this6.loadingOcasionalInformationHeader = false;
	        _this6.errorloadingOcasionalInformationHeader = true;
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.$uibModalInstance.close(this.globals);
	    }
	  }]);
	
	  return ModalSelectClientController;
	}();
	
	ModalSelectClientController.$inject = inject;
	
	exports.default = ModalSelectClientController;

/***/ },
/* 402 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$uibModalInstance', 'modalOptions'];
	
	var ModalVideoController = function () {
	  function ModalVideoController($scope, $uibModalInstance, modalOptions) {
	    _classCallCheck(this, ModalVideoController);
	
	    this.$scope = $scope;
	    this.$uibModalInstance = $uibModalInstance;
	    this.modalOptions = Object.assign({}, modalOptions);
	  }
	
	  _createClass(ModalVideoController, [{
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.$uibModalInstance.close();
	    }
	  }]);
	
	  return ModalVideoController;
	}();
	
	ModalVideoController.$inject = inject;
	
	exports.default = ModalVideoController;

/***/ },
/* 403 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$uibModalInstance'];
	
	var OfflineModalController = function () {
	  function OfflineModalController($scope, $uibModalInstance) {
	    _classCallCheck(this, OfflineModalController);
	
	    this.$scope = $scope;
	    this.$uibModalInstance = $uibModalInstance;
	    this.user = {};
	  }
	
	  _createClass(OfflineModalController, [{
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'selectThird',
	    value: function selectThird() {
	      this.$uibModalInstance.close(this.user);
	    }
	  }]);
	
	  return OfflineModalController;
	}();
	
	OfflineModalController.$inject = inject;
	
	exports.default = OfflineModalController;

/***/ },
/* 404 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	restrictType.$inject = ['$filter'];
	
	function restrictType($filter) {
	  var restrict = {
	    num: {
	      rest: /\d/,
	      validate: /^[\d]*$/
	    },
	    numAmount: {
	      rest: /[\d.]/,
	      validate: /^\d{1,14}\.\d{1,}$|^\d{1,14}$|^\.\d{1,}$|^\d{1,14}\.$/
	    },
	    numValues: {
	      rest: /[\d.]/,
	      validate: /^\d{1,14}\.\d{1,}$|^\d{1,14}$|^\.\d{1,}$|^\d{1,14}\.$/
	    },
	    numDec: {
	      rest: /[\d.]/,
	      validate: /^\d{1,14}\.\d{1,}$|^\d{1,14}$|^\.\d{1,}$|^\d{1,14}\.$/
	    },
	    numHours: {
	      rest: /[\d.]/,
	      validate: /^[0-9]+$|^\d*\.[0-5][0-9]$|^\d*\.[0-5]$/
	    },
	    numDec4: {
	      rest: /[\d.]/,
	      validate: /^\d{1,14}\.\d{1,}$|^\d{1,14}$|^\.\d{1,}$|^\d{1,14}\.$/
	    },
	    numHund: {
	      rest: /[\d.]/,
	      validate: /^(100)\.0{1,}$|^(100)$|^([0-9]{1,2}\.\d{1,})$|^([0-9]{1,2})$/
	    },
	    //numHund99:{
	    //    rest:/[\d.]/,
	    //    validate:/^(99)\.0{1,}$|^(99)$|^([0-9]{1,2}\.\d{1,})$|^([0-9]{1,2})$/
	    //},
	    numDash: {
	      rest: /[\d-]/,
	      validate: /^[\d-]*$/
	    },
	    alfanumeric: {
	      rest: /[\w]/,
	      validate: /^[\w]*$/
	    },
	    date: {
	      rest: /\d|[/]/,
	      validate: /(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))/
	    },
	    email: {
	      rest: /\w|\W/,
	      // validate:/^(\b[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\b)$/
	      validate: /^[\w-]+(\.[\w-]+)*@([a-z0-9-]+(\.[a-z0-9-]+)*?\.[a-z]{2,6}|(\d{1,3}\.){3}\d{1,3})(:\d{4})?$/i
	    },
	    numEleven: {
	      rest: /\d/,
	      validate: /^[0-9]$|^(1[0-1])$|^(0[0-9])$/
	    }
	  };
	
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    link: link
	  };
	
	  function link(scope, elem, attrs, ngModelCtrl) {
	
	    var restType = '',
	        numAmountValue = 2,
	        numValuesValue = 0;
	    attrs.$observe('restrictType', function (value) {
	      restType = value;
	    });
	
	    elem.on('keypress', function (e) {
	      //var k = document.all ? e.keyCode : e.which,
	      var k = e.which ? e.which : e.keyCode,
	          rend = '';
	      if (k === 8 || k === 0 || k === 9 || k === 37 || k === 39) return true;
	      if (attrs.restrictType === "date") {
	        if (k === 42 || k === 43 || k === 44 || k === 45 || k === 46) {
	          k = 47;
	          var h = String.fromCharCode(k);
	          if (!ngModelCtrl.$viewValue) {
	            rend = h;
	          } else if (ngModelCtrl.$viewValue.length === 10) {
	            return false;
	          } else {
	            rend = ngModelCtrl.$viewValue + h;
	          }
	          ngModelCtrl.$setViewValue(rend);
	          ngModelCtrl.$render();
	          return false;
	        }
	      }
	
	      if (attrs.restrictType === "numAmount" || attrs.restrictType === "numValues" || attrs.restrictType === "numDec" || attrs.restrictType === "numHours" || attrs.restrictType === "numHund" || attrs.restrictType === "numDec4") {
	        if (k === 46) {
	          var regex = /[.]/g;
	          if (regex.test(ngModelCtrl.$viewValue)) {
	            return false;
	          }
	        }
	      }
	      var patron = restrict[restType].rest;
	      var n = String.fromCharCode(k);
	      return patron.test(n);
	    });
	
	    var decValue = 0;
	    if (attrs.restrictType === "numAmount" || attrs.restrictType === "numValues" || attrs.restrictType === "numDec" || attrs.restrictType === "numHours" || attrs.restrictType === "numHund" || attrs.restrictType === "numDec4") {
	
	      if (attrs.restrictType === "numAmount") decValue = numAmountValue;
	      if (attrs.restrictType === "numValues") decValue = numValuesValue;
	      if (attrs.restrictType === "numDec" || attrs.restrictType === "numHund" || attrs.restrictType === "numHours") decValue = 2;
	      if (attrs.restrictType === "numDec4") decValue = 4;
	
	      elem.on('focus', function () {
	        if (ngModelCtrl.$viewValue) {
	          var newVal = ngModelCtrl.$viewValue.replace(/[,]/g, '');
	          ngModelCtrl.$setViewValue(newVal);
	          ngModelCtrl.$render();
	        }
	      });
	      elem.on('blur', function () {
	        console.log(attrs);
	        if (elem[0].required) {
	          if (parseFloat(ngModelCtrl.$viewValue)) {
	            if (setInvalidIfRequired(ngModelCtrl.$viewValue)) return;
	          } else {
	            var valueReq = $filter('number')(0, decValue);
	            ngModelCtrl.$setViewValue(valueReq);
	            setInvalidIfRequired(ngModelCtrl.$viewValue);
	            ngModelCtrl.$render();
	            return;
	          }
	        }
	        if (ngModelCtrl.$viewValue) {
	          setErrorIfInvalid(ngModelCtrl.$viewValue);
	        } else {
	          var value = $filter('number')(0, decValue);
	          ngModelCtrl.$setViewValue(value);
	          setErrorIfInvalid(value);
	          ngModelCtrl.$render();
	          return;
	        }
	        var newVal = $filter('number')(ngModelCtrl.$viewValue, decValue);
	        if (!newVal || newVal === "") return;
	        ngModelCtrl.$setViewValue(newVal);
	        ngModelCtrl.$render();
	      });
	      ngModelCtrl.$formatters.unshift(function (value) {
	        if (angular.isString(value)) value = value.replace(/[,]/g, '');
	        scope.$watch(function () {
	          return elem[0].required;
	        }, function (bool) {
	          if (bool) {
	            //if(elem[0].required){
	            if (value) {
	              if (setInvalidIfRequired(value)) {
	                value = $filter('number')(value, decValue);
	                return value ? value : null;
	              }
	            }
	          } else {
	            ngModelCtrl.$setValidity('morethanzero', true);
	            return value ? value : null;
	          }
	        });
	        setErrorIfInvalid(value);
	        value = $filter('number')(value, decValue);
	        return value ? value : null;
	      });
	    } else if (attrs.restrictType === "date") {
	      elem.on('blur', function () {
	        if (ngModelCtrl.$viewValue) {
	          autocompleteDate();
	          setErrorIfInvalid(ngModelCtrl.$viewValue);
	        }
	      });
	      ngModelCtrl.$formatters.unshift(function (value) {
	        setErrorIfInvalid(value);
	        return value ? value : null;
	      });
	    } else if (attrs.restrictType === "email") {
	      elem.on('blur', function () {
	        if (ngModelCtrl.$viewValue) {
	          setErrorIfInvalid(ngModelCtrl.$viewValue);
	        } else {
	          ngModelCtrl.$setValidity('restEmail', true);
	        }
	      });
	      ngModelCtrl.$formatters.unshift(function (value) {
	        if (!value) {
	          ngModelCtrl.$setValidity('restEmail', true);
	          return value ? value : null;
	        }
	        setErrorIfInvalid(value);
	        return value ? value : null;
	      });
	    } else {
	      elem.on('blur change keyup', function () {
	        if (ngModelCtrl.$viewValue) {
	          setErrorIfInvalid(ngModelCtrl.$viewValue);
	        }
	      });
	      ngModelCtrl.$formatters.unshift(function (value) {
	        setErrorIfInvalid(value);
	        return value ? value : null;
	      });
	    }
	
	    function setErrorIfInvalid(value) {
	      var isValid = true,
	          error = "";
	      if (!value) {
	        isValid = true;
	      } else {
	        if (!attrs.restrictType) return;
	        var regex = restrict[attrs.restrictType].validate;
	        isValid = regex.test(value);
	      }
	
	      if (attrs.restrictType === "numAmount" || attrs.restrictType === "numValues" || attrs.restrictType === "numDec") {
	        error = 'NumDec';
	      } else if (attrs.restrictType === "numHund") {
	        error = 'hundred';
	      } else if (attrs.restrictType === "num") {
	        error = 'Numeric';
	      } else if (attrs.restrictType === "numDash") {
	        error = 'numDash';
	      } else if (attrs.restrictType === "date") {
	        error = 'restDate';
	      } else if (attrs.restrictType === "alfanumeric") {
	        error = 'alfanumeric';
	      } else if (attrs.restrictType === "email") {
	        error = 'restEmail';
	      } else if (attrs.restrictType === "numEleven") {
	        error = 'numEleven';
	      } else if (attrs.restrictType === "numHours") {
	        error = 'numHours';
	      }
	
	      ngModelCtrl.$setValidity(error, isValid); //numHours
	    }
	
	    function setInvalidIfRequired(value) {
	      //var regex = /^0+?\.?0+$|^\.0+$/,
	      //    isValid = regex.test(value);
	      var isValid = parseFloat(value) ? false : true;
	      ngModelCtrl.$setValidity('morethanzero', !isValid);
	      return isValid;
	    }
	
	    function autocompleteDate() {
	      var newVal = '',
	          regex1 = /(^[1-9](?=\/)(?![0123]))\//,
	          regex2 = /\/([1-9](?=\/)(?![0123]))\//,
	          regex3 = /\/(\d)[^\d]*$/,
	          regex4 = /\/([0-2][0-9])[^\d]*$/,
	          regex5 = /\/([3-9][0-9])[^\d]*$/,
	          regex6 = /\/(\d\d\d)[^\d]*$/;
	
	      if (regex1.test(ngModelCtrl.$viewValue)) {
	        newVal = '0' + ngModelCtrl.$viewValue;
	        ngModelCtrl.$setViewValue(newVal);
	        ngModelCtrl.$render();
	      }
	      if (regex2.test(ngModelCtrl.$viewValue)) {
	        newVal = ngModelCtrl.$viewValue.slice(0, 3) + '0' + ngModelCtrl.$viewValue.slice(3);
	        ngModelCtrl.$setViewValue(newVal);
	        ngModelCtrl.$render();
	      }
	      if (regex3.test(ngModelCtrl.$viewValue)) {
	        newVal = ngModelCtrl.$viewValue.slice(0, 6) + '201' + ngModelCtrl.$viewValue.slice(-1);
	        ngModelCtrl.$setViewValue(newVal);
	        ngModelCtrl.$render();
	      }
	      if (regex4.test(ngModelCtrl.$viewValue)) {
	        newVal = ngModelCtrl.$viewValue.slice(0, 6) + '20' + ngModelCtrl.$viewValue.slice(6, 8);
	        ngModelCtrl.$setViewValue(newVal);
	        ngModelCtrl.$render();
	      }
	      if (regex5.test(ngModelCtrl.$viewValue)) {
	        newVal = ngModelCtrl.$viewValue.slice(0, 6) + '19' + ngModelCtrl.$viewValue.slice(6, 8);
	        ngModelCtrl.$setViewValue(newVal);
	        ngModelCtrl.$render();
	      }
	      if (regex6.test(ngModelCtrl.$viewValue)) {
	        console.log(ngModelCtrl.$viewValue);
	        newVal = ngModelCtrl.$viewValue.slice(0, 6) + '2' + ngModelCtrl.$viewValue.slice(6, 9);
	        console.log(newVal);
	        ngModelCtrl.$setViewValue(newVal);
	        ngModelCtrl.$render();
	      }
	    }
	  }
	}
	
	exports.default = restrictType;

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _session = __webpack_require__(406);
	
	var _session2 = _interopRequireDefault(_session);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sessionModule = _angular2.default.module('shared.components.session', []).service('SessionService', _session2.default);
	
	exports.default = sessionModule;

/***/ },
/* 406 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SessionService = function () {
	  function SessionService($cookies, $window, $q, $http, ngAuthSettings) {
	    _classCallCheck(this, SessionService);
	
	    this.ngAuthSettings = ngAuthSettings;
	    this.$cookies = $cookies;
	    this.$q = $q;
	    this.$http = $http;
	    this.branches = null;
	    this.models = ['contactEmail', 'contactFirstName', 'contactLastName', 'contactName', 'contactPosition', 'firstname', 'fullname', 'isB2B', 'isContactCenter', 'isLogged', 'applyLogisticsService', 'isMaster', 'isNatural', 'isSupervisor', 'paymentMethod', 'isProvider', 'isSeller', 'operatingCenter', 'operatingCenterId', 'sellerExt', 'sellerId', 'thirdAttendantTypeId', 'thirdAttendantTypeName', 'thirdDocumentDV', 'thirdDocumentNumber', 'thirdDocumentTypeId', 'thirdDocumentTypeName', 'thirdId', 'thirdName', 'userId', 'username', 'phone', 'payCart', 'totalCartPay'];
	    this.store = $window.localStorage;
	  }
	
	  /**
	   * @method get              Get akey value
	   * @param  {string} key     Key to get
	   */
	
	
	  _createClass(SessionService, [{
	    key: 'get',
	    value: function get(key) {
	      if (key === 'globals') {
	        this.getGlobals().then(function (response) {
	          return response;
	        });
	      } else {
	        var result = this.store.getItem(key);
	        try {
	          result = JSON.parse(result);
	        } catch (e) {}
	        return result;
	      }
	    }
	
	    /**
	     * @method put              Set the key-value pair in the session
	     * @param  {string} key     Key to set
	     * @param  {object} value   Key value to set
	     */
	
	  }, {
	    key: 'put',
	    value: function put(key, value) {
	      if (key === 'globals') {
	        var currentUser = {};
	        this.models.forEach(function (val) {
	          if (value.currentUser) {
	            currentUser[val] = value.currentUser[val];
	          }
	        });
	        try {
	          this.store.setItem('currentUser', JSON.stringify(currentUser));
	        } catch (e) {
	          this.store.setItem('currentUser', currentUser);
	        }
	        try {
	          this.store.setItem('currentClient', JSON.stringify(value.currentClient));
	        } catch (e) {
	          this.store.setItem('currentClient', value.currentClient);
	        }
	      } else {
	        try {
	          this.store.setItem(key, JSON.stringify(value));
	        } catch (e) {
	          this.store.setItem(key, value);
	        }
	      }
	    }
	
	    /**
	     * @method remove         Remove key from session
	     * @param {string} key    Key to remove from session
	     */
	
	  }, {
	    key: 'remove',
	    value: function remove(key) {
	      if (key === 'globals') {
	        this.store.removeItem('currentUser');
	        this.store.removeItem('currentClient');
	
	        // this.$cookies.remove('operatingCenters');
	      } else {
	        this.store.removeItem(key);
	      }
	    }
	  }, {
	    key: 'getGlobals',
	    value: function getGlobals() {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        var currentUser = _this.store.getItem('currentUser'),
	            currentClient = _this.store.getItem('currentClient');
	        try {
	          currentUser = JSON.parse(currentUser);
	        } catch (e) {}
	        try {
	          currentClient = JSON.parse(currentClient);
	        } catch (e) {}
	        if (currentUser && currentUser.userId) {
	          if (_this.branches) {
	            currentUser['operatingCenters'] = _this.branches;
	            resolve({
	              'currentUser': currentUser,
	              'currentClient': currentClient
	            });
	          } else {
	            _this.$http({
	              method: 'GET', //actionGetOperatingCentersByUserId
	              url: _this.ngAuthSettings.config.env.apiEndPoint + '/login/get-operating-centers-by-user-id?userId=' + currentUser.userId,
	              cache: false,
	              headers: { 'Content-Type': 'application/json' }
	            }).then(function (response) {
	              currentUser['operatingCenters'] = response.data.data;
	              _this.branches = response.data.data;
	              resolve({
	                'currentUser': currentUser,
	                'currentClient': currentClient
	              });
	            }).catch(function (reason) {
	              resolve({
	                'currentUser': currentUser,
	                'currentClient': currentClient
	              });
	            });
	          }
	        } else {
	          resolve({
	            'currentUser': currentUser,
	            'currentClient': currentClient
	          });
	        }
	      });
	    }
	  }]);
	
	  return SessionService;
	}();
	
	SessionService.$inject = ['$cookies', '$window', '$q', '$http', 'ngAuthSettings'];
	
	exports.default = SessionService;

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _autocomplete = __webpack_require__(382);
	
	var _autocomplete2 = _interopRequireDefault(_autocomplete);
	
	var _whenScrolled = __webpack_require__(410);
	
	var _whenScrolled2 = _interopRequireDefault(_whenScrolled);
	
	var _modalResponse = __webpack_require__(400);
	
	var _modalResponse2 = _interopRequireDefault(_modalResponse);
	
	var _modalVideo = __webpack_require__(402);
	
	var _modalVideo2 = _interopRequireDefault(_modalVideo);
	
	var _offlineModal = __webpack_require__(403);
	
	var _offlineModal2 = _interopRequireDefault(_offlineModal);
	
	var _modalRecommendProduct = __webpack_require__(399);
	
	var _modalRecommendProduct2 = _interopRequireDefault(_modalRecommendProduct);
	
	var _restrictType = __webpack_require__(404);
	
	var _restrictType2 = _interopRequireDefault(_restrictType);
	
	var _session = __webpack_require__(405);
	
	var _session2 = _interopRequireDefault(_session);
	
	var _menuDropdown = __webpack_require__(396);
	
	var _menuDropdown2 = _interopRequireDefault(_menuDropdown);
	
	var _banners = __webpack_require__(384);
	
	var _banners2 = _interopRequireDefault(_banners);
	
	var _modalMap = __webpack_require__(398);
	
	var _modalMap2 = _interopRequireDefault(_modalMap);
	
	var _modalDriver = __webpack_require__(397);
	
	var _modalDriver2 = _interopRequireDefault(_modalDriver);
	
	var _modalSelectClient = __webpack_require__(401);
	
	var _modalSelectClient2 = _interopRequireDefault(_modalSelectClient);
	
	var _staticViews = __webpack_require__(409);
	
	var _staticViews2 = _interopRequireDefault(_staticViews);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sharedComponentsModule = _angular2.default.module('shared.components', [_autocomplete2.default.name, _whenScrolled2.default.name, _menuDropdown2.default.name, _banners2.default.name, _staticViews2.default.name, _session2.default.name]).controller('ModalResponseController', _modalResponse2.default).directive('restrictType', _restrictType2.default).controller('OfflineModalController', _offlineModal2.default).controller('ModalSelectClientController', _modalSelectClient2.default).controller('ModalMapController', _modalMap2.default).controller('ModalDriverController', _modalDriver2.default).controller('ModalRecommendProductController', _modalRecommendProduct2.default).controller('ModalVideoController', _modalVideo2.default).filter('toTrusted', ['$sce', function ($sce) {
	  return function (text) {
	    return $sce.trustAsHtml(text);
	  };
	}]);
	
	exports.default = sharedComponentsModule;

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _howBuy = __webpack_require__(516);
	
	var _howBuy2 = _interopRequireDefault(_howBuy);
	
	var _cookies = __webpack_require__(514);
	
	var _cookies2 = _interopRequireDefault(_cookies);
	
	var _faq = __webpack_require__(515);
	
	var _faq2 = _interopRequireDefault(_faq);
	
	var _privacityPolitics = __webpack_require__(521);
	
	var _privacityPolitics2 = _interopRequireDefault(_privacityPolitics);
	
	var _terms = __webpack_require__(522);
	
	var _terms2 = _interopRequireDefault(_terms);
	
	var _notFoundPage = __webpack_require__(517);
	
	var _notFoundPage2 = _interopRequireDefault(_notFoundPage);
	
	var _quotations = __webpack_require__(520);
	
	var _quotations2 = _interopRequireDefault(_quotations);
	
	var _purchaseOrder = __webpack_require__(519);
	
	var _purchaseOrder2 = _interopRequireDefault(_purchaseOrder);
	
	var _orders = __webpack_require__(518);
	
	var _orders2 = _interopRequireDefault(_orders);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	routesConfig.$inject = ['$stateProvider'];
	
	// PAGOS Y ANTICIPOS
	
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.privacityPolitics', {
	    url: "/politicas-de-privacidad",
	    template: _privacityPolitics2.default
	  }).state('home.terms', {
	    url: "/terminos-y-condiciones",
	    template: _terms2.default
	  }).state('home.cookies', {
	    url: "/cookies",
	    template: _cookies2.default
	  }).state('home.faq', {
	    url: "/faq",
	    template: _faq2.default
	  }).state('home.404', {
	    url: "/404",
	    template: _notFoundPage2.default
	  })
	
	  // PAGOS Y ANTICIPOS
	  // .state('home.quotations', {
	  //   url: "/cotizaciones",
	  //   template: quotationsTemplate
	  // })
	  // .state('home.purchaseOrder', {
	  //   url: "/orden-de-compra",
	  //   template: purchaseOrderTemplate
	  // })
	  // .state('home.AdvancesOrders', {
	  //   url: "/pedidos",
	  //   template: AdvancesOrdersTemplate
	  // })
	
	  .state('home.howBuy', {
	    url: "/como-comprar",
	    template: _howBuy2.default
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _staticViews = __webpack_require__(408);
	
	var _staticViews2 = _interopRequireDefault(_staticViews);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var staticViewsModule = _angular2.default.module('shared.components.staticViews', []).config(_staticViews2.default);
	
	exports.default = staticViewsModule;

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var whenScrolledModule = _angular2.default.module('shared.components.whenScrolled', []).directive('whenScrolled', whenScrolled);
	
	function whenScrolled() {
	  return function (scope, elm, attr) {
	    var raw = elm[0];
	
	    elm.bind('scroll', function () {
	      if (raw.scrollTop + raw.offsetHeight >= raw.scrollHeight) {
	        scope.$apply(attr.whenScrolled);
	      }
	    });
	  };
	}
	
	whenScrolled.$inject = [];
	exports.default = whenScrolledModule;

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _providersSideMenu = __webpack_require__(525);
	
	var _providersSideMenu2 = _interopRequireDefault(_providersSideMenu);
	
	var _filterToolbox = __webpack_require__(523);
	
	var _filterToolbox2 = _interopRequireDefault(_filterToolbox);
	
	var _pagerToolbox = __webpack_require__(524);
	
	var _pagerToolbox2 = _interopRequireDefault(_pagerToolbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function compareTo() {
	  return {
	    require: "ngModel",
	    scope: {
	      otherModelValue: "=compareTo"
	    },
	    link: function link(scope, element, attributes, ngModel) {
	      ngModel.$validators.compareTo = function (modelValue) {
	        return modelValue === scope.otherModelValue;
	      };
	      scope.$watch("otherModelValue", function () {
	        ngModel.$validate();
	      });
	    }
	  };
	} // compareTo.$inject = ['$filter'];
	
	
	function upperCase() {
	  return {
	    restrict: 'EA',
	    require: 'ngModel',
	    link: function link(scope, element, attr, ngModel) {
	      ngModel.$parsers.push(function (value) {
	        if (!value) return null;
	        var newVal = value.toUpperCase();
	        ngModel.$setViewValue(newVal);
	        ngModel.$render();
	        return newVal;
	      });
	      ngModel.$formatters.push(function (value) {
	        if (!value || !angular.isString(value)) return;
	        return value.toUpperCase();
	      });
	    }
	  };
	}
	
	function providerSideMenu() {
	  return {
	    restrict: 'A',
	    template: _providersSideMenu2.default
	  };
	}
	
	function toolboxFilter() {
	  return {
	    restrict: 'A',
	    template: _filterToolbox2.default
	  };
	}
	
	function toolboxPagination() {
	  return {
	    restrict: 'A',
	    template: _pagerToolbox2.default
	  };
	}
	
	function ngEnter() {
	  return function (scope, element, attrs) {
	    element.bind("keydown keypress", function (event) {
	      if (event.which === 13) {
	        scope.$apply(function () {
	          scope.$eval(attrs.ngEnter);
	        });
	
	        event.preventDefault();
	      }
	    });
	  };
	}
	
	function checkStrength() {
	  return {
	    replace: false,
	    restrict: 'EACM',
	    link: function link(scope, iElement, iAttrs) {
	
	      var strength = void 0;
	      strength = {
	        colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
	        mesureStrength: function mesureStrength(p) {
	          var _force = 0;
	          //let _regex = /[$-/:-?{-~!"^_`\[\]]/;
	          var _regex = /[$-/:-?-~!^_`\[\]]/;
	
	          var _lowerLetters = /[a-z]+/.test(p);
	          var _upperLetters = /[A-Z]+/.test(p);
	          var _numbers = /[0-9]+/.test(p);
	          var _symbols = _regex.test(p);
	
	          var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
	          var _passedMatches = $.grep(_flags, function (el) {
	            return el === true;
	          }).length;
	
	          _force += 2 * p.length + (p.length >= 10 ? 1 : 0);
	          _force += _passedMatches * 10;
	
	          // penality (short password)
	          _force = p.length <= 6 ? Math.min(_force, 10) : _force;
	
	          // penality (poor letiety of characters)
	          _force = _passedMatches == 1 ? Math.min(_force, 10) : _force;
	          _force = _passedMatches == 2 ? Math.min(_force, 20) : _force;
	          _force = _passedMatches == 3 ? Math.min(_force, 40) : _force;
	          return _force;
	        },
	
	        getColor: function getColor(s) {
	          var idx = 0;
	          if (s <= 10) {
	            idx = 0;
	          } else if (s <= 20) {
	            idx = 1;
	          } else if (s <= 30) {
	            idx = 2;
	          } else if (s <= 40) {
	            idx = 3;
	          } else {
	            idx = 4;
	          }
	          return {
	            idx: idx + 1,
	            col: this.colors[idx]
	          };
	        }
	      }; // let strength
	      scope.$watch(iAttrs.checkStrength, function () {
	        if (scope.password === '') {
	          iElement.css({
	            "display": "none"
	          });
	        } else {
	          if (scope.password) {
	            var c = strength.getColor(strength.mesureStrength(scope.password));
	            scope.passwordStrength = c;
	            iElement.css({
	              "display": "inline"
	            });
	            iElement.children('li').css({
	              "background": "#DDD"
	            }).slice(0, c.idx).css({
	              "background": c.col
	            });
	          }
	        }
	      }); // watch
	    }, // link
	
	    template: '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>'
	  };
	}
	
	exports.default = {
	  compareTo: compareTo,
	  ngEnter: ngEnter,
	  upperCase: upperCase,
	  providerSideMenu: providerSideMenu,
	  toolboxPagination: toolboxPagination,
	  toolboxFilter: toolboxFilter,
	  checkStrength: checkStrength
	};

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _directivesSimple = __webpack_require__(411);
	
	var _directivesSimple2 = _interopRequireDefault(_directivesSimple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DirectivesModule = _angular2.default.module('app.shared.directives', []).directive('compareTo', _directivesSimple2.default.compareTo).directive('upperCase', _directivesSimple2.default.upperCase).directive('providerSideMenu', _directivesSimple2.default.providerSideMenu).directive('toolboxFilter', _directivesSimple2.default.toolboxFilter).directive('toolboxPagination', _directivesSimple2.default.toolboxFilter).directive('ngEnter', _directivesSimple2.default.ngEnter).directive('checkStrength', _directivesSimple2.default.checkStrength);
	
	exports.default = DirectivesModule;

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _filters = __webpack_require__(414);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var filters = _angular2.default.module('shared.filters', []).filter('capitalize', _filters2.default.capitalize).filter('s4bCurrency', _filters2.default.s4bCurrency).filter('fileSize', _filters2.default.fileSize).filter('ngEnter', _filters2.default.ngEnter).filter('b2bModalSelect', _filters2.default.b2bModalSelect).filter('textFilterFilter', _filters2.default.textFilterFilter);
	
	exports.default = filters;

/***/ },
/* 414 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	textFilterFilter.$inject = ['$rootScope'];
	function textFilterFilter($rootScope) {
	  return function (products, partSearchText, kitSearchFiltered) {
	    var output = [];
	    if (partSearchText) {
	      products.forEach(function (product) {
	        var productName = product.name;
	        if (productName) {
	          var productNameLowercase = productName.toLowerCase();
	          var partSearchTextLowercase = partSearchText.toLowerCase();
	          if (productNameLowercase.indexOf(partSearchTextLowercase) !== -1) {
	            if (!kitSearchFiltered) {
	              if (product.relatedParentId === kitSearchFiltered) {
	                output.push(product);
	              }
	            } else {
	              output.push(product);
	            }
	          }
	        }
	      });
	      return output;
	    }
	    return products;
	  };
	}
	
	function capitalize() {
	  return function (input, all) {
	    return !!input ? input.replace(/([^\W_]+[^\s-]*) */g, function (txt) {
	      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	    }) : '';
	  };
	}
	
	function ngEnter() {
	  return function (scope, element, attrs) {
	    element.bind("keydown keypress", function (event) {
	      if (event.which === 13) {
	        scope.$apply(function () {
	          scope.$eval(attrs.ngEnter);
	        });
	
	        event.preventDefault();
	      }
	    });
	  };
	}
	
	function b2bModalSelect() {
	  return function (data) {
	    if (data.length > 83) {
	      data = data.slice(0, 80);
	      data += '...';
	    }
	    return data;
	  };
	}
	
	s4bCurrency.$inject = ['$filter'];
	function s4bCurrency($filter) {
	  return function (input, currency, decimals) {
	    var decimal = decimals || 2;
	
	    if (currency === undefined) {
	      currency = '';
	    } else if (currency !== '') {
	      currency = currency + ' ';
	    }
	    input = parseFloat(input);
	    input = input.toFixed(input % 1 === 0 ? 0 : decimal);
	    return currency + ' ' + input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	  };
	}
	
	function fileSize() {
	  var units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
	  return function (bytes, precision) {
	    if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) {
	      return '?';
	    }
	
	    var unit = 0;
	
	    while (bytes >= 1024) {
	      bytes /= 1024;
	      unit++;
	    }
	
	    return bytes.toFixed(+precision) + ' ' + units[unit];
	  };
	}
	
	exports.default = {
	  textFilterFilter: textFilterFilter,
	  capitalize: capitalize,
	  fileSize: fileSize,
	  ngEnter: ngEnter,
	  s4bCurrency: s4bCurrency,
	  b2bModalSelect: b2bModalSelect
	};

/***/ },
/* 415 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	AuthInterceptor.$inject = ['AuthTokenFactory', '$q', '$injector'];
	AuthTokenFactory.$inject = ['$window'];
	
	function AuthTokenFactory($window) {
	  var store = $window.localStorage;
	  return {
	    getToken: getToken,
	    setToken: setToken
	  };
	
	  function getToken(key) {
	    return store.getItem(key);
	  }
	
	  function setToken(key, token) {
	    if (token) {
	      store.setItem(key, token);
	    } else {
	      store.removeItem(key);
	    }
	  }
	}
	
	function AuthInterceptor(AuthTokenFactory, $q, $injector) {
	  var vm = this;
	
	  vm.toastPosition = {
	    bottom: false,
	    top: true,
	    left: false,
	    right: true
	  };
	  return {
	    request: addToken,
	    requestError: requestError,
	    response: response,
	    responseError: _responseError
	  };
	
	  function addToken(config) {
	    var token = AuthTokenFactory.getToken();
	    if (token) {
	      config.headers = config.headers || {};
	      // config.headers.Authorization = 'Bearer ';
	    }
	    return config;
	  }
	
	  function requestError(rejection) {
	    return $q.reject(rejection);
	  }
	
	  function response(res) {
	    //return null; // <-- this is not returning the config object
	    //return response || $q.when(response);
	    //console.log(res);
	    return res;
	  }
	
	  function _responseError(rejection) {
	    // if (status === 0 || status === -1 || status === 503) {
	    //   MainService.checked = false;
	    //   // showActionToast(rejection,'Perdiste la conexión con el servidor.');
	    //   console.log('SIN CONEXION -- net::ERR_INTERNET_DISCONNECTED');
	    // }
	    // else if (status === 401) {
	    //   // TODO: Descomentariar el redireccionamiento cuando se vuelva a habilitar la seguridad
	    //   // $state.go('login');
	    //   MainService.showMessageResultError('No estás autorizado.');
	    // }
	    // else if(status === 400) console.log('Bad Request');
	    // else if(status === 404) console.log('Not Found');
	    // //else if (status === 331) console.log('RED SUSPENDIDA -- net::ERR_NETWORK_IO_SUSPENDED');
	    // else if (status >= 500 && status !== 504 && status !== 503) {
	    //   if(status === 500 && rejection.data.message === "No se puede eliminar el registro.") MainService.showMessageResultErrorToDelete();
	    //   else MainService.showMessageResultError('Error interno del servidor.');
	    // }
	    // else if (status === 403) {
	    // var nameState = $state.current.name;
	    // WindowViewService.changeRestart(true);
	    // MainService.showMessageResultError('No tienes permisos.');
	    // $state.go('home');
	    // WindowViewService.deleteWindowObject(nameState, true);
	    // WindowViewService.changeRestart(false);
	    // }
	    // else if (status === 504) showActionToast(rejection,'Tiempo de espera agotado.');
	    // else MainService.showMessageResultError('Error inesperado.');
	
	    return $q.reject(rejection);
	  }
	}
	
	var authObject = {
	  AuthTokenFactory: AuthTokenFactory,
	  AuthInterceptor: AuthInterceptor
	};
	
	exports.default = authObject;

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _auth = __webpack_require__(415);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sharedProvidersModule = _angular2.default.module('shared.providers', []).factory('AuthInterceptor', _auth2.default.AuthInterceptor).factory('AuthTokenFactory', _auth2.default.AuthTokenFactory);
	
	exports.default = sharedProvidersModule;

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _modalResponseView = __webpack_require__(3);
	
	var _modalResponseView2 = _interopRequireDefault(_modalResponseView);
	
	var _modalSelectClientView = __webpack_require__(512);
	
	var _modalSelectClientView2 = _interopRequireDefault(_modalSelectClientView);
	
	var _modalSelectBranchB2bUserView = __webpack_require__(36);
	
	var _modalSelectBranchB2bUserView2 = _interopRequireDefault(_modalSelectBranchB2bUserView);
	
	var _pqrsFormModalView = __webpack_require__(37);
	
	var _pqrsFormModalView2 = _interopRequireDefault(_pqrsFormModalView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', '$state', '$window', 'SharedService', 'CartService', '$rootScope', '$uibModal', 'AuthTokenFactory', 'ngAuthSettings', '$templateCache', '$location', '$timeout', 'SessionService', 'userData', 'LoginService'];
	
	var SharedController = function () {
	  function SharedController($scope, $state, $window, SharedService, CartService, $rootScope, $uibModal, AuthTokenFactory, ngAuthSettings, $templateCache, $location, $timeout, SessionService, userData, LoginService) {
	    var _this = this;
	
	    _classCallCheck(this, SharedController);
	
	    this.$state = $state;
	    this.LoginService = LoginService;
	    this.SharedService = SharedService;
	    this.CartService = CartService;
	    this.SessionService = SessionService;
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	    this.$templateCache = $templateCache;
	    this.$window = $window;
	    this.$timeout = $timeout;
	    this.$location = $location;
	    this.ngAuthSettings = ngAuthSettings;
	    this.AuthTokenFactory = AuthTokenFactory;
	    this.$uibModal = $uibModal;
	
	    this.clientSelected = {};
	    this.formatDate = 'yyyy/MM/dd';
	    this.dateOptions = {
	      maxDate: new Date(2020, 5, 22),
	      startingDay: 1,
	      showWeeks: false
	    };
	    this.altInputFormats = ['M!/d!/yyyy'];
	    this.openModal = false;
	    this.submittingCart = false;
	    this.checkOrderAfterConect = false;
	    this.isCheckingCart = false;
	    this.globals = userData.globals;
	    this.cart = userData.cartInfo;
	    this.params = userData.params;
	    this.globalCategoriesMenu = userData.categoriesMenu;
	    this.globalBanners = userData.banners;
	    this.globalCategories = userData.globalCategories;
	    this.mensajeNotificacion = '';
	    this.tituloMensajeNotificacion = '';
	    this.newsletterDataForm = {};
	    this.sendingNewsletterInfo = true;
	    this.cookiesAccepted = false;
	    this.newsletterInfoError = false;
	    this.enteredCaptcha = false;
	    this.expiredCaptcha = false;
	    this.captchaId = null;
	    this.captcha = '';
	    this.searchProductsGlobal = [];
	    this.newsletterInfoMessage = '';
	    this.globalSearchTextHome = '';
	    this.themeCaptcha = 'light';
	    this.captchaKey = this.ngAuthSettings.config.captchaKey;
	    this.activate();
	
	    this.$scope.$on('onReloadPage', function (event, arg) {
	      event.stopPropagation();
	      _this.activate();
	    });
	
	    this.$scope.$on('onUpdateCart', function (event, arg) {
	      event.stopPropagation();
	      _this.updateCartInfo();
	    });
	
	    this.$scope.$on('onShowModalErrorAddItem', function (event, arg) {
	      event.stopPropagation();
	      // this.messageErrorItem = arg;
	      // showErrorModalToAdd();
	    });
	
	    // this.$rootScope.$on('$viewContentLoaded', () => {
	    //   this.$templateCache.removeAll();
	    //
	    // });
	  }
	
	  _createClass(SharedController, [{
	    key: 'activate',
	    value: function activate() {
	      if (!this.globals.currentUser) {
	        if (this.$state.current.name !== 'home.login' && this.$state.current.name !== 'home.register' && this.$state.current.name !== 'home.knowUs' && this.$state.current.name !== 'home.contact'
	        // this.$state.current.name !== 'home.faq' &&
	        // this.$state.current.name !== '/policies' &&
	        // this.$state.current.name !== '/cookies' &&
	        // this.$state.current.name !== '/contactcenter_home'
	        && this.ngAuthSettings.site.config.redirectToB2bPage) {
	          this.$state.go(this.ngAuthSettings.site.config.header.logout.state_lost_session);
	        }
	      }
	      // this.redirect();
	      this.getParams();
	      this.appendToElement = window.document.querySelector('#formulario-busqueda-header');
	      this.cookiesAccepted = this.SessionService.get("enabledCookies");
	      this.getCurrentTime();
	      this.initScrollCartResume();
	      var Venedor = {
	        init: function init() {
	          if (!this.initialised) {
	            this.initialised = true;
	          } else {
	            return;
	          }
	          // Call Venedor Functions
	          this.menuHover();
	          this.responsiveMenu();
	        },
	        getNavContainerHeight: function getNavContainerHeight() {
	          /* Get nav container Height for better fixed menu */
	          if ($(window).width() > 768) {
	            this.navContainerHeight = $('#main-nav-container').outerHeight();
	          }
	        },
	        menuHover: function menuHover() {
	          // Sub menu show/hide with hoverIntent plugin
	          if ($.fn.hoverIntent) {
	            $('ul.menu').hoverIntent({
	              over: function over() {
	                if ($(window).width() > 768) {
	                  $(this).addClass('active').children('ul, .mega-menu').fadeIn(200);
	                } else {
	                  return false;
	                }
	              },
	              out: function out() {
	                if ($(window).width() > 768) {
	                  $(this).removeClass('active').children('ul, .mega-menu').fadeOut(75);
	                } else {
	                  return false;
	                }
	              },
	              selector: 'li',
	              timeout: 145,
	              interval: 55
	            });
	          }
	        },
	        responsiveMenu: function responsiveMenu() {
	          var menu = $('.menu').clone(false).removeClass('menu').addClass('responsive-nav container'),
	              container = $('#responsive-nav');
	          container.append(menu);
	          container.find('li, .col-2, .col-3, .col-4, .col-5').each(function () {
	            var $this = $(this);
	            if ($this.hasClass('mega-menu-container')) {
	              $this.removeClass('mega-menu-container');
	            }
	            $this.has('ul, .megamenu').prepend('<span class="menu-button"></span>');
	          });
	          $('span.menu-button').on('click', function () {
	            var $this = $(this);
	            if (!$this.hasClass('active')) {
	              $(this).addClass('active').siblings('ul, .mega-menu').slideDown('800');
	            } else {
	              $(this).removeClass('active').siblings('ul, .mega-menu').slideUp('800');
	            }
	          });
	          $("#responsive-nav").on('click', 'a', function () {
	            $("ul.responsive-nav").slideToggle();
	          });
	          $('#responsive-nav-button').on('click', function () {
	            var $this = $(this);
	            if ($this.hasClass('active')) {
	              $('#responsive-nav').find('.responsive-nav').slideUp(300, function () {
	                $this.removeClass('active');
	              });
	            } else {
	              $('#responsive-nav').find('.responsive-nav').slideDown(300, function () {
	                $this.addClass('active');
	              });
	            }
	          });
	        }
	      };
	      Venedor.init();
	      this.$timeout(function () {
	        $('#iconthird, #iconthird-user').on('click', function () {
	          $('#slthird').slideToggle('fast');
	        });
	      }, 500);
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      var _this2 = this;
	
	      this.LoginService.logout().then(function (response) {
	        if (_this2.cart.cartId) {
	          var _data = {
	            'cartId': _this2.cart.cartId
	          };
	          _this2.CartService.clearCart(_data).then(function (response) {
	            _this2.globals = {};
	            _this2.cart = {};
	            _this2.SessionService.remove('globals');
	            _this2.SessionService.remove('cartId');
	            // if(this.$state.current.name !== 'home.home'){
	            _this2.$rootScope.reloadProyect = true;
	            _this2.$rootScope.reloadProyectState = _this2.ngAuthSettings.site.app.header.logo.url;
	            // } else {
	            //
	            // }
	            _this2.$state.reload();
	          }).catch(function (reason) {});
	        } else {
	          _this2.globals = {};
	          _this2.cart = {};
	          _this2.SessionService.remove('globals');
	          _this2.SessionService.remove('cartId');
	          _this2.$rootScope.reloadProyect = true;
	          _this2.$rootScope.reloadProyectState = _this2.ngAuthSettings.site.app.header.logo.url;
	          _this2.$state.reload();
	        }
	      });
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      this.currentTime = new Date().getSeconds();
	    }
	  }, {
	    key: 'setWidgetId',
	    value: function setWidgetId(widgetId) {
	      this.captchaId = widgetId;
	    }
	  }, {
	    key: 'setResponse',
	    value: function setResponse(response) {
	      this.enteredCaptcha = true;
	      this.expiredCaptcha = false;
	
	      this.captcha = response;
	    }
	  }, {
	    key: 'cbExpiration',
	    value: function cbExpiration() {
	      this.expiredCaptcha = true;
	      this.enteredCaptcha = false;
	
	      this.captcha = '';
	    }
	  }, {
	    key: 'redirect',
	    value: function redirect() {
	      // /**
	      //  * Redirect to the b2b page if the b2b site flag is enabled and
	      //  * there is no user logged.
	      //  */
	      // if(this.ngAuthSettings.site.config.redirectToB2bPage) {
	      //   // let urlB2b = this.ngAuthSettings.site.app.url + 'introB2b.html';
	      //   if(
	      //     this.$state.current.name !== 'home.login' &&
	      //     this.$state.current.name !== 'home.register' &&
	      //     this.$state.current.name !== 'home.knowUs' &&
	      //     this.$state.current.name !== 'home.contact'
	      //     // this.$state.current.name !== 'home.faq' &&
	      //     // this.$state.current.name !== '/policies' &&
	      //     // this.$state.current.name !== '/cookies' &&
	      //     // this.$state.current.name !== '/contactcenter_home'
	      //   )
	      //   {
	      //     try {
	      //       if(!this.globals.currentUser.userId)  this.$state.go(this.ngAuthSettings.site.config.header.logout.state_lost_session);
	      //     }
	      //     catch(e) { this.$state.go(this.ngAuthSettings.site.config.header.logout.state_lost_session); }
	      //   }
	      //   else {
	      //     try {
	      //       if(this.$state.current.name === 'home.contactcenter_home' && !this.globals.currentUser.userId) {
	      //         this.$state.go(this.ngAuthSettings.site.config.header.logout.state_lost_session);
	      //       }
	      //     }
	      //     catch(e) {
	      //       this.$state.go(this.ngAuthSettings.site.config.header.logout.state_lost_session);
	      //     }
	      //   }
	      // }
	      //
	      // /**
	      //  * ===================================================================================================
	      //  * Redirect to the home page if the user is logged
	      //  * ===================================================================================================
	      //  */
	      // if(this.$state.current.name === 'home.login') {
	      //   try {
	      //     if(this.globals.currentUser.userId) {
	      //       this.$state.go(this.ngAuthSettings.site.app.header.logo.url);
	      //     }
	      //   }
	      //   catch(e) {}
	      // }else if(this.$state.current.name === 'home.orders'){
	      //   try {
	      //     if(!this.globals.currentUser.userId) {
	      //       this.$state.go(this.ngAuthSettings.site.config.header.logout.state_lost_session);
	      //     }
	      //   }
	      //   catch(e) {
	      //     this.$state.go(this.ngAuthSettings.site.config.header.logout.state_lost_session);
	      //   }
	      // }
	    }
	  }, {
	    key: 'updateCartInfo',
	    value: function updateCartInfo() {
	      var _this3 = this;
	
	      var cartId = this.SessionService.get('cartId') || '';
	      var userId = '';
	      try {
	        userId = this.globals.currentUser.userId;
	      } catch (e) {}
	      var clientPriceListName = '';
	      try {
	        clientPriceListName = this.SessionService.get('quoteCartSeller').clientPriceList;
	      } catch (e) {}
	      this.CartService.getCart(cartId, userId, clientPriceListName, true).then(function (response) {
	        _this3.cart = response;
	        _this3.initScrollCartResume();
	      });
	    }
	  }, {
	    key: 'getParams',
	    value: function getParams() {
	      this.globalParams = this.params;
	      // Init google analytics
	      if (this.params.uaCode) {
	        this.$window.ga('create', this.params.uaCode, 'auto');
	        this.$window.ga('create', this.params.uaCodeES, 'auto');
	        this.$window.ga('send', 'pageview', { page: this.$location.url() });
	      }
	      // Operating center selected
	      if (!this.globalParams.operatingCenterSelected) {
	        $('#modal-seleccion-sucursal-usuario-b2b-logueado').modal({
	          backdrop: 'static',
	          keyboard: false,
	          show: true
	        });
	      }
	      // items list view
	      try {
	        var pcView = this.globalParams.itemsView.pc;
	        var tabletView = this.globalParams.itemsView.tablet;
	        var mobileView = this.globalParams.itemsView.mobile;
	
	        // var cookieItemView = SessionService.get('itemsView') || '';
	
	        if ($(window).width() >= 1200) {
	          vistaMultipleProductos = '.btn-vista' + '3' + ' a';
	          this.SessionService.set('itemsView', pcView);
	        }
	
	        // TABLET
	        else if ($(window).width() >= 767 && $(window).width() < 1200) {
	            vistaMultipleProductos = '.btn-vista' + '3' + ' a';
	            this.SessionService.set('itemsView', tabletView);
	          }
	
	          // MOBILE
	          else if ($(window).width() < 767) {
	              vistaMultipleProductos = '.btn-vista' + '3' + ' a';
	              this.SessionService.set('itemsView', mobileView);
	            }
	      } catch (e) {}
	    }
	  }, {
	    key: 'isClientB2B',
	    value: function isClientB2B() {
	      this.isUserB2B = false;
	      // Client
	      try {
	        this.isUserB2B = this.globals.currentClient.id && this.globals.currentClient.third.isB2B || !this.globals.currentClient.id && this.globals.currentUser.userId && this.globals.currentUser.isB2B;
	      } catch (e) {}
	      // User
	      try {
	        this.isUserB2B = this.globals.currentUser.userId && this.globals.currentUser.isB2B;
	      } catch (e) {}
	      return this.isUserB2B;
	    }
	  }, {
	    key: 'sendNewsletterForm',
	    value: function sendNewsletterForm(form) {
	      if (form.$valid) {
	        this.sendingNewsletterInfo = true;
	        this.newsletterInfoError = false;
	        this.newsletterInfoMessage = '';
	        this.SharedService.sendNewsletterForm(this.newsletterDataForm).then(function (response) {
	          $scope.sendingNewsletterInfo = false;
	          $scope.newsLetterInfoSent = true;
	          $scope.newsletterInfoMessage = response.message;
	
	          if (response.error) {
	            $scope.newsletterInfoError = true;
	          }
	        }).catch(function (error) {
	          $scope.sendingNewsletterInfo = false;
	          $scope.newsletterInfoError = true;
	          $scope.newsletterInfoMessage = response.message;
	        });
	      } else {
	        _angular2.default.forEach(form.$error.required, function (field) {
	          field.$setDirty();
	        });
	      }
	    }
	  }, {
	    key: 'removeClientSelected',
	    value: function removeClientSelected() {
	      var _this4 = this;
	
	      this.globals.currentUser.userId = this.globals.currentUser.sellerId;
	      this.globals.currentClient = {};
	      // Clear cart
	      if (this.cart.cartId) {
	        var _data2 = {
	          'cartId': this.cart.cartId
	        };
	        this.CartService.clearCart(_data2).then(function (response) {
	          _this4.cart = {};
	          _this4.SessionService.put('cartId', '');
	          _this4.SessionService.put('globals', _this4.globals);
	          _this4.sellerQuoteFormDataHeader = {};
	          _this4.$state.reload();
	        });
	      } else {
	        this.cart = {};
	        this.SessionService.put('cartId', '');
	        this.SessionService.put('globals', this.globals);
	        this.sellerQuoteFormDataHeader = {};
	        this.$state.reload();
	      }
	      // $location.path('/contactcenter_home');
	    }
	  }, {
	    key: 'removeItemFromCart',
	    value: function removeItemFromCart(product) {
	      var _this5 = this;
	
	      var options = {
	        title: 'ELIMINAR PRODUCTO <b>' + product.name + '</b>',
	        isHtml: true,
	        titleIsHtml: true,
	        content: '\xBFEn realidad desea eliminar del carrito el producto <b>' + product.name + '</b>?',
	        showBottonCancel: true,
	        textActionCancel: 'Cancelar',
	        textAction: 'Aceptar'
	      };
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalResponseView2.default,
	        controller: 'ModalResponseController',
	        controllerAs: 'mdCtrl',
	        size: '',
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        _this5.confirmRemoveItem(product.id, product);
	      }).catch(function () {});
	    }
	  }, {
	    key: 'showModalSelectBranchUserB2B',
	    value: function showModalSelectBranchUserB2B() {
	      var _this6 = this;
	
	      var options = {
	        userData: this.globals,
	        branches: this.globals.currentUser.operatingCenters,
	        currentBranch: this.globals.currentUser.operatingCenter
	      };
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        static: true,
	        template: _modalSelectBranchB2bUserView2.default,
	        controller: 'ModalSelectBranchController',
	        controllerAs: 'mdCtrl',
	        size: '',
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function (result) {
	        _this6.globals = _angular2.default.copy(result);
	      }).catch(function (reason) {});
	    }
	  }, {
	    key: 'showModalCartSellerHeader',
	    value: function showModalCartSellerHeader() {
	      var _this7 = this;
	
	      var options = {
	        globals: this.globals
	      };
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalSelectClientView2.default,
	        controller: 'ModalSelectClientController',
	        controllerAs: 'mdCtrl',
	        size: '',
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function (globals) {
	        _this7.globals = _angular2.default.copy(globals);
	        _this7.LoginService.setOperatingCenter(data.operatingCenter.id).then(function (response) {
	          if (!response.error) {
	            _this7.SessionService.put('globals', _this7.globals);
	            // Clear cart
	            if (_this7.cart.cartId) {
	              var _data3 = {
	                'cartId': _this7.cart.cartId
	              };
	              _this7.CartService.clearCart(_data3).then(function (response) {
	                _this7.cart = {};
	                _this7.SessionService.put('cartId', '');
	                _this7.$state.go('home.salesHome');
	                _this7.$timeout(function () {
	                  _this7.$state.reload();
	                }, 2000);
	              });
	            } else {
	              _this7.cart = {};
	              _this7.SessionService.put('cartId', '');
	              _this7.$state.go('home.salesHome');
	              _this7.$timeout(function () {
	                _this7.$state.reload();
	              }, 2000);
	            }
	            // window.location.href = config.env.basePath + '#/reportes/b2b/dashboard';
	            // window.location.reload();
	          } else {
	            alert('Ha ocurrido un error al establecer el centro de operacion');
	            _this7.$state.reload();
	          }
	        }).catch(function (reason) {
	          alert('Ha ocurrido un error al establecer el centro de operacion');
	          _this7.$state.reload();
	        });
	      }).catch(function (reason) {});
	    }
	  }, {
	    key: 'showModalFormPQRS',
	    value: function showModalFormPQRS() {
	      var options = {
	        globals: this.globals
	      };
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        static: true,
	        template: _pqrsFormModalView2.default,
	        keyboard: false,
	        controller: 'PqrsFormModalController',
	        controllerAs: 'mdCtrl',
	        size: 'lg',
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	    }
	  }, {
	    key: 'confirmRemoveItem',
	    value: function confirmRemoveItem(productId, product) {
	      var _this8 = this;
	
	      var cartId = this.SessionService.get('cartId') || '';
	      if (cartId) {
	        this.deletingItemCart = true;
	        this.deletedItemCart = false;
	        this.errorDeletedItemCart = false;
	        this.CartService.deleteItemFromCart(productId, cartId).then(function (response) {
	          _this8.deletingItemCart = false;
	          if (!response.error) {
	            _this8.deletedItemCart = true;
	            _this8.updateCartInfo();
	            var options = {
	              title: 'Notificación',
	              isHtml: true,
	              content: '<div class="alert alert-success" style="margin-bottom: 10px;">\n              El producto <b>' + (product ? product.name : '') + '</b> ha sido eliminado del carrito.\n            </div>',
	              size: 'sm',
	              showBottonCancel: false,
	              textActionCancel: '',
	              textAction: 'Aceptar'
	            };
	            _this8.messageResponse(options);
	          } else {
	            _this8.errorDeletedItemCart = true;
	          }
	        }).catch(function (error) {
	          _this8.deletingItemCart = false;
	          _this8.deletedItemCart = false;
	          _this8.errorDeletedItemCart = true;
	        });
	      }
	    }
	
	    /**
	     * =======================================================================================================================
	     * Init the socekts to preload the client info.
	     * =======================================================================================================================
	     */
	
	  }, {
	    key: 'initSocket',
	    value: function initSocket() {
	      try {
	        var isLogged = this.globals.currentUser.isLogged;
	        var isSeller = this.globals.currentUser.isSeller;
	        var sellerExt = this.globals.currentUser.sellerExt;
	
	        // if(isLogged && isSeller) {
	        //   var socket = io('http://98.142.108.42:3000');
	
	        //   socket.on('preload client', function(msg){
	        //     var data = JSON.parse(msg);
	
	        //     if(sellerExt === +data.seller.ext) {
	        //       $('#modalQuoteSellerHeader #sellerQuoteAttendantDocumentNumberHeader').val(data.client.nid);
	        //       $scope.sellerQuoteFormDataHeader.attendant.documentNumber = data.client.nid;
	        //       $scope.showModalCartSellerHeader();
	
	        //       document.getElementById('newClientNotificacion').play();
	        //       alert('Un nuevo cliente se encuentra en espera de ser atendido');
	        //     }
	        //   });
	        // }
	      } catch (e) {}
	    }
	  }, {
	    key: 'countWatchers',
	    value: function countWatchers() {
	      var root = _angular2.default.element(document.getElementsByTagName('body'));
	      var watchers = [];
	      var f = function f(element) {
	        _angular2.default.forEach(['$scope', '$isolateScope'], function (scopeProperty) {
	          if (element.data() && element.data().hasOwnProperty(scopeProperty)) {
	            _angular2.default.forEach(element.data()[scopeProperty].$$watchers, function (watcher) {
	              watchers.push(watcher);
	            });
	          }
	        });
	
	        _angular2.default.forEach(element.children(), function (childElement) {
	          f(_angular2.default.element(childElement));
	        });
	      };
	
	      f(root);
	
	      // Remove duplicate watchers
	      var watchersWithoutDuplicates = [];
	      _angular2.default.forEach(watchers, function (item) {
	        if (watchersWithoutDuplicates.indexOf(item) < 0) {
	          watchersWithoutDuplicates.push(item);
	        }
	      });
	
	      this.resultWatchers = watchersWithoutDuplicates.length;
	    }
	  }, {
	    key: 'initScrollCartResume',
	    value: function initScrollCartResume() {
	      this.$timeout(function () {
	        var scroll1 = $('#wrapper-dropdown-cart-product-list'),
	            scroll12 = $('#wrapper-dropdown-cart-product-list2');
	        scroll1.simplebar();
	        scroll12.simplebar();
	      }, 1000);
	    }
	  }, {
	    key: 'enableCookies',
	    value: function enableCookies() {
	      this.cookiesAccepted = true;
	      this.SessionService.put("enabledCookies", true);
	    }
	  }, {
	    key: 'getSearchProductsGlobal',
	    value: function getSearchProductsGlobal(searchText) {
	      var userId = '';
	      try {
	        userId = this.globals.currentUser.userId;
	      } catch (e) {}
	      this.offsetProductSearch = 0;
	      return this.SharedService.getSearchProductsGlobal(searchText, 10).then(function (response) {
	        return response;
	      }).catch(function (error) {
	        console.log(error);
	        return null;
	      });
	    }
	  }, {
	    key: 'goToSearchProduct',
	    value: function goToSearchProduct($item) {
	      this.typeaheadIsOpen = false;
	      $item = $item || this.globalSearchTextHome;
	      // if($scope.globalSearchTextHome) {
	      if ($item) {
	        var searchText = encodeURIComponent($item);
	        this.$state.go('home.productSearch', { searchText: searchText });
	      }
	    }
	  }, {
	    key: 'goToTop',
	    value: function goToTop() {
	      $('html, body').animate({
	        'scrollTop': 0
	      }, 1200);
	    }
	  }, {
	    key: 'messageResponse',
	    value: function messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalResponseView2.default,
	        controller: 'ModalResponseController',
	        controllerAs: 'mdCtrl',
	        size: options.size,
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        if (callAcept) {
	          callback();
	        }
	      }).catch(function (reason) {
	        if (callCancel) {
	          callbackCancel();
	        }
	      });
	    }
	  }]);
	
	  return SharedController;
	}();
	
	SharedController.$inject = inject;
	
	exports.default = SharedController;

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _sharedProviders = __webpack_require__(416);
	
	var _sharedProviders2 = _interopRequireDefault(_sharedProviders);
	
	var _sharedComponents = __webpack_require__(407);
	
	var _sharedComponents2 = _interopRequireDefault(_sharedComponents);
	
	var _shared = __webpack_require__(419);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _filters = __webpack_require__(413);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	var _shared3 = __webpack_require__(417);
	
	var _shared4 = _interopRequireDefault(_shared3);
	
	var _directives = __webpack_require__(412);
	
	var _directives2 = _interopRequireDefault(_directives);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sharedModule = _angular2.default.module('shared', [_sharedProviders2.default.name, _filters2.default.name, _directives2.default.name, _sharedComponents2.default.name]).controller('SharedController', _shared4.default).service('SharedService', _shared2.default);
	
	exports.default = sharedModule;

/***/ },
/* 419 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$http', 'ngAuthSettings', '$q', 'AuthTokenFactory', 'SessionService', '$httpParamSerializerJQLike'];
	
	var SharedService = function () {
	  function SharedService($http, ngAuthSettings, $q, AuthTokenFactory, SessionService, $httpParamSerializerJQLike) {
	    _classCallCheck(this, SharedService);
	
	    this.ngAuthSettings = ngAuthSettings;
	    this.$q = $q;
	    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	    this.AuthTokenFactory = AuthTokenFactory;
	    this.$http = $http;
	    this.SessionService = SessionService;
	    this.globals = {};
	    this.constants = {
	      cities: '/crm/proyectos/search-city',
	      thirds: '/terceros/terceros/search-terceros',
	      items: '/items/items/search-items'
	    };
	  }
	
	  _createClass(SharedService, [{
	    key: 'getInitialParams',
	    value: function getInitialParams(userId) {
	      var globalCategories = this.$http({
	        method: 'GET',
	        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.categories,
	        cache: false
	      }),
	          categoriesMenu = this.$http({
	        method: 'GET',
	        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.categoriesMenu + '?userId=' + userId,
	        cache: false
	      }),
	          banners = this.$http({
	        method: 'GET',
	        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.getBanners,
	        cache: false
	      }),
	          params = this.$http({
	        method: 'POST',
	        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.getParams,
	        cache: false,
	        data: this.$httpParamSerializerJQLike({ 'userId': userId }),
	        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
	      });
	      return this.$q.all([globalCategories, categoriesMenu, banners, params]).then(function (data) {
	        return data;
	      });
	    }
	  }, {
	    key: 'sendMailContact',
	    value: function sendMailContact(data) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'POST',
	          url: _this.ngAuthSettings.apiServiceBaseUri + _this.ngAuthSettings.config.paths.mailProductRecommended,
	          cache: false,
	          data: _this.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'updateDespachoPedido',
	    value: function updateDespachoPedido(data) {
	      var _this2 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this2.$http({
	          method: 'POST',
	          url: _this2.ngAuthSettings.apiServiceBaseUri + _this2.ngAuthSettings.config.paths.updateDespachoPedido,
	          cache: false,
	          data: _this2.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'sendNewsletterForm',
	    value: function sendNewsletterForm(newsletterDataForm) {
	      var _this3 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this3.$http({
	          method: 'POST',
	          url: _this3.ngAuthSettings.apiServiceBaseUri + _this3.ngAuthSettings.config.paths.mailNewsletter,
	          cache: false,
	          data: _this3.$httpParamSerializerJQLike(newsletterDataForm),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getParams',
	    value: function getParams(userId) {
	      var _this4 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this4.$http({
	          method: 'POST',
	          url: _this4.ngAuthSettings.apiServiceBaseUri + _this4.ngAuthSettings.config.paths.getParams,
	          cache: false,
	          data: _this4.$httpParamSerializerJQLike({ 'userId': userId }),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getSearchProductsGlobal',
	    value: function getSearchProductsGlobal(searchText, limit) {
	      var _this5 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this5.$http({
	          method: 'GET',
	          url: _this5.ngAuthSettings.apiServiceBaseUri + _this5.ngAuthSettings.config.paths.searchProductAutocomplete + searchText + '&limit=' + limit,
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getGlobalCategories',
	    value: function getGlobalCategories() {
	      var _this6 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this6.$http({
	          method: 'GET',
	          url: _this6.ngAuthSettings.apiServiceBaseUri + _this6.ngAuthSettings.config.paths.categories,
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getBanners',
	    value: function getBanners() {
	      var _this7 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this7.$http({
	          method: 'GET',
	          url: _this7.ngAuthSettings.apiServiceBaseUri + _this7.ngAuthSettings.config.paths.getBanners,
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getCategoriesMenu',
	    value: function getCategoriesMenu(userId) {
	      var _this8 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this8.$http({
	          method: 'GET',
	          url: _this8.ngAuthSettings.apiServiceBaseUri + _this8.ngAuthSettings.config.paths.categoriesMenu + '?userId=' + userId,
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getAllSimple',
	    value: function getAllSimple(pageSize, pageNumber, search, param) {
	      var _this9 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this9.$http({
	          method: 'GET',
	          url: _this9.ngAuthSettings.apiServiceBaseUri + _this9.constants[param] + '?pageSize=' + pageSize + '&pageNumber=' + pageNumber + '&searchText=' + search,
	          cache: false
	          // data : {
	          //   'pageSize' : pageSize,
	          //   'pageNumber' : pageNumber,
	          //   'searchText' : search
	          // }
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'saveUserLogued',
	    value: function saveUserLogued(user) {
	      console.log(user);
	      // let token = btoa(user.userId + ':' + new Date());
	      // this.AuthTokenFactory.setToken('auth-user', token);
	      // this.userSaved = user;
	      this.globals = {
	        currentUser: user
	      };
	
	      try {
	        var operatingCenters = user.operatingCenters;
	        this.globals.currentClient = {};
	        if (operatingCenters.length === 1) {
	          this.globals.currentClient = {};
	          if (!user.isSeller) {
	            this.globals.currentClient.seller = user.seller;
	            this.globals.currentClient.operatingCenter = {
	              'id': operatingCenters[0].id,
	              'name': operatingCenters[0].name,
	              "address": operatingCenters[0].address,
	              "location": operatingCenters[0].location,
	              "code": operatingCenters[0].code
	            };
	            // Third
	            this.globals.currentClient.third = {
	              'id': operatingCenters[0].thirdId,
	              'name': operatingCenters[0].thirdName,
	              'documentNumber': user.thirdDocumentNumber
	            };
	            // Contact
	            this.globals.currentClient.contact = {
	              'id': operatingCenters[0].contactId,
	              'name': operatingCenters[0].contactName
	            };
	          }
	        } else {
	          if (!user.isSeller) {
	            this.globals.currentClient = {};
	            this.globals.currentClient.seller = user.seller;
	            // Third
	            this.globals.currentClient.third = {
	              'id': operatingCenters[0].thirdId,
	              'name': operatingCenters[0].thirdName,
	              'documentNumber': user.thirdDocumentNumber
	            };
	            // Contact
	            this.globals.currentClient.contact = {
	              'id': operatingCenters[0].contactId,
	              'name': operatingCenters[0].contactName
	            };
	          }
	        }
	      } catch (e) {}
	
	      this.SessionService.put('globals', this.globals);
	    }
	  }, {
	    key: 'partialConsultThird',
	    value: function partialConsultThird() {
	      var token = this.AuthTokenFactory.getToken('auth-third');
	      if (token) {
	        var thirdId = atob(token);
	        thirdId = thirdId.split(':')[0];
	        return thirdId;
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'saveThirdSelected',
	    value: function saveThirdSelected(third) {
	      var token = btoa(third.id + ':' + new Date());
	      this.AuthTokenFactory.setToken('auth-third', token);
	      if (third.branchSelected) {
	        var branch = btoa(third.branchSelected.id + ':' + new Date());
	        this.AuthTokenFactory.setToken('auth-third-branch', branch);
	      }
	      this.thirdSelected = third;
	    }
	  }, {
	    key: 'clearThird',
	    value: function clearThird() {
	      this.AuthTokenFactory.setToken('auth-third');
	      this.AuthTokenFactory.setToken('auth-third-branch');
	      this.thirdSelected = {};
	    }
	  }, {
	    key: 'partialConsultUser',
	    value: function partialConsultUser() {
	      var token = this.AuthTokenFactory.getToken('auth-user');
	      if (token) {
	        var userId = atob(token);
	        userId = userId.split(':')[0];
	        return userId;
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'getUserData',
	    value: function getUserData() {
	      var _this10 = this;
	
	      return this.$q(function (resolve, reject) {
	        if (_this10.userSaved.userId) {
	          resolve(_this10.userSaved);
	        } else {
	          var userInSave = _this10.AuthTokenFactory.getToken('auth-user');
	          if (!userInSave) return reject();
	          var user = atob(userInSave);
	          user = user.split(':')[0];
	          _this10.$http({
	            method: 'GET',
	            url: _this10.ngAuthSettings.apiServiceBaseUri + '/terceros/terceros/get-info-user?userId=' + user,
	            cache: false
	          }).then(function (response) {
	            _this10.userSaved = response.data;
	            resolve(response.data);
	          }, function (reason) {
	            reject(reason);
	          });
	        }
	      });
	    }
	  }, {
	    key: 'getThirdData',
	    value: function getThirdData() {
	      var _this11 = this;
	
	      return this.$q(function (resolve, reject) {
	        var thirdSelected = _this11.AuthTokenFactory.getToken('auth-third');
	        if (!thirdSelected) return reject();
	        var third = atob(thirdSelected);
	        third = third.split(':')[0];
	        _this11.$http({
	          method: 'GET',
	          url: _this11.ngAuthSettings.apiServiceBaseUri + '/terceros/terceros/get-tercero?terceroId=' + third,
	          cache: false
	        }).then(function (response) {
	          var branch = _this11.AuthTokenFactory.getToken('auth-third-branch');
	          if (branch) {
	            var branchSelected = atob(branch);
	            branchSelected = branchSelected.split(':')[0];
	            response.data.branchSelected = response.data.sucursales.filter(function (val) {
	              return val.id === branchSelected;
	            })[0];
	          }
	          _this11.thirdSelected = response.data;
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getFeaturedProducts',
	    value: function getFeaturedProducts(third) {
	      var _this12 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this12.$http({
	          method: 'GET',
	          url: _this12.ngAuthSettings.apiServiceBaseUri + '/items/items/search-items?pageSize=' + 10 + '&pageNumber=' + 1 + '&searchText=&terceroId=' + third + '&tipoFiltro=1',
	          // url: this.ngAuthSettings.apiServiceBaseUri + '/item-info/ver-productos-destacados?userId=' + this.thirdSelected.id,
	          cache: true
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getOcasionalInformation',
	    value: function getOcasionalInformation(data) {
	      var _this13 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this13.$http({
	          method: 'POST',
	          url: _this13.ngAuthSettings.apiServiceBaseUri + _this13.ngAuthSettings.config.paths.getOcasionalInformation,
	          cache: false,
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          data: _this13.$httpParamSerializerJQLike(data)
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'validateNumberIdUnusedHeader',
	    value: function validateNumberIdUnusedHeader(data) {
	      var _this14 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this14.$http({
	          method: 'POST',
	          url: _this14.ngAuthSettings.apiServiceBaseUri + _this14.ngAuthSettings.config.paths.validateNumberId,
	          cache: false,
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          data: _this14.$httpParamSerializerJQLike(data)
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'updateInfoClientSelected',
	    value: function updateInfoClientSelected(data) {
	      var _this15 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this15.$http({
	          method: 'POST',
	          url: _this15.ngAuthSettings.apiServiceBaseUri + _this15.ngAuthSettings.config.paths.updateInfoClientSelected,
	          cache: false,
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          data: _this15.$httpParamSerializerJQLike(data)
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'validateEmailUnusedHeader',
	    value: function validateEmailUnusedHeader(data) {
	      var _this16 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this16.$http({
	          method: 'POST',
	          url: _this16.ngAuthSettings.apiServiceBaseUri + _this16.ngAuthSettings.config.paths.validateEmail,
	          cache: false,
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          data: _this16.$httpParamSerializerJQLike(data)
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'validateEmail',
	    value: function validateEmail(email) {
	      var _this17 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this17.$http({
	          method: 'POST',
	          url: _this17.ngAuthSettings.apiServiceBaseUri + '/login/validate-email',
	          cache: false,
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          data: _this17.$httpParamSerializerJQLike({ 'email': email })
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getLocationBySearchText',
	    value: function getLocationBySearchText(data) {
	      var _this18 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this18.$http({
	          method: 'POST',
	          url: _this18.ngAuthSettings.apiServiceBaseUri + _this18.ngAuthSettings.config.paths.locationBySearchText,
	          cache: false,
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          data: _this18.$httpParamSerializerJQLike(data)
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getContactByIdentificationNumber',
	    value: function getContactByIdentificationNumber(data) {
	      var _this19 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this19.$http({
	          method: 'POST',
	          url: _this19.ngAuthSettings.apiServiceBaseUri + _this19.ngAuthSettings.config.paths.thirdBySearchText,
	          cache: false,
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          data: _this19.$httpParamSerializerJQLike(data)
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getThirdBySearchText',
	    value: function getThirdBySearchText(data) {
	      var _this20 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this20.$http({
	          method: 'POST',
	          url: _this20.ngAuthSettings.apiServiceBaseUri + _this20.ngAuthSettings.config.paths.thirdBySearchText,
	          cache: false,
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          data: _this20.$httpParamSerializerJQLike(data)
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'validateThirdDocument',
	    value: function validateThirdDocument(document) {
	      var _this21 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this21.$http({
	          method: 'POST',
	          url: _this21.ngAuthSettings.apiServiceBaseUri + '/terceros/terceros/validar-tercero',
	          cache: false,
	          data: {
	            'terceroDocumento': document
	          }
	        }).then(function (response) {
	          var resolveData = parseInt(response.data);
	          resolve(resolveData);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'logoutUser',
	    value: function logoutUser() {
	      var _this22 = this;
	
	      return this.$q(function (resolve, reject) {
	        try {
	          _this22.AuthTokenFactory.setToken('auth-third');
	          _this22.AuthTokenFactory.setToken('auth-user');
	          _this22.AuthTokenFactory.setToken('auth-third-branch');
	          _this22.AuthTokenFactory.setToken('auth-cart');
	          _this22.userSaved = {};
	          _this22.thirdSelected = {};
	          _this22.cart = {};
	          resolve();
	        } catch (n) {
	          reject();
	        }
	      });
	    }
	  }]);
	
	  return SharedService;
	}();
	
	SharedService.$inject = inject;
	
	exports.default = SharedService;

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateDetail = __webpack_require__(422);
	
	var _templateDetail2 = _interopRequireDefault(_templateDetail);
	
	var _templateDetailView = __webpack_require__(526);
	
	var _templateDetailView2 = _interopRequireDefault(_templateDetailView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TemplateDetailComponent = {
	  template: _templateDetailView2.default,
	  controller: _templateDetail2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = TemplateDetailComponent;

/***/ },
/* 421 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.templateDetail', {
	    url: "/plantillas/detalle/{templateId}",
	    template: '<template-detail sh-ctrl="shCtrl"></template-detail>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _modalResponseView = __webpack_require__(3);
	
	var _modalResponseView2 = _interopRequireDefault(_modalResponseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'TemplateDetailService', '$state', '$rootScope', 'SharedService', '$uibModal', '$timeout', 'Pagination', 'SessionService', '$window', 'ngAuthSettings', '$stateParams'];
	
	var TemplateDetailController = function () {
	  function TemplateDetailController($scope, TemplateDetailService, $state, $rootScope, SharedService, $uibModal, $timeout, Pagination, SessionService, $window, ngAuthSettings, $stateParams) {
	    _classCallCheck(this, TemplateDetailController);
	
	    this.$state = $state;
	    this.$scope = $scope;
	    this.$stateParams = $stateParams;
	    this.$timeout = $timeout;
	    this.$rootScope = $rootScope;
	    this.ngAuthSettings = ngAuthSettings;
	    this.$uibModal = $uibModal;
	    this.TemplateDetailService = TemplateDetailService;
	    this.Pagination = Pagination;
	    this.SharedService = SharedService;
	    this.SessionService = SessionService;
	    this.$window = $window;
	    this.loadingTemplate = false;
	  }
	
	  _createClass(TemplateDetailController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getTemplate();
	    }
	  }, {
	    key: 'getTemplate',
	    value: function getTemplate() {
	      var _this = this;
	
	      this.loadingTemplate = true;
	      var globals = this.shCtrl.globals;
	
	      var userId = '';
	      try {
	        userId = globals.currentUser.userId;
	      } catch (e) {}
	
	      var sellerId = '';
	      try {
	        sellerId = globals.currentUser.sellerId;
	      } catch (e) {}
	
	      this.TemplateDetailService.getUserCartTemplate({
	        'id': this.$stateParams.templateId,
	        'userId': userId,
	        'sellerId': sellerId
	      }).then(function (response) {
	        _this.loadingTemplate = false;
	
	        if (!response.error) {
	          _this.template = response.data.template;
	        } else {
	          // TODO
	        }
	      }).catch(function (reason) {
	        _this.loadingTemplate = false;
	      });
	    }
	  }, {
	    key: 'messageResponse',
	    value: function messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalResponseView2.default,
	        controller: 'ModalResponseController',
	        controllerAs: 'mdCtrl',
	        size: options.size,
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        if (callAcept) {
	          callback();
	        }
	      }).catch(function (reason) {
	        if (callCancel) {
	          callbackCancel();
	        }
	      });
	    }
	  }]);
	
	  return TemplateDetailController;
	}();
	
	TemplateDetailController.$inject = inject;
	
	exports.default = TemplateDetailController;

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _templateDetail = __webpack_require__(420);
	
	var _templateDetail2 = _interopRequireDefault(_templateDetail);
	
	var _templateDetail3 = __webpack_require__(424);
	
	var _templateDetail4 = _interopRequireDefault(_templateDetail3);
	
	var _templateDetail5 = __webpack_require__(421);
	
	var _templateDetail6 = _interopRequireDefault(_templateDetail5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var templateDetailModule = _angular2.default.module('app.templates.templateDetail', []).component('templateDetail', _templateDetail2.default).service('TemplateDetailService', _templateDetail4.default).config(_templateDetail6.default);
	
	exports.default = templateDetailModule;

/***/ },
/* 424 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService', '$httpParamSerializerJQLike'];
	
	var TemplateDetailService = function () {
	  function TemplateDetailService($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService, $httpParamSerializerJQLike) {
	    _classCallCheck(this, TemplateDetailService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	    this.ngAuthSettings = ngAuthSettings;
	    this.AuthTokenFactory = AuthTokenFactory;
	    this.SharedService = SharedService;
	    this.SessionService = SessionService;
	  }
	
	  _createClass(TemplateDetailService, [{
	    key: 'getUserCartTemplate',
	    value: function getUserCartTemplate(data) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'POST',
	          url: _this.ngAuthSettings.apiServiceBaseUri + _this.ngAuthSettings.config.paths.getUserCartTemplate,
	          cache: false,
	          data: _this.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return TemplateDetailService;
	}();
	
	TemplateDetailService.$inject = inject;
	
	exports.default = TemplateDetailService;

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templates = __webpack_require__(427);
	
	var _templates2 = _interopRequireDefault(_templates);
	
	var _templatesView = __webpack_require__(527);
	
	var _templatesView2 = _interopRequireDefault(_templatesView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TemplatesComponent = {
	  template: _templatesView2.default,
	  controller: _templates2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = TemplatesComponent;

/***/ },
/* 426 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.templates', {
	    url: "/plantillas",
	    template: '<templates sh-ctrl="shCtrl"></templates>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _modalResponseView = __webpack_require__(3);
	
	var _modalResponseView2 = _interopRequireDefault(_modalResponseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'TemplatesService', '$state', '$rootScope', 'SharedService', '$uibModal', '$timeout', 'Pagination', 'SessionService', '$window'];
	
	var TemplatesController = function () {
	  function TemplatesController($scope, TemplatesService, $state, $rootScope, SharedService, $uibModal, $timeout, Pagination, SessionService, $window) {
	    _classCallCheck(this, TemplatesController);
	
	    this.$state = $state;
	    this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.$rootScope = $rootScope;
	    this.$uibModal = $uibModal;
	    this.TemplatesService = TemplatesService;
	    this.Pagination = Pagination;
	    this.SharedService = SharedService;
	    this.SessionService = SessionService;
	    this.$window = $window;
	
	    /**
	     Text for searching orders
	     @property searchText
	     @type String
	     @default ''
	     */
	    this.searchText = '';
	
	    /**
	     Sort type by order attribute
	     @property sortType
	     @type String
	     @default 'name'
	     */
	    this.sortType = 'fecha_creacion';
	
	    /**
	     Orders sort order. Use true for reverse order
	     @property sortReverse
	     @type boolean
	     @default false
	     */
	    this.sortReverse = true;
	
	    this.userCartTemplates = [];
	    this.loadingUserCartTemplates = false;
	    this.loadedUserCartTemplates = false;
	    this.errorloadingUserCartTemplates = false;
	    this.itemsPerPage = 10;
	  }
	
	  _createClass(TemplatesController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getUserCartTemplates();
	    }
	  }, {
	    key: 'deleteCartTemplate',
	    value: function deleteCartTemplate(cartTemplate) {
	      var _this = this;
	
	      cartTemplate.loading = true;
	      cartTemplate.response = {};
	
	      var globals = this.shCtrl.globals;
	      var userId = '';
	      try {
	        userId = globals.currentUser.userId;
	      } catch (e) {}
	
	      var sellerId = '';
	      try {
	        sellerId = globals.currentUser.sellerId;
	      } catch (e) {}
	      this.TemplatesService.deleteCartTemplate({
	        'cartTemplateId': cartTemplate.id,
	        'userId': userId,
	        'sellerId': sellerId }).then(function (response) {
	        cartTemplate.loading = false;
	        cartTemplate.response = response;
	
	        if (!response.error) {
	          _this.$timeout(function () {
	            _this.$state.reload();
	          }, 1000);
	        }
	      }).catch(function (reason) {
	        cartTemplate.loading = false;
	        cartTemplate.response.error = true;
	        cartTemplate.response.message = 'Ha ocurrido un error interno. Por favor contacte al administrador del sistema.';
	      });
	    }
	  }, {
	    key: 'getUserCartTemplates',
	    value: function getUserCartTemplates() {
	      var _this2 = this;
	
	      var globals = this.shCtrl.globals;
	      var userId = '';
	      try {
	        userId = globals.currentUser.userId;
	      } catch (e) {}
	
	      var sellerId = '';
	      try {
	        sellerId = globals.currentUser.sellerId;
	      } catch (e) {}
	
	      this.loadingUserCartTemplates = true;
	      this.loadedUserCartTemplates = false;
	      this.errorloadingUserCartTemplates = false;
	
	      this.TemplatesService.getUserCartTemplates({ 'userId': userId, 'sellerId': sellerId }).then(function (response) {
	        _this2.loadingUserCartTemplates = false;
	        _this2.loadedUserCartTemplates = true;
	        _this2.errorloadingUserCartTemplates = false;
	
	        _this2.pagination = _this2.Pagination.getNew(40);
	        _this2.userCartTemplates = response.data;
	
	        if (_this2.userCartTemplates.templates.length > 0) {
	          _this2.pagination.numPages = Math.ceil(_this2.userCartTemplates.templates.length / _this2.pagination.perPage);
	        }
	      }).catch(function (reason) {
	        _this2.loadingUserCartTemplates = false;
	        _this2.loadedUserCartTemplates = true;
	        _this2.errorloadingUserCartTemplates = true;
	      });
	    }
	  }, {
	    key: 'loadCartTemplateToCurrentCart',
	    value: function loadCartTemplateToCurrentCart(cartTemplate) {
	      var _this3 = this;
	
	      cartTemplate.duplicate = {};
	
	      cartTemplate.duplicate.duplicating = true;
	      cartTemplate.duplicate.duplicated = false;
	      cartTemplate.duplicate.message = '';
	
	      var cartTemplateId = cartTemplate.id;
	      var cartId = this.SessionService.get('cartId') || '';
	      this.TemplatesService.duplicateCartTemplate({ 'cartTemplateId': cartTemplateId, 'cartId': cartId }).then(function (response) {
	        _this3.$timeout(function () {
	          if (!response.error) {
	            cartTemplate.duplicate.duplicating = false;
	            cartTemplate.duplicate.duplicated = true;
	
	            cartTemplate.duplicate.error = false;
	            cartTemplate.duplicate.message = response.message;
	
	            _this3.SessionService.put('cartId', response.cartId);
	            _this3.$state.go('home.cart');
	          } else {
	            cartTemplate.duplicate.duplicating = false;
	            cartTemplate.duplicate.duplicated = false;
	
	            cartTemplate.duplicate.error = true;
	            cartTemplate.duplicate.message = response.message;
	          }
	        }, 1000);
	      }).catch(function (reason) {
	        cartTemplate.duplicate.duplicating = false;
	        cartTemplate.duplicate.duplicated = false;
	
	        cartTemplate.duplicate.error = true;
	        cartTemplate.duplicate.message = 'Ha ocurrido un error al duplicar el pedido.';
	      });
	    }
	  }, {
	    key: 'setCurrentCartTemplate',
	    value: function setCurrentCartTemplate(template) {
	      this.currentCartTemplate = template;
	    }
	  }, {
	    key: 'messageResponse',
	    value: function messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalResponseView2.default,
	        controller: 'ModalResponseController',
	        controllerAs: 'mdCtrl',
	        size: options.size,
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        if (callAcept) {
	          callback();
	        }
	      }).catch(function (reason) {
	        if (callCancel) {
	          callbackCancel();
	        }
	      });
	    }
	  }, {
	    key: 'setPagination',
	    value: function setPagination(itemsPerPage) {
	      this.itemsPerPage = itemsPerPage;
	      this.pagination = this.Pagination.getNew(this.itemsPerPage);
	      this.pagination.numPages = Math.ceil(this.userOrders.ordersQuotes.length / this.pagination.perPage);
	    }
	  }]);
	
	  return TemplatesController;
	}();
	
	TemplatesController.$inject = inject;
	
	exports.default = TemplatesController;

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _templates = __webpack_require__(425);
	
	var _templates2 = _interopRequireDefault(_templates);
	
	var _templates3 = __webpack_require__(429);
	
	var _templates4 = _interopRequireDefault(_templates3);
	
	var _templates5 = __webpack_require__(426);
	
	var _templates6 = _interopRequireDefault(_templates5);
	
	var _templateDetail = __webpack_require__(423);
	
	var _templateDetail2 = _interopRequireDefault(_templateDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var templatesModule = _angular2.default.module('app.templates', [_templateDetail2.default.name]).component('templates', _templates2.default).service('TemplatesService', _templates4.default).config(_templates6.default);
	
	exports.default = templatesModule;

/***/ },
/* 429 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService', '$httpParamSerializerJQLike'];
	
	var TemplatesService = function () {
	  function TemplatesService($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService, $httpParamSerializerJQLike) {
	    _classCallCheck(this, TemplatesService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	    this.AuthTokenFactory = AuthTokenFactory;
	    this.SharedService = SharedService;
	    this.SessionService = SessionService;
	    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	  }
	
	  _createClass(TemplatesService, [{
	    key: 'deleteCartTemplate',
	    value: function deleteCartTemplate(data) {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'POST',
	          url: _this.ngAuthSettings.apiServiceBaseUri + _this.ngAuthSettings.config.paths.deleteCartTemplate,
	          data: _this.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getUserCartTemplates',
	    value: function getUserCartTemplates(data) {
	      var _this2 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this2.$http({
	          method: 'POST',
	          url: _this2.ngAuthSettings.apiServiceBaseUri + _this2.ngAuthSettings.config.paths.getUserCartTemplates,
	          data: _this2.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'duplicateCartTemplate',
	    value: function duplicateCartTemplate(data) {
	      var _this3 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this3.$http({
	          method: 'POST',
	          url: _this3.ngAuthSettings.apiServiceBaseUri + _this3.ngAuthSettings.config.paths.duplicateCartTemplate,
	          data: _this3.$httpParamSerializerJQLike(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }, function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return TemplatesService;
	}();
	
	TemplatesService.$inject = inject;
	
	exports.default = TemplatesService;

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tunnel = __webpack_require__(432);
	
	var _tunnel2 = _interopRequireDefault(_tunnel);
	
	var _tunnelView = __webpack_require__(528);
	
	var _tunnelView2 = _interopRequireDefault(_tunnelView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TunnelComponent = {
	  template: _tunnelView2.default,
	  controller: _tunnel2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = TunnelComponent;

/***/ },
/* 431 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	routesConfig.$inject = ['$stateProvider'];
	
	function routesConfig($stateProvider) {
	  $stateProvider.state('home.tunnel', {
	    url: "/tunnel",
	    template: '<tunnel sh-ctrl="shCtrl"></tunnel>'
	  });
	}
	
	exports.default = routesConfig;

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _modalResponseView = __webpack_require__(3);
	
	var _modalResponseView2 = _interopRequireDefault(_modalResponseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$scope', 'TunnelService', '$state', '$rootScope', 'SharedService', '$uibModal', '$timeout', 'CartService', 'SessionService', 'ngAuthSettings', '$window', '$stateParams'];
	
	var TunnelController = function () {
	  function TunnelController($scope, TunnelService, $state, $rootScope, SharedService, $uibModal, $timeout, CartService, SessionService, ngAuthSettings, $window, $stateParams) {
	    _classCallCheck(this, TunnelController);
	
	    this.$state = $state;
	    this.$scope = $scope;
	    this.$stateParams = $stateParams;
	    this.CartService = CartService;
	    this.ngAuthSettings = ngAuthSettings;
	    this.$window = $window;
	    this.$timeout = $timeout;
	    this.$rootScope = $rootScope;
	    this.SessionService = SessionService;
	    this.$uibModal = $uibModal;
	    this.TunnelService = TunnelService;
	    this.SharedService = SharedService;
	    var quoteCartSeller = this.SessionService.get('quoteCartSeller') || null;
	    this.quoteCartSeller = quoteCartSeller;
	    this.totalItemsQuoteValueSeller = 0;
	    if (quoteCartSeller) {
	      this.totalItemsQuoteValueSeller = quoteCartSeller.totalItemsQuoteValueSeller;
	    }
	    this.tunnelStep = 1;
	    this.location = {};
	    this.tunnelStep2FormData = {};
	    this.cart = null;
	    this.savingTunnelData = false;
	    this.savingOrder = false;
	    this.savedTunnelData = false;
	    this.errorSavingTunnelData = '';
	    this.tunnelStep2FormData = {};
	    this.countriesBilling = {};
	    this.loadingCountriesBilling = false;
	    this.loadedCountriesBilling = false;
	    this.statesBilling = {};
	    this.loadingStatesBilling = false;
	    this.loadedStatesBilling = false;
	    this.citiesBilling = {};
	    this.loadingCitiesBilling = false;
	    this.loadedCitiesBilling = false;
	    this.loadingSavingOrder = false;
	    this.orderSaved = false;
	    this.allowGuestInTunnel = this.$rootScope.allowGuestInTunnel;
	    this.errorSavingOrder = false;
	    this.messageSavingTheOrder = '';
	    this.errorsDataSavingOrder = [];
	    this.initLocationInfoLoaded = false;
	    this.orderIdSaved = 0;
	    this.cartOrderCreated = false;
	    this.cartQuoteCreated = false;
	    this.tunnelDataForm = {};
	    this.tunnelDataForm.loadingCartInfo = false;
	    this.tunnelDataForm.loadedCartInfo = false;
	    this.hideEmptyCartAfterTunel = false;
	  }
	
	  _createClass(TunnelController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      var cartId = this.SessionService.get('cartId') || '';
	      var userId = '';
	      try {
	        userId = this.globals.currentUser.userId;
	      } catch (e) {}
	      var clientPriceListName = '';
	      try {
	        clientPriceListName = this.SessionService.get('quoteCartSeller').clientPriceList;
	      } catch (e) {}
	      this.CartService.getCart(cartId, userId, clientPriceListName, true).then(function (response) {
	        _this.cart = response;
	        _this.tunnelDataForm.loadingCartInfo = true;
	        _this.tunnelDataForm.loadedCartInfo = false;
	        _this.$rootScope.orderIdInsideTunnel = _this.$stateParams.orderId;
	        if (!_this.$rootScope.orderIdInsideTunnel) {
	          var cart = _this.cart;
	          if (cart) {
	            if (!cart.items.length) return _this.$state.go(_this.ngAuthSettings.site.app.header.logo.url);
	            _this.getAllCartOrderInfo();
	
	            try {
	              _this.isUserLogged = !!_this.shCtrl.globals.currentUser.username;
	            } catch (e) {
	
	              if (_this.$rootScope.allowGuestInTunnel) {
	                // Do nothing
	                _this.tunnelDataForm.loadingCartInfo = false;
	                _this.tunnelDataForm.loadedCartInfo = true;
	                return false;
	              } else {
	                if (_this.ngAuthSettings.site.config.data.tunnel.allowQuotesNoLogin && cart.order.totalItemsToQuote === cart.items.length) {
	                  // Do nothing
	                  _this.isUserLogged = true;
	                } else {
	                  // window.location.assign(config.env.basePath + '/#/login');
	                  _this.$rootScope.showModalLoginAfterTunnel = true;
	                  _this.$state.go('home.login');
	                  _this.$timeout(function () {
	                    _this.$state.reload();
	                  }, 3000);
	                  return false;
	                }
	              }
	            }
	          }
	
	          _this.tunnelDataForm.loadingCartInfo = false;
	          _this.tunnelDataForm.loadedCartInfo = true;
	        }
	        // When the order exist
	        else if (!_this.tunnelDataForm.loadedCartInfo) {
	            try {
	              _this.isUserLogged = !!_this.shCtrl.globals.currentUser.username;
	              _this.tunnelDataForm.loadedCartInfo = true;
	              _this.tunnelDataForm.loadingCartInfo = false;
	
	              _this.getPayMethodsTunnel();
	              var url = _this.ngAuthSettings.config.env.apiEndPoint + _this.ngAuthSettings.config.paths.getCart + _this.$rootScope.orderIdInsideTunnel + '&userId=' + '' + '&isOrder=' + '1';
	              _this.CartService.getCart(cartId, userId, clientPriceListName, true, url).then(function (response) {
	                _this.cart = response;
	              }).catch(function (reason) {});
	            } catch (e) {
	              _this.$rootScope.showModalLoginAfterTunnel = true;
	              _this.$state.go('home.login');
	              _this.$timeout(function () {
	                _this.$state.reload();
	              }, 3000);
	              return false;
	            }
	          }
	      }).catch(function () {
	        _this.$state.go(_this.ngAuthSettings.site.app.header.logo.url);
	      });
	    }
	  }, {
	    key: 'copyDataIntoBilling',
	    value: function copyDataIntoBilling(fieldName, delivery) {
	      var _this2 = this;
	
	      if (fieldName === 'neighborhood') {
	        this.tunnelStep2FormData.contactNeighborhoodBilling = delivery;
	      } else if (fieldName === 'building') {
	        this.tunnelStep2FormData.contactBuildingBilling = delivery;
	      } else if (fieldName === 'aparment') {
	        this.tunnelStep2FormData.contactAparmentBilling = delivery;
	      } else if (fieldName === 'address') {
	        this.tunnelStep2FormData.contactAddressBilling = delivery;
	      } else if (fieldName === 'branchOffice') {
	        if (delivery) {
	          this.tunnelStep2FormData.branchOffice = 0;
	          this.cart.tunnel.operatingCentersAddresses.forEach(function (sucursal, key) {
	            if (sucursal['address'] === _this2.tunnelStep2FormData.contactAddressBilling) {
	              _this2.tunnelStep2FormData.branchOffice = sucursal['id'];
	            }
	          });
	        }
	      }
	    }
	  }, {
	    key: 'getAllCartOrderInfo',
	    value: function getAllCartOrderInfo() {
	      var _this3 = this;
	
	      if (!this.initLocationInfoLoaded) {
	        var cart = this.cart;
	        // Set info data based on cart info
	        this.contactCountryDelivery = this.cart.order.location.country.name.toString();
	        var stateName = this.cart.order.location.state.name.toString();
	        var cityName = this.cart.order.location.city.name.toString();
	        //let operatingCentersAddresses = $rootScope.cart.tunnel.operatingCentersAddresses;
	        this.contactStateDelivery = stateName;
	        this.contactCityDelivery = cityName;
	        this.payMethod = this.cart.order.payment.name.toString();
	        this.tunnelStep2FormData.contactBuildingDelivery = cart.tunnel.contactBuildingDelivery;
	        this.tunnelStep2FormData.contactBuildingBilling = cart.tunnel.contactBuildingBilling;
	        this.tunnelStep2FormData.contactAparmentDelivery = cart.tunnel.contactAparmentDelivery;
	        this.tunnelStep2FormData.contactAparmentBilling = cart.tunnel.contactAparmentBilling;
	        this.tunnelStep2FormData.contactNeighborhoodDelivery = cart.tunnel.contactNeighborhoodDelivery;
	        this.tunnelStep2FormData.contactNeighborhoodBilling = cart.tunnel.contactNeighborhoodBilling;
	        try {
	          if (this.shCtrl.globals.currentUser.isB2B) {
	            this.tunnelStep2FormData.contactAddressDelivery = this.shCtrl.globals.currentClient.operatingCenter.address;
	          } else {
	            this.tunnelStep2FormData.contactAddressDelivery = cart.tunnel.contactAddressDelivery;
	          }
	        } catch (ex) {
	          this.tunnelStep2FormData.contactAddressDelivery = cart.tunnel.contactAddressDelivery;
	        }
	        this.tunnelStep2FormData.contactAddressBilling = cart.tunnel.contactAddressBilling;
	        this.tunnelStep2FormData.contactProgrammedDelivery = cart.tunnel.contactProgrammedDelivery;
	
	        this.tunnelStep2FormData.contactName = cart.tunnel.contactName;
	        this.tunnelStep2FormData.contactPhone = cart.tunnel.contactPhone;
	        this.tunnelStep2FormData.contactMovil = cart.tunnel.contactMovil;
	        try {
	          this.tunnelStep2FormData.contactMail = this.shCtrl.globals.currentUser.contactEmail;
	        } catch (e) {}
	        //
	
	        /*try {
	            if(operatingCentersAddresses.length === 1) {
	                this.tunnelStep2FormData.contactAddressDelivery = operatingCentersAddresses[0]['address'];
	                this.tunnelStep2FormData.contactAddressBilling = operatingCentersAddresses[0]['address'];
	            }
	        } catch(e) {}
	          if(!operatingCentersAddresses.length && $rootScope.isClientB2B()) {
	            this.tunnelStep2FormData.contactAddressDelivery = '';
	        }*/
	
	        // Get the billing location info
	        this.TunnelService.getCountriesBilling().then(function (response) {
	          _this3.countriesBilling = response.data;
	          var countryId = _this3.cart.order.billing.country.id.toString();
	          _this3.TunnelService.getStatesBilling(countryId).then(function (response) {
	            _this3.statesBilling = response.data;
	            var stateId = _this3.cart.order.billing.state.id.toString();
	            _this3.TunnelService.getCitiesBilling(stateId).then(function (response) {
	              _this3.citiesBilling = response.data;
	              _this3.$timeout(function () {
	                _this3.tunnelStep2FormData.contactCountryBilling = _this3.cart.order.billing.country.id.toString();
	                _this3.tunnelStep2FormData.contactStateBilling = _this3.cart.order.billing.state.id.toString();
	                _this3.tunnelStep2FormData.contactCityBilling = _this3.cart.order.billing.city.id.toString();
	                _this3.initLocationInfoLoaded = true;
	              }, 300);
	            }).catch(function (reason) {
	              var options = {
	                title: '',
	                isHtml: false,
	                content: reason,
	                size: '',
	                showBottonCancel: false,
	                textActionCancel: '',
	                textAction: 'Aceptar'
	              };
	              _this3.messageResponse(options);
	            });
	          }).catch(function (reason) {
	            var options = {
	              title: '',
	              isHtml: false,
	              content: reason,
	              size: '',
	              showBottonCancel: false,
	              textActionCancel: '',
	              textAction: 'Aceptar'
	            };
	            _this3.messageResponse(options);
	          });
	        }).catch(function (reason) {
	          var options = {
	            title: '',
	            isHtml: false,
	            content: reason,
	            size: '',
	            showBottonCancel: false,
	            textActionCancel: '',
	            textAction: 'Aceptar'
	          };
	          _this3.messageResponse(options);
	        });
	      }
	    }
	  }, {
	    key: 'getPayMethodsTunnel',
	    value: function getPayMethodsTunnel() {
	      var _this4 = this;
	
	      if (!this.paymentMethodsTunnel) {
	        this.TunnelService.getPayMethods().then(function (response) {
	          _this4.paymentMethodsTunnel = response;
	          if (_this4.paymentMethodsTunnel.length === 1) {
	            _this4.paymentMethodTunnel = _this4.paymentMethodsTunnel[0]['id'];
	          }
	        }).catch(function (reason) {});
	      }
	    }
	  }, {
	    key: 'saveTunnel',
	    value: function saveTunnel(tunnelStep2Form, alsoCreateOrder2) {
	      var _this5 = this;
	
	      var alsoCreateOrder = alsoCreateOrder2 || false;
	      if (this.$rootScope.orderIdInsideTunnel) {
	        this.savingTunnelData = false;
	        this.savedTunnelData = true;
	        this.tunnelStep = 3;
	      } else if (tunnelStep2Form.$valid) {
	        var cartId = this.SessionService.get('cartId') || '';
	        var globals = this.shCtrl.globals;
	        if (this.shCtrl.globalParams.solicitarInfoTransporte) {
	          if (cartId) {
	            this.TunnelService.updateDespachoPedido(this.cart.order.vehiculo_transporte).then(function (response) {
	              if (!response.error) {
	                _this5.saveTunnelOkey(tunnelStep2Form, alsoCreateOrder);
	              } else {
	                alert("Error al guardar informacion del conductor, verifique.");
	              }
	            }).catch(function (reason) {
	              _this5.saveTunnelOkey(tunnelStep2Form, alsoCreateOrder);
	            });
	          }
	        } else {
	          this.saveTunnelOkey(tunnelStep2Form, alsoCreateOrder);
	        }
	      } else {
	        _angular2.default.forEach(tunnelStep2Form.$error.required, function (field) {
	          field.$setDirty();
	        });
	      }
	    }
	  }, {
	    key: 'saveTunnelOkey',
	    value: function saveTunnelOkey(tunnelStep2Form, alsoCreateOrder) {
	      var _this6 = this;
	
	      this.savingTunnelData = true;
	      this.savedTunnelData = false;
	      this.errorSavingTunnelData = '';
	
	      this.tunnelStep2FormData.cartId = this.cart.cartId;
	      this.tunnelStep2FormData.userId = '';
	
	      if (this.shCtrl.globals) {
	        try {
	          this.tunnelStep2FormData.userId = this.shCtrl.globals.currentUser.userId;
	        } catch (e) {}
	      }
	
	      this.tunnelStep2FormData.allowGuestInTunnel = this.$rootScope.allowGuestInTunnel;
	      this.TunnelService.saveCartTunnelData(this.tunnelStep2FormData).then(function (response) {
	        _this6.savingTunnelData = false;
	        if (!response.error) {
	          _this6.savedTunnelData = true;
	          _this6.tunnelStep = 3;
	          if (alsoCreateOrder) {
	            // showModalRespuestaCreacionOrden();
	            _this6.saveOrder();
	          }
	        } else {
	          _this6.savedTunnelData = false;
	          _this6.errorSavingTunnelData = response.message;
	        }
	      });
	    }
	  }, {
	    key: 'saveOrder',
	    value: function saveOrder() {
	      var _this7 = this;
	
	      this.loadingSavingOrder = true;
	      this.orderSaved = false;
	      this.errorSavingOrder = false;
	      this.messageSavingTheOrder = '';
	      this.errorsDataSavingOrder = [];
	
	      var cartId = this.SessionService.get('cartId') || '';
	
	      if (cartId) {
	        var userId = '';
	        try {
	          userId = this.shCtrl.globals.currentUser.userId;
	        } catch (e) {}
	
	        var sellerId = '';
	        try {
	          sellerId = this.shCtrl.globals.currentUser.sellerId;
	        } catch (e) {}
	
	        var orderOnlyToQuote = '';
	        if (this.ngAuthSettings.site.config.data.tunnel.allowQuotesNoLogin && this.cart.order.totalItemsToQuote === this.cart.items.length) {
	          orderOnlyToQuote = 1;
	        }
	        // Get the contact mail
	        var contactMail = '';
	        try {
	          contactMail = this.tunnelStep2FormData.contactMail;
	        } catch (e) {}
	
	        // Get the type and number id
	        var contactTypeId = '';
	        var contactNumberId = '';
	        try {
	          contactTypeId = this.tunnelStep2FormData.contactTypeId;
	          contactNumberId = this.tunnelStep2FormData.contactNumberId;
	        } catch (e) {}
	        // Client price list
	        var clientPriceList = '';
	        try {
	          clientPriceList = this.quoteCartSeller.clientPriceList;
	        } catch (e) {}
	        // Send the request
	        this.TunnelService.saveOrder({
	          'cartId': cartId,
	          'userId': userId,
	          'sellerId': sellerId,
	          'orderOnlyToQuote': orderOnlyToQuote,
	          'contactMail': contactMail,
	          'contactTypeId': contactTypeId,
	          'contactNumberId': contactNumberId,
	          'quoteCartSeller': this.quoteCartSeller,
	          'quoteCartSellerPriceListName': clientPriceList
	        }).then(function (response) {
	          _this7.loadingSavingOrder = false;
	          if (!response.error) {
	            _this7.orderSaved = true;
	            _this7.orderIdSaved = response.data.orderId;
	            _this7.SessionService.remove('quoteCartSeller');
	            _this7.messageSavingTheOrder = 'El pedido ha sido realizado exitosamente.';
	            $('div.modal-backdrop').remove();
	            if (_this7.cart.order.totalItemsToQuote !== _this7.cart.items.length) {
	              // Se limpia el carrito
	              _this7.SessionService.put('cartId', '');
	              _this7.cart = {};
	              _this7.CartService.clearCart();
	              _this7.$scope.$emit('onUpdateCart');
	              _this7.cartOrderCreated = true;
	              var orderId = response.data.orderId;
	
	              if (_this7.ngAuthSettings.site.config.data.tunnel.hasGangway) {
	                // window.location = config.env.apiEndPoint + '/order/pay-gate?id='+this.orderIdSaved;
	                // this.hideEmptyCartAfterTunel = true;
	                _this7.$state.go('home.confirmationOrder', { orderId: _this7.orderIdSaved, resolve: false });
	                _this7.hideEmptyCartAfterTunel = true;
	              } else {
	                _this7.$state.go('home.orderDetail', { orderId: _this7.orderIdSaved });
	                _this7.hideEmptyCartAfterTunel = true;
	              }
	            } else {
	              // Se limpia el carrito
	              _this7.SessionService.put('cartId', '');
	              _this7.cart = {};
	              _this7.CartService.clearCart();
	              _this7.$scope.$emit('onUpdateCart');
	              _this7.cartQuoteCreated = true;
	              _this7.$state.go('home.quoteDetail', { quoteId: response.data.quoteId });
	            }
	          } else {
	            if (response.errorCode === 'CANASTA-NO-EXISTE') {
	              response.message = 'Se ha presentado un problema interno en la aplicación. ' + 'La canasta ha sido eliminada. En un momento será redirigido ' + 'la página de inicio.';
	              // Se limpia el carrito
	              _this7.SessionService.put('cartId', '');
	              _this7.cart = {};
	              _this7.CartService.clearCart();
	              _this7.$scope.$emit('onUpdateCart');
	              _this7.$timeout(function () {
	                this.$state.go(this.ngAuthSettings.site.app.header.logo.url);
	              }, 3000);
	            }
	
	            _this7.errorSavingOrder = true;
	            _this7.messageSavingTheOrder = response.message;
	            _this7.errorsDataSavingOrder = response.errorsMessages;
	            var options = {
	              title: '',
	              isHtml: false,
	              content: _this7.errorsDataSavingOrder,
	              size: '',
	              showBottonCancel: false,
	              textActionCancel: '',
	              textAction: 'Aceptar'
	            };
	            _this7.messageResponse(options);
	          }
	        }).catch(function (reason) {
	          _this7.loadingSavingOrder = false;
	          _this7.errorSavingOrder = true;
	          _this7.messageSavingTheOrder = 'Ha ocurrido un error al realizar el pedido.' + ' Por favor vuelva a intentarlo más tarde.';
	        });
	      } else {
	        alert('No existe una canasta');
	      }
	    }
	  }, {
	    key: 'sendOrderToGanway',
	    value: function sendOrderToGanway(tunnelStep2Form) {
	      if (this.$rootScope.orderIdInsideTunnel) {
	        if (tunnelStep2Form.$valid && this.paymentMethodTunnel) {
	          if (this.ngAuthSettings.site.config.data.tunnel.hasGangway) {
	            var url = config.env.apiEndPoint + '/order/pay-gate?id=' + this.$rootScope.orderIdInsideTunnel + '&paymentMethodTunnel=' + this.paymentMethodTunnel;
	            this.$rootScope.orderIdInsideTunnel = '';
	            $window.location = url;
	          } else {
	            this.$rootScope.orderIdInsideTunnel = '';
	            // $location.path('/pedido-creado/' + this.orderIdSaved);
	            this.$state.go('home.orderDetail', { orderId: this.orderIdSaved });
	          }
	        } else {
	          _angular2.default.forEach(tunnelStep2Form.$error.required, function (field) {
	            field.$setDirty();
	          });
	        }
	      }
	    }
	  }, {
	    key: 'messageResponse',
	    value: function messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template: _modalResponseView2.default,
	        controller: 'ModalResponseController',
	        controllerAs: 'mdCtrl',
	        size: options.size,
	        resolve: {
	          modalOptions: function modalOptions() {
	            return options;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        if (callAcept) {
	          callback();
	        }
	      }).catch(function (reason) {
	        if (callCancel) {
	          callbackCancel();
	        }
	      });
	    }
	  }]);
	
	  return TunnelController;
	}();
	
	TunnelController.$inject = inject;
	
	exports.default = TunnelController;

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tunnel = __webpack_require__(430);
	
	var _tunnel2 = _interopRequireDefault(_tunnel);
	
	var _tunnel3 = __webpack_require__(434);
	
	var _tunnel4 = _interopRequireDefault(_tunnel3);
	
	var _tunnel5 = __webpack_require__(431);
	
	var _tunnel6 = _interopRequireDefault(_tunnel5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tunnelModule = _angular2.default.module('app.tunnel', []).component('tunnel', _tunnel2.default).service('TunnelService', _tunnel4.default).config(_tunnel6.default);
	
	exports.default = tunnelModule;

/***/ },
/* 434 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService'];
	
	var TunnelService = function () {
	  function TunnelService($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService) {
	    _classCallCheck(this, TunnelService);
	
	    this.$q = $q;
	    this.$http = $http;
	    this.ngAuthSettings = ngAuthSettings;
	    this.AuthTokenFactory = AuthTokenFactory;
	    this.SharedService = SharedService;
	    this.SessionService = SessionService;
	  }
	
	  _createClass(TunnelService, [{
	    key: 'getCountriesBilling',
	    value: function getCountriesBilling() {
	      var _this = this;
	
	      return this.$q(function (resolve, reject) {
	        _this.$http({
	          method: 'GET',
	          url: _this.ngAuthSettings.apiServiceBaseUri + _this.ngAuthSettings.config.paths.countries,
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getStatesBilling',
	    value: function getStatesBilling(countryId) {
	      var _this2 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this2.$http({
	          method: 'GET',
	          url: _this2.ngAuthSettings.apiServiceBaseUri + _this2.ngAuthSettings.config.paths.states + countryId,
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getCitiesBilling',
	    value: function getCitiesBilling(stateId) {
	      var _this3 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this3.$http({
	          method: 'GET',
	          url: _this3.ngAuthSettings.apiServiceBaseUri + _this3.ngAuthSettings.config.paths.cities + stateId,
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'getPayMethods',
	    value: function getPayMethods() {
	      var _this4 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this4.$http({
	          method: 'GET',
	          url: _this4.ngAuthSettings.apiServiceBaseUri + _this4.ngAuthSettings.config.paths.payMethods,
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'updateDespachoPedido',
	    value: function updateDespachoPedido(data) {
	      var _this5 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this5.$http({
	          method: 'POST',
	          url: _this5.ngAuthSettings.apiServiceBaseUri + _this5.ngAuthSettings.config.paths.updateDespachoPedido,
	          data: $.param(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'saveCartTunnelData',
	    value: function saveCartTunnelData(data) {
	      var _this6 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this6.$http({
	          method: 'POST',
	          url: _this6.ngAuthSettings.apiServiceBaseUri + _this6.ngAuthSettings.config.paths.saveCartTunnelData,
	          data: $.param(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }, {
	    key: 'saveOrder',
	    value: function saveOrder(data) {
	      var _this7 = this;
	
	      return this.$q(function (resolve, reject) {
	        _this7.$http({
	          method: 'POST',
	          url: _this7.ngAuthSettings.apiServiceBaseUri + _this7.ngAuthSettings.config.paths.saveOrder,
	          data: $.param(data),
	          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	          cache: false
	        }).then(function (response) {
	          resolve(response.data);
	        }).catch(function (reason) {
	          reject(reason);
	        });
	      });
	    }
	  }]);
	
	  return TunnelService;
	}();
	
	TunnelService.$inject = inject;
	
	exports.default = TunnelService;

/***/ },
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6f9e0e238c7a915a8e2c4b79b59d1cd3.jpg";

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4cfb254756b28ece61b3cc4360063762.jpg";

/***/ },
/* 444 */,
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div><div class=container><div class=wrapper-loading-animation ng-show=$ctrl.orderDataForm.loadingCartInfo><i ng-class=\"{'fa fa-history load-animation': $ctrl.orderDataForm.loadingCartInfo, 'fa fa-history': !$ctrl.orderDataForm.loadingCartInfo}\"></i> <span>Cargando información del carrito</span></div><div><form id=order-form name=$ctrl.orderForm ng-submit=$ctrl.buyNow($ctrl.orderForm) novalidate><div class=\"row config-envio\"><div class=row ng-show=\"$ctrl.loadedPointsOfSale && !$ctrl.pointsOfSaleData.length\" style=\"margin-bottom: 10px\"><div><div class=\"alert alert-danger\" style=\"margin: 0px 20px\">No existen puntos de venta asociados. Por favor contácte al administrador del sistema y reporte este inconveniente.</div></div></div><div class=row ng-show=\"$ctrl.loadedCartInfo && $ctrl.pointsOfSaleData.length === 1 && !$ctrl.orderDataForm.pointOfSaleId\" style=\"margin-bottom: 10px\"><div><div class=\"alert alert-danger\" style=\"margin: 0px 20px\">El punto de venta asociado no fue seleccionado. Por favor contácte al administrador del sistema y reporte este inconveniente.</div></div></div><div class=row ng-show=\"!$ctrl.payMethods.length && $ctrl.loadedPayMethods\" style=\"margin-bottom: 10px\"><div><div class=\"alert alert-danger\" style=\"margin: 0px 20px\">No existen métodos de pago asociados. Por favor contácte al administrador del sistema y reporte este inconveniente.</div></div></div><div class=\"col-md-4 col-sm-6 col-xs-12\"><div class=\"config-pedido-box box1\"><h5 id=info-des><i class=\"fa fa-map-marker\" aria-hidden=true></i> Información de destino.</h5><div ng-if=\"!$ctrl.shCtrl.globals.currentUser.isB2B || !$ctrl.orderDataForm.city\"><dd><input class=form-control ng-model=$ctrl.orderDataForm.searchLocationtext id=searchLocationtext name=searchLocationtext placeholder=\"Digite la ciudad de destino\" ng-keyup=$ctrl.getLocationsByFastSearch($ctrl.orderDataForm.searchLocationtext) autocomplete=off ng-disabled=$ctrl.cartData.loadingCartInfo required><div style=position:relative ng-show=!$ctrl.orderDataForm.locationSelected><div class=\"ubicaciones-texto col-md-12\" ng-show=$ctrl.orderDataForm.locationsByFastSearch.length><div class=ubicacion-texto ng-repeat=\"locationByFastSearch in $ctrl.orderDataForm.locationsByFastSearch\" ng-click=$ctrl.setLocationCity(locationByFastSearch);><span>{{locationByFastSearch.cityName}}, {{locationByFastSearch.stateName}} - {{locationByFastSearch.countryName}}</span></div></div><div class=\"ubicaciones-texto col-md-12\" ng-show=\"!$ctrl.orderDataForm.locationsByFastSearch.length &&\r\n                                   $ctrl.orderDataForm.loadedLocationsByFastSearch &&\r\n                                   $ctrl.orderDataForm.searchLocationtext.length > 3\"><div class=ubicacion-texto>No hay resultados para '{{$ctrl.orderDataForm.searchLocationtext}}'</div></div></div><i ng-show=$ctrl.updatingCityLocation ng-class=\"{'fa fa-history load-animation': $ctrl.updatingCityLocation, 'fa fa-history': !$ctrl.updatingCityLocation}\"></i> <span ng-show=\"$ctrl.orderForm.city.$invalid &&\r\n                                    !$ctrl.orderForm.searchLocationtext.$pristine\" class=help-block>Seleccione la Ciudad. </span><span ng-show=$ctrl.errorUpdatingCityLocation class=help-block>Ha ocurrido un error al actualizar la ciudad de destino.</span></div><div ng-if=$ctrl.shCtrl.globals.currentUser.isB2B style=\"margin-top: 5px; font-size: 11px\"><span style=\"font-weight: 600;font-size: 12px\">{{$ctrl.shCtrl.globalParams.operatingCenterSelected.name}}</span><br>{{$ctrl.shCtrl.globalParams.operatingCenterSelected.address}}<br>{{$ctrl.shCtrl.globalParams.operatingCenterSelected.location.fullname}}</div><p class=text-right style=display:none><button type=button class=\"btn btn-success btn-sm\" type=button>Guardar</button></div></div><div ng-show=\"$ctrl.ngAuthSettings.site.config.data.shipping.showPointsOfSale || $ctrl.ngAuthSettings.site.config.data.shipping.showShippingMethod\" class=\"col-md-4 col-sm-4 col-xs-12\"><div class=\"config-pedido-box box2\"><h5 id=info-env>¿Cómo desea el envío?</h5><div ng-show=$ctrl.ngAuthSettings.site.config.data.shipping.showPointsOfSale><div ng-show=\"!$ctrl.loadingPointsOfSale && $ctrl.pointsOfSaleData.length > 0\"><select class=form-control name=pointOfSaleId id=pointOfSaleId ng-model=$ctrl.orderDataForm.pointOfSaleId title=\"Por favor seleccione el punto de venta\" ng-change=$ctrl.setCurrentPointOfSale($ctrl.orderDataForm.pointOfSaleId) ng-disabled=$ctrl.cartData.loadingCartInfo required><option value=\"\">Seleccione un punto de venta<option ng-repeat=\"pos in $ctrl.pointsOfSaleData\" ng-show=\"$ctrl.pointsOfSaleData.length > 0\" value={{pos.id}}>{{pos.name}}</select><span ng-show=\"$ctrl.orderForm.pointOfSaleId.$invalid && !$ctrl.orderForm.pointOfSaleId.$pristine\" class=help-block>Seleccione el punto de venta.</span></div><div class=\"table-responsive table-puntos-de-venta\" ng-show=\"$ctrl.currentPointOfSale && $ctrl.orderDataForm.pointOfSaleId\"><table><tr class=punto-de-venta><td><div class=datos-sucursal><div class=latitude>{{$ctrl.currentPointOfSale.latitude}}</div><div class=longitude>{{$ctrl.currentPointOfSale.longitude}}</div><div class=direccion>{{$ctrl.currentPointOfSale.address}}</div><div class=pbx>{{$ctrl.currentPointOfSale.phone}}</div><a class=\"openmodal btn btn-default btn-sm ver-mapa\" ng-click=$ctrl.openMap($ctrl.currentPointOfSale) ng-show=\"$ctrl.currentPointOfSale.latitude && $ctrl.currentPointOfSale.longitude\" style=width:50px><img src=" + __webpack_require__(72) + "> </a><a class=\"openmodal btn btn-default btn-sm ver-mapa\" ng-click=$ctrl.openMap($ctrl.currentPointOfSale) ng-show=\"!$ctrl.currentPointOfSale.latitude && $ctrl.currentPointOfSale.longitude\" style=width:50px><img src=" + __webpack_require__(68) + "></a></div><td><div class=datos-ubicacion-sucursal><div><b>Punto de Venta:</b><label class=name>{{$ctrl.currentPointOfSale.name}}</label></div><div ng-show=$ctrl.currentPointOfSale.address><label class=address>{{$ctrl.currentPointOfSale.address}}</label></div><div ng-show=$ctrl.currentPointOfSale.phone><b>Tel.:</b><label class=phone>{{$ctrl.currentPointOfSale.phone}}</label></div></div></table></div></div><div ng-shows=$ctrl.ngAuthSettings.site.config.data.shipping.showShippingMethod><div class=checkbox><label><input type=radio name=shipping id=shipping ng-model=$ctrl.orderDataForm.shipping ng-disabled=$ctrl.cartData.loadingCartInfo value=0> Deseo que me lo envien, sumar el costo del envío al pedido actual.</label></div><div class=checkbox><label><input type=radio name=shipping id=shipping ng-model=$ctrl.orderDataForm.shipping ng-disabled=$ctrl.cartData.loadingCartInfo ng-value=1> Deseo recogerlo en el punto de venta.</label></div><div class=\"table-responsive table-puntos-de-venta table-puntos-de-venta-shipping\" ng-show=\"$ctrl.currentPointOfSale &&\r\n                               $ctrl.orderDataForm.pointOfSaleId &&\r\n                               $ctrl.orderDataForm.shipping == 1\"><table><tr class=punto-de-venta><td><div class=datos-sucursal><div class=latitude>{{$ctrl.currentPointOfSale.latitude}}</div><div class=longitude>{{$ctrl.currentPointOfSale.longitude}}</div><div class=direccion>{{$ctrl.currentPointOfSale.address}}</div><div class=pbx>{{$ctrl.currentPointOfSale.phone}}</div><a class=\"openmodal btn btn-default btn-sm ver-mapa\" ng-click=$ctrl.openMap($ctrl.currentPointOfSale) ng-show=\"$ctrl.currentPointOfSale.latitude && $ctrl.currentPointOfSale.longitude\" style=width:50px><img src=" + __webpack_require__(72) + "> </a><a class=\"openmodal btn btn-default btn-sm ver-mapa\" ng-click=$ctrl.openMap($ctrl.currentPointOfSale) ng-show=\"!$ctrl.currentPointOfSale.latitude && $ctrl.currentPointOfSale.longitude\" style=width:50px><img src=" + __webpack_require__(68) + "></a></div><td><div class=datos-ubicacion-sucursal><div><b>Punto de Venta:</b><label class=name>{{$ctrl.currentPointOfSale.name}}</label></div><div ng-show=$ctrl.currentPointOfSale.address><label class=address>{{$ctrl.currentPointOfSale.address}}</label></div><div ng-show=$ctrl.currentPointOfSale.phone><b>Tel.:</b><label class=phone>{{$ctrl.currentPointOfSale.phone}}</label></div></div></table></div></div></div><span ng-show=\"$ctrl.orderForm.shipping.$invalid && !$ctrl.orderForm.shipping.$pristine\" class=help-block>Seleccione el tipo de envío.</span></div><div class=\"col-md-4 col-sm-6 col-xs-12\"><div class=\"config-pedido-box box3\"><h5 id=info-pag><i class=\"fa fa-credit-card\" aria-hidden=true></i> Metodo de Pago</h5><select class=form-control name=payment id=payment title=\"Por favor seleccione un medio de pago\" ng-model=$ctrl.orderDataForm.payment ng-disabled=$ctrl.cartData.loadingCartInfo ng-change=$ctrl.savePayMethodCart($ctrl.orderDataForm.payment) required><option value=\"\">Seleccione su medio de pago<option ng-repeat=\"payMethod in $ctrl.payMethods\" value={{payMethod.id}}>{{payMethod.nombre}}</select><i ng-show=$ctrl.savingPayMethodCart ng-class=\"{'fa fa-history load-animation': $ctrl.savingPayMethodCart, 'fa fa-history': !$ctrl.savingPayMethodCart}\"></i> <span ng-show=\"$ctrl.orderForm.payment.$invalid && !$ctrl.orderForm.payment.$pristine\" class=help-block>Seleccione el medio de pago. </span><span ng-show=$ctrl.errorUpdatingPayMethod class=help-block>Ha ocurrido un error al actualizar el método de pago.</span></div></div><div class=\"col-md-4 hidden-sm hidden-xs text-center\" ng-if=globals.currentUser.applyLogisticsService><div class=\"config-pedido-box box4\"><h5 id=info-des>Servicio logístico.</h5><div class=form-group><label class=switch-user><span>Si</span> <span>No</span> <input type=checkbox ng-change=$ctrl.changeLogisticService(isLogisticService) ng-model=isLogisticService><div class=slider-switch></div></label></div></div></div><div class=\"col-md-4 hidden-sm hidden-xs\" ng-if=\"::$ctrl.ngAuthSettings.site.config.data.shipping.showBannerShippingMethod && $ctrl.shCtrl.globalBanners.canastaHeaderRight\"><div class=\"config-pedido-box box4\"><dynamic-banner db-data=$ctrl.shCtrl.globalBanners.canastaHeaderRight db-name=canastaHeaderRight></dynamic-banner></div></div><div class=\"col-md-4 col-sm-4 col-xs-12\" ng-if=\"$ctrl.ngAuthSettings.site.config.data.cart.showCartetera && $ctrl.shCtrl.globals.currentUser\"><div class=\"config-pedido-box box4\"><h5 id=info-pag><i class=\"fa fa-pie-chart\" aria-hidden=true></i> Estado de Cartera</h5><div><span class=term>Cupo:</span> <span class=defn>$ {{ ($ctrl.billfoldResume.CUPO_CREDITO || 0) | currency:'':0}}</span></div><div><span class=term>Corriente:</span> <span class=defn>$ {{ ($ctrl.billfoldResume.VLR_SIN_VENCER || 0) | number:0}}</span></div><div><span class=term>Vencida:</span> <span class=defn ng-class=\"{'cartera-vencida':billfoldResume.VLR_VENCIDO < 0}\">$ {{ ($ctrl.billfoldResume.VLR_VENCIDO || 0) | currency:'':0}}</span></div><div><span class=term>Cupo Disponible:</span> <span class=defn>$ {{ ($ctrl.billfoldResume.CUPO_DISPONIBLE || 0) | currency:'':0}}</span></div></div></div></div><div class=\"row premessage_order\"><div ng-show=$ctrl.ngAuthSettings.site.config.data.cart.showPremessageOrder class=\"col-sm-8 col-xs-12\"><div class=\"config-pedido canasta_alerts alert alert-warning orden-texto-importante-inicial\"><strong>TENER PRESENTE:</strong> Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</div></div><div ng-show=\"$ctrl.ngAuthSettings.site.config.data.cart.showPremessageOrder &&\r\n                    ($ctrl.shCtrl.globals.currentUser.isSeller || $ctrl.shCtrl.globals.currentUser.isContactCenter)\" class=\"col-sm-4 col-xs-12\"><div ng-show=$ctrl.loadingBillResume class=\"config-pedido canasta_alerts alert alert-warning\"><div class=valores_item>Cargando resumen de cartera...</div><div class=valores_item>&nbsp;</div><div class=valores_item>&nbsp;</div><div class=valores_item>&nbsp;</div></div><div ng-show=$ctrl.loadedBillResume class=\"config-pedido canasta_alerts alert alert-warning\"><div class=valores_item>Cupo Asignado: <span class=pull-right>$ {{ ($ctrl.billfoldResume.CUPO_CREDITO || 0) | currency:'':0}}</span></div><div class=valores_item>Cartera: <span class=pull-right>$ {{ ($ctrl.billfoldResume.CARTERA || 0) | currency:'':0}}</span></div><div class=valores_item>Pedidos: <span class=pull-right>$ {{ ($ctrl.billfoldResume.PEDIDO_COMPROMETIDO || 0) | currency:'':0}}</span></div><div class=valores_item>Remisiones: <span class=pull-right>$ {{ ($ctrl.billfoldResume.REMISION_SIN_FACTURAR || 0) | currency:'':0}}</span></div><div class=valores_item>Cupo Disponible: <span class=pull-right>$ {{ ($ctrl.billfoldResume.CUPO_DISPONIBLE || 0) | number:0}}</span></div><div class=valores_item>Cartera Corriente: <span class=pull-right>$ {{ ($ctrl.billfoldResume.VLR_SIN_VENCER || 0) | number:0}}</span></div><div class=valores_item>Cartera Vencida: <span class=pull-right>$ {{ ($ctrl.billfoldResume.VLR_VENCIDO || 0) | currency:'':0}}</span></div><br><div class=valores_item>&Uacute;ltima Actualizaci&oacute;n: {{$ctrl.lastUpdatedBillResume}}</div></div></div></div><div class=\"col-sm-4 col-xs-12 lista-precio-cliente\" ng-if=\"$ctrl.shCtrl.globals.currentUser.isSeller && $ctrl.ngAuthSettings.site.config.data.cart.showSelectPriceList\"><div class=row><div class=form-group><label>Lista de Precios del Cliente *</label><select class=form-control name=clientPriceList id=clientPriceList title=\"Por favor seleccione la lista de precios a aplicar al cliente\" ng-model=$ctrl.orderDataForm.clientPriceList ng-change=$ctrl.updateValuesQuoteSeller() ng-disabled=$ctrl.cartData.loadingCartInfo required><option value=client>Lista de precio del cliente<option value=cost>Lista de precio al costo</select><span ng-show=\"$ctrl.orderForm.clientPriceList.$invalid && !$ctrl.orderForm.clientPriceList.$pristine\" class=help-block>Seleccione la lista de precios a aplicar al cliente.</span></div></div></div><div class=\"row canasta-pedido pagcanasta\"><div class=\"col-md-12 table-responsive\"><div class=\"alert alert-warning\" ng-show=$ctrl.errorAddingQuantityItemtoCart><div ng-bind-html=\"$ctrl.errorMessageAddingQuantityItemtoCart | toTrusted\"></div></div><table class=\"table cart-table tb\" ng-repeat=\"isorderQuoteTable in [1, 0]\" ng-show=\"(isorderQuoteTable && $ctrl.cart.order.totalItemsToQuote > 0) ||\r\n                             (!isorderQuoteTable && $ctrl.cart.order.totalItemsToQuote !== $ctrl.cart.items.length)\"><thead><tr><th class=\"title-quote-or-order table-title text-center\" colspan=8><span ng-show=isorderQuoteTable>ITEMS A COTIZAR</span> <span ng-show=!isorderQuoteTable class=titulo-table-pedido>ITEMS DEL PEDIDO A COMPRAR</span><tr><th class=table-title>Item <i ng-show=\"$ctrl.cartData.loadingCartInfo || $ctrl.addingQuantityItemCart\" ng-class=\"{'fa fa-history load-animation': $ctrl.cartData.loadingCartInfo, 'fa fa-history': !$ctrl.cartData.loadingCartInfo}\"></i><th class=\"table-title hidden-xs\">U.M.<th class=\"table-title hidden-xs\">Cantidad<th class=\"table-title hidden-xs\" ng-if=$ctrl.shCtrl.globalParams.showKilosItemCanasta>Peso(kg)<th class=\"table-title hidden-xs\"><span ng-if=!$ctrl.orderDataForm.clientPriceList>Vr. Unit.</span> <span ng-if=\"$ctrl.orderDataForm.clientPriceList === 'client'\">Vr. Unit.</span> <span ng-if=\"$ctrl.orderDataForm.clientPriceList === 'cost'\">Costo Unitario</span><th class=\"table-title hidden-xs\" ng-show=$ctrl.ngAuthSettings.site.config.debug><span class=debug>Vr. Total</span><th class=\"table-title hidden-xs\"><span ng-if=!$ctrl.orderDataForm.clientPriceList>Descuento</span> <span ng-if=\"$ctrl.orderDataForm.clientPriceList === 'client'\">Dscto %</span> <span ng-if=\"$ctrl.orderDataForm.clientPriceList === 'cost'\">Factor</span><th class=\"table-title hidden-xs\"><span>Imp.%</span><th class=\"table-title hidden-xs\">Subtotal<tbody><tr ng-repeat=\"item in $ctrl.cart.items\" ng-if=\"item.quote === isorderQuoteTable\"><td class=item-name-col><figure class=hidden-xs><a ui-sref=\"home.productDetailId({productId : item.id})\"><img ng-src={{item.image}}></a></figure><div class=datos-prod><header class=item-name><a ui-sref=\"home.productDetailId({productId : item.id})\">{{item.name}}</a></header><ul><li><strong>Referencia:</strong> {{item.reference}}<li ng-repeat=\"attribute in item.attributesDetail\"><b>{{attribute.title}}:</b> {{attribute.value| join}}<li class=hidden-xs><button title=Eliminar type=button class=\"btn btn-default pull-left\" ng-click=$ctrl.removeItemFromCart(item) ng-disabled=$ctrl.cartData.loadingCartInfo><i class=\"fa fa-times\" aria-hidden=true></i></button> <button title=\"Agregar Comentario\" type=button ng-show=$ctrl.ngAuthSettings.site.config.data.item.showComments class=\"btn btn-default pull-left\" ng-class=\"{'item-has-comment': item.comment}\" ng-disabled=$ctrl.cartData.loadingCartInfo><span class=\"glyphicon glyphicon-comment\"></span></button></li><div class=xs-margin></div></ul></div><div class=\"extras-xs visible-xs\"><div class=cant-en-xs><label>Cantidad:</label><input restrict-type=num maxlength=5 ng-init=\"item.quantityToAddFromCart = item.quantity\" ng-model=item.quantityToAddFromCart ng-blur=$ctrl.saveItemQuantity(item) class=\"cantidad form-control\" ng-disabled=$ctrl.cartData.loadingCartInfo style=text-align:right></div><div class=xs-margin></div><div class=\"precio-en-xs text-left\"><strong>Precio:</strong> <span class=item-price-special ng-if=\"!$ctrl.shCtrl.globals.currentUser.isSeller && !item.quote\">$ {{item.price| currency:'':0}} <small>COP</small> </span><span class=item-price-special ng-if=\"!$ctrl.shCtrl.globals.currentUser.isSeller && item.quote\">- </span><span ng-class=\"item - price - special\" ng-if=$ctrl.shCtrl.globals.currentUser.isSeller>$ {{item.priceItemQuoteSeller| currency:'':0}} COP</span></div><div class=\"precio-en-xs text-left\"><strong>Impuesto:</strong> <span class=item-price-special ng-if=!item.quote>{{item.iva| currency:'':0}} % </span><span class=item-price-special ng-if=\"!$ctrl.shCtrl.globals.currentUser.isSeller && item.quote\">- </span><span class=item-price-special ng-if=\"$ctrl.shCtrl.globals.currentUser.isSeller && item.quote\">$ {{item.ivaPercentageQuoteSeller}} %</span></div><div class=cant-en-xs><label ng-if=!$ctrl.orderDataForm.clientPriceList>Descuento</label><label ng-if=\"$ctrl.orderDataForm.clientPriceList === 'client'\">Desc.</label><label ng-if=\"$ctrl.orderDataForm.clientPriceList === 'cost'\">Factor</label><span class=item-price-special ng-show=\"!$ctrl.shCtrl.globals.currentUser.isSeller && !item.quote\"><span ng-class=\"{'debug': $ctrl.ngAuthSettings.site.config.debug}\">$ {{item.discount| currency:'':0}} <small>COP</small> </span></span><span class=item-price-special ng-if=\"!$ctrl.shCtrl.globals.currentUser.isSeller && item.quote\">-</span><div ng-class=\"item - price - special\" style=text-align:center ng-if=$ctrl.shCtrl.globals.currentUser.isSeller><input restrict-type=num maxlength=3 ng-model=item.discountPercentageItemQuoteSeller ng-blur=$ctrl.updateValuesQuoteSeller(item) class=\"cantidad form-control\" ng-disabled=$ctrl.cartData.loadingCartInfo style=\"text-align:right;\r\n                                 display:inline\" ng-show=\"$ctrl.orderDataForm.clientPriceList === 'cost' || item.maxDiscount > 0\"> <span ng-show=\"item.maxDiscount > 0\">%</span><div ng-show=\"$ctrl.orderDataForm.clientPriceList === 'client' && item.maxDiscount > 0\" style=\"font-size: 10px;\r\n                               text-align: left\">descuento m&aacute;x. {{item.maxDiscount}} %</div><div ng-show=\"$ctrl.orderDataForm.clientPriceList !== 'cost' && !item.maxDiscount\">-</div></div></div><div class=xs-margin></div><button title=Eliminar type=button class=\"btn btn-default pull-left\" ng-click=$ctrl.removeItemFromCart(item)><span class=\"glyphicon glyphicon-trash\"></span></button> <button title=\"Agregar Comentario\" type=button ng-show=$ctrl.ngAuthSettings.site.config.data.item.showComments class=\"btn btn-default pull-left\" ng-class=\"{'item-has-comment': item.comment}\" ng-click=$ctrl.showProductComment(item)><span class=\"glyphicon glyphicon-comment\"></span></button></div><div class=comentario-item ng-show=item.comment><b>Comentario:</b> {{item.comment}}</div><td class=\"item-price-col hidden-xs\">{{item.measureUnit}}<td class=\"hidden-xs content-liquidacion\"><input restrict-type=num maxlength=5 ng-init=\"item.quantityToAddFromCart = item.quantity\" ng-model=item.quantityToAddFromCart ng-blur=$ctrl.saveItemQuantity(item) ng-change=$ctrl.calcularTotales() class=\"cantidad form-control\" ng-disabled=$ctrl.cartData.loadingCartInfo style=text-align:right><td class=\"hidden-xs content-liquidacion\" ng-if=$ctrl.shCtrl.globalParams.showKilosItemCanasta>{{item.quantityToAddFromCart * item.peso.embalaje}}<td class=\"item-price-col hidden-xs currency\"><span class=item-price-special ng-if=\"!$ctrl.shCtrl.globals.currentUser.isSeller && !item.quote\">$ {{item.price | currency:'':0}} <small>COP</small></span><span class=item-price-special ng-if=\"!$ctrl.shCtrl.globals.currentUser.isSeller && item.quote\">-</span><div ng-class=\"item - price - special\" style=text-align:center ng-if=$ctrl.shCtrl.globals.currentUser.isSeller><span>$</span><label>{{item.priceItemQuoteSeller| currency:'':0}} COP</label></div><td class=\"item-price-col hidden-xs currency\" ng-show=site.config.debug><span class=item-price-special><span class=debug>$ {{item.price * item.quantity| currency:'':0}} <small>COP</small></span></span><td class=\"item-des-col hidden-xs currency_old\"><span class=item-price-special ng-show=\"!$ctrl.shCtrl.globals.currentUser.isSeller && !item.quote\"><span ng-class=\"{'debug': $ctrl.ngAuthSettings.site.config.debug}\">{{item.discountPercentage}}% </span></span><span class=item-price-special ng-if=\"!$ctrl.shCtrl.globals.currentUser.isSeller && item.quote\">-</span><div ng-class=\"item - price - special\" style=text-align:center ng-if=$ctrl.shCtrl.globals.currentUser.isSeller><input maxlength=3 restrict-type=num ng-model=item.discountPercentageItemQuoteSeller ng-blur=$ctrl.updateValuesQuoteSeller(item) class=\"cantidad form-control\" ng-disabled=$ctrl.cartData.loadingCartInfo style=\"text-align:right;\r\n                             display:inline\" ng-show=\"$ctrl.orderDataForm.clientPriceList === 'cost' || item.maxDiscount > 0\"> <span ng-show=\"item.maxDiscount > 0\">%</span><div ng-show=\"$ctrl.orderDataForm.clientPriceList === 'client' && item.maxDiscount > 0\" style=\"top: 8px;\r\n                           font-size: 10px;\r\n                           position: relative;\r\n                           left: -5px\">máx. {{item.maxDiscount}} %</div><div ng-show=\"$ctrl.orderDataForm.clientPriceList !== 'cost' && !item.maxDiscount\">$ {{item.discount| currency:'':0}} <small>COP</small></div></div><td class=\"item-des-col hidden-xs currency_old\"><span class=item-price-special ng-if=!item.quote>{{item.iva| currency:'':0}}% </span><span class=item-price-special ng-if=\"!$ctrl.shCtrl.globals.currentUser.isSeller && item.quote\">- </span><span class=item-price-special ng-if=\"$ctrl.shCtrl.globals.currentUser.isSeller && item.quote\">$ {{item.ivaPercentageQuoteSeller}} %<br></span><td class=\"item-total-col hidden-xs currency\"><span class=item-price-special ng-if=\"!$ctrl.shCtrl.globals.currentUser.isSeller && !item.quote\">$ {{item.total|currency:'':0}} <small>COP</small> </span><span class=item-price-special ng-if=\"!$ctrl.shCtrl.globals.currentUser.isSeller && item.quote\">(Cotizar) </span><span class=item-price-special ng-if=$ctrl.shCtrl.globals.currentUser.isSeller>$ {{ item.total | currency:'':0 }} COP</span></table></div></div><div class=sm-margin></div><div class=\"row datos-totales\" ng-show=\"$ctrl.cart.order.totalItemsToQuote !== $ctrl.cart.items.length ||\r\n                       $ctrl.cart.order.totalItemsToQuote === $ctrl.cart.items.length\"><div class=\"col-md-4 col-sm-6 col-xs-12\"><div class=comentario-orden ng-show=$ctrl.ngAuthSettings.site.config.data.cart.showOrderComment><label class=control-label>Comentario de la Orden</label><button class=\"btn btn-default btn-block\" type=button ng-click=$ctrl.openCartComment() ng-disabled=$ctrl.cartData.loadingCartInfo ng-class=\"{'order-has-comment': $ctrl.orderComment}\"><i class=\"fa fa-commenting-o\" aria-hidden=true></i> Añadir comentario</button><div class=comentario-order-local ng-show=$ctrl.orderComment><b>Comentario:</b> {{$ctrl.orderComment}}</div></div></div><div class=\"col-md-4 col-sm-6 col-xs-12\"><div style=\"height: 120px\" ng-class=\"{'cod-descuento': !$ctrl.coupon.validCoupon, 'cod-descuento alert alert-success bg-success': $ctrl.coupon.validCoupon}\" ng-show=$ctrl.shCtrl.site.config.data.cart.showDiscountCoupon><label class=control-label ng-show=!$ctrl.coupon.validCoupon>¿Tiene un código de descuento? <span ng-show=$ctrl.coupon.savingCoupon><i ng-class=\"{'fa fa-history load-animation': $ctrl.coupon.savingCoupon, 'fa fa-history': !$ctrl.coupon.savingCoupon}\"></i></span></label><div class=input-group style=\"margin-bottom: 0px\"><input class=form-control placeholder=\"Ingrese código de descuento\" ng-model=$ctrl.coupon.discountCoupon ng-disabled=$ctrl.coupon.savingCoupon upper-case ng-show=!$ctrl.coupon.validCoupon> <span class=input-group-btn><button type=button class=\"btn btn-custom-2\" ng-disabled=$ctrl.coupon.savingCoupon ng-click=$ctrl.saveDiscountCoupon($ctrl.coupon.discountCoupon); ng-show=!$ctrl.coupon.validCoupon>Enviar</button></span><div ng-show=$ctrl.coupon.validCoupon>Has obtenido un descuento de $ {{$ctrl.coupon.couponValue| currency:'':0}} al ingresar el cupón {{$ctrl.coupon.discountCoupon}}</div></div><span ng-show=\"$ctrl.coupon.couponSaved && !$ctrl.coupon.validCoupon\" style=\"color: red;font-size: 12px;display: block;margin-top: 4px\">El cupón ingresado no es válido.</span></div></div><div class=\"visible-sm col-sm-6\"></div><div class=\"col-md-4 col-sm-6 col-xs-12 totales-pedido\" ng-show=\"!$ctrl.shCtrl.globals.currentUser.isSeller && $ctrl.cart.order.totalItemsToQuote !== $ctrl.cart.items.length\"><table class=\"table total-table\"><tr><td class=total-table-title>Subtotal Bruto:<td class=currency>$ {{$ctrl.cart.cartSubtotal| currency:'':0}} <small>COP</small><tr ng-show=\"$ctrl.cart.cartDiscounts || $ctrl.ngAuthSettings.site.config.debug\"><td class=total-table-title><span ng-class=\"{'debug': $ctrl.ngAuthSettings.site.config.debug}\">Descuento Comercial:</span><td class=currency><span ng-class=\"{'debug': $ctrl.ngAuthSettings.site.config.debug}\">$ {{$ctrl.cart.cartDiscounts| currency:'':0}} <small>COP</small></span><tr><td class=total-table-title>Subtotal Neto:<td class=currency>$ {{($ctrl.cart.cartSubtotal - $ctrl.cart.cartDiscounts) | currency:'':0}} <small>COP</small><tr><td class=total-table-title>Iva:<td class=currency>$ {{$ctrl.cart.cartTaxes| currency:'':0}} <small>COP</small><tr ng-show=\"($ctrl.ngAuthSettings.site.config.data.cart.showTransportPrice || $ctrl.ngAuthSettings.site.config.debug) && $ctrl.cartTransports\"><td class=total-table-title><span ng-class=\"{'debug': $ctrl.ngAuthSettings.site.config.debug}\">Gestión y Transporte:</span><td class=currency><span ng-class=\"{'debug': $ctrl.ngAuthSettings.site.config.debug}\">$ {{$ctrl.cart.cartTransports| currency:'':0}} <small>COP</small></span><tfoot><tr><td class=total-label>Total a Pagar:<td class=\"total-precio currency\">$ {{$ctrl.cart.cartTotal - $ctrl.coupon.couponValue| currency:'':0}} <small>COP</small></table><div class=xs-margin></div></div><div class=\"col-md-4 col-sm-6 col-xs-12 totales-pedido\" ng-show=$ctrl.shCtrl.globals.currentUser.isSeller><table class=\"table total-table\"><tr><td class=total-table-title>Subtotal:<td class=currency>$ {{$ctrl.quoteCartSeller.subtotalItemsQuoteValueSeller| currency:'':0}} <small>COP</small><tr><td class=total-table-title><span ng-if=\"$ctrl.orderDataForm.clientPriceList === 'client'\">Descuentos:</span> <span ng-if=\"$ctrl.orderDataForm.clientPriceList === 'cost'\">Utilidades:</span><td class=currency><span>$ {{$ctrl.quoteCartSeller.discountsItemsQuoteValueSeller| currency:'':0}} <small>COP</small></span><tr><td class=total-table-title><span>Impuestos:</span><td class=currency><span>$ {{$ctrl.quoteCartSeller.ivaItemsQuoteValueSeller| currency:'':0}} <small>COP</small></span><tr><td class=total-table-title><span>Transporte:</span><td class=currency><span>$ {{$ctrl.cartTransports| currency:'':0}} <small>COP</small></span><tfoot><tr><td class=total-label>TOTAL A PAGAR:<td class=\"total-precio currency\">$ {{$ctrl.quoteCartSeller.totalItemsQuoteValueSeller| currency:'':0}} <small>COP</small></table><div class=xs-margin></div><table class=\"table total-table\"><tfoot><tr ng-if=$ctrl.shCtrl.globalParams.showTotalKilosCanasta><td class=\"total-label total-table-title\">TOTAL EN KILOS:<td class=\"total-precio currency\">{{ $ctrl.cart.order.totalPesoItems | currency:'':0}}<tr><td class=\"total-label total-table-title\">TOTAL DE UNIDADES:<td class=\"total-precio currency\">{{ $ctrl.cart.order.cantidadTotalCanasta | currency:'':0}}</table><span class=valores-calculados ng-if=\"$ctrl.orderDataForm.clientPriceList === 'client'\">* Los valores han sido calculados en base a la <b>Lista de Precios del Cliente</b>. </span><span class=valores-calculados ng-if=\"$ctrl.orderDataForm.clientPriceList === 'cost'\">* Los valores han sido calculados en base a la <b>Lista de Precios de Costo</b>.</span></div></div><div class=md-margin></div><div class=row><div class=loader-general ng-show=$ctrl.savingOrderCart style=\"float: right;padding-right: 30px\"><img src=" + __webpack_require__(2) + "> <span>Actualizando el carrito...</span></div><div class=col-sm-12 ng-show=!$ctrl.savingOrderCart><div class=\"pull-left btns-bot-canasta\"><button type=button ng-disabled=\"!$ctrl.orderForm.$valid || $ctrl.cartData.loadingCartInfo\" ng-show=$ctrl.ngAuthSettings.site.config.data.cart.showPdfButton class=\"btn btn-custom-4\"><span class=\"fa fa-file-pdf-o\"></span> Ver PDF</button> <button type=button ng-disabled=$ctrl.cartData.loadingCartInfo ng-if=\"$ctrl.shCtrl.globals.currentUser.userId && $ctrl.cart.items.length\" class=\"btn btn-info\" ng-click=$ctrl.createTemplate()><span class=\"glyphicon glyphicon-list\"></span> Crear Plantilla</button> <button type=button class=\"btn btn-warning\" ui-sref=home.category ng-disabled=$ctrl.cartData.loadingCartInfo><span class=\"glyphicon glyphicon-list\"></span> Ver más Productos</button> <a id=clearCartBtn ng-show=\"!$ctrl.shCtrl.globals.currentUser.isSeller && $ctrl.cart.order.totalItemsToQuote !== $ctrl.cart.items.length\" class=\"btn btn-danger\" ng-disabled=$ctrl.cartData.loadingCartInfo ng-click=$ctrl.clearCart()><span class=\"glyphicon glyphicon-trash\"></span> Descartar Pedido </a><a id=clearCartBtn ng-show=\"!$ctrl.shCtrl.globals.currentUser.isSeller && $ctrl.cart.order.totalItemsToQuote === $ctrl.cart.items.length\" class=\"btn btn-danger\" ng-click=$ctrl.clearCart()><span class=\"glyphicon glyphicon-trash\"></span> Descartar Cotización </a><a id=clearCartBtn ng-show=$ctrl.shCtrl.globals.currentUser.isSeller class=\"btn btn-danger\" ng-click=$ctrl.clearCart()><span class=\"glyphicon glyphicon-trash\"></span> Descartar</a></div><div id=content-bot-canasta class=pull-right><input type=button ng-disabled=$ctrl.cartData.loadingCartInfo ng-if=\"!$ctrl.shCtrl.globals.currentUser.isLogged && $ctrl.cart.order.totalItemsToQuote !== $ctrl.cart.items.length\" class=\"btn btn-custom-4\" data-toggle=tooltip title=\"Haz clic aquí para hacer tu pedido sin registrarte.\" ng-click=\"$ctrl.buyNow($ctrl.orderForm, 1)\" value=\"Comprar como Invitado\"> <input type=button ng-disabled=$ctrl.cartData.loadingCartInfo ng-if=\"!$ctrl.shCtrl.globals.currentUser.isLogged && $ctrl.cart.order.totalItemsToQuote !== $ctrl.cart.items.length\" style=margin-right:5px class=\"btn btn-custom-4\" data-toggle=tooltip title=\"Haz clic aquí para loguearte.\" ng-click=\"$ctrl.buyNow($ctrl.orderForm, 'register')\" value=\"Comprar como cliente registrado\"> <input type=submit ng-show=\"$ctrl.shCtrl.globals.currentUser.isLogged && !$ctrl.shCtrl.globals.currentUser.isSeller && $ctrl.cart.order.totalItemsToQuote !== $ctrl.cart.items.length\" ng-disabled=$ctrl.cartData.loadingCartInfo class=\"btn btn-custom-4\" value={{$ctrl.ngAuthSettings.site.config.data.cart.cartBuyText}}> <input type=submit ng-show=\"$ctrl.shCtrl.globals.currentUser.isLogged && !$ctrl.shCtrl.globals.currentUser.isSeller && $ctrl.cart.order.totalItemsToQuote === $ctrl.cart.items.length\" ng-disabled=$ctrl.cartData.loadingCartInfo class=\"btn btn-custom-4\" value=\"Cotizar Ahora\"><div class=col-md-12><div class=row ng-if=$ctrl.shCtrl.globals.currentUser.isSeller><div class=\"form-group col-md-9\"><div class=row><select class=form-control ng-model=$ctrl.orderDataForm.quoteCartSellerAction><option value=\"\">- Seleccione la acción a realizar -<option value=order>Enviar todo como pedido<option value=quote>Enviar todo como una solicitud de cotización</select></div></div><div class=\"form-group col-md-3\"><div class=\"row pull-right\"><button type=button ng-disabled=!$ctrl.orderDataForm.quoteCartSellerAction class=\"btn btn-success\" ng-click=$ctrl.setCartSellerAction($ctrl.orderForm)>Enviar</button></div></div></div><div class=row ng-if=\"!$ctrl.shCtrl.globals.currentUser.isLogged && $ctrl.cart.order.totalItemsToQuote === $ctrl.cart.items.length\"><div class=\"form-group col-md-9\"></div><div class=\"form-group col-md-3\"><div class=\"row pull-right\"><button ng-init=\"$ctrl.orderDataForm.quoteCartSellerAction = 'quote'\" ng-disabled=!$ctrl.orderDataForm.quoteCartSellerAction class=\"btn btn-custom-4\" ng-click=$ctrl.setCartSellerAction($ctrl.orderForm)>Cotizar Ahora</button></div></div></div></div></div></div></div><div class=md-margin></div><div class=row><div id=content-footer-canasta class=\"pull-left col-md-8 col-sm-12 col-xs-12\"><div ng-if=$ctrl.shCtrl.globals.currentClient.id><h4 ng-show=$ctrl.shCtrl.globals.currentClient.contact.name>Hola {{$ctrl.shCtrl.globals.currentClient.contact.name}},</h4><h4 ng-show=!$ctrl.shCtrl.globals.currentClient.contact.name>Hola,</h4></div><div ng-if=!$ctrl.shCtrl.globals.currentClient.id><h4 ng-show=$ctrl.shCtrl.globals.currentUser.fullname>Hola {{$ctrl.shCtrl.globals.currentUser.fullname}},</h4><h4 ng-show=!$ctrl.shCtrl.globals.currentUser.fullname>Hola,</h4></div><p><div ng-bind-html=\"$ctrl.shCtrl.globalParams.cmsInfo.CANASTA_INFO_INFERIOR | toTrusted\"></div></div></div><div class=md-margin></div></form></div><inner-banners></inner-banners></div></div>";

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"modal-content salir-aplication\"><div class=modal-header><h5 class=modal-title><span>Crear plantilla canasta</span></h5></div><div class=modal-body><div class=\"product-add clearfix\"><div><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\">Desea crear una plantilla con los productos de la canasta actual?</div><div style=margin-top:10px class=\"col-md-12 col-sm-12 col-xs-12\"><input class=form-control ng-model=mdCtrl.cartTemplate.name placeholder=\"Ingrese el nombre de la plantilla. Ej. Plantilla de Compra General\" autocomplete=off ng-disabled=mdCtrl.cartTemplate.loading></div></div><div class=row><div class=\"alert alert-success\" ng-show=\"mdCtrl.cartTemplate.response.message && !mdCtrl.cartTemplate.response.error\" style=\"margin-top: 15px;margin-left: 15px;margin-right: 15px;margin-bottom: 15px\">{{mdCtrl.cartTemplate.response.message}}</div><div class=\"alert alert-danger\" ng-show=mdCtrl.cartTemplate.response.error style=\"margin-top: 15px;margin-left: 15px;margin-right: 15px;margin-bottom: 0px\">{{mdCtrl.cartTemplate.response.message}}<ul class=error-list><li ng-repeat=\"error in mdCtrl.cartTemplate.response.errorsMessages\">{{error}}</ul></div><div class=row><div class=loader-general ng-show=mdCtrl.cartTemplate.loading style=\"text-align:center; margin-top: 15px\"><img src=" + __webpack_require__(2) + "> <span>Creando plantilla de la canasta...</span></div></div><div class=\"col-md-12 col-sm-12 col-xs-12 text-right\" ng-show=\"!mdCtrl.cartTemplate.loading &&\r\n                                         !(mdCtrl.cartTemplate.response.message && !mdCtrl.cartTemplate.response.error)\"><div class=sm-margin></div><button type=button class=\"btn btn-custom-4\" ng-click=mdCtrl.createCartTemplate() ng-disabled=!mdCtrl.cartTemplate.name>Crear Plantilla</button> &nbsp; <button id=btn-cancelar-crear-plantilla-canasta ng-click=mdCtrl.cancel() class=\"btn btn-default btn\">Cancelar</button></div><div class=\"col-md-12 col-sm-12 col-xs-12 text-right\" ng-show=\"mdCtrl.cartTemplate.response.message && !mdCtrl.cartTemplate.response.error\"><button id=btn-cerrar-2-eliminar-producto-canasta class=\"btn btn-default btn\" ng-click=mdCtrl.clearCreateTemplateForm()>Cerrar</button></div></div></div></div></div></div>";

/***/ },
/* 447 */
/***/ function(module, exports) {

	module.exports = "<div class=\"modal-content salir-aplication\"><div class=modal-header><h5 class=modal-title><span>Comentarios del pedido</span></h5></div><div class=modal-body><div class=\"product-add clearfix\"><div class=\"row content-modal-margin\"><div class=\"col-md-12 col-sm-12 col-xs-12\"><label>En el siguiente recuadro puedes ingresar un comentario abierto para tu pedido: (Máximo {{mdCtrl.maxlengthComment}} caracteres)</label><div class=sm-margin></div><textarea id=textarea-order-comment class=form-control style=\"height: 100px\" ng-model=mdCtrl.comment maxlength={{mdCtrl.maxlengthComment}}></textarea><div class=text-right style=margin-top:5px;color#666;font-size:12px>{{mdCtrl.comment.length}} caracteres</div></div><div class=\"col-md-12 col-sm-12 col-xs-12\" ng-show=mdCtrl.errorAddedCommentCart><div class=\"alert alert-danger\" style=\"margin-top: 11px\">Ha ocurrido un error al guardar el comentario. Inténtalo de nuevo.</div></div><div class=\"col-md-12 col-sm-12 col-xs-12\" ng-if=mdCtrl.addedCommentCart><div class=\"alert alert-success\" style=\"margin-top: 11px\">El comentario ha sido guardado exitosamente</div></div><div class=\"col-md-12 col-sm-12 col-xs-12\" ng-if=mdCtrl.addingCommentCart style=\"text-align: right;margin-top: 17px\"><i class=\"fa fa-history load-animation\"></i> Guardando comentario...</div></div><div class=\"row btn-actions\"><div class=\"col-xs-12 text-right\"><button type=button ng-click=mdCtrl.cancel() class=\"btn btn-danger\"><strong>Cancelar</strong></button> <button type=button ng-click=mdCtrl.saveOrderComment() class=\"btn btn-custom-4\"><strong>Guardar</strong></button></div></div></div></div></div><style>.angular-google-map-container { height: 400px; }\r\n  .text-right {\r\n    text-align: right;\r\n  }</style>";

/***/ },
/* 448 */
/***/ function(module, exports) {

	module.exports = "<div class=modal-content><div class=modal-header><button type=button class=close aria-hidden=true ng-click=mdCtrl.cancel()>×</button><h4 class=modal-title id=mySmallModalLabel>Contacto del pedido</h4></div><div class=modal-body><form name=mdCtrl.guestUserForm class=selectThirdForm><div class=form-group><input name=contactoNombre id=contactoNombre ng-model=mdCtrl.user.contactoNombre required placeholder=\"Nombre del contacto\" maxlength=50 class=form-control> <span class=input-help><span ng-if=\"mdCtrl.guestUserForm.contactoNombre.$invalid && !mdCtrl.guestUserForm.contactoNombre.$pristine\" class=help-block>Ingrese el nombre del contacto</span></span></div><div class=form-group><input type=email name=contactoEmail id=contactoEmail ng-model=mdCtrl.user.contactoEmail required maxlength=50 placeholder=\"Email del contacto\" class=form-control> <span class=input-help><span ng-if=\"mdCtrl.guestUserForm.contactoEmail.$invalid && !mdCtrl.guestUserForm.contactoEmail.$pristine\" class=help-block>Ingrese el email del contacto</span></span></div><div class=form-group><input name=contactoTelefono id=contactoTelefono ng-model=mdCtrl.user.contactoTelefono restrict-type=num required maxlength=10 placeholder=\"Teléfono del contacto\" class=form-control> <span class=input-help><span ng-if=\"mdCtrl.guestUserForm.contactoTelefono.$invalid && !mdCtrl.guestUserForm.contactoTelefono.$pristine\" class=help-block>Ingrese el teléfono del contacto</span></span></div><div class=form-group><input name=contactoDireccion id=contactoDireccion ng-model=mdCtrl.user.contactoDireccion required placeholder=\"Dirección del contacto\" class=form-control> <span class=input-help><span ng-if=\"mdCtrl.guestUserForm.contactoDireccion.$invalid && !mdCtrl.guestUserForm.contactoDireccion.$pristine\" class=help-block>Ingrese la dirección del contacto</span></span></div><div class=form-group><input name=contactoNombreCiudad id=contactoNombreCiudad ng-model=mdCtrl.user.contactoNombreCiudad required placeholder=\"Ciudad del contacto\" class=form-control> <span class=input-help><span ng-if=\"mdCtrl.guestUserForm.contactoNombreCiudad.$invalid && !mdCtrl.guestUserForm.contactoNombreCiudad.$pristine\" class=help-block>Ingrese la ciudad del contacto</span></span></div></form></div><div class=modal-footer><button type=button class=\"btn btn-default\" ng-click=mdCtrl.cancel()>Cancelar</button> <button type=button class=\"btn btn-success\" ng-click=mdCtrl.selectThird()>Aceptar</button></div></div><style>.selectThirdForm auto-complete{\r\n        width : 79%;\r\n        display : inline-block;\r\n    }\r\n    .selectThirdForm .btn-invited{\r\n        width : 17%;\r\n        vertical-align: top;\r\n        margin: 0 2px;\r\n        display : inline-block;\r\n    }</style>";

/***/ },
/* 449 */
/***/ function(module, exports) {

	module.exports = "<div class=\"modal-content salir-aplication\"><div class=modal-header><h5 class=modal-title><span>Comentario del producto</span></h5></div><div class=modal-body><div class=\"product-add clearfix\"><div class=\"row content-modal-body\"><div class=\"col-md-12 col-sm-12 col-xs-12\"><label>Ingrese su anotación a la orden de pedido en el campo a continuación: (Máximo {{mdCtrl.maxlengthComment}} caracteres)</label><div class=sm-margin></div><textarea id=textarea-order-comment class=form-control style=\"height: 100px\" ng-model=mdCtrl.comment maxlength={{mdCtrl.maxlengthComment}}></textarea><div class=text-right style=margin-top:5px;color#666;font-size:12px>{{mdCtrl.maxlengthComment - mdCtrl.orderDataForm.comment.length}} caracteres</div></div><div class=\"col-md-12 col-sm-12 col-xs-12\" ng-show=mdCtrl.errorAddedCommentCart><div class=\"alert alert-danger\" style=\"margin-top: 11px\">Ha ocurrido un error al guardar el comentario. Inténtalo de nuevo.</div></div><div class=\"col-md-12 col-sm-12 col-xs-12\" ng-if=mdCtrl.addedCommentCart><div class=\"alert alert-success\" style=\"margin-top: 11px\">El comentario ha sido guardado exitosamente</div></div><div class=\"col-md-12 col-sm-12 col-xs-12\" ng-if=mdCtrl.addingCommentCart style=\"text-align: right;margin-top: 17px\"><i class=\"fa fa-history load-animation\"></i> Guardando comentario...</div></div><div class=\"row btn-actions\"><div class=\"col-xs-12 text-right\"><button type=button ng-click=mdCtrl.cancel() class=\"btn btn-danger\"><strong>Cancelar</strong></button> <button type=button ng-click=mdCtrl.ok() class=\"btn btn-info\"><strong>Aceptar</strong></button></div></div></div></div></div><style>.angular-google-map-container { height: 400px; }\r\n  .text-right {\r\n    text-align: right;\r\n  }</style>";

/***/ },
/* 450 */
/***/ function(module, exports) {

	module.exports = "<div ng-if=\"$ctrl.ngAuthSettings.site.config.data.categories.menuType === 1\"><categories-input-filter sh-ctrl=$ctrl.shCtrl></categories-input-filter></div><div ng-show=\"$ctrl.ngAuthSettings.site.config.data.categories.menuType === 2\"><categories-slider-filter sh-ctrl=$ctrl.shCtrl></categories-slider-filter></div><div ng-if=\"$ctrl.ngAuthSettings.site.config.data.categories.menuType === 3\"><categories-sliding-filter sh-ctrl=$ctrl.shCtrl></categories-sliding-filter></div>";

/***/ },
/* 451 */
/***/ function(module, exports) {

	module.exports = "<div id=categories-input-filter class=hidden-xs><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=input-group><input name=name id=categories-search-text class=form-control placeholder=\"Búsqueda por Categorías\" autocomplete=off ng-model=$ctrl.categoriesSearchText></div></div><div category-multilevel-menu=globalCategoriesMenu filter-text=categoriesSearchText class=menu-multinivel-busqueda-categoria></div></div><div class=\"btn-mostrar-catg visible-xs\"><button type=button class=\"btn btn-default btn-block\" data-toggle=modal data-target=#modal-categoria-productos-slider>Búsqueda por Categorías <i class=\"fa fa-bars respcategory\"></i></button></div>";

/***/ },
/* 452 */
/***/ function(module, exports) {

	module.exports = "<menu-dropdown sh-ctrl=$ctrl.shCtrl></menu-dropdown><style>#category-filter h3 a { color: white !important; }\r\n\r\n  .modal-dialog{\r\n    overflow-y: initial !important\r\n  }\r\n  div#modal-categoria-productos .modal-body {\r\n    padding: 15px 0;\r\n  }\r\n  .modal-footer {\r\n    padding: 10px;\r\n    background-color: #19232D;\r\n  }\r\n  .modal-body .input-group {\r\n    background-color: #DEDEDE;\r\n    padding: 10px;\r\n    width: 100%;\r\n  }\r\n  ul.nav-mobile li a {\r\n    padding: 5px 15px;\r\n    color: #444;\r\n  }\r\n  .nav-subcategoria li a {\r\n    padding: 3px 15px !important;\r\n    color: #222 !important;\r\n  }\r\n  ul.nav.nav-mobile ul.nav.nav-subcategoria li {\r\n    padding: 0 10px;\r\n    font-weight: 300;\r\n  }\r\n  ul.nav.nav-subcategoria li a:before {\r\n    position: relative;\r\n    content: '-';\r\n  }\r\n  i.respcategory {\r\n    font-size: 18px;\r\n    position: relative;\r\n    margin-left: 5px;\r\n    color: #19232D;\r\n  }\r\n  .btn-mostrar-catg {\r\n    padding: 7px;\r\n    margin: 0 0 15px;\r\n    background-color: #E2E2E2;\r\n  }</style>";

/***/ },
/* 453 */
/***/ function(module, exports) {

	module.exports = "<div style=clear:both></div><div class=\"category-toolbar clearfix viewcategories\"><div class=\"col-md-12 viewcategories-paginado\"><div class=row><div class=\"toolbox-filter clearfix\"></div><div class=\"toolbox-pagination clearfix\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><div class=row><div class=view-count-box><span class=separator>Ver:</span><div class=\"btn-group select-dropdown\"><button type=button class=\"btn select-btn\">{{ $ctrl.itemsPerPage }}</button> <button type=button class=\"btn dropdown-toggle\" data-toggle=dropdown><i class=\"fa fa-angle-down\"></i></button><ul class=dropdown-menu role=menu><li><a href=\"\" ng-click=$ctrl.setPagination($ctrl.pagerCategories.length);>Todos ({{$ctrl.pagerCategories.length}})</a><li><a href=\"\" ng-click=$ctrl.setPagination(12);>12</a><li><a href=\"\" ng-click=$ctrl.setPagination(24);>24</a><li><a href=\"\" ng-click=$ctrl.setPagination(40);>40</a></ul></div></div></div></div><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=row><ul class=pagination><li><a href=\"\" ng-click=$ctrl.pagination.prevPage()>&laquo;</a><li ng-repeat=\"n in [] | range: $ctrl.pagination.numPages\" ng-class=\"{active: n == $ctrl.pagination.page}\"><a href=\"\" ng-click=$ctrl.pagination.toPageId(n)>{{n + 1}}</a><li><a href=\"\" ng-click=$ctrl.pagination.nextPage()>&raquo;</a></ul></div></div></div></div></div><div class=\"col-md-12 viewcategories-resumen\"><div class=row><div class=\"filter-resume listcategoria\">Mostrando {{$ctrl.pagination.page * $ctrl.itemsPerPage + 1}} - <span ng-show=\"$ctrl.pagination.page * $ctrl.itemsPerPage + $ctrl.itemsPerPage < $ctrl.pagerCategories.length\">{{$ctrl.pagination.page * $ctrl.itemsPerPage + $ctrl.itemsPerPage}} </span><span ng-show=\"$ctrl.pagination.page * $ctrl.itemsPerPage + $ctrl.itemsPerPage >= $ctrl.pagerCategories.length\">{{$ctrl.pagerCategories.length}} </span>de {{$ctrl.pagerCategories.length}} categorías</div></div></div></div><div style=clear:both></div>";

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div><div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-3 col-sm-4 col-xs-12\"></div><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a href={{$ctrl.shCtrl.ngAuthSettings.site.app.header.logo.url}}><i class=\"fa fa-home\"></i></a><li><a ui-sref=home.category>Nuestros productos</a><li ng-repeat=\"breadcrumbItem in $ctrl.currentCategory.breadcrumb | limitTo:$ctrl.currentCategory.breadcrumb.length-1\" ng-show=$ctrl.currentCategory.title><a href={{breadcrumbItem.url}} target={{breadcrumbItem.target}} title={{breadcrumbItem.title}}>{{breadcrumbItem.name}}</a><li class=active ng-show=::$ctrl.currentCategory.title><span>{{::$ctrl.currentCategory.title}}</span></ul></div></div></div></div><div class=container><div class=row><div class=col-md-12><div class=row><aside class=\"col-md-3 col-sm-4 col-xs-12 sidebar\"><div id=btn-movil-cat class=container><div class=row><categories-filter sh-ctrl=$ctrl.shCtrl></categories-filter></div></div><input id=aside-ctrl type=checkbox class=\"sr-only visible-xs\"><label for=aside-ctrl class=\"aside-ctrl--reset visible-xs\"></label><div id=aside><div class=filtro-productos-responsive ng-show=\"$ctrl.categoryAttributes.length || $ctrl.shCtrl.ngAuthSettings.site.config.data.item.showItemsPriceFilter\"><div class=content-filtros><h4 ng-show=\"($ctrl.shCtrl.globalParams.showPriceFilter || $ctrl.categoryAttributes.length)\">Filtrar por: <span class=\"btn btn-default btn-sm glyphicon glyphicon-repeat pull-right reload-filter\" ng-click=$ctrl.cleanFilters()></span></h4><div id=filter-wrapper><price-filter ng-show=$ctrl.shCtrl.globalParams.showPriceFilter></price-filter><dynamic-filters></dynamic-filters><div style=margin-top:6px class=\"col-xs-5 col-xs-push-7\"><div class=row><label class=\"btn btn-xs btn-custom-4 visible-xs\" for=aside-ctrl>Aplicar</label></div></div><div class=clearfix></div></div></div><label for=aside-ctrl class=\"aside-ctrl--label visible-xs\"></label></div></div></aside><div class=\"col-md-9 col-sm-8 col-xs-12 main-content\"><div id=category-header class=category-banner><img src=" + __webpack_require__(71) + " alt=\"Banner Categoria\" class=\"img-responsive img-bg-category-header\"> <img src={{::$ctrl.currentCategory.image}} ng-show=::$ctrl.currentCategory.image class=imagen-categoria><div class=category-title ng-show=!$ctrl.currentCategory.title><h2>Nuestros Productos</h2><p ng-show=$ctrl.shCtrl.ngAuthSettings.site.config.data.categories.textOurProducts>{{$ctrl.shCtrl.ngAuthSettings.site.config.data.categories.textOurProducts}}</div><div class=category-title ng-show=$ctrl.currentCategory.title><h2>{{::$ctrl.currentCategory.title}}</h2><p>{{::$ctrl.currentCategory.description | limitTo: 150}} <span ng-show=\"::$ctrl.currentCategory.description.length > 150\">...</span></div></div><div ng-show=\"$ctrl.loadingItemsBatch && $ctrl.totalItemsToLoad > 100\" class=\"alert alert-success\" style=\"padding: 5px\">{{$ctrl.textLoadingItemsBatch}} <i class=\"fa fa-history load-animation\"></i></div><div ng-show=\"$ctrl.isProductSearch && $ctrl.loadingProducts\" class=\"alert alert-success\" style=\"padding: 5px\">Realizando la búsqueda de los productos <b>'{{$ctrl.productSearchText}}'</b> <i class=\"fa fa-history load-animation\"></i></div><div ng-show=$ctrl.loadingProducts class=\"alert alert-success\" style=\"padding: 5px\">Cargando productos... <i class=\"fa fa-history load-animation\"></i></div><div class=\"col-xs-12 modulo_opciones_productos\"><div class=row><div class=\"col-md-3 col-sm-6 col-xs-6 buscador-pp\"><div class=row><input class=boton-busqueda-productos ng-model=$ctrl.searchText ng-blur=$ctrl.getProducts() ng-enter=$ctrl.getProducts() ng-change=$ctrl.changeInternalWordSearch() placeholder=\"Filtrar en este listado\" style=\"padding: 3px 10px;width: 90%\"></div></div><div class=\"col-md-3 col-sm-6 col-xs-6 vistas-pp\"><div class=row><ul><li class=btn-listado ng-class=\"{'activated': $ctrl.typeview === 0}\"><a ng-click=$ctrl.setCookieItemsView(0)></a><li class=btn-vista1 ng-class=\"{'activated': $ctrl.typeview === 1}\" ng-click=$ctrl.setCookieItemsView(1)><a href=\"\"></a><li class=btn-vista2 ng-class=\"{'activated': $ctrl.typeview === 2}\" ng-click=$ctrl.setCookieItemsView(2)><a href=\"\"></a><li class=btn-vista3 ng-class=\"{'activated': $ctrl.typeview === 3}\" ng-click=$ctrl.setCookieItemsView(3)><a href=\"\"></a><li class=btn-vista4 ng-class=\"{'activated': $ctrl.typeview === 4}\" ng-click=$ctrl.setCookieItemsView(4)><a href=\"\"></a></ul></div></div><div class=\"col-md-6 col-sm-6 col-xs-12 paginador-pp hidden-sm hidden-xs\"><div class=\"row row-pagination-control\"><ul uib-pagination total-items=$ctrl.totalItems ng-change=$ctrl.getProducts() ng-model=$ctrl.currentPage previous-text=&lsaquo; next-text=&rsaquo; first-text=&laquo; last-text=&raquo; max-size=4 items-per-page=$ctrl.pageSize class=pagination-sm boundary-link-numbers=true num-pages=$ctrl.totalPages></ul></div></div></div><div class=row><hr class=\"separador-pp xs-hidden\"></div><div class=row><div class=\"col-md-4 col-sm-6 col-xs-12 ver-pp hidden-xs hidden-sm\"><div class=row><div class=view-count-box><span class=separator>ver:</span><div class=\"btn-group select-dropdown\"><button type=button class=\"btn select-btn\">{{$ctrl.pageSize}}</button> <button type=button class=\"btn dropdown-toggle\" data-toggle=dropdown><i class=\"fa fa-angle-down\"></i></button><ul class=dropdown-menu role=menu ng-show=\"$ctrl.totalItems >= 24\"><li><a href=\"\" ng-show=\"$ctrl.totalItems >= 24\" ng-click=$ctrl.setPagination(24);>24</a><li><a href=\"\" ng-show=\"$ctrl.totalItems >= 48\" ng-click=$ctrl.setPagination(48);>48</a><li><a href=\"\" ng-show=\"$ctrl.totalItems >= 84\" ng-click=$ctrl.setPagination(84);>84</a></ul></div></div></div></div><div class=\"col-md-4 col-sm-6 col-xs-6 ordenar-pp\"><div class=row><div class=sort-box><span class=separator>ordenar:</span><div class=\"btn-group select-dropdown\"><button type=button class=\"btn select-btn\"><label><span ng-switch=$ctrl.sortType><span ng-switch-when=1>Posición Inicial</span> <span ng-switch-when=2>Productos (A-Z)</span> <span ng-switch-when=3>Productos (Z-A)</span> <span ng-switch-when=4>Precio (ascendente)</span> <span ng-switch-when=5>Precio (descendente)</span></span></label></button> <button type=button class=\"btn dropdown-toggle\" data-toggle=dropdown><i class=\"fa fa-angle-down\"></i></button><ul class=dropdown-menu role=menu><li><a href=\"\" ng-click=$ctrl.setSort(1)>Orden Inicial</a><li><a href=\"\" ng-click=$ctrl.setSort(2)>Productos (A-Z)</a><li><a href=\"\" ng-click=$ctrl.setSort(3)>Productos (Z-A)</a><li><a href=\"\" ng-click=$ctrl.setSort(4)>Precio (ascendente)</a><li><a href=\"\" ng-click=$ctrl.setSort(5)>Precio (descendente)</a></ul></div></div></div></div><div class=\"col-md-4 col-sm-6 col-xs-6 resumen-pp\"><div class=row><div class=\"filter-resume pull-right\">{{($ctrl.currentPage - 1) *$ctrl.pageSize + 1}} - <span ng-show=\"($ctrl.currentPage - 1) * $ctrl.pageSize + $ctrl.pageSize < $ctrl.totalItems\">{{($ctrl.currentPage - 1) *$ctrl.pageSize + $ctrl.pageSize}} </span><span ng-show=\"($ctrl.currentPage - 1) * $ctrl.pageSize + $ctrl.pageSize >= $ctrl.totalItems\">{{$ctrl.totalItems}} </span>de {{$ctrl.totalItems}} productos</div></div></div></div></div><div class=clear></div><div><div ng-show=!$ctrl.loadingProducts style=\"margin-top: 30px\"><div ng-if=\"!$ctrl.productsList.length && $ctrl.controlPrice\" class=\"alert alert-warning\">No hay productos que coincidan con las características seleccionadas.</div></div><products-list sh-ctrl=$ctrl.shCtrl ng-show=\"$ctrl.productsList.length > 0\" category-slug=$ctrl.categorySlug category-id=$ctrl.categoryId typeview=$ctrl.typeview products-list=$ctrl.productsList></products-list><div class=clear></div><div class=\"category-toolbar bottom clearfix\" ng-show=\"$ctrl.productsList.length > 0\"><div class=\"clear hidden-lg hidden-md\"></div></div></div><div class=clear></div><div class=\"col-xs-12 modulo_opciones_productos\" ng-show=\"$ctrl.productsList.length > 0\"><div class=row><div class=\"col-md-4 col-sm-6 col-xs-12 ver-pp hidden-xs hidden-sm\"><div class=row><div class=view-count-box><span class=separator>ver:</span><div class=\"btn-group select-dropdown\"><button type=button class=\"btn select-btn\">{{$ctrl.pageSize}}</button> <button type=button class=\"btn dropdown-toggle\" data-toggle=dropdown><i class=\"fa fa-angle-down\"></i></button><ul class=dropdown-menu role=menu ng-show=\"$ctrl.totalItems >= 24\"><li><a href=\"\" ng-show=\"$ctrl.totalItems >= 24\" ng-click=\"$ctrl.setPagination(24, true);\">24</a><li><a href=\"\" ng-show=\"$ctrl.totalItems >= 48\" ng-click=\"$ctrl.setPagination(48, true);\">48</a><li><a href=\"\" ng-show=\"$ctrl.totalItems >= 84\" ng-click=\"$ctrl.setPagination(84, true);\">84</a></ul></div></div></div></div><div class=\"col-md-4 col-sm-6 col-xs-6 ordenar-pp\"><div class=row><div class=sort-box><span class=separator>ordenar:</span><div class=\"btn-group select-dropdown\"><button type=button class=\"btn select-btn\"><label style=\"position: relative;top: -4px\"><span ng-switch=$ctrl.sortType><span ng-switch-when=1>Posición</span> <span ng-switch-when=2>Productos (A-Z)</span> <span ng-switch-when=3>Productos (Z-A)</span> <span ng-switch-when=4>Precio (ascendente)</span> <span ng-switch-when=5>Precio (descendente)</span></span></label></button> <button type=button class=\"btn dropdown-toggle\" data-toggle=dropdown><i class=\"fa fa-angle-down\"></i></button><ul class=dropdown-menu role=menu style=\"bottom: 100%; top: initial\"><li><a href=# ng-click=\"$ctrl.setSort(1, true)\">Orden Inicial</a><li><a href=# ng-click=\"$ctrl.setSort(2, true)\">Productos (A-Z)</a><li><a href=# ng-click=\"$ctrl.setSort(3, true)\">Productos (Z-A)</a><li><a href=# ng-click=\"$ctrl.setSort(4, true)\">Precio (ascendente)</a><li><a href=# ng-click=\"$ctrl.setSort(5, true)\">Precio (descendente)</a></ul></div></div></div></div><div class=\"col-md-4 col-sm-6 col-xs-12 paginador-pp hidden-sm hidden-xs\"><div class=\"row row-pagination-control\"><ul uib-pagination total-items=$ctrl.totalItems ng-change=$ctrl.getProducts(true); ng-model=$ctrl.currentPage previous-text=&lsaquo; next-text=&rsaquo; first-text=&laquo; last-text=&raquo; max-size=4 class=pagination-sm items-per-page=$ctrl.pageSize boundary-link-numbers=true num-pages=$ctrl.totalPages></ul></div></div></div></div></div></div></div></div></div></div>";

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div><div><div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-3 col-sm-4 col-xs-12\"></div><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{$ctrl.shCtrl.ngAuthSettings.site.app.header.logo.url}}><i class=\"fa fa-home\"></i></a><li><a ui-sref=home.category>Nuestros productos</a><li ng-repeat=\"breadcrumbItem in $ctrl.currentCategory.breadcrumb | limitTo:$ctrl.currentCategory.breadcrumb.length-1\" ng-show=$ctrl.currentCategory.title><a href={{breadcrumbItem.url}} target={{breadcrumbItem.target}} title={{breadcrumbItem.title}}>{{breadcrumbItem.name}}</a><li class=active ng-show=$ctrl.currentCategory.title><span>{{$ctrl.currentCategory.title}}</span></ul></div></div></div></div></div><div class=container><div class=row><div class=col-md-12><div class=row><aside class=\"col-md-3 col-sm-4 col-xs-12 sidebar\"><categories-filter sh-ctrl=$ctrl.shCtrl></categories-filter><side-banners sh-ctrl=$ctrl.shCtrl></side-banners></aside><div class=\"col-md-9 col-sm-8 col-xs-12 main-content\"><div id=category-header class=category-banner><img src=" + __webpack_require__(71) + " alt=\"Banner Categoria\" class=\"img-responsive img-bg-category-header\"> <img ng-src=\"{{$ctrl.shCtrl.ngAuthSettings.config.env.basePath + $ctrl.currentCategory.image}}\" ng-show=$ctrl.currentCategory.image class=imagen-categoria><div class=category-title ng-show=!$ctrl.currentCategory.title><h2>Nuestros Productos</h2><p ng-show=$ctrl.shCtrl.ngAuthSettings.site.config.data.categories.textOurProducts>{{$ctrl.shCtrl.ngAuthSettings.site.config.data.categories.textOurProducts}}</div><div class=category-title ng-show=$ctrl.currentCategory.title><h2>{{$ctrl.currentCategory.title}}</h2><p>{{$ctrl.currentCategory.description | limitTo: 150}} <span ng-show=\"$ctrl.currentCategory.description.length > 150\">...</span></div></div><div class=toolbox-pagination-header><category-pager-toolbox ng-if=\"$ctrl.pagerCategories.length > 0\"></category-pager-toolbox></div><div class=loader-general ng-show=$ctrl.loadingCategories><img src=" + __webpack_require__(2) + "> <span>Cargando categorías</span></div><div class=\"category-item-container lista-categorias\"><div class=\"alert alert-info\"><ul><li><strong>Categorías:</strong> {{$ctrl.pagerCategories.length}}<li><strong>Categorías por página:</strong> {{$ctrl.itemsPerPage}}</ul></div><div ng-repeat=\"item in $ctrl.pagerCategories | startFrom: $ctrl.pagination.page * $ctrl.pagination.perPage | limitTo: $ctrl.pagination.perPage\"><div class=\"col-md-4 col-sm-6 col-xs-12\"><div class=\"item item-hover\"><div class=item-image-wrapper><figure><div><a ng-if=item.url_destino href={{item.url_destino}} target=\"{{item.url_destino ? '_blank' : '_self'}}\" title={{item.title}}>{{$ctrl.ngAuthSettings.config.env.basePath}} <img ng-if=item.imagen ng-src=\"{{$ctrl.shCtrl.ngAuthSettings.config.env.basePath + item.imagen}}\" alt=item1> <img ng-if=!item.imagen ng-src=\"{{$ctrl.shCtrl.ngAuthSettings.config.env.basePath + item.imagen}}\" alt=item1> </a><a ng-if=\"!item.url_destino && item.hijas.length\" ui-sref=\"home.categorySlug({categorySlug : item.slug})\" target=\"{{item.url_destino ? '_blank' : '_self'}}\" title={{item.title}}>{{$ctrl.ngAuthSettings.config.env.basePath}} <img ng-if=item.imagen ng-src=\"{{$ctrl.shCtrl.ngAuthSettings.config.env.basePath + item.imagen}}\" alt=item1> <img ng-if=!item.imagen ng-src=\"{{$ctrl.shCtrl.ngAuthSettings.config.env.basePath + item.imagen}}\" alt=item1> </a><a ng-if=\"!item.url_destino && !item.hijas.length\" ui-sref=\"home.categorySlugProducts({categorySlug : item.slug})\" target=\"{{item.url_destino ? '_blank' : '_self'}}\" title={{item.title}}>{{$ctrl.ngAuthSettings.config.env.basePath}} <img ng-if=item.imagen ng-src=\"{{$ctrl.shCtrl.ngAuthSettings.config.env.basePath + item.imagen}}\" alt=item1> <img ng-if=!item.imagen ng-src=\"{{$ctrl.shCtrl.ngAuthSettings.config.env.basePath + item.imagen}}\" alt=item1></a></div></figure></div><div class=item-meta-container><h3 class=\"item-name category-name\"><a ng-if=item.url_destino href={{item.url_destino}} target=\"{{item.url_destino ? '_blank' : '_self'}}\" title={{item.title}}>{{ item.nombre | limitTo: 30}} <span ng-show=\"item.nombre.length > 30\">...</span> </a><a ng-if=\"!item.url_destino && item.hijas.length\" ui-sref=\"home.categorySlug({categorySlug : item.slug})\" target=\"{{item.url_destino ? '_blank' : '_self'}}\" title={{item.title}}>{{ item.nombre | limitTo: 30}} <span ng-show=\"item.nombre.length > 30\">...</span> </a><a ng-if=\"!item.url_destino && !item.hijas.length\" ui-sref=\"home.categorySlugProducts({categorySlug : item.slug})\" target=\"{{item.url_destino ? '_blank' : '_self'}}\" title={{item.title}}>{{ item.nombre | limitTo: 30}} <span ng-show=\"item.nombre.length > 30\">...</span></a></h3><div class=description-container>{{ item.descripcion | limitTo: 70}} <span ng-show=\"item.descripcion.length > 70\">...</span></div><div class=clear>&nbsp;</div><div class=item-action><a ng-if=\"!item.url_destino && item.hijas.length\" ui-sref=\"home.categorySlug({categorySlug : item.slug})\" target=\"{{item.url_destino ? '_blank' : '_self'}}\" title={{item.title}} class=item-add-btn><span class=icon-cart-text>Ver</span> </a><a ng-if=\"!item.url_destino && item.hijas.length\" ui-sref=\"home.categorySlug({categorySlug : item.slug})\" target=\"{{item.url_destino ? '_blank' : '_self'}}\" title={{item.title}} class=item-add-btn><span class=icon-cart-text>Ver</span> </a><a ng-if=\"!item.url_destino && !item.hijas.length\" ui-sref=\"home.categorySlugProducts({categorySlug : item.slug})\" target=\"{{item.url_destino ? '_blank' : '_self'}}\" title={{item.title}} class=item-add-btn><span class=icon-cart-text>Ver</span></a></div></div></div></div></div></div><div class=toolbox-pagination-footer><category-pager-toolbox ng-if=\"$ctrl.pagerCategories.length > 0\"></category-pager-toolbox></div></div></div></div></div></div></div>";

/***/ },
/* 456 */
/***/ function(module, exports) {

	module.exports = "<div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{$ctrl.shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li class=active><span>Comparar productos</span></ul></div></div></div></div><div class=container><div class=row><div class=col-md-12><div class=row><div class=\"col-md-12 table-responsive\"><div class=\"alert alert-warning alert-dismissable alerta-nohay\" style=\"display: none\"><button aria-hidden=true data-dismiss=alert class=close type=button>×</button> <strong>Nota: </strong>No hay productos para comparar. <a class=alert-link ui-sref={{$ctrl.shCtrl.ngAuthSettings.site.app.header.logo.url}}>Ir al inicio</a>.</div><table class=\"table table-striped compare-item-table\"><tr><td class=table-title>Producto<td ng-repeat=\"productCompare in $ctrl.productsToCompare\" class=product-{{::productCompare.id}}><figure>- <a ui-sref=\"home.productDetailSlug({productSlug : productCompare.slug})\"><img ng-src={{::productCompare.imagesDetail[0].path}}md-{{::productCompare.imagesDetail[0].image}} alt={{::productCompare.name}}></a></figure><p class=item-name><a ui-sref=\"home.productDetailSlug({productSlug : productCompare.slug})\">{{::productCompare.name}}</a><h3 class=item-reference>Ref: {{::productCompare.reference}}</h3><h3 class=item-reference ng-show=productCompare.erpCode>Código: {{::productCompare.erpCode}}</h3><tr><td class=table-title>Precio<td class=product-{{::productCompare.id}} ng-repeat=\"productCompare in $ctrl.productsToCompare\" ng-if=::productCompare.showPrices><span class=item-price ng-show=\"::productCompare.currentPrice !== null\"><span ng-show=!productCompare.visualExcludedIva>$ {{productCompare.currentPrice | currency:'':0}}</span> <span ng-show=productCompare.visualExcludedIva>$ {{productCompare.currentPrice - productCompare.taxValue | currency:'':0}}</span> <span class=sub-price>{{::productCompare.rate}}</span> <i class=\"fa fa-info-circle add-tooltip\" data-toggle=tooltip data-placement=top title={{productCompare.taxText}} data-container=body></i> </span><span class=\"item-price no-disponible\" ng-show=\"::productCompare.currentPrice == null\">Precio no disponible</span><td class=product-{{::productCompare.id}} ng-repeat=\"productCompare in $ctrl.productsToCompare\" ng-if=::!productCompare.showPrices>-<tr style=display:none><td class=table-title>Stock<td ng-repeat=\"productCompare in $ctrl.productsToCompare\" class=product-{{::productCompare.id}}><label ng-show=::productCompare.isSoldOut>Agotado</label><label ng-show=::!productCompare.isSoldOut>Disponible</label><tr style=display:none><td class=table-title>Calificación<td ng-repeat=\"productCompare in $ctrl.productsToCompare\" class=product-{{::productCompare.id}}><div class=ratings-container><div class=ratings><div class=ratings-result data-result={{::productCompare.ratedPercentaje}}></div></div><span class=ratings-amount></span></div><tr><td class=table-title>Descripción<td ng-repeat=\"productCompare in $ctrl.productsToCompare\" class=product-{{::productCompare.id}} ng-bind-html=\"::productCompare.description | toTrusted\">{{::productCompare.description}}<tr class=item-brand-col ng-repeat=\"attributeCategoryToCompare in $ctrl.categoryAttributesToCompare\"><td class=table-title ng-bind-html=\"attributeCategoryToCompare.title | toTrusted\"><td ng-repeat=\"productCompare in $ctrl.productsToCompare\" class=product-{{productCompare.id}}><label ng-repeat=\"attributeProductToCompare in productCompare.attributesDetail\"> <span ng-show=\"(attributeCategoryToCompare.group === attributeProductToCompare.name)\" ng-bind-html=\"attributeProductToCompare.value | join | toTrusted\"></span></label><tr><td class=table-title><td ng-repeat=\"productCompare in $ctrl.productsToCompare\" class=product-{{::productCompare.id}}><a ng-if=::productCompare.showProductAction class=item-add-btn data-target=.precanasta-cantidad ng-click=$ctrl.setItemToAddToCart(productCompare)><span class=icon-cart-text>{{::productCompare.textAction}}</span> </a><a ng-if=::!productCompare.showProductAction class=item-add-btn ui-sref=\"home.productDetailSlug({productSlug : productCompare.slug})\"><span class=icon-cart-text>Más información</span></a><div class=sm-margin></div><a ng-click=$ctrl.delProductToArray(productCompare.id) href=\"\" class=\"close-button del_prod_com\"></a></table><div class=xlg-margin></div></div></div></div></div></div>";

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=bg_gray><div class=container><div class=row><div class=row><div class=col-md-12><div class=\"purchased-items-container carousel-wrapper\"><header class=content-title><h2 class=ng-cloak><span class=pt-5>PRODUCTOS DESTACADOS</span> <span ng-if=\"$ctrl.featuredProducts.length > 0\" class=cantidad-productos-destacados>({{$ctrl.featuredProducts.length}})</span></h2></header><div class=loader-general ng-if=$ctrl.loadingRelatedProducts style=margin-bottom:10px><img src=" + __webpack_require__(2) + "> <span>Cargando productos destacados</span></div><div class=\"carousel-controls margin-top-6\"><div id=purchased-items-slider-prev class=\"carousel-btn carousel-btn-prev\"></div><div id=purchased-items-slider-next class=\"carousel-btn carousel-btn-next carousel-space\"></div></div><div class=\"purchased-items-slider owl-carousel\"><div class=\"item item-product ng-cloak\" ng-repeat=\"product in $ctrl.featuredProducts1\"><div class=item-image-wrapper><figure class=item-image-container ng-show=::product.imagesDetail.length><a ui-sref=\"home.productDetailSlug({productSlug : product.slug})\"><img ng-src={{::product.imagesDetail[0].path}}/md-{{::product.imagesDetail[0].image}} alt=item1 class=item-image> <img ng-if=\"::product.imagesDetail.length === 1\" ng-src={{::product.imagesDetail[0].path}}/md-{{::product.imagesDetail[0].image}} alt=\"item2  Hover\" class=item-image-hover> <img ng-if=\"::product.imagesDetail.length > 1\" ng-src={{::product.imagesDetail[1].path}}/md-{{::product.imagesDetail[1].image}} alt=\"item2  Hover\" class=item-image-hover></a></figure><div class=novedades-del-producto><span class=new-rect ng-show=::product.isNew>Nuevo</span> <span class=\"discount-rect porct\" ng-show=\"::product.discountPercentage > 0\">{{ ::product.discountPercentage | s4bCurrency }} %</span></div></div><div class=item-meta-container><h3 class=item-name style=\"margin: 0\"><a ui-sref=\"home.productDetailSlug({productSlug : product.slug})\">{{::product.name}}</a></h3><h3 class=item-reference style=margin-bottom:0>Ref: {{::product.reference}}</h3><h3 ng-if=product.erpCode class=item-reference>Código: {{::product.erpCode}}</h3><div class=ratings-container><div class=ratings><div class=ratings-result data-result=50></div></div><span class=ratings-amount>{{::product.ratedQuantity}} Calificaciones</span></div></div><div class=description-container style=\"margin-bottom: 10px;margin-top:5px\">{{ ::product.shortDescription | limitTo: 70}} <span ng-show=\"::product.shortDescription.length > 70\">...</span></div><div class=item-price-container ng-show=::product.showPrices style=\"width: 100% !important; text-align: right; line-height: 18px\"><span class=\"item-price wrapper-precio-internet\" ng-show=\"::product.currentPrice !== null\"><span class=precio-internet>{{::$ctrl.ngAuthSettings.site.config.data.item.internetPriceString}} <span ng-show=::product.isTemplate>desde</span>: </span><span data-toggle=tooltip data-placement=top title={{product.taxText}} data-container=body><span ng-show=!product.visualExcludedIva>{{product.currentPrice | currency:'$':0}}</span> <span ng-show=product.visualExcludedIva>{{product.currentPrice - product.taxValue | currency:'$':0}}</span> </span><span class=sub-price>COP</span> <i class=\"fa fa-info-circle add-tooltip\" data-toggle=tooltip data-placement=top title={{product.taxText}} data-container=body></i> </span><span class=\"item-price wrapper-precio-normal\" ng-show=\"::(product.currentPrice !== null && product.itemStorePrice !== null && !product.isTemplate)\"><span class=\"precio-internet rayado\">Precio Normal</span>: <span class=\"precio-normal color-orange\">{{::product.itemStorePrice | currency:'$':0}}</span> <span class=sub-price>COP</span> <i class=\"fa fa-info-circle add-tooltip\" data-toggle=tooltip data-placement=top title={{product.taxText}} data-container=body></i> </span><span class=\"item-price no-disponible\" ng-show=\"::product.currentPrice == null\">Precio no disponible </span><span class=item-price-regular ng-show=\"::(product.currentPrice > 0 && (product.currentPrice !== product.lastPrice) && !product.isTemplate)\"><span class=precio-regular>Precio Oficial:</span> {{::product.lastPrice | currency:'$':0}} <span class=sub-price>COP</span> <i class=\"fa fa-info-circle add-tooltip\" data-toggle=tooltip data-placement=top title={{product.taxText}} data-container=body></i> </span><span ng-show=\"::product.isSoldOut || !product.cantidad\" class=agotado>Producto Agotado</span></div><div class=clear>&nbsp;</div><div class=\"item-action ofertas-icons\"><a ng-show=::product.isTemplate class=\"icon-button-2 add-tooltip ofertas-icons\" data-toggle=tooltip data-placement=top data-container=body title=\"Características variadas\"><i class=\"fa fa-plus-square\"></i> </a><a class=\"icon-button-2 add-tooltip ofertas-icons\" data-toggle=tooltip data-placement=top data-container=body ng-show=::product.isInternetExclusive title=\"Venta sólo por internet\"><i class=\"fa fa-globe\" ng-class=\"::{'icono-opciones-producto-deshabilitado': !product.isInternetExclusive}\"></i> </a><a class=\"icon-button-2 add-tooltip producto-oferta\" data-toggle=tooltip data-placement=top title=\"¡Producto en Oferta!\" style=\"color: #CCC !important\"><i class=\"fa fa-gift\" ng-class=\"{'icono-opciones-producto-deshabilitado': true}\"></i> </a><a class=\"icon-button-2 add-tooltip envio-casa\" data-toggle=tooltip data-placement=top title=\"Recogida en Tienda\" data-container=body style=\"color: #CCC !important\"><i class=\"fa fa-truck\" ng-class=\"{'icono-opciones-producto-deshabilitado': true}\"></i></a></div><div class=item-action><div class=item-action-inner ng-show=::!product.isTemplate><i class=\"fa fa-history load-animation product-is-setting-as-favorite\" ng-hide=!product.isSettingAsFavorite></i> <a href=\"\" class=\"icon-button icon-like add-tooltip\" data-toggle=tooltip data-placement=top title=\"Añadir a Favorito\" ng-click=$ctrl.updateFavoriteProducts(product); ng-class=\"{'producto-favorito': product.isFavorite}\" ng-hide=\"!$ctrl.shCtrl.globals.currentUser.username || product.isSettingAsFavorite\"></a></div><a ng-if=\"::product.showProductAction && product.cantidad\" class=\"item-add-btn add-tooltip\" title=Adicionar ng-click=$ctrl.setItemToAddToCart(product)></a> <a ng-if=::!product.showProductAction class=masinfo ui-sref=\"home.productDetailSlug({productSlug : product.slug})\"><i class=\"fa fa-info-circle add-tooltip\" title=\"Más información\" data-container=body></i> <span>Detalles</span></a></div></div></div><div class=\"purchased-items-slider owl-carousel\" ng-if=$ctrl.featuredProducts2.length><div class=\"item item-product ng-cloak\" ng-repeat=\"product in ::$ctrl.featuredProducts2\"><div class=item-image-wrapper><figure class=item-image-container ng-show=::product.imagesDetail.length><a ui-sref=\"home.productDetailSlug({productSlug : product.slug})\"><img ng-src={{::product.imagesDetail[0].path}}/md-{{::product.imagesDetail[0].image}} alt=item1 class=item-image> <img ng-if=\"::product.imagesDetail.length === 1\" ng-src={{::product.imagesDetail[0].path}}/md-{{::product.imagesDetail[0].image}} alt=\"item2  Hover\" class=item-image-hover> <img ng-if=\"::product.imagesDetail.length > 1\" ng-src={{::product.imagesDetail[1].path}}/md-{{::product.imagesDetail[1].image}} alt=\"item2  Hover\" class=item-image-hover></a></figure><div class=novedades-del-producto><span class=new-rect ng-show=::product.isNew>Nuevo</span> <span class=\"discount-rect porct\" ng-show=\"::product.discountPercentage > 0\">{{ ::product.discountPercentage | s4bCurrency }} %</span></div></div><div class=item-meta-container><h3 class=item-name style=\"margin: 0px\"><a ui-sref=\"home.productDetailSlug({productSlug : product.slug})\">{{::product.name}}</a></h3><h3 class=item-reference style=margin-bottom:0px>Ref: {{::product.reference}}</h3><h3 ng-if=product.erpCode class=item-reference>Código: {{::product.erpCode}}</h3><div class=ratings-container><div class=ratings><div class=ratings-result data-result=50></div></div><span class=ratings-amount>{{::product.ratedQuantity}} Calificaciones</span></div></div><div class=description-container style=\"margin-bottom: 10px;margin-top:5px\">{{ ::product.shortDescription | limitTo: 70}} <span ng-show=\"::product.shortDescription.length > 70\">...</span></div><div class=item-price-container ng-show=::product.showPrices style=\"width: 100% !important; text-align: right; line-height: 18px\"><span class=\"item-price wrapper-precio-internet\" ng-show=\"::product.currentPrice !== null\"><span class=precio-internet>{{::$ctrl.ngAuthSettings.config.data.item.internetPriceString}} <span ng-show=::product.isTemplate>desde</span>: </span><span data-toggle=tooltip data-placement=top title={{product.taxText}} data-container=body><span ng-show=!product.visualExcludedIva>{{product.currentPrice | currency:'$':0}}</span> <span ng-show=product.visualExcludedIva>{{product.currentPrice - product.taxValue | currency:'$':0}}</span> </span><span class=sub-price>COP</span> <i class=\"fa fa-info-circle add-tooltip\" data-toggle=tooltip data-placement=top title={{product.taxText}} data-container=body></i> </span><span class=\"item-price wrapper-precio-normal\" ng-show=\"::(product.currentPrice !== null && product.itemStorePrice !== null && !product.isTemplate)\"><span class=\"precio-internet rayado\">Precio Normal</span>: <span class=\"precio-normal color-orange\">{{::product.itemStorePrice | currency:'$':0}}</span> <span class=sub-price>COP</span> <i class=\"fa fa-info-circle add-tooltip\" data-toggle=tooltip data-placement=top title={{product.taxText}} data-container=body></i> </span><span class=\"item-price no-disponible\" ng-show=\"::product.currentPrice == null\">Precio no disponible </span><span class=item-price-regular ng-show=\"::(product.currentPrice > 0 && (product.currentPrice !== product.lastPrice) && !product.isTemplate)\"><span class=precio-regular>Precio Oficial:</span> {{::product.lastPrice | currency:'$':0}} <span class=sub-price>COP</span> <i class=\"fa fa-info-circle add-tooltip\" data-toggle=tooltip data-placement=top title={{product.taxText}} data-container=body></i> </span><span ng-show=\"::product.isSoldOut || !product.cantidad\" class=agotado>Producto Agotado</span></div><div class=clear>&nbsp;</div><div class=\"item-action ofertas-icons\"><a href=# ng-show=::product.isTemplate class=\"icon-button-2 add-tooltip ofertas-icons\" data-toggle=tooltip data-placement=top data-container=body title=\"Características variadas\"><i class=\"fa fa-plus-square\"></i> </a><a href=# class=\"icon-button-2 add-tooltip ofertas-icons\" data-toggle=tooltip data-placement=top data-container=body ng-show=::product.isInternetExclusive title=\"Venta sólo por internet\"><i class=\"fa fa-globe\" ng-class=\"::{'icono-opciones-producto-deshabilitado': !product.isInternetExclusive}\"></i> </a><a href=# class=\"icon-button-2 add-tooltip producto-oferta\" data-toggle=tooltip data-placement=top title=\"¡Producto en Oferta!\" style=\"color: #CCC !important\"><i class=\"fa fa-gift\" ng-class=\"{'icono-opciones-producto-deshabilitado': true}\"></i> </a><a href=# class=\"icon-button-2 add-tooltip envio-casa\" data-toggle=tooltip data-placement=top title=\"Recogida en Tienda\" data-container=body style=\"color: #CCC !important\"><i class=\"fa fa-truck\" ng-class=\"{'icono-opciones-producto-deshabilitado': true}\"></i></a></div><div class=item-action><div class=item-action-inner ng-show=::!product.isTemplate><i class=\"fa fa-history load-animation product-is-setting-as-favorite\" ng-hide=!product.isSettingAsFavorite></i> <a href=\"\" class=\"icon-button icon-like add-tooltip\" data-toggle=tooltip data-placement=top title=\"Añadir a Favorito\" ng-click=$ctrl.updateFavoriteProducts(product); ng-class=\"{'producto-favorito': product.isFavorite}\" ng-hide=\"!$ctrl.shCtrl.globals.currentUser.username || product.isSettingAsFavorite\"></a></div><a ng-if=\"::product.showProductAction && product.cantidad\" class=\"item-add-btn add-tooltip\" title=Adicionar ng-click=$ctrl.setItemToAddToCart(product)></a> <a ng-if=::!product.showProductAction class=masinfo ui-sref=\"home.productDetailSlug({productSlug : product.slug})\"><i class=\"fa fa-info-circle add-tooltip\" title=\"Más información\" data-container=body></i> <span>Detalles</span></a></div></div></div></div></div></div></div><div class=sm-margin></div></div></div>";

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=bg_gray><div class=container><div class=row><div class=row><div class=col-md-12><div class=\"purchased-items-container carousel-wrapper\"><header class=content-title><h2 class=ng-cloak><span class=pt-5>PRODUCTOS MÁS VENDIDOS</span> <span ng-if=\"$ctrl.mostSelledProducts.length > 0\" class=cantidad-productos-destacados>({{$ctrl.mostSelledProducts.length}})</span></h2></header><div class=loader-general ng-if=$ctrl.loadingRelatedProducts style=margin-bottom:10px><img src=" + __webpack_require__(2) + "> <span>Cargando productos destacados</span></div><div class=\"carousel-controls margin-top-6\"><div id=most-selled-items-slider-prev class=\"carousel-btn carousel-btn-prev\"></div><div id=most-selled-items-slider-next class=\"carousel-btn carousel-btn-next carousel-space\"></div></div><div class=\"most-selled-items-slider owl-carousel\"><div class=\"item item-product ng-cloak\" ng-repeat=\"product in $ctrl.mostSelledProducts1\"><div class=item-image-wrapper><figure class=item-image-container ng-show=::product.imagesDetail.length><a ui-sref=\"home.productDetailSlug({productSlug : product.slug})\"><img ng-src={{::product.imagesDetail[0].path}}/md-{{::product.imagesDetail[0].image}} alt=item1 class=item-image> <img ng-if=\"::product.imagesDetail.length === 1\" ng-src={{::product.imagesDetail[0].path}}/md-{{::product.imagesDetail[0].image}} alt=\"item2  Hover\" class=item-image-hover> <img ng-if=\"::product.imagesDetail.length > 1\" ng-src={{::product.imagesDetail[1].path}}/md-{{::product.imagesDetail[1].image}} alt=\"item2  Hover\" class=item-image-hover></a></figure><div class=novedades-del-producto><span class=new-rect ng-show=::product.isNew>Nuevo</span> <span class=\"discount-rect porct\" ng-show=\"::product.discountPercentage > 0\">{{ ::product.discountPercentage | s4bCurrency }} %</span></div></div><div class=item-meta-container><h3 class=item-name style=\"margin: 0\"><a ui-sref=\"home.productDetailSlug({productSlug : product.slug})\">{{::product.name}}</a></h3><h3 class=item-reference style=margin-bottom:0>Ref: {{::product.reference}}</h3><h3 ng-if=product.erpCode class=item-reference>Código: {{::product.erpCode}}</h3><div class=ratings-container><div class=ratings><div class=ratings-result data-result=50></div></div><span class=ratings-amount>{{::product.ratedQuantity}} Calificaciones</span></div></div><div class=description-container style=\"margin-bottom: 10px;margin-top:5px\">{{ ::product.shortDescription | limitTo: 70}} <span ng-show=\"::product.shortDescription.length > 70\">...</span></div><div class=item-price-container ng-show=::product.showPrices style=\"width: 100% !important; text-align: right; line-height: 18px\"><span class=\"item-price wrapper-precio-internet\" ng-show=\"::product.currentPrice !== null\"><span class=precio-internet>{{::$ctrl.ngAuthSettings.site.config.data.item.internetPriceString}} <span ng-show=::product.isTemplate>desde</span>: </span><span data-toggle=tooltip data-placement=top title={{product.taxText}} data-container=body><span ng-show=!product.visualExcludedIva>{{product.currentPrice | currency:'$':0}}</span> <span ng-show=product.visualExcludedIva>{{product.currentPrice - product.taxValue | currency:'$':0}}</span> </span><span class=sub-price>COP</span> <i class=\"fa fa-info-circle add-tooltip\" data-toggle=tooltip data-placement=top title={{product.taxText}} data-container=body></i> </span><span class=\"item-price wrapper-precio-normal\" ng-show=\"::(product.currentPrice !== null && product.itemStorePrice !== null && !product.isTemplate)\"><span class=\"precio-internet rayado\">Precio Normal</span>: <span class=\"precio-normal color-orange\">{{::product.itemStorePrice | currency:'$':0}}</span> <span class=sub-price>COP</span> <i class=\"fa fa-info-circle add-tooltip\" data-toggle=tooltip data-placement=top title={{product.taxText}} data-container=body></i> </span><span class=\"item-price no-disponible\" ng-show=\"::product.currentPrice == null\">Precio no disponible </span><span class=item-price-regular ng-show=\"::(product.currentPrice > 0 && (product.currentPrice !== product.lastPrice) && !product.isTemplate)\"><span class=precio-regular>Precio Oficial:</span> {{::product.lastPrice | currency:'$':0}} <span class=sub-price>COP</span> <i class=\"fa fa-info-circle add-tooltip\" data-toggle=tooltip data-placement=top title={{product.taxText}} data-container=body></i> </span><span ng-show=\"::product.isSoldOut || !product.cantidad\" class=agotado>Producto Agotado</span></div><div class=clear>&nbsp;</div><div class=\"item-action ofertas-icons\"><a ng-show=::product.isTemplate class=\"icon-button-2 add-tooltip ofertas-icons\" data-toggle=tooltip data-placement=top data-container=body title=\"Características variadas\"><i class=\"fa fa-plus-square\"></i> </a><a class=\"icon-button-2 add-tooltip ofertas-icons\" data-toggle=tooltip data-placement=top data-container=body ng-show=::product.isInternetExclusive title=\"Venta sólo por internet\"><i class=\"fa fa-globe\" ng-class=\"::{'icono-opciones-producto-deshabilitado': !product.isInternetExclusive}\"></i> </a><a class=\"icon-button-2 add-tooltip producto-oferta\" data-toggle=tooltip data-placement=top title=\"¡Producto en Oferta!\" style=\"color: #CCC !important\"><i class=\"fa fa-gift\" ng-class=\"{'icono-opciones-producto-deshabilitado': true}\"></i> </a><a class=\"icon-button-2 add-tooltip envio-casa\" data-toggle=tooltip data-placement=top title=\"Recogida en Tienda\" data-container=body style=\"color: #CCC !important\"><i class=\"fa fa-truck\" ng-class=\"{'icono-opciones-producto-deshabilitado': true}\"></i></a></div><div class=item-action><div class=item-action-inner ng-show=::!product.isTemplate><i class=\"fa fa-history load-animation product-is-setting-as-favorite\" ng-hide=!product.isSettingAsFavorite></i> <a href=\"\" class=\"icon-button icon-like add-tooltip\" data-toggle=tooltip data-placement=top title=\"Añadir a Favorito\" ng-click=$ctrl.updateFavoriteProducts(product); ng-class=\"{'producto-favorito': product.isFavorite}\" ng-hide=\"!$ctrl.shCtrl.globals.currentUser.username || product.isSettingAsFavorite\"></a></div><a ng-if=\"::product.showProductAction && product.cantidad\" class=\"item-add-btn add-tooltip\" title=Adicionar ng-click=$ctrl.setItemToAddToCart(product)></a> <a ng-if=::!product.showProductAction class=masinfo ui-sref=\"home.productDetailSlug({productSlug : product.slug})\"><i class=\"fa fa-info-circle add-tooltip\" title=\"Más información\" data-container=body></i> <span>Detalles</span></a></div></div></div><div class=\"most-selled-items-slider owl-carousel\" ng-if=$ctrl.mostSelledProducts2.length><div class=\"item item-product ng-cloak\" ng-repeat=\"product in ::$ctrl.mostSelledProducts2\"><div class=item-image-wrapper><figure class=item-image-container ng-show=::product.imagesDetail.length><a ui-sref=\"home.productDetailSlug({productSlug : product.slug})\"><img ng-src={{::product.imagesDetail[0].path}}/md-{{::product.imagesDetail[0].image}} alt=item1 class=item-image> <img ng-if=\"::product.imagesDetail.length === 1\" ng-src={{::product.imagesDetail[0].path}}/md-{{::product.imagesDetail[0].image}} alt=\"item2  Hover\" class=item-image-hover> <img ng-if=\"::product.imagesDetail.length > 1\" ng-src={{::product.imagesDetail[1].path}}/md-{{::product.imagesDetail[1].image}} alt=\"item2  Hover\" class=item-image-hover></a></figure><div class=novedades-del-producto><span class=new-rect ng-show=::product.isNew>Nuevo</span> <span class=\"discount-rect porct\" ng-show=\"::product.discountPercentage > 0\">{{ ::product.discountPercentage | s4bCurrency }} %</span></div></div><div class=item-meta-container><h3 class=item-name style=\"margin: 0px\"><a ui-sref=\"home.productDetailSlug({productSlug : product.slug})\">{{::product.name}}</a></h3><h3 class=item-reference style=margin-bottom:0px>Ref: {{::product.reference}}</h3><h3 ng-if=product.erpCode class=item-reference>Código: {{::product.erpCode}}</h3><div class=ratings-container><div class=ratings><div class=ratings-result data-result=50></div></div><span class=ratings-amount>{{::product.ratedQuantity}} Calificaciones</span></div></div><div class=description-container style=\"margin-bottom: 10px;margin-top:5px\">{{ ::product.shortDescription | limitTo: 70}} <span ng-show=\"::product.shortDescription.length > 70\">...</span></div><div class=item-price-container ng-show=::product.showPrices style=\"width: 100% !important; text-align: right; line-height: 18px\"><span class=\"item-price wrapper-precio-internet\" ng-show=\"::product.currentPrice !== null\"><span class=precio-internet>{{::$ctrl.ngAuthSettings.config.data.item.internetPriceString}} <span ng-show=::product.isTemplate>desde</span>: </span><span data-toggle=tooltip data-placement=top title={{product.taxText}} data-container=body><span ng-show=!product.visualExcludedIva>{{product.currentPrice | currency:'$':0}}</span> <span ng-show=product.visualExcludedIva>{{product.currentPrice - product.taxValue | currency:'$':0}}</span> </span><span class=sub-price>COP</span> <i class=\"fa fa-info-circle add-tooltip\" data-toggle=tooltip data-placement=top title={{product.taxText}} data-container=body></i> </span><span class=\"item-price wrapper-precio-normal\" ng-show=\"::(product.currentPrice !== null && product.itemStorePrice !== null && !product.isTemplate)\"><span class=\"precio-internet rayado\">Precio Normal</span>: <span class=\"precio-normal color-orange\">{{::product.itemStorePrice | currency:'$':0}}</span> <span class=sub-price>COP</span> <i class=\"fa fa-info-circle add-tooltip\" data-toggle=tooltip data-placement=top title={{product.taxText}} data-container=body></i> </span><span class=\"item-price no-disponible\" ng-show=\"::product.currentPrice == null\">Precio no disponible </span><span class=item-price-regular ng-show=\"::(product.currentPrice > 0 && (product.currentPrice !== product.lastPrice) && !product.isTemplate)\"><span class=precio-regular>Precio Oficial:</span> {{::product.lastPrice | currency:'$':0}} <span class=sub-price>COP</span> <i class=\"fa fa-info-circle add-tooltip\" data-toggle=tooltip data-placement=top title={{product.taxText}} data-container=body></i> </span><span ng-show=\"::product.isSoldOut || !product.cantidad\" class=agotado>Producto Agotado</span></div><div class=clear>&nbsp;</div><div class=\"item-action ofertas-icons\"><a href=# ng-show=::product.isTemplate class=\"icon-button-2 add-tooltip ofertas-icons\" data-toggle=tooltip data-placement=top data-container=body title=\"Características variadas\"><i class=\"fa fa-plus-square\"></i> </a><a href=# class=\"icon-button-2 add-tooltip ofertas-icons\" data-toggle=tooltip data-placement=top data-container=body ng-show=::product.isInternetExclusive title=\"Venta sólo por internet\"><i class=\"fa fa-globe\" ng-class=\"::{'icono-opciones-producto-deshabilitado': !product.isInternetExclusive}\"></i> </a><a href=# class=\"icon-button-2 add-tooltip producto-oferta\" data-toggle=tooltip data-placement=top title=\"¡Producto en Oferta!\" style=\"color: #CCC !important\"><i class=\"fa fa-gift\" ng-class=\"{'icono-opciones-producto-deshabilitado': true}\"></i> </a><a href=# class=\"icon-button-2 add-tooltip envio-casa\" data-toggle=tooltip data-placement=top title=\"Recogida en Tienda\" data-container=body style=\"color: #CCC !important\"><i class=\"fa fa-truck\" ng-class=\"{'icono-opciones-producto-deshabilitado': true}\"></i></a></div><div class=item-action><div class=item-action-inner ng-show=::!product.isTemplate><i class=\"fa fa-history load-animation product-is-setting-as-favorite\" ng-hide=!product.isSettingAsFavorite></i> <a href=\"\" class=\"icon-button icon-like add-tooltip\" data-toggle=tooltip data-placement=top title=\"Añadir a Favorito\" ng-click=$ctrl.updateFavoriteProducts(product); ng-class=\"{'producto-favorito': product.isFavorite}\" ng-hide=\"!$ctrl.shCtrl.globals.currentUser.username || product.isSettingAsFavorite\"></a></div><a ng-if=\"::product.showProductAction && product.cantidad\" class=\"item-add-btn add-tooltip\" title=Adicionar ng-click=$ctrl.setItemToAddToCart(product)></a> <a ng-if=::!product.showProductAction class=masinfo ui-sref=\"home.productDetailSlug({productSlug : product.slug})\"><i class=\"fa fa-info-circle add-tooltip\" title=\"Más información\" data-container=body></i> <span>Detalles</span></a></div></div></div></div></div></div></div><div class=sm-margin></div></div></div>";

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=bg_gray><div class=container><div class=row><div class=row><div class=col-md-12><div class=\"purchased-items-container carousel-wrapper\"><header class=content-title><h2 class=ng-cloak><span class=pt-5>PRODUCTOS NUEVOS</span> <span ng-if=\"$ctrl.newProducts.length > 0\" class=cantidad-productos-destacados>({{$ctrl.newProducts.length}})</span></h2></header><div class=loader-general ng-if=$ctrl.loadingRelatedProducts style=margin-bottom:10px><img src=" + __webpack_require__(2) + "> <span>Cargando productos nuevos</span></div><div class=\"carousel-controls margin-top-6\"><div id=new-items-slider-prev class=\"carousel-btn carousel-btn-prev\"></div><div id=new-items-slider-next class=\"carousel-btn carousel-btn-next carousel-space\"></div></div><div class=\"new-items-slider owl-carousel\"><div class=\"item item-product ng-cloak\" ng-repeat=\"product in $ctrl.newProducts1\"><div class=item-image-wrapper><figure class=item-image-container ng-show=::product.imagesDetail.length><a ui-sref=\"home.productDetailSlug({productSlug : product.slug})\"><img ng-src={{::product.imagesDetail[0].path}}/md-{{::product.imagesDetail[0].image}} alt=item1 class=item-image> <img ng-if=\"::product.imagesDetail.length === 1\" ng-src={{::product.imagesDetail[0].path}}/md-{{::product.imagesDetail[0].image}} alt=\"item2  Hover\" class=item-image-hover> <img ng-if=\"::product.imagesDetail.length > 1\" ng-src={{::product.imagesDetail[1].path}}/md-{{::product.imagesDetail[1].image}} alt=\"item2  Hover\" class=item-image-hover></a></figure><div class=novedades-del-producto><span class=new-rect ng-show=::product.isNew>Nuevo</span> <span class=\"discount-rect porct\" ng-show=\"::product.discountPercentage > 0\">{{ ::product.discountPercentage | s4bCurrency }} %</span></div></div><div class=item-meta-container><h3 class=item-name style=\"margin: 0\"><a ui-sref=\"home.productDetailSlug({productSlug : product.slug})\">{{::product.name}}</a></h3><h3 class=item-reference style=margin-bottom:0>Ref: {{::product.reference}}</h3><h3 ng-if=product.erpCode class=item-reference>Código: {{::product.erpCode}}</h3><div class=ratings-container><div class=ratings><div class=ratings-result data-result=50></div></div><span class=ratings-amount>{{::product.ratedQuantity}} Calificaciones</span></div></div><div class=description-container style=\"margin-bottom: 10px;margin-top:5px\">{{ ::product.shortDescription | limitTo: 70}} <span ng-show=\"::product.shortDescription.length > 70\">...</span></div><div class=item-price-container ng-show=::product.showPrices style=\"width: 100% !important; text-align: right; line-height: 18px\"><span class=\"item-price wrapper-precio-internet\" ng-show=\"product.currentPrice !== null\"><span class=precio-internet>{{$ctrl.ngAuthSettings.site.config.data.item.internetPriceString}} <span ng-show=product.isTemplate>desde</span>: </span><span data-toggle=tooltip data-placement=top title={{product.taxText}} data-container=body><span ng-show=!product.visualExcludedIva>{{product.currentPrice | currency:'$':0}}</span> <span ng-show=product.visualExcludedIva>{{product.currentPrice - product.taxValue | currency:'$':0}}</span> </span><span class=sub-price>COP</span> <i class=\"fa fa-info-circle add-tooltip\" data-toggle=tooltip data-placement=top title={{product.taxText}} data-container=body></i> </span><span class=\"item-price wrapper-precio-normal\" ng-show=\"::(product.currentPrice !== null && product.itemStorePrice !== null && !product.isTemplate)\"><span class=\"precio-internet rayado\">Precio Normal</span>: <span class=\"precio-normal color-orange\">{{::product.itemStorePrice | currency:'$':0}}</span> <span class=sub-price>COP</span> <i class=\"fa fa-info-circle add-tooltip\" data-toggle=tooltip data-placement=top title={{product.taxText}} data-container=body></i> </span><span class=\"item-price no-disponible\" ng-show=\"::product.currentPrice == null\">Precio no disponible </span><span class=item-price-regular ng-show=\"::(product.currentPrice > 0 && (product.currentPrice !== product.lastPrice) && !product.isTemplate)\"><span class=precio-regular>Precio Oficial:</span> {{::product.lastPrice | currency:'$':0}} <span class=sub-price>COP</span> <i class=\"fa fa-info-circle add-tooltip\" data-toggle=tooltip data-placement=top title={{product.taxText}} data-container=body></i> </span><span ng-show=\"::product.isSoldOut || !product.cantidad\" class=agotado>Producto Agotado</span></div><div class=clear>&nbsp;</div><div class=\"item-action ofertas-icons\"><a ng-show=::product.isTemplate class=\"icon-button-2 add-tooltip ofertas-icons\" data-toggle=tooltip data-placement=top data-container=body title=\"Características variadas\"><i class=\"fa fa-plus-square\"></i> </a><a class=\"icon-button-2 add-tooltip ofertas-icons\" data-toggle=tooltip data-placement=top data-container=body ng-show=::product.isInternetExclusive title=\"Venta sólo por internet\"><i class=\"fa fa-globe\" ng-class=\"::{'icono-opciones-producto-deshabilitado': !product.isInternetExclusive}\"></i> </a><a class=\"icon-button-2 add-tooltip producto-oferta\" data-toggle=tooltip data-placement=top title=\"¡Producto en Oferta!\" style=\"color: #CCC !important\"><i class=\"fa fa-gift\" ng-class=\"{'icono-opciones-producto-deshabilitado': true}\"></i> </a><a class=\"icon-button-2 add-tooltip envio-casa\" data-toggle=tooltip data-placement=top title=\"Recogida en Tienda\" data-container=body style=\"color: #CCC !important\"><i class=\"fa fa-truck\" ng-class=\"{'icono-opciones-producto-deshabilitado': true}\"></i></a></div><div class=item-action><div class=item-action-inner ng-show=::!product.isTemplate><i class=\"fa fa-history load-animation product-is-setting-as-favorite\" ng-hide=!product.isSettingAsFavorite></i> <a href=\"\" class=\"icon-button icon-like add-tooltip\" data-toggle=tooltip data-placement=top title=\"Añadir a Favorito\" ng-click=$ctrl.updateFavoriteProducts(product); ng-class=\"{'producto-favorito': product.isFavorite}\" ng-hide=\"!$ctrl.shCtrl.globals.currentUser.username || product.isSettingAsFavorite\"></a></div><a ng-if=\"::product.showProductAction && product.cantidad\" class=\"item-add-btn add-tooltip\" title=Adicionar ng-click=$ctrl.setItemToAddToCart(product)></a> <a ng-if=::!product.showProductAction class=masinfo ui-sref=\"home.productDetailSlug({productSlug : product.slug})\"><i class=\"fa fa-info-circle add-tooltip\" title=\"Más información\" data-container=body></i> <span>Detalles</span></a></div></div></div><div class=\"new-items-slider owl-carousel\" ng-if=$ctrl.newProducts2.length><div class=\"item item-product ng-cloak\" ng-repeat=\"product in ::$ctrl.newProducts2\"><div class=item-image-wrapper><figure class=item-image-container ng-show=::product.imagesDetail.length><a ui-sref=\"home.productDetailSlug({productSlug : product.slug})\"><img ng-src={{::product.imagesDetail[0].path}}/md-{{::product.imagesDetail[0].image}} alt=item1 class=item-image> <img ng-if=\"::product.imagesDetail.length === 1\" ng-src={{::product.imagesDetail[0].path}}/md-{{::product.imagesDetail[0].image}} alt=\"item2  Hover\" class=item-image-hover> <img ng-if=\"::product.imagesDetail.length > 1\" ng-src={{::product.imagesDetail[1].path}}/md-{{::product.imagesDetail[1].image}} alt=\"item2  Hover\" class=item-image-hover></a></figure><div class=novedades-del-producto><span class=new-rect ng-show=::product.isNew>Nuevo</span> <span class=\"discount-rect porct\" ng-show=\"::product.discountPercentage > 0\">{{ ::product.discountPercentage | s4bCurrency }} %</span></div></div><div class=item-meta-container><h3 class=item-name style=\"margin: 0px\"><a ui-sref=\"home.productDetailSlug({productSlug : product.slug})\">{{::product.name}}</a></h3><h3 class=item-reference style=margin-bottom:0px>Ref: {{::product.reference}}</h3><h3 ng-if=product.erpCode class=item-reference>Código: {{::product.erpCode}}</h3><div class=ratings-container><div class=ratings><div class=ratings-result data-result=50></div></div><span class=ratings-amount>{{::product.ratedQuantity}} Calificaciones</span></div></div><div class=description-container style=\"margin-bottom: 10px;margin-top:5px\">{{ ::product.shortDescription | limitTo: 70}} <span ng-show=\"::product.shortDescription.length > 70\">...</span></div><div class=item-price-container ng-show=::product.showPrices style=\"width: 100% !important; text-align: right; line-height: 18px\"><span class=\"item-price wrapper-precio-internet\" ng-show=\"::product.currentPrice !== null\"><span class=precio-internet>{{::$ctrl.ngAuthSettings.site.config.data.item.internetPriceString}} <span ng-show=::product.isTemplate>desde</span>: </span><span data-toggle=tooltip data-placement=top title={{product.taxText}} data-container=body><span ng-show=!product.visualExcludedIva>{{product.currentPrice | currency:'$':0}}</span> <span ng-show=product.visualExcludedIva>{{product.currentPrice - product.taxValue | currency:'$':0}}</span> </span><span class=sub-price>COP</span> <i class=\"fa fa-info-circle add-tooltip\" data-toggle=tooltip data-placement=top title={{product.taxText}} data-container=body></i> </span><span class=\"item-price wrapper-precio-normal\" ng-show=\"::(product.currentPrice !== null && product.itemStorePrice !== null && !product.isTemplate)\"><span class=\"precio-internet rayado\">Precio Normal</span>: <span class=\"precio-normal color-orange\">{{::product.itemStorePrice | currency:'$':0}}</span> <span class=sub-price>COP</span> <i class=\"fa fa-info-circle add-tooltip\" data-toggle=tooltip data-placement=top title={{product.taxText}} data-container=body></i> </span><span class=\"item-price no-disponible\" ng-show=\"::product.currentPrice == null\">Precio no disponible </span><span class=item-price-regular ng-show=\"::(product.currentPrice > 0 && (product.currentPrice !== product.lastPrice) && !product.isTemplate)\"><span class=precio-regular>Precio Oficial:</span> {{::product.lastPrice | currency:'$':0}} <span class=sub-price>COP</span> <i class=\"fa fa-info-circle add-tooltip\" data-toggle=tooltip data-placement=top title={{product.taxText}} data-container=body></i> </span><span ng-show=\"::product.isSoldOut || !product.cantidad\" class=agotado>Producto Agotado</span></div><div class=clear>&nbsp;</div><div class=\"item-action ofertas-icons\"><a href=# ng-show=::product.isTemplate class=\"icon-button-2 add-tooltip ofertas-icons\" data-toggle=tooltip data-placement=top data-container=body title=\"Características variadas\"><i class=\"fa fa-plus-square\"></i> </a><a href=# class=\"icon-button-2 add-tooltip ofertas-icons\" data-toggle=tooltip data-placement=top data-container=body ng-show=::product.isInternetExclusive title=\"Venta sólo por internet\"><i class=\"fa fa-globe\" ng-class=\"::{'icono-opciones-producto-deshabilitado': !product.isInternetExclusive}\"></i> </a><a href=# class=\"icon-button-2 add-tooltip producto-oferta\" data-toggle=tooltip data-placement=top title=\"¡Producto en Oferta!\" style=\"color: #CCC !important\"><i class=\"fa fa-gift\" ng-class=\"{'icono-opciones-producto-deshabilitado': true}\"></i> </a><a href=# class=\"icon-button-2 add-tooltip envio-casa\" data-toggle=tooltip data-placement=top title=\"Recogida en Tienda\" data-container=body style=\"color: #CCC !important\"><i class=\"fa fa-truck\" ng-class=\"{'icono-opciones-producto-deshabilitado': true}\"></i></a></div><div class=item-action><div class=item-action-inner ng-show=::!product.isTemplate><i class=\"fa fa-history load-animation product-is-setting-as-favorite\" ng-hide=!product.isSettingAsFavorite></i> <a href=\"\" class=\"icon-button icon-like add-tooltip\" data-toggle=tooltip data-placement=top title=\"Añadir a Favorito\" ng-click=$ctrl.updateFavoriteProducts(product); ng-class=\"{'producto-favorito': product.isFavorite}\" ng-hide=\"!$ctrl.shCtrl.globals.currentUser.username || product.isSettingAsFavorite\"></a></div><a ng-if=\"::product.showProductAction && product.cantidad\" class=\"item-add-btn add-tooltip\" title=Adicionar ng-click=$ctrl.setItemToAddToCart(product)></a> <a ng-if=::!product.showProductAction class=masinfo ui-sref=\"home.productDetailSlug({productSlug : product.slug})\"><i class=\"fa fa-info-circle add-tooltip\" title=\"Más información\" data-container=body></i> <span>Detalles</span></a></div></div></div></div></div></div></div><div class=sm-margin></div></div></div>";

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div><div><div id=breadcrumb-container class=\"transparent hproduct\"><div class=container><div class=row><div class=col-xs-12><ul class=breadcrumb><li><a ui-sref={{$ctrl.shCtrl.ngAuthSettings.site.app.header.logo.url}}><i class=\"fa fa-home\"></i></a><li><a ui-sref=home.category><span>Nuestros productos</span></a><li ng-repeat=\"breadcrumbItem in $ctrl.productDetail.breadcrumb\"><a ui-sref=\"home.categoryIdProducts({idCategory : breadcrumbItem.id})\" target={{breadcrumbItem.target}} title={{breadcrumbItem.title}} class=ng-cloak>{{breadcrumbItem.name}}</a><li class=active><span class=ng-cloak>{{$ctrl.productDetail.name}}</span></ul></div></div></div></div><div class=\"container product-detail\"><div class=row><div class=col-md-12><div class=loader-general ng-show=$ctrl.loadingProductDetail><img src=" + __webpack_require__(2) + "> <span>Cargando producto</span></div><div class=row ng-show=!$ctrl.loadingProductDetail><div class=\"col-md-5 col-sm-12 col-xs-12 product-viewer clearfix\"><div id=product-image-carousel-container><ul id=product-carousel class=celastislide-list><li class=active-slide ng-repeat=\"images in $ctrl.productDetail.imagesDetail\" class=ng-cloak><a data-rel=prettyPhoto[product] href={{images.path}}{{images.image}} data-image={{images.path}}{{images.image}} data-zoom-image={{images.path}}{{images.image}} class=product-gallery-item><img ng-src={{images.path}}xs-{{images.image}} alt={{$ctrl.productDetail.name}}></a></ul></div><div id=product-image-container ng-click=$ctrl.clickgaleria(); ng-if=\"$ctrl.productDetail.imagesDetail.length > 0\"><figure><img ng-src={{$ctrl.productDetail.imagesDetail[0].path}}{{$ctrl.productDetail.imagesDetail[0].image}} data-zoom-image={{$ctrl.productDetail.imagesDetail[0].path}}{{$ctrl.productDetail.imagesDetail[0].image}} alt={{$ctrl.productDetail.name}} class=ng-cloak id=product-image></figure></div></div><div class=\"col-md-7 col-sm-12 col-xs-12 product\"><div class=\"lg-margin visible-sm visible-xs\"></div><div class=labels-product-details><span class=\"discount-rect ng-binding\" ng-show=\"$ctrl.productDetail.discountPercentage > 0\">{{ $ctrl.productDetail.discountPercentage | s4bCurrency }} % </span><span class=new-rect ng-show=$ctrl.productDetail.isNew>Nuevo</span></div><h1 class=\"product-name ng-cloak\" ng-bind-html=\"$ctrl.productDetail.name | toTrusted\"></h1><h3 class=\"product-short-description ng-cloak\" ng-bind-html=\"$ctrl.productDetail.shortDescription | toTrusted\"></h3><div class=\"col-md-12 col-sm-12 col-xs-12 md-margin\"><div class=\"informacion-producto row\"><div class=\"col-md-7 col-sm-12 col-xs-12\"><ul class=\"product-list listado-atributos-detalle-producto\"><li><span>Referencia:</span>{{$ctrl.productDetail.reference}}<li ng-if=$ctrl.productDetail.erpCode><span>Código:</span>{{$ctrl.productDetail.erpCode}}<li><span>Categoría:</span>{{$ctrl.productDetail.category.title}}<li ng-if=$ctrl.productDetail.unidades_por_um><span>{{$ctrl.productDetail.label_unidades_por_um}}:</span>{{$ctrl.productDetail.unidades_por_um}}<li ng-if=$ctrl.productDetail.measureUnit><span>Unidad de Medida:</span> {{$ctrl.productDetail.measureUnit}}<li ng-repeat=\"attribute in $ctrl.productDetail.attributesDetail\" ng-if=\"attribute.type === 'only' && attribute.typeId !== 1\" class=ng-cloak><span ng-bind-html=\"attribute.title + ':' | capitalize | toTrusted\"></span><label ng-bind-html=\"attribute.value | toTrusted\"></label><li ng-repeat=\"attribute in $ctrl.productDetail.attributesDetail\" ng-if=\"attribute.type === 'selected' && attribute.value.length === 1 && attribute.typeId !== 1\" class=ng-cloak><span ng-bind-html=\"attribute.title + ':' | capitalize | toTrusted\"></span><label ng-bind-html=\"attribute.value[0] | toTrusted\"></label><li ng-repeat=\"attribute in $ctrl.productDetail.attributesDetail\" ng-if=\"attribute.type === 'selected' && attribute.value.length > 1 && attribute.typeId !== 1\" class=ng-cloak><span ng-bind-html=\"attribute.title + ':' | capitalize | toTrusted\"></span><label ng-bind-html=\"attribute.value | join | toTrusted\"></label></ul></div><div class=\"col-md-5 col-sm-12 col-xs-12\"><ul class=product-list><li ng-repeat=\"attribute in $ctrl.productDetail.attributesDetail\" ng-if=\"attribute.typeId === 1\" class=ng-cloak><span ng-bind-html=\"attribute.title + ':' | capitalize | toTrusted\"></span><label ng-bind-html=\"attribute.value | toTrusted\"></label></ul><div ng-show=\"$ctrl.productDetail.clonedAttributesDetail.length && !$ctrl.productDetail.quote\" style=margin-bottom:10px><span style=font-weight:bold ng-show=$ctrl.productDetail.minValueClonedAttributes>Precio desde:</span><div style=\"float: right\" ng-show=$ctrl.productDetail.minValueClonedAttributes>$ {{ $ctrl.productDetail.minValueClonedAttributes | currency:'':0}} <small class=cop-product>COP</small> <i class=\"fa fa-info-circle add-tooltip hidden-xs\" data-toggle=tooltip data-placement=top title={{$ctrl.productDetail.taxText}} data-container=body style=\"position: relative; top: -7px;font-size: 10px;left: -3px\"></i></div><div class=clearfix></div></div><form id=cloned-form ng-show=$ctrl.productDetail.clonedAttributesDetail.length name=clonedForm ng-submit=clonedForm.$valid novalidate><ul ng-show=$ctrl.productDetail.clonedAttributesDetail.length style=\"margin-bottom: 10px\"><li ng-repeat=\"attribute in $ctrl.productDetail.clonedAttributesDetail\" class=ng-cloak><span>{{attribute.title| capitalize}}*:</span><select class=form-control ng-model=$ctrl.clonedFormData[attribute.name] ng-change=$ctrl.clonedAttributesSelected() required><option value=\"\">Seleccione una opción<option ng-repeat=\"(key, value) in attribute.value\" value={{key}} ng-selected=\"$ctrl.clonedFormData[attribute.name] === key\">{{value}}</select></ul></form><div class=loader-general ng-show=loadingClonedProductPrice style=\"margin-bottom:10px;font-size: 11px\"><img src=" + __webpack_require__(2) + "> <span>Cargando información del producto...</span></div><div ng-show=\"messageClonedProductPrice && !$ctrl.productDetail.isTemplate\" style=\"color:red; font-weight:bold\">Producto no disponible</div><ul class=\"product-list product-accion\" ng-show=!$ctrl.productDetail.isTemplate><li class=\"product-valor ng-cloak\" ng-show=\"$ctrl.productDetail.currentPrice !== null &&\r\n                                  $ctrl.showProductPrice &&\r\n                                  $ctrl.productDetail.showPrices\"><div><span>Precio: </span><small ng-show=!$ctrl.productDetail.visualExcludedIva style=\"font-size: 16px;font-weight: 600\">$ {{$ctrl.productDetail.currentPrice| currency:'':0}}</small> <small ng-show=$ctrl.productDetail.visualExcludedIva style=\"font-size: 16px;font-weight: 600\">$ {{$ctrl.productDetail.currentPrice - $ctrl.productDetail.taxValue| currency:'':0}}</small> <small class=cop-product>COP</small> <i ng-show=false class=\"fa fa-info-circle add-tooltip hidden-xs\" data-toggle=tooltip data-placement=top title={{$ctrl.productDetail.taxText}} data-container=body style=\"position: relative; top: -7px;font-size: 10px;left: -3px\"></i><label style=\"font-size: 10px\"><span ng-show=!$ctrl.productDetail.visualExcludedIva>{{$ctrl.productDetail.taxText}}</span> <span ng-show=$ctrl.productDetail.visualExcludedIva style=\"margin: 5px 1px\">No Incluye IVA</span></label></div><div class=\"item-price wrapper-precio-normal\" ng-show=\"$ctrl.productDetail.currentPrice !== null &&\r\n                                     $ctrl.productDetail.itemStorePrice !== null\"><span>Precio Normal: </span>$ {{$ctrl.productDetail.itemStorePrice| currency:'':0}} <small class=cop-product>COP</small> <i class=\"fa fa-info-circle add-tooltip hidden-xs\" data-toggle=tooltip data-placement=top title={{$ctrl.productDetail.taxText}} data-container=body style=\"position: relative; top: -9px;font-size: 10px;left: -3px\"></i></div><li class=\"product-valor no-disponible ng-cloak\" ng-show=\"$ctrl.productDetail.currentPrice === null &&\r\n                                  $ctrl.showProductPrice &&\r\n                                  $ctrl.productDetail.showPrices\">Precio no disponible<li ng-show=\"$ctrl.productDetail.isSoldOut && $ctrl.productDetail.showPrices || !$ctrl.productDetail.cantidad && $ctrl.productDetail.showProductAction\"><span class=agotado style=color:red>Producto Agotado</span><li ng-if=\"$ctrl.productDetail.showProductAction || $ctrl.productDetail.showClonedAction\"><div class=\"product-add clearfix\"><div class=\"custom-quantity-input margin-right-10\"><input class=only_numeric maxlength=4 ng-model=$ctrl.productQuantity name=cantidad id=cantidadProducto restrict-type=num> <a class=\"quantity-btn quantity-input-up\" ng-click=$ctrl.increaseProductQuantity(); href=\"\"><i class=\"fa fa-angle-up\"></i> </a><a class=\"quantity-btn quantity-input-down\" ng-click=$ctrl.decreaseProductQuantity() href=\"\"><i class=\"fa fa-angle-down\"></i></a></div><span><a class=\"btn btn-custom-4\" ng-disabled=!$ctrl.productQuantity ng-click=\"$ctrl.addItemToCart($ctrl.productDetail, $ctrl.productQuantity)\"><i class=\"fa fa-shopping-cart\"></i> {{$ctrl.productDetail.textAction}}</a></span></div></ul><div ng-if=\"$ctrl.productDetail.showProductDetailContactAction && !$ctrl.productDetail.isTemplate\" class=margin-top-8><span><a class=\"btn btn-custom-4\" style=\"width: 100%; font-size: 12px\" ui-sref=home.contact><i class=\"fa fa-user\"></i> Contáctenos para mas información</a></span></div><discounts-range descuentos=$ctrl.productDetail onlylabel=true></discounts-range></div><div class=\"wrapper-opciones-producto-usuario col-md-12 col-sm-12 col-xs-12\"><div class=opciones-producto-usuario><div class=ratings-container><span>Calificación</span><div class=ratings><div class=ratings-result data-result={{$ctrl.productDetail.ratedPercentaje}}></div></div></div><div class=add-favoritos><i class=\"fa fa-history load-animation product-is-setting-as-favorite\" ng-hide=!$ctrl.productDetail.isSettingAsFavorite></i> <a href=\"\" class=\"icon-button icon-like add-tooltip\" data-toggle=tooltip data-placement=top title=\"Añadir a Favorito\" ng-click=$ctrl.updateFavoriteProducts($ctrl.productDetail); ng-class=\"{'producto-favorito2': $ctrl.productDetail.isFavorite}\" ng-hide=\"!$ctrl.shCtrl.globals.currentUser.username || $ctrl.productDetail.isSettingAsFavorite\">Añadir a Favorito</a></div></div></div></div></div><div class=\"product-extra clearfix\"><div class=row><div class=\"col-xs-3 col-ms-2 col-md-4 col-lg-4\"><button class=\"btn btn-custom-2\" type=button><i class=\"fa fa-check-circle\"></i> Calificar producto</button></div><div class=\"col-xs-12 col-ms-6 col-md-12 text-right\"><ul class=redes-producto><li><span>Compartir</span><li><a href=./#/producto/{{$ctrl.productDetail.id}}/redes-sociales/facebook title=\"Compartir en Facebook\"><img src=" + __webpack_require__(538) + "></a><li><a href=./#/producto/{{$ctrl.productDetail.id}}/redes-sociales/twitter title=\"Compartir en Twitter\"><img src=" + __webpack_require__(542) + "></a><li><a href=./#/producto/{{$ctrl.productDetail.id}}/redes-sociales/gplus title=\"Compartir en Google Plus\"><img src=" + __webpack_require__(539) + "></a><li><a href=./#/producto/{{$ctrl.productDetail.id}}/redes-sociales/instagram title=\"Compartir en Instagram\"><img src=" + __webpack_require__(540) + "></a><li><a href=./#/producto/{{$ctrl.productDetail.id}}/redes-sociales/pinterest title=\"Compartir en Pinterest\"><img src=" + __webpack_require__(541) + "></a></ul><div class=recomendar-amigo><i class=\"fa fa-envelope\"></i> <a ng-click=$ctrl.recommendProduct()>Recomendar <span>producto</span></a></div></div></div></div></div></div><div class=sm-margin></div><div class=row ng-show=!$ctrl.loadingProductDetail><div class=\"col-sm-12 col-xs-12\" ng-class=\"{'col-md-9': $ctrl.featuredProducts.length > 0}\"><uib-tabset active=$ctrl.active><uib-tab index=0 heading=Descripción><div class=\"products-tabs-content tabs-content tab_container\"><div ng-if=\"$ctrl.productDetail.description !== ''\"><div id=wrapper-detail-description class=simplebar><div ng-bind-html=\"$ctrl.productDetail.description | toTrusted\"></div></div></div><div ng-show=\"$ctrl.productDetail.description === ''\">No se ha ingresado una descripción para el producto</div></div></uib-tab><uib-tab index=1 heading=\"Ficha Técnica\" ng-if=\"$ctrl.productDetail.datasheet.length > 0\"><div class=\"products-tabs-content tabs-content tab_container\"><ul class=fa-ul><li ng-repeat=\"data in $ctrl.productDetail.datasheet\" class=ng-cloak><i class=\"fa-li fa fa-check-square\"></i> {{data}}</ul></div></uib-tab><uib-tab index=2 heading=Detalles ng-if=\"$ctrl.productDetail.attributesDetail.length > 0\"><div class=\"products-tabs-content tabs-content tab_container\"><div class=table-responsive><table class=\"table table-condensed col-xs-12\"><thead><tr><th>Atributos<th>Detalle<tbody><tr ng-repeat=\"attribute in $ctrl.productDetail.attributesDetail\" ng-show=\"attribute.type === 'only'\" class=ng-cloak><td scope=row>{{attribute.name| capitalize}}<td>{{attribute.value}}<tr ng-repeat=\"attribute in $ctrl.productDetail.attributesDetail\" ng-show=\"attribute.type === 'selected'\" class=ng-cloak><td scope=row>{{attribute.title| capitalize}}<td>{{attribute.value| join}}</table></div><div class=clear></div></div></uib-tab><uib-tab index=3 heading=Videos ng-if=\"$ctrl.productDetail.videos.length > 0\"><div class=\"products-tabs-content tabs-content tab_container\"><ul><li ng-repeat=\"video in $ctrl.productDetail.videos\" class=ng-cloak><a href=\"\" class=\"btn btn-default\" style=border-color:transparent ng-click=$ctrl.openVideo(video)><img ng-src={{video.videoId}} style=width:30px;display:inline> <span class=video-des>{{video.title}}</span></a></ul></div></uib-tab><uib-tab index=4 heading=Enlaces ng-if=\"$ctrl.productDetail.urls.length > 0\"><div class=\"products-tabs-content tabs-content tab_container\"><ul class=fa-ul><li ng-repeat=\"url in $ctrl.productDetail.urls\"><i class=\"fa-li fa fa-check-square\"></i> <a href={{url.url}} target=_blank title={{url.title}} class=ng-cloak>{{url.title}}</a></ul></div></uib-tab><uib-tab index=5 heading={{site.config.data.item.annexedDocumentString}} ng-if=\"$ctrl.productDetail.attachments.length > 0 || $ctrl.productDetail.category.attachments.length > 0\"><div class=\"products-tabs-content tabs-content tab_container\"><ul class=fa-ul ng-show=\"$ctrl.productDetail.attachments.length > 0\"><li ng-repeat=\"attachment in $ctrl.productDetail.attachments\"><i class=\"fa-li fa fa-check-square\"></i> <a href={{attachment.url}} target=_blank title={{attachment.title}} class=ng-cloak>{{attachment.title}}</a></ul><ul class=fa-ul ng-show=\"$ctrl.productDetail.category.attachments.length > 0\"><li ng-repeat=\"attachment in $ctrl.productDetail.category.attachments\"><i class=\"fa-li fa fa-check-square\"></i> <a href={{attachment.url}} target=_blank title={{attachment.title}} class=ng-cloak>{{attachment.title}}</a></ul></div></uib-tab><uib-tab index=6 heading=Complementos ng-if=\"$ctrl.partSuppliesProduct.length > 0\"><div class=\"products-tabs-content tabs-content tab_container\"><table class=\"table table-condensed\" style=\"width=100%\" ng-show=\"$ctrl.partSuppliesProduct.length > 0\"><thead><tr><th>Imagen<th>Nombre<th>Referencia<th>Tipo<th>-<tbody><tr ng-repeat=\"partsupply in $ctrl.partSuppliesProduct\"><td><a href=./#/{{partsupply.category.slug}}/{{partsupply.slug}} title={{partsupply.name}}><img style=\"width:35px; margin:auto\" ng-src={{partsupply.imagesDetail[0].path}}xs-{{partsupply.imagesDetail[0].image}} alt={{partsupply.name}}></a><td style=text-align:left><a href=./#/{{partsupply.category.slug}}/{{partsupply.slug}} title={{partsupply.name}}>{{partsupply.name}}</a><td>{{partsupply.reference}}<td>{{partsupply.tipo_relacionado}}<td><span><a ng-if=\"(!partsupply.isSoldOut && partsupply.currentPrice !== null)\r\n                                    || (partsupply.currentPrice == null && partsupply.quote)\" class=item-add-btn href=\"\" ng-click=$ctrl.setItemToAddToCart(partsupply)><span class=icon-cart-text>{{partsupply.textAction}}</span> </a><span ng-if=partsupply.isSoldOut><span class=icon-cart-text>-</span></span></span></table><div ng-show=!$ctrl.partSuppliesProduct.length>No existen repuestos ni insumos relacionados al producto.</div></div></uib-tab><uib-tab index=7 heading=Sustitutos ng-if=\"$ctrl.partSustitutesProduct.length > 0\"><div class=\"products-tabs-content tabs-content tab_container\"><table class=\"table table-condensed\" style=\"width=100%\" ng-show=\"$ctrl.partSustitutesProduct.length > 0\"><thead><tr><th>Imagen<th>Nombre<th>Referencia<th>Tipo<th>-<tbody><tr ng-repeat=\"partSustitute in $ctrl.partSustitutesProduct\"><td><a href=./#/{{partSustitute.category.slug}}/{{partSustitute.slug}} title={{partSustitute.name}}><img style=\"width:35px; margin:auto\" ng-src={{partSustitute.imagesDetail[0].path}}xs-{{partSustitute.imagesDetail[0].image}} alt={{partSustitute.name}}></a><td style=text-align:left><a href=./#/{{partSustitute.category.slug}}/{{partSustitute.slug}} title={{partSustitute.name}}>{{partSustitute.name}}</a><td>{{partSustitute.reference}}<td>{{partSustitute.tipo_relacionado}}<td><span><a ng-if=\"(!partSustitute.isSoldOut && partSustitute.currentPrice !== null)\r\n                                    || (partSustitute.currentPrice == null && partSustitute.quote)\" class=item-add-btn href=\"\" ng-click=$ctrl.setItemToAddToCart(partSustitute)><span class=icon-cart-text>{{partSustitute.textAction}}</span> </a><span ng-if=partSustitute.isSoldOut><span class=icon-cart-text>-</span></span></span></table><div ng-show=!$ctrl.partSuppliesProduct.length>No existen repuestos ni insumos relacionados al producto.</div></div></uib-tab><uib-tab index=8 heading=Asistencia><div class=\"products-tabs-content tabs-content tab_container\"><a ui-sref=home.contact title=Contáctanos style=\"position: relative;top: 20px\"><img src=" + __webpack_require__(442) + " class=center-block></a></div></uib-tab></uib-tabset><div class=\"lg-margin visible-xs\"></div></div><div class=\"lg-margin2x visible-sm visible-xs\"></div><div class=\"col-md-3 hidden-sm hidden-xs sidebar\" ng-show=\"$ctrl.featuredProducts.length > 0\"><div class=\"widget related\"><h3><span>Destacados</span><div class=\"related-slider flexslider sidebarslider\"><ul class=flex-direction-nav style=top:-35px><li><a class=flex-prev id=featured-items-slider-prev></a><li><a class=flex-next id=featured-items-slider-next></a></ul></div></h3><div id=featured-items-slider class=\"owl-carousel related-slider flexslider-xxx sidebarslider no-border\"><ul class=\"item related-list clearfix\" ng-repeat=\"relacionados in $ctrl.featuredProducts\"><li><div class=\"related-product clearfix\" ng-repeat=\"related in relacionados\"><figure><a ui-sref=\"home.productDetailSlug({productSlug : related.slug})\"><img ng-src={{related.image}} alt=\"\"> <img ng-src={{related.imagesDetail[0].path}}/xs-{{related.imagesDetail[0].image}} alt=item1 class=item-image></a></figure><h5><a ui-sref=\"home.productDetailSlug({productSlug : related.slug})\">{{related.name}}</a></h5><div ng-if=::related.showPrices><div class=\"related-price item-price\" ng-show=\"related.currentPrice !== null\"><span ng-show=!related.visualExcludedIva>$ {{related.currentPrice| currency:'':0}}</span> <span ng-show=related.visualExcludedIva>$ {{related.currentPrice - related.taxValue| currency:'':0}}</span> <span class=sub-price>COP </span><i class=\"fa fa-info-circle add-tooltip hidden-xs\" data-toggle=tooltip data-placement=top title={{related.taxText}} data-container=body style=\"margin-left: 0px\"></i></div><span class=\"item-price wrapper-precio-normal\" style=\"display:block;font-weight: 600;margin-top: 6px\" ng-show=\"related.currentPrice !== null && related.itemStorePrice !== null\"><span class=precio-normal>$ {{related.itemStorePrice| currency:'':0}}</span> <span class=sub-price>COP</span> <i class=\"fa fa-info-circle add-tooltip\" data-toggle=tooltip data-placement=top title={{related.taxText}} data-container=body></i> </span><span class=\"item-price no-disponible\" ng-show=\"related.currentPrice == null\">Precio no disponible</span></div><a ng-if=related.showProductAction class=\"btn btn-custom-4 btn-sm\" href=\"\" title=Adicionar ng-click=$ctrl.setItemToAddToCart(related)>Adicionar </a><a ng-if=!related.showProductAction class=\"btn btn-custom-4 btn-sm\" ui-sref=\"home.productDetailSlug({productSlug : related.slug})\">Ver producto</a></div></ul></div></div></div></div></div></div></div><related-products sh-ctrl=$ctrl.shCtrl product-related-id=$ctrl.productDetail.id ng-if=$ctrl.productDetail.id></related-products></div></div>";

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div><div><div id=breadcrumb-container class=\"transparent hproduct\"><div class=container><div class=row><div class=col-xs-12><ul class=breadcrumb><li><a ui-sref={{$ctrl.shCtrl.ngAuthSettings.site.app.header.logo.url}}><i class=\"fa fa-home\"></i></a><li class=active><span>Producto no encontrado</span></ul></div></div></div></div><div class=container><div class=row><div class=col-md-12><div class=row><div class=col-md-12><h3 class=title>No se encontraron ítems relacionados con la palabra \"<span style=color:#0664cd>{{$ctrl.productSearchText}}</span>\"</h3><p>Es posible que lo que busca esté en nuestra base de datos con otro nombre.<br class=\"hidden-sm hidden-xs\">Por favor diligencie el siguiente formulario y pronto estaremos en contacto.</div></div><div class=sm-margin></div><div class=\"row contenido-producto-no-encontrado\"><div class=\"col-md-4 hidden-sm hidden-xs\"><img alt=\"banner 1\" src=" + __webpack_require__(70) + " class=img-responsive></div><div class=\"col-md-8 col-sm-12\"><div class=\"alert alert-success\" ng-show=\"!$ctrl.mailSent && $ctrl.productNotFoundForm.$valid\" style=display:none>Ahora puede enviar su comentario relacionado a la búsqueda del producto</div><div class=\"alert alert-success\" ng-show=$ctrl.mailSent><h4>PRONTO ESTAREMOS EN CONTACTO</h4><p>Su mensaje ha sido enviado exitosamente. Pronto uno de nuestros representantes comerciales se contactará con usted.</div><fieldset class=\"input-desc-box formulario-asistencia\" ng-show=!$ctrl.mailSent><div class=\"alert alert-warning\" style=display:none><div><strong>Nombre Completo:</strong> {{ $ctrl.productNotFoundDataForm.name }}</div><div><strong>Empresa:</strong> {{ $ctrl.productNotFoundDataForm.company }}</div><div><strong>Teléfono:</strong> {{ $ctrl.productNotFoundDataForm.phone }}</div><div><strong>Email:</strong> {{ $ctrl.productNotFoundDataForm.email }}</div><div><strong>Vía Respuesta:</strong> {{ $ctrl.productNotFoundDataForm.replyOption }}</div><div><br><strong>Comentario:</strong> {{ $ctrl.productNotFoundDataForm.message }}</div></div><form name=$ctrl.productNotFoundForm ng-submit=$ctrl.sendMailProductNotFound($ctrl.productNotFoundForm) novalidate><h5>Búsqueda de producto</h5><div class=row><div class=\"col-lg-6 col-sm-6\"><div class=linea><div class=form-group><label>Nombre Completo*</label><input placeholder=\"Por favor ingrese su nombre\" class=form-control name=name ng-model=$ctrl.productNotFoundDataForm.name autocomplete=off required> <span ng-show=\"$ctrl.productNotFoundForm.name.$invalid && !$ctrl.productNotFoundForm.name.$pristine\" class=help-block>Ingrese su nombre completo.</span></div><div class=form-group><label>Empresa</label><input class=form-control name=company placeholder=\"Por favor ingrese su empresa\" ng-model=$ctrl.productNotFoundDataForm.company autocomplete=off> <span ng-show=\"$ctrl.productNotFoundForm.company.$invalid && !$ctrl.productNotFoundForm.company.$pristine\" class=help-block>Ingrese el nombre de su empresa.</span></div><div class=form-group><label>Ciudad*</label><input placeholder=\"Por favor ingrese su ciudad\" class=form-control name=city ng-model=$ctrl.productNotFoundDataForm.city autocomplete=off required> <span ng-show=\"$ctrl.productNotFoundForm.city.$invalid &&\r\n                        !$ctrl.productNotFoundForm.city.$pristine\" class=help-block>Ingrese su ciudad.</span></div><div class=form-group><label>Teléfono*</label><input class=form-control name=phone ng-model=$ctrl.productNotFoundDataForm.phone placeholder=\"Por favor ingrese su teléfono\" autocomplete=off required> <span ng-show=\"$ctrl.productNotFoundForm.phone.$invalid && !$ctrl.productNotFoundForm.phone.$pristine\" class=help-block>Ingrese su teléfono.</span></div></div></div><div class=\"col-lg-6 col-sm-6\"><div class=form-group><label>Email*</label><input type=email placeholder=\"Por favor ingrese su email\" class=\"form-control required email\" name=email ng-model=$ctrl.productNotFoundDataForm.email restrict-type=email autocomplete=off required> <span ng-show=\"$ctrl.productNotFoundForm.email.$invalid &&\r\n                                  $ctrl.productNotFoundForm.email.$error.restEmail &&\r\n                                  !$ctrl.productNotFoundForm.email.$pristine\" class=help-block>Ingrese un e-mail válido.</span></div><div class=form-group><label>Responder*</label><select class=\"form-control valid\" id=noProResponder name=replyOption ng-model=$ctrl.productNotFoundDataForm.replyOption required><option value=\"\">Seleccione la forma en que desee su respuesta<option value=Email>Vía email<option value=Telefono>Vía telefónica<option value=\"Visita Presencial\">Visita Presencial</select><span ng-show=\"$ctrl.productNotFoundForm.replyOption.$invalid && !$ctrl.productNotFoundForm.replyOption.$pristine\" class=help-block>Seleccione una forma de respuesta.</span></div><div class=form-group><label>Comentario*</label><textarea title=\"Por favor ingrese su comentario\" placeholder=\"Describa el producto que necesita\" class=\"required form-control\" id=noProComentario name=message rows=5 ng-model=$ctrl.productNotFoundDataForm.message required></textarea><span ng-show=\"$ctrl.productNotFoundForm.message.$invalid && !$ctrl.productNotFoundForm.message.$pristine\" class=help-block>Ingrese el comentario.</span></div><div class=\"form-group text-right\"><input type=submit class=\"btn btn-custom-2 md-margin\" value=Enviar></div></div></div></form></fieldset></div></div></div></div></div></div></div><style>input[type=\"submit\"]:disabled {\r\n    background-color: #CCC !important;\r\n    border: 1px solid #CCC !important;\r\n  }\r\n\r\n  .help-block {\r\n    position: relative;\r\n    font-size: 11px;\r\n  }</style>";

/***/ },
/* 462 */
/***/ function(module, exports) {

	module.exports = "<div ng-show=$ctrl.categoryAttributes.length><input class=boton-busqueda-valores-atributos ng-model=$ctrl.searchTextAttributes placeholder=\"e.j. marca\"></div><div class=wrapper-filtros-atributos><div class=filtros-atributos><div class=filter ng-show=$ctrl.categoryAttributes.length ng-repeat=\"(key, attribute) in $ctrl.categoryAttributes\r\n                    | filter:$ctrl.searchTextAttributes\r\n                    | orderBy:['order', 'title']:false\"><div class=accordion-header><div class=accordion-title><span ng-bind-html=\"::attribute.title | toTrusted\"></span></div><a class=\"accordion-btn opened\" data-toggle=collapse data-target=#filtro{{::attribute.id}}></a></div><div id=filtro{{::attribute.id}} ng-class=\"key > 0 ? 'collapse' : 'collapse in'\"><div class=panel-body><ul class=\"category-filter-list jscrollpane\" ng-repeat=\"data in attribute.data | filter:$ctrl.searchTextAttributes | orderBy:['order', 'value']:false\"><li ng-class=\"{'es-filtro-con-imagen': attribute.isIconAttribute}\"><label><input type=checkbox id=filtro_{{::attribute.id}}_{{$index}} ng-model=data.name ng-change=\"$ctrl.updateProductAttribute(attribute.group, data.value, data.name, attribute.id, data.id);\"> <span ng-bind-html=\"::data.value | toTrusted\"></span><div ng-if=attribute.isIconAttribute><img ng-src=\"{{$ctrl.ngAuthSettings.config.env.basePath + data.icon}}\" title={{data.value}}></div></label></ul></div></div></div></div></div>";

/***/ },
/* 463 */
/***/ function(module, exports) {

	module.exports = "<div class=panel ng-show=$ctrl.ngAuthSettings.site.config.data.item.showItemsPriceFilter><div class=accordion-header><div class=accordion-title><span>Precio</span></div><a class=\"accordion-btn opened\" data-toggle=collapse data-target=#filtro-precios></a></div><div id=filtro-precios class=\"collapse in\"><div class=panel-body><div style=\"margin-bottom: 10px\"><rzslider rz-slider-model=$ctrl.customFilters.productLowPriceTest rz-slider-high=$ctrl.customFilters.productHighPriceTest rz-slider-options=$ctrl.sliderOptions.options></rzslider></div><div id=price-range-details><div class=\"input-group input-group-sm\"><span class=input-group-addon>$</span><input class=\"separator price-range-dummy\" ng-model=$ctrl.customFilters.productLowPriceTest ng-change=$ctrl.onChangePriceFilter()></div><div class=\"input-group input-group-sm\"><span class=input-group-addon>$</span><input ng-model=$ctrl.customFilters.productHighPriceTest class=price-range-dummy style=\"margin-left: 5%\" ng-change=$ctrl.onChangePriceFilter()></div></div></div></div></div>";

/***/ },
/* 464 */
/***/ function(module, exports) {

	module.exports = "<div class=selected-products-to-compare ng-show=\"$ctrl.productsList.length > 0\"><div class=\"btn btn-custom pull-right btn-comparar hidden-xs hidden-sm\" ng-show=\"$ctrl.productsToCompare.customLength > 1\"><a href=\"\" ng-click=$ctrl.compareProductsSelected() data-toggle=tooltip title=\"Comparar productos\"><i class=\"fa fa-check-square-o\"></i> ({{$ctrl.productsToCompare.customLength}})</a></div></div><div class=catalogo-productos><div class=\"vistas-productos background-list-products\"><div class=opcion-vista ng-class=\"{\r\n            'listado': $ctrl.typeview === 0,\r\n            'vista-1': $ctrl.typeview === 1,\r\n            'vista-2 col-md-6': $ctrl.typeview === 2,\r\n            'vista-3 col-md-4': $ctrl.typeview === 3,\r\n            'vista-4 col-md-3': $ctrl.typeview === 4,\r\n            'vista-5 col-md-2': $ctrl.typeview === 5}\" ng-repeat=\"product in $ctrl.productsList\"><div class=productos-item-box><div class=col-md-2><div class=row><figure class=producto-img-box><div class=content-img><a ui-sref=\"home.productDetailSlug({productSlug : product.slug})\"><img ng-src={{::product.imagesDetail[0].path}}/md-{{::product.imagesDetail[0].image}} alt=\"\" class=img-responsive></a></div><div class=iconos-acciones-adiccionales><a ng-show=::product.isTemplate class=\"icon-button-2 add-tooltip ofertas-icons plantillas\" data-toggle=tooltip data-placement=top title=\"Características variadas\"><i class=\"fa fa-plus-square\"></i> </a><a ng-show=::product.isInternetExclusive class=\"icon-button-2 add-tooltip ofertas-icons\" data-toggle=tooltip data-placement=top title=\"Exclusivo en Internet\"><i class=\"fa fa-globe\" style=\"color: #0B56AB\"></i></a></div></figure><div class=novedades-del-producto><div class=ribbons><div class=\"ribbon-novedades nuevo\" ng-show=::product.isNew style=\"background-color: #0664cd;\r\n                            color: white;\r\n                            width: 30%;\r\n                            padding: 3px;\r\n                            opacity: 1;\r\n                            font-size:10px;\r\n                            text-align:center\"><small>Nuevo</small></div><div class=\"ribbon-novedades descuento\" ng-show=\"::product.discountPercentage > 0\" style=\"color: white;\r\n                            width: 30%;\r\n                            padding: 3px;\r\n                            opacity: 1;\r\n                            text-align:center\"><small>{{::product.discountPercentage | s4bCurrency }} %</small></div></div></div></div></div><div class=col-md-7><div class=row><div class=descripcion-producto-box><h1><a ui-sref=\"home.productDetailSlug({productSlug : product.slug})\" ng-bind-html=\"::product.name | toTrusted\"></a></h1><div class=categoria-box><a ui-sref=\"home.categorySlugProducts({categorySlug : product.category.slug})\" ng-bind-html=product.category.title></a></div><div class=referencia-box ng-bind-html=\"'REF:' + product.reference | toTrusted\"></div><div class=referencia-box ng-bind-html=\"'U.M: ' + product.measureUnit | toTrusted\"></div><div class=descripcion-box><span ng-bind-html=\"product.shortDescription | limitTo: 70\"></span> <span ng-show=\"product.shortDescription.length > 70\">...</span></div></div></div></div><div ng-class=\"{'col-md-5': $ctrl.typeview === 0, 'col-md-3': $ctrl.typeview !== 0,}\"><div class=row><div class=precio-producto-box><div class=clearfix></div><div class=precio-productos-item ng-show=product.showPrices><span class=precio-text-g ng-show=\"::product.currentPrice !== null\">{{::$ctrl.ngAuthSettings.site.config.data.item.internetPriceString}} <span ng-show=product.isTemplate>desde</span>: </span><span class=precio-valor ng-show=\"::product.currentPrice !== null\">{{::product.currentPrice | currency:'$':0}} <span class=sub-price>COP</span> <span class=sub-price>COP</span> <i class=\"fa fa-info-circle add-tooltip hidden-xs\" data-toggle=tooltip data-placement=top title={{product.taxText}} data-container=body></i></span><div class=clearfix></div><span class=\"precio-text-g regular\" ng-show=\"(product.currentPrice > 0 && (product.currentPrice !== product.lastPrice) && !product.isTemplate )\"><span class=hidd-vista-5>Precio</span> Oficial </span><span class=precio-valor ng-show=\"(product.currentPrice > 0 && (product.currentPrice !== product.lastPrice) && !product.isTemplate )\">{{::product.lastPrice | currency:'$':0}} <span class=sub-price>COP</span> <i class=\"fa fa-info-circle add-tooltip hidden-xs\" data-toggle=tooltip data-placement=top title=\"El precio incluye IVA\" data-container=body></i></span><div class=clearfix></div><span class=precio-text-g ng-show=\"(product.currentPrice !== null && product.itemStorePrice && !product.isTemplate)\"></span> <span class=\"precio-valor gray\" ng-show=\"::(product.currentPrice !== null && product.itemStorePrice && !product.isTemplate)\"><small>{{::product.itemStorePrice | currency:'$':0}}</small> <span class=sub-price>COP</span></span><div class=clearfix></div><span class=\"precio-text-g no-disponible\" ng-show=\"::product.currentPrice == null\"><small>Precio no disponible</small></span><div class=clearfix></div><span class=\"precio-text-g agotado\" ng-show=\"::!product.cantidad && product.showProductAction\"><small style=color:red>Producto Agotado</small></span></div><div class=boton-acciones-producto><a ng-if=\"::product.showProductAction && product.cantidad\" class=\"item-add-btn add-tooltip\" title=Agregar href=\"\" ng-click=$ctrl.setItemToAddToCart(product)></a> <a ng-if=\"::!product.showProductAction || !product.cantidad\" class=masinfo ui-sref=\"home.productDetailSlug({productSlug : product.slug})\"><i class=\"fa fa-info-circle add-tooltip\" title=\"Más información\" data-container=body></i> </a><a href=\"\" class=\"icon-button icon-like add-tooltip\" ng-show=::!product.isTemplate data-toggle=tooltip data-placement=top ng-click=$ctrl.updateFavoriteProducts(product) ng-class=\"{'producto-favorito': product.isFavorite}\" data-original-title=Favorito ng-hide=\"!$ctrl.shCtrl.globals.currentUser.username || product.isSettingAsFavorite\"></a> <i class=\"fa fa-history load-animation product-is-setting-as-favorite\" ng-hide=!product.isSettingAsFavorite style=\"float: right;margin-top: 5px;margin-left: 5px;margin-right: 7px\"></i><a class=\"icon-button icon-compare add-tooltip hidden-xs hidden-sm\" data-toggle=tooltip data-placement=top title=Comparar href=\"\" ng-click=$ctrl.updateProductToCompare(product.id) ng-class=\"{'producto-a-comparar': $ctrl.productsToCompare.items[product.id]}\" ng-show=\"::(!product.isTemplate && ($ctrl.categoryId || $ctrl.categorySlug))\"></a></div></div></div></div></div></div></div></div>";

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=bg_gray><div class=container><div class=row><div class=row><div class=col-md-12><div class=\"purchased-items-container carousel-wrapper\"><header class=content-title><h2 class=ng-cloak><span class=pt-5>PRODUCTOS RELACIONADOS</span> <span ng-if=\"$ctrl.relatedProducts.length > 0\" class=cantidad-productos-destacados>({{$ctrl.relatedProducts.length}})</span></h2></header><div class=loader-general ng-if=$ctrl.loadingRelatedProducts style=margin-bottom:10px><img src=" + __webpack_require__(2) + "> <span>Cargando productos relacionados</span></div><div class=\"carousel-controls margin-top-6\"><div id=related-items-slider-prev class=\"carousel-btn carousel-btn-prev\"></div><div id=related-items-slider-next class=\"carousel-btn carousel-btn-next carousel-space\"></div></div><div class=\"related-items-slider owl-carousel\"><div class=\"item item-product ng-cloak\" ng-repeat=\"product in $ctrl.relatedProducts\"><div class=item-image-wrapper><figure class=item-image-container ng-show=::product.imagesDetail.length><a ui-sref=\"home.productDetailSlug({productSlug : product.slug})\"><img ng-src={{::product.imagesDetail[0].path}}/md-{{::product.imagesDetail[0].image}} alt=item1 class=item-image> <img ng-if=\"::product.imagesDetail.length === 1\" ng-src={{::product.imagesDetail[0].path}}/md-{{::product.imagesDetail[0].image}} alt=\"item2  Hover\" class=item-image-hover> <img ng-if=\"::product.imagesDetail.length > 1\" ng-src={{::product.imagesDetail[1].path}}/md-{{::product.imagesDetail[1].image}} alt=\"item2  Hover\" class=item-image-hover></a></figure><div class=novedades-del-producto><span class=new-rect ng-show=::product.isNew>Nuevo</span> <span class=\"discount-rect porct\" ng-show=\"::product.discountPercentage > 0\">{{ ::product.discountPercentage | s4bCurrency }} %</span></div></div><div class=item-meta-container><h3 class=item-name style=\"margin: 0\"><a ui-sref=\"home.productDetailSlug({productSlug : product.slug})\">{{::product.name}}</a></h3><h3 class=item-reference style=margin-bottom:0>Ref: {{::product.reference}}</h3><h3 ng-if=product.erpCode class=item-reference>Código: {{::product.erpCode}}</h3><div class=ratings-container><div class=ratings><div class=ratings-result data-result=50></div></div><span class=ratings-amount>{{::product.ratedQuantity}} Calificaciones</span></div></div><div class=description-container style=\"margin-bottom: 10px;margin-top:5px\">{{ ::product.shortDescription | limitTo: 70}} <span ng-show=\"::product.shortDescription.length > 70\">...</span></div><div class=item-price-container ng-show=::product.showPrices style=\"width: 100% !important; text-align: right; line-height: 18px\"><span class=\"item-price wrapper-precio-internet\" ng-show=\"::product.currentPrice !== null\"><span class=precio-internet>{{::$ctrl.ngAuthSettings.site.config.data.item.internetPriceString}} <span ng-show=::product.isTemplate>desde</span>: </span><span data-toggle=tooltip data-placement=top title={{product.taxText}} data-container=body><span ng-show=!product.visualExcludedIva>$ {{product.currentPrice | currency:'':0}}</span> <span ng-show=product.visualExcludedIva>$ {{product.currentPrice - product.taxValue | currency:'':0}}</span> </span><span class=sub-price>COP</span> <i class=\"fa fa-info-circle add-tooltip\" data-toggle=tooltip data-placement=top title={{product.taxText}} data-container=body></i> </span><span class=\"item-price wrapper-precio-normal\" ng-show=\"::(product.currentPrice !== null && product.itemStorePrice !== null && !product.isTemplate)\"><span class=\"precio-internet rayado\">Precio Normal</span>: <span class=\"precio-normal color-orange\">$ {{::product.itemStorePrice | currency:'':0}}</span> <span class=sub-price>COP</span> <i class=\"fa fa-info-circle add-tooltip\" data-toggle=tooltip data-placement=top title={{product.taxText}} data-container=body></i> </span><span class=\"item-price no-disponible\" ng-show=\"::product.currentPrice == null\">Precio no disponible </span><span class=item-price-regular ng-show=\"::(product.currentPrice > 0 && (product.currentPrice !== product.lastPrice) && !product.isTemplate)\"><span class=precio-regular>Precio Oficial:</span> $ {{::product.lastPrice | currency:'':0}} <span class=sub-price>COP</span> <i class=\"fa fa-info-circle add-tooltip\" data-toggle=tooltip data-placement=top title={{product.taxText}} data-container=body></i> </span><span ng-show=\"::product.isSoldOut || !product.cantidad\" class=agotado>Producto Agotado</span></div><div class=clear>&nbsp;</div><div class=\"item-action ofertas-icons\"><a ng-show=::product.isTemplate class=\"icon-button-2 add-tooltip ofertas-icons\" data-toggle=tooltip data-placement=top data-container=body title=\"Características variadas\"><i class=\"fa fa-plus-square\"></i> </a><a class=\"icon-button-2 add-tooltip ofertas-icons\" data-toggle=tooltip data-placement=top data-container=body ng-show=::product.isInternetExclusive title=\"Venta sólo por internet\"><i class=\"fa fa-globe\" ng-class=\"::{'icono-opciones-producto-deshabilitado': !product.isInternetExclusive}\"></i> </a><a class=\"icon-button-2 add-tooltip producto-oferta\" data-toggle=tooltip data-placement=top title=\"¡Producto en Oferta!\" style=\"color: #CCC !important\"><i class=\"fa fa-gift\" ng-class=\"{'icono-opciones-producto-deshabilitado': true}\"></i> </a><a class=\"icon-button-2 add-tooltip envio-casa\" data-toggle=tooltip data-placement=top title=\"Recogida en Tienda\" data-container=body style=\"color: #CCC !important\"><i class=\"fa fa-truck\" ng-class=\"{'icono-opciones-producto-deshabilitado': true}\"></i></a></div><div class=item-action><div class=item-action-inner ng-show=::!product.isTemplate><i class=\"fa fa-history load-animation product-is-setting-as-favorite\" ng-hide=!product.isSettingAsFavorite></i> <a href=\"\" class=\"icon-button icon-like add-tooltip\" data-toggle=tooltip data-placement=top title=\"Añadir a Favorito\" ng-click=$ctrl.updateFavoriteProducts(product); ng-class=\"{'producto-favorito': product.isFavorite}\" ng-hide=\"!$ctrl.shCtrl.globals.currentUser.username || product.isSettingAsFavorite\"></a></div><a ng-if=\"::product.showProductAction && product.cantidad\" class=\"item-add-btn add-tooltip\" title=Adicionar ng-click=$ctrl.setItemToAddToCart(product)></a> <a ng-if=::!product.showProductAction class=masinfo ui-sref=\"home.productDetailSlug({productSlug : product.slug})\"><i class=\"fa fa-info-circle add-tooltip\" title=\"Más información\" data-container=body></i> <span>Detalles</span></a></div></div></div></div></div></div></div><div class=sm-margin></div></div></div>";

/***/ },
/* 466 */,
/* 467 */
/***/ function(module, exports) {

	module.exports = "<div class=container id=pagos><br><div class=col-xs-12><div class=\"row header-pagos\"><div ng-bind-html=\"$ctrl.shCtrl.globalParams.cmsInfo.ZONA_DE_PAGOS_TITULO | toTrusted\"></div></div></div><uib-tabset active=$ctrl.shCtrl.globals.currentUser.activeTap><uib-tab index=0 ng-click=\"$ctrl.copy(); $ctrl.tab = 1;\"><uib-tab-heading class=headeing--icon><i class=\"fa fa-file-text-o\" aria-hidden=true></i><br>Act. Específicas</uib-tab-heading><specific-act-list ng-if=\"$ctrl.tab == 1\" sh-ctrl=$ctrl.shCtrl></specific-act-list></uib-tab><uib-tab index=1 ng-click=\"$ctrl.copy(); $ctrl.tab = 2\"><uib-tab-heading class=headeing--icon><i class=\"fa fa-file-text-o\" aria-hidden=true></i><br>Rutinas</uib-tab-heading><routines-list ng-if=\"$ctrl.tab == 2\" sh-ctrl=$ctrl.shCtrl></routines-list></uib-tab><uib-tab index=2 ng-click=\"$ctrl.copy(); $ctrl.tab = 3\"><uib-tab-heading class=headeing--icon><i class=\"fa fa-file-text-o\" aria-hidden=true></i><br>Actas</uib-tab-heading><proceedings-list ng-if=\"$ctrl.tab == 3\" sh-ctrl=$ctrl.shCtrl></proceedings-list></uib-tab><uib-tab index=3 ng-click=\"$ctrl.copy(); $ctrl.tab = 4\"><uib-tab-heading class=headeing--icon><i class=\"fa fa-file-text-o\" aria-hidden=true></i><br>Documentos</uib-tab-heading><documents-list ng-if=\"$ctrl.tab == 4\" sh-ctrl=$ctrl.shCtrl></documents-list></uib-tab><uib-tab index=4 ng-click=\"$ctrl.copy(); $ctrl.tab = 5\"><uib-tab-heading class=headeing--icon><i class=\"fa fa-file-text-o\" aria-hidden=true></i><br>PQRS</uib-tab-heading><pqrs-list ng-if=\"$ctrl.tab == 5\" sh-ctrl=$ctrl.shCtrl></pqrs-list></uib-tab><uib-tab index=5 ng-click=\"$ctrl.copy(); $ctrl.tab = 6\"><uib-tab-heading class=headeing--icon><i class=\"fa fa-file-text-o\" aria-hidden=true></i><br>Tareas</uib-tab-heading><task-list ng-if=\"$ctrl.tab == 6\" sh-ctrl=$ctrl.shCtrl></task-list></uib-tab></uib-tabset></div>";

/***/ },
/* 468 */
/***/ function(module, exports) {

	module.exports = "<div class=\"container mb-20\"><div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{$ctrl.shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li class=active><span>Documentos</span></ul></div></div></div></div><div class=\"mb-10 small text-right\"><i class=\"fa fa-refresh\"></i> <b>Última Actualización:</b> <span class=\"text-muted ng-binding\"><i>{{$ctrl.ultimaActualizacion}}</i></span></div><div class=\"tabs-title ng-binding\"><h5>DOCUMENTOS</h5></div><div class=consultas><div class=table-responsive><table class=\"table table-condensed table-bordered table-striped listado table-min-space small\"><thead><tr><th style=\"width: 20%\" class=sort ng-click=\"$ctrl.orderBy('name');\"><span>Nombre de Documento </span><span ng-if=!$ctrl.search.id class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 20%\" class=sort ng-click=\"$ctrl.orderBy('filename');\"><span>Nombre de Archivo </span><span ng-if=!$ctrl.search.id class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 15%\" class=sort ng-click=\"$ctrl.orderBy('category_id');\"><span>Categoría </span><span ng-if=!$ctrl.search.id class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 13%\" class=sort ng-click=\"$ctrl.orderBy('centroCosto');\"><span>Centro de Costo </span><span ng-if=!$ctrl.search.id class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 20%\" class=sort ng-click=\"$ctrl.orderBy('date_entered');\"><span>Fecha Creación </span><span ng-if=!$ctrl.search.id class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 20%\" class=sort ng-click=\"$ctrl.orderBy('created_by_name');\"><span>Creado Por </span><span ng-if=!$ctrl.search.id class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 10%\">Ver / Descargar<tr><th class=ng-table-filters><input class=form-control ng-blur=$ctrl.getActivities() ng-enter=$ctrl.getActivities() ng-model=$ctrl.filter.name><th class=ng-table-filters><input class=form-control ng-blur=$ctrl.getActivities() ng-enter=$ctrl.getActivities() ng-model=$ctrl.filter.filename><th class=ng-table-filters><select class=form-control ng-model=$ctrl.filter.category_id ng-change=$ctrl.getActivities()><option value=\"\">Todas<option value=Actas>Actas<option value=Documento>Documento<option value=FT_HS>Fecha Tecnica y Hoja Seguridad<option value=Indicador>Indicador<option value=Informe>Informe</select><th class=ng-table-filters><input class=form-control ng-blur=$ctrl.getActivities() ng-enter=$ctrl.getActivities() ng-model=$ctrl.filter.centroCosto><th class=ng-table-filters><input class=form-control ng-blur=$ctrl.getActivities() ng-enter=$ctrl.getActivities() ng-model=$ctrl.filter.date_entered><th class=ng-table-filters><input class=form-control ng-blur=$ctrl.getActivities() ng-enter=$ctrl.getActivities() ng-model=$ctrl.filter.created_by_name><th><tbody><tr ng-show=\"$ctrl.loading && !$ctrl.error\"><td colspan=7><span aria-hidden=true>Cargando registros... <i class=\"fa fa-history load-animation\"></i></span><tr ng-show=\"!$ctrl.loading && ($ctrl.error || $ctrl.activities.length == 0)\"><td colspan=7><span aria-hidden=true>{{$ctrl.errorMsg}}</span><tr ng-repeat=\"actividad in $ctrl.activities\" ng-if=\"!$ctrl.loading && $ctrl.activities.length\"><td>{{actividad.name}}<td>{{actividad.filename}}<td>{{actividad.category_id}}<td>{{actividad.centroCosto}}<td>{{actividad.date_entered}}<td>{{actividad.created_by_name}}<td><button ng-click=$ctrl.descargarDocumento(actividad.referencia,actividad.name) class=\"btn btn-default\"><span class=\"glyphicon glyphicon-download-alt\"></span></button></table></div><div class=col-sm-6><div class=\"row mt-10 small time-update\"><i class=\"fa fa-refresh\"></i> <b>Última Actualización:</b> <span class=\"text-muted ng-binding\"><i>{{$ctrl.ultimaActualizacion}}</i></span></div></div><div class=col-sm-6><div class=row><div class=\"filter-resume pull-right\">{{($ctrl.currentPage - 1) * 20 + 1}} - <span ng-show=\"($ctrl.currentPage - 1) *  20 +  20 < $ctrl.totalItems\">{{($ctrl.currentPage - 1) * 20 + 20}} </span><span ng-show=\"($ctrl.currentPage - 1) *  20 +  20 >= $ctrl.totalItems\">{{$ctrl.totalItems}} </span>de {{$ctrl.totalItems}} documentos</div></div><div class=row><ul uib-pagination total-items=$ctrl.totalItems ng-change=$ctrl.getActivities() ng-model=$ctrl.currentPage previous-text=&lsaquo; next-text=&rsaquo; first-text=&laquo; last-text=&raquo; max-size=5 class=pagination-sm items-per-page=20 boundary-links=true num-pages=$ctrl.totalPages></ul></div></div></div><div style=margin-top:20px></div><div class=\"mt-20 row\"><div class=col-md-6><div ng-if=$ctrl.detalle.id class=pull-left><button ng-click=\"$ctrl.detalle = {};\" class=\"btn btn-default\" type=button><span class=\"glyphicon glyphicon-chevron-left\"></span> Volver al listado</button></div></div><div class=\"col-md-6 mt-20\" ng-if=\"$ctrl.totalItems > 0 && !$ctrl.detalle.id\"><button ng-click=$ctrl.exportarXls() class=\"btn btn-success pull-right\" type=button><span>Exportar Excel <i class=\"fa fa-file-excel-o\" aria-hidden=true></i></span></button> <a id=labelprueba href=\"\" download></a></div><div class=col-md-6 ng-if=\"$ctrl.totalItems > 0 && $ctrl.detalle.id\"><button ng-click=$ctrl.exportarPdf() class=\"btn btn-success pull-right\" type=button><span>Exportar PDF <i class=\"fa fa-file-pdf-o\" aria-hidden=true></i></span></button> <a id=labelprueba href=\"\" target=blank download></a></div></div><div ng-show=$ctrl.exportLoading class=loadAnimation><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div></div>";

/***/ },
/* 469 */
/***/ function(module, exports) {

	module.exports = "<div class=\"container mb-20\"><div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{$ctrl.shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li class=active><span>PQRS</span></ul></div></div></div></div><div class=mt-1></div><div class=\"tabs-title ng-binding\"><h5>PQRS</h5></div><div class=consultas ng-if=!$ctrl.detalle.id><div class=table-responsive><table class=\"table table-striped listado table-min-space small\"><thead><tr><th style=\"width: 5%\" class=sort ng-click=\"$ctrl.orderBy('case_number');\"><span># </span><span ng-if=!$ctrl.search.id class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 10%\" class=sort ng-click=\"$ctrl.orderBy('name');\"><span>Asunto </span><span ng-if=!$ctrl.search.id class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 10%\" class=sort ng-click=\"$ctrl.orderBy('assigned_user_name');\"><span>Asignado a </span><span ng-if=!$ctrl.search.id class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 10\" class=sort ng-click=\"$ctrl.orderBy('proceso');\"><span>Proceso </span><span ng-if=!$ctrl.search.id class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 30\" class=sort ng-click=\"$ctrl.orderBy('type');\"><span>Tipo </span><span ng-if=!$ctrl.search.id class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 14%\" class=sort ng-click=\"$ctrl.orderBy('nivel_criticidad');\"><span>Nivel de Criticidad </span><span ng-if=!$ctrl.search.id class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 8%\" class=sort ng-click=\"$ctrl.orderBy('status');\"><span>Estado </span><span ng-if=!$ctrl.search.id class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 14%\" class=sort ng-click=\"$ctrl.orderBy('date_entered');\"><span>Fecha de Creación </span><span ng-if=!$ctrl.search.id class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 14%\" class=sort ng-click=\"$ctrl.orderBy('centroCosto');\"><span>Centro de Costo </span><span ng-if=!$ctrl.search.id class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 10%\">Ver / Descargar<tr><th class=ng-table-filters><input class=form-control ng-blur=$ctrl.getActivities() ng-enter=$ctrl.getActivities() ng-model=$ctrl.filter.case_number><th class=ng-table-filters><input class=form-control ng-blur=$ctrl.getActivities() ng-enter=$ctrl.getActivities() ng-model=$ctrl.filter.name><th class=ng-table-filters><input class=form-control ng-blur=$ctrl.getActivities() ng-enter=$ctrl.getActivities() ng-model=$ctrl.filter.assigned_user_name><th class=ng-table-filters><select class=form-control ng-change=$ctrl.getActivities() ng-model=$ctrl.filter.proceso><option value=\"\">Todas<option value=Administrativo>Administrativo<option value=Calidad>Calidad<option value=Comercial>Comercial<option value=Gestion_Humana>Gestión Humana<option value=logistica>Logistica<option value=Mercadeo>Mercadeo<option value=Operaciones>Operaciones<option value=Salud_Ocupacional>Seguridad y Salud en el trabajo</select><th class=ng-table-filters><select class=form-control ng-change=$ctrl.getActivities() ng-model=$ctrl.filter.type><option value=\"\">Todas<option value=Felicitaciones>Felicitaciones<option value=\"No conforme\">No conforme<option value=\"Novedades Internas\">Novedades Internas<option value=\"Oportunidad de mejora\">Oportunidad de mejora<option value=Queja>Queja<option value=Reclamos>Reclamos<option value=Recomendacion>Recomendación<option value=Solicitudes>Solicitudes</select><th class=ng-table-filters><select class=form-control ng-change=$ctrl.getActivities() ng-model=$ctrl.filter.nivel_criticidad><option value=\"\">Todas<option value=Critico>Critico<option value=No_critico>No critico</select><th class=ng-table-filters><select class=form-control ng-change=$ctrl.getActivities() ng-model=$ctrl.filter.status><option value=\"\">Todas<option value=Abierto>Abierto<option value=Cerrado>Cerrado</select><th class=ng-table-filters><input class=form-control ng-blur=$ctrl.getActivities() ng-enter=$ctrl.getActivities() ng-model=$ctrl.filter.date_entered><th class=ng-table-filters><input class=form-control ng-blur=$ctrl.getActivities() ng-enter=$ctrl.getActivities() ng-model=$ctrl.filter.centroCosto><th><tbody><tr ng-show=\"$ctrl.loading && !$ctrl.error\"><td colspan=9><span aria-hidden=true>Cargando registros... <i class=\"fa fa-history load-animation\"></i></span><tr ng-show=\"!$ctrl.loading && ($ctrl.error || $ctrl.activities.length == 0)\"><td colspan=9><span aria-hidden=true>{{$ctrl.errorMsg}}</span><tr ng-repeat=\"actividad in $ctrl.activities\" ng-if=\"!$ctrl.loading && $ctrl.activities.length\"><td>{{actividad.case_number}}<td>{{actividad.name}}<td>{{actividad.assigned_user_name}}<td>{{actividad.proceso}}<td>{{actividad.type}}<td>{{actividad.nivel_criticidad}}<td>{{actividad.status}}<td>{{actividad.date_entered}}<td>{{actividad.centroCosto}}<td class=text-center><button ng-click=\"$ctrl.detalle.id = actividad.id;$ctrl.detalle.rut = actividad.name;\" class=\"btn btn-default\"><span class=\"glyphicon glyphicon-align-justify\"></span></button></table></div><div class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4\" style=\"line-height: 2.3em; font-size: 0.9em\"><i class=\"fa fa-chart-bar\"></i> <span><b><i class=\"fa fa-bar-chart\"></i> Última Actualización:</b> </span><span class=\"text-min ng-binding\">{{$ctrl.ultimaActualizacion}}</span></div><div class=col-xs-12><div class=row><div class=\"filter-resume pull-right\">{{($ctrl.currentPage - 1) * 20 + 1}} - <span ng-show=\"($ctrl.currentPage - 1) *  20 +  20 < $ctrl.totalItems\">{{($ctrl.currentPage - 1) * 20 + 20}} </span><span ng-show=\"($ctrl.currentPage - 1) *  20 +  20 >= $ctrl.totalItems\">{{$ctrl.totalItems}} </span>de {{$ctrl.totalItems}} pqrs</div></div></div><div class=\"col-xs-12 pr-0\"><ul uib-pagination total-items=$ctrl.totalItems ng-change=$ctrl.getActivities() ng-model=$ctrl.currentPage previous-text=&lsaquo; next-text=&rsaquo; first-text=&laquo; last-text=&raquo; max-size=5 class=pagination-sm items-per-page=20 boundary-links=true num-pages=$ctrl.totalPages></ul></div></div><div ng-if=!$ctrl.detalle.id class=row></div><div ng-repeat=\"actividad in $ctrl.activities\" ng-if=\"!$ctrl.loading && $ctrl.activities.length\"><table ng-if=\"$ctrl.detalle.id == actividad.id\" class=\"table mt-5\"><tr><td class=\"text-right active align-middle\" width=15%><strong>Caso:</strong><td class=\"text-left align-middle\" width=45%>#{{actividad.case_number}}<td class=\"text-right active align-middle\" width=20%><strong>Centro de Costo:</strong><td class=\"text-left align-middle\" width=40%>{{actividad.centroCosto}}<tr><td class=\"text-right active align-middle\"><strong>Asunto del Caso:</strong><td class=\"text-left align-middle\">{{actividad.name}}<td class=\"text-right active align-middle\"><strong>Tipo:</strong><td class=\"text-left align-middle\">{{actividad.type}}<tr><td class=\"text-right active align-middle\"><strong>Ciudad:</strong><td class=\"text-left align-middle\">{{actividad.ciudad}}<td class=\"text-right active align-middle\"><strong>Nivel de Criticidad:</strong><td class=\"text-left align-middle\">{{actividad.nivel_criticidad}}<tr><td class=\"text-right active align-middle\"><strong>Estado:</strong><td class=\"text-left align-middle\">{{actividad.status}}<td class=\"text-right active align-middle\"><strong>Etapa:</strong><td class=\"text-left align-middle\">{{actividad.etapa_c}}<tr><td class=\"text-right active align-middle\"><strong>Proceso:</strong><td class=\"text-left align-middle\">{{actividad.proceso}}<td class=\"text-right active align-middle\"><strong>Detalle Clasificación:</strong><td class=\"text-left align-middle\">{{actividad.detalle_clasificacion}}<tr><td class=\"text-right active align-middle\"><strong>Asignado a:</strong><td class=\"text-left align-middle\">{{actividad.assigned_user_name}}<td class=\"text-right active align-middle\"><strong>Se dió respuesta al cliente:</strong><td class=\"text-left align-middle\"><span ng-show=actividad.respuesta_al_cliente_c class=\"glyphicon glyphicon-ok\" aria-hidden=true></span><span ng-show=!actividad.respuesta_al_cliente_c class=\"glyphicon glyphicon-remove\" aria-hidden=true></span><tr><td class=\"text-right active align-middle\"><strong>Cargos:</strong><td class=\"text-left align-middle\">{{actividad.cargos}}<td class=\"text-right active align-middle\"><strong>Creado Por:</strong><td class=\"text-left align-middle\">{{actividad.created_by_name}}<tr><td class=\"text-right active align-middle\"><strong>Descripción:</strong><td class=\"text-left align-middle\" colspan=3>{{actividad.description}}</table><div ng-if=\"$ctrl.detalle.id == actividad.id\"><div class=mt-5></div><div class=\"tabs-title ng-binding\"><h5>Tareas</h5></div><table border=1 class=\"table table-condensed table-bordered table-striped listado table-min-space small\"><thead><tr><th>Asunto<th>Estado<th>Fecha de Modificación<th>Fecha de Creación<th>Fecha de Vencimiento<th>Usuario Asignado<tbody><tr ng-repeat=\"acta in actividad.actasAsociadas\"><td><a target=_blank href=#!/app/consultas/tareas/{{acta.id}}>{{acta.name}}</a><td>{{acta.status}}<td>{{acta.date_modified}}<td>{{acta.date_entered}}<td>{{acta.date_due}}<td>{{acta.nombre_responsable}}<tr ng-if=\"actividad.actasAsociadas.length == 0\"><td colspan=7>Esta Acta no tiene tareas asociadas</table></div></div><div class=row><div ng-if=$ctrl.detalle.id class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4\" style=\"line-height: 2.3em; font-size: 0.9em\"><i class=\"fa fa-chart-bar\"></i> <span><b><i class=\"fa fa-bar-chart\"></i> Última Actualización:</b> </span><span class=\"text-min ng-binding\">{{$ctrl.ultimaActualizacion}}</span></div></div><div class=\"mt-20 row\"><div class=col-md-6><div ng-if=$ctrl.detalle.id class=pull-left><button ng-click=\"$ctrl.detalle = {};\" class=\"btn btn-default\" type=button><span class=\"glyphicon glyphicon-chevron-left\"></span> Volver al listado</button></div></div><div class=col-md-6 ng-if=\"$ctrl.totalItems > 0 && !$ctrl.detalle.id\"><button ng-click=$ctrl.exportarXls() class=\"btn btn-success pull-right\" type=button><span>Exportar Excel <i class=\"fa fa-file-excel-o\" aria-hidden=true></i></span></button> <a id=labelprueba href=\"\" download></a></div><div class=col-md-6 ng-if=\"$ctrl.totalItems > 0 && $ctrl.detalle.id\"><button ng-click=$ctrl.exportarPdf() class=\"btn btn-success pull-right\" type=button><span>Exportar PDF <i class=\"fa fa-file-pdf-o\" aria-hidden=true></i></span></button> <a id=labelprueba href=\"\" target=blank download></a></div></div><div ng-show=$ctrl.exportLoading class=loadAnimation><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div></div>";

/***/ },
/* 470 */
/***/ function(module, exports) {

	module.exports = "<div class=\"container mb-20\"><div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{$ctrl.shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li class=active><span>Actas</span></ul></div></div></div></div><div class=\"mb-10 small text-right\"><i class=\"fa fa-refresh\"></i> <b>Última Actualización:</b> <span class=\"text-muted ng-binding\"><i>{{$ctrl.ultimaActualizacion}}</i></span></div><div class=\"tabs-title ng-binding\"><h5>ACTAS</h5></div><div class=consultas ng-if=!$ctrl.detalle.id><div class=table-responsive><table class=\"table table-condensed table-bordered table-striped listado table-min-space small\"><thead><tr><th style=\"width: 30%\" class=sort ng-click=\"$ctrl.orderBy('name');\"><span>Asunto </span><span ng-if=!$ctrl.search.id class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 30%\" class=sort ng-click=\"$ctrl.orderBy('centroCosto');\"><span>Centro de Costo </span><span ng-if=!$ctrl.search.id class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 30\" class=sort ng-click=\"$ctrl.orderBy('date_entered');\"><span>Fecha Creación </span><span ng-if=!$ctrl.search.id class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 30\" class=sort ng-click=\"$ctrl.orderBy('created_by_name');\"><span>Creado Por </span><span ng-if=!$ctrl.search.id class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 10%\">Ver / Descargar<tr><th class=ng-table-filters><input class=form-control ng-blur=$ctrl.getActivities() ng-enter=$ctrl.getActivities() ng-model=$ctrl.filter.name><th class=ng-table-filters><input class=form-control ng-blur=$ctrl.getActivities() ng-enter=$ctrl.getActivities() ng-model=$ctrl.filter.centroCosto><th class=ng-table-filters><input class=form-control ng-blur=$ctrl.getActivities() ng-enter=$ctrl.getActivities() ng-model=$ctrl.filter.date_entered><th class=ng-table-filters><input class=form-control ng-blur=$ctrl.getActivities() ng-enter=$ctrl.getActivities() ng-model=$ctrl.filter.created_by_name><th><tbody><tr ng-show=\"$ctrl.loading && !$ctrl.error\"><td colspan=6><span aria-hidden=true>Cargando registros... <i class=\"fa fa-history load-animation\"></i></span><tr ng-show=\"!$ctrl.loading && ($ctrl.error || $ctrl.activities.length == 0)\"><td colspan=6><span aria-hidden=true>{{$ctrl.errorMsg}}</span><tr ng-repeat=\"actividad in $ctrl.activities\" ng-if=\"!$ctrl.loading && $ctrl.activities.length\"><td>{{actividad.name}}<td>{{actividad.centroCosto}}<td>{{actividad.date_entered}}<td>{{actividad.created_by_name}}<td><button ng-click=\"$ctrl.detalle.id = actividad.id;$ctrl.detalle.referencia = actividad.referencia;$ctrl.detalle.rut = actividad.name;\" class=\"btn btn-default\"><span class=\"glyphicon glyphicon-align-justify\"></span></button></table></div><div class=col-sm-6><div class=\"row mt-10 small time-update\"><i class=\"fa fa-refresh\"></i> <b>Última Actualización:</b> <span class=\"text-muted ng-binding\"><i>{{$ctrl.ultimaActualizacion}}</i></span></div></div><div class=col-sm-6><div class=row><div class=\"filter-resume pull-right\">{{($ctrl.currentPage - 1) * 20 + 1}} - <span ng-show=\"($ctrl.currentPage - 1) *  20 +  20 < $ctrl.totalItems\">{{($ctrl.currentPage - 1) * 20 + 20}} </span><span ng-show=\"($ctrl.currentPage - 1) *  20 +  20 >= $ctrl.totalItems\">{{$ctrl.totalItems}} </span>de {{$ctrl.totalItems}} actas</div></div><div class=row><ul uib-pagination total-items=$ctrl.totalItems ng-change=$ctrl.getActivities() ng-model=$ctrl.currentPage previous-text=&lsaquo; next-text=&rsaquo; first-text=&laquo; last-text=&raquo; max-size=5 class=pagination-sm items-per-page=20 boundary-links=true num-pages=$ctrl.totalPages></ul></div></div></div><div ng-if=!$ctrl.detalle.id class=row></div><div ng-repeat=\"actividad in $ctrl.activities\" ng-if=\"!$ctrl.loading && $ctrl.activities.length\"><table ng-if=\"$ctrl.detalle.id == actividad.id\" class=\"table mt-5\"><tr><td class=\"text-right active align-middle\" width=15%><strong>Creado Por:</strong><td class=\"text-left align-middle\" width=45%>{{actividad.created_by_name}}<td class=\"text-right active align-middle\" width=20%><strong>Fecha de Creación:</strong><td class=\"text-left align-middle\" width=40%>{{actividad.date_entered}}<tr><td class=\"text-right active align-middle\"><strong>Modificado Por:</strong><td class=\"text-left align-middle\">{{actividad.modified_by_name}}<td class=\"text-right active align-middle\"><strong>Última Modificación:</strong><td class=\"text-left align-middle\">{{actividad.date_modified}}<tr><td class=\"text-right active align-middle\"><strong>Asunto:</strong><td class=\"text-left align-middle\">{{actividad.name}}<td class=\"text-right active align-middle\"><strong>Usuario:</strong><td class=\"text-left align-middle\">{{actividad.assigned_user_name}}<tr><td class=\"text-right active align-middle\"><strong>Fecha Inicio:</strong><td class=\"text-left align-middle\">{{actividad.inicia}}<td class=\"text-right active align-middle\"><strong>Fecha Fin:</strong><td class=\"text-left align-middle\">{{actividad.termina}}<tr><td class=\"text-right active align-middle\"><strong>Centro de Costo:</strong><td class=\"text-left align-middle\">{{actividad.centroCosto}}<td class=\"text-right active align-middle\"><strong>Reuniones:</strong><td class=\"text-left align-middle\">{{actividad.pnt_acta_meetings_name}}<tr><td class=\"text-right active align-middle\"><strong>Asistentes:</strong><td class=\"text-left align-middle\" ng-bind-html=\"actividad.description | toTrusted\" colspan=3><tr><td class=\"text-right active align-middle\"><strong>Próposito:</strong><td class=\"text-left align-middle\" ng-bind-html=\"actividad.acuerdos | toTrusted\" colspan=3><tr><td class=\"text-right active align-middle\"><strong>Observaciones:</strong><td class=\"text-left align-middle\" ng-bind-html=\"actividad.pendientes | toTrusted\" colspan=3></table><div ng-if=\"$ctrl.detalle.id == actividad.id\"><div class=mt-5></div><div class=\"tabs-title ng-binding\"><h5>Tareas</h5></div><table border=1 class=\"table table-condensed table-bordered table-striped listado table-min-space small\"><thead><tr><th>Asunto<th>Estado<th>Fecha de Modificación<th>Fecha de Creación<th>Fecha de Vencimiento<th>Usuario Asignado<tbody><tr ng-repeat=\"acta in actividad.actasAsociadas\"><td><a target=_blank href=#!/app/consultas/tareas/{{acta.id}}>{{acta.name}}</a><td>{{acta.status}}<td>{{acta.date_modified}}<td>{{acta.date_entered}}<td>{{acta.date_due}}<td>{{acta.nombre_responsable}}<tr ng-if=\"actividad.actasAsociadas.length == 0\"><td colspan=7>Esta Acta no tiene tareas asociadas</table></div><div class=row><div ng-if=\"$ctrl.detalle.id == actividad.id\" class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4\" style=\"line-height: 2.3em; font-size: 0.9em\"><i class=\"fa fa-chart-bar\"></i> <span><b><i class=\"fa fa-bar-chart\"></i> Última Actualización:</b> </span><span class=\"text-min ng-binding\">{{$ctrl.ultimaActualizacion}}</span></div></div></div><div class=\"mt-20 row\"><div class=col-md-6><div ng-if=$ctrl.detalle.id class=pull-left><button ng-click=\"$ctrl.detalle = {};\" class=\"btn btn-default\" type=button><span class=\"glyphicon glyphicon-chevron-left\"></span> Volver al listado</button></div></div><div class=col-md-6 ng-if=\"$ctrl.totalItems > 0 && !$ctrl.detalle.id\"><button ng-click=$ctrl.exportarXls() class=\"btn btn-success pull-right\" type=button><span>Exportar Excel <i class=\"fa fa-file-excel-o\" aria-hidden=true></i></span></button> <a id=labelprueba href=\"\" download></a></div><div class=col-md-6 ng-if=\"$ctrl.totalItems > 0 && $ctrl.detalle.id\"><button ng-click=$ctrl.exportarPdf() class=\"btn btn-success pull-right\" type=button><span>Exportar PDF <i class=\"fa fa-file-pdf-o\" aria-hidden=true></i></span></button> <a id=labelprueba href=\"\" target=blank download></a></div></div><div ng-show=$ctrl.exportLoading class=loadAnimation><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div></div>";

/***/ },
/* 471 */
/***/ function(module, exports) {

	module.exports = "<div class=consultas><table class=\"table table-condensed table-bordered table-striped listado table-min-space\"><thead><tr><th style=\"width: 11%\"><span>Hora Inicial</span><th style=\"width: 10%\"><span>Hora Final</span><th style=\"width: 10%\"><span>Turno</span><th style=\"width: 35%\"><span>Descripción</span><th style=\"width: 13%\"><span>Frecuencia</span><th style=\"width: 20%\"><span>Tipo</span><th style=\"width: 5%\"><span>Lun</span><th style=\"width: 5%\"><span>Mar</span><th style=\"width: 5%\"><span>Mier</span><th style=\"width: 5%\"><span>Jue</span><th style=\"width: 5%\"><span>Vier</span><th style=\"width: 5%\"><span>Sab</span><th style=\"width: 5%\"><span>Dom</span><tr><th class=ng-table-filters><input class=form-control ng-blur=$ctrl.getActivities() ng-enter=$ctrl.getActivities() ng-model=$ctrl.filter.hora_inicial_24_desde><th class=ng-table-filters><input class=form-control ng-blur=$ctrl.getActivities() ng-enter=$ctrl.getActivities() ng-model=$ctrl.filter.hora_final_24_hasta><th class=ng-table-filters><select class=form-control ng-change=$ctrl.getActivities() ng-model=$ctrl.filter.turno><option value=\"\"><option value=AM>AM<option value=PM>PM</select><th class=ng-table-filters><input class=form-control ng-blur=$ctrl.getActivities() ng-enter=$ctrl.getActivities() ng-model=$ctrl.filter.description><th class=ng-table-filters><select class=form-control ng-change=$ctrl.getActivities() ng-model=$ctrl.filter.frecuencia><option value=\"\"><option value=Diario>Diario<option value=Semanal>Semanal<option value=Mensual>Mensual<option value=Bimestral>Bimestral<option value=Trimestral>Trimestral<option value=Semestral>Semestral<option value=Anual>Anual<option value=Quincenal>Quincenal</select><th class=ng-table-filters><select class=form-control ng-change=$ctrl.getActivities() ng-model=$ctrl.filter.tipo><option value=\"\"><option value=\"Actividad especial\">Actividad especial<option value=\"Actividad regular\">Actividad regular</select><th class=ng-table-filters><th class=ng-table-filters><th class=ng-table-filters><th class=ng-table-filters><th class=ng-table-filters><th class=ng-table-filters><th class=ng-table-filters><tbody><tr ng-show=\"$ctrl.loading && !$ctrl.error\"><td colspan=13><span aria-hidden=true>Cargando registros... <i class=\"fa fa-history load-animation\"></i></span><tr ng-show=\"!$ctrl.loading && ($ctrl.error || $ctrl.activities.length == 0)\"><td colspan=13><span aria-hidden=true>{{$ctrl.errorMsg}}</span><tr ng-repeat=\"actividad in $ctrl.activities \" ng-if=\"!$ctrl.loading && $ctrl.activities.length\"><td class=\"text-left small\">{{actividad.hora_inicial_24}}<td class=\"text-left small\">{{actividad.hora_final_24}}<td class=\"text-left small\">{{actividad.turno}}<td class=\"text-left small\">{{actividad.description}}<td class=\"text-left small\">{{actividad.frecuencia}}<td class=\"text-left small\">{{actividad.tipo}}<td class=\"text-left small\"><span ng-if=\"actividad.dia_lunes == 1\" class=\"glyphicon glyphicon-ok\" aria-hidden=true></span> <span ng-if=\"actividad.dia_lunes == 0\" class=\"glyphicon glyphicon glyphicon-remove\" aria-hidden=true></span><td class=\"text-left small\"><span ng-if=\"actividad.dia_martes == 1\" class=\"glyphicon glyphicon-ok\" aria-hidden=true></span> <span ng-if=\"actividad.dia_martes == 0\" class=\"glyphicon glyphicon glyphicon-remove\" aria-hidden=true></span><td class=\"text-left small\"><span ng-if=\"actividad.dia_miercoles == 1\" class=\"glyphicon glyphicon-ok\" aria-hidden=true></span> <span ng-if=\"actividad.dia_miercoles == 0\" class=\"glyphicon glyphicon glyphicon-remove\" aria-hidden=true></span><td class=\"text-left small\"><span ng-if=\"actividad.dia_jueves == 1\" class=\"glyphicon glyphicon-ok\" aria-hidden=true></span> <span ng-if=\"actividad.dia_jueves == 0\" class=\"glyphicon glyphicon glyphicon-remove\" aria-hidden=true></span><td class=\"text-left small\"><span ng-if=\"actividad.dia_viernes == 1\" class=\"glyphicon glyphicon-ok\" aria-hidden=true></span> <span ng-if=\"actividad.dia_viernes == 0\" class=\"glyphicon glyphicon glyphicon-remove\" aria-hidden=true></span><td class=\"text-left small\"><span ng-if=\"actividad.dia_sabado == 1\" class=\"glyphicon glyphicon-ok\" aria-hidden=true></span> <span ng-if=\"actividad.dia_sabado == 0\" class=\"glyphicon glyphicon glyphicon-remove\" aria-hidden=true></span><td class=\"text-left small\"><span ng-if=\"actividad.dia_domingo == 1\" class=\"glyphicon glyphicon-ok\" aria-hidden=true></span> <span ng-if=\"actividad.dia_domingo == 0\" class=\"glyphicon glyphicon glyphicon-remove\" aria-hidden=true></span></table><div class=col-sm-6><div class=\"row mt-10 small time-update\"><i class=\"fa fa-refresh\"></i> <b>Última Actualización:</b> <span class=\"text-muted ng-binding\"><i>{{$ctrl.ultimaActualizacion}}</i></span></div></div><div class=col-sm-6><div class=row><div class=\"filter-resume pull-right\">{{($ctrl.currentPage - 1) * 20 + 1}} - <span ng-show=\"($ctrl.currentPage - 1) *  20 +  20 < $ctrl.totalItems\">{{($ctrl.currentPage - 1) * 20 + 20}} </span><span ng-show=\"($ctrl.currentPage - 1) *  20 +  20 >= $ctrl.totalItems\">{{$ctrl.totalItems}} </span>de {{$ctrl.totalItems}} detalles de rutina</div></div><div class=row><ul uib-pagination total-items=$ctrl.totalItems ng-change=$ctrl.getActivities() ng-model=$ctrl.currentPage previous-text=&lsaquo; next-text=&rsaquo; first-text=&laquo; last-text=&raquo; max-size=5 class=pagination-sm items-per-page=20 boundary-links=true num-pages=$ctrl.totalPages></ul></div></div></div><div class=row></div><div style=margin-top:20px class=row><div class=\"col-lg-6 col-md-6\"><div class=pull-left><button ng-click=\"$ctrl.id = null;\" class=\"btn btn-default\" type=button><a style=\"color: #777\"><span class=\"glyphicon glyphicon-chevron-left\"></span> Volver al listado</a></button></div></div><div class=col-md-6 ng-if=\"$ctrl.totalItems > 0\"><div class=pull-right><button ng-click=$ctrl.exportarPdf() class=\"btn btn-success\" type=button><span>Exportar a .PDF <i class=\"fa fa-file-pdf-o\" aria-hidden=true></i></span></button> <button ng-click=$ctrl.exportarXls($ctrl.$stateParams.id) class=\"btn btn-success\" type=button><span><i ng-show=$ctrl.exportLoading2 style=color:#fff class=\"fa fa-history load-animation\"></i> Exportar a .XLS <i class=\"fa fa-file-xls-o\" aria-hidden=true></i></span></button></div></div><a id=labelprueba href=\"\" target=_blank download></a></div><div ng-show=$ctrl.exportLoading class=loadAnimation><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div>";

/***/ },
/* 472 */
/***/ function(module, exports) {

	module.exports = "<div class=\"container mb-20\"><div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{$ctrl.shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li class=active><span>Rutinas</span></ul></div></div></div></div><div class=\"mb-10 small text-right\"><i class=\"fa fa-refresh\"></i> <b>Última Actualización:</b> <span class=\"text-muted ng-binding\"><i>{{$ctrl.ultimaActualizacion}}</i></span></div><div class=\"tabs-title ng-binding\"><h5 ng-if=!$ctrl.detalle.id>RUTINAS</h5><h5 ng-if=$ctrl.detalle.id>RUTINA {{$ctrl.detalle.rut}}</h5></div><div class=consultas ng-if=!$ctrl.detalle.id><div class=table-responsive><table class=\"table table-condensed table-bordered table-striped listado table-min-space small\"><thead><tr><th style=\"width: 30%\" class=sort ng-click=\"$ctrl.orderBy('name');\"><span>Nombre </span><span class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 30%\" class=sort ng-click=\"$ctrl.orderBy('area');\"><span>Área </span><span class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 30\" class=sort ng-click=\"$ctrl.orderBy('turno_nocturno');\"><span>Horario </span><span class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 30\" class=sort ng-click=\"$ctrl.orderBy('centroCosto');\"><span>Centro de costo </span><span class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 10%\">Ver / Descargar<tr><th class=ng-table-filters><input class=form-control ng-blur=$ctrl.getActivities() ng-enter=$ctrl.getActivities() ng-model=$ctrl.filter.name><th class=ng-table-filters><input class=form-control ng-blur=$ctrl.getActivities() ng-enter=$ctrl.getActivities() ng-model=$ctrl.filter.area><th class=ng-table-filters><select class=form-control ng-change=$ctrl.getActivities() ng-model=$ctrl.filter.turno_nocturno><option value=\"\">Todas<option value=0>Diurno<option value=1>Nocturno</select><th class=ng-table-filters><input class=form-control ng-blur=$ctrl.getActivities() ng-enter=$ctrl.getActivities() ng-model=$ctrl.filter.centroCosto><th><tbody><tr ng-show=\"$ctrl.loading && !$ctrl.error\"><td colspan=6><span aria-hidden=true>Cargando registros... <i class=\"fa fa-history load-animation\"></i></span><tr ng-show=\"!$ctrl.loading && ($ctrl.error || $ctrl.activities.length == 0)\"><td colspan=6><span aria-hidden=true>{{$ctrl.errorMsg}}</span><tr ng-repeat=\"actividad in $ctrl.activities \" ng-if=\"!$ctrl.loading && $ctrl.activities.length\"><td>{{actividad.name}}<td>{{actividad.area}}<td>{{actividad.turno_nocturno}}<td>{{actividad.centroCosto}}<td><button ng-click=\"$ctrl.detalle.id = actividad.id;$ctrl.detalle.rut = actividad.name;\" class=\"btn btn-default\"><span class=\"glyphicon glyphicon-align-justify\"></span></button></table></div><div class=col-sm-6><div class=\"row mt-10 small time-update\"><i class=\"fa fa-refresh\"></i> <b>Última Actualización:</b> <span class=\"text-muted ng-binding\"><i>{{$ctrl.ultimaActualizacion}}</i></span></div></div><div class=col-sm-6><div class=row><div class=\"filter-resume pull-right\">{{($ctrl.currentPage - 1) * 20 + 1}} - <span ng-show=\"($ctrl.currentPage - 1) *  20 +  20 < $ctrl.totalItems\">{{($ctrl.currentPage - 1) * 20 + 20}} </span><span ng-show=\"($ctrl.currentPage - 1) *  20 +  20 >= $ctrl.totalItems\">{{$ctrl.totalItems}} </span>de {{$ctrl.totalItems}} rutinas</div></div><div class=row><ul uib-pagination total-items=$ctrl.totalItems ng-change=$ctrl.getActivities() ng-model=$ctrl.currentPage previous-text=&lsaquo; next-text=&rsaquo; first-text=&laquo; last-text=&raquo; max-size=5 class=pagination-sm items-per-page=20 boundary-links=true num-pages=$ctrl.totalPages></ul></div></div><div class=\"mt-20 row\"><div class=\"col-md-offset-6 mt-20 col-md-6\" ng-if=\"$ctrl.totalItems > 0\"><button ng-click=$ctrl.exportarXls() class=\"btn btn-success pull-right\" type=button><span><i ng-show=$ctrl.exportLoading style=color:#fff class=\"fa fa-history load-animation\"></i>Exportar Excel <i class=\"fa fa-file-excel-o\" aria-hidden=true></i></span></button> <a id=labelprueba href=\"\" download></a></div></div></div><routines-detail ng-if=$ctrl.detalle.id sh-ctrl=$ctrl.shCtrl id=$ctrl.detalle.id rut=$ctrl.detalle.rut></routines-detail></div>";

/***/ },
/* 473 */
/***/ function(module, exports) {

	module.exports = "<div class=\"container mb-20\"><div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{$ctrl.shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li class=active><span>Actividades Específicas</span></ul></div></div></div></div><div class=\"mb-10 small text-right\"><i class=\"fa fa-refresh\"></i> <b>Última Actualización:</b> <span class=\"text-muted ng-binding\"><i>{{$ctrl.ultimaActualizacion}}</i></span></div><div class=\"tabs-title ng-binding\"><h5>ACTIVIDADES ESPECÍFICAS</h5></div><div class=consultas><div class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-condensed table-bordered table-striped listado table-min-space small\"><thead><tr><th style=\"width: 17%\" class=sort ng-click=\"$ctrl.orderBy('name');\"><span>Nombre de la actividad </span><span ng-if=!$ctrl.search.id class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 30%\" class=sort ng-click=\"$ctrl.orderBy('description');\"><span>Descripción </span><span ng-if=!$ctrl.search.id class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 11%\" class=sort ng-click=\"$ctrl.orderBy('date_start');\"><span>Fecha Inicio </span><span ng-if=!$ctrl.search.id class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 11%\" class=sort ng-click=\"$ctrl.orderBy('date_due');\"><span>Fecha Final </span><span ng-if=!$ctrl.search.id class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 9%\" class=sort ng-click=\"$ctrl.orderBy('estado');\"><span>Estado </span><span ng-if=!$ctrl.search.id class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 12%\" class=sort ng-click=\"$ctrl.orderBy('centroCosto');\"><span>Centro de Costo</span><th style=\"width: 18%\" class=sort ng-click=\"$ctrl.orderBy('tipo_c');\"><span>Tipo Actividad</span><tr><th class=ng-table-filters ng-if=!$ctrl.search.id><input class=form-control ng-blur=$ctrl.getActivities() ng-enter=$ctrl.getActivities() ng-model=$ctrl.filter.name><th class=ng-table-filters ng-if=!$ctrl.search.id><input ng-if=!$ctrl.search.id class=form-control ng-blur=$ctrl.getActivities() ng-enter=$ctrl.getActivities() ng-model=$ctrl.filter.description><th class=ng-table-filters ng-if=!$ctrl.search.id><input ng-if=!$ctrl.search.id class=form-control ng-blur=$ctrl.getActivities() ng-enter=$ctrl.getActivities() ng-model=$ctrl.filter.date_start_desde><th class=ng-table-filters ng-if=!$ctrl.search.id><input ng-if=!$ctrl.search.id class=form-control ng-blur=$ctrl.getActivities() ng-enter=$ctrl.getActivities() ng-model=$ctrl.filter.date_due_hasta><th class=ng-table-filters ng-if=!$ctrl.search.id><select ng-if=!$ctrl.search.id class=form-control ng-change=$ctrl.getActivities() ng-model=$ctrl.filter.estado><option value=\"\">Todas<option value=Cerrada>Cerrada<option value=Ejecutada>Ejecutada<option value=Programada>Programada</select><th class=ng-table-filters ng-if=!$ctrl.search.id><input ng-if=!$ctrl.search.id class=form-control ng-blur=$ctrl.getActivities() ng-enter=$ctrl.getActivities() ng-model=$ctrl.filter.centroCosto><th class=ng-table-filters ng-if=!$ctrl.search.id><select ng-if=!$ctrl.search.id class=form-control ng-change=$ctrl.getActivities() ng-model=$ctrl.filter.tipo_c><option value=\"\">Todas<option value=\"Mantenimiento de Piso\">Mantenimiento de Piso<option value=Limpieza>Limpieza<option value=Otro>Otro</select><tbody><tr ng-show=\"$ctrl.loading && !$ctrl.error\"><td colspan=6><span aria-hidden=true>Cargando registros... <i class=\"fa fa-history load-animation\"></i></span><tr ng-show=\"!$ctrl.loading && ($ctrl.error || $ctrl.activities.length == 0)\"><td colspan=6><span aria-hidden=true>{{$ctrl.errorMsg}}</span><tr ng-repeat=\"actividad in $ctrl.activities | filter:$ctrl.search\" ng-if=\"!$ctrl.loading && $ctrl.activities.length\"><td>{{actividad.name}}<td class=text-left>{{actividad.description}}<td>{{actividad.date_start}}<td>{{actividad.date_due}}<td>{{actividad.estado}}<td>{{actividad.centroCosto}}<td>{{actividad.tipo_c}}</table></div></div></div><div class=col-sm-6><div class=\"row mt-10 small time-update\"><i class=\"fa fa-refresh\"></i> <b>Última Actualización:</b> <span class=\"text-muted ng-binding\"><i>{{$ctrl.ultimaActualizacion}}</i></span></div></div><div class=col-sm-6 ng-if=!$ctrl.search.id><div class=row><div class=\"filter-resume pull-right\">{{($ctrl.currentPage - 1) * 20 + 1}} - <span ng-show=\"($ctrl.currentPage - 1) *  20 +  20 < $ctrl.totalItems\">{{($ctrl.currentPage - 1) * 20 + 20}} </span><span ng-show=\"($ctrl.currentPage - 1) *  20 +  20 >= $ctrl.totalItems\">{{$ctrl.totalItems}} </span>de {{$ctrl.totalItems}} actividades especificas</div></div><div class=row><ul uib-pagination total-items=$ctrl.totalItems ng-change=$ctrl.getActivities() ng-model=$ctrl.currentPage previous-text=&lsaquo; next-text=&rsaquo; first-text=&laquo; last-text=&raquo; max-size=5 class=pagination-sm items-per-page=20 boundary-links=true num-pages=$ctrl.totalPages></ul></div></div><div class=row><div class=\"col-md-6 mt-20\"><div ng-if=$ctrl.search.id class=pull-left><button ng-click=\"$ctrl.search = {};\" class=\"btn btn-default\" type=button><span class=\"glyphicon glyphicon-chevron-left\"></span> Volver al listado</button></div></div><div class=\"col-md-6 mt-20\" ng-if=\"$ctrl.totalItems > 0\"><button ng-click=$ctrl.exportarXls() class=\"btn btn-success pull-right\" type=button><span><i ng-show=$ctrl.exportLoading style=color:#fff class=\"fa fa-history load-animation\"></i>Exportar Excel <i class=\"fa fa-file-excel-o\" aria-hidden=true></i></span></button> <a id=labelprueba href=\"\" download></a></div></div><style>.sort {\r\n        cursor: pointer;\r\n        font-size: 14px\r\n      }</style></div></div>";

/***/ },
/* 474 */
/***/ function(module, exports) {

	module.exports = "<div class=\"container mb-20\"><div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{$ctrl.shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li class=active><span>Tareas</span></ul></div></div></div></div><div class=\"mb-10 small text-right\"><i class=\"fa fa-refresh\"></i> <b>Última Actualización:</b> <span class=\"text-muted ng-binding\"><i>{{$ctrl.ultimaActualizacion}}</i></span></div><div class=\"tabs-title ng-binding\"><h5>TAREAS</h5></div><div class=consultas ng-if=!$ctrl.detalle.id><div class=table-responsive><table class=\"table table-condensed table-bordered table-striped listado table-min-space small\"><thead><tr><th style=\"width: 15%\" class=sort ng-click=\"$ctrl.orderBy('name');\"><span>Asunto </span><span ng-if=!$ctrl.search.id class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 15%\" class=sort ng-click=\"$ctrl.orderBy('tipo_actividad');\"><span>Tipo de Actividad </span><span ng-if=!$ctrl.search.id class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 12%\" class=sort ng-click=\"$ctrl.orderBy('date_start');\"><span>Fecha de Inicio </span><span ng-if=!$ctrl.search.id class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 12%\" class=sort ng-click=\"$ctrl.orderBy('date_due');\"><span>Fecha de Cierre </span><span ng-if=!$ctrl.search.id class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 30\" class=sort ng-click=\"$ctrl.orderBy('nombre_responsable');\"><span>Responsable </span><span ng-if=!$ctrl.search.id class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 30\" class=sort ng-click=\"$ctrl.orderBy('status');\"><span>Estado </span><span ng-if=!$ctrl.search.id class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 13%\" class=sort ng-click=\"$ctrl.orderBy('centroCosto');\"><span>Centro de Costo </span><span ng-if=!$ctrl.search.id class=\"glyphicon glyphicon-sort\"></span><th style=\"width: 10%\">Ver / Descargar<tr><th class=ng-table-filters><input class=form-control ng-blur=$ctrl.getActivities() ng-enter=$ctrl.getActivities() ng-model=$ctrl.filter.name><th class=ng-table-filters><select class=form-control ng-model=$ctrl.filter.tipo_actividad ng-change=$ctrl.getActivities()><option value=\"\">Todas<option value=\"Accidente de trabajo\">Accidente de trabajo<option value=\"Auditoria Costos\">Auditoria Costos<option value=\"Auditoria de servicio\">Auditoria de servicio<option value=\"Auditoria externa\">Auditoria externa<option value=\"Auditoria interna\">Auditoria interna<option value=\"Capacitacion Bimestral\">Capacitacion Bimestral<option value=\"Comunicacion interna\">Comunicación Interna<option value=DomiciolioJueves>Domicilios Jueves<option value=DomiliosMartes>Domicilios Martes<option value=\"Envio cotizacion\">Envío Cotización<option value=\"Evaluacion mantenimiento\">Evaluación mantenimiento<option value=\"Evaluacion personal\">Evaluación personal<option value=Furat>Furat<option value=Incapacidad>Incapacidad<option value=Indicadores>Indicadores<option value=Informe>Informe<option value=\"Informe de llegadas tardes\">Informe de llegadas tardes<option value=\"Informe disciplinario\">Informe disciplinario<option value=\"Inspeccion Gerencial\">Inspección Gerencial<option value=\"Inspeccion salud ocupacional\">Inspección salud ocupacional<option value=Llamada>Llamada<option value=\"Medicion de limpieza\">Medicion de limpieza<option value=PQRS>PQRS<option value=Presupuesto>Presupuesto<option value=Retroalimentacion>Retroalimentación<option value=Reunion>Reunión<option value=\"Revision procesos\">Revision de Procesos<option value=\"Revision por la direccion\">Revisión por la direccion<option value=\"RQ Insumos\">RQ Insumos<option value=\"RQ Personal\">RQ Personal<option value=\"Satisfaccion Cliente\">Satisfaccion Cliente<option value=Seguimiento>Seguimiento<option value=SeguimientoC>Seguimiento Comite GH<option value=\"Seguimiento iniciacion\">Seguimiento iniciación<option value=\"Solicitud Facturacion\">Solicitud Facturación<option value=\"Solicitud Mercadeo\">Solicitud Mercadeo<option value=Visita>Visita comercial<option value=\"Visita operativa\">Visita operativa</select><th class=ng-table-filters><input class=form-control ng-blur=$ctrl.getActivities() ng-enter=$ctrl.getActivities() ng-model=$ctrl.filter.date_start><th class=ng-table-filters><input class=form-control ng-blur=$ctrl.getActivities() ng-enter=$ctrl.getActivities() ng-model=$ctrl.filter.date_due><th class=ng-table-filters><input class=form-control ng-blur=$ctrl.getActivities() ng-enter=$ctrl.getActivities() ng-model=$ctrl.filter.nombre_responsable><th class=ng-table-filters><select class=form-control ng-change=$ctrl.getActivities() ng-model=$ctrl.filter.status><option value=\"\">Todas<option value=\"No Iniciada\">No Iniciada<option value=\"En Progreso\">En Progreso<option value=Completada>Completada<option value=\"Pendiente de Información\">Pendiente de Información<option value=Aplazada>Aplazada</select><th class=ng-table-filters><input class=form-control ng-blur=$ctrl.getActivities() ng-enter=$ctrl.getActivities() ng-model=$ctrl.filter.centroCosto><th><tbody><tr ng-show=\"$ctrl.loading && !$ctrl.error\"><td colspan=9><span aria-hidden=true>Cargando registros... <i class=\"fa fa-history load-animation\"></i></span><tr ng-show=\"!$ctrl.loading && ($ctrl.error || $ctrl.activities.length == 0)\"><td colspan=9><span aria-hidden=true>{{$ctrl.errorMsg}}</span><tr ng-repeat=\"actividad in $ctrl.activities\" ng-if=\"!$ctrl.loading && $ctrl.activities.length\"><td>{{actividad.name}}<td>{{actividad.tipo_actividad}}<td>{{actividad.date_start}}<td>{{actividad.date_due}}<td>{{actividad.nombre_responsable}}<td>{{actividad.status}}<td>{{actividad.centroCosto}}<td><button ng-click=\"$ctrl.detalle.id = actividad.id;$ctrl.detalle.rut = actividad.name;\" class=\"btn btn-default\"><span class=\"glyphicon glyphicon-align-justify\"></span></button></table></div><div class=col-sm-6><div class=\"row mt-10 small time-update\"><i class=\"fa fa-refresh\"></i> <b>Última Actualización:</b> <span class=\"text-muted ng-binding\"><i>{{$ctrl.ultimaActualizacion}}</i></span></div></div><div class=col-sm-6><div class=row><div class=\"filter-resume pull-right\">{{($ctrl.currentPage - 1) * 20 + 1}} - <span ng-show=\"($ctrl.currentPage - 1) *  20 +  20 < $ctrl.totalItems\">{{($ctrl.currentPage - 1) * 20 + 20}} </span><span ng-show=\"($ctrl.currentPage - 1) *  20 +  20 >= $ctrl.totalItems\">{{$ctrl.totalItems}} </span>de {{$ctrl.totalItems}} tareas</div></div><div class=row><ul uib-pagination total-items=$ctrl.totalItems ng-change=$ctrl.getActivities() ng-model=$ctrl.currentPage previous-text=&lsaquo; next-text=&rsaquo; first-text=&laquo; last-text=&raquo; max-size=5 class=pagination-sm items-per-page=20 boundary-links=true num-pages=$ctrl.totalPages></ul></div></div></div><div ng-if=!$ctrl.detalle.id class=row></div><div ng-repeat=\"actividad in $ctrl.activities\" ng-if=\"!$ctrl.loading && $ctrl.activities.length\"><table ng-if=\"$ctrl.detalle.id == actividad.id\" class=\"table mt-5 small\"><tr><td class=\"active text-right\"><strong>Asunto:</strong><td class=text-left>{{actividad.name}}<td class=\"active text-right\"><strong>Estado:</strong><td class=text-left>{{actividad.status}}<tr><td class=\"active text-right\"><strong>Descripción de la acción:</strong><td ng-bind-html=\"actividad.description | toTrusted\" colspan=3 class=text-left><tr><td class=\"active text-right\"><strong>Fecha de inicio:</strong><td class=text-left>{{actividad.date_start}}<td class=\"active text-right\"><strong>Fecha de cierre:</strong><td class=text-left>{{actividad.date_due}}<tr><td class=\"active text-right\"><strong>Verificación:</strong><td class=text-left><span ng-show=\"actividad.verificacion == '1'\" class=\"glyphicon glyphicon-ok\" aria-hidden=true></span><span ng-show=\"actividad.verificacion == '0'\" class=\"glyphicon glyphicon-remove\" aria-hidden=true></span><td class=\"active text-right\"><strong>Centro de Costo:</strong><td class=text-left>{{actividad.centroCosto}}<tr><td class=\"active text-right\"><strong>Responsable:</strong><td class=text-left>{{actividad.nombre_responsable}}<td class=\"active text-right\"><strong>Tipo de Actividad:</strong><td class=text-left>{{actividad.tipo_actividad}}<tr ng-if=actividad.pqrs><td class=\"active text-right\"><strong>PQRS:</strong><td colspan=3 class=text-left>{{actividad.pqrs}}</table></div><div class=row><div ng-if=$ctrl.detalle.id class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4\" style=\"line-height: 2.3em; font-size: 0.9em\"><i class=\"fa fa-chart-bar\"></i> <span><b><i class=\"fa fa-bar-chart\"></i> Última Actualización:</b> </span><span class=\"text-min ng-binding\">{{$ctrl.ultimaActualizacion}}</span></div></div><div class=\"mt-20 row\"><div class=col-md-6><div ng-if=$ctrl.detalle.id class=pull-left><button ng-click=$ctrl.volverAlListado() class=\"btn btn-default\" type=button><span class=\"glyphicon glyphicon-chevron-left\"></span> Volver al listado</button></div></div><div class=col-md-6 ng-if=\"$ctrl.totalItems > 0 && !$ctrl.detalle.id\"><button ng-click=$ctrl.exportarXls() class=\"btn btn-success pull-right\" type=button><span>Exportar Excel <i class=\"fa fa-file-excel-o\" aria-hidden=true></i></span></button> <a id=labelprueba href=\"\" download></a></div><div class=col-md-6 ng-if=\"$ctrl.totalItems > 0 && $ctrl.detalle.id\"><button ng-click=$ctrl.exportarPdf() class=\"btn btn-success pull-right\" type=button><span>Exportar PDF <i class=\"fa fa-file-pdf-o\" aria-hidden=true></i></span></button> <a id=labelprueba href=\"\" target=blank download></a></div></div><div ng-show=$ctrl.exportLoading class=loadAnimation><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div></div>";

/***/ },
/* 475 */,
/* 476 */
/***/ function(module, exports) {

	module.exports = "<div id=wrapper><div id=pestana_der ng-if=\"shCtrl.globals.currentUser.isLogged && shCtrl.ngAuthSettings.site.config.header.show_tab_right\"><ul id=toolsLinks class=\"list-unstyled text-center\"><li ng-if=\"shCtrl.globals.currentUser.isSeller || shCtrl.globals.currentUser.isContactCenter\"><a ui-sref=home.contactCenterHome><i class=\"fa fa-home\"></i></a><div class=\"ttip_pd bounceInRight\" ng-show=\"shCtrl.globals.currentUser.isSeller && !shCtrl.globals.currentUser.isContactCenter\">Inicio Vendedor ({{shCtrl.globals.currentUser.contactName}})</div><div class=\"ttip_pd bounceInRight\" ng-show=shCtrl.globals.currentUser.isContactCenter>Inicio Contact Center ({{shCtrl.globals.currentUser.contactName}})</div><li ng-click=shCtrl.showModalCartSellerHeader() ng-if=\"shCtrl.globals.currentUser.isSeller || shCtrl.globals.currentUser.isContactCenter\"><a href=# onclick=\"return false\"><i class=\"fa fa-user-plus\"></i></a><div class=\"ttip_pd bounceInRight\">Crear/Seleccionar Cliente</div><li><a ui-sref=home.salesHome ng-if=shCtrl.globals.currentUser.isB2B><i class=\"fa fa-bar-chart-o\"></i></a><div class=\"ttip_pd bounceInRight\">Dashboard</div><li ng-if=\"shCtrl.globals.currentUser.isLogged && shCtrl.globals.currentUser.isMaster\"><a ui-sref=home.users><i class=\"fa fa-users\"></i></a><div class=\"ttip_pd bounceInRight\">Usuarios</div><li><a ui-sref=home.orders><i class=\"fa fa-pencil-square-o\"></i></a><div class=\"ttip_pd bounceInRight\">Mis Pedidos</div><li><a ui-sref=home.templates><i class=\"fa fa-list\"></i></a><div class=\"ttip_pd bounceInRight\">Mis Plantillas</div><li><a ui-sref=home.account><i class=\"fa fa-user\"></i></a><div class=\"ttip_pd bounceInRight\">Mis Datos</div></ul></div><header id=header class=header6><div id=header-top><div class=container><div class=row><div class=\"col-md-12 ng-cloak\"><div class=header-top-right ng-if=shCtrl.globals.currentUser.username><div class=\"header-text-container pull-right\"><ul id=top-links class=clearfix><li class=moneda-top><label>Moneda</label><select class=\"form-control input-sm\"><option>COP</select><li class=mi-carrito-top ng-show=\"shCtrl.globals.currentUser.userId && !shCtrl.globals.currentUser.isSeller\"><div><a ng-if=shCtrl.globals.currentUser.isSeller id=btn-seleccionar-centro-operacion-cliente ng-click=$ctrl.showModalSelectBranchUserB2B()><i class=\"fa fa-user\"></i> Seleccionar C.O.</a></div><li class=\"mi-carrito-top visible-tb\" id=usuario-tb ng-show=shCtrl.globals.currentUser.isSeller><div class=\"ttip_pd bounceInRight\"><span ng-show=!shCtrl.globals.currentClient.userId>Seleccionar cliente </span><span ng-show=shCtrl.globals.currentClient.userId>{{shCtrl.globals.currentClient.operatingCenter.name}} - {{shCtrl.globals.currentClient.third.name}}</span></div><a title=\"Seleccionar/Cambiar Cliente\" ng-click=shCtrl.showModalCartSellerHeader()><i class=\"fa fa-user\"></i> <span ng-show=shCtrl.globals.currentClient.name>{{shCtrl.globals.currentClient.name}} </span><span ng-show=!shCtrl.globals.currentClient.name>Seleccionar Cliente </span></a><a href=\"\" ng-show=shCtrl.globals.currentClient.name title=\"Volver al vendedor\" ng-click=shCtrl.removeClientSelected()><i class=\"fa fa-times\"></i></a><li class=\"mi-carrito-top visible-tb\" ng-if=shCtrl.ngAuthSettings.site.config.header.selectBranch><a href=\"\" title=\"Seleccionar Centro de Operación\" ng-click=shCtrl.showModalSelectBranchUserB2B() ng-if=\"!shCtrl.globals.currentUser.isContactCenter && !shCtrl.globals.currentUser.isSeller && shCtrl.globals.currentUser.operatingCenters.length\"><i class=\"fa fa-globe\" aria-hidden=true></i> <span ng-if=!shCtrl.globalParams.operatingCenterSelected.id>Centro de Operación</span> <span ng-if=shCtrl.globalParams.operatingCenterSelected.id>{{ shCtrl.globalParams.operatingCenterSelected.name}} - {{ shCtrl.globalParams.operatingCenterSelected.location.fullname}}</span></a><li class=\"mi-carrito-top visible-tb\" ng-if=\"shCtrl.globalParams.showCart && shCtrl.ngAuthSettings.site.config.header.show_cart_in_header\"><a ui-sref=home.cart title=\"Mi carrito\"><i class=\"fa fa-shopping-cart\"></i> <span>Mi Carrito</span></a><li class=\"mi-cuenta-top visible-tb\" ng-if=::shCtrl.ngAuthSettings.site.config.header.show_account_in_header><a ui-sref=home.dashboard title=\"Mi cuenta\"><i class=\"fa fa-desktop\"></i> <span class=\"hidden-sm hidden-xs\">Mi cuenta</span></a><li class=\"salir-top visible-tb\"><a href=\"\" ng-click=shCtrl.logout() title=\"Cerrar Sesión\"><i class=\"fa fa-sign-out\"></i> <span class=\"hidden-sm hidden-xs\">Salir</span></a></ul></div></div></div></div></div></div><div class=\"container subtop\"><div id=inner-header><div class=row><div class=\"col-md-3 col-sm-5 col-xs-5\"><div class=\"logo clearfix ng-cloak\"><span ng-bind-html=\"::shCtrl.ngAuthSettings.site.app.header.logo.title | toTrusted\"></span> <a ui-sref=home.login title={{::shCtrl.ngAuthSettings.site.app.header.logo.title}} ng-show=::shCtrl.ngAuthSettings.site.app.header.logo.title class=ng-cloak><img class=ng-cloak ng-src={{::shCtrl.ngAuthSettings.site.app.header.logo.src}} alt={{::shCtrl.ngAuthSettings.site.app.header.logo.alt}} width=100% height={{::shCtrl.ngAuthSettings.site.app.header.logo.height}}></a></div></div><div class=\"col-md-9 col-sm-7 col-xs-7\"><div class=\"header-inner-right-wrapper clearfix\"><div class=\"dropdown-cart-menu-container pull-right ng-cloak\" ng-class=\"{'margin-button-login' : shCtrl.globals.currentUser.username && !shCtrl.globals.currentClient.id}\" ng-hide=\"shCtrl.ngAuthSettings.site.config.redirectToB2bPage && !shCtrl.globals.currentUser.userId\" ng-if=\"shCtrl.globalParams.showCart && shCtrl.ngAuthSettings.site.config.header.show_cart_in_header\"><div class=\"btn-group dropdown-cart\"><a ui-sref=home.cart title=\"ver carrito\"><button type=button class=\"btn btn-custom dropdown-toggle\" data-toggle=dropdown style=background-color:#eee;color:#444><span class=cart-menu-icon></span> {{shCtrl.cart.cartQuantity}} item(s)<br><span class=drop-price ng-show=\"shCtrl.cart.items.length &&\r\n                                      shCtrl.cart.order.totalItemsToQuote !== shCtrl.cart.items.length\">$ {{shCtrl.cart.cartTotal| currency:'':0}} <span class=sub-price>COP</span> </span><span class=drop-price ng-show=\"shCtrl.cart.items.length &&\r\n                                    shCtrl.cart.order.totalItemsToQuote === shCtrl.cart.items.length\">Para Cotizar</span></button></a><div class=\"dropdown-menu dropdown-cart-menu pull-right clearfix\" role=menu><div ng-if=\"shCtrl.cart.cartQuantity > 0\"><p class=dropdown-cart-description>Items agregados<div id=wrapper-dropdown-cart-product-list ng-class=\"{'simplebar cart-resume-1-item': shCtrl.cart.items.length === 1, 'simplebar cart-resume-2-item': shCtrl.cart.items.length === 2, 'simplebar cart-resume-3-item': shCtrl.cart.items.length > 2}\" style=\"height: 335px; border-bottom: 1px solid #CCC\"><ul class=dropdown-cart-product-list><li class=\"item clearfix\" ng-repeat=\"item in shCtrl.cart.items\"><a href=\"\" ng-click=shCtrl.removeItemFromCart(item) title=\"Eliminar producto de mi carrito\" class=delete-item><i class=\"fa fa-times\"></i></a><figure><a href=./#/{{::item.category.slug}}/{{::item.slug}}><img ng-src={{item.image}} alt={{item.name}}></a></figure><div class=dropdown-cart-details><p class=item-name><a href=./#/{{::item.category.slug}}/{{::item.slug}}>{{item.name}}</a><p ng-show=!item.quote>{{item.quantity}}x <span class=item-price>$ {{item.total| currency:'':0}}</span><p ng-show=item.quote>{{item.quantity}} <span class=item-price>( Cotizar )</span></div></ul></div><ul class=dropdown-cart-total ng-show=\"shCtrl.cart.order.totalItemsToQuote !== shCtrl.cart.items.length\"><li ng-show=shCtrl.cart.cartTransports><span class=dropdown-cart-total-title>Transporte:</span> $ {{shCtrl.cart.cartTransports| currency:'':0}}<span class=sub-price> COP</span><li><span class=dropdown-cart-total-title>Total a Pagar:</span> ${{shCtrl.cart.cartTotal| currency:'':0}}<span class=sub-price> COP</span></ul><ul class=\"dropdown-cart-total peso-total\" ng-if=shCtrl.globalParams.showTotalKilosCanasta><li><span class=dropdown-cart-total-title>Total en Kilos:</span></ul><div class=dropdown-cart-action><p><a ui-sref=home.cart class=\"btn btn-custom-2 btn-block\">Ir al Carrito</a></div></div><div ng-if=!shCtrl.cart.cartQuantity><p class=dropdown-cart-description>No hay productos en su canasta.</div></div></div></div><div class=\"header-box user-box pull-right clearfix ng-cloak\"><span ng-if=!shCtrl.globals.currentUser.username class=\"header-box-icon header-box-icon-earphones\"></span><div ng-if=\"shCtrl.globals.currentUser.username && !shCtrl.globals.currentClient.id\" data-toggle=tooltip data-placement=bottom title=\"{{ shCtrl.globals.currentUser.thirdName}} / {{ shCtrl.globalParams.operatingCenterSelected.name}}\" style=\"cursor:pointer; max-width: 25em\"><span class=\"header-box-icon header-box-icon-earphones\"></span><div class=\"bienvenido-subheader text-overflow-ellipsis\"><ul class=pull-left style=\"padding: 4px 0 0 3px\"><li>Bienvenido<li><strong>Usuario:</strong> {{ shCtrl.globals.currentUser.firstname}}<li>{{ shCtrl.globals.currentClient.operatingCenter.name}}<li><strong>Cliente:</strong> <span style=\"white-space:nowrap;text-overflow: ellipsis\" class=cliente-header>{{shCtrl.globals.currentUser.thirdName}}</span></ul></div></div><div class=bienvenido-subheader ng-if=\"shCtrl.globals.currentUser.username && shCtrl.globals.currentClient.id\" data-toggle=tooltip data-placement=left title=\"{{ shCtrl.globals.currentClient.third.name}} / {{ shCtrl.globals.currentClient.operatingCenter.name}}\" style=cursor:pointer><span class=\"header-box-icon header-box-icon-earphones\"></span> <span>Bienvenido</span><br><span>{{ shCtrl.globals.currentClient.contact.firstname}}</span></div><ul class=pull-left ng-if=!shCtrl.globals.currentUser.username><li class=toplogin><a ui-sref=home.login>Iniciar sesi&oacute;n</a><li class=topcuenta ng-if=shCtrl.ngAuthSettings.site.config.data.register.allowRegister><a ui-sref=home.register>Crear una cuenta</a></ul></div><div class=\"header-box contact-phones pull-right clearfix ng-cloak\"><span class=\"header-box-icon header-box-icon-earphones\"></span><ul class=pull-left style=\"padding: 4px 0 0 3px\"><li><strong>Línea de atención nacional</strong><li>01 8000 220 117<li style=\"padding: 1px\">{{::shCtrl.ngAuthSettings.site.info.company.email}}<li>{{::shCtrl.ngAuthSettings.site.info.company.phone}}</ul></div><div class=\"header-box transp-box pull-right clearfix ng-cloak hidden-md\" style=\"display: none\"><span class=\"header-box-icon header-box-icon-earphones\"></span><ul class=pull-left><li>Transporte<li>al detal y al por mayor</ul></div></div></div></div></div><div class=row><div class=\"container cantainer-nav\"><nav class=\"navbar navbar-custom\"><div class=container-fluid><div class=navbar-header><button type=button class=\"navbar-toggle collapsed\" ng-click=\"vm.isCollapsed = !vm.isCollapsed\" data-toggle=collapse data-target=#bs-example-navbar-collapse-1 aria-expanded=false><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button></div><div class=\"collapse navbar-collapse\" uib-collapse=false id=bs-example-navbar-collapse-1><ul class=\"nav navbar-nav\"><li ng-if=shCtrl.globals.currentUser.isLogged><a ui-sref={{shCtrl.ngAuthSettings.site.app.header.logo.url}}>INICIO</a><li ng-if=shCtrl.globals.currentUser.isLogged class=dropdown uib-dropdown><a href=# class=dropdown-toggle uib-dropdown-toggle data-toggle=dropdown role=button aria-haspopup=true aria-expanded=false>CONSULTAS CRM <span class=caret></span></a><ul class=dropdown-menu uib-dropdown-menu><li><a href=#!/app/consultas/actividades-especificas>ACTIVIDADES ESPECÍFICAS</a><li><a href=#!/app/consultas/rutinas>RUTINAS</a><li><a href=#!/app/consultas/actas>ACTAS</a><li><a href=#!/app/consultas/documentos>DOCUMENTOS</a><li><a href=#!/app/consultas/pqrs>PQRS</a><li><a href=#!/app/consultas/tareas>TAREAS</a></ul><li ng-if=shCtrl.globals.currentUser.isLogged><a href=#!/app/users>USUARIOS</a><li><a href=#!/app/contact>CONTÁCTENOS</a></ul></div></div></nav></div></div></div><!--!shCtrl.globals.currentUser.userId\">--><div class=\"modal fade mostrar-cliente ng-cloak\" tabindex=-1 role=dialog aria-labelledby=mySmallModalLabel><div class=\"modal-dialog modal-sm\" style=width:50%><div class=modal-content><div class=modal-header><h5 class=modal-title><span>INFORMACIÓN DEL CLIENTE Y LA SUCURSAL SELECCIONADA</span></h5></div><div class=\"col-md-12 col-sm-12 col-xs-12\" style=\"padding: 20px; background-color:white\"><div class=col-md-12><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=form-group><label style=font-size:17px><strong>Información del cliente y de la sucursal</strong></label><p>Se ha seleccionado la siguiente información de cliente y sucursal asociada del cliente:<div class=col-md-12 style=\"margin-top: 15px\"><table class=\"table table-striped table-hover table-mostrar-cliente\"><tr><td class=titulo style=width:20%>Cliente<td>{{selectedClientReal.name}}<tr><td class=titulo>Sucursal<td>{{selectedBranchReal.name}}<tr><td class=titulo>Responsable<td>{{selectedClientReal.responsible}}<tr><td class=titulo>Correo<td>{{selectedClientReal.mail}}</table></div></div></div></div><hr><div class=\"col-md-12 col-sm-12 col-xs-12 text-right\"><button data-dismiss=modal class=\"btn btn-default btn-sm\">Cerrar</button></div></div></div></div></div></div></header><main ui-view=\"\" id=content class=\"main-content content\"></main><footer id=footer><div id=inner-footer><div class=container><div class=\"row ng-cloak\"><div><div class=\"col-md-4 col-sm-12 widget\"><h3><span>{{::shCtrl.ngAuthSettings.site.info.company.name | capitalize}}</span></h3><div class=txt-logo-footer><h6>{{::shCtrl.ngAuthSettings.site.app.footer.info.title}}</h6><p class=text-justify>{{::shCtrl.ngAuthSettings.site.app.footer.info.description}}</div></div><div class=\"col-md-4 col-sm-4 col-xs-6 widget sm-margin\"><h3><span>Acerca de</span></h3><ul class=links><li ng-if=shCtrl.globals.currentUser.isLogged><a ui-sref={{::shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li><a ui-sref={{::shCtrl.ngAuthSettings.site.config.footer.know_us.url_state}} ng-bind=::shCtrl.ngAuthSettings.site.config.footer.know_us.text_describe ng-if=::shCtrl.ngAuthSettings.site.config.footer.know_us.is_state></a> <a href={{::shCtrl.ngAuthSettings.site.config.footer.know_us.url_state}} ng-bind=::shCtrl.ngAuthSettings.site.config.footer.know_us.text_describe ng-if=::!shCtrl.ngAuthSettings.site.config.footer.know_us.is_state></a><li ng-if=\"shCtrl.globals.currentUser.isLogged && shCtrl.globals.currentUser.isProvider\"><a>Proveedores</a><li><a target=_blank href=https://diamante.com.co/POLITICA_DE_DATOS.pdf>Política de Tratamiento de Datos Personales</a><li><a target=_blank href=https://diamante.com.co/CODIGO_DE_ETICA.pdf>Código de ética</a><li><a ui-sref=home.terms>Términos y Condiciones</a></ul></div><div ng-if=false class=\"col-md-3 col-sm-4 hidden-xs widget sm-margin\"><h3><span>Mi cuenta</span></h3><ul class=links><li ng-show=\"shCtrl.ngAuthSettings.site.config.data.register.allowRegister && !shCtrl.globals.currentUser.username\"><a ui-sref=home.register>Regístrese</a><li ng-show=shCtrl.globals.currentUser.username><a ui-sref=home.account>Actualice sus datos</a><li ng-show=!shCtrl.globals.currentUser.username><a ui-sref=home.login>Olvidé mi clave</a><li ng-show=\"shCtrl.globals.currentUser.username && shCtrl.ngAuthSettings.site.config.menu.showSearchJob\" class=enlace-buscas-empleo><a href=./#/en-construccion>Buscas empleo?</a></ul></div><div class=\"col-md-4 col-sm-4 col-xs-6 widget sm-margin\"><h3><span>Contacto</span></h3><div class=links-pie><ul class=\"list-unstyled mt-15\"><li class=mb-10><i class=\"fa fa-map-marker\" aria-hidden=true></i>{{ ::shCtrl.ngAuthSettings.site.info.company.address }}, Cali - Colombia<li class=mb-10><i class=\"fa fa-phone\" aria-hidden=true></i> PBX: {{::shCtrl.ngAuthSettings.site.info.company.pbx}}<li class=mb-10><i class=\"fa fa-envelope-o\" aria-hidden=true></i> {{::shCtrl.ngAuthSettings.site.info.company.email}}</ul><div class=btn-sedes><a ui-sref={{::shCtrl.ngAuthSettings.site.app.footer.menu.contactUrl}}>Ver otras sedes</a></div></div></div></div></div></div></div><div class=derechos><div class=copy><label>Copyright {{shCtrl.ngAuthSettings.site.app.footer.info.date | date:'yyyy' }} © {{::shCtrl.ngAuthSettings.site.info.company.name | capitalize}}</label><label>-</label><label>Todos los derechos reservados</label><label>-</label><a target=_blank href=https://diamante.com.co/POLITICA_DE_DATOS.pdf>Políticas de privacidad</a> <a class=designed-by href=http://e-solutions.com.co/ target=_blank>Designed &amp; developed by E-Solutions</a></div></div></footer><div class=info-cookie ng-show=!shCtrl.cookiesAccepted><div class=container>Nuestro Portal Web utiliza COOKIES, si continua navegando entendemos que acepta nuestra <a ui-sref=home.cookies>Política de Manejo de Cookies</a>. <button class=\"aceptar-cookies btn\" ng-click=shCtrl.enableCookies()><i class=\"fa fa-times\" aria-hidden=true></i></button></div></div><a id=scroll-top title=\"Scroll to Top\" ng-click=shCtrl.goToTop()><i class=\"fa fa-angle-up\"></i></a></div>";

/***/ },
/* 477 */
/***/ function(module, exports) {

	module.exports = "<div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{$ctrl.shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li class=active><span>Mi cuenta</span></ul></div></div></div></div><div class=container style=margin-top:10px><div class=row><div class=col-md-12><h3>Mi cuenta</h3></div></div><div class=\"alert alert-danger\" style=margin-bottom:20px ng-show=$ctrl.errorloadingDashboardInfo>Ha ocurrido un error al obtener la información del dashboard. Por favor contacte al administrador del sistema.</div><div class=\"row panel-control\"><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=box-panel><h5><i class=\"fa fa-puzzle-piece\"></i> Acciones</h5><div class=\"col-sm-4 col-xs-12 item-pcontrol\" ng-show=$ctrl.shCtrl.ngAuthSettings.site.config.dashboard.showMyAccount><a ui-sref=home.account><div class=row><i class=\"fa fa-user\"></i> <span>Mis datos</span></div></a></div><div class=\"col-sm-4 col-xs-12 item-pcontrol\"><a ui-sref=home.contact><div class=row><i class=\"fa fa-envelope\"></i> <span>Contacto</span></div></a></div><div class=\"col-sm-4 col-xs-12 item-pcontrol\" ng-if=\"$ctrl.shCtrl.globals.currentUser.isLogged && $ctrl.shCtrl.globals.currentUser.isMaster\"><a ui-sref=home.users><div class=row><i class=\"fa fa-users\"></i> <span>Usuarios</span></div></a></div><div class=row></div></div></div><div class=\"col-md-6 col-sm-6 col-xs-12\"><img ng-if=!$ctrl.shCtrl.ngAuthSettings.site.config.dashboard.showSummary src={{$ctrl.shCtrl.globalBanners.MI_CUENTA.items[0].imageUrl}} class=imagen-responsiva alt=\"\"></div></div><div class=md-margin></div></div><style>.box-panel{\r\n    border: 1px solid #ddd;\r\n    margin-bottom: 20px;\r\n    min-height: 230px;\r\n  }\r\n\r\n  .box-panel h5{ background: #eeeeee; padding: 10px; font-size: 14px; margin-bottom: 0;}\r\n  .box-panel h5 i{ font-size: 18px;}\r\n\r\n\r\n  ul.datos-operaciones{\r\n    padding: 8px 30px 20px;\r\n  }\r\n\r\n  ul.datos-operaciones li{\r\n    padding: 10px 0;\r\n    border-bottom: 1px dashed #babdc0;\r\n    min-height: 40px;\r\n  }\r\n\r\n  ul.datos-operaciones li:last-child{\r\n    border: none;\r\n  }\r\n\r\n  ul.datos-operaciones li i{\r\n    font-size: 22px;\r\n    width: 35px;\r\n    color: #0664cd;\r\n  }\r\n\r\n  #top-links li.salir-top{\r\n    margin: 0;\r\n  }\r\n\r\n  #top-links li.salir-top a{\r\n    margin: 7px 0;\r\n    padding-left: 8px;\r\n    padding-right: 8px;\r\n  }\r\n\r\n  #header-top .header-link {\r\n    right: 26px;\r\n  }\r\n\r\n  .en-construccion {\r\n    opacity: .5;\r\n    color: black;\r\n  }\r\n\r\n  .panel-control .fa-history {\r\n    cursor: pointer;\r\n  }</style>";

/***/ },
/* 478 */
/***/ function(module, exports) {

	module.exports = "<div class=\"marcas_destacadas hidden-xs\"><div class=container><div class=row><div class=row><div class=col-md-12><div class=\"purchased-items-container carousel-wrapper\"><header class=\"content-title brands border-bot-nr\"><h2 class=ng-cloak><span class=color-orange>MARCAS DE DISTRIBUCIÓN DIRECTA</span></h2></header><div class=\"carousel-controls btns-brands\"><div id=brands-slider-prev class=\"carousel-btn brandbtn carousel-btn-prev\"></div><div id=brands-slider-next class=\"carousel-btn brandbtn carousel-btn-next carousel-space\"></div></div><section class=brands-slider-container><div class=\"brands-slider owl-carousel\"><div class=\"item item-marca\"><img class=abracol alt=\"\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAABsAQMAAAAVG28lAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABlJREFUeNrtwQENAAAAwqD3T20PBxQAAPwbCvgAAVoaXZEAAAAASUVORK5CYII=\"></div><div class=\"item item-marca\"><img class=blackdecker alt=\"\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAABsAQMAAAAVG28lAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABlJREFUeNrtwQENAAAAwqD3T20PBxQAAPwbCvgAAVoaXZEAAAAASUVORK5CYII=\"></div><div class=\"item item-marca\"><img class=bosch alt=\"\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAABsAQMAAAAVG28lAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABlJREFUeNrtwQENAAAAwqD3T20PBxQAAPwbCvgAAVoaXZEAAAAASUVORK5CYII=\"></div><div class=\"item item-marca\"><img class=dewalt alt=\"\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAABsAQMAAAAVG28lAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABlJREFUeNrtwQENAAAAwqD3T20PBxQAAPwbCvgAAVoaXZEAAAAASUVORK5CYII=\"></div><div class=\"item item-marca\"><img class=distribucioneshoyos alt=\"\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAABsAQMAAAAVG28lAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABlJREFUeNrtwQENAAAAwqD3T20PBxQAAPwbCvgAAVoaXZEAAAAASUVORK5CYII=\"></div><div class=\"item item-marca\"><img class=dremel alt=\"\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAABsAQMAAAAVG28lAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABlJREFUeNrtwQENAAAAwqD3T20PBxQAAPwbCvgAAVoaXZEAAAAASUVORK5CYII=\"></div><div class=\"item item-marca\"><img class=grival alt=\"\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAABsAQMAAAAVG28lAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABlJREFUeNrtwQENAAAAwqD3T20PBxQAAPwbCvgAAVoaXZEAAAAASUVORK5CYII=\"></div><div class=\"item item-marca\"><img class=henkel alt=\"\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAABsAQMAAAAVG28lAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABlJREFUeNrtwQENAAAAwqD3T20PBxQAAPwbCvgAAVoaXZEAAAAASUVORK5CYII=\"></div><div class=\"item item-marca\"><img class=hoyoslight alt=\"\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAABsAQMAAAAVG28lAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABlJREFUeNrtwQENAAAAwqD3T20PBxQAAPwbCvgAAVoaXZEAAAAASUVORK5CYII=\"></div></div></section><section class=brands-slider-container><div class=\"brands-slider owl-carousel\"><div class=\"item item-marca\"><img class=induma alt=\"\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAABsAQMAAAAVG28lAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABlJREFUeNrtwQENAAAAwqD3T20PBxQAAPwbCvgAAVoaXZEAAAAASUVORK5CYII=\"></div><div class=\"item item-marca\"><img class=lufkin alt=\"\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAABsAQMAAAAVG28lAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABlJREFUeNrtwQENAAAAwqD3T20PBxQAAPwbCvgAAVoaXZEAAAAASUVORK5CYII=\"></div><div class=\"item item-marca\"><img class=skil alt=\"\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAABsAQMAAAAVG28lAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABlJREFUeNrtwQENAAAAwqD3T20PBxQAAPwbCvgAAVoaXZEAAAAASUVORK5CYII=\"></div><div class=\"item item-marca\"><img class=stanley alt=\"\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAABsAQMAAAAVG28lAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABlJREFUeNrtwQENAAAAwqD3T20PBxQAAPwbCvgAAVoaXZEAAAAASUVORK5CYII=\"></div><div class=\"item item-marca\"><img class=stihl alt=\"\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAABsAQMAAAAVG28lAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABlJREFUeNrtwQENAAAAwqD3T20PBxQAAPwbCvgAAVoaXZEAAAAASUVORK5CYII=\"></div><div class=\"item item-marca\"><img class=uduke alt=\"\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAABsAQMAAAAVG28lAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABlJREFUeNrtwQENAAAAwqD3T20PBxQAAPwbCvgAAVoaXZEAAAAASUVORK5CYII=\"></div><div class=\"item item-marca\"><img class=yale alt=\"\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAABsAQMAAAAVG28lAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABlJREFUeNrtwQENAAAAwqD3T20PBxQAAPwbCvgAAVoaXZEAAAAASUVORK5CYII=\"></div><div class=\"item item-marca\"><img class=abracol alt=\"\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAABsAQMAAAAVG28lAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABlJREFUeNrtwQENAAAAwqD3T20PBxQAAPwbCvgAAVoaXZEAAAAASUVORK5CYII=\"></div></div></section></div></div></div></div></div></div>";

/***/ },
/* 479 */
/***/ function(module, exports) {

	module.exports = "<div class=container><div class=row><div class=col-md-12><img class=center-block src={{$ctrl.shCtrl.globalBanners.BANNER_PRINCIPAL.items[0].imageUrl}}></div></div><div class=\"row mb-20\"><div class=\"col-md-12 mt-20\"><h2 class=text-center>Bienvenido a nuestra zona de <span class=\"font-weight-900 cliente-header\">Consultas B2B al CRM</span></h2><div class=\"col-md-2 col-sm-6 col-xs-6 mt-10\"><a class=boton-1-home href=#!/app/consultas/actividades-especificas></a></div><div class=\"col-md-2 col-sm-6 col-xs-6 mt-10\"><a class=boton-2-home href=#!/app/consultas/rutinas></a></div><div class=\"col-md-2 col-sm-6 col-xs-6 mt-10\"><a class=boton-3-home href=#!/app/consultas/actas></a></div><div class=\"col-md-2 col-sm-6 col-xs-6 mt-10\"><a class=boton-4-home href=#!/app/consultas/documentos></a></div><div class=\"col-md-2 col-sm-6 col-xs-6 mt-10\"><a class=boton-5-home href=#!/app/consultas/pqrs></a></div><div class=\"col-md-2 col-sm-6 col-xs-6 mt-10\"><a class=boton-6-home href=#!/app/consultas/tareas></a></div></div></div></div>";

/***/ },
/* 480 */,
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=container></div><div class=container><div class=md-margin></div><div class=\"row inicio-sesion\"><div class=\"wraperr-inicio-sesion col-lg-10 col-md-12 col-lg-offset-1\"><div id=login-tabs class=\"tab-container clearfix\"><uib-tabset active=$ctrl.active><uib-tab index=0 heading=\"Iniciar sesión\"><div id=tab-login ng-class=\"$ctrl.active === 0 ? 'tab-pane active': 'tab-pane'\"><div class=row><div class=\"col-md-6 col-sm-12 formulario-acceso\"><h5>Acceso Usuarios Registrados</h5><p>Por favor ingrese sus datos de acceso<div class=xs-margin></div><div ng-show=\"$ctrl.dataReceived && $ctrl.isAValidUser\"><div class=\"alert alert-success\" ng-show=!$ctrl.showSelectModal>{{::$ctrl.shCtrl.ngAuthSettings.site.config.login.text_welcome_withow_branch}}</div><div class=\"alert alert-success\" ng-show=$ctrl.showSelectModal>{{::$ctrl.shCtrl.ngAuthSettings.site.config.login.text_welcome_with_branch}}</div><div class=loader-general ng-show=!$ctrl.showModalSelectBranchUserB2B style=\"margin-top:10px; margin-bottom: 10px;text-align:center\"><img src=" + __webpack_require__(2) + "> <span>Redireccionando a la página de inicio...</span></div></div><div ng-bind-html=\"$ctrl.errorLogin | toTrusted\" class=\"alert alert-danger alert-dismissable\" ng-show=\"!$ctrl.dataLoading && ($ctrl.dataReceived && !$ctrl.isAValidUser)\"></div><div class=loader-general ng-show=$ctrl.dataLoading style=\"margin-top:10px; margin-bottom: 10px;text-align:center\"><img src=" + __webpack_require__(2) + "> <span>Validando los datos de acceso...</span></div><form id=login-form name=$ctrl.loginForm ng-submit=$ctrl.loginUser() autocomplete=off novalidate><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=input-group><span class=input-group-addon><span class=input-text><i class=\"fa fa-envelope\"></i> Email </span></span><input type=email id=email name=email title=\"Por favor ingrese un email válido\" placeholder=\"Ingrese su Email\" class=form-control restrict-type=email ng-model=$ctrl.loginDataForm.email required></div><span class=input-help><span ng-show=\"$ctrl.loginForm.email.$touched && $ctrl.loginForm.email.$error.required && !$ctrl.loginForm.email.$pristine\" class=help-block>Ingrese un email válido. </span><span ng-show=\"$ctrl.loginForm.email.$touched && $ctrl.loginForm.email.$error.restEmail && !$ctrl.loginForm.email.$pristine\" class=help-block>Ingrese un email válido.</span></span><div class=input-group><span class=input-group-addon><span class=input-text><i class=\"fa fa-lock\"></i> Contraseña </span></span><input type=password id=password name=password title=\"Por favor ingrese una contraseña\" placeholder=\"Ingrese su contraseña\" class=form-control ng-model=$ctrl.loginDataForm.password required></div><span class=input-help><span ng-show=\"$ctrl.loginForm.password.$touched && $ctrl.loginForm.password.$invalid && !$ctrl.loginForm.password.$pristine\" class=help-block>Debe ingresar una contraseña valida. </span></span><input type=submit ng-disabled=!$ctrl.loginForm.$valid class=\"btn btn-custom-4 pull-right\" value=Ingresar></div></div></form></div><div class=\"col-md-1 acceso-social\"><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"></div></div></div><div class=\"sm-margin hidden-lg hidden-md\"></div><div class=\"col-md-5 col-sm-12 acceso-crear-cuenta border-right\" ng-if=$ctrl.ngAuthSettings.site.config.data.register.allowRegister><h5>¿Deseas Crear una Cuenta?</h5><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=input-desc-box><p>Crear una cuenta como <strong>\"Cliente Virtual\"</strong>, le permitirá ingresar sus pedidos o cotizaciones a través de nuestra plataforma de negocios para que sean atendidos oportunamente de manera rápida, segura y confiable.</div><a id=btn-registro class=\"btn btn-primary pull-right\" ui-sref=home.register style=\"color:white;padding: 9px\">Click para registrarse <i class=\"fa fa-arrow-circle-right\"></i></a></div></div></div><div class=\"col-md-6 col-sm-12 tips-recuperar\" ng-if=!$ctrl.ngAuthSettings.site.config.data.register.allowRegister><h5><i class=\"fa fa-question-circle\"></i> Tips de Ayuda</h5><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=input-desc-box><p>Si tiene problemas intentando ingresar por favor haga <a ui-sref=home.contact>clíc aquí</a>, para brindarle ayuda.</div><div class=input-desc-box><p>• Recuerde mantener siempre actualizados sus datos de contacto.<p>• Mantenga los datos de su cuenta en un lugar seguro.<p>• Cambie su clave regularmente.</div></div></div></div></div></div></uib-tab><uib-tab index=1 heading=\"Restablecer contraseña\"><div id=tab-recuperar ng-class=\"$ctrl.active === 1 ? 'tab-pane active': 'tab-pane'\"><div class=row><div class=\"col-md-6 col-sm-12 formulario-recuperar\"><h5>¿Olvidó su contraseña?</h5><p ng-bind-html=\"$ctrl.shCtrl.globalParams.cmsInfo.RESTABLECER_PASSWORD_INTRO | toTrusted\"><div class=xs-margin></div><div class=loader-general ng-show=$ctrl.recoveryPasswordDataLoading style=\"margin-top:10px; margin-bottom: 10px;text-align:center\"><img src=" + __webpack_require__(2) + "> <span>Reestableciendo la clave de acesso...</span></div><div class=\"alert alert-success\" ng-show=\"$ctrl.recoveryPasswordDataReceived && $ctrl.recoveryPasswordIsAValidUser\">Se ha enviado una nueva clave de acceso a su correo.</div><div class=\"alert alert-danger alert-dismissable\" ng-show=\"$ctrl.recoveryPasswordDataReceived && !$ctrl.recoveryPasswordIsAValidUser\"><div ng-bind-html=\"$ctrl.errorRecoveryPassword | toTrusted\"></div></div><form id=recover-password-form name=$ctrl.recoveryPasswordForm ng-show=\"!($ctrl.recoveryPasswordDataLoading || $ctrl.recoveryPasswordIsAValidUser)\" ng-submit=$ctrl.restoreAccountByEmail() novalidate><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=input-group><span class=input-group-addon><span class=input-text><i class=\"fa fa-envelope\"></i> Email </span></span><input type=email id=receovery-password-email name=email title=\"Por favor ingrese un email válido\" placeholder=\"Ingrese su Email\" class=form-control restrict-type=email ng-model=$ctrl.recoveryPasswordDataForm.email autocomplete=off required></div><span class=input-help><span ng-show=\"$ctrl.recoveryPasswordForm.email.$touched && $ctrl.recoveryPasswordForm.email.$error.required && !$ctrl.recoveryPasswordForm.email.$pristine\" class=help-block>Ingrese un email válido. </span><span ng-show=\"$ctrl.recoveryPasswordForm.email.$touched && $ctrl.recoveryPasswordForm.email.$error.restEmail && !$ctrl.recoveryPasswordForm.email.$pristine\" class=help-block>Ingrese un email válido.</span></span><div class=row><div class=\"col-md-8 col-sm-8 col-xs-12\"><div class=\"form-group captcha\"><label>Código de seguridad</label><div class=captcha-recuperar vc-recaptcha ng-model=$ctrl.captchaModel theme=$ctrl.shCtrl.themeCaptcha key=$ctrl.shCtrl.captchaKey on-create=$ctrl.shCtrl.setWidgetId(widgetId) on-success=$ctrl.shCtrl.setResponse(response) on-expire=$ctrl.shCtrl.cbExpiration()></div></div></div><div class=\"col-md-4 col-sm-4 col-xs-12\"><input type=submit ng-disabled=\"!$ctrl.captchaModel || !$ctrl.recoveryPasswordForm.$valid\" class=\"btn btn-custom-4 pull-right\" value=Reestablecer></div></div></div></div></form></div><div class=\"sm-margin hidden-lg hidden-md\"></div><div class=\"col-md-6 col-sm-12 tips-recuperar\"><h5><i class=\"fa fa-question-circle\"></i> Tips de Ayuda</h5><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=input-desc-box><p>Si tiene problemas intentando recuperar su contraseña por favor haga <a ui-sref=home.contact>clíc aquí</a>, para brindarle ayuda.</div><div class=input-desc-box ng-bind-html=\"$ctrl.shCtrl.globalParams.cmsInfo.RESTABLECER_PASSWORD_TIP | toTrusted\"></div></div></div></div></div></div></uib-tab></uib-tabset></div></div></div><div class=md-margin></div></div>";

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{$ctrl.shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li><a ui-sref=home.orders>Mis Pedidos</a><li class=active><span>Pedido # {{$ctrl.orderData.id}}</span></ul></div></div></div></div><div class=loader-general ng-show=$ctrl.loadingDataOrder style=\"margin-top:10px; margin-bottom: 10px;text-align:center\"><img src=" + __webpack_require__(2) + "> <span style=float:none>Cargando la notificación del pedido...</span></div><div class=\"container container-detail-order\" ng-show=!$ctrl.loadingDataOrder><div class=row><div class=col-md-12><div class=\"row detalles-pedido-titulo\"><div class=\"col-md-offset-8 col-sm-4\" ng-show=$ctrl.shCtrl.globals.currentUser.userId><a class=\"btn btn-custom-4 btn-sm volver-pedidos\" title=\"Volver a mis cotizaciones\" ui-sref=home.orders><i class=\"fa fa-arrow-circle-left\"></i> <strong>Volver a mis pedidos </strong></a><a class=\"btn btn-custom-4 btn-sm volver-pedidos\" ng-click=$ctrl.payNow($ctrl.orderData.id) title=\"Realizar pago del pedido No. {{$ctrl.orderData.id}}\" ng-if=\"!$ctrl.shCtrl.globals.currentUser.isSeller && !$ctrl.shCtrl.globals.currentUser.isB2B && $ctrl.orderData.showPayOrderAction && $ctrl.orderData.estado_anulacion == 'activa' && $ctrl.orderData.retomaPedido\" style=\"margin-right: 7px\">Realizar Pago</a></div></div><hr class=separador-detalles-pedidos><div class=\"col-md-12 header-cotizacion\"><div class=row><div class=\"col-md-4 col-sm-4 col-xs-12 logotipo-header-cotizacion\"><img alt=\"Logo HoyosTools\" src=" + __webpack_require__(537) + "></div><div class=\"col-md-4 col-sm-4 col-xs-6 text-center datos-header\"><strong>{{$ctrl.orderData.terceroPropietario.nombre}}</strong><br>{{$ctrl.orderData.terceroPropietario.tipo_documento}} {{$ctrl.orderData.terceroPropietario.documento_numero}}<br>{{$ctrl.orderData.co.direccion}}<br>Telefono {{$ctrl.orderData.co.telefono}}<br><span ng-if=$ctrl.orderData.terceroPropietario.web_site><span class=only_print>Visítenos en:</span> {{$ctrl.orderData.terceroPropietario.web_site}}</span></div><div class=\"col-md-4 col-sm-4 col-xs-6 cotizacion-datos-header\"><div class=text-right><strong>Pedido Nro.: <span>{{$ctrl.orderData.id}}</span></strong><br><span ng-if=$ctrl.orderData.numero_factura><b>Factura No.:</b> {{$ctrl.orderData.numero_factura}}<br></span><b>Elaborada el:</b> {{$ctrl.orderData.fecha_elaboracion}}<br><span ng-if=!$ctrl.shCtrl.globals.currentUser.isSeller><b>Estado:</b> {{$ctrl.orderData.estado_documento}}<br></span><div ng-if=\"$ctrl.shCtrl.globals.currentUser.isSeller || $ctrl.shCtrl.globals.currentUser.isContactCenter\"><form class=form-inline><div class=form-group><label for=exampleInputName2><b>Estado:</b></label><select class=\"form-control input-sm\" ng-model=$ctrl.orderData.estado_documento_id ng-change=$ctrl.changeStatus()><option value={{estado.id}} ng-repeat=\"estado in $ctrl.orderData.estados\" ng-selected=\"estado.id == $ctrl.orderData.estado_documento_id\">{{estado.nombre}}</select><i ng-class=\"{'fa fa-history load-animation' : !$ctrl.orderSaved}\"></i></div></form><br></div><span ng-if=$ctrl.orderData.tiempoRetomarPedido><b>Dias restantes para pago:</b> {{$ctrl.orderData.tiempoRetomarPedido}} dias<br></span><span ng-if=!$ctrl.orderData.tiempoRetomarPedido><b>Dias restantes para pago:</b> Expirado<br></span></div></div></div></div><div class=clear></div><div class=xs-margin></div><div class=\"col-md-4 pedidos-bloques1\"><div class=\"cabezas-info text-left\">CLIENTE</div><div class=\"col-md-12 entregas-contactos\"><ul><li><span class=datos-entregas><strong>{{$ctrl.orderData.tercero.nombre}}</strong></span><li><span class=datos-entregas>{{$ctrl.orderData.tercero.tipo_documento}} {{$ctrl.orderData.tercero.documento_numero}}{{$ctrl.orderData.tercero.documento_dv}}</span><li><span class=datos-entregas>{{'Sucursal: ' + $ctrl.orderData.branch.nombre}}</span><li><span class=datos-entregas>{{$ctrl.orderData.direccion_despacho}}</span><li><span class=datos-entregas>{{$ctrl.orderData.telefono_contacto ? $ctrl.orderData.telefono_contacto : $ctrl.orderData.applicant.movil }}</span></ul></div></div><div class=\"col-md-4 pedidos-bloques1\"><div class=\"cabezas-info text-left\">CONTACTO DEL PEDIDO</div><div class=\"col-md-12 entregas-contactos\"><ul><li><span class=datos-entregas><strong>{{$ctrl.orderData.nombre_contacto}}</strong></span><li><span class=datos-entregas>{{$ctrl.orderData.telefono_contacto}}</span><li><span class=datos-entregas>{{$ctrl.orderData.movil_contacto ? $ctrl.orderData.movil_contacto : 'Sin definir'}}</span><li><span class=datos-entregas>{{$ctrl.orderData.correo_contacto}}</span><li><span class=datos-entregas>&nbsp;</span></ul></div></div><div class=\"col-md-4 pedidos-bloques1\" style=display:none><div class=\"cabezas-info text-left\">SOLICITANTE</div><div class=\"col-md-12 entregas-contactos\"><ul><li><span class=datos-entregas><strong>{{$ctrl.orderData.applicant.name}}</strong></span><li><span class=datos-entregas>{{$ctrl.orderData.applicant.phone}}</span><li ng-show=$ctrl.orderData.applicant.movil><span class=datos-entregas>{{$ctrl.orderData.applicant.movil}}</span><li><span class=datos-entregas>{{$ctrl.orderData.applicant.email}}</span></ul></div></div><div class=\"col-md-4 pedidos-bloques1\" ng-if=$ctrl.orderData.seller><div class=\"cabezas-info text-left asesor verdeprint\">ASESOR COMERCIAL</div><div class=\"col-md-12 entregas-contactos\"><ul><li><span class=datos-entregas><strong>{{$ctrl.orderData.seller.name}}</strong></span><li><span class=datos-entregas>Sucursal: {{$ctrl.orderData.seller.co.nombre}}</span><li><span class=datos-entregas>{{$ctrl.orderData.seller.co.address}}</span><li><span class=datos-entregas>{{$ctrl.orderData.seller.phone}} </span><span class=datos-entregas ng-if=\"$ctrl.orderData.seller.phone && $ctrl.orderData.seller.movil\">- </span><span class=datos-entregas>{{$ctrl.orderData.seller.movil}}</span><li><span class=datos-entregas>{{$ctrl.orderData.seller.email}}</span></ul></div></div><div class=clear></div><div class=md-margin></div><div class=detalles-pedidos><div class=col-md-12><h4 class=titulo-detalle-tabla>DETALLE DEL PEDIDO</h4><div class=\"table-responsive initial-overflow\"><table class=\"table cart-table-cotizacion tb-cotizacion\" style=min-width:960px><thead><tr><th class=table-title style=\"width: 4%\"><i class=\"fa fa-check-square-o\" aria-hidden=true></i><th class=table-title style=\"width: 34%\">ITEMS<th class=table-title style=\"width: 10%\">REF.<th class=table-title style=\"width: 3%\">U.M.<th class=table-title style=\"width: 3%\">CANT.<th class=table-title style=\"width: 6%\" ng-if=\"$ctrl.orderData.clientPriceList === 'client'\">Vr. UNIT<th class=table-title style=\"width: 7%\" ng-if=\"$ctrl.orderData.clientPriceList === 'cost'\">Vr. COSTO<th class=table-title style=\"width: 6%\" ng-if=\"$ctrl.orderData.clientPriceList === 'client'\">DSCTO %<th class=table-title style=\"width: 8%\" ng-if=\"$ctrl.shCtrl.globals.currentUser.isSeller && $ctrl.orderData.clientPriceList === 'cost'\">FACTOR %<th class=table-title style=\"width: 6%\">IMP. %<th class=table-title style=\"width: 5%\">SUBTOTAL<tbody><tr ng-repeat=\"item in $ctrl.orderData.items\"><td class=tdInDiscount><button type=button class=\"alter-container-discount-table no_print\" ng-if=\"$ctrl.shCtrl.globals.currentUser.isMaster || $ctrl.shCtrl.globals.currentUser.isSupervisor\"><span class=\"fa fa-tag fa-flip-horizontal\" aria-hidden=true></span><div class=popover-discount><div class=titleDiscount>Descuentos Financieros</div><div class=table-responsive><table class=\"table cart-table-cotizacion tb-cotizacion discountTableInPopover\"><thead><tr><th class=table-title style=\"width: 40%\">Fecha Límite<th class=table-title style=\"width: 20%\">Dsc.%<th class=table-title style=\"width: 40%\">Valor<tbody><tr ng-repeat=\"itemDiscount in item.decuentosFinancieros\"><td>{{itemDiscount.fechaLimite}}<td>{{itemDiscount.descuento}}<td>$ {{itemDiscount.valor| currency:'':0}}</table></div></div></button> {{$index + 1}}<td class=text-left><a ui-sref=\"home.productDetailId({productId : item.id})\" title={{item.nombre}}><h2>{{item.nombre}}</h2></a><ul><li ng-repeat=\"attribute in item.atributos\"><strong>{{attribute.title}}:</strong> {{attribute.value| join}}</ul><div ng-if=item.adjuntos.length style=margin-top:6px class=f_anexos><strong>Archivos anexos:</strong><ul style=\"list-style-type: decimal;\r\n                        padding-left: 25px;\r\n                        margin-top: 2px\"><li ng-repeat=\"adjunto in item.adjuntos track by adjunto.id\"><a href={{adjunto.url}} title={{adjunto.title}} target=_blank>{{adjunto.title}}</a></ul></div><td>{{item.referencia}}<td>{{item.unidadMedida}}<td>{{item.cantidad}}<td style=\"text-align: right\"><span>$ {{item.precio_unitario| currency:'':0}}</span><td ng-if=\"$ctrl.orderData.clientPriceList === 'client'\"><label>{{item.descuento_porcentaje}}</label><td ng-if=\"$ctrl.shCtrl.globals.currentUser.isSeller && $ctrl.orderData.clientPriceList === 'cost'\"><label>{{item.margen_ganancia| currency:'':0}}</label><td>{{item.impuesto| currency:'':0}}<td style=\"text-align: right\"><span ng-init=\"cotizacionForm.item[item.id_registro].total = item.total\">$ {{ cotizacionForm.item[item.id_registro].total | currency:'':0 }}</span></table></div></div></div></div><div class=clear></div><div class=md-margin></div><div class=\"col-md-12 anotaciones-block\"><div class=\"col-md-8 col-sm-7 col-xs-12\"><div class=\"anotaciones cli-ven\"><strong class=\"blue print-green\">ANOTACIONES CLIENTE</strong> <span ng-show=$ctrl.orderData.comentario class=text-left>{{$ctrl.orderData.comentario}} </span><span ng-show=!$ctrl.orderData.comentario class=text-left>No se han ingresado comentarios para este pedido.</span></div><div class=\"anotaciones cli-ven\"><strong class=\"blue print-green\">ANOTACIONES VENDEDOR</strong> <span ng-show=$ctrl.orderData.anotaciones_vendedor>{{$ctrl.orderData.anotaciones_vendedor}} </span><span ng-show=!$ctrl.orderData.anotaciones_vendedor>El vendedor no ha ingresado comentarios para este pedido.</span></div><div class=row><div class=\"col-md-6 col-sm-6\" style=display:none><div class=\"anotaciones edit-{{$ctrl.orderData.id_estado}}\"><strong class=print-green>FECHA DE ENTREGA PROGRAMADA</strong> <span>{{$ctrl.orderData.fecha_entrega_programada_label}}</span></div></div><div class=\"col-md-6 col-sm-6\"><div class=\"anotaciones edit-{{$ctrl.orderData.id_estado}}\"><strong class=print-green>FORMA DE PAGO </strong><span>{{$ctrl.orderData.medioPago.nombre}}</span></div></div></div></div><div class=\"col-md-4 col-sm-5 col-xs-12\"><table class=\"table table-bordered table-striped tb-cotizacion\"><tr><td style=\"text-align: left\">SUBTOTAL BRUTO: $ <span class=cotizacion-vlrs>$ <span>{{$ctrl.orderData.subtotal| currency:'':0}}</span></span><tr ng-if=\"$ctrl.shCtrl.globals.currentUser.isSeller && $ctrl.orderData.clientPriceList === 'cost'\"><td style=\"text-align: left\">UTILIDAD: <span class=cotizacion-vlrs>$ {{$ctrl.orderData.utilidades| currency:'':0}}</span><tr ng-if=\"$ctrl.orderData.clientPriceList === 'client'\"><td style=\"text-align: left\">DESCUENTO COMERCIAL: <span class=cotizacion-vlrs>$ {{$ctrl.orderData.descuentos| currency:'':0}}</span><tr><td style=\"text-align: left\">SUBTOTAL NETO: <span class=cotizacion-vlrs>$ {{($ctrl.orderData.subtotal - $ctrl.orderData.descuentos)| currency:'':0}}</span><tr><td style=\"text-align: left\">IVA: <span class=cotizacion-vlrs>$ {{$ctrl.orderData.impuestos| currency:'':0}}</span><tr ng-if=$ctrl.orderData.gestion_y_transporte><td style=\"text-align: left\">GESTIÓN DE TRANSPORTE: <span class=cotizacion-vlrs>$ {{$ctrl.orderData.gestion_y_transporte| currency:'':0}}</span><tr><td style=\"text-align: left; padding-left: 30px; position: relative\" class=\"tdInDiscount total total-detail-table\"><button type=button ng-if=\"$ctrl.shCtrl.globals.currentUser.isMaster || $ctrl.shCtrl.globals.currentUser.isSupervisor\" class=\"container-discount-table no_print\"><span class=\"fa fa-tag fa-flip-horizontal\" aria-hidden=true></span><div class=popover-discount><div class=titleDiscount>Descuentos Financieros</div><div class=table-responsive><table class=\"table cart-table-cotizacion tb-cotizacion discountTableInPopover\"><thead><tr><th class=table-title style=\"width: 40%\">Fecha Límite<th class=table-title style=\"width: 20%\">Dsc.%<th class=table-title style=\"width: 40%\">Valor<tbody><tr ng-repeat=\"decuentoFinanciero in $ctrl.orderData.decuentosFinancieros\"><td>{{decuentoFinanciero.fechaLimite}}<td>{{decuentoFinanciero.descuento}}<td>$ {{decuentoFinanciero.valor| currency:'':0}}</table></div></div></button> TOTAL A PAGAR: <span class=cotizacion-vlrs>$ {{$ctrl.orderData.total| currency:'':0}}</span></table><div class=xs-margin></div><table class=\"table table-bordered table-striped tb-cotizacion\"><tfoot><tr ng-if=$ctrl.shCtrl.globalParams.showTotalKilosCanasta><td style=\"text-align: left\">TOTAL EN KILOS: <span class=cotizacion-vlrs>{{ $ctrl.orderData.totalPesoItems | currency:'':0}}</span><tr><td style=\"text-align: left\">TOTAL DE UNIDADES: <span class=cotizacion-vlrs>{{ $ctrl.orderData.cantidadTotalCanasta | currency:'':0}}</span></table></div></div><div class=\"col-md-12 anotaciones-block\"><div class=\"col-md-8 col-sm-7 col-xs-12\" ng-if=$ctrl.orderData.tiempoRetomarPedido><span><strong>Nota:</strong> Recuerda que podrás realizar el pago de tu pedido hasta {{$ctrl.orderData.tiempoRetomarPedido}} días a partir de la fecha de realización.</span></div></div><div class=clear></div><div class=md-margin></div><div class=clear></div><div class=md-margin></div><div class=\"container only_print terminos_condiciones\"><div class=row><div class=lg-margin></div><div class=lg-margin></div><div class=col-md-3><hr><strong>{{$ctrl.orderData.seller.name}}</strong><br>{{$ctrl.orderData.seller.co.nombre}}<br>{{$ctrl.orderData.seller.co.direccion_principal}}<br>Telefono: {{$ctrl.orderData.seller.phone}}<br>{{$ctrl.orderData.seller.co.ciudad}} - {{$ctrl.orderData.seller.co.pais}}<br></div></div></div><div class=\"col-md-12 botonera-acciones\" style=text-align:right><a href=\"\" class=\"btn btn-info btn-sm\" onclick=window.print()><i class=\"fa fa-print\" aria-hidden=true></i> Imprimir / PDF </a><a href=\"\" class=\"btn btn-info btn-sm\" ng-click=$ctrl.showModalDriver() ng-if=$ctrl.shCtrl.globalParams.solicitarInfoTransporte><i class=\"fa fa-truck\" aria-hidden=true></i> Info. de quien transporta el pedido </a><a href=\"\" class=\"btn btn-info btn-sm\" ng-click=\"$ctrl.syncOrder($ctrl.orderData.id, $ctrl.orderData)\" ng-if=\"$ctrl.shCtrl.globalParams.sincronizacionManualPedidos && $ctrl.shCtrl.globalParams.usuario.esSupervisor\"><i class=\"fa fa-upload\" aria-hidden=true></i> Sincronizar Pedido</a></div><div class=clear></div><div class=\"md-margin sep-botonera\"></div></div></div>";

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{$ctrl.shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li class=active><span>Mis pedidos</span></ul></div></div></div></div><div class=container><div class=row><div class=col-md-12><h2>Resumen del Mes Actual:</h2></div></div><div class=\"row confirmacion-registro\" style=margin-bottom:20px ng-show=\"$ctrl.loadedUserOrders && !$ctrl.userOrders.ordersQuotes.length\"><div class=\"col-md-9 col-sm-8\" style=margin-top:15px><h3>Historial de Mis Pedidos | <small>{{$ctrl.userOrders.ordersQuotes.length}} pedido(s) </small></h3><hr><p>Aún no ha realizado ningún pedido. Lo invitamos a realizar su primer pedido con la excelente calidad de nuestros productos.<p>¿Qué desea hacer ahora?<div class=deseas-hacer><a class=\"btn botones-acciones btn-default\" ui-sref=home.category><i class=\"fa fa-cart-arrow-down\"></i> <strong>Comenzar a comprar </strong></a><a class=\"btn botones-acciones btn-default\" ui-sref=home.contact><i class=\"fa fa-user\"></i> <strong>Servicio al cliente</strong></a></div></div><div class=\"col-md-3 col-sm-4 hidden-xs\"><img src=" + __webpack_require__(23) + " class=\"img-responsive asesora\" alt=\"Mujer asesora\"></div></div><div class=\"row barra-mis-cotizaciones\" ng-show=$ctrl.userOrders.ordersQuotes.length><div class=\"col-lg-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-md-3 col-xs-12\"><div class=\"small-box bg-aqua\"><div class=inner><h3>{{$ctrl.userOrders.summary.currentMonth.quantity}}</h3><p>Pedidos</div><div class=icon><i class=\"fa fa-file-text-o\"></i></div></div></div><div class=\"col-md-3 col-xs-12\"><div class=\"small-box bg-yellow\"><div class=inner><h3>$ {{$ctrl.userOrders.summary.currentMonth.value| currency:'':0}}</h3><p>Valor total pedidos</div><div class=icon><i class=\"fa fa-usd\"></i></div></div></div><div class=\"col-md-3 col-xs-12\"><div class=\"small-box bg-green\"><div class=inner><h3>{{$ctrl.userOrders.summary.currentMonth.pending}}</h3><p>Pendientes por revisar</div><div class=icon><i class=\"fa fa-files-o\"></i></div></div></div><div class=\"col-md-3 col-xs-12\"><div class=\"small-box bg-red\"><div class=inner><h3>{{$ctrl.userOrders.summary.currentMonth.ordersPaid}}</h3><p>Pedidos pagados</div><div class=icon><i class=\"fa fa-clipboard\"></i></div></div></div></div><div class=clear></div><div class=clear></div><div class=\"category-toolbar top clearfix\" ng-show=\"$ctrl.userOrders.ordersQuotes.length > 0\"><div id=filtros-top-cotizacion><div class=\"toolbox-filter clearfix\"><div class=\"col-md-2 col-xs-4 search-cotizacion\"><div class=row><input ng-model=$ctrl.searchText placeholder=Buscar> <i id=buscar-filtrar class=\"fa fa-search\"></i></div></div><div class=\"col-md-4 col-xs-8 orderlist\"><span class=separator ng-show=$ctrl.userOrdersFiltered.length>Ordenar:</span><div class=\"btn-group select-dropdown\" ng-show=$ctrl.userOrdersFiltered.length><button type=button class=\"btn select-btn\"><label><span ng-switch=$ctrl.sortType><span ng-switch-when=orderId>No. Pedido </span><span ng-switch-when=totalPrice>Precio </span></span>- <span ng-show=\"$ctrl.sortType === 'orderId'\" ng-switch=$ctrl.sortReverse><span ng-switch-when=true>(descendente)</span> <span ng-switch-when=false>(ascendente)</span> </span><span ng-show=\"$ctrl.sortType === 'totalPrice'\" ng-switch=$ctrl.sortReverse><span ng-switch-when=true>(descendente)</span> <span ng-switch-when=false>(ascendente)</span></span></label></button> <button type=button class=\"btn dropdown-toggle\" data-toggle=dropdown><i class=\"fa fa-angle-down\"></i></button><ul class=dropdown-menu role=menu><li><a href=\"\" ng-click=\"$ctrl.sortType = 'orderId'; $ctrl.sortReverse = false;\">No. Pedido (ascendente)</a><li><a href=\"\" ng-click=\"$ctrl.sortType = 'orderId'; $ctrl.sortReverse = true;\">No. Pedido (descendente)</a><li><a href=\"\" ng-click=\"$ctrl.sortType = 'totalPrice'; $ctrl.sortReverse = false;\">Precio (ascendente)</a><li><a href=\"\" ng-click=\"$ctrl.sortType = 'totalPrice'; $ctrl.sortReverse = true;\">Precio (descendente)</a></ul></div></div><div class=\"col-md-2 col-sm-6 hidden-xs\"><div id=paginacion-listado-top ng-show=$ctrl.userOrdersFiltered.length><div class=\"toolbox-pagination clearfix\"><div class=row><div class=view-count-box><span class=separator>Ver:</span><div class=\"btn-group select-dropdown\"><button type=button class=\"btn select-btn\">{{ $ctrl.itemsPerPage}}</button> <button type=button class=\"btn dropdown-toggle\" data-toggle=dropdown><i class=\"fa fa-angle-down\"></i></button><ul class=dropdown-menu role=menu><li><a href=\"\" ng-click=$ctrl.setPagination($ctrl.userOrders.ordersQuotes.length);>Todos ({{$ctrl.userOrders.ordersQuotes.length}})</a><li><a href=\"\" ng-click=$ctrl.setPagination(12);>12</a><li><a href=\"\" ng-click=$ctrl.setPagination(24);>24</a><li><a href=\"\" ng-click=$ctrl.setPagination(40);>40</a></ul></div></div></div></div></div></div><div class=\"col-md-3 col-sm-6 col-xs-12 text-right paginacion-cotizacion\"><dir-pagination-controls boundary-links=false template-url=../../assets/lib/old/dirPagination.tpl.html on-page-change=$ctrl.changePageOrdes(newPageNumber) max-size=4></dir-pagination-controls></div><div class=\"col-md-1 col-xs-12\"><div class=row style=\"float: right\"><div class=\"filter-resume pull-left\" ng-show=$ctrl.userOrdersFiltered.length>{{$ctrl.actualPage*$ctrl.itemsPerPage + 1}} - <span ng-show=\"$ctrl.actualPage*$ctrl.itemsPerPage + $ctrl.itemsPerPage < $ctrl.userOrdersFiltered.length\">{{$ctrl.actualPage*$ctrl.itemsPerPage + $ctrl.itemsPerPage}} </span><span ng-show=\"$ctrl.actualPage *$ctrl.itemsPerPage + $ctrl.itemsPerPage >= $ctrl.userOrdersFiltered.length\">{{$ctrl.userOrdersFiltered.length}} </span>de {{$ctrl.userOrdersFiltered.length}} pedidos</div></div></div></div></div><div class=\"clear hidden-lg hidden-md\"></div></div><div class=clear></div><div class=row><div class=col-md-12><h2 class=text-center>Gestión de Pedidos</h2></div></div><div class=xs-margin></div><div class=\"row tabla-mis-cotizaciones\" ng-show=$ctrl.userOrdersFiltered.length><div class=col-md-12><div class=table-responsive><table class=table style=min-width:800px><thead><tr><th style=\"width: 7%\">Fecha<th style=\"width: 10%\">Pedido<th style=\"width: 20%\">Tercero<th style=\"width: 20%\">Vendedor<th style=\"width: 8%\">Estado<th style=\"width: 6%\">Tiempo<th style=\"width: 7%\" ng-if=\"$ctrl.shCtrl.globalParams.sincronizacionManualPedidos && $ctrl.shCtrl.globalParams.usuario.esSupervisor\">Sinc.<th style=\"width: 8%\"><tbody><tr dir-paginate=\"order in $ctrl.userOrdersFiltered =\r\n                          ($ctrl.userOrders.ordersQuotes\r\n                                  | filter:$ctrl.searchText\r\n                                  | orderBy:$ctrl.sortType:$ctrl.sortReverse\r\n                                  | itemsPerPage: $ctrl.itemsPerPage)\" current-page=$ctrl.currentPage><td class=filtrado-orden>{{order.creationDate}}<td class=info-usuario><strong>Número: <a ui-sref=\"home.orderDetail({orderId : order.orderId})\" title=\"Ver cotización No. {{order.orderNumber}}\">{{order.orderNumber}}</a></strong><br><label ng-if=order.numeroFactura style=\"margin-bottom: 0px\">Factura: {{order.numeroFactura}}</label>Destino: {{order.ciudadDestino}}<br>Valor: $ {{order.totalPrice| currency:'':0}} COP<br><td class=info-usuario><strong>{{order.terceroCliente.nombre}} </strong><br><span ng-show=order.terceroCliente.documento_numero>{{order.terceroCliente.tipo_documento}} {{order.terceroCliente.documento_numero}} <span ng-show=order.terceroCliente.documento_dv>- {{order.terceroCliente.documento_dv}}</span> </span><br><span>{{order.contactoNombre}}</span><br><span>Teléfono: {{order.contactoTelefono}}</span><br><span>{{order.contactoEmail}}</span><br><td class=\"text-left forma-pago info-usuario\"><strong>{{order.responsableNombre}}</strong><br><span>Sucursal: {{order.co.nombre}} </span><br><span>{{order.co.direccion}} </span><br><span>Teléfono: {{order.co.telefono}} </span><br><span>{{order.responsableEmail}}</span><br><td class=\"text-left forma-pago\"><span>{{order.orderState}}</span><br><span class=\"label label-success\" ng-show=\"order.cancelState == 'activa'\">{{order.cancelState}} </span><span class=\"label label-danger\" ng-show=\"order.cancelState == 'anulada'\">{{order.cancelState}}</span><td class=\"text-left forma-pago\"><span ng-if=\"order.estadoId != '35' && order.estadoId != '38'\">{{order.tiempo}}</span><br><span ng-if=\"order.estadoId == '35' || order.estadoId == '38'\">--</span><br><td class=text-center ng-if=\"$ctrl.shCtrl.globalParams.sincronizacionManualPedidos && $ctrl.shCtrl.globalParams.usuario.esSupervisor\"><span ng-bind=order.sincronizado.label></span><td class=\"text-left acciones\"><div class=btn-group><a class=\"btn btn-default\" ui-sref=\"home.orderDetail({orderId : order.orderId})\" title=\"Ver pedido No. {{order.orderNumber}}\"><i class=\"fa fa-bars\" aria-hidden=true></i> </a><a class=\"btn btn-default xs-margin\" href=\"\" title=\"Sincronizar el pedido No. {{order.orderNumber}}\" ng-click=\"$ctrl.syncOrder(order.orderId, order)\" ng-if=\"$ctrl.shCtrl.globalParams.sincronizacionManualPedidos && $ctrl.shCtrl.globalParams.usuario.esSupervisor\"><i class=\"fa fa-upload\" aria-hidden=true></i> </a><button data-toggle=dropdown ng-if=\"!$ctrl.shCtrl.globals.currentUser.isSeller && !$ctrl.shCtrl.globals.currentUser.isB2B && order.showPayOrderAction && order.cancelState == 'activa' && order.paymentStateName !== 'Pagada'\" class=\"btn btn-default dropdown-toggle\" type=button><span class=caret></span> <span class=sr-only>Toggle Dropdown</span></button><ul role=menu class=dropdown-menu ng-if=\"!$ctrl.shCtrl.globals.currentUser.isSeller && !$ctrl.shCtrl.globals.currentUser.isB2B && order.cancelState == 'activa'\"><li><a ng-click=$ctrl.duplicateOrder(order)>Duplicar <i ng-if=$ctrl.loadingDuplicateOrders class=\"fa fa-spinner\"></i></a><li ng-if=\"!$ctrl.shCtrl.globals.currentUser.isSeller && !$ctrl.shCtrl.globals.currentUser.isB2B && order.showPayOrderAction && order.cancelState == 'activa' && order.paymentStateName !== 'Pagada' && order.retomaPedido\"><a ng-click=$ctrl.payNow(order.orderId)>Realizar Pago</a></ul></div></table></div></div></div><div class=row><div class=\"alert alert-warning\" ng-show=!$ctrl.userOrdersFiltered.length>No se han encontrado pedidos para la búsqueda seleccionada <span style=\"color: #0664cd\">'{{$ctrl.searchText}}'</span></div></div></div></div><div class=md-margin></div></div>";

/***/ },
/* 484 */
/***/ function(module, exports) {

	module.exports = "<div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{$ctrl.shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li class=active><span>Zona de pagos</span></ul></div></div></div></div><div class=container id=pagos><div class=col-md-12><div class=row><div class=\"informacion-top table-tada-desing\"><div class=\"col-md-4 col-sm-12\"><h3 style=\"margin-bottom: 7px\">{{$ctrl.shCtrl.globals.currentUser.thirdName}}<br></h3><div class=leicon><i class=\"fa fa-list-alt\" aria-hidden=true></i></div><ul><li><i class=\"fa fa-user\" aria-hidden=true></i> <span><strong>Nit.:</strong> {{$ctrl.shCtrl.globals.currentUser.thirdDocumentNumber}} <span ng-show=$ctrl.shCtrl.globals.currentUser.thirdDocumentDV>- {{$ctrl.shCtrl.globals.currentUser.thirdDocumentDV}}</span></span></ul></div><div class=\"col-md-4 col-sm-12\"><h3 style=\"margin-bottom: 7px\">Estado de Cartera<br></h3><div class=leicon><i class=\"fa fa-usd\"></i></div><ul class=estado-cartera><li><span><strong>Cupo:</strong> $ {{ ($ctrl.billfoldResume.CUPO_CREDITO || 0) | currency:'':0}}</span><li><strong>Vencida:</strong> <span class=defn ng-class=\"{'value-cartera-vencida':$ctrl.billfoldResume.VLR_VENCIDO > 0}\">$ {{ ($ctrl.billfoldResume.VLR_VENCIDO || 0) | currency:'':0}}</span><li><span><strong>Cupo Disponible: </strong><span class=defn ng-class=\"{'cartera-vencida':$ctrl.billfoldResume.CUPO_DISPONIBLE < 0}\">$ {{ ($ctrl.billfoldResume.CUPO_DISPONIBLE || 0) | currency:'':0}}</span></span></ul></div><div class=\"col-md-4 col-sm-12\"><h3 style=\"margin-bottom: 7px\">Total Pendiente por Pago<br></h3><ul><li><i class=\"fa fa-usd\" aria-hidden=true style=\"left: 5px\"></i> <strong>Valor:</strong> <span class=\"defn value-cartera-total\">$ {{$ctrl.billfoldResumeAll | currency:'':0}}</span></ul><div class=leicon><i class=\"fa fa-money\" aria-hidden=true></i></div></div></div></div></div><div class=clearfix></div><hr><div class=col-xs-12 style=\"text-align: center\"><h2 style=\"font-weight: 600; font-size: 22px;     margin-bottom: 15px\">VALOR PENDIENTE DE PAGO POR PLANTA</h2><p>Seleccione a continuación la planta a la cual desea Pagar/abonar a los documentos pendientes por pago</p><br></div><div class=clearfix></div><div class=\"col-md-4 col-sm-6 col-xs-12 zona-pagos\" ng-repeat=\"plant in $ctrl.plants\"><div class=small-box ng-class=\"'bg-' + $index\"><div class=inner><h3>{{::plant.nombre}}</h3><p>Vr. pendiente de pago: <span class=valor-box-pagos ng-class=\"{'value-cartera-vencida': plant.cartera > 0}\">$ {{::plant.cartera | currency:'':0}}</span><p>Vr. vencido: <span class=valor-box-pagos>$ {{::plant.vencido | currency:'':0}}</span></div><div class=icon><i class=\"fa fa-industry\" aria-hidden=true></i></div><a href=./#/zona-de-pagos/detalle/{{plant.referencia}} class=small-box-footer>Pagar / Abonar <i class=\"fa fa-arrow-circle-right\"></i></a></div></div><div class=clear></div><hr></div>";

/***/ },
/* 485 */
/***/ function(module, exports) {

	module.exports = "<div class=container id=pagos><br><div class=col-xs-12><div class=\"row header-pagos\"><div ng-bind-html=\"$ctrl.shCtrl.globalParams.cmsInfo.ZONA_DE_PAGOS_TITULO | toTrusted\"></div></div></div><uib-tabset active=$ctrl.shCtrl.globals.currentUser.activeTap><uib-tab index=0 ng-click=$ctrl.copy()><uib-tab-heading class=headeing--icon><i class=\"fa fa-file-text-o\" aria-hidden=true></i><br>Cotizaciones</uib-tab-heading><quotations sh-ctrl=$ctrl.shCtrl></quotations></uib-tab><uib-tab index=1 ng-click=$ctrl.copy()><uib-tab-heading class=headeing--icon><i class=\"fa fa-list-ol\" aria-hidden=true></i><br>Pedidos</uib-tab-heading><payment-orders sh-ctrl=$ctrl.shCtrl></payment-orders></uib-tab><uib-tab index=2 ng-click=$ctrl.copy()><uib-tab-heading class=headeing--icon><i class=\"fa fa-files-o\" aria-hidden=true></i><br>Facturas</uib-tab-heading><payment-bills sh-ctrl=$ctrl.shCtrl></payment-bills></uib-tab><uib-tab index=3 ng-click=$ctrl.copy()><uib-tab-heading class=headeing--icon><i class=\"fa fa-shopping-cart\" aria-hidden=true></i><br>Carrito de Pagos</uib-tab-heading><payment-cart sh-ctrl=$ctrl.shCtrl></payment-cart></uib-tab></uib-tabset></div>";

/***/ },
/* 486 */
/***/ function(module, exports) {

	module.exports = "<div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{$ctrl.shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li><a ui-sref=home.detailZone>Detalle</a><li class=active>Detalle de pago</ul></div></div></div></div><div class=container id=consultas ng-show=\"$ctrl.tab === 1\"><div class=\"row media cabecera\"><div class=col-sm-8><h1>Documentos pendientes por pago</h1><p><em>Los documentos que se presentan a continuación corresponden a los últimos 6 meses</em><p><strong>Nota</strong>: <em>Para editar el valor a pagar hoy haga doble clic sobre él precio.</em><p>Por favor seleccione a continuación el o los documentos a los cuales desea abonar o pagar:</div><div class=col-sm-4><ul class=cabecera-adiciconal><li><strong>Razón Social:</strong> {{::$ctrl.shCtrl.globals.currentUser.thirdName}}<li><strong>Total valor pendiente de pago: </strong>{{$ctrl.payment.recaudo | currency:'$':0}}</ul></div></div><div class=sm-margin></div><div class=\"row consultas\"><div class=col-md-12><div class=table-responsive><div class=\"gridFinancialEntity text-center\" ui-grid=gridOptions ui-grid-selection ui-grid-cellnav ui-grid-resize-columns ui-grid-auto-resize ng-style=$ctrl.getTableHeight ui-grid-edit></div><div class=col-sm-8></div><div class=\"col-sm-4 col-xs-12 totales-pedido\" style=\"padding-right: 0\"><table class=\"table total-table\"><tr><td class=total-table-title>Valor Pendiente:<td class=currency>{{$ctrl.payment.recaudo | currency:'$':0}}<tfoot><tr><td class=total-label>Total a Pagar:<td class=\"total-precio currency\">{{$ctrl.payment.recaudo_total | currency:'$':0}}</table><div class=xs-margin></div></div></div><div class=\"btns-accion btn-pago-detallado text-right col-xs-12 sin-padding\"><button class=\"btn btn-danger\" ng-click=$ctrl.cancelTransaction()>Cancelar</button> <a ui-sref=home.detailZone class=\"btn btn-custom-4\">Regresar </a><button type=button class=\"btn btn-success\" ng-click=$ctrl.submitDetail()>Continuar</button></div></div></div></div><div class=container id=pagos ng-show=\"$ctrl.tab === 2\"><div class=col-xs-12><div class=\"row header-pagos\"><h2>Resumen de pago a realizar</h2><p>A continuación encontrarás un resumen del pago/abono que efectuarás sobre los documentos seleccionados previamente:</div></div><div class=col-md-6><div class=\"info-pagos confirmacion\"><div class=clearfix></div><h3>Información de contacto</h3><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label>Nit.:</label><p>{{$ctrl.shCtrl.globals.currentUser.thirdDocumentNumber}} {{($ctrl.shCtrl.globals.currentUser.thirdDocumentDV ? ('- ' + $ctrl.shCtrl.globals.currentUser.thirdDocumentDV) : '')}}<hr></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label>Razón Social:</label><p>{{$ctrl.shCtrl.globals.currentUser.thirdName}}<hr></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label>Contacto:</label><p>{{$ctrl.shCtrl.globals.currentUser.contactName}}<hr></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label>Email:</label><p>{{$ctrl.shCtrl.globals.currentUser.contactEmail}}<hr></div></div><div class=sm-margin></div></div></div><div class=col-md-6><div class=\"info-pagos confirmacion\"><div class=clearfix></div><h3>Información para el pago</h3><div class=\"col-xs-12 col-sm-4\"><div class=form-group><label>Concepto:</label><p>Pago / abono facturas</div></div><div class=\"col-xs-12 col-sm-3\"><div class=form-group><label>Fecha:</label><p>{{$ctrl.payment.fecha_creacion}}</div></div><div class=\"col-xs-12 col-sm-5\"><div class=form-group><label>Comentario:</label><p>{{$ctrl.payment.observaciones}}</div></div><div class=clearfix></div><div class=\"row consultas consultas-pago-resumen\"><div class=\"col-xs-12 table-responsive\"><table class=\"table table-condensed table-bordered table-striped listado\"><col style=\"width: 25%\"><col style=\"width: 25%\"><col style=\"width: 25%\"><thead><tr class=tablesorter-headerRow><th data-column=1><div class=tablesorter-header-inner></div><th data-column=1><div class=tablesorter-header-inner>No. Documento</div><th data-column=7><div class=tablesorter-header-inner>Vr. pte. de pago</div><th data-column=9><div class=tablesorter-header-inner>Vr. a pagar</div><tbody><tr class=odd ng-repeat=\"bill in $ctrl.payment.bills\"><td><i class=\"fa fa-check-square fa-lg check-confirmacion\"></i><td>{{bill.detalle_numero_documento}}<td class=text-right>{{bill.detalle_saldo_documento | currency:'$':0}}<td class=text-right>{{bill.valor_recaudo | currency:'$':0}}</table></div></div><div class=xs-margin></div><div class=\"col-xs-12 col-sm-6 pull-right\"><div class=row><div class=\"form-group text-right\" style=\"font-size: 1.2em\"><p class=text-right><label class=text-success>Total valor a pagar:</label><strong>{{$ctrl.payment.recaudo_total | currency:'$':0}}</strong><hr></div></div></div><div class=clearfix></div><div class=sm-margin></div><div class=\"btns-accion text-right\"><button type=button class=\"btn btn-danger\" ng-click=$ctrl.cancelTransaction()>Cancelar</button> <button type=button class=\"btn btn-primary\" ng-click=$ctrl.openPaymentComment()>Comentar</button> <button type=button class=\"btn btn-custom-4\" ng-click=\"$ctrl.tab = 1;\">Regresar</button><form action=https://www.pallomaro.com/tienda/smartb2020/frontend/web/index.php/recaudos/recaudos/pay-gate method=POST style=\"display: inline-block\"><input name=concepto_id id=concepto_id style=\"display: hide\" ng-model=$ctrl.payment.concepto_id> <input name=tercero_id id=tercero_id style=\"display: none\" ng-model=$ctrl.shCtrl.globals.currentUser.thirdId> <input name=centro_operacion_id id=centro_operacion_id style=\"display: none\" ng-model=$ctrl.payment.centro_operacion_id> <input name=recaudo_total id=recaudo_total style=\"display: none\" ng-model=$ctrl.payment.recaudo_total> <input name=observaciones id=observaciones style=\"display: none\" ng-model=$ctrl.payment.observaciones> <input name=usuario_creacion id=usuario_creacion style=\"display: none\" ng-model=$ctrl.payment.usuario_creacion> <input name=fecha_creacion id=fecha_creacion style=\"display: none\" ng-model=$ctrl.payment.fecha_creacion><div ng-repeat=\"bill in $ctrl.payment.bills\"><input name=\"{{('facturas[' + $index + '][numero_documento]')}}\" ng-model=\"bill['detalle_numero_documento']\" style=\"display: none\"> <input name=\"{{('facturas[' + $index + '][valor_recaudo]')}}\" ng-model=\"bill['valor_recaudo']\" style=\"display: none\"></div><button type=submit class=\"btn btn-success\">Pagar</button></form></div></div></div></div><style>.text-right {\r\n    text-align: right !important;\r\n  }\r\n\r\n  table.listado tr th {\r\n    padding: 10px 10px 8px;\r\n    line-height: 15px;\r\n    font-weight: 500;\r\n  }\r\n  td strong {\r\n    font-size: 12px;\r\n  }</style><style>table.listado tr th {\r\n    padding: 10px 10px 8px;\r\n    line-height: 15px;\r\n    font-weight: 500;\r\n  }\r\n  td strong {\r\n    font-size: 12px;\r\n  }\r\n  td strong.text-success, td.fontstrong strong {\r\n    font-size: inherit;\r\n  }\r\n  ul.cabecera-adiciconal {\r\n    float: right;\r\n    width: 100%;\r\n  }\r\n  ul.cabecera-adiciconal li {\r\n    text-align: right;\r\n    border-bottom: 1px solid #f5f4f4;\r\n    margin-bottom: 3px;\r\n    padding-bottom: 3px;\r\n    font-size: 14px;\r\n  }</style><style>.pagination{\r\n    float : left !important ;\r\n  }\r\n  .sin-padding{\r\n    padding : 0;\r\n  }\r\n  .ui-grid, .ui-grid-viewport,.ui-grid-contents-wrapper, .ui-grid-canvas { height: auto !important; }</style>";

/***/ },
/* 487 */
/***/ function(module, exports) {

	module.exports = "<div class=\"modal-content salir-aplication\"><div class=modal-header><h5 class=modal-title><span>Comentarios del pago</span></h5></div><div class=modal-body><div class=\"product-add clearfix\"><div class=\"row content-modal-margin\"><div class=\"col-md-12 col-sm-12 col-xs-12\"><label>En el siguiente recuadro puedes ingresar un comentario abierto para tu pago: (Máximo {{mdCtrl.maxlengthComment}} caracteres)</label><div class=sm-margin></div><textarea id=textarea-order-comment class=form-control style=\"height: 100px\" ng-model=mdCtrl.comment maxlength={{mdCtrl.maxlengthComment}}></textarea><div class=text-right style=margin-top:5px;color#666;font-size:12px>{{mdCtrl.comment.length}} caracteres</div></div><div class=\"col-md-12 col-sm-12 col-xs-12\" ng-show=mdCtrl.errorAddedCommentCart><div class=\"alert alert-danger\" style=\"margin-top: 11px\">Ha ocurrido un error al guardar el comentario. Inténtalo de nuevo.</div></div><div class=\"col-md-12 col-sm-12 col-xs-12\" ng-if=mdCtrl.addedCommentCart><div class=\"alert alert-success\" style=\"margin-top: 11px\">El comentario ha sido guardado exitosamente</div></div><div class=\"col-md-12 col-sm-12 col-xs-12\" ng-if=mdCtrl.addingCommentCart style=\"text-align: right;margin-top: 17px\"><i class=\"fa fa-history load-animation\"></i> Guardando comentario...</div></div><div class=\"row btn-actions\"><div class=\"col-xs-12 text-right\"><button type=button ng-click=mdCtrl.cancel() class=\"btn btn-danger\"><strong>Cancelar</strong></button> <button type=button ng-click=mdCtrl.ok() class=\"btn btn-custom-4\"><strong>Guardar</strong></button></div></div></div></div></div><style>.angular-google-map-container { height: 400px; }\r\n  .text-right {\r\n    text-align: right;\r\n  }</style>";

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{$ctrl.shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li ui-sref=home.myPaymentsList class=active><span>Mis Pagos</span><li class=active><span>Detalle de Pago</span></ul></div></div></div></div><div class=container style=margin-top:15px><div class=row><div class=col-md-12><div class=row><div class=col-md-12><div class=row><div class=col-md-6><h4><i class=\"fa fa-file-text-o\"></i> <span id=title-header-cartera>Consulta de Detalle de Pagos</span></h4></div></div><hr><div class=row><div class=col-md-4><strong>Vr. Pago:</strong> {{$ctrl.payment.recaudo_total | currency:'$':0}}<br></div><div class=col-md-4><strong>Número Documento:</strong> {{$ctrl.payment.id}}<br><strong>Estado:</strong> {{$ctrl.payment.referencia_de_pago}}<br></div></div><hr><div class=loader-general ng-if=$ctrl.loandingPayments style=\"margin-bottom:10px; margin-top: 20px\"><img src=" + __webpack_require__(2) + "> <span>Cargando detalle de pago</span></div><div class=\"row consultas\" ng-if=!$ctrl.loandingPayments><div class=col-md-12><div class=table-responsive><table ng-table-dynamic=\"$ctrl.ngTableConfigPayList with $ctrl.ngTableColsPayList\" class=\"table table-condensed table-bordered table-striped listado\"><tr ng-repeat=\"row in $data\"><td ng-repeat=\"col in $columns\"><div ng-switch=col.field><div ng-switch-when=Valor_aplicado>{{row[col.field] | currency:'$':0}}</div><div ng-switch-when=Saldo_Docto>{{row[col.field] | currency:'$':0}}</div><div ng-switch-default ng-if=row[col.field]>{{row[col.field]}}</div><div ng-switch-default ng-if=!row[col.field]>--</div></div></table></div></div></div></div></div></div></div></div><style>.btn-acciones-export i {\r\n    font-size: 17px;\r\n    padding: 4px 0 0;\r\n  }\r\n\r\n  tr td {\r\n    vertical-align: middle !important;\r\n  }\r\n\r\n  th.filter, th.sortable {\r\n    border-left: 1px solid #cdcdcd !important;\r\n  }\r\n\r\n  .table.listado {\r\n    border: transparent;\r\n  }\r\n\r\n  /* table.listado thead tr.ng-table-filters th:first-child {\r\n     width: 145px;\r\n   }*/\r\n\r\n  .ng-table th.sortable .sort-indicator:after, .ng-table th.sortable .sort-indicator:before {\r\n    margin-left: 4px;\r\n  }\r\n\r\n  span a button {\r\n    background: #990c54 !important;\r\n    color: #fff !important;\r\n    padding: 3px 8px !important;\r\n  }\r\n\r\n  .ng-table-pager {\r\n    margin-top: 20px;\r\n  }\r\n\r\n  .ng-table-header {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    line-height: 17px;\r\n  }\r\n\r\n  @media (max-width: 992px) {\r\n    .ng-table-pager {\r\n      position: absolute;\r\n      right: 15px;\r\n    }\r\n  }\r\n  .datos-del-detalle p {\r\n    margin-bottom: 5px;\r\n  }\r\n  .ng-table th.sortable .sort-indicator:after, .ng-table th.sortable .sort-indicator:before {\r\n    border-color: #fff transparent !important;\r\n  }\r\n  .ng-table-counts.btn-group {\r\n    float: left !important;\r\n  }\r\n  ul.pagination.pagination {\r\n    float: right;\r\n  }\r\n  #abonar-cartera .modal-body {\r\n    overflow: hidden;\r\n    padding: 10px;\r\n    font-size: 15px;\r\n  }\r\n  .dato_cartera {\r\n    border-bottom: 1px solid #eee;\r\n    padding: 7px 0;\r\n    color: #808080;\r\n  }\r\n  .dato_cartera strong {\r\n    font-size: 15px;\r\n    font-weight: 500;\r\n    color: rgb(44, 45, 44);\r\n  }\r\n  .dato_cartera span {\r\n    font-size: 12px;\r\n  }\r\n  #cerrarModal {\r\n    width: 90%;\r\n    margin: 4px;\r\n  }</style>";

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{$ctrl.shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li class=active><span>Mis Pagos</span></ul></div></div></div></div><div class=container style=margin-top:15px><div class=row><div class=col-md-12><div class=row><div class=col-md-12><div class=row><div class=col-md-12><h4><i class=\"fa fa-file-text-o\"></i> <span id=title-header-cartera>Consulta mis de Pagos</span></h4></div></div><hr><div class=loader-general ng-if=$ctrl.loandingPayments style=\"margin-bottom:10px; margin-top: 20px\"><img src=" + __webpack_require__(2) + "> <span>Cargando historico de pagos</span></div><div class=\"row confirmacion-registro\" style=margin-bottom:20px ng-if=\"!$ctrl.loandingPayments && !$ctrl.payments.length\"><p>Aún no ha realizado ningún pago. Lo invitamos a realizar su primer pago.</div><div class=\"row consultas\" ng-if=\"!$ctrl.loandingPayments && $ctrl.payments.length\"><div class=col-md-12><div class=row style=\"margin-bottom: 16px\"><div class=\"col-lg-4 col-xs-6\"><div class=\"small-box bg-aqua\"><div class=inner><h3>{{$ctrl.payments.length}}</h3><p>No. Pagos</div><div class=icon><i class=\"fa fa-file-text-o\"></i></div></div></div><div class=\"col-lg-4 col-xs-6\"><div class=\"small-box bg-yellow\"><div class=inner><h3>{{$ctrl.totalPayed | currency:'$':0}}</h3><p>Valor Pagado</div><div class=icon><i class=\"fa fa-usd\"></i></div></div></div></div><div class=table-responsive><table ng-table-dynamic=\"$ctrl.ngTableConfigPayList with $ctrl.ngTableColsPayList\" class=\"table table-condensed table-bordered table-striped listado\"><tr ng-repeat=\"row in $data\"><td ng-repeat=\"col in $columns\"><div ng-switch=col.field><div ng-switch-when=id><strong>Número: {{ row['id']}}</strong></div><div ng-switch-when=tercero_id class=info-usuario style=text-align:left><strong>{{row['tercero']['nombre']}} </strong>/ Nit: {{row['tercero']['documento_numero']}} <span ng-show=\"row['tercero']['documento_dv']\">- {{row['tercero']['documento_dv']}}</span><br><span ng-show=\"row['tercero']['documento_numero']\">Contacto pedido: {{(row['contacto']['primerNombre'] + ' ' + row['contacto']['primerApellido'])}}</span></div><div ng-switch-when=recaudo_total>{{row[col.field] | currency:'$':0}}</div><div ng-switch-when=actions class=\"text-center acciones\"><div class=btn-group><button data-toggle=dropdown class=\"btn btn-default dropdown-toggle\" type=button><span class=caret></span> <span class=sr-only>Toggle Dropdown</span></button><ul class=dropdown-menu style=\"right: 0;left: inherit\"><li><a ui-sref=\"home.myPaymentsDetail({paymentId : row['id']})\" title=\"Ver pago No. {{row['id']}}\">Ver detalle</a></ul></div></div><div ng-switch-default ng-if=row[col.field]>{{row[col.field]}}</div><div ng-switch-default ng-if=!row[col.field]>--</div></div></table></div></div></div></div></div></div></div></div><style>/*table.listado tr th:nth-child(1) {\r\n    width: 150px;\r\n  }\r\n  table.listado tr th:nth-child(2) {\r\n    width: 160px;\r\n  }\r\n  table.listado tr th:nth-child(3) {\r\n    width: 160px;\r\n  }\r\n  table.listado tr th:nth-child(4) {\r\n    width: 150px;\r\n  }\r\n  table.listado tr th:nth-child(5) {\r\n    width: 160px;\r\n  }\r\n  table.listado tr th:nth-child(6) {\r\n    width: 160px;\r\n  }\r\n  table.listado tr th:nth-child(7) {\r\n    width: 150px;\r\n  }\r\n  table.listado tr th:nth-child(8) {\r\n    width: 160px;\r\n  }\r\n  table.listado tr th:nth-child(9) {\r\n    width: 160px;\r\n  }*/\r\n\r\n  tr td {\r\n    vertical-align: middle !important;\r\n  }\r\n\r\n  th.filter, th.sortable {\r\n    border-left: 1px solid #cdcdcd !important;\r\n  }\r\n\r\n  .table.listado {\r\n    border: transparent;\r\n  }\r\n\r\n  /* table.listado thead tr.ng-table-filters th:first-child {\r\n     width: 145px;\r\n   }*/\r\n\r\n  .ng-table th.sortable .sort-indicator:after, .ng-table th.sortable .sort-indicator:before {\r\n    margin-left: 4px;\r\n  }\r\n\r\n  span a button {\r\n    background: #990c54 !important;\r\n    color: #fff !important;\r\n    padding: 3px 8px !important;\r\n  }\r\n\r\n  .ng-table-pager {\r\n    margin-top: 20px;\r\n  }\r\n\r\n  .ng-table-header {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    line-height: 17px;\r\n  }\r\n\r\n  @media (max-width: 992px) {\r\n    .ng-table-pager {\r\n      position: absolute;\r\n      right: 15px;\r\n    }\r\n  }\r\n  .datos-del-detalle p {\r\n    margin-bottom: 5px;\r\n  }\r\n  .ng-table th.sortable .sort-indicator:after, .ng-table th.sortable .sort-indicator:before {\r\n    border-color: #fff transparent !important;\r\n  }\r\n  .ng-table-counts.btn-group {\r\n    float: left !important;\r\n  }\r\n  ul.pagination.pagination {\r\n    float: right;\r\n  }\r\n  #abonar-cartera .modal-body {\r\n    overflow: hidden;\r\n    padding: 10px;\r\n    font-size: 15px;\r\n  }\r\n  .dato_cartera {\r\n    border-bottom: 1px solid #eee;\r\n    padding: 7px 0;\r\n    color: #808080;\r\n  }\r\n  .dato_cartera strong {\r\n    font-size: 15px;\r\n    font-weight: 500;\r\n    color: rgb(44, 45, 44);\r\n  }\r\n  .dato_cartera span {\r\n    font-size: 12px;\r\n  }\r\n  #cerrarModal {\r\n    width: 90%;\r\n    margin: 4px;\r\n  }</style>";

/***/ },
/* 490 */
/***/ function(module, exports) {

	module.exports = "<div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{$ctrl.shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li class=active><span>Confirmación de Pago</span></ul></div></div></div></div><div class=\"container confirmation\"><section class=orden-pago><h2 class=\"text-center exitoso\">{{$ctrl.payInfo.Info }} <i class=\"fa fa-check-square-o\" style=color:#6dca0b ng-if=\"$ctrl.payInfo.estado_transaccion == 1 || $ctrl.payInfo.estado_transaccion == 0\"></i> <i class=\"fa fa-times-circle\" style=color:red ng-if=\"$ctrl.payInfo.estado_transaccion == 2 || $ctrl.payInfo.estado_transaccion == '-1'\"></i></h2><div class=\"col-sm-12 col-xs-6\"><br><h6 class=\"text-center exitoso\">La siguiente información es el resumen de la transacción Nro. {{$ctrl.payInfo.recaudo_cartera_id}},</h6><table class=\"table nonborde\"><tr><td width=50% style=text-align:right;padding-right:5px><strong>Valor de transacción :</strong><td width=50% style=text-align:left;padding-left:5px>{{$ctrl.payInfo.recaudo_total | currency}}<tr><td width=50% style=text-align:right;padding-right:5px><strong>Estado transacción:</strong><td width=50% style=text-align:left;padding-left:5px>{{$ctrl.payInfo.transaccionAprobada}}<tr><td width=50% style=text-align:right;padding-right:5px><strong>Nro Transacción:</strong><td width=50% style=text-align:left;padding-left:5px>{{$ctrl.payInfo.recaudo_cartera_id}}<tr><td width=50% style=text-align:right;padding-right:5px><strong>Fecha de pago:</strong><td width=50% style=text-align:left;padding-left:5px>{{$ctrl.payInfo.fecha_creacion_formato }}<tr><td width=50% style=text-align:right;padding-right:5px><strong>Pagado por:</strong><td width=50% style=text-align:left;padding-left:5px>{{$ctrl.payInfo.contacto_cliente}}<tr><td width=50% style=text-align:right;padding-right:5px><strong>Email:</strong><td width=50% style=text-align:left;padding-left:5px>{{$ctrl.payInfo.email_cliente}}</table></div><div class=\"col-sm-12 col-xs-6\"><br><h4>Listado de documentos pagados :<div class=\"info-pagos confirmacion\"><div class=\"row consultas consultas-pago-resumen\" ng-if=$ctrl.payInfo.facturas.facturas.length><div class=\"col-xs-12 table-responsive\"><table class=\"table table-condensed table-bordered table-striped listado\" style=\"margin-top: 2%\"><col style=\"width: 5%\"><col style=\"width: 20%\"><col style=\"width: 25%\"><col style=\"width: 25%\"><col style=\"width: 25%\"><thead><tr class=tablesorter-headerRow><th data-column=1><div class=tablesorter-header-inner></div><th data-column=1><div class=tablesorter-header-inner>No. Documento</div><th data-column=1><div class=tablesorter-header-inner>Vr. pagado</div><tbody><tr class=odd ng-repeat=\"bill in $ctrl.payInfo.facturas.facturas\"><td><i class=\"check-confirmacion fa fa-2x fa-check-circle\"></i><td>{{bill.tipo_documento}}-{{bill.numero_documento}}<td>${{bill.valor_recaudo | currency:'':0}}</table></div></div></div></h4></div><div class=\"col-xs-12 desea-hacer\"><a ui-sref=home.detailZone class=\"btn btn-success\">Realizar otro pago</a></div></section></div>";

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"row media cabecera\"><div class=col-sm-12><div class=tabs-title ng-bind-html=\"$ctrl.shCtrl.globalParams.cmsInfo.ZONA_DE_PAGO_FACTURAS_TITULO | toTrusted\"></div><div class=tabs-descripcion ng-bind-html=\"$ctrl.shCtrl.globalParams.cmsInfo.ZONA_DE_PAGO_FACTURAS_DETALLE | toTrusted\"></div></div></div><div class=sm-margin></div><div class=\"alert alert-success\" ng-show=$ctrl.notification>El/los documentos seleccionados han sido agregados al carrito de pagos.</div><div class=table-responsive ng-show=\"$ctrl.stateServiceOrders.loaded && !$ctrl.stateServiceOrders.error\"><table ng-table-dynamic=\"$ctrl.ngTableConfigServiceOrders with $ctrl.ngTableColsServiceOrders\" class=\"table table-condensed table-bordered table-striped listado table-min-space pay-bills\"><col><col><col><col><tr ng-repeat=\"(fIndex, row) in $data\"><td ng-repeat=\"col in $columns\"><span ng-switch=col.field><span ng-switch-when=valor_doc style=\"text-align:right; display: block\">$ {{row[col.field] | currency:'':0}} </span><span ng-switch-when=detalle_valor_documento style=\"text-align:right; display: block\">$ {{row[col.field] | currency:'':0}}</span><div ng-switch-when=valor_pagar_hoy style=\"display: block\"><input class=form-control restrict-type=numValues ng-model=row[col.field] ng-disabled=!row.activate ng-blur=$ctrl.changeValor(row) style=\"text-align: right\"></div><span ng-switch-when=detalle_saldo_documento style=\"text-align:right; display: block\">$ {{row[col.field] | currency:'':0}} </span><span ng-switch-when=saldo_documento style=\"text-align:right; display: block\">$ {{row[col.field] | currency: '':0}}</span><div ng-switch-when=selection><p class=\"custom-checkbox seleccion\" ng-if=\"row.valor_pendiente > 0\"><input type=checkbox ng-model=row.activate ng-change=$ctrl.activateServiceOrder(row) id=check-{{fIndex}}><label for=check-{{fIndex}}></label></div><span ng-switch-default ng-if=row[col.field]>{{row[col.field]}} </span><span ng-switch-default ng-if=!row[col.field]>--</span></span><tr class=total-table><td colspan=4 class=\"no-border-side fontstrong text-right\"><strong class=text-info>TOTALES:</strong><td class=\"no-border-side fontstrong text-right\"><strong>{{$ctrl.payment.recaudo | currency:'$':0}}</strong><td colspan=1 class=\"no-border-side fontstrong text-right\"><strong style=\"margin-right: 3%\" class=text-success>{{$ctrl.payment.recaudo_total | currency:'$':0}}</strong><td colspan=3 class=no-border-side></table><div style=\"clear: both\"></div><div class=sm-margin></div><div class=\"btns-accion text-right\" style=\"padding: 0\"><button class=\"btn btn-danger\" ng-click=$ctrl.addPayment()>Agregar a carrito de pago</button> <button class=\"btn btn-success\">Ir al carrito de pago</button></div></div><div class=col-md-12 ng-show=\"$ctrl.stateServiceOrders.loaded && !$ctrl.stateServiceOrders.error && !$ctrl.serviceOrdersList.length\" style=\"margin-top: 14px\"><div class=\"alert alert-warning\">No se ha encontrado información para la consulta realizada.</div></div><div class=col-md-12 ng-show=\"$ctrl.stateServiceOrders.loaded && $ctrl.stateServiceOrders.error\"><div class=\"alert alert-warning\">No se ha encontrado información para la consulta realizada.</div></div><div class=col-md-12 style=text-align:center><div class=loader-general ng-show=$ctrl.stateServiceOrders.loading style=\"margin-top:10px; margin-bottom: 10px;text-align:left;font-size:11px;\r\n        margin-left:7px; displaY:inline-block\"><img src=" + __webpack_require__(2) + " style=width:18px> Espere un momento mientras se cargan las facturas...</div></div>";

/***/ },
/* 492 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row canasta-pedido pagcanasta\"><div class=\"media cabecera\"><div class=col-sm-12><div class=tabs-title ng-bind-html=\"$ctrl.shCtrl.globalParams.cmsInfo.ZONA_DE_PAGO_CARRITO_DE_PAGO_TITULO | toTrusted\"></div><div class=tabs-descripcion ng-bind-html=\"$ctrl.shCtrl.globalParams.cmsInfo.ZONA_DE_PAGO_CARRITO_DE_PAGO_DETALLE | toTrusted\"></div></div></div><br><br><div class=col-md-12><div class=\"alert alert-warning\" ng-show=$ctrl.errorAddingQuantityItemtoCart><div ng-bind-html=\"$ctrl.errorMessageAddingQuantityItemtoCart | toTrusted\"></div></div><table class=\"table tb\"><thead><tr><th class=\"title-quote-or-order table-title text-center\" colspan=8><span class=titulo-table-pedido>LISTADO DE DOCUMENTOS A PAGAR</span><tr><th width=5% class=\"table-title hidden-xs\">Quitar<th width=25% class=\"table-title hidden-xs\">Tipo doc.<th width=20% class=\"table-title hidden-xs\">No.<th width=25% class=\"table-title hidden-xs\">Vr. Doc / Ítem<th width=25% class=\"table-title hidden-xs\">Vr. A pagar<tbody><tr ng-repeat=\"(key, item) in $ctrl.shCtrl.globals.currentClient.payCart\"><td class=item-name-col><a href=\"\" ng-click=$ctrl.removeItems(this) ng-model=key><i class=\"fa fa-times-circle text-danger\" aria-hidden=true></i></a><td class=item-name-col>{{item.type}}<td class=item-name-col>{{item.detalle_numero_documento}}<td class=\"item-name-col text-right\">{{item.detalle_valor_documento | currency:'$':0}}<td class=\"item-name-col text-right\">{{item.valor_pagar_hoy | currency:'$':0}}</table></div></div><div class=\"btns-accion text-right\"></div><div class=\"row datos-totales\"><div class=\"visible-sm col-sm-6\"></div><div class=\"col-md-4 col-sm-6 col-xs-12 col-md-offset-8 totales-pedido\"><table class=\"table total-table\" style=\"margin-top: 3%\"><tfoot><tr><td class=total-label>Total a Pagar:<td class=\"total-precio currency\">$ {{$ctrl.shCtrl.globals.currentClient.totalCartPay | currency:'':0}} <small>COP</small></table><div class=xs-margin></div></div></div><div class=\"btns-accion text-right\"><form action=https://www.pallomaro.com/tienda/smartb2020/frontend/web/index.php/recaudos/recaudos/pay-gate method=POST style=\"display: inline-block\"><input name=concepto_id id=concepto_id style=\"display: none\" ng-model=$ctrl.concepType> <input name=tercero_id id=tercero_id style=\"display: none\" ng-model=$ctrl.shCtrl.globals.currentClient.thirdId> <input name=centro_operacion_id id=centro_operacion_id style=\"display: none\" ng-model=$ctrl.payment.centro_operacion_id> <input name=recaudo_total id=recaudo_total style=\"display: none\" ng-model=$ctrl.shCtrl.globals.currentClient.totalCartPay> <input name=observaciones id=observaciones style=\"display: none\" ng-model=$ctrl.payment.observaciones> <input name=usuario_creacion id=usuario_creacion style=\"display: none\" ng-model=$ctrl.shCtrl.globals.currentClient.userId> <input name=fecha_creacion id=fecha_creacion style=\"display: none\" ng-model=$ctrl.fecha><div ng-repeat=\"bill in $ctrl.shCtrl.globals.currentClient.payCart\"><input name=\"{{('facturas[' + $index + '][numero_documento]')}}\" ng-model=\"bill['detalle_numero_documento']\" style=\"display: none\"> <input name=\"{{('facturas[' + $index + '][detalle_valor_documento]')}}\" ng-model=\"bill['detalle_valor_documento']\" style=\"display: none\"> <input name=\"{{('facturas[' + $index + '][valor_pagar_hoy]')}}\" ng-model=\"bill['valor_pagar_hoy']\" style=\"display: none\"> <input name=\"{{('facturas[' + $index + '][type]')}}\" ng-model=\"bill['type']\" style=\"display: none\"> <input name=\"{{('facturas[' + $index + '][referencia]')}}\" ng-model=\"bill['referencia']\" style=\"display: none\"></div><button type=submit class=\"btn btn-success\" ng-click=$ctrl.clear() ng-if=$ctrl.shCtrl.globals.currentClient.totalCartPay>Realizar pago</button></form></div>";

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"row media cabecera\"><div class=col-sm-12><div class=tabs-title ng-bind-html=\"$ctrl.shCtrl.globalParams.cmsInfo.ZONA_DE_PAGO_PEDIDOS_TITULO | toTrusted\"></div><div class=tabs-descripcion ng-bind-html=\"$ctrl.shCtrl.globalParams.cmsInfo.ZONA_DE_PAGO_PEDIDOS_DETALLE | toTrusted\"></div></div></div><div class=sm-margin></div><div class=\"alert alert-success\" ng-show=$ctrl.notification>El/los documentos seleccionados han sido agregados al carrito de pagos.</div><div class=table-responsive ng-show=\"$ctrl.serviceOrdersList.length > 0 && $ctrl.stateServiceOrders.loaded && !$ctrl.stateServiceOrders.loading\"><table ng-table-dynamic=\"$ctrl.ngTableConfigServiceOrders with $ctrl.ngTableColsServiceOrders\" class=\"table table-condensed table-bordered table-striped listado table-min-space pay-orders\"><col><col><col><col><tr ng-repeat=\"(fIndex, row) in $data\"><td ng-repeat=\"col in $columns\"><span ng-switch=col.field><span ng-switch-when=valor_doc style=\"text-align:right; display: block\">$ {{row[col.field] | currency:'':0}} </span><span ng-switch-when=detalle_valor_documento style=\"text-align:right; display: block\">$ {{row[col.field] | currency:'':0}}</span><div ng-switch-when=valor_pagar_hoy style=\"display: block\"><input class=form-control restrict-type=numValues ng-model=row[col.field] ng-disabled=!row.activate ng-blur=$ctrl.changeValor(row) style=\"text-align: right\"></div><span ng-switch-when=detalle_saldo_documento style=\"text-align:right; display: block\">$ {{row[col.field] | currency:'':0}}</span><div ng-switch-when=selection><p class=\"custom-checkbox seleccion\" ng-if=\"row.valor_pendiente > 0\"><input type=checkbox ng-model=row.activate ng-change=$ctrl.activateServiceOrder(row) id=check-{{fIndex}}><label for=check-{{fIndex}}></label></div><span ng-switch-default ng-if=row[col.field]>{{row[col.field]}} </span><span ng-switch-default ng-if=!row[col.field]>--</span></span><tr class=total-table><td colspan=3 class=\"no-border-side fontstrong text-right\"><strong class=text-info>TOTALES:</strong><td class=\"no-border-side fontstrong text-right\"><strong>{{$ctrl.payment.recaudo | currency:'$':0}}</strong><td colspan=1 class=\"no-border-side fontstrong text-right\"><strong style=\"margin-right: 3%\" class=text-success>{{$ctrl.payment.recaudo_total | currency:'$':0}}</strong><td colspan=3 class=no-border-side></table><div style=\"clear: both\"></div><div class=sm-margin></div><div class=\"btns-accion text-right\" style=\"padding: 0\"><button class=\"btn btn-danger\" ng-click=$ctrl.addPayment()>Agregar a carrito de pago</button> <button class=\"btn btn-success\">Ir al carrito de pago</button></div></div><div class=col-md-12 ng-show=\"$ctrl.stateServiceOrders.loaded && !$ctrl.stateServiceOrders.error && !$ctrl.serviceOrdersList.length\" style=\"margin-top: 14px\"><div class=\"alert alert-warning\">No se ha encontrado información para la consulta realizada.</div></div><div class=col-md-12 ng-show=\"$ctrl.stateServiceOrders.loaded && $ctrl.stateServiceOrders.error\"><div class=\"alert alert-warning\">No se ha encontrado información para la consulta realizada.</div></div><div class=col-md-12 style=text-align:center><div class=loader-general ng-show=$ctrl.stateServiceOrders.loading style=\"margin-top:10px; margin-bottom: 10px;text-align:left;font-size:11px;\r\n          margin-left:7px; displaY:inline-block\"><img src=" + __webpack_require__(2) + " style=width:18px> Espere un momento mientras se cargan las cotizaciones...</div></div>";

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"row media cabecera\" ng-if=!$ctrl.wachingDetailQuotation><div class=col-sm-12><div class=tabs-title ng-bind-html=\"$ctrl.shCtrl.globalParams.cmsInfo.ZONA_DE_PAGO_COTIZACIONES_TITULO | toTrusted\"></div><div class=tabs-descripcion ng-bind-html=\"$ctrl.shCtrl.globalParams.cmsInfo.ZONA_DE_PAGO_COTIZACIONES_DETALLE | toTrusted\"></div></div></div><div class=\"alert alert-success\" ng-show=$ctrl.notification>El/los documentos seleccionados han sido agregados al carrito de pagos.</div><div class=\"row consultas\" ng-if=!$ctrl.wachingDetailQuotation><div class=\"col-xs-12 table-responsive\" ng-show=\"$ctrl.quotationsList.length > 0 && $ctrl.stateQuotations.loaded && !$ctrl.stateQuotations.loading\"><table ng-table-dynamic=\"$ctrl.ngTableConfigQuotations with $ctrl.ngTableColsQuotations\" class=\"table table-condensed table-bordered table-striped listado table-min-space\"><col><col><col><col><tr ng-repeat=\"(fIndex, row) in $data\"><td ng-repeat=\"col in $columns\"><span ng-switch=col.field><span ng-switch-when=actions><div class=btn-group><button type=button class=\"btn btn-default btn-sm dropdown-toggle\" data-toggle=dropdown aria-haspopup=true aria-expanded=false><i class=\"fa fa-bars\" aria-hidden=true></i></button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a title=\"Ver detalle\" style=\"cursor: pointer\" ng-click=$ctrl.getQuotationDetail(row);>Detalle</a></ul></div></span><span ng-switch-when=subtotal|impuestos|valor_doc ng-switch-when-separator=| style=\"text-align:right; display: block\">$ {{row[col.field] | currency:'':0}} </span><span ng-switch-default ng-if=row[col.field]>{{row[col.field]}} </span><span ng-switch-default ng-if=!row[col.field]>--</span></span></table><div style=\"clear: both\"></div><div class=sm-margin></div></div><div class=col-md-12 ng-show=\"$ctrl.stateQuotations.loaded && !$ctrl.stateQuotations.error && !$ctrl.quotationsList.length\" style=\"margin-top: 14px\"><div class=\"alert alert-warning\">No se ha encontrado información para la consulta realizada.</div></div><div class=col-md-12 ng-show=\"$ctrl.stateQuotations.loaded && $ctrl.stateQuotations.error\"><div class=\"alert alert-danger\">Ha ocurrido un error al obtener las cotizaciones. Por favor contacte al administrador del sistema.</div></div><div class=col-md-12 style=text-align:center><div class=loader-general ng-show=$ctrl.stateQuotations.loading style=\"margin-top:10px; margin-bottom: 10px;text-align:left;font-size:11px;\r\n        margin-left:7px; displaY:inline-block\"><img src=" + __webpack_require__(2) + " style=width:18px> Espere un momento mientras se cargan las cotizaciones...</div></div></div><div ng-if=$ctrl.wachingDetailQuotation><div class=\"row media cabecera\"><div class=col-md-12><div class=tabs-title ng-bind-html=\"$ctrl.shCtrl.globalParams.cmsInfo.ZONA_DE_PAGO_COTIZACIONES_DETALLE_TITULO | toTrusted\"></div><div class=tabs-descripcion ng-bind-html=\"$ctrl.shCtrl.globalParams.cmsInfo.ZONA_DE_PAGO_COTIZACIONES_DETALLE_DETALLE | toTrusted\"></div><br></div><div class=sm-margin></div><div class=col-md-4><ul><li><strong>Cotización No. :</strong> {{$ctrl.currentQuote.number}}<li><strong>Fecha elaboración : </strong>{{$ctrl.currentQuote.elaborationDate}}</ul></div><div class=col-md-4><ul><li><strong>Vendedor :</strong> {{$ctrl.currentQuote.assigned_user_name}}<li><strong>Fecha vencimiento : </strong>{{$ctrl.currentQuote.expirationDate}}</ul></div></div><div class=sm-margin></div><div class=\"row consultas\"><div class=col-xs-12 ng-show=\"$ctrl.quotationDetail.length > 0 && $ctrl.stateQuotationDetail.loaded && !$ctrl.stateQuotationDetail.loading\"><table ng-table-dynamic=\"$ctrl.ngTableConfigQuotationDetail with $ctrl.ngTableColsQuotationDetail\" class=\"table table-condensed table-bordered table-striped listado table-min-space quotations-detail\"><col><col><col><col><tr ng-repeat=\"(fIndex, row) in $data\"><td ng-repeat=\"col in $columns\"><span ng-switch=col.field><span ng-switch-when=vr_total|vr_unit|descuento_moneda ng-switch-when-separator=| style=\"text-align:right; display: block\">$ {{row[col.field] | currency:'':0}}</span><div ng-switch-when=unidad_medida><span style=\"width:5% !important\">{{row[col.field]}}</span></div><span ng-switch-when=porcentaje_descuento|impuestos ng-switch-when-separator=|>{{row[col.field] + '%'}} </span><span ng-switch-when=descriptionShort><small>{{row[col.field]}}</small> <a ng-if=row.short ng-model=key uib-tooltip=\"{{row['descripcion_item']}}\" tooltip-placement=top tooltip-trigger=\"'mouseenter'\"><i class=\"fa fa-plus-circle\" aria-hidden=true></i> </a></span><span ng-switch-default ng-if=row[col.field]>{{row[col.field]}}</span><div ng-switch-when=valor_pagar_hoy style=\"display: block\"><input class=\"form-control text-right\" restrict-type=numValues ng-model=row[col.field] ng-disabled=!row.activate ng-blur=$ctrl.changeValor(row)></div><div ng-switch-when=selection><p class=\"custom-checkbox seleccion\"><input type=checkbox ng-model=row.activate ng-change=$ctrl.activateQuotation(row) id=check-{{fIndex}}><label for=check-{{fIndex}}></label></div><span ng-switch-default ng-if=!row[col.field]>--</span></span><tr class=total-table><td colspan=8 class=\"no-border-side fontstrong text-right\"><strong class=text-info>Totales:</strong><td class=\"no-border-side fontstrong text-right\"><strong>{{$ctrl.payment.recaudo | currency:'$':0}}</strong><td colspan=1 class=\"no-border-side fontstrong text-right\"><strong style=\"margin-right: 3%\" class=text-success>{{$ctrl.payment.recaudo_total | currency:'$':0}}</strong><td colspan=3 class=no-border-side></table><p><strong>*Nota</strong>: <em>El valor mínimo a pagar de cada producto debe ser del 30% de su valor total</em><div style=\"clear: both\"></div><div class=sm-margin></div><div class=\"btns-accion text-right\" style=\"padding: 0\"><button class=\"btn btn-custom-4\" ng-click=$ctrl.getQuotationsHead();>Regresar</button> <button class=\"btn btn-danger\" ng-click=$ctrl.addPayment()>Agregar a carrito de pago</button> <button class=\"btn btn-success\">Ir al carrito de pago</button></div></div><div class=col-md-12 ng-show=\"$ctrl.stateQuotationDetail.loaded && !$ctrl.stateQuotationDetail.error && !$ctrl.quotationDetail.length\" style=\"margin-top: 14px\"><div class=\"alert alert-warning\">No se ha encontrado información para la consulta realizada.</div></div><div class=col-md-12 ng-show=\"$ctrl.stateQuotationDetail.loaded && $ctrl.stateQuotationDetail.error\"><div class=\"alert alert-danger\">Ha ocurrido un error al obtener el detalle de la cotización. Por favor contacte al administrador del sistema.</div></div><div class=col-md-12 style=text-align:center><div class=loader-general ng-show=$ctrl.stateQuotationDetail.loading style=\"margin-top:10px; margin-bottom: 10px;text-align:left;font-size:11px;\r\n          margin-left:7px; displaY:inline-block\"><img src=" + __webpack_require__(2) + " style=width:18px> Espere un momento mientras se carga la cotización...</div></div></div></div>";

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li><span>Pagos y Anticipos</span><li><span>Anticipos</span><li class=active><span>Ordenes de Servicio</span></ul></div></div></div></div><div class=container ng-if=!$ctrl.wachingDetailServiceOrder><div class=\"row media cabecera\"><div class=col-sm-6><span class=dropcap><img src=http://solucion-maestra.com/clientes/tablemac/produccion/images/consultas_ico.png alt=\"Consulta de estado de pedidos\"></span><h1>Documentos Anticipos / Ordenes de Servicio</h1><p><strong>Nota</strong>: <em>Los documentos que se presentan a continuación corresponden a los últimos 6 meses</em></div><div class=col-sm-6><ul class=cabecera-adiciconal><li><strong>Razón Social:</strong> {{$ctrl.shCtrl.globals.currentUser.thirdName}}<li><strong>Total valor pendiente de pago: </strong>{{$ctrl.payment.recaudo | currency:'$':0}}</ul></div></div><div class=sm-margin></div><div class=\"row consultas\"><div class=\"col-xs-12 table-responsive\" ng-show=\"$ctrl.serviceOrdersList.length > 0 && $ctrl.stateServiceOrders.loaded && !$ctrl.stateServiceOrders.loading\"><table ng-table-dynamic=\"$ctrl.ngTableConfigServiceOrders with $ctrl.ngTableColsServiceOrders\" class=\"table table-condensed table-bordered table-striped listado table-min-space table-order-service-head\"><col><col><col><col><tr ng-repeat=\"(fIndex, row) in $data\"><td ng-repeat=\"col in $columns\"><span ng-switch=col.field><span ng-switch-when=actions><div class=btn-group><button type=button class=\"btn btn-default btn-sm dropdown-toggle\" data-toggle=dropdown aria-haspopup=true aria-expanded=false><i class=\"fa fa-bars\" aria-hidden=true></i></button><ul class=dropdown-menu><li><a ui-sref=\"home.quotations({orderServiceId : row.name})\" title=\"Ver detalle\" style=\"cursor: pointer\">Detalle</a></ul></div></span><span ng-switch-when=subtotal|impuestos|valor_doc ng-switch-when-separator=| style=\"text-align:right; display: block\">$ {{row[col.field] | currency:'':0}}</span><div ng-switch-when=valor_pagar_hoy style=\"display: block\"><input class=form-control restrict-type=numValues ng-model=row[col.field] ng-disabled=!row.activate ng-blur=$ctrl.changeValor(row)></div><div ng-switch-when=selection><p class=\"custom-checkbox seleccion\" ng-if=\"row.valor_pendiente > 0\"><input type=checkbox ng-model=row.activate ng-change=$ctrl.activateServiceOrder(row) id=check-{{fIndex}}><label for=check-{{fIndex}}></label></div><span ng-switch-default ng-if=row[col.field]>{{row[col.field]}} </span><span ng-switch-default ng-if=!row[col.field]>--</span></span><tr class=total-table><td colspan=6 class=\"no-border-side fontstrong text-right\"><strong class=text-info>TOTALES:</strong><td class=\"no-border-side fontstrong text-right\"><strong>{{$ctrl.payment.recaudo | currency:'$':0}}</strong><td colspan=2 class=\"no-border-side fontstrong text-right\"><strong class=text-success>{{$ctrl.payment.recaudo_total | currency:'$':0}}</strong><td colspan=2 class=no-border-side></table><div style=\"clear: both\"></div><div class=sm-margin></div><div class=\"btns-accion text-right\" style=\"padding: 0\"><button class=\"btn btn-danger\">Pagar <i class=\"fa fa-money\" aria-hidden=true></i></button></div></div><div class=col-md-12 ng-show=\"$ctrl.stateServiceOrders.loaded && !$ctrl.stateServiceOrders.error && !$ctrl.serviceOrdersList.length\" style=\"margin-top: 14px\"><div class=\"alert alert-warning\">No se ha encontrado información para la consulta realizada.</div></div><div class=col-md-12 ng-show=\"$ctrl.stateServiceOrders.loaded && $ctrl.stateServiceOrders.error\"><div class=\"alert alert-danger\">Ha ocurrido un error al obtener las ordenes de servicio. Por favor contacte al administrador del sistema.</div></div><div class=col-md-12 style=text-align:center><div class=loader-general ng-show=$ctrl.stateServiceOrders.loading style=\"margin-top:10px; margin-bottom: 10px;text-align:left;font-size:11px;\r\n        margin-left:7px; displaY:inline-block\"><img src=" + __webpack_require__(2) + " style=width:18px> Espere un momento mientras se cargan las ordenes de servicio...</div></div></div></div>";

/***/ },
/* 496 */
/***/ function(module, exports) {

	module.exports = "<div class=\"modal-content salir-aplication\"><div class=modal-header><h5 class=modal-title><span>Comentario final de caso</span></h5></div><div class=modal-body><div class=\"product-add clearfix\"><form name=mdCtrl.lastCommentForm id=lastCommentForm novalidate><label>Ingrese el comentario final del caso</label><textarea required name=\"\" cols=30 rows=3 ng-model=mdCtrl.comment class=form-control></textarea></form><div class=\"row btn-actions\"><div class=col-xs-12><button class=\"btn btn-danger\" type=button ng-click=mdCtrl.cancel() style=\"margin-right: 5px\"><strong>Cerrar</strong></button> <button class=\"btn btn-primary\" type=button ng-disabled=mdCtrl.lastCommentForm.$invalid ng-click=mdCtrl.ok()>Guardar</button></div></div></div></div></div>";

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{$ctrl.shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li><a>PQRS</a><li class=active><span>Detalle del caso</span></ul></div></div></div></div><div class=container><div class=row><div class=col-md-12><div class=md-margin></div><div class=row><div class=col-md-12><h2><i class=\"fa fa-info-circle\" aria-hidden=true></i> Detalle del caso # {{::$ctrl.pqrs.id}} <a href=\"\" ng-click=$ctrl.exportCSV($ctrl.pqrs.id) style=float:right class=\"btn btn-info btn-sm\"><i class=\"fa fa-file-excel-o\" aria-hidden=true></i> Exportar a .XLS</a></h2><h5>{{::$ctrl.pqrs.branchName}} / {{::$ctrl.pqrs.thirdPartyName}}</h5><hr><div class=col-xs-12 style=\"padding-left: 0px;padding-right: 0px\"><div ng-show=$ctrl.changeStateSuccess class=\"alert alert-success\">Estado del PQRS modificado exitosamente.</div></div><div class=col-xs-12 style=\"padding-left: 0px;padding-right: 0px\"><div ng-show=$ctrl.changeResponsableSuccess class=\"alert alert-success\">PQRS Reasignado exitosamente.</div></div></div></div><div class=xs-margin></div><div class=\"col-md-12 no-padding-right\"><div class=row><div class=col-md-12><div class=\"row seven-cols\"><div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-12 list-detail-page\" style=\"margin-bottom: 0.5em\"><div class=row><div class=detail-header><div class=propiedad-detail><span>Asunto:</span></div><div class=valor-detail>{{$ctrl.pqrs.subject}}</div></div><div class=detail-header><div class=propiedad-detail>Relacionado con:</div><div class=valor-detail>{{$ctrl.pqrs.relatedWith}}</div></div><div class=detail-header><div class=propiedad-detail>Registrado el:</div><div class=valor-detail>{{$ctrl.pqrs.registeredDate}}</div></div></div></div><div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-12 list-detail-page\" style=\"margin-bottom: 0.5em\"><div class=row><div class=detail-header><div class=propiedad-detail>Estado del caso:</div><div class=valor-detail><span ng-if=!$ctrl.pqrs.responsable>{{$ctrl.pqrs.state}}</span><form name=$ctrl.pqrsStatus novalidate><select ng-if=$ctrl.pqrs.responsable name=status id=status style=\"width: 100%\" ng-change=$ctrl.changePQRSState() ng-model=$ctrl.pqrs.stateId ng-options=\"status.id as status.nombre for status in $ctrl.statuses\"></select></form></div></div><div class=detail-header><div class=propiedad-detail>No. Documento:</div><div class=valor-detail><span>{{$ctrl.pqrs.documentNumber}}</span> <span ng-if=!$ctrl.pqrs.documentNumber>Sin documento asociado</span></div></div><div class=detail-header><div class=propiedad-detail><span>Lugar del incidente:</span></div><div class=valor-detail>{{$ctrl.pqrs.incidenceLocation}}</div></div></div></div><div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-12 list-detail-page\" style=\"margin-bottom: 0.5em\"><div class=row><div class=detail-header><div class=propiedad-detail>Fecha del incidente:</div><div class=valor-detail>{{$ctrl.pqrs.incidenceDate}}</div></div><div class=detail-header><div class=propiedad-detail>Email Respuesta:</div><div class=valor-detail>{{$ctrl.pqrs.incidenceResponseMail}}</div></div><div class=detail-header><div class=propiedad-detail>Teléfono Respuesta:</div><div class=valor-detail>{{$ctrl.pqrs.incidenceResponsePhone}}</div></div><div class=detail-header ng-if=\"($ctrl.pqrs.responsable && $ctrl.reasignacion && !$ctrl.pqrs.isClosed) || ($ctrl.pqrs.responsable && $ctrl.shCtrl.globals.currentUser.isSupervisor && !$ctrl.pqrs.isClosed) || ($ctrl.pqrs.responsable && $ctrl.shCtrl.globals.currentUser.isMaster && !$ctrl.pqrs.isClosed)\"><div class=propiedad-detail>Encargado:</div><div class=valor-detail><form name=$ctrl.pqrsReponsableFrom novalidate><input class=form-control ng-model=$ctrl.pqrs_responsable.nombre id=pqrsResponsable style=\"height: 21px\" name=pqrsResponsable placeholder=\"Ingrese encargado\" uib-typeahead=\"resp as resp.nombre for resp in $ctrl.getPQRSResponsables($viewValue)\" typeahead-no-results=$ctrl.noResults typeahead-on-select=\"$ctrl.savePQRSResponsable($item, $model)\" typeahead-min-length=3 typeahead-editable=false><div class=\"ubicaciones-texto col-md-12\" ng-show=$ctrl.noResults><div class=ubicacion-texto>No hay resultados para el texto ingresado</div></div></form></div></div></div></div></div></div></div></div><div class=clear></div><div class=lg-margin></div><div class=row><div class=\"col-md-12 comentario-caso\"><strong>Comentario inicial del caso</strong><hr><p>{{$ctrl.pqrs.comments}}</div></div><div class=clear></div><div class=lg-margin></div><form id=pqrs-respose-form ng-if=!$ctrl.pqrs.isClosed class=\"form pqrs\" name=$ctrl.pqrsResponseForm ng-submit=$ctrl.saveResponsePQRS($ctrl.pqrsResponseForm) novalidate><div class=row><div class=\"col-md-12 no-padding-right\"><div class=row><div class=col-md-12><div class=detalle-caso style=\"overflow: visible\"><label class=\"absolute-element-center container_tooltip\"><i class=\"fa fa-question-circle\"></i> Archivos Anexos: <span class=message_tool>Peso máximo por archivo <b>3MB</b> en formatos <b>.jpg</b> o <b>.pdf</b>.</span></label><div class=\"custom-inputfile float-right\"><input type=file ng-model=$ctrl.pqrsResponseFormData.attachFiles id=files name=files multiple accept=\"image/*, .pdf\" base-sixty-four-input ng-change=$ctrl.copyFiles();><label for=files class=\"btn btn-primary\">Escoge un Archivo</label></div></div></div><div class=col-md-12 style=\"margin-bottom: 12px\"><div class=\"col-md-6 files-list\" ng-repeat=\"file in $ctrl.pqrs.anexos\" ng-class=\"{'no-margin-top': $index > 1}\"><div class=white-space-file><a href={{::file.anexosFile}} download target=_blank>{{::file.anexosName}}</a></div></div></div></div></div></div><div class=\"row contenido-registro\"><div class=col-md-12><div class=form-group><p class=\"text-warning bg-warning\" style=\"padding: 15px\" ng-show=$ctrl.maxSizeError>Los archivos no deben exceder 3 MB.<p class=\"text-warning bg-warning\" style=\"padding: 15px\" ng-show=$ctrl.invalidExt>Archivo con formato invalido.<br>Formato permitido: (.jpg, .pdf)</div></div><div class=\"col-md-12 margin-bot-20\"><table class=table ng-show=\"$ctrl.pqrsResponseFormData.files.length > 0\"><thead><tr><th width=50%>Nombre del archivo<th>Tamaño<th>Remover<tbody><tr ng-repeat=\"file in $ctrl.pqrsResponseFormData.files\"><td>{{file.filename}}<td>{{file.filesize | fileSize:2}}<td><button type=button class=\"btn btn-danger btn-s\" ng-click=$ctrl.removeFile(file); style=\"padding: 2px 5px\" ng-disabled=$ctrl.pqrsResponseFormData.state.savingPqrs><span class=\"glyphicon glyphicon-trash\"></span></button><tr><td><b>Peso Total</b><td><b>{{$ctrl.totalSize | fileSize:2}}</b><td></table></div><div class=col-xs-12><div class=form-group><div class=\"col-md-12 detalle-caso\"><strong>Agregar Respuesta:</strong></div><textarea rows=5 placeholder=\"\" class=\"form-control input-sm\" name=comments title=\"Por favor comentenos su caso\" autocomplete=off ng-model=$ctrl.pqrsResponseFormData.comments ng-disabled=$ctrl.pqrsResponseFormData.state.savingPqrsResponse required>\r\n                </textarea><span class=input-help><span ng-show=\"$ctrl.pqrsResponseForm.comments.$invalid && !$ctrl.pqrsResponseForm.comments.$pristine\" class=help-block>Ingrese una respuesta a la incidencia.</span></span></div></div><div class=col-xs-12><div><div class=loader-general ng-show=$ctrl.pqrsResponseFormData.state.savingPqrsResponse style=\"margin-bottom: 10px;text-align:left;font-size:13px;\r\n                  margin-left:7px; display:inline-block;color:#787878\"><img src=" + __webpack_require__(2) + " style=width:18px> Agregando Respuesta...</div></div><div class=col-xs-12 style=\"padding-left: 0px;padding-right: 0px\"><div ng-show=$ctrl.pqrsResponseFormData.state.savedPqrsResponse class=\"alert alert-success\">La respuesta a la incidencia # {{$ctrl.pqrs.id}} ha sido agregada.</div></div><button type=submit ng-show=!$ctrl.pqrsResponseFormData.state.savingPqrsResponse ng-disabled=$ctrl.pqrsResponseFormData.state.savingPqrsResponse class=\"btn btn btn-success md-margin\"><span ng-show=!$ctrl.pqrsResponseFormData.state.savingPqrsResponse>Agregar Respuesta</span> <span ng-show=$ctrl.pqrsResponseFormData.state.savingPqrsResponse>Agregando Respuesta...</span></button><div class=pull-right ng-show=!$ctrl.pqrs.responsable style=\"margin-bottom: 0px; padding: 0\"><div class=input-desc-box><input type=checkbox id=check-pqrs-as-resolved name=check-pqrs-as-resolved ng-model=$ctrl.pqrsResponseFormData.markedAsResolved ng-disabled=$ctrl.pqrsResponseFormData.state.savingPqrsResponse style=\"position: relative;top: 2px;cursor:pointer\"><label ng-show=!$ctrl.pqrsResponseFormData.state.resolvingPqrs for=check-pqrs-as-resolved style=cursor:pointer>Marcar como resuelto.</label></div></div><div class=pull-right ng-show=$ctrl.shCtrl.globals.currentUser.isOwner style=\"margin-bottom: 0px; padding: 0\"><div class=input-desc-box><input type=checkbox id=check-pqrs-as-inner name=check-pqrs-as-inner ng-model=$ctrl.pqrsResponseFormData.markedAsInner ng-disabled=$ctrl.pqrsResponseFormData.state.savingPqrsResponse style=\"position: relative;top: 2px;cursor:pointer\"><label ng-show=!$ctrl.pqrsResponseFormData.state.resolvingPqrs for=check-pqrs-as-resolved style=cursor:pointer>Marcar como Interno.</label></div></div></div></div></form><div class=clear></div><div class=row><div class=col-md-12><h2><i class=\"fa fa-commenting\" aria-hidden=true></i> Respuestas del caso <button class=\"btn btn-info pull-right\" ng-if=$ctrl.shCtrl.globals.currentUser.isOwner ng-click=$ctrl.openModalInnerComments()>Comentarios Internos</button></h2><hr></div></div><div class=row><div class=col-md-12><div class=respuestas-message><div ng-show=!$ctrl.pqrs.responses.length><div class=\"alert alert-warning\">Aún no se han ingresado respuestas para la incidencia. Utilice el formulario de arriba para crear una respuesta a la incidencia.</div></div><ul class=respuestas ng-show=$ctrl.pqrs.responses.length><li ng-class=\"!response.user.isClient ? 'left clearfix ejecutivo' : 'right clearfix contacto'\" ng-repeat=\"response in $ctrl.pqrs.responses\"><span ng-class=\"!response.user.isClient ? 'respuestas-img pull-left' : 'respuestas-img pull-right'\"><img ng-src={{response.user.avatar}} alt=\"User Avatar\"></span><div class=\"respuestas-body clearfix\"><div class=header-respuesta><div class=\"col md-12\"><div class=\"col-md-6 no-padding\"><strong>{{response.user.position}} <span ng-if=\"!response.user.isClient && response.markedAsInner\"><strong>(Interno)</strong></span>:</strong><br>{{response.user.name}}</div><div class=\"col-md-6 text-right\"><strong>Fecha de respuesta:</strong><br>{{response.date}}</div></div></div><p>{{response.comments}}</div></ul></div></div></div><div class=row><div class=text-right><a ui-sref=home.pqrsList><button type=button class=\"btn btn-primary\"><i class=\"fa fa-reply\" aria-hidden=true></i> Volver al listado</button></a></div></div></div></div></div><div class=md-margin></div><div class=col-md-12 ng-show=\"$ctrl.state.loaded && !$ctrl.state.error && !$ctrl.pqrs\"><div class=\"alert alert-warning\">No se ha encontrado la incidencia buscada. Si desea crear una incidencia de click <a ng-click=$ctrl.showModalFormPQRS()>aqu&iacute;</a></div></div><div class=col-md-12 ng-show=\"$ctrl.state.loaded && $ctrl.state.error\"><div class=\"alert alert-danger\">Ha ocurrido un error al obtener la incidencias. Por favor contacte al administrador del sistema.</div></div><div class=col-md-12 style=text-align:center><div class=loader-general ng-show=$ctrl.state.loading style=\"margin-top:10px; margin-bottom: 10px;text-align:left;font-size:11px;\r\n      margin-left:7px; displaY:inline-block\"><img src=" + __webpack_require__(2) + " style=width:18px> Espere un momento mientras se carga la incidencia...</div></div><style>p {\r\n    margin: 0 0 10px;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .detalle-caso {\r\n    font-size: 14px;\r\n    border-right: 3px solid #FFFFFF;\r\n    background: rgb(238, 238, 238);\r\n    padding: 10px 10px;\r\n    box-shadow: 0px 4px #555555, -3px 4px #FFFFFF;\r\n    margin: 0px;\r\n    color: #888888;\r\n    overflow: hidden;\r\n    position: relative;\r\n  }\r\n  .detalle-caso strong {\r\n    color: #7b6f6f;\r\n  }\r\n\r\n  .comentario-caso hr {\r\n    margin: 8px 0;\r\n  }\r\n  .comentario-caso strong {\r\n    font-size: 15px;\r\n  }\r\n\r\n  .respuestas {\r\n    list-style: none;\r\n    margin: 0;\r\n  }\r\n  .respuestas li img {\r\n    width: 50px;\r\n    border-radius: 50em;\r\n    -moz-border-radius: 50em;\r\n    -webkit-border-radius: 50em;\r\n  }\r\n  img {\r\n    max-width: 100%;\r\n  }\r\n  .respuestas-body {\r\n    padding-bottom: 20px;\r\n  }\r\n  .respuestas li.left .respuestas-body {\r\n    margin-left: 70px;\r\n    background-color: #F0F0F0;\r\n  }\r\n  .respuestas li .respuestas-body {\r\n    position: relative;\r\n    padding: 10px;\r\n    border: 1px solid #CFCFCF;\r\n  }\r\n  .respuestas li .respuestas-body p {\r\n    margin: 0;\r\n  }\r\n  .respuestas li.left .respuestas-body:before {\r\n    position: absolute;\r\n    top: 10px;\r\n    left: -8px;\r\n    display: inline-block;\r\n    background: #F0F0F0;\r\n    width: 16px;\r\n    height: 16px;\r\n    border-top: 1px solid #CFCFCF;\r\n    border-left: 1px solid #CFCFCF;\r\n    content: '';\r\n    transform: rotate(-45deg);\r\n    -webkit-transform: rotate(-45deg);\r\n    -moz-transform: rotate(-45deg);\r\n    -ms-transform: rotate(-45deg);\r\n    -o-transform: rotate(-45deg);\r\n  }\r\n  .respuestas li.right .respuestas-body:before {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: -8px;\r\n    display: inline-block;\r\n    background: #fff;\r\n    width: 16px;\r\n    height: 16px;\r\n    border-top: 1px solid #CFCFCF;\r\n    border-right: 1px solid #CFCFCF;\r\n    content: '';\r\n    transform: rotate(45deg);\r\n    -webkit-transform: rotate(45deg);\r\n    -moz-transform: rotate(45deg);\r\n    -ms-transform: rotate(45deg);\r\n    -o-transform: rotate(45deg);\r\n  }\r\n  .respuestas li {\r\n    margin: 15px 0 40px;\r\n  }\r\n  .respuestas li.right .respuestas-body {\r\n    margin-right: 70px;\r\n    background-color: #fff;\r\n  }\r\n  .respuestas-box {\r\n    position: fixed;\r\n    bottom: 0;\r\n    left: 444px;\r\n    right: 0;\r\n    padding: 15px;\r\n    border-top: 1px solid #eee;\r\n    transition: all .5s ease;\r\n    -webkit-transition: all .5s ease;\r\n    -moz-transition: all .5s ease;\r\n    -ms-transition: all .5s ease;\r\n    -o-transition: all .5s ease;\r\n  }\r\n\r\n  .header-respuesta {\r\n    border-bottom: 1px solid #DADADA;\r\n    overflow: auto;\r\n    padding-bottom: 5px;\r\n    margin-bottom: 7px;\r\n  }\r\n  .header-respuesta strong {\r\n    color: #08097c !important;\r\n  }\r\n\r\n  .page-pqrs-detail h2, .page-pqrs-detail .h2 {\r\n    font-size: 20px;\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  #pqrs-response-form input:disabled,\r\n  #pqrs-response-form select:disabled {\r\n    background-color: #eee;\r\n  }\r\n  input[type=\"submit\"]:disabled,\r\n  button[type=\"submit\"]:disabled {\r\n    background-color: #CCC !important;\r\n    border: 1px solid #CCC !important;\r\n  }\r\n  .help-block {\r\n    font-size: 13px;\r\n    margin-top: 7px;\r\n  }\r\n\r\n  .modal-header-error {\r\n    background-color: red;\r\n  }\r\n\r\n  .files-list {\r\n    padding: 5px;\r\n    border: 1px solid #e0e0e0;\r\n    line-height: 1.5;\r\n    display: table-cell;\r\n    margin-top: 5px;\r\n  }\r\n\r\n  .no-margin-top {\r\n    margin-top: 0;\r\n  }\r\n  .container_tooltip{\r\n    position: relative;\r\n    display: inline-block;\r\n    cursor: pointer;\r\n    font-weight: bold;\r\n  }\r\n  .form-group .container_tooltip:hover{\r\n    color: #d75f07;\r\n  }\r\n  .container_tooltip:hover > .message_tool{\r\n    display: table;\r\n  }\r\n  .message_tool{\r\n    top: -60px;\r\n    left: 0px;\r\n    font-size: 13px;\r\n    line-height: 1.3;\r\n    text-align: justify;\r\n    width: 200px;\r\n    display: none;\r\n    position: absolute;\r\n    padding: 8px;\r\n    color: white;\r\n    background: #7b7876;\r\n    border-radius: 5px;\r\n    font-weight: initial;\r\n  }\r\n  .message_tool::after{\r\n    content: \"\";\r\n    width: 0px;\r\n    height: 0px;\r\n    border-left: 15px solid transparent;\r\n    border-right: 15px solid transparent;\r\n    border-top: 12px solid #7b7876;\r\n    font-size: 0px;\r\n    line-height: 0px;\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 20px;\r\n    display: table;\r\n  }</style>";

/***/ },
/* 498 */
/***/ function(module, exports) {

	module.exports = "<div class=\"modal-content salir-aplication\"><div class=modal-header><h5 class=modal-title><span>Comentarios internos</span></h5></div><div class=modal-body><div class=\"product-add clearfix\"><div class=col-md-12 style=\"max-height: 300px;overflow-y: auto\"><div class=respuestas-message><div ng-show=!mdCtrl.responses.length><div class=\"alert alert-warning\">Aún no se han ingresado respuestas para la incidencia. Utilice el formulario de arriba para crear una respuesta a la incidencia.</div></div><ul class=respuestas ng-show=mdCtrl.responses.length><li ng-class=\"!response.user.isClient ? 'left clearfix ejecutivo' : 'right clearfix contacto'\" ng-repeat=\"response in mdCtrl.responses\"><span ng-class=\"!response.user.isClient ? 'respuestas-img pull-left' : 'respuestas-img pull-right'\"><img ng-src={{response.user.avatar}} alt=\"User Avatar\"></span><div class=\"respuestas-body clearfix\"><div class=header-respuesta><div class=\"col md-12\"><div class=\"col-md-6 no-padding\"><strong>{{response.user.position}} <span ng-if=\"!response.user.isClient && response.markedAsInner\"><strong>(Interno)</strong></span>:</strong><br>{{response.user.name}}</div><div class=\"col-md-6 text-right\"><strong>Fecha de respuesta:</strong><br>{{response.date}}</div></div></div><p>{{response.comments}}</div></ul></div></div><div class=\"row btn-actions\"><div class=col-xs-12><button class=\"btn btn-danger\" type=button ng-click=mdCtrl.cancel() style=\"margin-right: 5px\"><strong>Cerrar</strong></button></div></div></div></div></div>";

/***/ },
/* 499 */
/***/ function(module, exports) {

	module.exports = "<div class=\"modal-content salir-aplication\"><div class=modal-header><h5 class=modal-title><span>Comentario reasignación del caso</span></h5></div><div class=modal-body><div class=\"product-add clearfix\"><div class=\"row content-modal-body\"><form name=mdCtrl.lastCommentForm id=lastCommentForm novalidate><label>Ingrese el motivo de la reasignación</label><textarea required name=\"\" cols=30 rows=3 ng-model=mdCtrl.comment class=form-control></textarea></form></div><div class=\"row btn-actions\"><div class=col-xs-12><button class=\"btn btn-danger\" type=button ng-click=mdCtrl.cancel() style=\"margin-right: 5px\"><strong>Cancelar</strong></button> <button type=button ng-click=mdCtrl.ok() ng-disabled=mdCtrl.lastCommentForm.$invalid class=\"btn btn-primary\"><strong>Guardar</strong></button></div></div></div></div></div>";

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{$ctrl.shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li><a>PQRS</a><li class=active><span>Listado</span></ul></div></div></div></div><div class=container><div class=row><div class=col-md-12><div class=row><div class=col-md-12><h4>Administración de Casos - Bienvenido! <a href=\"\" ng-click=$ctrl.exportCSV() style=float:right class=\"btn btn-info btn-sm\"><i class=\"fa fa-file-excel-o\" aria-hidden=true></i> Exportar a .XLS</a></h4><hr><p>Desde acá podrá administrar y realizar seguimiento a las incidencias reportadas. Si tiene cualquier duda o inconveniente no dude encontactarnos.</div></div></div><div class=col-md-12 style=\"margin: 16px 0px\" ng-show=$ctrl.responsable><div class=row><div class=\"col-lg-3 col-xs-6\"><div class=\"small-box {{$ctrl.statistics[0].bgcolor}}\"><div class=inner><h3>{{$ctrl.statistics[0].total}}</h3><p>{{$ctrl.statistics[0].state}}</div><div class=icon><i class=\"fa fa-file-text-o\"></i></div></div></div><div class=\"col-lg-3 col-xs-6\"><div class=\"small-box {{$ctrl.statistics[1].bgcolor}}\"><div class=inner><h3>{{$ctrl.statistics[1].total}}</h3><p>{{$ctrl.statistics[1].state}}</div><div class=icon><i class=\"fa fa-file-text-o\"></i></div></div></div><div class=\"col-lg-3 col-xs-6\"><div class=\"small-box {{$ctrl.statistics[2].bgcolor}}\"><div class=inner><h3>{{$ctrl.statistics[2].total}}</h3><p>{{$ctrl.statistics[2].state}}</div><div class=icon><i class=\"fa fa-file-text-o\"></i></div></div></div><div class=\"col-lg-3 col-xs-6\"><div class=\"small-box {{$ctrl.statistics[3].bgcolor}}\"><div class=inner><h3>{{$ctrl.statistics[3].total}}</h3><p>{{$ctrl.statistics[3].state}}</div><div class=icon><i class=\"fa fa-file-text-o\"></i></div></div></div></div></div><div class=col-md-12 ng-show=$ctrl.pqrsList.length><div class=md-margin></div><div class=table-responsive><table ng-table-dynamic=\"$ctrl.ngTableConfig with $ctrl.ngTableCols\" class=\"table table-condensed table-bordered table-striped listado\"><col><col><col><col><tr ng-repeat=\"row in $data\"><td ng-repeat=\"col in $columns\"><span ng-switch=col.field><span ng-switch-when=actions><a ui-sref=\"home.pqrsDetail({id : row['id']})\"><button class=\"btn btn-default dropdown-toggle\" type=button><i class=\"fa fa-bars\" aria-hidden=true></i></button> </a></span><span ng-switch-default>{{row[col.field]}}</span></span></table></div></div><div class=col-xs-12 style=\"margin-top: 20px\"><a href=\"\" ng-click=$ctrl.exportCSV() style=float:right class=\"btn btn-info btn-sm\"><i class=\"fa fa-file-excel-o\" aria-hidden=true></i> Exportar a .XLS</a></div><div class=col-md-12 ng-show=\"$ctrl.state.loaded && !$ctrl.state.error && !$ctrl.pqrsList.length\"><div class=\"alert alert-warning\">No se han encontrado incidencias reportadas. Si desea crear una incidencia de click <a ng-click=$ctrl.showModalFormPQRS();>aqu&iacute;</a></div></div><div class=col-md-12 ng-show=\"$ctrl.state.loaded && $ctrl.state.error\"><div class=\"alert alert-danger\">Ha ocurrido un error al obtener las incidencias reportadas. Por favor contacte al administrador del sistema.</div></div><div class=col-md-12 style=text-align:center><div class=loader-general ng-show=$ctrl.state.loading style=\"margin-top:10px; margin-bottom: 10px;text-align:left;font-size:11px;\r\n        margin-left:7px; displaY:inline-block\"><img src=" + __webpack_require__(2) + " style=width:18px> Espere un momento mientras se cargan las incidencias...</div></div></div></div><style>tr td {\r\n    vertical-align: middle !important;\r\n  }\r\n  table.listado tr th {\r\n    padding: 6px 5px 0 !important;\r\n    background: rgb(236, 236, 236) !important;\r\n    box-shadow: inset 0 -3px 0 rgb(236, 236, 236);\r\n    color: #655a5a !important;\r\n    border-bottom: 1px solid rgb(236, 236, 236) !important;\r\n    border-right: 1px solid #cdcdcd;\r\n    border-top: 1px solid #cdcdcd !important;\r\n  }\r\n  th.filter, th.sortable {\r\n    border-left: 1px solid #cdcdcd !important;\r\n  }\r\n  thead.ng-scope {\r\n    border-bottom: 3px solid #c1c1c1 !important;\r\n  }\r\n  table.listado thead tr.ng-table-filters th {\r\n    padding: 4px 10px 9px !important;\r\n  }\r\n  table.listado thead tr th .form-control {\r\n    height: 30px !important;\r\n    font-weight: 400;\r\n  }\r\n  table.listado thead tr th:last-child {\r\n    background: transparent !important;\r\n    border: transparent !important;\r\n    box-shadow: none;\r\n  }\r\n  .table.listado {\r\n    border: transparent;\r\n  }\r\n  table.listado thead tr.ng-table-filters th:first-child {\r\n    width: 75px;\r\n  }\r\n  .ng-table th.sortable .sort-indicator:after, .ng-table th.sortable .sort-indicator:before {\r\n    margin-left: 4px;\r\n  }\r\n  span a button {\r\n    background: #d75f07 !important;\r\n    color: #fff !important;\r\n    padding: 3px 8px !important;\r\n  }\r\n  .ng-table-pager {\r\n    margin-top: 20px;\r\n  }\r\n  ul.pagination {\r\n    /*display: block;*/\r\n    float: left;\r\n  }\r\n  @media (max-width: 992px) {\r\n    .ng-table-pager {\r\n      position: absolute;\r\n      right: 15px;\r\n    }\r\n  }</style>";

/***/ },
/* 501 */,
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{$ctrl.shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li><a>Consultas B2B</a><li class=active><span>Cartera</span></ul></div></div></div></div><div class=\"container consultas\" style=margin-top:15px ng-if=!$ctrl.watchingBillfold><div class=row><div class=\"customFilters col-xs-12\" ng-if=\"!$ctrl.shCtrl.globals.currentClient.third.documentNumber && $ctrl.shCtrl.globals.currentUser.isOwner\"><div class=col-xs-3><label for=third>Selecciona Tercero*</label><auto-complete id-city=third param=thirds my-attribute=$ctrl.thirdSelected typeahead-select=$ctrl.getBranches(item) is-editable=false append-body=true is-req=true></auto-complete></div><div class=col-xs-3><label for=branches>Selecciona Sucursal(es)</label><select class=\"form-control selectpicker\" ng-model=$ctrl.branchesSelected ng-disabled=!$ctrl.thirdSelected ng-if=\"$ctrl.branches.length < 2 || !$ctrl.branches\" ng-options=\"x as x.nombre for x in $ctrl.branches\" name=branches id=branches></select><select class=\"form-control selectpicker\" ng-model=$ctrl.branchesSelected ng-disabled=!$ctrl.thirdSelected ng-if=\"$ctrl.branches.length > 1\" ng-options=\"x as x.nombre for x in $ctrl.branches\" name=branches multiple id=branchesOne></select></div><button type=button class=\"btn btn-custom btnSearch\" ng-click=$ctrl.getBillFolds(true)><span class=\"glyphicon glyphicon-search\"></span></button></div><div class=col-md-12 ng-show=$ctrl.billfolds.length><div class=row><div class=col-md-12><h3><i class=\"fa fa-file-text-o\"></i> Consulta de Cartera</h3><hr><div class=row><div class=col-md-4><strong>Cliente:</strong> {{$ctrl.shCtrl.globals.currentClient.third.name}}<br><strong>NIT:</strong> {{$ctrl.shCtrl.globals.currentClient.third.documentNumber}} {{$ctrl.shCtrl.globals.currentClient.third.documentDV ? ' - ' + $ctrl.shCtrl.globals.currentClient.third.documentDV : '' }}<br><strong>Sucursal:</strong> {{$ctrl.shCtrl.globals.currentClient.operatingCenter.name}}<br><strong>Código Sucursal:</strong> {{$ctrl.shCtrl.globals.currentClient.operatingCenter.code}}</div><div class=col-md-4><strong>Cupo Crédito:</strong> $ {{ $ctrl.billfolds[0].cupo_credito | currency:'':0 }}<br><strong>Valor Pedidos Pendientes:</strong> $ {{ $ctrl.billfolds[0].total_cartera | currency:'':0 }}<br><strong>Valor Disponible.:</strong> #<br><strong>Última Actualización:</strong> {{ $ctrl.updatedAt }}</div></div></div></div></div><div class=\"col-md-12 table-order-states\" ng-show=\"$ctrl.billfolds.length > 0\"><div class=md-margin></div><table ng-table-dynamic=\"$ctrl.ngTableConfig with $ctrl.ngTableCols\" class=\"table table-condensed table-bordered table-striped listado\"><col><col><col><col><tr ng-repeat=\"row in $data\"><td ng-repeat=\"col in $columns\"><span ng-switch=col.field><div ng-switch-when=sucursal class=text-left>{{row['sucursal_nombre']}}<div class=direccion>Codigo: {{row['sucursal']}}</div><div class=direccion>{{row['sucursal_direccion']}}</div></div><span ng-switch-when=actions><div class=btn-group><a class=\"btn btn-default\" ng-click=$ctrl.selectBillfold(row) title=\"Ver detalle\"><i class=\"fa fa-bars\" aria-hidden=true></i></a></div></span><span ng-switch-default ng-if=\"row[col.field] && isNaN(row[col.field])\">{{row[col.field]}} </span><span ng-switch-default ng-if=\"row[col.field] && !isNaN(row[col.field])\" style=\"text-align: right; display: block\">{{row[col.field] | number:0}} </span><span ng-switch-default ng-if=!row[col.field]>--</span></span></table></div><div class=col-md-12 ng-show=\"$ctrl.state.loaded && !$ctrl.state.error && !$ctrl.billfolds.length\" style=\"margin-top: 14px\"><div class=\"alert alert-warning\">No se ha encontrado información para la consulta realizada.</div></div><div class=col-md-12 ng-show=\"$ctrl.state.loaded && $ctrl.state.error\"><div class=\"alert alert-danger\">Ha ocurrido un error al obtener la cartera. Por favor contacte al administrador del sistema.</div></div><div class=col-md-12 style=text-align:center><div class=loader-general ng-show=$ctrl.state.loading style=\"margin-top:10px; margin-bottom: 10px;text-align:left;font-size:11px;\r\n        margin-left:7px; displaY:inline-block\"><img src=" + __webpack_require__(2) + " style=width:18px> Espere un momento mientras se carga la cartera...</div></div></div></div><div class=container style=margin-top:15px ng-if=$ctrl.watchingBillfold><div class=row><div class=col-md-12 ng-show=$ctrl.billfoldSelected><div class=row><div class=col-md-12><div class=row><div class=col-md-8><h4><i class=\"fa fa-file-text-o\"></i> Consulta de Detalle de Cartera</h4></div><div class=col-md-4 style=text-align:right><a href=# ng-click=$ctrl.blurBillfold() class=\"btn btn-custom-4\"><i class=\"fa fa-arrow-circle-left\"></i> Volver al Listado</a></div></div><hr><div class=row ng-if=$ctrl.thirdSelected><div class=col-md-4><strong>Cliente:</strong> {{$ctrl.thirdSelected.name}}<br><strong>NIT:</strong> {{$ctrl.thirdSelected.documentNumber}} {{$ctrl.thirdSelected.documentDV ? ' - ' + $ctrl.thirdSelected.documentDV : '' }}<br><strong>Sucursal:</strong> {{$ctrl.shCtrl.globals.currentClient.operatingCenter.name}}<br><strong>Código Sucursal:</strong> {{$ctrl.branchCode}}<br><strong>Última Actualización:</strong> {{ $ctrl.updatedAt }}</div></div></div></div></div><div class=col-md-12 ng-show=$ctrl.billfoldSelected><div class=md-margin></div><table ng-table-dynamic=\"$ctrl.ngTableConfigBillfold with $ctrl.ngTableColsBillfold\" class=\"table table-condensed table-bordered table-striped listado\"><col><col><col><col><tr ng-repeat=\"row in $data\"><td ng-repeat=\"col in $columns\"><span ng-switch=col.field><span ng-switch-when=detalle_numero_documento style=text-align:right>{{row[col.field]}} </span><span ng-switch-when=detalle_fecha_vencimiento_documento style=text-align:right>{{row[col.field]}} </span><span ng-switch-when=detalle_fecha_documento style=text-align:right>{{row[col.field]}} </span><span ng-switch-default ng-if=\"row[col.field] && isNaN(row[col.field])\">{{row[col.field]}} </span><span ng-switch-default ng-if=\"row[col.field] && !isNaN(row[col.field])\" style=\"text-align: right; display: block\">{{row[col.field] | number:0}} </span><span ng-switch-default ng-if=!row[col.field]>--</span></span></table></div><div class=col-md-12 ng-show=\"$ctrl.stateBillfold.loaded && !$ctrl.stateBillfold.error && !$ctrl.billfoldSelected.length\" style=\"margin-top: 14px\"><div class=\"alert alert-warning\">No se ha encontrado información para la consulta realizada.</div></div><div class=col-md-12 ng-show=\"$ctrl.stateBillfold.loaded && $ctrl.stateBillfold.error\"><div class=\"alert alert-danger\">Ha ocurrido un error al obtener la información de la orden. Por favor contacte al administrador del sistema.</div></div><div class=col-md-12 style=text-align:center><div class=loader-general ng-show=$ctrl.stateBillfold.loading style=\"margin-top:10px; margin-bottom: 10px;text-align:left;font-size:11px;\r\n        margin-left:7px; displaY:inline-block\"><img src=" + __webpack_require__(2) + " style=width:18px> Espere un momento mientras se carga la información del detalle de la cartera...</div></div></div></div><style>/* NG-TABLE */\r\n  thead.ng-scope {\r\n    border-bottom: 3px solid #8fb1d8 !important;\r\n  }\r\n\r\n  .consultas table.listado th{\r\n    background: rgb(22, 64, 111);\r\n    color: #ffffff !important;\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    padding: 5px 11px 0;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    line-height: 16px;\r\n    border-color: #436890;\r\n    border-bottom-color: #16406f;\r\n    text-shadow: none !important;\r\n  }\r\n\r\n  .consultas .ng-table th.filter .input-filter,\r\n  .consultas table.listado th input {\r\n    padding: 5px;\r\n    min-width: 25px !important;\r\n    height: 30px !important;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  th.header.sortable.sort-desc {\r\n    background: #ececec !important;\r\n  }\r\n\r\n  .ng-table th.sortable.sort-desc,\r\n  .ng-table th.sortable.sort-asc {\r\n    background-color: rgb(22, 64, 111) !important;\r\n  }\r\n\r\n  .consultas table.listado td {\r\n    font-size: 13px;\r\n    vertical-align: middle;\r\n  }\r\n\r\n  .consultas table.listado td .direccion{\r\n    color: #969696;\r\n    font-size: 10px;\r\n  }\r\n\r\n  .consultas .ng-table-pager .ng-table-counts .btn-group,\r\n  .consultas .ng-table-pager .ng-table-counts .btn-group-vertical{\r\n    margin-top: 17px;\r\n  }\r\n\r\n  .ng-table-pager {\r\n    margin-top: 20px;\r\n  }\r\n\r\n  .ng-table-header {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  ul.pagination.pagination {\r\n    float: right;\r\n  }\r\n  .ng-table-counts.btn-group {\r\n    float: left !important;\r\n  }\r\n\r\n  .consultas table.listado th:first-child {\r\n    width: 200px;\r\n  }\r\n\r\n  .consultas table.listado th:nth-child(2) {\r\n    width: 100px;\r\n  }\r\n\r\n  .table-order-states tbody td {\r\n    font-size: 12px !important;\r\n  }\r\n  .ng-table th.sortable .sort-indicator:before {\r\n    border-top: 4px solid #fff !important;\r\n  }\r\n  .ng-table th.sortable .sort-indicator:after, .ng-table th.sortable .sort-indicator:before {\r\n    border-color: #fff transparent !important;\r\n  }\r\n\r\n  .ng-table-counts {\r\n    display: none;\r\n  }\r\n  tr td {\r\n    vertical-align: middle !important;\r\n  }\r\n\r\n  table.listado tr th {\r\n    background: rgb(22, 64, 111);\r\n    color: #ffffff !important;\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    padding: 5px 11px 0;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    line-height: 16px;\r\n    border-color: #436890;\r\n    border-bottom-color: #16406f;\r\n    text-shadow: none !important;\r\n  }\r\n\r\n  th.filter, th.sortable {\r\n    border-left: 1px solid #cdcdcd !important;\r\n  }\r\n\r\n  thead.ng-scope {\r\n    border-bottom: 3px solid #8fb1d8 !important;\r\n  }\r\n\r\n  /*table.listado thead tr.ng-table-filters th {*/\r\n    /*padding: 4px 10px 9px !important;*/\r\n  /*}*/\r\n\r\n  table.listado thead tr th .form-control {\r\n    height: 30px !important;\r\n    font-weight: 400;\r\n  }\r\n\r\n  .table.listado {\r\n    border: transparent;\r\n  }\r\n\r\n  table.listado thead tr.ng-table-filters th:first-child {\r\n    width: 75px;\r\n  }\r\n\r\n  .ng-table th.sortable .sort-indicator:after, .ng-table th.sortable .sort-indicator:before {\r\n    margin-left: 4px;\r\n  }\r\n\r\n  span a button {\r\n    background: #990c54 !important;\r\n    color: #fff !important;\r\n    padding: 3px 8px !important;\r\n  }\r\n\r\n  .ng-table-pager {\r\n    margin-top: 20px;\r\n  }\r\n\r\n  .ng-table-header {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    line-height: 17px;\r\n  }\r\n\r\n  @media (max-width: 992px) {\r\n    .ng-table-pager {\r\n      position: absolute;\r\n      right: 15px;\r\n    }\r\n  }\r\n  .datos-del-detalle p {\r\n    margin-bottom: 5px;\r\n  }\r\n  .ng-table th.sortable .sort-indicator:after, .ng-table th.sortable .sort-indicator:before {\r\n    border-color: #fff transparent !important;\r\n  }\r\n  .ng-table th.sortable.sort-desc,\r\n  .ng-table th.sortable.sort-asc {\r\n    background-color: rgb(22, 64, 111) !important;\r\n  }\r\n  .ng-table-counts.btn-group {\r\n    float: left !important;\r\n  }\r\n  ul.pagination.pagination {\r\n    float: right;\r\n  }</style>";

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{$ctrl.shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li><a>Consultas B2B</a><li class=active><span>Estado de Pedidos</span></ul></div></div></div></div><div class=\"container consultas\" style=margin-top:15px ng-if=!$ctrl.watchingOrder><div class=row><div class=\"customFilters col-xs-12\" ng-if=\"!$ctrl.shCtrl.globals.currentClient.third.documentNumber && $ctrl.shCtrl.globals.currentUser.isOwner\"><div class=col-xs-3><label for=third>Selecciona Tercero*</label><auto-complete id-city=third param=thirds my-attribute=$ctrl.thirdSelected typeahead-select=$ctrl.getBranches(item) is-editable=false append-body=true is-req=true></auto-complete></div><div class=col-xs-3><label for=branches>Selecciona Sucursal(es)</label><select class=\"form-control selectpicker\" ng-model=$ctrl.branchesSelected ng-disabled=!$ctrl.thirdSelected ng-if=\"$ctrl.branches.length < 2 || !$ctrl.branches\" ng-options=\"x as x.nombre for x in $ctrl.branches\" name=branches id=branches></select><select class=\"form-control selectpicker\" ng-model=$ctrl.branchesSelected ng-disabled=!$ctrl.thirdSelected ng-if=\"$ctrl.branches.length > 1\" ng-options=\"x as x.nombre for x in $ctrl.branches\" name=branches multiple id=branchesOne></select></div><div class=col-xs-2><label for=fecha_ini>Fecha Inicio</label><div class=\"col-xs-12 input-group\"><input id=fecha_ini name=fecha_ini data-provide=datepicker data-date-format=yyyy-mm-dd data-date-calendar-weeks=false data-date-clear-btn=false data-date-keyboard-navigation=false class=\"form-control datepicker input-sm\" placeholder=\"ej. 2016-07-13\" ng-model=$ctrl.fecha_ini><label class=\"input-group-addon btn\" for=fecha_ini style=min-width:auto><span class=\"fa fa-calendar\"></span></label></div></div><div class=col-xs-2><label for=fecha_fin>Fecha Fin</label><div class=\"col-xs-12 input-group\"><input id=fecha_fin name=fecha_fin data-provide=datepicker data-date-format=yyyy-mm-dd data-date-calendar-weeks=false data-date-clear-btn=false data-date-keyboard-navigation=false class=\"form-control datepicker input-sm\" placeholder=\"ej. 2016-07-13\" ng-model=$ctrl.fecha_fin><label class=\"input-group-addon btn\" for=fecha_fin style=min-width:auto><span class=\"fa fa-calendar\"></span></label></div></div><button type=button class=\"btn btn-custom btnSearch\" ng-click=$ctrl.getOrderStates(true)><span class=\"glyphicon glyphicon-search\"></span></button></div><div class=col-md-12 ng-show=$ctrl.orders.length><div class=row><div class=col-md-12><h3><i class=\"fa fa-file-text-o\"></i> Consulta de Estado de Pedidos</h3><hr><div class=row><div class=col-md-4 ng-if=\"($ctrl.shCtrl.globals.currentUser.isContactCenter || $ctrl.shCtrl.globals.currentUser.isSeller) && $ctrl.shCtrl.globals.currentClient.id\"><strong>Cliente:</strong> {{$ctrl.shCtrl.globals.currentClient.third.name}}<br><strong>Sucursal:</strong> {{$ctrl.shCtrl.globals.currentClient.operatingCenter.name}}<br><strong>Número de Documento:</strong> {{$ctrl.shCtrl.globals.currentClient.third.documentNumber}}<br><strong>Código Sucursal:</strong> {{$ctrl.shCtrl.globals.currentClient.operatingCenter.code}}</div><div class=col-md-4><div ng-show=$ctrl.orders.length><strong>Cantidad Ordenes:</strong> {{ $ctrl.orders.length }}</div><strong>Valor Neto Total Ordenes:</strong> $ {{ $ctrl.totalValueToPayOrders | currency:'':0 }}<br><strong>Valor Neto Pendiente Ordenes:</strong> $ {{ $ctrl.totalValuePendingOrders | currency:'':0 }}<br><strong>Última Fecha Actualización:</strong> {{$ctrl.updatedAt}}</div></div></div></div></div><div class=\"col-md-12 table-order-states\" ng-show=$ctrl.orders.length><div class=md-margin></div><table ng-table-dynamic=\"$ctrl.ngTableConfig with $ctrl.ngTableCols\" class=\"table table-condensed table-bordered table-striped listado\"><col><col><col><col><tr ng-repeat=\"row in $data\"><td ng-repeat=\"col in $columns\"><span ng-switch=col.field><span ng-switch-when=actions><div class=btn-group><a class=\"btn btn-default\" ng-click=$ctrl.selectOrder(row) title=\"Ver detalle\"><i class=\"fa fa-bars\" aria-hidden=true></i></a></div></span><span ng-switch-when=valor_pagar style=text-align:right>$ {{row[col.field] | currency:'':0}} </span><span ng-switch-when=valor_pendiente style=text-align:right>$ {{row[col.field] | currency:'':0}} </span><span ng-switch-default ng-if=row[col.field]>{{row[col.field]}} </span><span ng-switch-default ng-if=!row[col.field]>--</span></span></table></div><div class=col-md-12 ng-show=\"$ctrl.state.loaded && !$ctrl.state.error && !$ctrl.orders.length\" style=\"margin-top: 14px\"><div class=\"alert alert-warning\">No se ha encontrado información para la consulta realizada.</div></div><div class=col-md-12 ng-show=\"$ctrl.state.loaded && $ctrl.state.error\"><div class=\"alert alert-danger\">Ha ocurrido un error al obtener el estado de las ordenes. Por favor contacte al administrador del sistema.</div></div><div class=col-md-12 style=text-align:center><div class=loader-general ng-show=$ctrl.state.loading style=\"margin-top:10px; margin-bottom: 10px;text-align:left;font-size:11px;\r\n        margin-left:7px; displaY:inline-block\"><img src=" + __webpack_require__(2) + " style=width:18px> Espere un momento mientras se cargan los estados de las ordenes...</div></div></div></div><div class=container style=margin-top:15px ng-if=$ctrl.watchingOrder><div class=row><div class=col-md-12 ng-show=$ctrl.orderSelected><div class=row><div class=col-md-8><h4><i class=\"fa fa-file-text-o\"></i> Consulta de Detalle de Pedido</h4></div><div class=col-md-4 style=text-align:right><a ng-click=$ctrl.blurOrder() class=\"btn btn-custom-4\"><i class=\"fa fa-arrow-circle-left\"></i> Volver al Listado</a></div></div></div><div class=col-md-12 ng-show=$ctrl.orderSelected><div class=\"row datos-del-detalle\"><div class=\"col-sm-4 col-xs-12\"><p><strong>Cliente:</strong> {{$ctrl.orderSelected[0].tercero}}<p><strong>Número de Documento:</strong> {{$ctrl.orderSelected[0].tercero_id}}<p><strong>Sucursal:</strong> {{$ctrl.orderSelected[0].sucursal}}<p><strong>Código Sucursal:</strong> {{$ctrl.orderSelected[0].sucursal_id}}</div><div class=\"col-sm-4 col-xs-12\"><p><strong>Pedido ERP:</strong> {{$ctrl.orderSelected[0].pedido_id}}<p><strong>Pedido T. Virtual:</strong> {{$ctrl.orderSelected[0].pedido_smartb ? $ctrl.orderSelected[0].pedido_smartb : '--'}}<p><strong>O.C. del cliente:</strong> {{$ctrl.orderSelected[0].orden_compra ? $ctrl.orderSelected[0].orden_compra : '--'}}<p><strong>Vendedor:</strong> {{$ctrl.orderSelected[0].vendedor}}</div><div class=\"col-sm-4 col-xs-12\"><p><strong>Valor Neto Total:</strong> $ {{ $ctrl.orderSelected[0].valor_pagar | currency:'':0 }}<p><strong>Valor Neto Pendiente:</strong> $ {{ $ctrl.orderSelected[0].valor_pendiente | currency:'':0 }}</div></div></div><div class=col-md-12 ng-show=$ctrl.orderSelected><div class=md-margin></div><table ng-table-dynamic=\"$ctrl.ngTableConfigOrder with $ctrl.ngTableColsOrder\" class=\"table table-condensed table-bordered table-striped listado\"><col><col><col><col><tr ng-repeat=\"row in $data\"><td ng-repeat=\"col in $columns\"><span ng-switch=col.field><span ng-switch-when=item_valor_unitario>$ {{row[col.field] | currency:'':0}} </span><span ng-switch-when=item_valor_descuento>$ {{row[col.field] | currency:'':0}} </span><span ng-switch-when=item_valor_total>$ {{row[col.field] | currency:'':0}} </span><span ng-switch-default ng-if=row[col.field]>{{row[col.field]}}</span> <span ng-switch-default ng-if=!row[col.field]>-</span></span></table></div><div class=col-md-12 ng-show=\"$ctrl.stateOrder.loaded && !$ctrl.stateOrder.error && !$ctrl.orderSelected.length\" style=\"margin-top: 14px\"><div class=\"alert alert-warning\">No se ha encontrado información para la consulta realizada.</div></div><div class=col-md-12 ng-show=\"$ctrl.stateOrder.loaded && $ctrl.stateOrder.error\"><div class=\"alert alert-danger\">Ha ocurrido un error al obtener la información de la orden. Por favor contacte al administrador del sistema.</div></div><div class=col-md-12 style=text-align:center><div class=loader-general ng-show=$ctrl.stateOrder.loading style=\"margin-top:10px; margin-bottom: 10px;text-align:left;font-size:11px;\r\n        margin-left:7px; displaY:inline-block\"><img src=" + __webpack_require__(2) + " style=width:18px> Espere un momento mientras se carga la información de la orden...</div></div></div></div><style>/* NG-TABLE */\r\n  thead.ng-scope {\r\n    border-bottom: 3px solid #8fb1d8 !important;\r\n  }\r\n\r\n  .consultas table.listado th{\r\n    background: rgb(22, 64, 111);\r\n    color: #ffffff !important;\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    padding: 5px 11px 0;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    line-height: 16px;\r\n    border-color: #436890;\r\n    border-bottom-color: #16406f;\r\n    text-shadow: none !important;\r\n  }\r\n\r\n  .ng-table th.filter .input-filter,\r\n  .consultas table.listado th input {\r\n    padding: 5px;\r\n    min-width: 25px !important;\r\n    height: 30px !important;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  th.header.sortable.sort-desc {\r\n    background: #ececec !important;\r\n  }\r\n\r\n  .ng-table th.sortable.sort-desc,\r\n  .ng-table th.sortable.sort-asc {\r\n    background-color: rgb(22, 64, 111) !important;\r\n  }\r\n\r\n  .consultas table.listado td {\r\n    font-size: 13px;\r\n    vertical-align: middle;\r\n  }\r\n\r\n  .consultas table.listado td .direccion{\r\n    color: #969696;\r\n    font-size: 10px;\r\n  }\r\n\r\n  .consultas .ng-table-pager .ng-table-counts .btn-group,\r\n  .consultas .ng-table-pager .ng-table-counts .btn-group-vertical{\r\n    margin-top: 17px;\r\n  }\r\n\r\n  .ng-table-pager {\r\n    margin-top: 20px;\r\n  }\r\n\r\n  .ng-table-header {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  ul.pagination.pagination {\r\n    float: right;\r\n  }\r\n  .ng-table-counts.btn-group {\r\n    float: left !important;\r\n  }\r\n\r\n  .consultas table.listado th:first-child {\r\n    width: 200px;\r\n  }\r\n\r\n  .consultas table.listado th:nth-child(2) {\r\n    width: 100px;\r\n  }\r\n\r\n  .table-order-states tbody td {\r\n    font-size: 12px !important;\r\n  }\r\n  .ng-table th.sortable .sort-indicator:before {\r\n    border-top: 4px solid #fff !important;\r\n  }\r\n  .ng-table th.sortable .sort-indicator:after, .ng-table th.sortable .sort-indicator:before {\r\n    border-color: #fff transparent !important;\r\n  }\r\n\r\n  .ng-table-counts {\r\n    display: none;\r\n  }\r\n  tr td {\r\n    vertical-align: middle !important;\r\n  }\r\n\r\n  table.listado tr th {\r\n    background: rgb(22, 64, 111);\r\n    color: #ffffff !important;\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    padding: 5px 11px 0;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    line-height: 16px;\r\n    border-color: #436890;\r\n    border-bottom-color: #16406f;\r\n    text-shadow: none !important;\r\n  }\r\n\r\n  th.filter, th.sortable {\r\n    border-left: 1px solid #cdcdcd !important;\r\n  }\r\n\r\n  thead.ng-scope {\r\n    border-bottom: 3px solid #8fb1d8 !important;\r\n  }\r\n\r\n  /*table.listado thead tr.ng-table-filters th {*/\r\n    /*padding: 4px 10px 9px !important;*/\r\n  /*}*/\r\n\r\n  table.listado thead tr th .form-control {\r\n    height: 30px !important;\r\n    font-weight: 400;\r\n  }\r\n\r\n  .table.listado {\r\n    border: transparent;\r\n  }\r\n\r\n  table.listado thead tr.ng-table-filters th:first-child {\r\n    width: 75px;\r\n  }\r\n\r\n  .ng-table th.sortable .sort-indicator:after, .ng-table th.sortable .sort-indicator:before {\r\n    margin-left: 4px;\r\n  }\r\n\r\n  span a button {\r\n    background: #990c54 !important;\r\n    color: #fff !important;\r\n    padding: 3px 8px !important;\r\n  }\r\n\r\n  .ng-table-pager {\r\n    margin-top: 20px;\r\n  }\r\n\r\n  .ng-table-header {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    line-height: 17px;\r\n  }\r\n\r\n  @media (max-width: 992px) {\r\n    .ng-table-pager {\r\n      position: absolute;\r\n      right: 15px;\r\n    }\r\n  }\r\n  .datos-del-detalle p {\r\n    margin-bottom: 5px;\r\n  }\r\n  .ng-table th.sortable .sort-indicator:after, .ng-table th.sortable .sort-indicator:before {\r\n    border-color: #fff transparent !important;\r\n  }\r\n  .ng-table th.sortable.sort-desc,\r\n  .ng-table th.sortable.sort-asc {\r\n    background-color: rgb(22, 64, 111) !important;\r\n  }\r\n  .ng-table-counts.btn-group {\r\n    float: left !important;\r\n  }\r\n  ul.pagination.pagination {\r\n    float: right;\r\n  }</style>";

/***/ },
/* 504 */,
/* 505 */
/***/ function(module, exports) {

	module.exports = "<div class=directiveCity uib-dropdown dropdown-append-to-body=ctrl.appendBody><button uib-dropdown-toggle ng-click=ctrl.getCityList() ng-disabled=ctrl.isDis><span class=caret></span></button> <input id={{ctrl.idCity}} name={{ctrl.idCity}} class=\"form-control uib-typeahead-match\" ng-model=ctrl.myValue placeholder={{ctrl.placeholder}} uib-typeahead=\"type as (type.name) for type in ctrl.getCitySearch($viewValue)\" typeahead-min-length=2 ng-blur=\"ctrl.onBlurInput({item : $item})\" typeahead-editable=ctrl.editable typeahead-append-to-body=ctrl.appendBody typeahead-on-select=\"ctrl.typeaheadSelect({item : $item})\" ng-required=ctrl.isReq ng-disabled=ctrl.isDis><ul class=\"dropdown-menu dropdownDirectivs\" uib-dropdown-menu role=menu when-scrolled=ctrl.getCityList()><li ng-repeat=\"type in ctrl.listCity2 track by type.id\"><a href=\"\" id=listPuc ng-click=ctrl.onSelect(type)>{{type.name}}</a></ul></div><style>.dropdown-menu{\r\n    max-height: 20em;\r\n    overflow: auto;\r\n  }\r\n  .directiveCity{\r\n    position:relative;\r\n  }\r\n  .caret {\r\n    display: inline-block;\r\n    width: 0;\r\n    height: 0;\r\n    margin-left: 2px;\r\n    vertical-align: middle;\r\n    border-top: 6px dashed;\r\n    border-right: 3px solid transparent;\r\n    border-left: 3px solid transparent;\r\n    color: transparent;\r\n  }\r\n  .directivePuc input,\r\n  .directiveCity input,\r\n  .customersAutocomplete input,\r\n  .providersAutocomplete input,\r\n  .directiveThird input {\r\n    width: 100%;\r\n  }\r\n  .directivePuc button,\r\n  .directiveCity button,\r\n  .customersAutocomplete button,\r\n  .providersAutocomplete button,\r\n  .directiveThird button {\r\n    width: 20px;\r\n    height: 2.7em;\r\n    padding: 0.1em 0;\r\n    position: absolute;\r\n    right: 0;\r\n    background-color: transparent;\r\n    border: none;\r\n    color: #000;\r\n  }\r\n  .directivePuc button:disabled,\r\n  .directiveCity button:disabled,\r\n  .customersAutocomplete button:disabled,\r\n  .providersAutocomplete button:disabled,\r\n  .directiveThird button:disabled {\r\n    background-color: transparent !important;\r\n  }\r\n  .directivePuc button span,\r\n  .directiveCity button span,\r\n  .customersAutocomplete button span,\r\n  .providersAutocomplete button span,\r\n  .directiveThird button span {\r\n    font-size: 0.5em;\r\n  }\r\n  .directivePuc:hover .caret,\r\n  .directiveCity:hover .caret,\r\n  .customersAutocomplete:hover .caret,\r\n  .providersAutocomplete:hover .caret,\r\n  .directiveThird:hover .caret {\r\n    color: #000;\r\n  }\r\n  .directivePuc > .dropdown-menu,\r\n  .directiveCity > .dropdown-menu,\r\n  .customersAutocomplete > .dropdown-menu,\r\n  .providersAutocomplete > .dropdown-menu,\r\n  .directiveThird > .dropdown-menu {\r\n    padding-right: 0.5em;\r\n  }\r\n  .dropdownDirectivs {\r\n    max-height: 200px;\r\n    font-size: 1.2em;\r\n    overflow: auto;\r\n    z-index: 200;\r\n  }</style>";

/***/ },
/* 506 */
/***/ function(module, exports) {

	module.exports = "<div id={{$ctrl.cbName}}><div uib-carousel active=$ctrl.active interval=$ctrl.myInterval><div uib-slide ng-repeat=\"item in $ctrl.cbItems\" index=$index><a href=\"{{item.url ? item.url : '#'}}\" title={{item.title}}><img ng-src={{item.imageUrl}} target=\"{{item.url ? '_blank': '_self'}}\" style=margin:auto></a><div class=carousel-caption></div></div></div></div>";

/***/ },
/* 507 */
/***/ function(module, exports) {

	module.exports = "<div><carousel-banner ng-if=$ctrl.dbData.isCarousel cb-items=$ctrl.dbData.items cb-name=$ctrl.dbName></carousel-banner><div ng-if=!$ctrl.dbData.isCarousel><a href=\"{{$ctrl.dbData.items[0].url ? $ctrl.dbData.items[0].url : '#'}}\" title={{$ctrl.dbData.items[0].title}}><img ng-src={{$ctrl.dbData.items[0].imageUrl}}></a></div></div>";

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"widget banner-slider-container\"><div class=\"banner-slider flexslider\"><ul class=\"banner-slider-list clearfix\"><li ng-show=$ctrl.ngAuthSettings.site.config.data.banners.showNews><a href=\"\"><img src=" + __webpack_require__(443) + " alt=\"Banner Noticias\"></a><li><dynamic-banner db-data=$ctrl.shCtrl.globalBanners.sideTop db-name=sideTopBanner></dynamic-banner><li><dynamic-banner db-data=$ctrl.shCtrl.globalBanners.sideBottom db-name=sideTsideBottomBanneropBanner></dynamic-banner></ul></div></div><style></style>";

/***/ },
/* 509 */
/***/ function(module, exports) {

	module.exports = "<div id=category-filter class=\"panel-group custom-accordion sm-accordion acc-nuestros-productos inicio\"><div class=\"widget reversebg\"><h3><a ui-sref=home.category title=\"Líneas de productos\">Líneas de productos</a></h3><div class=\"panel-group custom-accordion sm-accordion\" id=acc-categorias><div class=\"panel simplebar-content\" ng-repeat=\"item in $ctrl.shCtrl.globalCategoriesMenu\"><div class=accordion-header><div class=accordion-title data-toggle=collapse data-target=#acc-cat{{item.id}} data-parent=#acc-categorias><a ng-if=\"!item.url_destino && item.hijas.length\" ui-sref=\"home.categorySlug({categorySlug : item.slug})\" target=\"{{item.url_destino ? '_blank' : ''}}\" title={{item.title}}><span ng-class=\"{'enlace-externo-categoria': item.url_destino}\"><img src=\"{{$ctrl.ngAuthSettings.config.env.basePath + item.icon}}\" alt=\"\"> {{item.nombre}} </span></a><a ng-if=\"!item.url_destino && !item.hijas.length\" ui-sref=\"home.categorySlugProducts({categorySlug : item.slug})\" target=\"{{item.url_destino ? '_blank' : ''}}\" title={{item.title}}><span ng-class=\"{'enlace-externo-categoria': item.url_destino}\"><img src=\"{{$ctrl.ngAuthSettings.config.env.basePath + item.icon}}\" alt=\"\"> {{item.nombre}}</span></a></div><a class=\"accordion-btn collapsed\" data-toggle=collapse data-target=#acc-cat{{::item.id}} data-parent=#acc-categorias ng-show=item.hijas.length></a></div><div id=acc-cat{{item.id}} class=collapse><div class=panel-body><ul><li ng-repeat=\"hija in item.hijas\"><a href=\"{{hija.url_destino ?\r\n                    hija.url_destino :\r\n                    (hija.hijas.length ? $ctrl.ngAuthSettings.config.env.basePath + hija.slug : $ctrl.ngAuthSettings.config.env.basePath + hija.slug + '/productos')}}\" target=\"{{hija.url_destino ? '_blank' : ''}}\" title={{hija.nombre}} class=list-group-item><span ng-class=\"{'enlace-externo-categoria': hija.url_destino}\">{{hija.nombre}}</span></a></ul></div></div></div><div class=ver-mas-cat><i class=\"fa fa-plus-circle\"></i> Ver más categorías</div><div class=ver-menos-cat style=display:none><i class=\"fa fa-minus-circle\"></i> Ver menos categorias</div></div></div></div>";

/***/ },
/* 510 */
/***/ function(module, exports) {

	module.exports = "<div class=\"modal-content salir-aplication\"><div class=modal-header><h5 class=modal-title><span>Información de quien recogerá su pedido</span></h5></div><div class=modal-body><div class=\"product-add clearfix\"><div class=row ng-show=!mdCtrl.vehiculo_transporte.save><div class=\"col-md-12 col-sm-12 col-xs-12\"><p>Indíquenos por favor los datos de la persona de su compañía que recogerá este pedido en las instalaciones de {{mdCtrl.propietario.nombre}}.</div></div><div class=clear></div><div class=xs-margin></div><div class=row><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=\"form-group form-group-sm\"><label class=text-left>Conductor</label><input class=\"form-control input-sm\" ng-model=mdCtrl.vehiculo_transporte.nombre_conductor></div></div><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=\"form-group form-group-sm\"><label class=text-left>Cédula</label><input class=\"form-control input-sm\" ng-model=mdCtrl.vehiculo_transporte.documento_conductor></div></div><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=\"form-group form-group-sm\"><label class=text-left>Placa del Vehiculo</label><input class=\"form-control input-sm\" maxlength=6 minlength=6 ng-model=mdCtrl.vehiculo_transporte.placa_vehiculo></div></div><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=\"form-group form-group-sm\"><label class=text-left>Fecha estimada de Cargue</label><input class=\"form-control input-sm\" id=fecha_cargue data-provide=datepicker data-date-format=yyyy-mm-dd data-date-start-date=0d data-date-calendar-weeks=false data-date-clear-btn=true data-date-today-btn=linked data-date-today-highlight=true data-date-days-of-week-disabled=false data-date-keyboard-navigation=true ng-model=mdCtrl.vehiculo_transporte.fecha_cargue></div></div></div><div class=\"row btn-actions\"><div class=col-xs-12><button class=\"btn btn-danger\" type=button ng-click=mdCtrl.cancel() style=\"margin-right: 5px\"><strong>Cancelar</strong></button> <button class=\"btn btn-success btn-sm\" ng-click=mdCtrl.cancel() ng-if=!mdCtrl.vehiculo_transporte.pedido_id><i class=\"fa fa-share\" aria-hidden=true></i> Diligenciar más tarde</button> <button class=\"btn btn-success btn-sm\" ng-click=mdCtrl.updateInformation(mdCtrl.vehiculo_transporte) ng-if=!mdCtrl.vehiculo_transporte.pedido_id><i class=\"fa fa-save\" aria-hidden=true></i> Guardar y continuar</button> <button type=button ng-click=mdCtrl.updateInformation(mdCtrl.vehiculo_transporte) ng-if=mdCtrl.vehiculo_transporte.pedido_id class=\"btn btn-warning\"><strong>Guardar</strong></button></div></div></div></div></div>";

/***/ },
/* 511 */
/***/ function(module, exports) {

	module.exports = "<div class=modal-header><h5 class=modal-title>Recomendar producto a un amigo</h5></div><div class=modal-body style=padding-top:10px><div ng-show=mdCtrl.mailSent><div class=\"alert alert-success\">El correo ha sido enviado exitosamente. Gracias por recomendar el producto {{mdCtrl.product.name}} - Referencia {{mdCtrl.product.reference}}.</div><div class=\"input-group pull-right\"><button ng-click=mdCtrl.ok() type=button class=\"btn btn-default\">Cerrar</button></div></div><div class=row><div class=col-md-12 ng-show=!mdCtrl.mailSent><p>Utiliza el siguiente formulario para recomendar el producto: <strong>{{mdCtrl.product.name}}</strong></div><form id=contact-form name=mdCtrl.contactForm ng-if=!mdCtrl.mailSent ng-submit=mdCtrl.sendMailContact(mdCtrl.contactForm) novalidate><div class=\"col-md-6 col-sm-12 col-xs-12\"><div class=\"input-group text-muted\">Datos personales</div><div class=input-group><span class=input-group-addon><span class=input-text>Nombre&#42;</span> </span><input name=name id=contact-name class=form-control placeholder=\"Digite su nombre\" ng-model=mdCtrl.contactDataForm.name autocomplete=off required></div><span ng-show=\"mdCtrl.contactForm.name.$invalid && !mdCtrl.contactForm.name.$pristine\" class=help-block>Ingrese su nombre completo.</span><div class=input-group><span class=input-group-addon><span class=input-text>Email&#42;</span> </span><input type=email name=email id=contact-email class=form-control placeholder=\"Digite su email\" ng-model=mdCtrl.contactDataForm.email autocomplete=off required></div><span ng-show=\"mdCtrl.contactForm.email.$invalid && !mdCtrl.contactForm.email.$pristine\" class=help-block>Ingrese un email válido.</span><div class=\"input-group text-muted\">Datos de su amigo</div><div class=input-group><span class=input-group-addon><span class=input-text>Nombre&#42;</span> </span><input name=friendName id=contact-name2 class=form-control placeholder=\"Nombre de su amigo\" ng-model=mdCtrl.contactDataForm.friendName autocomplete=off required></div><span ng-show=\"mdCtrl.contactForm.friendName.$invalid && !mdCtrl.contactForm.friendName.$pristine\" class=help-block>Ingrese el nombre de su amigo.</span><div class=input-group><span class=input-group-addon><span class=input-text>Email&#42;</span> </span><input type=email name=friendEmail id=contact-email2 class=form-control placeholder=\"Email de su amigo\" ng-model=mdCtrl.contactDataForm.friendEmail autocomplete=off required></div><span ng-show=\"mdCtrl.contactForm.friendEmail.$invalid && !mdCtrl.contactForm.friendEmail.$pristine\" class=help-block>Ingrese el email de su amigo.</span><p class=\"item-desc hidden-sm hidden-xs\">Los campos con * son obligatorios.</div><div class=\"col-md-6 col-sm-12 col-xs-12\"><div class=\"input-group hidden-sm hidden-xs\">&nbsp;</div><div class=\"input-group textarea-container\"><span class=input-group-addon><span class=input-text>Comentario</span></span><textarea name=message id=contact-message class=form-control cols=30 rows=5 placeholder=\"Ingrese el mensaje a enviar\" ng-model=mdCtrl.contactDataForm.message required></textarea></div><span ng-show=\"mdCtrl.contactForm.message.$invalid && !mdCtrl.contactForm.message.$pristine\" class=help-block>Ingrese el mensaje a enviar.</span><p class=\"item-desc hidden-md hidden-lg hidden-xl\">Los campos con * son obligatorios.<div class=\"input-group pull-right\"><button ng-click=mdCtrl.cancel() type=button class=\"btn btn-default\">Cancelar</button> <input type=submit value=Enviar class=\"btn btn-custom-4\"></div></div></form></div></div>";

/***/ },
/* 512 */
/***/ function(module, exports) {

	module.exports = "<div class=\"modal-content salir-aplication\" id=modalQuoteSellerHeader><div class=modal-header><button type=button class=close ng-click=mdCtrl.cancel()>&times;</button><h5 class=modal-title><span>Información del Cliente</span></h5></div><div class=\"modal-body cotizanteHeader\"><section><div class=\"panel-group informacion-cotizantes\" id=accordionSelectClientHeader><div class=\"panel panel-default paso1Header\"><div class=accordion-header><div class=accordion-title>1. Datos del Solicitante</div></div><div id=paso1Header class=\"panel-collapse collapse in\"><div class=panel-body><form id=seller-quote-form-step-1-header name=mdCtrl.sellerQuoteFormStep1Header autocomplete=off novalidate><div class=row><div class=\"col-md-12 show-ids-toc\"><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=form-group><label class=bold>Id Solicitante *</label><br><input name=sellerQuoteAttendantId class=form-control ng-model=mdCtrl.sellerQuoteFormDataHeader.attendant.id title=\"Id Solicitante\" disabled placeholder=\"\" maxlength=20 size=20></div></div></div><div class=col-md-12><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=form-group><label class=bold>Tipo Identificación *</label><select title=\"Por favor seleccione el tipo de identificación\" class=form-control name=sellerQuoteAttendanteDocumentType ng-model=mdCtrl.sellerQuoteFormDataHeader.attendant.documentType ng-disabled=\"mdCtrl.savingQuoteOrderCartSellerHeader ||\r\n                                                mdCtrl.loadingOcasionalInformationHeader ||\r\n                                                mdCtrl.sellerQuoteFormDataHeader.attendant.id\" ng-change=mdCtrl.autosetAttendantClientTypeHeader() required><option value=\"\" style=color:#aaa>Seleccione el tipo de identificación<option value=1>Cédula de Ciudadan&iacute;a<option value=2>NIT<option value=3>RUT</select><span class=input-help><span ng-show=\"mdCtrl.sellerQuoteFormStep1Header.sellerQuoteAttendanteDocumentType.$invalid &&\r\n                                        !mdCtrl.sellerQuoteFormStep1Header.sellerQuoteAttendanteDocumentType.$pristine\" class=help-block>Seleccione el tipo de identificación.</span></span></div></div><div class=col-sm-4><div class=form-group><label for=\"\" class=bold>Nro. Documento * <i ng-show=\"mdCtrl.loadingOcasionalInformationHeader || mdCtrl.validatingNumberIdHeader\" class=\"fa fa-history load-animation\"></i></label><input id=sellerQuoteAttendantDocumentNumberHeader name=sellerQuoteAttendantDocumentNumber class=form-control ng-model=mdCtrl.sellerQuoteFormDataHeader.attendant.documentNumber title=\"Por favor ingrese el número de identificación del solicitante\" ng-disabled=\"mdCtrl.savingQuoteOrderCartSellerHeader ||\r\n                                               mdCtrl.loadingOcasionalInformationHeader ||\r\n                                               mdCtrl.validatingNumberIdHeader\" placeholder=\"\" maxlength=20 size=20 restrict-type=num ng-blur=mdCtrl.validateNumberIdUnusedHeader(mdCtrl.sellerQuoteFormDataHeader.attendant.documentNumber) required> <span ng-show=\"!mdCtrl.ocasionalClientExistHeader && mdCtrl.validatedNumberIdHeader && !mdCtrl.numberIdIsValidHeader\" class=help-block>Esta cédula ya tiene una cuenta asociada. </span><span ng-show=\"mdCtrl.terceroAsociadoOtroVendedor && mdCtrl.validatedNumberIdHeader\" class=help-block>Este cliente ya tiene otro vendedor asignado. </span><span ng-show=\"mdCtrl.thirdIsInactive && mdCtrl.validatedNumberIdHeader\" class=help-block>El cliente se encuentra inactivo. </span><span class=input-help><span ng-show=\"mdCtrl.sellerQuoteFormStep1Header.sellerQuoteAttendantDocumentNumber.$invalid &&\r\n                                              !mdCtrl.sellerQuoteFormStep1Header.sellerQuoteAttendantDocumentNumber.$pristine\" class=help-block>Ingrese el número de identificación.</span></span></div></div><div class=col-sm-2><div class=form-group ng-show=\"mdCtrl.sellerQuoteFormDataHeader.attendant.clientType == 2 &&\r\n                                           mdCtrl.sellerQuoteFormDataHeader.attendant.documentType == 2\"><label for=\"\" class=bold>DV</label><input ng-model=mdCtrl.sellerQuoteFormDataHeader.attendant.documentDV ng-disabled=\"mdCtrl.savingQuoteOrderCartSellerHeader || mdCtrl.loadingOcasionalInformationHeader\" class=form-control title=\"Por favor ingrese el dígito de verificación\" autocomplete=off placeholder=\"\" maxlength=1 size=1 restrict-type=num></div></div></div><div class=col-sm-12><div class=col-sm-6><div class=form-group><label for=\"\" class=bold>Tipo *</label><select class=form-control name=sellerQuoteAttendantType ng-model=mdCtrl.sellerQuoteFormDataHeader.attendant.clientType ng-disabled=\"mdCtrl.savingQuoteOrderCartSellerHeader ||\r\n                                                mdCtrl.loadingOcasionalInformationHeader ||\r\n                                                mdCtrl.sellerQuoteFormDataHeader.attendant.id\" required><option value=\"\" style=color:#aaa>Seleccione el tipo de solicitante<option value=1>Persona Natural<option value=2>Persona Jurídica</select><span class=input-help><span ng-show=\"mdCtrl.sellerQuoteFormStep1Header.sellerQuoteAttendantType.$invalid &&\r\n                                              !mdCtrl.sellerQuoteFormStep1Header.sellerQuoteAttendantType.$pristine\" class=help-block>Seleccione el tipo de persona.</span></span></div></div><div class=col-sm-6><div class=form-group><label for=\"\" class=bold>Persona / Razón social *</label><span class=\"preload-data no-editable\" style=position:relative><div mass-autocomplete><input name=sellerQuoteAttendantName mass-autocomplete-item=mdCtrl.attendant_name_options class=form-control placeholder=\"e.j. Carvajal\" title=\"Por favor ingrese el nombre de la empresa\" ng-model=mdCtrl.sellerQuoteFormDataHeader.attendant.name ng-disabled=\"mdCtrl.savingQuoteOrderCartSellerHeader ||\r\n                                                mdCtrl.loadingOcasionalInformationHeader\" autocomplete=off required></div></span><span class=input-help><span ng-show=\"mdCtrl.sellerQuoteFormStep1Header.sellerQuoteAttendantName.$invalid &&\r\n                                              !mdCtrl.sellerQuoteFormStep1Header.sellerQuoteAttendantName.$pristine\" class=help-block>Ingrese el nombre del solicitante.</span></span></div></div></div></div><div class=clear></div><hr class=cotizanteHeader><div class=pull-right><div class=col-sm-12><a href=cotizanteHeader#paso2Header ng-disabled=\"!mdCtrl.sellerQuoteFormStep1Header.$valid ||\r\n                                       (mdCtrl.validatedNumberIdHeader && !mdCtrl.numberIdIsValidHeader) ||\r\n                                       mdCtrl.loadingOcasionalInformationHeader\" class=\"btn btn-success xs-margin collapsed\" data-parent=#accordionSelectClientHeader data-toggle=collapse>Siguiente Paso <i class=\"fa fa-arrow-circle-right\"></i></a></div></div></form></div></div></div><div class=\"panel panel-default\"><div class=accordion-header><div class=accordion-title>2. Información del Destino de los Items</div></div><div id=paso2Header class=\"panel-collapse collapse\"><div class=panel-body><form id=seller-quote-form-step-2-header name=mdCtrl.sellerQuoteFormStep2Header novalidate><div class=row><div class=\"col-md-12 show-ids-toc\"><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=form-group><label class=bold>Id Centro Operación *</label><br><input name=sellerQuoteDestinationId class=form-control ng-model=mdCtrl.sellerQuoteFormDataHeader.destination.id title=\"Id Centro Operación\" disabled autocomplete=off placeholder=\"\" maxlength=20 size=20></div></div></div><div class=col-sm-12 ng-if=mdCtrl.sellerQuoteFormDataHeader.destinations.length><div class=col-sm-12><div class=form-group><label for=\"\" class=bold>Centro de Operación</label><select class=form-control ng-if=\"mdCtrl.sellerQuoteFormDataHeader.destinations.length >= 1\" ng-model=mdCtrl.sellerQuoteFormDataHeader.destination ng-change=mdCtrl.clearNameCityHeader() ng-options=\"item as (item.branchOffice + ' - ' + item.location.fullname) for item\r\n                                                in mdCtrl.sellerQuoteFormDataHeader.destinations track by item.id\"><option value=\"\" style=color:#aaa selected>Nuevo Centro de Operación<option value={{item.id}}>{{item.branchOffice}}</select></div></div></div><div class=col-md-12><div class=col-sm-12><div class=form-group><label for=\"\" class=bold>Ciudad de destino * <i ng-show=mdCtrl.loadingCitiesHeader class=\"fa fa-history load-animation\"></i></label><span class=\"preload-data no-editable\" ng-show=mdCtrl.sellerQuoteFormDataHeader.destination.id>{{mdCtrl.sellerQuoteFormDataHeader.destination.location.fullname}} </span><span class=\"preload-data no-editable\" ng-show=!mdCtrl.sellerQuoteFormDataHeader.destination.id style=position:relative><div mass-autocomplete><input name=sellerQuoteDestinationCityLocation mass-autocomplete-item=mdCtrl.autocomplete_options class=form-control placeholder=\"e.j. Cali\" title=\"Por favor ingrese la ciudad del destino\" ng-model=mdCtrl.globalCities.value ng-disabled=mdCtrl.savingQuoteOrderCartSellerHeader autocomplete=off></div></span><input type=hidden name=sellerQuoteDestinationCityId ng-model=mdCtrl.sellerQuoteFormDataHeader.destination.location.city.id required> <span class=input-help><span ng-show=\"mdCtrl.sellerQuoteFormStep2Header.sellerQuoteDestinationCityId.$invalid &&\r\n                                        !mdCtrl.sellerQuoteFormStep2Header.sellerQuoteDestinationCityLocation.$pristine\" class=help-block>Seleccione la ciudad de destino. La ciudad seleccionada no es valida.</span></span></div></div></div><div class=col-sm-12><div class=col-sm-12><div class=form-group><label for=\"\" class=bold>Nombre sucursal o Punto de Envío *</label><input name=sellerQuoteDestinationBranchOffice ng-show=\"!mdCtrl.sellerQuoteFormDataHeader.destination.id || !mdCtrl.globals.currentUser.isB2B\" class=form-control placeholder=\"\" title=\"Por favor ingrese el nombre de la sucursal o del punto de envío\" ng-model=mdCtrl.sellerQuoteFormDataHeader.destination.branchOffice ng-disabled=mdCtrl.savingQuoteOrderCartSellerHeader autocomplete=off maxlength=100 required> <span ng-show=\"mdCtrl.sellerQuoteFormDataHeader.destination.id && mdCtrl.globals.currentUser.isB2B\" class=\"preload-data no-editable\">{{mdCtrl.sellerQuoteFormDataHeader.destination.branchOffice}} </span><span class=input-help><span ng-show=\"mdCtrl.sellerQuoteFormStep2Header.sellerQuoteDestinationBranchOffice.$invalid &&\r\n                                              !mdCtrl.sellerQuoteFormStep2Header.sellerQuoteDestinationBranchOffice.$pristine\" class=help-block>Ingrese la sucursal o el punto de envío.</span></span></div></div></div><div class=col-md-12><div class=col-sm-6><div class=form-group><label for=\"\" class=bold>Dirección * <span ng-show=\"mdCtrl.sellerQuoteFormDataHeader.destination.id && mdCtrl.globals.currentUser.isB2B\" ng-click=\"mdCtrl.sellerQuoteFormDataHeader.showNewAddresField =\r\n                                              !mdCtrl.sellerQuoteFormDataHeader.showNewAddresField\"><i class=\"fa fa-edit\"></i></span></label><input name=sellerQuoteDestinationAddress class=form-control title=\"Por favor ingrese la dirección de destino\" placeholder=\"Ingrese la nueva dirección\" ng-show=\"!mdCtrl.sellerQuoteFormDataHeader.destination.id || !mdCtrl.globals.currentUser.isB2B\" ng-model=mdCtrl.sellerQuoteFormDataHeader.destination.address ng-disabled=mdCtrl.savingQuoteOrderCartSellerHeader autocomplete=off maxlength=150 required> <input name=sellerQuoteDestinationNewAddress class=form-control title=\"Por favor ingrese la nueva dirección de destino\" placeholder=\"\" ng-show=\"mdCtrl.sellerQuoteFormDataHeader.destination.id &&\r\n                                               mdCtrl.globals.currentUser.isB2B &&\r\n                                               mdCtrl.sellerQuoteFormDataHeader.showNewAddresField\" ng-model=mdCtrl.sellerQuoteFormDataHeader.destination.newAddress ng-disabled=mdCtrl.savingQuoteOrderCartSellerHeader autocomplete=off maxlength=150> <span ng-show=\"mdCtrl.sellerQuoteFormDataHeader.destination.id && mdCtrl.globals.currentUser.isB2B\" class=\"preload-data no-editable\">{{mdCtrl.sellerQuoteFormDataHeader.destination.address}} </span><span class=input-help><span ng-show=\"mdCtrl.sellerQuoteFormStep2Header.sellerQuoteDestinationAddress.$invalid &&\r\n                                              !mdCtrl.sellerQuoteFormStep2Header.sellerQuoteDestinationAddress.$pristine\" class=help-block>Ingrese su dirección de destino.</span></span></div></div><div class=col-sm-6><div class=form-group><label for=\"\" class=bold>Teléfono Fijo <span ng-show=\"mdCtrl.sellerQuoteFormDataHeader.destination.id && mdCtrl.globals.currentUser.isB2B\" ng-click=\"mdCtrl.sellerQuoteFormDataHeader.showNewPhoneNumberField =\r\n                                              !mdCtrl.sellerQuoteFormDataHeader.showNewPhoneNumberField\"><i class=\"fa fa-edit\"></i></span></label><div class=\"form-group phone-number\"><div class=row><div class=\"col-xs-3 text-center\"><span class=\"preload-data no-editable\"><span ng-if=mdCtrl.sellerQuoteFormDataHeader.destination.location.country.indicative>{{mdCtrl.sellerQuoteFormDataHeader.destination.location.country.indicative}} </span><span ng-if=!mdCtrl.sellerQuoteFormDataHeader.destination.location.country.indicative>-</span></span></div><div class=\"col-xs-3 text-center\"><span class=\"preload-data no-editable\"><span ng-if=mdCtrl.sellerQuoteFormDataHeader.destination.location.city.indicative>{{mdCtrl.sellerQuoteFormDataHeader.destination.location.city.indicative}} </span><span ng-if=!mdCtrl.sellerQuoteFormDataHeader.destination.location.city.indicative>-</span></span></div><div class=col-xs-6><input type=tel name=sellerQuoteDestinationPhoneNumber class=form-control size=7 maxlength=50 placeholder=\"\" title=\"Por favor ingrese el número de teléfono\" ng-show=\"!mdCtrl.sellerQuoteFormDataHeader.destination.id || !mdCtrl.globals.currentUser.isB2B\" ng-model=mdCtrl.sellerQuoteFormDataHeader.destination.phoneNumber ng-disabled=mdCtrl.savingQuoteOrderCartSellerHeader autocomplete=off restrict-type=num> <input type=tel name=sellerQuoteDestinationNewPhoneNumber class=form-control size=7 maxlength=50 placeholder=\"\" title=\"Por favor ingrese el nuevo número de teléfono\" ng-show=\"mdCtrl.sellerQuoteFormDataHeader.destination.id &&\r\n                                                     mdCtrl.globals.currentUser.isB2B &&\r\n                                                     mdCtrl.sellerQuoteFormDataHeader.showNewPhoneNumberField\" ng-model=mdCtrl.sellerQuoteFormDataHeader.destination.newPhoneNumber ng-disabled=mdCtrl.savingQuoteOrderCartSellerHeader autocomplete=off></div><span ng-show=\"mdCtrl.sellerQuoteFormDataHeader.destination.id && mdCtrl.globals.currentUser.isB2B\" class=\"preload-data no-editable\" style=\"display: block;text-align: center\">{{mdCtrl.sellerQuoteFormDataHeader.destination.phoneNumber}} </span><span class=input-help><span ng-show=\"mdCtrl.sellerQuoteFormStep2Header.sellerQuoteDestinationPhoneNumber.$invalid &&\r\n                                                  !mdCtrl.sellerQuoteFormStep2Header.sellerQuoteDestinationPhoneNumber.$pristine\" class=help-block>Ingrese el teléfono fijo del destino.</span></span></div></div></div></div></div></div><div class=clear></div><hr class=cotizanteHeader><div class=pull-right><div class=col-sm-12><a href=cotizanteHeader#paso1Header class=\"btn btn-primary xs-margin collapsed\" data-parent=#accordionSelectClientHeader data-toggle=collapse><i class=\"fa fa-arrow-circle-left\"></i> Paso Anterior </a><a href=cotizanteHeader#paso3Header class=\"btn btn-success xs-margin collapsed\" data-parent=#accordionSelectClientHeader ng-disabled=!mdCtrl.sellerQuoteFormStep2Header.$valid data-toggle=collapse>Siguiente Paso <i class=\"fa fa-arrow-circle-right\"></i></a></div></div></form></div></div></div><div class=\"panel panel-default\"><div class=accordion-header><div class=accordion-title>3. Información de Contacto</div></div><div id=paso3Header class=\"panel-collapse collapse\"><div class=panel-body><form id=seller-quote-form-step-3-header name=mdCtrl.sellerQuoteFormStep3Header novalidate><div class=row><div class=\"col-md-12 show-ids-toc\"><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=form-group><label class=bold>Id Contacto *</label><br><input name=sellerQuoteContactId class=form-control ng-model=mdCtrl.sellerQuoteFormDataHeader.contact.id title=\"Id Contacto\" disabled autocomplete=off placeholder=\"\" maxlength=20 size=20></div></div></div><div class=col-sm-12 ng-if=mdCtrl.sellerQuoteFormDataHeader.contacts.length><div class=col-sm-12><div class=form-group><label for=\"\" class=bold>Contacto</label><select class=form-control ng-if=\"mdCtrl.sellerQuoteFormDataHeader.contacts.length >= 1\" ng-model=mdCtrl.sellerQuoteFormDataHeader.contact ng-options=\"item as item.fullnameAndDocumentNumber for item\r\n                                                in mdCtrl.sellerQuoteFormDataHeader.contacts track by item.id\" ng-disabled=mdCtrl.loadingContactByIdentificationNumberHeader><option value=\"\" style=color:#aaa selected>Nuevo Contacto<option value={{item.id}}>{{item.fullnameAndDocumentNumber}}</select></div></div></div><div class=col-md-12><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=form-group><label class=bold>Tipo Identificación *</label><select title=\"Por favor seleccione el tipo de identificación\" class=form-control name=sellerQuoteContactDocumentType ng-model=mdCtrl.sellerQuoteFormDataHeader.contact.documentType ng-disabled=\"mdCtrl.savingQuoteOrderCartSellerHeader ||\r\n                                                mdCtrl.loadingOcasionalInformationHeader ||\r\n                                                mdCtrl.loadingContactByIdentificationNumberHeader\" required><option value=\"\" style=color:#aaa>Seleccione el tipo de identificación<option value=1>Cédula de Ciudadan&iacute;a<option value=2>NIT<option value=3>RUT</select><span class=input-help><span ng-show=\"mdCtrl.sellerQuoteFormStep3Header.sellerQuoteContactDocumentType.$invalid &&\r\n                                              !mdCtrl.sellerQuoteFormStep3Header.sellerQuoteContactDocumentType.$pristine\" class=help-block>Seleccione el tipo de identificación.</span></span></div></div><div class=col-sm-4><div class=form-group><label for=\"\" class=bold>Nro. Documento * <i ng-show=mdCtrl.loadingContactByIdentificationNumberHeader class=\"fa fa-history load-animation\"></i></label><input id=sellerQuoteContactDocumentNumber name=sellerQuoteContactDocumentNumber class=form-control ng-model=mdCtrl.sellerQuoteFormDataHeader.contact.documentNumber title=\"Por favor ingrese el número de identificación del solicitante\" ng-disabled=\"mdCtrl.savingQuoteOrderCartSellerHeader ||\r\n                                               mdCtrl.loadingOcasionalInformationHeader ||\r\n                                               mdCtrl.loadingContactByIdentificationNumberHeader\" autocomplete=off placeholder=\"\" maxlength=45 size=20 restrict-type=num ng-blur=mdCtrl.loadContactByIdentificacionNumberHeader(mdCtrl.sellerQuoteFormDataHeader.contact.documentNumber) required> <span class=input-help><span ng-show=\"mdCtrl.sellerQuoteFormStep3Header.sellerQuoteContactDocumentNumber.$invalid &&\r\n                                              !mdCtrl.sellerQuoteFormStep3Header.sellerQuoteContactDocumentNumber.$pristine\" class=help-block>Ingrese el número de identificación.</span></span></div></div></div><div class=col-md-12><div class=col-sm-6><div class=form-group><label for=\"\" class=bold>Nombre(s) *</label><input name=sellerQuoteContactFirstname class=form-control title=\"Por favor ingrese los nombres del contacto\" placeholder=\"\" ng-model=mdCtrl.sellerQuoteFormDataHeader.contact.firstname ng-disabled=\"mdCtrl.savingQuoteOrderCartSellerHeader ||\r\n                                               mdCtrl.loadingContactByIdentificationNumberHeader\" restrict-type=num maxlength=50 required> <span class=input-help><span ng-show=\"mdCtrl.sellerQuoteFormStep3Header.sellerQuoteContactFirstname.$invalid &&\r\n                                              !mdCtrl.sellerQuoteFormStep3Header.sellerQuoteContactFirstname.$pristine\" class=help-block>Ingrese los nombres del contacto.</span></span></div></div><div class=col-sm-6><div class=form-group><label for=\"\" class=bold>Apellido(s) *</label><input name=sellerQuoteContactLastname class=form-control title=\"Por favor ingrese los apellidos del contacto\" placeholder=\"\" ng-model=mdCtrl.sellerQuoteFormDataHeader.contact.lastname ng-disabled=\"mdCtrl.savingQuoteOrderCartSellerHeader ||\r\n                                               mdCtrl.loadingContactByIdentificationNumberHeader\" restrict-type=num maxlength=50 required> <span class=input-help><span ng-show=\"mdCtrl.sellerQuoteFormStep3Header.sellerQuoteContactLastname.$invalid &&\r\n                                              !mdCtrl.sellerQuoteFormStep3Header.sellerQuoteContactLastname.$pristine\" class=help-block>Ingrese los apellidos del contacto.</span></span></div></div></div><div class=col-md-12><div class=col-sm-6><div class=form-group><label for=\"\" class=bold>Cargo</label><input class=form-control placeholder=\"\" maxlength=255 title=\"Por favor ingrese el cargo del contacto\" ng-model=mdCtrl.sellerQuoteFormDataHeader.contact.position ng-disabled=\"mdCtrl.savingQuoteOrderCartSellerHeader ||\r\n                                               mdCtrl.loadingContactByIdentificationNumberHeader\" autocomplete=off></div></div><div class=col-sm-6><div class=form-group><label for=\"\" class=bold>Teléfono Fijo *</label><div class=\"form-group phone-number\"><div class=row><div class=\"col-xs-3 text-center\"><span class=\"preload-data no-editable\"><span ng-if=mdCtrl.sellerQuoteFormDataHeader.destination.location.country.indicative>{{mdCtrl.sellerQuoteFormDataHeader.destination.location.country.indicative}} </span><span ng-if=!mdCtrl.sellerQuoteFormDataHeader.destination.location.country.indicative>-</span></span></div><div class=\"col-xs-3 text-center\"><span class=\"preload-data no-editable\"><span ng-if=mdCtrl.sellerQuoteFormDataHeader.destination.location.city.indicative>{{mdCtrl.sellerQuoteFormDataHeader.destination.location.city.indicative}} </span><span ng-if=!mdCtrl.sellerQuoteFormDataHeader.destination.location.city.indicative>-</span></span></div><div class=col-xs-6><input type=tel name=sellerQuoteContactPhoneNumber class=form-control size=7 placeholder=\"\" title=\"Por favor ingrese el número de teléfono\" ng-model=mdCtrl.sellerQuoteFormDataHeader.contact.phoneNumber ng-disabled=\"mdCtrl.savingQuoteOrderCartSellerHeader ||\r\n                                                     mdCtrl.loadingContactByIdentificationNumberHeader\" autocomplete=off maxlength=50 restrict-type=num required></div><span class=input-help><span ng-show=\"mdCtrl.sellerQuoteFormStep3Header.sellerQuoteContactPhoneNumber.$invalid &&\r\n                                                  !mdCtrl.sellerQuoteFormStep3Header.sellerQuoteContactPhoneNumber.$pristine\" class=help-block>Ingrese el teléfono fijo del contacto.</span></span></div></div></div></div></div><div class=col-md-12><div class=col-sm-6><div class=form-group><label for=\"\" class=bold>Celular</label><div class=\"form-group phone-number\"><div class=row><div class=\"col-xs-5 text-center\"><span class=\"preload-data no-editable\"><span ng-if=mdCtrl.sellerQuoteFormDataHeader.destination.location.country.indicative>{{mdCtrl.sellerQuoteFormDataHeader.destination.location.country.indicative}} </span><span ng-if=!mdCtrl.sellerQuoteFormDataHeader.destination.location.country.indicative>-</span></span></div><div class=col-xs-7><div class=row><input type=tel name=sellerQuoteContactCelularDataCelularNumber class=form-control size=10 placeholder=\"\" title=\"Por favor ingrese el número del celular\" ng-model=mdCtrl.sellerQuoteFormDataHeader.contact.celularNumber ng-disabled=\"mdCtrl.savingQuoteOrderCartSellerHeader ||\r\n                                                       mdCtrl.loadingContactByIdentificationNumberHeader\" autocomplete=off maxlength=50 restrict-type=num></div></div><div class=\"input-help col-xs-12\"><span ng-show=\"(\r\n                                                  mdCtrl.sellerQuoteFormStep3Header.sellerQuoteContactCelularDataCountryIndicator.$invalid &&\r\n                                                  !mdCtrl.sellerQuoteFormStep3Header.sellerQuoteContactCelularDataCountryIndicator.$pristine\r\n                                                  )\r\n                                                  ||\r\n                                                  (\r\n                                                          mdCtrl.sellerQuoteFormStep3Header.sellerQuoteContactCelularDataCelularNumber.$invalid &&\r\n                                                          !mdCtrl.sellerQuoteFormStep3Header.sellerQuoteContactCelularDataCelularNumber.$pristine\r\n                                                          )\" class=help-block>Ingrese el número de celular.</span></div></div></div></div></div><div class=col-sm-6><div class=form-group><label for=\"\" class=bold>WhatsApp</label><div class=\"form-group phone-number\"><div class=row><div class=\"col-xs-4 text-center\"><span class=\"preload-data no-editable\"><span ng-if=mdCtrl.sellerQuoteFormDataHeader.destination.location.country.indicative>{{mdCtrl.sellerQuoteFormDataHeader.destination.location.country.indicative}} </span><span ng-if=!mdCtrl.sellerQuoteFormDataHeader.destination.location.country.indicative>-</span></span></div><div class=col-xs-7><div class=row><input type=tel class=form-control size=10 placeholder=\"\" title=\"Por favor ingrese el número de whatsapp\" ng-model=mdCtrl.sellerQuoteFormDataHeader.contact.whatsappNumber ng-disabled=\"mdCtrl.savingQuoteOrderCartSellerHeader ||\r\n                                                       mdCtrl.loadingContactByIdentificationNumberHeader\" autocomplete=off maxlength=255 restrict-type=num></div></div></div></div></div></div></div><div class=col-md-12><div class=col-sm-6><div class=form-group><label for=\"\" class=bold>Email Principal * <i ng-show=\"mdCtrl.loadingOcasionalInformationHeader || mdCtrl.sellerQuoteFormDataHeader.contact.validatingEmail\" class=\"fa fa-history load-animation\"></i></label><input type=email name=sellerQuoteContactPrincipalEmail title=\"Por favor ingrese su email\" placeholder=\"\" class=\"form-control input-sm\" ng-model=mdCtrl.sellerQuoteFormDataHeader.contact.principalEmail ng-disabled=\"mdCtrl.savingQuoteOrderCartSellerHeader ||\r\n                                               mdCtrl.loadingContactByIdentificationNumberHeader\" ng-blur=mdCtrl.validateEmailUnusedHeader() required> <span class=input-help><span ng-show=\"mdCtrl.sellerQuoteFormStep3Header.sellerQuoteContactPrincipalEmail.$error.email &&\r\n                                              !mdCtrl.sellerQuoteFormStep3Header.sellerQuoteContactPrincipalEmail.$pristine\" class=help-block>Ingrese un email válido. </span><span ng-show=\"!mdCtrl.sellerQuoteFormDataHeader.contact.id &&\r\n                                              mdCtrl.sellerQuoteFormDataHeader.contact.principalEmail &&\r\n                                              mdCtrl.sellerQuoteFormDataHeader.contact.validatedEmail &&\r\n                                              !mdCtrl.sellerQuoteFormDataHeader.contact.emailIsValid\" class=help-block>El email ingresado ya ha sido utilizado.</span></span></div></div><div class=col-sm-6><div class=form-group><label for=\"\" class=bold>Email Alterno</label><input type=email name=sellerQuoteContactSecondaryEmail title=\"Por favor ingrese su email\" placeholder=\"\" class=\"form-control input-sm\" ng-model=mdCtrl.sellerQuoteFormDataHeader.contact.secondaryEmail ng-disabled=\"mdCtrl.savingQuoteOrderCartSellerHeader ||\r\n                                               mdCtrl.loadingContactByIdentificationNumberHeader\" autocomplete=off> <span class=input-help><span ng-show=\"mdCtrl.sellerQuoteFormStep3Header.sellerQuoteContactSecondaryEmail.$touched &&\r\n                                              mdCtrl.sellerQuoteFormStep3Header.sellerQuoteContactSecondaryEmail.$error.email &&\r\n                                              !mdCtrl.sellerQuoteFormStep3Header.sellerQuoteContactSecondaryEmail.$pristine\" class=help-block>Ingrese un email válido.</span></span></div></div></div></div><div class=clear></div><div class=col-md-12 ng-show=mdCtrl.errorSavingQuoteOrderCartSellerHeader style=margin-top:20px><div class=\"alert alert-danger\" ng-show=mdCtrl.errorSavingQuoteOrderCartSellerHeader>{{mdCtrl.errorMessageSavingQuoteOrderCartSellerHeader}}<ul ng-show=mdCtrl.errorMessagesSavingQuoteOrderCartSellerHeader.length style=\"list-style-type: decimal;padding: 17px\"><li ng-repeat=\"error in mdCtrl.errorMessagesSavingQuoteOrderCartSellerHeader\">{{error}}</ul></div></div><div class=pull-right><div class=col-sm-12><div ng-show=mdCtrl.savingQuoteOrderCartSellerHeader><i ng-class=\"{'fa fa-history load-animation':\r\n                                      mdCtrl.savingQuoteOrderCartSellerHeader, 'fa fa-history': !mdCtrl.savingQuoteOrderCartSellerHeader}\"></i> <span>Cargando el cliente seleccionado...</span></div><a href=cotizanteHeader#paso2Header ng-show=!mdCtrl.savingQuoteOrderCartSellerHeader class=\"btn btn-primary xs-margin collapsed\" data-parent=#accordionSelectClientHeader ng-disabled=mdCtrl.sellerQuoteFormDataHeader.contact.validatingEmail data-toggle=collapse><i class=\"fa fa-arrow-circle-left\"></i> Paso Anterior </a><a href=\"\" ng-show=!mdCtrl.savingQuoteOrderCartSellerHeader ng-click=mdCtrl.setClientQuoteFormDataSeller(mdCtrl.sellerQuoteFormStep3Header) class=\"btn btn-primary xs-margin collapsed\">Finalizar</a></div></div></form></div></div></div></div></section></div><div class=modal-footer><button type=button id=btn-cerrar-modal-seleccion-cliente ng-show=!mdCtrl.savingQuoteOrderCartSellerHeader class=\"btn btn-default\" ng-click=mdCtrl.cancel()>Cerrar</button></div></div>";

/***/ },
/* 513 */
/***/ function(module, exports) {

	module.exports = "<div class=modal-content><div class=modal-body><div><iframe width=100% height=350 ng-src={{mdCtrl.modalOprions.video[mdCtrl.modalOprions.propertySrc]}}></iframe></div><div class=modal-footer style=\"margin: 0;padding: 10px 0 0;border: 0\"><button type=button class=\"btn btn-default\" ng-click=mdCtrl.cancel()>Cerrar</button></div></div></div>";

/***/ },
/* 514 */
/***/ function(module, exports) {

	module.exports = "<div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li class=active><span>Políticas de Cookies</span></ul></div></div></div></div><div class=container><div class=row><div class=col-md-12><div class=row><div class=xs-margin></div><aside class=col-md-12><h2>POLÍTICA DE COOKIES</h2><p>Una cookie es un fichero que se descarga en el computador, celular inteligente o tablet del visitante al acceder a las páginas web de nuestro portal, para almacenar y recuperar información sobre la navegación que se efectúa desde dicho equipo.<p>Nuestra compañía utiliza en esta plataforma web las siguientes cookies para brindar una mejor calidad de servicio:<ol><li>cookies estrictamente necesarias para la prestación de determinados servicios solicitados expresamente por el usuario: si se desactivan estas cookies, no podrá recibir correctamente nuestros contenidos, servicios y es muy posible que el sitio no pueda efectuar transacciones.<li>cookies analíticas (para el seguimiento y análisis estadístico del comportamiento de los usuarios), publicitarias (para la gestión de los espacios publicitarios en base a criterios como la frecuencia en la que se muestran los anuncios) y comportamentales (para la gestión de los espacios publicitarios según el perfil específico del usuario): si se desactivan estas cookies, el sitio web podrá seguir funcionando sin perjuicio funcional alguno.</ol></aside></div></div></div></div><style>ol {\r\n    padding: 7px 30px 20px;\r\n    list-style-type: decimal;\r\n  }\r\n\r\n  ol li {\r\n    margin-bottom: 13px;\r\n  }</style>";

/***/ },
/* 515 */
/***/ function(module, exports) {

	module.exports = "<div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-3 col-sm-4 col-xs-12\"></div><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li class=active><span>Preguntas frecuentes</span></ul></div></div></div></div><div class=container><div class=row><div class=col-md-12><div class=row><aside class=\"col-md-3 col-sm-4 col-xs-12 sidebar\"><categories-filter sh-ctrl=shCtrl ng-if=\"shCtrl.ngAuthSettings.site.config.redirectToB2bPage && !shCtrl.globals.currentUser.userId\"></categories-filter><side-banners sh-ctrl=shCtrl></side-banners></aside><div class=\"col-md-9 col-sm-8 col-xs-12 main-content\"><div ng-bind-html=\"shCtrl.globalParams.cmsInfo.FOOTER_PREGUNTAS_FRECUENTE | toTrusted\"></div></div></div></div></div></div><style>.preguntas-frecuentes .pregunta{ margin-bottom: 10px; }\r\n  .preguntas-frecuentes .pregunta span{ display: inline-block; background: #19232D; margin-right: 10px; padding: 2px 10px; color: #fff; }\r\n  .preguntas-frecuentes .respuesta{ padding: 0 15px; }</style>";

/***/ },
/* 516 */
/***/ function(module, exports) {

	module.exports = "<div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li class=active><span>Como comprar</span></ul></div></div></div></div><div class=container><div class=row><div class=col-md-12><div class=row><aside class=\"col-md-3 col-sm-4 col-xs-12 sidebar\"><categories-filter sh-ctrl=shCtrl ng-if=\"shCtrl.ngAuthSettings.site.config.redirectToB2bPage && !shCtrl.globals.currentUser.userId\"></categories-filter><side-banners sh-ctrl=shCtrl></side-banners></aside><div class=\"col-md-9 col-sm-8 col-xs-12 main-content\"><div ng-bind-html=\"shCtrl.globalParams.cmsInfo.COMO_COMPRAR | toTrusted\"></div></div></div></div></div></div>";

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li class=active><span>Página no encontrada</span></ul></div></div></div></div><div class=container><div class=row><div class=col-md-12><div class=\"row contenido-404\"><div class=md-margin></div><div class=\"col-md-5 col-sm-4 col-xs-12\"><img alt=\"banner 1\" src=" + __webpack_require__(536) + " class=img-responsive></div><div class=\"col-md-7 col-sm-8 col-xs-12\"><div class=\"sm-margin hidden-sm\"></div><div class=texto-404><div ng-bind-html=\"shCtrl.globalParams.cmsInfo.ERROR_404 | toTrusted\"></div><div class=sm-margin></div><div class=\"col-md-4 col-sm-4 col-xs-4 opc404\"><a ui-sref={{shCtrl.ngAuthSettings.site.app.header.logo.url}}><i class=\"fa fa-home\"></i> Página principal</a></div><div class=\"col-md-4 col-sm-4 col-xs-4 opc404\"><a ui-sref=home.category><i class=\"fa fa-cubes\"></i> Nuestros productos</a></div><div class=\"col-md-4 col-sm-4 col-xs-4 opc404 no-border\"><a ui-sref=home.contact><i class=\"fa fa-envelope\"></i> Formulario de contacto</a></div><div class=clear></div></div></div></div></div></div><div class=md-margin></div></div>";

/***/ },
/* 518 */
/***/ function(module, exports) {

	module.exports = "<div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li><span>Pagos y Anticipos</span><li><span>Anticipos</span><li class=active><span>Pedidos</span></ul></div></div></div></div><div class=container><div class=\"row media cabecera\"><div class=col-sm-6><span class=dropcap><img src=http://solucion-maestra.com/clientes/tablemac/produccion/images/consultas_ico.png alt=\"Consulta de estado de pedidos\"></span><h1>Documentos Anticipos / Cotizaciones</h1><p><strong>Nota</strong>: <em>Los documentos que se presentan a continuación corresponden a los últimos 6 meses</em></div><div class=col-sm-6><ul class=cabecera-adiciconal><li><strong>Razón Social:</strong> Nombre Razón Social<li><strong>Total valor pendiente de pago: </strong>$0</ul></div></div><div class=sm-margin></div><div class=\"row consultas\"><div class=\"col-xs-12 table-responsive\"><table class=\"table table-condensed table-bordered table-striped listado\"><col style=\"width: 9%\"><col style=\"width: 9%\"><col style=\"width: 10%\"><col style=\"width: 10%\"><col style=\"width: 10%\"><col style=\"width: 10%\"><col style=\"width: 10%\"><col style=\"width: 10%\"><col style=\"width: 10%\"><col style=\"width: 4%\"><thead><tr class=orders><th data-column=1>No. Doc.<th data-column=2>Tipo<th data-column=4>F. Elaboración<th data-column=6>F. Vencimiento<th data-column=7>Vendedor/Ejecutivo<th data-column=8>Vr. Saldo Doc.<th data-column=9>Vr. Pte. x pagar<th data-column=10>Vr. a pagar hoy<th data-column=11>Saldo Doc.<th data-column=11>Acciones<tbody><tr><td>NCN-000024<td>Lorem Ipsum<td>10/02/2017<td>10/02/2017<td>Lorem Ipsum<td class=text-right>$444.669.00<td class=text-right>$444.669.00<td class=text-right>$444.669.00<td class=text-right>$444.669.00<td><div class=btn-group><button type=button class=\"btn btn-default btn-sm dropdown-toggle\" data-toggle=dropdown aria-haspopup=true aria-expanded=false><i class=\"fa fa-bars\" aria-hidden=true></i></button><ul class=dropdown-menu><li><a href=#>Detalle</a><li><a href=#>Pagar</a></ul></div></table><div class=sm-margin></div><div class=\"btns-accion text-right\" style=\"padding: 0\"><button class=\"btn btn-danger\" data-toggle=modal data-target=#modal-cancelar>Cancelar <i class=\"fa fa-ban\" aria-hidden=true></i></button> <a href=./#/pagos/paso10 class=\"btn btn-custom-4\">Regresar <i class=\"fa fa-arrow-left\" aria-hidden=true></i></a></div></div></div></div>";

/***/ },
/* 519 */
/***/ function(module, exports) {

	module.exports = "<div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li><span>Pagos y Anticipos</span><li><span>Anticipos</span><li class=active><span>Orden de Compra</span></ul></div></div></div></div><div class=container><div class=\"row media cabecera\"><div class=col-sm-6><span class=dropcap><img src=http://solucion-maestra.com/clientes/tablemac/produccion/images/consultas_ico.png alt=\"Consulta de estado de pedidos\"></span><h1>Documentos Anticipos / Cotizaciones</h1><p><strong>Nota</strong>: <em>Los documentos que se presentan a continuación corresponden a los últimos 6 meses</em></div><div class=col-sm-6><ul class=cabecera-adiciconal><li><strong>Razón Social:</strong> Nombre Razón Social<li><strong>Total valor pendiente de pago: </strong>$0</ul></div></div><div class=sm-margin></div><div class=\"row consultas\"><div class=\"col-xs-12 table-responsive\"><table class=\"table table-condensed table-bordered table-striped listado\"><col style=\"width: 9%\"><col style=\"width: 9%\"><col style=\"width: 10%\"><col style=\"width: 10%\"><col style=\"width: 10%\"><col style=\"width: 10%\"><col style=\"width: 10%\"><col style=\"width: 10%\"><col style=\"width: 10%\"><col style=\"width: 4%\"><thead><tr class=purchase-order><th data-column=1>No. Doc.<th data-column=2>Tipo<th data-column=4>F. Elaboración<th data-column=6>F. Vencimiento<th data-column=7>Vendedor/Ejecutivo<th data-column=8>Vr. Saldo Doc.<th data-column=9>Vr. Pte. x pagar<th data-column=10>Vr. a pagar hoy<th data-column=11>Saldo Doc.<th data-column=11>Acciones<tbody><tr><td>NCN-000024<td>Lorem Ipsum<td>10/02/2017<td>10/02/2017<td>Lorem Ipsum<td class=text-right>$444.669.00<td class=text-right>$444.669.00<td class=text-right>$444.669.00<td class=text-right>$444.669.00<td><div class=btn-group><button type=button class=\"btn btn-default btn-sm dropdown-toggle\" data-toggle=dropdown aria-haspopup=true aria-expanded=false><i class=\"fa fa-bars\" aria-hidden=true></i></button><ul class=dropdown-menu><li><a href=#>Detalle</a><li><a href=#>Pagar</a></ul></div></table><div class=sm-margin></div><div class=\"btns-accion text-right\" style=\"padding: 0\"><button class=\"btn btn-danger\" data-toggle=modal data-target=#modal-cancelar>Cancelar <i class=\"fa fa-ban\" aria-hidden=true></i></button> <a href=./#/pagos/paso10 class=\"btn btn-custom-4\">Regresar <i class=\"fa fa-arrow-left\" aria-hidden=true></i></a></div></div></div></div>";

/***/ },
/* 520 */
/***/ function(module, exports) {

	module.exports = "<div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li><span>Pagos y Anticipos</span><li><span>Anticipos</span><li class=active><span>Cotizaciones</span></ul></div></div></div></div><div class=container><div class=\"row media cabecera\"><div class=col-sm-6><span class=dropcap><img src=http://solucion-maestra.com/clientes/tablemac/produccion/images/consultas_ico.png alt=\"Consulta de estado de pedidos\"></span><h1>Documentos Anticipos / Cotizaciones</h1><p><strong>Nota</strong>: <em>Los documentos que se presentan a continuación corresponden a los últimos 6 meses</em></div><div class=col-sm-6><ul class=cabecera-adiciconal><li><strong>Razón Social:</strong> Nombre Razón Social<li><strong>Total valor pendiente de pago: </strong>$0</ul></div></div><div class=sm-margin></div><div class=\"row consultas\"><div class=\"col-xs-12 table-responsive\"><table class=\"table table-condensed table-bordered table-striped listado\"><col style=\"width: 9%\"><col style=\"width: 9%\"><col style=\"width: 10%\"><col style=\"width: 10%\"><col style=\"width: 10%\"><col style=\"width: 10%\"><col style=\"width: 10%\"><col style=\"width: 10%\"><col style=\"width: 10%\"><col style=\"width: 4%\"><thead><tr class=quotations><th data-column=1>No. Doc.<th data-column=2>Tipo<th data-column=4>F. Elaboración<th data-column=6>F. Vencimiento<th data-column=7>Vendedor/Ejecutivo<th data-column=8>Vr. Saldo Doc.<th data-column=9>Vr. Pte. x pagar<th data-column=10>Vr. a pagar hoy<th data-column=11>Saldo Doc.<th data-column=11>Acciones<tbody><tr><td>NCN-000024<td>Lorem Ipsum<td>10/02/2017<td>10/02/2017<td>Lorem Ipsum<td class=text-right>$444.669.00<td class=text-right>$444.669.00<td class=text-right>$444.669.00<td class=text-right>$444.669.00<td><div class=btn-group><button type=button class=\"btn btn-default btn-sm dropdown-toggle\" data-toggle=dropdown aria-haspopup=true aria-expanded=false><i class=\"fa fa-bars\" aria-hidden=true></i></button><ul class=dropdown-menu><li><a href=#>Detalle</a><li><a href=#>Pagar</a></ul></div></table><div class=sm-margin></div><div class=\"btns-accion text-right\" style=\"padding: 0\"><button class=\"btn btn-danger\" data-toggle=modal data-target=#modal-cancelar>Cancelar <i class=\"fa fa-ban\" aria-hidden=true></i></button> <a href=./#/pagos/paso10 class=\"btn btn-custom-4\">Regresar <i class=\"fa fa-arrow-left\" aria-hidden=true></i></a></div></div></div></div>";

/***/ },
/* 521 */
/***/ function(module, exports) {

	module.exports = "<div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li class=active><span>Políticas de privacidad</span></ul></div></div></div></div><div class=container><div class=row><div class=col-md-12><div class=row><aside class=\"col-md-3 col-sm-4 col-xs-12 sidebar\"><categories-filter sh-ctrl=shCtrl ng-if=\"shCtrl.ngAuthSettings.site.config.redirectToB2bPage && !shCtrl.globals.currentUser.userId\"></categories-filter><side-banners sh-ctrl=shCtrl></side-banners></aside><div class=\"col-md-9 col-sm-8 col-xs-12 main-content\"><h1 class=title>Políticas de Privacidad</h1><hr><section><div class=col-md-12><p class=\"normal-text mrg-bot-15\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque egestas enim nec mauris accumsan sodales. Pellentesque tincidunt turpis ex, sit amet finibus purus luctus efficitur. Maecenas ut facilisis ipsum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec nec dolor vel velit pretium dictum ut ut lectus. Nunc accumsan dapibus malesuada. Maecenas egestas ipsum lobortis risus fermentum, in feugiat sem venenatis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Phasellus nisi odio, pretium porta ornare ut, ultricies quis massa. Cras rutrum odio elit, eget ornare sem tempus in. Maecenas vitae arcu in velit vehicula placerat vitae at nisi. Nam mollis eu quam in dignissim. Nulla ante neque, bibendum ut ex id, pellentesque rhoncus diam. Ut sodales aliquam augue quis porta. Nulla tincidunt turpis ut velit accumsan, sed fermentum magna condimentum. Curabitur mollis velit quam, at elementum arcu viverra quis. Aenean vel eros at odio tincidunt sodales. Donec id odio eu libero ornare porttitor. Etiam posuere sapien sapien, posuere pharetra eros porta at. Cras eleifend dapibus odio, non varius sapien ultrices ut. Duis sed imperdiet justo, tristique volutpat lectus. Praesent ultrices pellentesque commodo. Pellentesque nec libero id mi auctor vestibulum. Quisque id sem commodo ligula eleifend pharetra at a enim. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Sed et mi ligula. Maecenas rutrum magna sed lectus congue, non suscipit diam scelerisque. Nam aliquam tellus elit. Mauris sit amet velit metus. Aliquam ut tortor viverra, pretium mauris in, finibus nisi. Nullam dapibus nunc ut ligula condimentum, eu pulvinar enim scelerisque. Proin quis augue quis est tincidunt fermentum. Phasellus in lacinia felis. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Sed fringilla arcu leo, ac facilisis lectus tempor ac. Mauris ac enim a lacus pulvinar pharetra at quis tellus. Aenean eleifend, libero sed pellentesque aliquam, sapien lectus volutpat urna, et hendrerit lorem odio sed ligula. Aliquam dignissim viverra tellus, eu pretium libero. Sed interdum, lorem quis facilisis sollicitudin, ante lacus tempus dolor, sed porta turpis enim a ipsum. Phasellus vel est laoreet, accumsan odio nec, cursus dui. Duis vel dapibus orci, vel volutpat ligula. Suspendisse lacinia justo a tortor fringilla malesuada. Nulla interdum urna ut auctor fringilla. Nulla facilisi. Donec tempor est id accumsan hendrerit. Curabitur ac metus lacus. Nunc vel sem mauris. Morbi dignissim sagittis erat sed sagittis. Phasellus et erat sed purus placerat porttitor. Nunc sagittis semper leo, sit amet consequat urna dapibus eu. Aenean euismod tempor orci a auctor. Nulla eu libero iaculis, rhoncus magna sed, porta nisl. Donec facilisis, neque in vehicula maximus, elit arcu pharetra orci, ac hendrerit quam est condimentum enim. Vestibulum elementum, eros vel interdum imperdiet, lectus nisi tempor risus, nec fermentum enim mauris sed lorem. Aenean sed facilisis magna. Aenean tincidunt urna sed felis gravida, non finibus ipsum laoreet. Nunc justo nisl, tempus et ullamcorper in, dignissim quis arcu.</div><div class=clear></div></section></div></div></div></div></div>";

/***/ },
/* 522 */
/***/ function(module, exports) {

	module.exports = "<div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li class=active><span>Términos y condiciones</span></ul></div></div></div></div><div class=container><div class=row><div class=col-md-12><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12 main-content\"><div ng-bind-html=\"shCtrl.globalParams.cmsInfo.TERMINOS_Y_CONDICIONES | toTrusted\"></div></div></div></div></div></div>";

/***/ },
/* 523 */
/***/ function(module, exports) {

	module.exports = "<div class=\"toolbox-filter clearfix\" ng-show=\"$ctrl.products.length > 0 || $ctrl.fastSearch\"><div class=\"sort-box products-categories\"><div class=\"col-md-4 col-sm-6 col-xs-6 buscar\"><div class=row><span class=\"separator text-buscar\">Buscar:</span> <input class=boton-busqueda-productos ng-model=$ctrl.searchText placeholder=\"\" ng-enter=$ctrl.doFastSearch(searchText)> <input type=button ng-show=$ctrl.fastSearch ng-click=$ctrl.doFastSearch(searchText) class=\"btn btn-custom-4 btn-fast-search\" value=Buscar style=margin-left:5px></div></div><div class=\"col-md-4 col-sm-6 col-xs-6 vistas-pp\"><div class=row><ul><li class=btn-listado><a href=\"\" ng-click=\"$ctrl.setCookieItemsView('')\"></a><li class=\"btn-vista1 activa\" ng-click=$ctrl.setCookieItemsView(1)><a href=\"\"></a><li class=btn-vista2 ng-click=$ctrl.setCookieItemsView(2)><a href=\"\"></a><li class=btn-vista3 ng-click=$ctrl.setCookieItemsView(3)><a href=\"\"></a><li class=btn-vista4 ng-click=$ctrl.setCookieItemsView(4)><a href=\"\"></a><li class=btn-vista5 ng-click=$ctrl.setCookieItemsView(5)><a href=\"\"></a></ul></div></div><div class=\"col-md-4 col-sm-6 ordenar\"><div class=\"row pull-right\"><span class=\"separator text-ordenar\" ng-show=\"$ctrl.products.length > 0 && !$ctrl.fastLoadByLastProductsBought\">Ordenar:</span><div class=\"btn-group select-dropdown\" ng-show=\"$ctrl.products.length > 0 && !$ctrl.fastLoadByLastProductsBought\"><button type=button class=\"btn select-btn\" style=\"height: 31px\"><label style=\"position: relative;top: -4px\"><span ng-switch=$ctrl.sortType><span ng-switch-when=name>Productos </span><span ng-switch-when=currentPrice>Precio </span></span>- <span ng-show=\"$ctrl.sortType === 'name'\" ng-switch=$ctrl.sortReverse><span ng-switch-when=true>(Z-A)</span> <span ng-switch-when=false>(A-Z)</span> </span><span ng-show=\"$ctrl.sortType === 'currentPrice'\" ng-switch=$ctrl.sortReverse><span ng-switch-when=true>(descendente)</span> <span ng-switch-when=false>(ascendente)</span></span></label></button> <button type=button class=\"btn dropdown-toggle\" data-toggle=dropdown><i class=\"fa fa-angle-down\"></i></button><ul class=dropdown-menu role=menu><li><a ng-click=\"$ctrl.sortType = 'name'; $ctrl.sortReverse = false;\">Productos (A-Z)</a><li><a ng-click=\"$ctrl.sortType = 'name'; $ctrl.sortReverse = true;\">Productos (Z-A)</a><li><a ng-click=\"$ctrl.sortType = 'currentPrice'; $ctrl.sortReverse = false;\">Precio (ascendente)</a><li><a ng-click=\"$ctrl.sortType = 'currentPrice'; $ctrl.sortReverse = true;\">Precio (descendente)</a></ul></div></div></div></div></div>";

/***/ },
/* 524 */
/***/ function(module, exports) {

	module.exports = "<div class=\"toolbox-pagination clearfix\"><div class=view-count-box><div class=\"col-lg-6 col-xs-6\"><div class=row><span class=separator>Ver:</span><div class=\"btn-group select-dropdown\"><button type=button class=\"btn select-btn\">{{ $ctrl.itemsPerPage }}</button> <button type=button class=\"btn dropdown-toggle\" data-toggle=dropdown><i class=\"fa fa-angle-down\"></i></button><ul class=dropdown-menu role=menu><li><a href=\"\" ng-click=$ctrl.setPagination($ctrl.products.length);>Todos ({{$ctrl.products.length}})</a><li><a href=\"\" ng-click=$ctrl.setPagination(12);>12</a><li><a href=\"\" ng-click=$ctrl.setPagination(24);>24</a><li><a href=\"\" ng-click=$ctrl.setPagination(40);>40</a></ul></div></div></div><div class=\"col-lg-6 col-xs-6\"><div class=\"row pull-right\"><ul class=\"pagination-control pagination-prev\" ng-if=\"$ctrl.pagination.numPages > 4\"><li><a href=\"\" ng-click=\"$ctrl.pagination.prevPage(); $ctrl.updatePaginationPosition()\">&laquo;</a></ul><ul class=\"pagination-control pagination-prev\" ng-if=\"$ctrl.pagination.numPages <= 4\"><li><a href=\"\" ng-click=$ctrl.pagination.prevPage();>&laquo;</a></ul><div class=pagination-items><ul><li ng-repeat=\"n in [] | range: $ctrl.pagination.numPages\" ng-class=\"{active: n == $ctrl.pagination.page}\"><a href=\"\" ng-click=$ctrl.pagination.toPageId(n)>{{n + 1}}</a></ul></div><ul class=\"pagination-control pagination-next pull-right\" ng-if=\"$ctrl.pagination.numPages > 4\"><li><a href=\"\" ng-click=\"$ctrl.pagination.nextPage(); $ctrl.updatePaginationPosition()\">&raquo;</a></ul><ul class=\"pagination-control pagination-next pull-right\" ng-if=\"$ctrl.pagination.numPages <= 4\"><li><a href=\"\" ng-click=$ctrl.pagination.nextPage();>&raquo;</a></ul></div></div></div></div><style type=text/css>.pagination-items {\r\n    float: left;\r\n    width: auto;\r\n    min-width: 35px;\r\n    height: 30px;\r\n    overflow: hidden;\r\n    max-width: 216px;\r\n  }\r\n\r\n  .pagination-items ul li {\r\n  \tfloat: left;\r\n  }\r\n\r\n  .pagination-items ul li a,\r\n  .pagination-control.pagination-prev a,\r\n  .pagination-control.pagination-next a{\r\n    background-color: #EEE !important;\r\n    color: #444 !important;\r\n    display: block;\r\n    width: 35px;\r\n    text-align: center;\r\n    height: 30px;\r\n    padding-top: 4px;\r\n  }\r\n\r\n  .pagination-items ul li a:hover,\r\n  .pagination-control.pagination-prev a:hover,\r\n  .pagination-control.pagination-next a:hover {\r\n      background-color: #555 !important;\r\n    \tcolor: white !important;\r\n  }\r\n\r\n  .pagination-items .active > a {\r\n  \tbackground-color: #f55f00 !important;\r\n    color: white !important;\r\n  }\r\n\r\n  .pagination-items ul {\r\n    width: auto;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .pagination-control.pagination-prev,\r\n  .pagination-control.pagination-next {\r\n  \tfloat: left;\r\n  }</style>";

/***/ },
/* 525 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div id=category-filter class=\"panel-group custom-accordion sm-accordion acc-nuestros-productos inicio\"><div class=\"widget reversebg\"><h3>MENÚ</h3><div class=\"panel-group custom-accordion\"><div class=panel><div class=accordion-header><div class=accordion-title><a ui-sref=home.providersControlPanel>INICIO</a></div></div></div><div class=panel><div class=accordion-header><div class=accordion-title><a href=./#/proveedores/pagos-programados>PAGOS PROGRAMADOS</a></div></div></div><div class=panel><div class=accordion-header><div class=accordion-title><a href=./#/proveedores/pagos-realizados>PAGOS REALIZADOS</a></div></div></div><div class=panel><div class=accordion-header><div class=accordion-title><a href=./#/proveedores/notas-credito>NOTAS</a></div></div></div><div class=panel><div class=accordion-header><div class=accordion-title><a href=./#/proveedores/mi-cuenta>MIS DATOS</a></div></div></div><div class=panel><div class=accordion-header><div class=accordion-title><a ng-click=$ctrl.shCtrl.logout()>SALIR</a></div></div></div></div></div></div></div><style type=text/css>.titulo-pagina-sub {\r\n    color: initial;\r\n    margin-bottom: 0;\r\n    font-size: 15px;\r\n  }\r\n\r\n  .titulo-pagina-sub small {\r\n    color: #24B700;\r\n    font-size: 15px;\r\n  }</style>";

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{$ctrl.shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li><a ui-sref=home.orders>Mis Pedidos</a><li><a ui-sref=home.dashboard>Panel de Control</a><li><a ui-sref=home.templates>Mis Plantillas</a><li class=active><span>Plantilla # {{$ctrl.template.id}}</span></ul></div></div></div></div><div class=\"container loader-general\" ng-show=$ctrl.loadingTemplate style=\"margin-top:10px; margin-bottom: 10px;text-align:center\"><img src=" + __webpack_require__(2) + "> <span style=float:none>Cargando la plantilla...</span></div><div class=container ng-show=!$ctrl.loadingTemplate><div class=row><div class=col-md-12><div class=\"row detalles-pedido-titulo\"><div class=\"col-md-offset-8 col-sm-4\" ng-show=$ctrl.shCtrl.globals.currentUser.userId><a class=\"btn btn-custom-4 btn-sm volver-pedidos\" title=\"Volver a mis plantillas\" ui-sref=home.templates><i class=\"fa fa-arrow-circle-left\"></i> <strong>Volver a mis plantillas</strong></a></div></div><div class=clear></div><div class=md-margin></div><div class=detalles-pedidos><div class=col-md-12><div class=table-responsive><table class=\"table cart-table tb-cotizacion\" style=min-width:800px><thead><tr><th class=table-title style=width:5%>No.<th class=table-title style=width:25%>Nombre Plantilla<th class=table-title style=width:25%>Nombre Empresa<th class=table-title style=width:25%>Nombre Contacto<th class=table-title style=width:20%>Fecha Creación<tbody><td class=text-center>{{$ctrl.template.header.id}}<td class=text-left>{{$ctrl.template.header.nombre_plantilla}}<td class=text-left>{{$ctrl.template.header.nombre_tercero}}<td class=text-left>{{$ctrl.template.header.nombre_contacto}}<td class=text-center>{{$ctrl.template.header.fecha_creacion}}</table></div><hr><div class=table-responsive><table class=\"table cart-table tb-cotizacion\" style=min-width:800px><thead><tr><th class=table-title style=\"width: 1%\"><i class=\"fa fa-check-square-o\" aria-hidden=true></i><th class=table-title style=\"width: 50%\">ITEM<th class=table-title style=\"width: 20%\">REF.<th class=table-title style=\"width: 15%\">U.M.<th class=table-title style=\"width: 15%\">CANT.<tbody><tr ng-repeat=\"item in $ctrl.template.items\"><td>{{$index + 1}}<td class=text-left><a ui-sref=\"home.productDetailId(productId : item.id)\" title={{item.name}}>{{item.name}}</a><td>{{item.reference}}<td>{{item.measureUnit}}<td>{{item.quantity}}</table></div></div></div></div><div class=clear></div><div class=md-margin></div></div></div>";

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{$ctrl.shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li class=active><span>Mis plantillas</span></ul></div></div></div></div><div class=container><div class=\"row confirmacion-registro\" style=margin-bottom:20px ng-show=\"$ctrl.loadedUserCartTemplates && !$ctrl.userCartTemplates.templates.length\"><div class=\"col-md-9 col-sm-8\" style=margin-top:15px><h3>Historial de Mis Plantillas | <small>{{$ctrl.userCartTemplates.templates.length}} plantilla(s)</small></h3><hr><p>Aún no ha creado ninguna plantilla.<p>¿Qué desea hacer ahora?<div class=deseas-hacer><a class=\"btn botones-acciones btn-default\" ui-sref=home.category role=button><i class=\"fa fa-cart-arrow-down\"></i> <strong>Comenzar a comprar </strong></a><a class=\"btn botones-acciones btn-default\" ui-sref=home.contact role=button><i class=\"fa fa-user\"></i> <strong>Servicio al cliente</strong></a></div></div><div class=\"col-md-3 col-sm-4 hidden-xs\"><img src=" + __webpack_require__(23) + " class=\"img-responsive asesora\" alt=\"Mujer asesora\"></div></div><div class=loader-general ng-show=$ctrl.loading$ctrl.userCartTemplates style=margin-top:10px><img src=" + __webpack_require__(2) + "> <span>Espere un momento mientras se cargan las plantillas creadas...</span></div><div class=\"alert alert-danger\" style=margin-bottom:20px ng-show=$ctrl.errorloading$ctrl.userCartTemplates>Ha ocurrido un error al cargar las plantillas. Por favor contacte al administrador del sistema.</div><div class=\"row barra-mis-cotizaciones\" ng-show=$ctrl.userCartTemplates.templates.length><div class=\"col-lg-12 col-md-12 col-xs-12\"><div class=\"category-toolbar top clearfix\" ng-show=\"$ctrl.userCartTemplates.templates.length > 0\"><div id=filtros-top-cotizacion><div class=\"toolbox-filter clearfix\"><div class=\"col-md-2 search-cotizacion\"><div class=row><input ng-model=$ctrl.searchText placeholder=Buscar> <i id=buscar-filtrar class=\"fa fa-search\"></i></div></div><div class=col-md-4><span class=separator ng-show=$ctrl.userCartTemplatesFiltered.length>Ordenar:</span><div class=\"btn-group select-dropdown\" ng-show=$ctrl.userCartTemplatesFiltered.length><button type=button class=\"btn select-btn\"><label><span ng-switch=$ctrl.sortType><span ng-switch-when=fecha_creacion>Fecha </span></span>- <span ng-show=\"$ctrl.sortType === 'fecha_creacion'\" ng-switch=$ctrl.sortReverse><span ng-switch-when=true>(descendente)</span> <span ng-switch-when=false>(ascendente)</span></span></label></button> <button type=button class=\"btn dropdown-toggle\" data-toggle=dropdown><i class=\"fa fa-angle-down\"></i></button><ul class=dropdown-menu role=menu><li><a href=# onclick=\"return false\" ng-click=\"$ctrl.sortType='fecha_creacion'; $ctrl.sortReverse=false;\">Fecha Creación (ascendente)</a><li><a href=# onclick=\"return false\" ng-click=\"$ctrl.sortType='fecha_creacion'; $ctrl.sortReverse=true;\">Fecha Creación (descendente)</a></ul></div></div><div class=col-md-2><div id=paginacion-listado-top ng-show=$ctrl.userCartTemplatesFiltered.length><div class=\"toolbox-pagination clearfix\"><div class=row><div class=view-count-box><span class=separator>Ver:</span><div class=\"btn-group select-dropdown\"><button type=button class=\"btn select-btn\">{{ $ctrl.itemsPerPage }}</button> <button type=button class=\"btn dropdown-toggle\" data-toggle=dropdown><i class=\"fa fa-angle-down\"></i></button><ul class=dropdown-menu role=menu><li><a href=\"\" ng-click=$ctrl.setPagination($ctrl.userCartTemplates.templates.length);>Todos ({{$ctrl.userCartTemplates.templates.length}})</a><li><a href=\"\" ng-click=$ctrl.setPagination(10);>10</a><li><a href=\"\" ng-click=$ctrl.setPagination(20);>20</a><li><a href=\"\" ng-click=$ctrl.setPagination(30);>30</a></ul></div></div></div></div></div></div><div class=\"col-md-3 text-right\"><ul class=pagination><li><a href=\"\" ng-click=$ctrl.pagination.prevPage()>&laquo;</a><li ng-repeat=\"n in [] | range: $ctrl.pagination.numPages\" ng-class=\"{active: n == $ctrl.pagination.page}\"><a href=\"\" ng-click=$ctrl.pagination.toPageId(n)>{{n + 1}}</a><li><a href=\"\" ng-click=$ctrl.pagination.nextPage()>&raquo;</a></ul></div><div class=col-md-1><div class=row style=\"float: right\"><div class=\"filter-resume pull-left\" ng-show=$ctrl.userCartTemplatesFiltered.length>{{$ctrl.pagination.page*$ctrl.itemsPerPage + 1}} - <span ng-show=\"$ctrl.pagination.page*$ctrl.itemsPerPage + $ctrl.itemsPerPage < $ctrl.userCartTemplates.templates.length\">{{$ctrl.pagination.page*$ctrl.itemsPerPage + $ctrl.itemsPerPage}} </span><span ng-show=\"$ctrl.pagination.page*$ctrl.itemsPerPage + $ctrl.itemsPerPage >= $ctrl.userCartTemplates.templates.length\">{{$ctrl.userCartTemplates.templates.length}} </span>de {{$ctrl.userCartTemplates.templates.length}}</div></div></div></div></div><div class=\"clear hidden-lg hidden-md\"></div></div><div class=clear></div><div class=row><div class=col-md-12><h2 class=text-center>Gestión de Plantillas</h2></div></div><div class=xs-margin></div><div class=\"row tabla-mis-cotizaciones\" ng-show=$ctrl.userCartTemplatesFiltered.length><div class=col-md-12><div class=table-responsive><table class=table style=min-width:800px><thead><tr><th style=\"width: 20%\">Nombre Plantilla<th style=\"width: 20%\">Nombre Empresa<th style=\"width: 25%\">Nombre Contacto<th style=\"width: 10%\">F. Creación<th style=\"width: 15%\"><tbody><tr ng-repeat=\"template in $ctrl.userCartTemplatesFiltered =\r\n                                                            ($ctrl.userCartTemplates.templates\r\n                                                    | filter:$ctrl.searchText\r\n                                                    | filter: $ctrl.searchClientName.length && $ctrl.searchClientName\r\n                                                    | orderBy:$ctrl.sortType:$ctrl.sortReverse\r\n                                                    | startFrom: $ctrl.pagination.page * $ctrl.pagination.perPage\r\n                                                    | limitTo: $ctrl.pagination.perPage)\"><td style=\"text-align: left\">{{template.nombre_plantilla}}<td style=\"text-align: left\">{{template.nombre_tercero}}<td style=\"text-align: left\">{{template.nombre_contacto}}<td style=\"text-align: center\">{{template.fecha_creacion}}<td class=\"text-left acciones\"><div class=btn-group><a class=\"btn btn-default\" ui-sref=\"home.templateDetail({templateId : template.id})\" title=\"Ver plantilla No. {{template.id}}\">Detalle </a><button ng-if=!template.duplicate.duplicated data-toggle=dropdown class=\"btn btn-default dropdown-toggle\" type=button><span class=caret></span> <span class=sr-only>Toggle Dropdown</span></button><ul role=menu class=dropdown-menu ng-if=!template.duplicate.duplicated><li><a ng-click=$ctrl.loadCartTemplateToCurrentCart(template)>Cargar</a><li><a ng-click=$ctrl.deleteCartTemplate(template)>Eliminar</a></ul><i class=\"fa fa-history load-animation product-is-setting-as-favorite\" ng-show=template.duplicate.duplicating style=\"font-size: 15px;\r\n                                      margin-left: 9px;margin-top: 5px;cursor:pointer\"></i> <i class=\"fa fa-check\" title=\"La plantilla no. {{template.id}} ha sido duplicado.\" ng-show=template.duplicate.duplicated style=\"color: green;font-size: 20px;\r\n                                      margin-left: 9px;margin-top: 1px;cursor:pointer\"></i> <i class=\"fa fa-times\" title=\"Ha ocurrido un error al duplicar la plantilla no. {{template.id}}.\" ng-show=template.duplicate.error style=\"color: red;font-size: 20px;\r\n                                      margin-left: 9px;margin-top: 1px;cursor:pointer\"></i></div></table></div></div></div><div class=row><div class=\"alert alert-warning\" ng-show=!$ctrl.userCartTemplatesFiltered.length>No hay plantillas que coincidan con las palabras digitadas. Por favor inténtelo nuevamente.</div></div></div></div><div class=md-margin></div></div>";

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{$ctrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li class=active><span>Tunel</span></ul></div></div></div></div><div class=\"wrapper-container page page-tunnel\"><div class=container ng-show=\"!$ctrl.ngAuthSettings.site.config.data.tunnel.hasGangway && $ctrl.orderSaved\" style=font-size:14px><div class=\"col-md-9 col-sm-8\" style=\"margin-top: 15px\"><h3><span ng-show=$ctrl.cartOrderCreated>Pedido generado </span><span ng-show=$ctrl.cartQuoteCreated>Solicitud de cotización generada</span><hr><p ng-show=$ctrl.cartOrderCreated style=\"font-size: 13px\">Su pedido ha sido creado exitosamente. Para más detalles puede revisar la copia enviada a su correo electrónico o haga clic <a ui-sref=\"home.orderId({orderId : $ctrl.orderIdSaved})\" title=\"Ver pedido\">aquí</a>.<p ng-show=$ctrl.cartQuoteCreated style=\"font-size: 13px\">Su solicitud de cotización ha sido creada exitosamente. Para más detalles puede revisar la copia enviada a su correo electrónico.<p style=\"font-size: 13px\">¿Qué desea hacer ahora?<div class=deseas-hacer><a class=\"btn botones-acciones btn-default\" ui-sref=home.category role=button><i class=\"fa fa-cart-arrow-down\"></i> <strong ng-show=$ctrl.cartOrderCreated>Seguir Comprando </strong><strong ng-show=$ctrl.cartQuoteCreated>Seguir Cotizando </strong></a><a class=\"btn botones-acciones btn-default\" ui-sref=home.contact role=button><i class=\"fa fa-user\"></i> <strong>Servicio al cliente</strong></a></div></h3></div><div class=\"col-md-3 col-sm-4 hidden-xs\"><img src=" + __webpack_require__(23) + " class=\"img-responsive asesora\" alt=\"Mujer asesora\"></div></div><div class=container ng-show=!$ctrl.orderSaved><div class=wrapper-loading-animation ng-show=$ctrl.tunnelDataForm.loadingCartInfo><i ng-class=\"{'fa fa-history load-animation': $ctrl.tunnelDataForm.loadingCartInfo, 'fa fa-history': !$ctrl.tunnelDataForm.loadingCartInfo}\"></i> <span ng-show=$ctrl.shCtrl.globals.currentUser.userId>Cargando información de la canasta</span> <span ng-show=!$ctrl.shCtrl.globals.currentUser.userId>Dirigiendo a la página de Login</span></div><div class=row ng-show=\"(($ctrl.shCtrl.globals.currentUser.userId || $ctrl.allowGuestInTunnel) && $ctrl.tunnelDataForm.loadedCartInfo)\"><div class=col-md-12><header ng-if=!$ctrl.orderIdInsideTunnel><h1 class=title>Hola {{$ctrl.shCtrl.globals.currentUser.fullname}}, esta es su confirmación de <span ng-show=\"$ctrl.cart.order.totalItemsToQuote !== $ctrl.cart.items.length\">pedido</span> <span ng-show=\"$ctrl.cart.order.totalItemsToQuote === $ctrl.cart.items.length\">cotización</span></h1><p>Confirme la información de los siguientes pasos para continuar con el proceso de <span ng-show=\"$ctrl.cart.order.totalItemsToQuote !== $ctrl.cart.items.length\">compra:</span> <span ng-show=\"$ctrl.cart.order.totalItemsToQuote === $ctrl.cart.items.length\">cotización:</span></header><header class=content-title ng-if=$ctrl.orderIdInsideTunnel><h1 class=title>Hola {{$ctrl.shCtrl.globals.currentUser.fullname}}, esta es la información de su pedido No. <a ui-sref=\"home.orderId({orderId : $ctrl.orderIdInsideTunnel})\" target=_blank title=\"Ver detalle del pedido No. {{$ctrl.orderIdInsideTunnel}}\">{{$ctrl.orderIdInsideTunnel}} </a>, para el cual no se ha finalizado el proceso de compra</h1><p>Confirme la información de los siguientes pasos para continuar con el proceso de finalizacíón de la compra:</header></div></div><div class=\"row pasos-pedido\" ng-show=\"(($ctrl.shCtrl.globals.currentUser.userId || $ctrl.allowGuestInTunnel) && $ctrl.tunnelDataForm.loadedCartInfo)\"><div class=col-md-12><div class=xs-margin></div><div class=\"row tunnel_new\"><form id=tunel-step2-form name=$ctrl.tunnelStep2Form novalidate><div class=\"col-md-4 col-xs-12\"><div class=\"panel panel-default resumen-canasta\"><div class=panel-heading>Resumen de la Compra</div><div class=\"panel-body form-horizontal\"><div class=form-group><label class=\"col-sm-4 col-xs-6 control-label\">Subtotal</label><div class=col-sm-8><p class=form-control-static>$ {{$ctrl.cart.cartSubtotal | currency:'':0}}</div></div><div class=form-group ng-show=$ctrl.cart.cartDiscounts><label class=\"col-sm-4 col-xs-6control-label\">Descuentos</label><div class=col-sm-8><p class=form-control-static>$ {{$ctrl.cart.cartDiscounts | currency:'':0}}</div></div><div class=form-group><label class=\"col-sm-4 col-xs-6 control-label\">IVA</label><div class=col-sm-8><p class=form-control-static>$ {{$ctrl.cart.cartTaxes | currency:'':0}}</div></div><div class=form-group><label class=\"col-sm-4 col-xs-6 control-label\">Preliquidación</label><div class=col-sm-8><p class=form-control-static>$ {{$ctrl.cart.cartTotal - cartTransports | currency:'':0}}</div></div><div class=form-group><label class=\"col-sm-4 col-xs-6 control-label\">Transporte</label><div class=col-sm-8><p class=form-control-static>$ {{$ctrl.cart.cartTransports | currency:'':0}}</div></div><div class=form-group><label class=\"col-sm-4 col-xs-6 control-label destacar\">Total a Pagar</label><div class=col-sm-8><p class=\"form-control-static destacar\">$ {{$ctrl.cart.cartTotal | currency:'':0}}</div></div></div></div></div><div class=\"col-md-4 col-xs-12\" ng-if=!$ctrl.shCtrl.globalParams.solicitarInfoTransporte><div class=\"panel panel-default\"><div class=panel-heading>Información de Despacho</div><div class=\"panel-body form-horizontal\"><div class=form-group><label class=\"col-sm-4 control-label\">Dirección*</label><div class=col-sm-8><input ng-if=!$ctrl.shCtrl.globals.currentUser.isB2B title=\"Por favor ingrese la dirección de despacho\" placeholder=\"Ingrese su dirección\" class=\"form-control input-sm\" id=contactAddressDelivery name=contactAddressDelivery ng-model=$ctrl.tunnelStep2FormData.contactAddressDelivery ng-blur=\"$ctrl.copyDataIntoBilling('address', $ctrl.tunnelStep2FormData.contactAddressDelivery)\" ng-disabled=$ctrl.orderIdInsideTunnel required> <input ng-if=\"!$ctrl.cart.tunnel.operatingCentersAddresses.length && $ctrl.shCtrl.globals.currentUser.isB2B\" title=\"Por favor ingrese la dirección de despacho\" placeholder=\"Ingrese su dirección\" class=\"form-control input-sm\" id=contactAddressDelivery name=contactAddressDelivery ng-model=$ctrl.tunnelStep2FormData.contactAddressDelivery ng-blur=\"$ctrl.copyDataIntoBilling('address', $ctrl.tunnelStep2FormData.contactAddressDelivery)\" disabled required><select class=form-control ng-if=\"$ctrl.cart.tunnel.operatingCentersAddresses.length && $ctrl.shCtrl.globals.currentUser.isB2B\" id=contactAddressDelivery name=contactAddressDelivery title=\"Por favor ingrese la dirección de despacho\" placeholder=\"Ingrese su dirección\" ng-model=$ctrl.tunnelStep2FormData.contactAddressDelivery ng-options=\"operatinCenter.address as operatinCenter.address for operatinCenter in $ctrl.cart.tunnel.operatingCentersAddresses\" ng-change=\"$ctrl.copyDataIntoBilling('address', $ctrl.tunnelStep2FormData.contactAddressDelivery)\" ng-disabled=\"$ctrl.orderIdInsideTunnel || $ctrl.loadingCountries || $ctrl.loadingSavingOrder || $ctrl.savingTunnelData\" required><option value=\"\">Seleccione la dirección de despacho</select><input type=hidden value=guardarInfoDespacho name=opcion> <span ng-show=\"$ctrl.tunnelStep2Form.contactAddressDelivery.$invalid &&\r\n                                    !$ctrl.tunnelStep2Form.contactAddressDelivery.$pristine\" class=help-block>Ingrese su dirección.</span></div></div><div class=form-group><label class=\"col-sm-4 control-label\">Ciudad*</label><div class=col-sm-8><input readonly class=\"form-control input-sm\" ng-model=$ctrl.contactCityDelivery></div></div><div class=form-group><label class=\"col-sm-4 control-label\">Departamento*</label><div class=col-sm-8><input readonly class=\"form-control input-sm\" ng-model=$ctrl.contactStateDelivery></div></div><div class=form-group><label class=\"col-sm-4 control-label\">País*</label><div class=col-sm-8><input readonly class=\"form-control input-sm\" ng-model=$ctrl.contactCountryDelivery></div></div><div class=\"form-group neighborhood\" style=display:none><label class=\"col-sm-4 control-label\">Barrio</label><div class=col-sm-8><input title=\"Por favor ingrese el nombre del barrio de la dirección de despacho\" placeholder=\"Ingrese su barrio\" class=\"form-control input-sm\" id=contactNeighborhoodDelivery name=contactNeighborhoodDelivery ng-model=$ctrl.tunnelStep2FormData.contactNeighborhoodDelivery ng-blur=\"$ctrl.copyDataIntoBilling('neighborhood', $ctrl.tunnelStep2FormData.contactNeighborhoodDelivery)\" ng-disabled=\"$ctrl.orderIdInsideTunnel || $ctrl.loadingSavingOrder || $ctrl.savingTunnelData\"> <span ng-show=\"$ctrl.tunnelStep2Form.contactNeighborhoodDelivery.$invalid &&\r\n                                    !$ctrl.tunnelStep2Form.contactNeighborhoodDelivery.$pristine\" class=help-block>Ingrese su barrio.</span></div></div><div class=\"form-group building-delivery\" style=display:none><label class=\"col-sm-4 control-label\">No. Apto/Casa</label><div class=col-sm-8><input placeholder=\"Ingrese su condominio\" class=\"form-control input-sm\" id=contactBuildingDelivery name=contactBuildingDelivery ng-model=$ctrl.tunnelStep2FormData.contactBuildingDelivery ng-blur=\"$ctrl.copyDataIntoBilling('building', $ctrl.tunnelStep2FormData.contactBuildingDelivery)\" ng-disabled=\"$ctrl.orderIdInsideTunnel || $ctrl.loadingSavingOrder || $ctrl.savingTunnelData\"></div></div><div class=\"form-group aparment-delivery\" style=display:none><label class=\"col-sm-4 control-label\">Edificio/Condominio</label><div class=col-sm-8><input placeholder=Apto/Casa class=\"form-control input-sm\" id=contactAparmentDelivery name=contactAparmentDelivery ng-model=$ctrl.tunnelStep2FormData.contactAparmentDelivery ng-blur=\"$ctrl.copyDataIntoBilling('aparment', $ctrl.tunnelStep2FormData.contactAparmentDelivery)\" ng-disabled=\"$ctrl.orderIdInsideTunnel  || $ctrl.loadingSavingOrder || $ctrl.savingTunnelData\"></div></div></div></div></div><div class=\"col-md-4 col-xs-12\" ng-if=$ctrl.shCtrl.globalParams.solicitarInfoTransporte><div class=\"panel panel-default\"><div class=panel-heading>Información del Conductor</div><div class=\"panel-body form-horizontal\"><div class=form-group><label class=\"col-sm-4 control-label\">Conductor*</label><div class=col-sm-8><input id=nombre name=nombre ng-disabled=\"$ctrl.loadingSavingOrder || $ctrl.savingTunnelData\" class=\"form-control input-sm\" ng-model=$ctrl.cart.order.vehiculo_transporte.nombre_conductor required> <span class=input-help><span ng-if=\"$ctrl.tunnelStep2Form.nombre.$invalid && !$ctrl.tunnelStep2Form.nombre.$pristine\" class=help-block>Ingrese el nombre el conductor</span></span></div></div><div class=form-group><label class=\"col-sm-4 control-label\">Cédula*</label><div class=col-sm-8><input id=cedula name=cedula class=\"form-control input-sm\" ng-disabled=\"$ctrl.loadingSavingOrder || $ctrl.savingTunnelData\" ng-model=$ctrl.cart.order.vehiculo_transporte.documento_conductor required> <span class=input-help><span ng-if=\"$ctrl.tunnelStep2Form.cedula.$invalid && !$ctrl.tunnelStep2Form.cedula.$pristine\" class=help-block>Ingrese una cedula</span></span></div></div><div class=form-group><label class=\"col-sm-4 control-label\">Placa Vehículo*</label><div class=col-sm-8><input maxlength=6 minlength=6 id=placa_vehiculo name=placa_vehiculo class=\"form-control input-sm\" ng-disabled=\"$ctrl.loadingSavingOrder || $ctrl.savingTunnelData\" ng-model=$ctrl.cart.order.vehiculo_transporte.placa_vehiculo required> <span class=input-help><span ng-if=\"$ctrl.tunnelStep2Form.placa_vehiculo.$invalid && !$ctrl.tunnelStep2Form.placa_vehiculo.$pristine\" class=help-block>Ingrese una placa correcta</span></span></div></div><div class=form-group><label class=\"col-sm-4 control-label\">Fecha Cargue*</label><div class=col-sm-8><input data-provide=datepicker data-date-format=yyyy-mm-dd data-date-start-date=0d data-date-calendar-weeks=false data-date-clear-btn=true data-date-today-btn=linked data-date-today-highlight=true ng-disabled=\"$ctrl.loadingSavingOrder || $ctrl.savingTunnelData\" data-date-days-of-week-disabled=false data-date-keyboard-navigation=true class=\"form-control input-sm\" id=fecha_cargue name=fecha_cargue ng-model=$ctrl.cart.order.vehiculo_transporte.fecha_cargue><label class=\"glyphicon glyphicon-calendar form-control-feedback\" aria-hidden=true for=fecha_cargue style=\"top:2px; right: 13px\"></label></div></div></div></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-heading>Información de Contacto del Pedido</div><div class=\"panel-body form-horizontal\"><div class=form-group ng-if=$ctrl.allowGuestInTunnel><label class=\"col-sm-4 control-label\" disabled>Cédula* <i ng-show=$ctrl.loadingTunnelContactInfo class=\"fa fa-history load-animation\"></i></label><div class=col-sm-8><input restrict-type=num title=\"cédula de contacto\" name=contactIdNumber placeholder=\"Ingrese el número de cédula de contacto\" class=\"form-control input-sm\" ng-model=$ctrl.tunnelStep2FormData.contactIdNumber ng-disabled=\"$ctrl.loadingTunnelContactInfo || $ctrl.loadingSavingOrder || $ctrl.savingTunnelData\" ng-maxlength=15 required> <span ng-show=\"$ctrl.tunnelStep2Form.contactIdNumber.$invalid &&\r\n                                    !$ctrl.tunnelStep2Form.contactIdNumber.$pristine\" class=help-block>Ingrese el número de cédula del contacto. </span><span ng-show=$ctrl.tunnelStep2Form.contactIdNumber.$error.maxlength class=help-block>Ingrese un numero máximo de 10 dígitos.</span></div></div><div class=form-group ng-if=$ctrl.allowGuestInTunnel><label class=\"col-sm-4 control-label\">Nombre(s)*</label><div class=col-sm-8><input title=\"Por favor ingrese el nombre completo de la persona de contacto\" name=contactName placeholder=\"Ingrese el nombre completo de la persona de contacto\" class=\"form-control input-sm\" ng-model=$ctrl.tunnelStep2FormData.contactName ng-disabled=\"$ctrl.orderIdInsideTunnel || $ctrl.loadingTunnelContactInfo || $ctrl.loadedTunnelValidContactInfo || $ctrl.loadingSavingOrder || $ctrl.savingTunnelData\" required> <span ng-show=\"$ctrl.tunnelStep2Form.contactName.$invalid &&\r\n                                    !$ctrl.tunnelStep2Form.contactName.$pristine\" class=help-block>Ingrese el nombre completo de la persona de contacto.</span></div></div><div class=form-group ng-if=$ctrl.allowGuestInTunnel><label class=\"col-sm-4 control-label\">Apellido(s)*</label><div class=col-sm-8><input title=\"Por favor ingrese los apellidos de la persona de contacto\" name=contactLastname placeholder=\"Ingrese los apellidos de la persona de contacto\" class=\"form-control input-sm\" ng-model=$ctrl.tunnelStep2FormData.contactLastname ng-disabled=\"$ctrl.orderIdInsideTunnel || $ctrl.loadingTunnelContactInfo || $ctrl.loadedTunnelValidContactInfo || $ctrl.loadingSavingOrder || $ctrl.savingTunnelData\" required> <span ng-show=\"$ctrl.tunnelStep2Form.contactLastname.$invalid &&\r\n                                    !$ctrl.tunnelStep2Form.contactLastname.$pristine\" class=help-block>Ingrese los apellidos de la persona de contacto.</span></div></div><div class=form-group ng-if=!$ctrl.allowGuestInTunnel><label class=\"col-sm-4 control-label\">Nombre*</label><div class=col-sm-8><input title=\"Por favor ingrese el nombre de la persona de contacto\" name=contactName placeholder=\"Ingrese el nombre de la persona de contacto\" class=\"form-control input-sm\" ng-model=$ctrl.tunnelStep2FormData.contactName ng-disabled=\"$ctrl.orderIdInsideTunnel || $ctrl.loadingSavingOrder || $ctrl.savingTunnelData\" required> <span ng-show=\"$ctrl.tunnelStep2Form.contactName.$invalid &&\r\n                                    !$ctrl.tunnelStep2Form.contactName.$pristine\" class=help-block>Ingrese el nombre de la persona de contacto.</span></div></div><div class=form-group ng-if=$ctrl.allowGuestInTunnel><label class=\"col-sm-4 control-label\">Correo*</label><div class=col-sm-8><input type=email title=\"Por favor ingrese el correo del contacto\" name=contactMail placeholder=\"Ingrese el correo del contacto\" class=\"form-control input-sm\" ng-model=$ctrl.tunnelStep2FormData.contactMail ng-disabled=\"$ctrl.orderIdInsideTunnel || $ctrl.loadingTunnelContactInfo || $ctrl.loadedTunnelValidContactInfo || $ctrl.loadingSavingOrder || $ctrl.savingTunnelData\" required> <span class=input-help><span ng-show=\"$ctrl.tunnelStep2Form.contactMail.$invalid &&\r\n                                  $ctrl.tunnelStep2Form.contactMail.$error.email &&\r\n                                  !$ctrl.tunnelStep2Form.contactMail.$pristine\" class=help-block>Ingrese un email de contacto válido.</span></span></div></div><div class=form-group ng-if=\"!$ctrl.shCtrl.globals.currentUser.userId && $ctrl.cart.order.totalItemsToQuote === $ctrl.cart.items.length\"><label>Tipo Identificación*</label><select title=\"Por favor seleccione el tipo de identificación\" class=form-control name=contactTypeId id=contactTypeId ng-model=$ctrl.tunnelStep2FormData.contactTypeId required><option value=\"\">Seleccione el tipo de identificación<option value=1>Cédula de Ciudadania<option value=3>Cédula de Extranjeria<option value=8>Pasaporte<option value=10>Contraseña</select><div class=input-help ng-if=\"!$ctrl.shCtrl.globals.currentUser.userId && $ctrl.cart.order.totalItemsToQuote === $ctrl.cart.items.length\"><span ng-show=\"$ctrl.tunnelStep2Form.contactTypeId.$invalid && !$ctrl.tunnelStep2Form.contactTypeId.$pristine\" class=help-block>Seleccione el tipo de identificación.</span></div></div><div><div class=form-group ng-if=\"!$ctrl.shCtrl.globals.currentUser.userId && $ctrl.cart.order.totalItemsToQuote === $ctrl.cart.items.length\"><label>Número Identificación*</label><input name=contactNumberId id=contactNumberId placeholder=\"Ingrese su identificación\" title=\"Por favor ingrese el número de identificación\" class=\"form-control input-sm\" ng-model=$ctrl.tunnelStep2FormData.contactNumberId autocomplete=off restrict-type=num required><div class=input-help ng-if=\"!$ctrl.shCtrl.globals.currentUser.userId && $ctrl.cart.order.totalItemsToQuote === $ctrl.cart.items.length\"><span ng-show=\"$ctrl.tunnelStep2Form.contactNumberId.$invalid && !$ctrl.tunnelStep2Form.contactNumberId.$pristine\" class=help-block>Ingrese el número de identificación.</span></div></div></div><div class=form-group ng-if=!$ctrl.allowGuestInTunnel><label class=\"col-sm-4 control-label\">Correo*</label><div class=col-sm-8><input type=email title=\"Por favor ingrese el correo del contacto\" name=contactMail placeholder=\"Ingrese el correo del contacto\" class=\"form-control input-sm\" ng-model=$ctrl.tunnelStep2FormData.contactMail ng-disabled=\"$ctrl.orderIdInsideTunnel || $ctrl.loadingSavingOrder || $ctrl.savingTunnelData\" required> <span class=input-help><span ng-show=\"$ctrl.tunnelStep2Form.contactMail.$invalid &&\r\n                                  $ctrl.tunnelStep2Form.contactMail.$error.email &&\r\n                                  !$ctrl.tunnelStep2Form.contactMail.$pristine\" class=help-block>Ingrese un email de contacto válido.</span></span></div></div><div class=form-group ng-if=::false><label class=\"col-sm-4 control-label\" disabled>Cedula*</label><div class=col-sm-8><input title=\"cédula de contacto\" name=contactiDentityCard placeholder=\"Ingrese el número de cédula de contacto\" class=\"form-control input-sm\" ng-model=$ctrl.tunnelStep2FormData.contactIdentityCard ng-disabled=\"$ctrl.orderIdInsideTunnel || $ctrl.tunnelStep2FormData.contactIdentityCardOld || $ctrl.loadingSavingOrder || $ctrl.savingTunnelData\" required> <span ng-show=\"$ctrl.tunnelStep2Form.contactiDentityCard.$invalid &&\r\n                                    !$ctrl.tunnelStep2Form.contactiDentityCard.$pristine\" class=help-block>Ingrese el número de cédula del contacto.</span></div></div><div class=form-group><label class=\"col-sm-4 control-label\">Teléfono</label><div class=col-sm-8><input title=\"Indicativo país teléfono de contacto\" name=contactPhoneIndicativeCountry placeholder=\"\" class=\"form-control input-sm\" ng-model=$ctrl.tunnelStep2FormData.contactPhoneIndicativeCountry ng-disabled=\"$ctrl.orderIdInsideTunnel || $ctrl.loadingSavingOrder || $ctrl.savingTunnelData\" style=\"float: left; width: 20%\" restrict-type=num> <input title=\"Indicativo ciudad teléfono de contacto\" name=contactPhoneIndicativeCity placeholder=\"\" class=\"form-control input-sm\" ng-model=$ctrl.tunnelStep2FormData.contactPhoneIndicativeCity ng-disabled=\"$ctrl.orderIdInsideTunnel || $ctrl.loadingSavingOrder || $ctrl.savingTunnelData\" style=\"float: left; width: 20%; margin-left: 5%\" restrict-type=num> <input title=\"teléfono de contacto\" name=contactPhone placeholder=\"Ingrese el teléfono de contacto\" class=\"form-control input-sm\" ng-model=$ctrl.tunnelStep2FormData.contactPhone ng-disabled=\"$ctrl.orderIdInsideTunnel || $ctrl.loadingSavingOrder || $ctrl.savingTunnelData\" style=\"float: left; width: 50%; margin-left: 5%\" ng-maxlength=10 required> <span ng-show=\"$ctrl.tunnelStep2Form.contactPhone.$invalid &&\r\n                                    !$ctrl.tunnelStep2Form.contactPhone.$pristine\" class=help-block>Ingrese el teléfono del contacto. </span><span ng-show=$ctrl.tunnelStep2Form.contactIdNumber.$error.maxlength class=help-block>Ingrese un numero máximo de 10 dígitos.</span></div></div><div class=form-group><label class=\"col-sm-4 control-label\">Teléfono Móvil</label><div class=col-sm-8><input title=\"Indicativo teléfono móvil de contacto\" name=contactMovilIndicative placeholder=\"\" class=\"form-control input-sm\" ng-model=$ctrl.tunnelStep2FormData.contactMovilIndicative ng-disabled=\"$ctrl.orderIdInsideTunnel || $ctrl.loadingSavingOrder || $ctrl.savingTunnelData\" style=\"float: left; width: 25%\" restrict-type=num> <input title=\"teléfono móvil de contacto\" name=contactMovil placeholder=\"Ingrese el teléfono móvil de contacto\" class=\"form-control input-sm\" ng-model=$ctrl.tunnelStep2FormData.contactMovil ng-disabled=\"$ctrl.orderIdInsideTunnel || $ctrl.loadingSavingOrder || $ctrl.savingTunnelData\" style=\"float: left; width: 70%; margin-left: 5%\" ng-maxlength=10> <span ng-show=\"$ctrl.tunnelStep2Form.contactMovil.$invalid &&\r\n                                    !$ctrl.tunnelStep2Form.contactMovil.$pristine\" class=help-block>Ingrese el teléfono móvil del contacto. </span><span ng-show=$ctrl.tunnelStep2Form.contactIdNumber.$error.maxlength class=help-block>Ingrese un numero máximo de 10 dígitos.</span></div></div></div></div></div><div class=clear></div><div class=\"col-sm-4 hidden-xs hidden-sm\"><div class=\"panel panel-default\"><dynamic-banner db-data=$ctrl.shCtrl.globalBanners.bannerTunnel db-name=bannerTunnel></dynamic-banner></div><div class=\"panel panel-default\" ng-show=\"false && $ctrl.ngAuthSettings.site.config.data.tunnel.showContactProgrammedDelivery ||\r\n                                !$ctrl.tunnelStep2FormData.contactProgrammedDelivery\"><div class=panel-heading>Fecha de Entrega Sugerida</div><div class=\"panel-body has-feedback\"><label><span ng-show=\"$ctrl.cart.order.totalItemsToQuote !== $ctrl.cart.items.length\">Indíquenos la fecha sugerida en la que quiere recibir su pedido. </span><span ng-show=\"$ctrl.cart.order.totalItemsToQuote === $ctrl.cart.items.length\">Indíquenos la fecha sugerida en la que quiere recibir respuesta a su solicitud de cotización.</span></label><div class=input-group style=\"width: 100%; margin-bottom:0px\"><input data-provide=datepicker data-date-format=yyyy-mm-dd data-date-start-date=0d data-date-end-date=+1y data-date-calendar-weeks=false data-date-clear-btn=true data-date-today-btn=linked data-date-today-highlight=true data-date-days-of-week-disabled=[0,6] data-date-keyboard-navigation=true class=\"form-control datepicker\" id=contactProgrammedDelivery name=contactProgrammedDelivery ng-model=$ctrl.tunnelStep2FormData.contactProgrammedDelivery ng-disabled=\"$ctrl.orderIdInsideTunnel || $ctrl.loadingSavingOrder || $ctrl.savingTunnelData\" required> <span class=\"glyphicon glyphicon-calendar form-control-feedback\" aria-hidden=true for=contactProgrammedDelivery style=top:0></span></div><span ng-show=\"$ctrl.tunnelStep2Form.contactProgrammedDelivery.$invalid &&\r\n                                  !$ctrl.tunnelStep2Form.contactProgrammedDelivery.$pristine\" class=help-block style=margin-top:5px>Seleccione la fecha de entrega programada.</span></div></div></div><div class=\"col-md-8 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-heading>Términos y condiciones</div><div class=panel-body><div id=content-terminos-condiciones><div id=terminosCont><div ng-bind-html=\"$ctrl.shCtrl.globalParams.cmsInfo.TUNEL_TERMINOS_CONICIONES | toTrusted\"></div></div></div><div class=\"input-group custom-checkbox sm-margin top-10px\"><input type=checkbox id=policies name=policies ng-model=$ctrl.tunnelStep2FormData.policies required> <span class=checbox-container><i class=\"fa fa-check\"></i></span><label for=policies>Acepto los términos y condiciones.</label><span ng-show=\"$ctrl.tunnelStep2Form.policies.$error.required &&\r\n                                    !$ctrl.tunnelStep2Form.policies.$pristine\" class=help-block>Debe aceptar los términos y condiciones.</span></div></div></div></div><div class=\"col-md-8 pull-right\" ng-show=$ctrl.orderIdInsideTunnel><div class=\"panel panel-default\"><div class=panel-body><div class=form-group><div>Estás a punto de finalizar el proceso de compra...</div><span>Recuerda que el valor de tu pedido es <strong>$ {{$ctrl.cart.cartTotal | currency:'':0}} COP</strong> y has elegido el siguiente medio de pago:</span><select class=form-control name=payment id=payment ng-model=$ctrl.paymentMethodTunnel title=\"Por favor seleccione un medio de pago\" style=\"display: inline;width: 30%\" ng-options=\"payMethod.id as payMethod.nombre for payMethod in $ctrl.paymentMethodsTunnel\"><option value=\"\">Seleccione su medio de pago</select></div></div></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-show=$ctrl.errorSavingTunnelData.length><div class=\"alert alert-danger\">{{$ctrl.errorSavingTunnelData}}</div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-show=\"!$ctrl.savingTunnelData && !$ctrl.loadingSavingOrder\" style=\"position: relative; top: -10px\"><div class=pull-right><a ui-sref=home.cart class=\"btn btn-danger xs-margin collapsed btn-tunnel-back-to-cart\"><i class=\"fa fa-shopping-cart\"></i> Regresar al carrito </a><button type=button ng-click=\"$ctrl.saveTunnel($ctrl.tunnelStep2Form, true)\" class=\"btn btn-danger xs-margin collapsed\" ng-disabled=\"$ctrl.loadingSavingOrder || $ctrl.savingTunnelData\" ng-show=\"$ctrl.cart.order.totalItemsToQuote !== $ctrl.cart.items.length && !$ctrl.orderIdInsideTunnel\">Hacer Pedido <i class=\"fa fa-arrow-circle-right\"></i></button> <button type=button ng-click=\"$ctrl.saveTunnel($ctrl.tunnelStep2Form, true)\" class=\"btn btn-danger xs-margin collapsed\" ng-disabled=\"$ctrl.loadingSavingOrder || $ctrl.savingTunnelData\" ng-show=\"$ctrl.cart.order.totalItemsToQuote === $ctrl.cart.items.length && !$ctrl.orderIdInsideTunnel\">Enviar Cotización <i class=\"fa fa-arrow-circle-right\"></i></button> <button type=button ng-click=$ctrl.sendOrderToGanway($ctrl.tunnelStep2Form) class=\"btn btn-danger xs-margin collapsed\" ng-disabled=\"$ctrl.loadingSavingOrder || $ctrl.savingTunnelData\" ng-show=$ctrl.orderIdInsideTunnel>Hacer Pedido <i class=\"fa fa-arrow-circle-right\"></i></button></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"loader-general pull-right clear\" ng-show=\"$ctrl.savingTunnelData || $ctrl.loadingSavingOrder\" style=\"padding: 20px; padding-top:0px; padding-bottom:49px\"><img src=" + __webpack_require__(2) + "> <span>Guardando información del tunel...</span></div></div></form></div></div></div></div></div>";

/***/ },
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 537 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALAAAAB4CAYAAABSDHiHAAABN2lDQ1BBZG9iZSBSR0IgKDE5OTgpAAAokZWPv0rDUBSHvxtFxaFWCOLgcCdRUGzVwYxJW4ogWKtDkq1JQ5ViEm6uf/oQjm4dXNx9AidHwUHxCXwDxamDQ4QMBYvf9J3fORzOAaNi152GUYbzWKt205Gu58vZF2aYAoBOmKV2q3UAECdxxBjf7wiA10277jTG+38yH6ZKAyNguxtlIYgK0L/SqQYxBMygn2oQD4CpTto1EE9AqZf7G1AKcv8ASsr1fBBfgNlzPR+MOcAMcl8BTB1da4Bakg7UWe9Uy6plWdLuJkEkjweZjs4zuR+HiUoT1dFRF8jvA2AxH2w3HblWtay99X/+PRHX82Vun0cIQCw9F1lBeKEuf1UYO5PrYsdwGQ7vYXpUZLs3cLcBC7dFtlqF8hY8Dn8AwMZP/fNTP8gAAAAJcEhZcwAACxMAAAsTAQCanBgAAAXraVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA1LjYtYzE0MiA3OS4xNjA5MjQsIDIwMTcvMDcvMTMtMDE6MDY6MzkgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIiB4bWxuczpwaG90b3Nob3A9Imh0dHA6Ly9ucy5hZG9iZS5jb20vcGhvdG9zaG9wLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdEV2dD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlRXZlbnQjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE4IChXaW5kb3dzKSIgeG1wOkNyZWF0ZURhdGU9IjIwMTgtMDYtMjZUMDg6Mjk6MzAtMDU6MDAiIHhtcDpNb2RpZnlEYXRlPSIyMDE4LTA2LTI2VDE0OjU5OjUzLTA1OjAwIiB4bXA6TWV0YWRhdGFEYXRlPSIyMDE4LTA2LTI2VDE0OjU5OjUzLTA1OjAwIiBkYzpmb3JtYXQ9ImltYWdlL3BuZyIgcGhvdG9zaG9wOkNvbG9yTW9kZT0iMyIgcGhvdG9zaG9wOklDQ1Byb2ZpbGU9IkFkb2JlIFJHQiAoMTk5OCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MmM1NTQzOTEtOTBjMS01ZDRkLWFiMzktNTg3NTc4MTEyZjc0IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjhmZjQwMmI3LTBhY2EtYjY0OC05NWY0LTZmMDk4YTNiZTEzOCIgeG1wTU06T3JpZ2luYWxEb2N1bWVudElEPSJ4bXAuZGlkOjhmZjQwMmI3LTBhY2EtYjY0OC05NWY0LTZmMDk4YTNiZTEzOCI+IDx4bXBNTTpIaXN0b3J5PiA8cmRmOlNlcT4gPHJkZjpsaSBzdEV2dDphY3Rpb249ImNyZWF0ZWQiIHN0RXZ0Omluc3RhbmNlSUQ9InhtcC5paWQ6OGZmNDAyYjctMGFjYS1iNjQ4LTk1ZjQtNmYwOThhM2JlMTM4IiBzdEV2dDp3aGVuPSIyMDE4LTA2LTI2VDA4OjI5OjMwLTA1OjAwIiBzdEV2dDpzb2Z0d2FyZUFnZW50PSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxOCAoV2luZG93cykiLz4gPHJkZjpsaSBzdEV2dDphY3Rpb249InNhdmVkIiBzdEV2dDppbnN0YW5jZUlEPSJ4bXAuaWlkOjJjNTU0MzkxLTkwYzEtNWQ0ZC1hYjM5LTU4NzU3ODExMmY3NCIgc3RFdnQ6d2hlbj0iMjAxOC0wNi0yNlQxNDo1OTo1My0wNTowMCIgc3RFdnQ6c29mdHdhcmVBZ2VudD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTggKFdpbmRvd3MpIiBzdEV2dDpjaGFuZ2VkPSIvIi8+IDwvcmRmOlNlcT4gPC94bXBNTTpIaXN0b3J5PiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PrV+cW4AAC/PSURBVHic7Z15nBzFefd/VX3MsSPt6thd3UJakFgwOhACGQSKP+IQkoUwR2KC8loJiS2Dk+DXDgH75TDK69dXXvzGiY3NS0xeE8JpA4u4lNgRIZERhyQwrAAJdCEkoVt7zEx3V71/VFV3dU/PsdLuzCzs8/n07kyf1dPf/vVTTz1VTfAJt5b2T6evuyf9BjxMrXVZ+ssSGQsP3/7yufyDU17q3PBbVosycM6rchxalaPUgbVOnWnFzR+V5NknvrNxOQy8R63B/3NQi8LNeevzx7y9tYK3mjb4r1glNm/FNXt//8cvY8oFZ0YXdW74LXvrqQPrHrz5tSWMsfcM26hFCfvFqEUBjv/8l5vXX7pl7eH3al2eatjHGuD22fMoFn1zKS664WfI9czE57+zGmctnxm3brJ7+jsP3vzaEs/zBqUSK3gfvGX9ZVtfOHLQn3/y/PHFzvnjYIPvSvXBOlsXLsHcyx/AsUMZAIDTOwYXXf9sMSVWEA82JdbhtY+1H/YXTDm/lV313dV08dfWYsntC2pXwoEzUusCDJgt+uZSzL38AfQezYBQcaaqXmEm9mDNjxfhlfs3RTdrnz2PZhvenvb575y5mlI6lTn17UYWU15MOb8Vf/CdJ0BwDmUeuJ0+wF998jI8fed/VaNc1arEfTwBVvDmujKgFKDag4ZJIIm1B2t+vKjd2/JGXGVnyvwRp9Y7xFHl9c9Dgxee469PEpmqQTwE8PGagtfpycA0AMMIO0oMgOcBHgNgFlVioL4hrkR5dXiVVQviIYCPxxZ9cynOvuJBuD1pJEzANIT6GgAYASgHPAgVznuA4wLcGHRKLCuZv37w5vVXx8D7HAhmxsGrrBoQDwHcV1PKS90MbKm8JpEKTAFKANcT63oe4DAg7wAuB1wMGiUuFW1gV313dTl4AYASKnzi1zquxOpvrR2Icg4B3BdbfOsizLnsEfBcBikbSJiAZQlobRMgRHz2mHQdPCDHAMeRIHtAnte9Ep+o8hbsL9l4hL36+LKBgHgI4EpNwWu6GdiWADZlAIYFJEy0UIKESZFzBXQ5SnAk6wJ5V8CcywM5F8i6da3E/aG8hcZBk00DAvEQwJWYghdOBkkTSCeAhAWYBlqSJkYkLaQpQQ/jSNPgVPfnXezMewJczwF6HPG51wEY3YHn/+GyUhD/4ffO+hWAU6sFcX8rb8H+B0CJhwAuZwpe5fMmbaG86RQm2gZG2yYaZIuaZQSNEo4n/OCPch4OZR3sy3tAPgd05QTADisL8ckLmqb+wf+auxpVgHhglDdq/a/E1QJ48DQ36ab7vElLwmsDto2JSROjbRNNSQsGpWhMmLANgsaUCQrApAY4CJIUSBoUjHF0g8Jv6WAcAG/E1LMXozf3G+x+fW/08Ae3Zw99uOXgM5+6cPwlxCCjORuYi+Ur7y3rr4gqL//97z7TP/ACAAF3c0k6adbneGbMOry7dvuJ7vGOO+7oh3KVt8EHcLTCppTXtjExbfnKq8BN2QZG0h7kiQ1LAmsbBCY1AHAwQmBwjm6OIFrheQD3GjH1nJpBrOD9xdfe/Ny2/9x/2J9/8vzx/QtvYNzN9hvEQwDHWSy8NmBaaExZGJ+w0GBRjEiKzMlhSQuUELg0gaRpgFKChqQDwARjHB4XSswIgUEgICaaEntuI9rmVR1iHd4d63Yf9ef3q9sQZyElfhnvrn3/ePc0BHDUSihvS8LE5JSNBosiY1swCJCyDVBCkDIpLEpACWAQAs4tcAB5l8E2SAjiA8pvoxQAF7kTVYa4dvAGJiFediIQDwGs25LbF2LO0l+G4LVNIJkAbBPT0gJeyzCQMoXbYFKKlBm0IRuUgHPZnsE4mkg3ciQJzuH7xClKBcSEAKT6ENcDvMpOFOIhgJUtuX0hzvzs4+C5DBqSIkwmlRcJC9OTJppsA5ZhIGFQZBICXoMSAASWQUCJCLZQoiAmyMGGZRC4HgMhBBwEnsfQaBo44ANIAFIdiOsJXmUnAvEQwEAhvBYVsV7TAmwDLSkbY9IGDA6kLRMpy0BCqq5FKQwCH15lSoW5/GxQAsY4iPJ9OWABOEqI8IM5RDIQh6jYnXT2Rcjm1vYnxPUIr7LjhXgIYB3elFBbpE0Bb9JCS8rGeAoYJkGjZSFlGbAMAaxBCSwq/nuMg5Lgv1JhgxC4cp6CWEUmLELQyzhyHABhAKcC4jwDKBvZn9GJeoZX2fFA/MkGOAqv8nkt0TyMhIXxtgnLNjGcUFDbhE0AbhpIUAKDiEqbqpMppfUYhx5fVyrMuJBZAhGZ8EzAYjK8BhpAbJIgOjHlnBNW4sEAr7K+QlwtgOuvS9GS2xeSM5c+FErMMQ0BcMIEbBMNCeEWJE0DVsKCbVIQq/Be9DRuvBiIbKnSJqVQmycMCtsD0pSIcJxtyrwKKm6glLyJqNeGi294slh/sy1rD7/30C0vLwGwOa6PXTF4MevqtnqDVxnLHmmkcy5/DEtuX1jrsiirLwUOlLcplFVmyylhApaJZgNoMk2YlArFlaprGwSMELgIToxDtk1I31eZJ93bYipsSJe40ZCRCU4BykT6peqidJxKrOC957qupbs3dHb5G8y6ug2X3NgBik/VG7zKfCVuaNmId1/YUmy9T54CL7l9QYHyWhZgGaLyljQAywQMipSZACwDiUTx+y+rfVZK7PFgEt8DVXa8YP2MDMkpm2gbgG0AMIC0JcpjyvIQVyjxrKvb4soRVWJdefd1ruvxV5x1dRsW3fgYKNrrFV5lLHukkZ51xYNYfOuiWpelPgAW8D7GeXZUAby2KUJmhoAXRqTIWqw374XdhCwEpGpS5nGOvMfgMe67FlEPhJsGGiwaZLHZwn0RK0uIbUOUhzuTsOirz2HW1W3ts+cV/KY6xJDKG3UbcMmNHfXoNhQzlj3SiLMuf6zWENc+G60SeBOmuNVsEyMoxYiEgRZDFD1BgGEyVGbT8OkkwcEMCiuSGRX1h13Z0VOpcK/8kPMYDnGgtzePt10GuAzIOoCbDyfE9+ZFbjE3t+LZuy7Bxke2xp0qPXn++Cnj3ugNJeYo5R1E8OpGk41H2Cu//DyeXvWsPv+TkU4ZhdeSFaWErDyZlnAdlPJaJjKWgRYKDGcMSctAggAJBTDCENsGAfUEnMyg/mdlClwg7ELoADueh32MoLc3h50uF/3pcjIhPu8CnhtA7HoArK149q5L2snO98sO7RT4vHXvNpS05LAevPL4lTrEH/+x0XR47Qi8phHASwJ49e7xnime+TkO5DhHjnPkAXQxjrxU2LzHkQVBFsT/DAhw/c/UCMHretoXAHkDSJsUadMI3BV1Q6UM4dpQKp4YpgHAacOirz7XySdOKXn+s65uw6KvPjfo4QWAXFcaZ13+GBZ9c2m1D10bgHV4LVlBshS4BmCagC3zESwJCw0XtZvJFEjNctpdny8Se81qDx3HC9ZzDArX85Cj4sbISlXP88A5blG9nE1ZiYMhQhsWFVGSCMTFfGLfOM+D1EdP5xOyIAmq6ndi9QGOKm/CDi68aYpJqS2V7oOECpSgiwNd8vdSEOdCk1DiPASccVMPKLjjwZEVQtfzkHcZctQAdT1kCQFxPfQaBmwiFJlbsgKnVJjKG0yNPWFARiYk5CxXWok3PrKVPvbXF4HRTTBiB84cNEaTjUfw6pOXRf3gqhy7qkdbfNu55Mylj3GvN1Be2TgB0wzcB0O5DhISvXJGgX0ohFhXY6XEeW0CRAql+u8YFHmX+eACQN5jvvL2GgaYl0eeG+iR25k24I/0Q+WAKerpYJiyK78K9xkAy/tKHPdzsC0vfkAf/esl4Bi0EMv+dFdi9bf+rSbHr9qRFt92Lplz2ZPc7RklmoPtQK1MU9BhGrILvHIdIBPMEYYYhRADCKnxUcZ93zjHeQhe/b+yvKzgEddDlgNZ10OeBwrcRTy46k4wqRgkxa9cyvKZsuyGIVwKI1DijyPEtYYXqFYUQsHLsqNgmUBS8xctA7CSgEXEBbcN6ToQAYoa0yECsLr1MhxIEyAjFzfI9RoiqydizpTkBZzZiLucdYOKnFJfBfA+JiMRrmyVc5xgvAk9KuF6wXLGAGJ34rkfLi0VYqvXJuQ4KwfvxyeMpuD1ekf5zcG2GQ+vId0Hi0j1LQEwEHp+tKAQYmWG6yHJIW6OvIckiYFWbSJDEscIheG48CwTvW5OwEvk4Cgq/JZ3BcgOAzgT27qe+O9pn105FpuRKBsnHgwQl+2Gf84XVDSi43j2355/u+J1BzYXQldeHV5qiTAZlUkygPQbEXSspPIzSDA0qpqUW+F/B7oBODK/oZuLTRwO2ISAUwrGOVzG4RIAloGs/OwS4JDHkfAYjnGCBLgPbxfx4DIPu5kFGAwOkylunAtwZf4EOEMo9Y17olBMllPdHJ47EqecdxG6jz2LPW8div5c/OCOY3TPOx38tIsWghpjwOsvQlEJvPSSG39BTp53Bd/62zcBvNPXYzR7Byped+AA1pXXdxtkPNe0gCQRWV6qImSqpmLl81INVBJ+VhQBOY8AXlWxy3OA5j3kTAM5QpCQIAPAMZcjQQnyDMjLfe0BQcZ18ZFpood5OMgNwPMEvKohRGT/iP+qXAxCmZlM9gELYCc0+AyvGSeXhhgfvPsrnH7hRfUGcUXKe/FXHiD57uHw8kk+7byl2Lr+d+gjxLUHWK+wJS3AsgGbAtQW0Jqm8HMtBK5D1FWgJAAUEBBLtQ3mIbyOND36QAB0UwoOIOF4OGAYOEaIUFCIHPWDHOiFmADgMHNw1AMc0ABapg6IMMCAGksiKBPjwVODaKrtb+s045T5RSHG4R3d9abEFStvvns44wwcHJR5Npm+YHFflbi2AOvw2hJeU6quivGaKgwlM82U2hJIgKnWjQelQY5zLZQxjrxU4W4GHCIE3S5DNxdQ9QLYDZH0k2UMWddDlgAOMSLAQbgJjIWhjX4OuRE8KBPTy6/+e83l3Il6UeK+KC/TysnBQTynz0pcO4CnzD8bF/zJL0FZC2zR9Qe2DImZdgAvoYDJA5+XkGCigOibRoJKWozKFrgVcrPQFGeEAIwJaNU8VSlTI1gqEH311VwHwFdvcCrhVvBG/HUwCbECWisw8wDu1r0S91V5o3Y8SlwbgKfMPxtXrHocDcmxIhym3AVLwGvIqANRgX8riJsq9wEIOlGCh+fFKWwU2DjQlUVV0p8vQ2AKXmVR10FL/IFqpuZMPhHkfllke84AqOXaI4VDttaxshDXUokrhRe5Y41x8CpTSlwpxNUHWIeXc9kNyJYqa4m8BmoFkQUV/Ifs2aDUV5mCmGsQq/mlINVBVj2KOQqh1ddXN0oxeJXroMzVVJkRoaRA+ObQ96UUWp2PDrzajjnNmHZ+XSkxSWQO8Nee/FxJt+GSv3iQ5LqGlYJXme9OTD9/Gba+9AZKQFxdgBW8tj0WhIsWNtMO+pKZcqxeKtXWVPkNAKApb5y6hi46wn5xKZh55EOUXz/sFQFOdx8UvECh66DgVcuYBqPHtJuGyB0RbT3pY+jl5xxgbkmINSU+H9SYMJAQa68geDF2Benz0nxPQyXwKuPgoJ5rlfOJqwewgjdljxUJ55bMLJOVNEumRSpf1zQAg8lQmZYUI86uOMT+o1fzi7XZRf3d0L5Y/Mq6WvoVNu0ASn1d9Z1ItwKa+iJwNVTlza/EQXNfaDBfHU9/OrhOM6aXVeJn+GkXnTdQEJd9f4ZU3r7Cq0z5xKWUuDoAK3iT1lgQCJ/XNoSrYGiZZSYJ/F5CgiQYkCDmG5xdIcg+xPJLVJFLWjFogVDjg0ekq6AOI7cLwatcBqXCEl6mQRsHMKJAa2AXnCsHvNIQSyXuGAglrgje41DeqJVT4oEHWMGbTowFEMBLTKm6MhuLask5hqa4KreXI76JuCTEaoYGcsHykIxKYLUJkR/fdxW0/YcqbcrF0Pbp+7D67ooAzBDxy3lkHxHXogzEOLyju78hHmjljVopJR5YgKdccCauuPNJ2PZYQPm8JkBNUWmz7ABYQzYLmyqfl2qxXv9M4kGOqnGs4mpUcn0KLwosCramvBzxyusrrow4APHqy1nYl4a+rTwe4fAjE0C4zOr0lcvB3Gacev4CuuedDn5wx7HomfcnxNVS3qgVU+KBA3jKBWfiim89RU1jLCdcxHUtK1BcU6YQEi0ZXQ+RhRorCs6mvBrHqm0lpoHrEancBEKaoTEdUUZVWeMkLNp6xS2qvnoDB+eAS8P7jfrB+vH9kTGJGgFoDJ+xeOFAQlxt5Y1anBIPDMAavMyPNphB/qvqZqO+665CFOCSsKJ4vDcKctwUhdvjAbB+Q4IXDrMBgRvBmICcQaus6e6EF8CrXApdfZWLoJqXWUSNo+6Ff466Y6zNGyCIKaEgyeFH+KtPfDYO3vbZ8+j+yQs/i0v+4kGa604PBLzKfCWWEDd7B7Yg8uwsZpUBrMPLmez2bgaVNcsIFNc0g5wGvYUN0P6j7xCrZVH/uNg6UZXz3QQv/qdhJGgxYwggBTRFjii273YggFYHVfm/0X2ocyjwl7Wd62Xsb4gNC9xxP+SvP7OsmPLun7zws7j4zx+l+Z7kQMKrLHAn5l+5f9vWjfuN0RUpcXmAo8prmYHyUipg1hVX+b+qqVcH2Pf3lCvhExk9m+IQ+8vjlmmP9QJ15ojtQKkqeJSJ/Eum7SqU+6D5vYBU9ojPq6svZ4H7oM7bkyvpLoMOMEHwW+inJ3zi/oHYsACQPXjkG5fj5V/8Nro4pLxVgleZcCdcoy9KXBpgCS9MOpZzJsNiqhOjVF8AokFCy9318xpiGin0oL9K2oEGshq0jJB4kNVyPeMrOqn9KwAJCeDlVCitB5Fo7jcDa+etyugi7CtHXQdw0X+JyYIwBjjK/WBiPaXmDPLlMXJT1wvKp/xm5gWNKf75Ez2f+MQgVvA+eNMyvP/i+oLtUX3ljVpflbj4s1jBS+hYUKb1llDd302gKSHdBhXnNcQFUN0dDCMc602bYvQRUCDLxCtelZ9sym0aTFEJdJlYRxmFuJhJqfbgQE94DIfgV+BBEhEAZL3wyCWAuHWT8gbMumKwEmUKVDWoiuOK98gBYb/XoKLZHAhemmgnZBejSI8K9T0n1x1uAr3a+envm3M94Gh35GaX5TIokEhvoo/+9RK25cUP4k6/7YLGkVvPffrp0Bvry8DbPnse7bSnL5Hw2rWAVzdKKJidzuP5H13Vnn97NQpin8LiAVbwUoyFUl5VOVO+7/AE3lo+DWPTgYg7XPQh297L8IPtvejY2gUcdoSP7HhY+elR+H57Bi7jGP3yEXjvdAUhNteDMS2D/XMbYVKCzcdczF1zIBx7BbD2olE4s8kK9vFeb9CrA/Av9tqFwXojXjwIfJAPbpI8x01zm3DLyWmYlOA/9mWxeM1ecWMoPzZpYNtl4zEqYaDX42h57iPgg4Pi5gKArIdTpg/D+oXjYVKCu944gAzh+OPTRpW8MOv25/DNdQfw66XjSq6z+Psvhl0vZYyLZvquIxvov/7vpcUglm/xfAIE51DmgVGzpPKKUFl9wKtMhxhAR1xXo8KA1EnzZ4Tg9RsjSDj5HMDEjIkmm/pTc4JicoOJC0bbeHJOI7YtaQVOzgj1oxTDDYKMSdBkU5ykxjxlMlmGEnRMSaLJpsiYBGeNsGCMT4iOkZo1m8E+fj29QbT0qSEnOQfyHMaEJC4YbfvrAQhHEmyCFeMS/rEuHJMCRqSC/vfSRiUMZEyC5gTFtoWjgEwSUMLKOUYwA022GOIVAFpGNIR+j7jppLSJ1oZEyXVOa7SCGzvO8i6QGTWbXfjfO+jJ88fHrvP+f+zFQzcvA8dL3E4fKKW89QgvADDOQPM9Ni7+80cBLEUMr2bo20nzZ+DKVc+CsLFwWdB6RggCPzewXo8jYxI4DNh0RFzZZptgcoPY7eQGE8cuGIVhXR6wsyu07TbGg+IwDjQnBUia/dOEBJa/1xuap4//cMFoG2i1pLoGsdqOKcniv0qWoe3UYWhvCrqwWxT49vQGfGO3fCJ4AkjXT74R5/L0wjFY/KudIpIB4BD1/O0B4O9+dxhHci5yPTnMmdAoygeg87CDZ7cdBgC8eagXe7uD37HzsINH3z+CDAlO7M1DvcKNiKuoqqdEPhtADMQrsYSYg4zH+y++Fvdz1JPbEGcKYnbxnz/a+fyPrgIhfkfR9txmDWAFL3NF87BqkFCtadFhTTXb3eti7uM7hU+XosDk4dh33kg0J4TC3T9zGJZHABalg/BFPY6bpqZg0cAVtCjw+xPTWD6iGziQC/eX0+z+tjSWfyClM+8BzamCG8E3TzwJfjQ5ASB8rD+ckMQ3Gk3RdQOQ+Q9hu3RcCneeOxK3rd1XAFeGcKx/9QOs32gA2SxOOXci3rl0IgDg0feP4I6HNoNZFOjqwSkXn+pv97cbPsS9D3UWHiwjL02pd2xUCjFQMPg2AGDeimtw0Vfuq1d4lekQY83frwDwL2qZoFKHV/e3/ItUIu6qzCNCNbo94PX9aPnNR/6ii8ckgZSFoxF/FkTWwBsMXD9ZqOaWow7+5I2jcJgAa+XkpHYRC3/kZeNTwAhLwAvg220JxIzoL1u2KDDC8gH/1z29uGfLUQBCYReMGQ5w5SMEx9LrV7fOHo1Tpg8Tj3HNujgJRuWxbLQ6YReAqRyRhnRo/memjgbaRgMzxwOfagmmSl/TpUNczJ2Is0ECrzLfnbjoK/cBuEbNF/7PlaueBbyx8Fg4/AWEGyFKNiDIC0+JqGTs6sH2bnGRmxMUyMT4dB4XlbdJad/tuG93Dve/1Y1umXt789SUiF5wUdyoZUyCm6amxAUfbuHLU9IF6wTHY7jp5AYf8B++k8MNb3b7i+88owEg0rXQ+rFtOuJg1Yb9/vf1C8cDzRm8mw17YOCQFUUXee10M4QD3JDhOw/Zw0FE5NrJafC/mgP+5U+Bf2U2+Fdm4+VrPyVH9ek7xFPmjzi11Krts+fRwQavshiIKUX7BYtAMTYUZoprharEVOyViThrj1NmWwLAoL7P6jDge1t7gYM9+Mn7YvT9yQ0mjAlJOThIsL/DeebfIF9vSwNJE0sniUqgw4RvWWCpQOk/yjE8v/cYsC+LF/YLF+TTI22gJY1gDClhDQS47ZWDeGa38MebbIqnLxmLs+3I+VEiBpog4Zu1ixOAeCKmTCm8dAT8iDUQhPOUK7F8Fhg1fvb7zmWnlF339/7sGjB3UMGrjHEGMNfG7/3ZNQBAcd91N2DzC7cgPRyhd1Mpi+tHJvYU/u7xIAjvekCaYqL047pcDvTGAJX3gNEJXDpOPNK7XYblkxJYOm80JiUDte2YkoT/dkJpH/Z4+I6s4DUnKFZ+KoPbpgr1XXcwj8f35sLHcsJK3+MyrDytCV+a2+ivoipzogUtYh7H4jW7/Zvm0nEpPPx7LYW/SbTzpjI1TCsP7/uZ3b3409/sCE3X/tve8BADUYvONyiQbACe+9FKvPRPZUfDafuvxSvgeR2DbSw2ACKe7Xkdbf+1eAWgohAdt38HzEvj9ItvRV6+d0S9K1j5v4yLRyBBPNA5DuQdsSxh4x/OGYGMKbZ97bADHHMwPKYS9u3pDf7nJpviFzOHF6xz4ZgUMCohKnPS0hbB3duzuHNaA5oTFD85Y5i/7AfbezHeLoRQj05MbjBD2yj705PS+MawuAtrAoccnPT8R8gvGwuLwr8Z4kxFKMrZY29/FF+JS9FwFCgaC1ZGCWClgF/fvRKv3P/TcseTo8YfnORcvXzHgkfuh2EtredhrEJmWABHx6S1Vy+HhaOA7lSuvvM2vPn8KiTlRWVe4A74zbIMoawtaY0WxYIZrThj7iR86TNj8fK1J+H6aQGIC145JOCOWtrGH04oEfKS5lfmtNpU2qTAYQePbA9HN7pcjo73e8M3S94DxjQUj05o1pygmDexUbTKRM0gwPuH8MWX4iv1gRVxnQgHvDyOaItPH5ESlTi9Atc2unQc2C8PBex0xfDq1pCd1DVp7dXLwTE4lFiDtyE7qcs+1g4gGgdefedtAIAzLr0VuS74L0tTAHsE/rBJmgo02RT//pkRscf98hvHgHcOF8SQvZwHTE75KvbM7l4sfuVouMyjbPR+egQsKipzd7/VhZ5Qrwjghm0urp8WzHrig17gcKRFAsDKKUm/8vbjd47ihs1afNljWDopjSfnCHfiuzMasGDnkUKGZTjxvpcO4MJxw3Dt5GIVxmJJSEQ0BGn21VnN+Oqs5tC8zsMOTvvWvxdviQNkz+4KlPes5V/CzEvbcO+1N4WOIZT4aMvhr39+37IfPFjXSizhbXni659HE3r0RYXP2dV33oY3nlmFREYDl2kZVZ4YQpQzNMXGq4R1HnZAfr0fd6/Z6cPbJK+dw4AFGQNrZwQqvXhzt2js2NML7BWT13nMbyCZ3GCibVIKaamsKYOIGv+HPaEK2xd25QDG/GMBQFtjAndOC1yVG97rBT7sEcfZ0wvs6UHH6wfwUU4o/AWjbWBiBpbkJ21pbpSsJyx/flfouGZaf5KEydcbKQAD4xIVVIzj4u59hXfeimtw6Y1/h3HTv4br/vl7cavs61zX0/LE1z9ft0qsw4swvECpAO+S2+7E6RffCib9Tj2FklIgYWDpWSchMyx8MTqPUmw83Avs6wF6c7J7vSEqeaeOwPKxKRxxOTo+ymLBSBsTE4b4/tZhkQSkj4nGOTA+ieVjxaP/X7qEX3lNxsDOnIe172eBHheYnMLK5gQ+yDN0vNMlkoDkvC7Gcf+BPJaPspGhBJ29Lta+2VVYOXUZcMowfKlJgPPTfQ4WjLRxqsmx+QjB2nf3AXkSZI+5HjAugxUnJZFIWPjp28eAbQfFb+N6wIRGrJiWAQDcty0LbP4wGH9i7DBcd2qhr6/stYMUG17sDIfS1HH7Aq8fKvOAxDBg99vfb3/tRzfHvT2ppf3T6X3LfvAgCOpHiWPgTTZtR0N2kr9K6RaK6/75exg1+a/gZYOEdR1iR+ZKqP5wSjUMldwuuxSp1wSo3AfVxd4vhcpok8XRIfZYkECjG0VwPMaDEJulzVMDVRMq/Xe5rXrPhZ7lBQTj+KpfRh+N0qSF+b6ciwYNdU56krrriCw2tS9qBPWHnBcs445Wz+CiMpwgIgGKRW4yUmGFrVicN5EBdr/9/ag7oayuIC6ivFGAS9cUNvxyDU5d2ICG0eeBqx8cAfYmFTkItkybVOD6AGo5vaobvVJy9Q4MQ2umpnI9vfGEqhxjBKElvbeHWk/tS5mfk0y1ZHstNKWDoT767+RA+Bg0AjxHcGyDAgZXhQ8fX6WghkYilF9Nef5+Fyz536ZBvkM02lNJha1UI4WXB0aMOw+nLGhox+5/279nV+gA3ft3OS0HOp/onn7xDFBjes0GFCzhNpjJI7DdIPRZvqrrQzzqPDA3RrNjRJxEQFIj0+hditR//yeU8VNebB8x++cIwxQaTkpbPy62rUypL9HgjOvWo3/nkRmqo2aorFroy9+39l8fdlU/ZtyxCTlxeJVJiPdn2tLY8Ms10cU1h7iMz9t3gIFCiKNG/D+ByxBartRMk2+iLfNnqAsrZ+lwFoNYrVdBvSjW/BtG/95XgGPKB2g3SgzA6n8xgPVYb3/Bq6xelbgMvMDxAgyUhxiIhyykOjSsPjqsYgOEINb/x+2/2HF1K6W+QBhgLzKTx6wX+qytx4pc5NANEQU3Aqvyq/2nQj8qb9TqTYkrgBc4EYCBvitx9L+uxLo7EQIwArHfIFjCpSg2rxy8usqFrk85ZS2yXkELZQnljf7XQVflqgTeFfd+wTjz8vt4vsvq85uB6kWJK4QXOFGAgeOD2B82SYGrK7A2L7STMhAj5ntfzVdfjvCToIgLEd0uul5fAPbj6irGrlo4eeXKu+LeL2DizH/kuWPHP8adUuLU+GZsfPLp6OLu/buc1t2vPtp9+pJZAwKxhLf14euvhGnlyq1+4gADAuIzljbRVGYe99xCkKgGpA5xVJU5Ar9YB1+tXwnEKDIvahWrrypYpDx6hbMSgAmKg8si39VOlBJXEiqT8CLXVbw1qVLz8sDISXMx9ZyWWIgP7WUDosSa8hLPycEs35DSPwADwCsPPcfPuKwJqcZ5BUrsX38i4KARJQbExaI0eHRyhMH3XyEQA3HRRzsJ3wPKGArnF/Nv42cU94H1zDM90qK+R/9zwB8022NyH6q1E9WHV5mAeA6mntNaFSWOKC/xHFQXYAB45aHncMbSJiSHz4PnFPqpun8bG23Q3IeoEvuXJqLEJV0K+V8ftdJXec1C6hvnJyjQivgQPLKe/7WIz62Dq7sP+tgVGrzt3pZ7ov6obwMBrzIvT6qixDHKWxuAgQBipcSSQwCFSkUUjJLAAh9YU+KQmqkKkgYyiUIaedzrU9RKqW/Ri0KKnJd27ILGER1cFrTg6Vl+6nhmoLw1gVfZQCtxEeWtHcBAWImZo0GmVpAKqyD2/d0iSuxDHD1QjF/suxyovFJX4MvGLYw5dMGXIgoc8mtRRHG11FQjWVvljVqlSjzpnFOQGn560bBq1KwU0H3o4Zan/8cfRZW3tgADhUoMFF50/1FeAmJd5fTXD0Cbr3xj/51x2nqVgOzzFX3ks/DyuG1C25UB2M+hRjD+hd/tSn4mFvCbn9VeeaNWgRK3HH3v6e5hE6dh1MTT4RWmsIYskQF2/u6Rlhfu+mMAPVFwaw8wEK/EIYtEGeIgRkSJ/c00X1pBWgxcXmZSVoBLEfUtsBIK7EPMAveBeWH1ZVykpaaGAxs6/qK967W7i8P7j1/ExJn3Itd1gjHD47BySrx/l9N6bNvj3U1TTi0JcSID7Hj9kdb/+D/XqlBZfQIMlPaJARRAXMonLmh6jqu08UJwdX+1mPXFfQgdU3dtCMJ+r4IXgZp72oB9SnldVzxOd2y6CY/fcldpeGf8pCbwKqskxJbft7o7MyFeiSW8LevvWaGHyuoXYKBvSkxoaZ84NgkoEu3QIVbG9Q0qsFLuQ8G62mf9SeH7uspt8MJugyfV2EwBu964CQ98+ftFjyHg/WlN4VVWDuJiShxRXh3S+gYYQLu3fc3+5tmNSDWKEJtSRT0HQq/kKSXmPAyqngSkL9NNjwocd+tc1B/W/FkeWa7cFf3NRno4zI86KGiZUGLmiQpbZfDWVnmj1lclNu0C5R1UAO/fs4srJabpYUGLnR4X1iH2e0EjDKGeBKQ3dEB91KGVN0JfQa5IffUyyXLFRRmU+npueJgBxgCrAdj5+uBR3qj1RYmP7H0rqryDCmBl7d72NR+NPjNQ4rhcYUDCrFeypWLrSUAKGkS3i/rVckHZaIRsCYtaXMudvp4fz1XfWXi+58nBrOVn1xXw7tg4+JQ3ahUqccMHrz1eKlTWXwBX74da+au7kBl5I7gT9EBQEyHa241IME9/kz0Q9OilCGD3e07I0wmpfB/LqBhlQCgJXXch9AYIhnDljGnAerKy5jh9gfenyMUMgliPlsgAOzf9GPddd0Pc4j5nxh2nVS2u2P7Sd7+GroM/hJEsvOB+z2cWDDDtg6GFpjw11D8QagFSoaloY4F6/wVQPrQWBy8QFuho6xmPlFUpr3fcytvn37VmlusCJs68Hivu/YdaFqP6j6qVv7qLNo66kbn5YPBsvbOoQWMUWEYqVN80fWwFI6LEQPH/5UzdEzrATLsDouqrbijXlTciDz47rqiwfdyUN2pSiVtf+Lsb9763ye8JWi0Fro2vtfJXP8Pw5j+Dl5WgGmFwDSp7O5PArVAQKxdBrQsUuhQACiuMRBtQW/73m7eL/Ni++4BAaYFwXFepLZPQKuWlpeFtnTrT2nvBX/7xoIZXGk0OB9ux4cctL/3fv9rXua4H+Bi6ECG7+3NfxNGP7qGmHVTMQq6Dqs1H/yOAKPQKLASP9WiurdpGvQNOfVbQFoMX0JSbB/+ijRIKXgWuUx5eANh76rK5dNKsn9J8yQ4Ig8JY7xFg2uzr983+b7H+8EBabQAGgLs/90V25MA9IZ/Y9ym1+KkCm2kQh9ZVfi/CEOuPe91H7ov5b9uM+NZ+i5oGr1LfStwGAK2bn3iZ7dv+QyQyx/Xz1ZXZaWDPh09i3QP/r9qHrh3AQKDEhoXQYIJ+8D+ahsjhv+lSr7D5YCFcuQu9HZ4HIOsVvoL8XG1S8ELbb5zyOmHlbe/8p78td+p739vk4O7PfZVtWb9q8ELMASsJHNv/ZMuav7lGvs6gqjbgceCy9spDHfyMy8Yj1TgnSMuLy3mIJP8AER9XxX2J1ughjUf3FftFsyIhM09LylERB1cCbKeA7UJ5i+U2XPfzs29MjqQTdm08+pY/842nfoNhYww6aeYC7pbtElZfZqWBYweebFnzN9co31fZHXfcUZUi1B5gAHjloQ6csXQ8TWXmBH3sikDMoYGrPUBCKZkE0N8ZG0qM19YvZrpyR+O9Clz12XGE27BdKG8peCfNGnVX29zmZbl8buOujUff8Re+u/Y3PNM6iCDmIhmpCLxA9QCurxYfFZ1gORl1iITYVKiMyiiFikpEGzwAuQ7C0QcFfGwnVEQqgAha2JTy+qEyR1TY8k5FFbbrfn72jRNnjLwre8wBMQgSaTP33I/evGrdfTufCq245LY76ZzLb2XZo0X2VCdmpXy3IQ5eoHpRiPpQYGVSiZEcPgfMKcx98JuXVfplpOlZdy1UbnEo54KH4S1Iw4SmupGKm99I4Up4XcCwgR2byirvxBkj78p1OX7inOdyc/r8MVcOPiUur7zKPlkuhGbt3vbV+5tnjwv5xD6AQAhUf5aezKPN88NmyjeGDJtxxD58OABEXAYuGyeUy5B3xJtHrSSwbVNZn1fBGz3OoIS4hM8btU8swPv37OI+xMWUOOQHkxglRrDMXyeitj7I0agECuO8yufV47zbN63CA1/+n8XOoyi82jkMHogrV15ln1iAAQFx68HNz3ZPOHtMrBL7vSKiKqpFKrjaQFqogocAZF079ShDyG2QU172pNi+aRUeWHlbsfKXhdcv0yCBuA/Kq+wTDTAg0vIKlFiPTkTdhtAIQECBmxAKtcWYqrD54MreE6qxQlXY+gteZeUgHj6O0YkzPlMbiAPlbX3qG1fte/eVigvxiQcYiFNi2bNDV2IAAah6rBiRZQj7xQUNGFqrn+4yeJ7weQ0b2PF6/8KrTIfYyW0OxYnf+fcXagaxrrx9gBcYAti3kBIriAu6JEH7XgbiONMHHHFZOLfB82SobIDg1crvudycft6Ywjhx1SE+fuVVNgSwZrFK7PdcliuFoJaRCkIjvjAJ+74q1hua9HxeldvQz25DMasXJT4B5VU2BHDEAiWe1YZEZoZ4Z0e0ZY4UKnG0f534gFDyvMqx8H1fpiXmVAlev4yaElcd4hNXXmVDAMeYDLE9sb/lzDakGmeE3AllfpiYB1+Y/B43xJOvvDzwfT1WG3iV1QriflBeZUMAFzEfYl2Ji/bA0FvmEJlUyqZecZOfawmvsohPPIyctsVvMOl3iPtPeZUNAVzC+qTESo1VeiTn4TePRv1fM1V7eJVpPvEHO7Z2DpgSW2mg6+DDLWv+5o/6A15gCOCyVlKJgbBvrI9ZxiLw6j0szHT9wKusvDuRoxNnXHh8EEvl7Tr4cGvHLcv7C15gCOCKLFaJ9YiDsqjfG0qEh3An6hFeZaUhfvG4IZbK29pxy3K9Q2Z/2BDAFVqBEnuu7L3MIxlmSoEVwDISwZns+l4a3hX3zrll8szR3686vMr6FeKw8vY3vMAQwH0yGSd+qnvi2VNow/AZ3NN7dkRb3RCAyzhgZyqC96RZzd+uGbzK+gviAVReZUMA99G6D+1lrQc3P9U14ewpvhITaOpL4A8lpSpydhrY+caq9s777iiWElk38Co7IYgHXnmVDQF8HNZ9aC9r6d7xXPe42ZORbpoB1wlcYd2FYFzAu+t3q9o777ujc8NvWdz+6g5eZccLcRWUV9kQwMdp3ft3Oa0HNz/VPWHuFCSHCSUGtPhvAG/rb3+yalvnq17cfuoWXmV9grh6yqtsCOATsJASJ4fNCL2EJDkM2PnGKjyw8rbuQ3sHl/JGrVKICa0qvMAQwCdsvhJPPFsosesCiQbf520eO4HE+b2DBl5lEYiHkdM2ay12L/Lh43JoGHmw/YU7ryn2tBkI+2T2Sh4Aa50609p7/l/+MxrHX413N3y3fc/j3xh0Pm8lRgkSaRPP/f2bV6/7+c5Ha12cj/fgflW21qkzrenfe3jZC1dNL3phV9w755YpZ7Z8O3u0zOui6tk0iA9vHP/LYjdqNWwI4CpZ69SZ1qXfNL8+aJU3ahLih29/+dy3njqwrlbFqBbA/x8gmgqwiRBfxwAAAABJRU5ErkJggg=="

/***/ },
/* 538 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 539 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QkIzNkFBQzUzQjc5MTFFNTgzNDBGOENDMjlCOEM0Q0MiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QkIzNkFBQzYzQjc5MTFFNTgzNDBGOENDMjlCOEM0Q0MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpCQjM2QUFDMzNCNzkxMUU1ODM0MEY4Q0MyOUI4QzRDQyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpCQjM2QUFDNDNCNzkxMUU1ODM0MEY4Q0MyOUI4QzRDQyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PpNrQAIAAAiuSURBVHjaxFgJbFTXFT1/8eybZ8ZjPINX3DSO2EIpJBbCjhoKbZMqchtaRW0DlWikoNKoaRMRRVGaVKqqVnSJMBERVZCISEBpSaukaVUKtYkxTUmCQ6A42MUEbwwzXmbzLP//3vfGjOfPDF5EaJ/8xvP/vOW8u5x77xPOrF+xCMAL1FuoS/j/NoX6P6jvkOljN/W2/9XOmkp7q1r2QRQgiEWy+DoTEAPWeuNVNPrT2GrU57+5IIn0IZZcT7LaIMhl2cdMGmo8TmOFwpEtDJigA5KmwdQZErHMANFihWg00unEeSASaKwJSiwCNRYr2lBJxFG98zk41t3DnydPHMOlZ34EifYoXEnGtCzUqQQ/pbnhM7DeuRqWpqUwLK5BmdsLyW7PnVIvmTw1sO+qivGjf8Ho79qhRCbpd7mExOy0niM7xWYnbQoldSVrmQy0VAq2z98N30Nb6TRZzWbGwhBpM9HhvLGlToxDMpv5hungVYzsaydgb/FnfhBNK21j0y0ejWJwcBj+hno6l5Q1m+kmiyYzqn74FLxfe4i/uPbqfoTfOIzEyBBSGVrEUwHvA5tR//A2nWrU5BT+Q0Au7tsDmVStJhLIRCYgkCoFUrvT6YTNZtNtVthSJJDJySiqSoyRG361F9bld3KNXiZ9X3ntACaTScSmklAUBUqqBxf+fBSj3Sew5oV9ZHdZlTJbqt/xBEIXe9H70n7IDokDspD6vF4vrFbrrKCyJinc0HTlLCjg6pHD+HDvHkRJ1EysrvJyvrhIM9nJRg69go9q6rDsqedmzEqWsfqX7ZCGriDx8XlSqyU7h2xNIePXClxZiUXBTCcndfLKdCT7nqleY95/HTSdKqSpqvv4fa0Y6uiE3etCwO+HyWTSnVilBSfjCaw4+CfYb7tdt2GEedcT2yEYjMiQE9lWrUHF5m8X2xetYV2xCmUVlVkbowOF/nkSdlK7oHeCMHebJBnueO95GC0G+KuqYCSbYWrUNZKiTdAw9sYh2H/8jO4n69p1EGuXIHOpj9ONkbzZ2bphTnax+BfD8sCDJX/jGk5HJ6GQXdkdDi4pVVVLkqNAgKMkHeaNukXI7tTqOmTIIfjJ58N5czQuMWYbIhmtxWqZ3VjJDlLDQ4h9+H6OJHPN7UE0EkU5GX56dBjjHX9HPB6bjhz0p2TIHBRUrG2G2R/gUxJDgwie6qKDyZyaioAZaVET6V1KJeaOdbRB7KOeImAigY6SEXsWVyP6r26ECVh/Xz+YrXPzIXApCgb3vP4qatq+wecET53A8bZvosyqiz95EiMucy1fCaXr2NwyZl76yUDR6yQRcpqFM/JqxviMHw0UMSSy1euGLUkJSAaD7jAMlNFphQB9OM7FDP+XvopLHUfnEQ4FinmxovcRch5tGgBTn0xUUltbW0AXMU4nM2ar8UjGxhUyf85K/Ru/AmP9Es7oc4IrSFUSw4MInX4XMklJpw4Cp+9SIS1MS1IqGpsDZqDAunjL95BiacisNqZAdrl173r3/IZC2DUYyKPFPI/UptOm/F46uyoep/PrwIPfgqtlA88MZmv2Nc2574NvHsGF9l9TCCmDxWKZw3M0HspykuIJwCx0kc9HdT/5OS7tfAyR7k6IRCMCiT/r7goPHS4iTmfrvXz88N/exqlHt/KMwUi2M1fQZg4RPLAPQ0cOIRwOc7qQLKbS5hLsfifkXdus0w3LKkdffhFjb/8RmfEx7u9Mfa4NX0bllkd4HjXyh9dw4tHvEjFPQSRPCwQCcBBBlyTnvESSAi/GrgVx+XIQEuUDRocVDfX13K7yDhUW3mr0hQJbH3E3UlpjCVTrFyJJxHv/zV2ZJY0MEM88j/0VXVs2YzwS4aAqfT54PJ7ZQeV5dZwOziTGvjPDr6ioKPTKsHD6rqbQwMe9JA43fM3r4V75OViqa3k6LdHARRvvIxXMiDsdDuHk/a0YPneW819lZSXKKROZD6h8cPneWWJuWOhpWRmigO0epVAzNhoCi91sjpKkHHF5IzZ2fkDp8Az3BE924uim9QTKCD+pz+VyFQf8m29hOUtyEgLVNSj3eBEh9UxNTSExNgHP6jU6UNwjGz8LS00tzBT4bxGoGYJl4Jg4zeasaqqrq9GwpB4es7logqnCh7v27IenlrIJ8tJb1cRCoruub5lATZ3rQXKgv2iSb10Lmva+AtNtTVCikVsMjDEupQKsjFMoXVHof3LwCq784vlsaVfQzASqcfd+lG+6n/MbNO1TBSaz0k1Npzgjl/kqYaSsUqYUyLDIz58li43gl77SkKi0q3t+F689gwdf5sUxSteJCwdmrGuAc/0X4GhugeWOpRDKDLq6UaWqOtl3AWkSiOOOZSXToMDjT3NpXzt8AKLV9qkAE5REIkQ8xZl/qvccIl2diPS8j8RAH1KhENKkRnZlECJCdLV+Eat+tgtmkmapQqP/sW2IvNvFQ8/N0gWvkuJnTrs/2b0LQaodo0SgSQKS0didkMZTS6Yd+qTaIAkbeevqXe2oundT0WoxOlDf9u9kL1RuTqVhYfj1g6GeJ3/gnqT4lZGyRauBwgyjDtbZd5bKsM7YOkKSC41PYOnTP8Xt33+8IIIpOP9wGzJ9vbyUuymC7dqxjedgLOY5KRVm4YUBkvKKA23aa7k3EtvbnA6cf/ZJkmAEy3Y+O2NuNCfprYRy9gxMRtOclfisdDExEReMFjP8VOQyYrUTOCYdXXKXX/gyIqZg3tDUhKGXfour73ToPZVibiwazUl4oZ0JJBaLCfJITNV8PguclLJk2M3PPE/JFvHQnPCbv4fn7nXZupPApNlFSTSOcsaJCwzsbO9EIoHR0VFVNojC8Xgs2nax72JxDTVrMkrSTCVhPXUScn8/rwMkQxnOdr+H8FUiablvQetdX3M69nZQRixul0R2NaEs+HKY3WcoLIyxEo0SvdjlAQTf+4DDUZj0sWDPzJDkmG3s+K8AAwDjiMXMSDPNVgAAAABJRU5ErkJggg=="

/***/ },
/* 540 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 541 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 542 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pqrsList = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _pqrsList2 = _interopRequireDefault(_pqrsList);
	
	var _pqrsListView = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _pqrsListView2 = _interopRequireDefault(_pqrsListView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PqrsListComponent = {
	  template: _pqrsListView2.default,
	  controller: _pqrsList2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = PqrsListComponent;

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dashboard = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _dashboardView = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _dashboardView2 = _interopRequireDefault(_dashboardView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DashboardComponent = {
	  template: _dashboardView2.default,
	  controller: _dashboard2.default,
	  bindings: {
	    shCtrl: '<'
	  }
	};
	
	exports.default = DashboardComponent;

/***/ }
]);


/** WEBPACK FOOTER **
 ** app.bundle.js
 **/